
/** ********************** jquery ****************************** **/
 /*! jQuery v3.7.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.0",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i)return e.textContent;if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=ce.text(t);return n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},R=function(){V()},M=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&z(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function X(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&M(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function U(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function z(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",R),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:X(!1),disabled:X(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:U(function(){return[0]}),last:U(function(e,t){return[t-1]}),eq:U(function(e,t,n){return[n<0?n+t:n]}),even:U(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:U(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:U(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:U(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&z(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&z(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var R=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)R(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},M=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(M,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,X=new B,U=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,z=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(z,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:U.test(i)?JSON.parse(i):i)}catch(e){}X.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return X.hasData(e)||_.hasData(e)},data:function(e,t,n){return X.access(e,t,n)},removeData:function(e,t){X.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=X.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){X.set(this,n)}):R(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=X.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){X.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){X.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Re=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Me(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);X.hasData(e)&&(o=X.access(e),a=ce.extend({},o),X.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Re,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[X.expando]&&(n[X.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return R(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Me(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Me(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return R(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),Xe=/^--/,Ue=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},ze=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=Xe.test(t),u=e.style;return(n=n||Ue(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Ue(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=Xe.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return Xe.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):ze(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Ue(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-ze(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return R(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Ue(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return R(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return R(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Rt=/%20/g,Mt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},Xt="*/".concat("*"),Ut=C.createElement("a");function zt(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Ut.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Xt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:zt(Bt),ajaxTransport:zt(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Ut.protocol+"//"+Ut.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Mt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Rt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+Xt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return R(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return R(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});
 
/** **************************************************** **/
/** ********************** jquery.cookie ****************************** **/
 /*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));
 
/** **************************************************** **/
/** ********************** jquery-mask-plugin ****************************** **/
 // jQuery Mask Plugin v1.14.0
// github.com/igorescobar/jQuery-Mask-Plugin
(function(b){"function"===typeof define&&define.amd?define(["jquery"],b):"object"===typeof exports?module.exports=b(require("jquery")):b(jQuery||Zepto)})(function(b){var y=function(a,e,d){var c={invalid:[],getCaret:function(){try{var r,b=0,e=a.get(0),d=document.selection,f=e.selectionStart;if(d&&-1===navigator.appVersion.indexOf("MSIE 10"))r=d.createRange(),r.moveStart("character",-c.val().length),b=r.text.length;else if(f||"0"===f)b=f;return b}catch(g){}},setCaret:function(r){try{if(a.is(":focus")){var c,
b=a.get(0);b.setSelectionRange?(b.focus(),b.setSelectionRange(r,r)):(c=b.createTextRange(),c.collapse(!0),c.moveEnd("character",r),c.moveStart("character",r),c.select())}}catch(e){}},events:function(){a.on("keydown.mask",function(c){a.data("mask-keycode",c.keyCode||c.which)}).on(b.jMaskGlobals.useInput?"input.mask":"keyup.mask",c.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){a.keydown().keyup()},100)}).on("change.mask",function(){a.data("changed",!0)}).on("blur.mask",function(){n===
c.val()||a.data("changed")||a.trigger("change");a.data("changed",!1)}).on("blur.mask",function(){n=c.val()}).on("focus.mask",function(a){!0===d.selectOnFocus&&b(a.target).select()}).on("focusout.mask",function(){d.clearIfNotMatch&&!p.test(c.val())&&c.val("")})},getRegexMask:function(){for(var a=[],c,b,d,f,l=0;l<e.length;l++)(c=g.translation[e.charAt(l)])?(b=c.pattern.toString().replace(/.{1}$|^.{1}/g,""),d=c.optional,(c=c.recursive)?(a.push(e.charAt(l)),f={digit:e.charAt(l),pattern:b}):a.push(d||
c?b+"?":b)):a.push(e.charAt(l).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");f&&(a=a.replace(new RegExp("("+f.digit+"(.*"+f.digit+")?)"),"($1)?").replace(new RegExp(f.digit,"g"),f.pattern));return new RegExp(a)},destroyEvents:function(){a.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(c){var b=a.is("input")?"val":"text";if(0<arguments.length){if(a[b]()!==c)a[b](c);b=a}else b=a[b]();return b},getMCharsBeforeCount:function(a,c){for(var b=0,d=0,
f=e.length;d<f&&d<a;d++)g.translation[e.charAt(d)]||(a=c?a+1:a,b++);return b},caretPos:function(a,b,d,h){return g.translation[e.charAt(Math.min(a-1,e.length-1))]?Math.min(a+d-b-h,d):c.caretPos(a+1,b,d,h)},behaviour:function(d){d=d||window.event;c.invalid=[];var e=a.data("mask-keycode");if(-1===b.inArray(e,g.byPassKeys)){var m=c.getCaret(),h=c.val().length,f=c.getMasked(),l=f.length,k=c.getMCharsBeforeCount(l-1)-c.getMCharsBeforeCount(h-1),n=m<h;c.val(f);n&&(8!==e&&46!==e&&(m=c.caretPos(m,h,l,k)),
c.setCaret(m));return c.callbacks(d)}},getMasked:function(a,b){var m=[],h=void 0===b?c.val():b+"",f=0,l=e.length,k=0,n=h.length,q=1,p="push",u=-1,t,w;d.reverse?(p="unshift",q=-1,t=0,f=l-1,k=n-1,w=function(){return-1<f&&-1<k}):(t=l-1,w=function(){return f<l&&k<n});for(;w();){var x=e.charAt(f),v=h.charAt(k),s=g.translation[x];if(s)v.match(s.pattern)?(m[p](v),s.recursive&&(-1===u?u=f:f===t&&(f=u-q),t===u&&(f-=q)),f+=q):s.optional?(f+=q,k-=q):s.fallback?(m[p](s.fallback),f+=q,k-=q):c.invalid.push({p:k,
v:v,e:s.pattern}),k+=q;else{if(!a)m[p](x);v===x&&(k+=q);f+=q}}h=e.charAt(t);l!==n+1||g.translation[h]||m.push(h);return m.join("")},callbacks:function(b){var g=c.val(),m=g!==n,h=[g,b,a,d],f=function(a,b,c){"function"===typeof d[a]&&b&&d[a].apply(this,c)};f("onChange",!0===m,h);f("onKeyPress",!0===m,h);f("onComplete",g.length===e.length,h);f("onInvalid",0<c.invalid.length,[g,b,a,c.invalid,d])}};a=b(a);var g=this,n=c.val(),p;e="function"===typeof e?e(c.val(),void 0,a,d):e;g.mask=e;g.options=d;g.remove=
function(){var b=c.getCaret();c.destroyEvents();c.val(g.getCleanVal());c.setCaret(b-c.getMCharsBeforeCount(b));return a};g.getCleanVal=function(){return c.getMasked(!0)};g.getMaskedVal=function(a){return c.getMasked(!1,a)};g.init=function(e){e=e||!1;d=d||{};g.clearIfNotMatch=b.jMaskGlobals.clearIfNotMatch;g.byPassKeys=b.jMaskGlobals.byPassKeys;g.translation=b.extend({},b.jMaskGlobals.translation,d.translation);g=b.extend(!0,{},g,d);p=c.getRegexMask();!1===e?(d.placeholder&&a.attr("placeholder",d.placeholder),
a.data("mask")&&a.attr("autocomplete","off"),c.destroyEvents(),c.events(),e=c.getCaret(),c.val(c.getMasked()),c.setCaret(e+c.getMCharsBeforeCount(e,!0))):(c.events(),c.val(c.getMasked()))};g.init(!a.is("input"))};b.maskWatchers={};var A=function(){var a=b(this),e={},d=a.attr("data-mask");a.attr("data-mask-reverse")&&(e.reverse=!0);a.attr("data-mask-clearifnotmatch")&&(e.clearIfNotMatch=!0);"true"===a.attr("data-mask-selectonfocus")&&(e.selectOnFocus=!0);if(z(a,d,e))return a.data("mask",new y(this,
d,e))},z=function(a,e,d){d=d||{};var c=b(a).data("mask"),g=JSON.stringify;a=b(a).val()||b(a).text();try{return"function"===typeof e&&(e=e(a)),"object"!==typeof c||g(c.options)!==g(d)||c.mask!==e}catch(n){}};b.fn.mask=function(a,e){e=e||{};var d=this.selector,c=b.jMaskGlobals,g=c.watchInterval,c=e.watchInputs||c.watchInputs,n=function(){if(z(this,a,e))return b(this).data("mask",new y(this,a,e))};b(this).each(n);d&&""!==d&&c&&(clearInterval(b.maskWatchers[d]),b.maskWatchers[d]=setInterval(function(){b(document).find(d).each(n)},
g));return this};b.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};b.fn.unmask=function(){clearInterval(b.maskWatchers[this.selector]);delete b.maskWatchers[this.selector];return this.each(function(){var a=b(this).data("mask");a&&a.remove().removeData("mask")})};b.fn.cleanVal=function(){return this.data("mask").getCleanVal()};b.applyDataMask=function(a){a=a||b.jMaskGlobals.maskElements;(a instanceof b?a:b(a)).filter(b.jMaskGlobals.dataMaskAttr).each(A)};var p={maskElements:"input,td,span,div",
dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,useInput:function(a){var b=document.createElement("div"),d;a="on"+a;d=a in b;d||(b.setAttribute(a,"return;"),d="function"===typeof b[a]);return d}("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},S:{pattern:/[a-zA-Z]/}}};b.jMaskGlobals=b.jMaskGlobals||{};p=b.jMaskGlobals=b.extend(!0,{},p,b.jMaskGlobals);
p.dataMask&&b.applyDataMask();setInterval(function(){b.jMaskGlobals.watchDataMask&&b.applyDataMask()},p.watchInterval)});
 
/** **************************************************** **/
/** ********************** jquery-datepicker ****************************** **/
 /*! jQuery UI - v1.11.4 - 2016-06-28
* http://jqueryui.com
* Includes: core.js, datepicker.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */
(function(e){typeof define=="function"&&define.amd?define(["jquery"],e):e(jQuery)})(function(e){function t(t,r){var i,s,o,u=t.nodeName.toLowerCase();return"area"===u?(i=t.parentNode,s=i.name,!t.href||!s||i.nodeName.toLowerCase()!=="map"?!1:(o=e("img[usemap='#"+s+"']")[0],!!o&&n(o))):(/^(input|select|textarea|button|object)$/.test(u)?!t.disabled:"a"===u?t.href||r:r)&&n(t)}function n(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return e.css(this,"visibility")==="hidden"}).length}function i(e){var t,n;while(e.length&&e[0]!==document){t=e.css("position");if(t==="absolute"||t==="relative"||t==="fixed"){n=parseInt(e.css("zIndex"),10);if(!isNaN(n)&&n!==0)return n}e=e.parent()}return 0}function s(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},e.extend(this._defaults,this.regional[""]),this.regional.en=e.extend(!0,{},this.regional[""]),this.regional["en-US"]=e.extend(!0,{},this.regional.en),this.dpDiv=o(e("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function o(t){var n="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.delegate(n,"mouseout",function(){e(this).removeClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).removeClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).removeClass("ui-datepicker-next-hover")}).delegate(n,"mouseover",u)}function u(){e.datepicker._isDisabledDatepicker(r.inline?r.dpDiv.parent()[0]:r.input[0])||(e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),e(this).addClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).addClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).addClass("ui-datepicker-next-hover"))}function a(t,n){e.extend(t,n);for(var r in n)n[r]==null&&(t[r]=n[r]);return t}e.ui=e.ui||{},e.extend(e.ui,{version:"1.11.4",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({scrollParent:function(t){var n=this.css("position"),r=n==="absolute",i=t?/(auto|scroll|hidden)/:/(auto|scroll)/,s=this.parents().filter(function(){var t=e(this);return r&&t.css("position")==="static"?!1:i.test(t.css("overflow")+t.css("overflow-y")+t.css("overflow-x"))}).eq(0);return n==="fixed"||!s.length?e(this[0].ownerDocument||document):s},uniqueId:function(){var e=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++e)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(n){return!!e.data(n,t)}}):function(t,n,r){return!!e.data(t,r[3])},focusable:function(n){return t(n,!isNaN(e.attr(n,"tabindex")))},tabbable:function(n){var r=e.attr(n,"tabindex"),i=isNaN(r);return(i||r>=0)&&t(n,!i)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(t,n){function o(t,n,i,s){return e.each(r,function(){n-=parseFloat(e.css(t,"padding"+this))||0,i&&(n-=parseFloat(e.css(t,"border"+this+"Width"))||0),s&&(n-=parseFloat(e.css(t,"margin"+this))||0)}),n}var r=n==="Width"?["Left","Right"]:["Top","Bottom"],i=n.toLowerCase(),s={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+n]=function(t){return t===undefined?s["inner"+n].call(this):this.each(function(){e(this).css(i,o(this,t)+"px")})},e.fn["outer"+n]=function(t,r){return typeof t!="number"?s["outer"+n].call(this,t):this.each(function(){e(this).css(i,o(this,t,!0,r)+"px")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(e==null?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(n){return arguments.length?t.call(this,e.camelCase(n)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.fn.extend({focus:function(t){return function(n,r){return typeof n=="number"?this.each(function(){var t=this;setTimeout(function(){e(t).focus(),r&&r.call(t)},n)}):t.apply(this,arguments)}}(e.fn.focus),disableSelection:function(){var e="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.bind(e+".ui-disableSelection",function(e){e.preventDefault()})}}(),enableSelection:function(){return this.unbind(".ui-disableSelection")},zIndex:function(t){if(t!==undefined)return this.css("zIndex",t);if(this.length){var n=e(this[0]),r,i;while(n.length&&n[0]!==document){r=n.css("position");if(r==="absolute"||r==="relative"||r==="fixed"){i=parseInt(n.css("zIndex"),10);if(!isNaN(i)&&i!==0)return i}n=n.parent()}}return 0}}),e.ui.plugin={add:function(t,n,r){var i,s=e.ui[t].prototype;for(i in r)s.plugins[i]=s.plugins[i]||[],s.plugins[i].push([n,r[i]])},call:function(e,t,n,r){var i,s=e.plugins[t];if(!s)return;if(!r&&(!e.element[0].parentNode||e.element[0].parentNode.nodeType===11))return;for(i=0;i<s.length;i++)e.options[s[i][0]]&&s[i][1].apply(e.element,n)}},e.extend(e.ui,{datepicker:{version:"1.11.4"}});var r;e.extend(s.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return a(this._defaults,e||{}),this},_attachDatepicker:function(t,n){var r,i,s;r=t.nodeName.toLowerCase(),i=r==="div"||r==="span",t.id||(this.uuid+=1,t.id="dp"+this.uuid),s=this._newInst(e(t),i),s.settings=e.extend({},n||{}),r==="input"?this._connectDatepicker(t,s):i&&this._inlineDatepicker(t,s)},_newInst:function(t,n){var r=t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:r,input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:n,dpDiv:n?o(e("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,n){var r=e(t);n.append=e([]),n.trigger=e([]);if(r.hasClass(this.markerClassName))return;this._attachments(r,n),r.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(n),e.data(t,"datepicker",n),n.settings.disabled&&this._disableDatepicker(t)},_attachments:function(t,n){var r,i,s,o=this._get(n,"appendText"),u=this._get(n,"isRTL");n.append&&n.append.remove(),o&&(n.append=e("<span class='"+this._appendClass+"'>"+o+"</span>"),t[u?"before":"after"](n.append)),t.unbind("focus",this._showDatepicker),n.trigger&&n.trigger.remove(),r=this._get(n,"showOn"),(r==="focus"||r==="both")&&t.focus(this._showDatepicker);if(r==="button"||r==="both")i=this._get(n,"buttonText"),s=this._get(n,"buttonImage"),n.trigger=e(this._get(n,"buttonImageOnly")?e("<img/>").addClass(this._triggerClass).attr({src:s,alt:i,title:i}):e("<button type='button'></button>").addClass(this._triggerClass).html(s?e("<img/>").attr({src:s,alt:i,title:i}):i)),t[u?"before":"after"](n.trigger),n.trigger.click(function(){return e.datepicker._datepickerShowing&&e.datepicker._lastInput===t[0]?e.datepicker._hideDatepicker():e.datepicker._datepickerShowing&&e.datepicker._lastInput!==t[0]?(e.datepicker._hideDatepicker(),e.datepicker._showDatepicker(t[0])):e.datepicker._showDatepicker(t[0]),!1})},_autoSize:function(e){if(this._get(e,"autoSize")&&!e.inline){var t,n,r,i,s=new Date(2009,11,20),o=this._get(e,"dateFormat");o.match(/[DM]/)&&(t=function(e){n=0,r=0;for(i=0;i<e.length;i++)e[i].length>n&&(n=e[i].length,r=i);return r},s.setMonth(t(this._get(e,o.match(/MM/)?"monthNames":"monthNamesShort"))),s.setDate(t(this._get(e,o.match(/DD/)?"dayNames":"dayNamesShort"))+20-s.getDay())),e.input.attr("size",this._formatDate(e,s).length)}},_inlineDatepicker:function(t,n){var r=e(t);if(r.hasClass(this.markerClassName))return;r.addClass(this.markerClassName).append(n.dpDiv),e.data(t,"datepicker",n),this._setDate(n,this._getDefaultDate(n),!0),this._updateDatepicker(n),this._updateAlternate(n),n.settings.disabled&&this._disableDatepicker(t),n.dpDiv.css("display","block")},_dialogDatepicker:function(t,n,r,i,s){var o,u,f,l,c,h=this._dialogInst;return h||(this.uuid+=1,o="dp"+this.uuid,this._dialogInput=e("<input type='text' id='"+o+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),e("body").append(this._dialogInput),h=this._dialogInst=this._newInst(this._dialogInput,!1),h.settings={},e.data(this._dialogInput[0],"datepicker",h)),a(h.settings,i||{}),n=n&&n.constructor===Date?this._formatDate(h,n):n,this._dialogInput.val(n),this._pos=s?s.length?s:[s.pageX,s.pageY]:null,this._pos||(u=document.documentElement.clientWidth,f=document.documentElement.clientHeight,l=document.documentElement.scrollLeft||document.body.scrollLeft,c=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[u/2-100+l,f/2-150+c]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),h.settings.onSelect=r,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),e.blockUI&&e.blockUI(this.dpDiv),e.data(this._dialogInput[0],"datepicker",h),this},_destroyDatepicker:function(t){var n,i=e(t),s=e.data(t,"datepicker");if(!i.hasClass(this.markerClassName))return;n=t.nodeName.toLowerCase(),e.removeData(t,"datepicker"),n==="input"?(s.append.remove(),s.trigger.remove(),i.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):(n==="div"||n==="span")&&i.removeClass(this.markerClassName).empty(),r===s&&(r=null)},_enableDatepicker:function(t){var n,r,i=e(t),s=e.data(t,"datepicker");if(!i.hasClass(this.markerClassName))return;n=t.nodeName.toLowerCase();if(n==="input")t.disabled=!1,s.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""});else if(n==="div"||n==="span")r=i.children("."+this._inlineClass),r.children().removeClass("ui-state-disabled"),r.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1);this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e})},_disableDatepicker:function(t){var n,r,i=e(t),s=e.data(t,"datepicker");if(!i.hasClass(this.markerClassName))return;n=t.nodeName.toLowerCase();if(n==="input")t.disabled=!0,s.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"});else if(n==="div"||n==="span")r=i.children("."+this._inlineClass),r.children().addClass("ui-state-disabled"),r.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0);this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t},_isDisabledDatepicker:function(e){if(!e)return!1;for(var t=0;t<this._disabledInputs.length;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(t){try{return e.data(t,"datepicker")}catch(n){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(t,n,r){var i,s,o,u,f=this._getInst(t);if(arguments.length===2&&typeof n=="string")return n==="defaults"?e.extend({},e.datepicker._defaults):f?n==="all"?e.extend({},f.settings):this._get(f,n):null;i=n||{},typeof n=="string"&&(i={},i[n]=r),f&&(this._curInst===f&&this._hideDatepicker(),s=this._getDateDatepicker(t,!0),o=this._getMinMaxDate(f,"min"),u=this._getMinMaxDate(f,"max"),a(f.settings,i),o!==null&&i.dateFormat!==undefined&&i.minDate===undefined&&(f.settings.minDate=this._formatDate(f,o)),u!==null&&i.dateFormat!==undefined&&i.maxDate===undefined&&(f.settings.maxDate=this._formatDate(f,u)),"disabled"in i&&(i.disabled?this._disableDatepicker(t):this._enableDatepicker(t)),this._attachments(e(t),f),this._autoSize(f),this._setDate(f,s),this._updateAlternate(f),this._updateDatepicker(f))},_changeDatepicker:function(e,t,n){this._optionDatepicker(e,t,n)},_refreshDatepicker:function(e){var t=this._getInst(e);t&&this._updateDatepicker(t)},_setDateDatepicker:function(e,t){var n=this._getInst(e);n&&(this._setDate(n,t),this._updateDatepicker(n),this._updateAlternate(n))},_getDateDatepicker:function(e,t){var n=this._getInst(e);return n&&!n.inline&&this._setDateFromField(n,t),n?this._getDate(n):null},_doKeyDown:function(t){var n,r,i,s=e.datepicker._getInst(t.target),o=!0,u=s.dpDiv.is(".ui-datepicker-rtl");s._keyEvent=!0;if(e.datepicker._datepickerShowing)switch(t.keyCode){case 9:e.datepicker._hideDatepicker(),o=!1;break;case 13:return i=e("td."+e.datepicker._dayOverClass+":not(."+e.datepicker._currentClass+")",s.dpDiv),i[0]&&e.datepicker._selectDay(t.target,s.selectedMonth,s.selectedYear,i[0]),n=e.datepicker._get(s,"onSelect"),n?(r=e.datepicker._formatDate(s),n.apply(s.input?s.input[0]:null,[r,s])):e.datepicker._hideDatepicker(),!1;case 27:e.datepicker._hideDatepicker();break;case 33:e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(s,"stepBigMonths"):-e.datepicker._get(s,"stepMonths"),"M");break;case 34:e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(s,"stepBigMonths"):+e.datepicker._get(s,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&e.datepicker._clearDate(t.target),o=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&e.datepicker._gotoToday(t.target),o=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,u?1:-1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(s,"stepBigMonths"):-e.datepicker._get(s,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,-7,"D"),o=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,u?-1:1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(s,"stepBigMonths"):+e.datepicker._get(s,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,7,"D"),o=t.ctrlKey||t.metaKey;break;default:o=!1}else t.keyCode===36&&t.ctrlKey?e.datepicker._showDatepicker(this):o=!1;o&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var n,r,i=e.datepicker._getInst(t.target);if(e.datepicker._get(i,"constrainInput"))return n=e.datepicker._possibleChars(e.datepicker._get(i,"dateFormat")),r=String.fromCharCode(t.charCode==null?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||r<" "||!n||n.indexOf(r)>-1},_doKeyUp:function(t){var n,r=e.datepicker._getInst(t.target);if(r.input.val()!==r.lastVal)try{n=e.datepicker.parseDate(e.datepicker._get(r,"dateFormat"),r.input?r.input.val():null,e.datepicker._getFormatConfig(r)),n&&(e.datepicker._setDateFromField(r),e.datepicker._updateAlternate(r),e.datepicker._updateDatepicker(r))}catch(i){}return!0},_showDatepicker:function(t){t=t.target||t,t.nodeName.toLowerCase()!=="input"&&(t=e("input",t.parentNode)[0]);if(e.datepicker._isDisabledDatepicker(t)||e.datepicker._lastInput===t)return;var n,r,s,o,u,f,l;n=e.datepicker._getInst(t),e.datepicker._curInst&&e.datepicker._curInst!==n&&(e.datepicker._curInst.dpDiv.stop(!0,!0),n&&e.datepicker._datepickerShowing&&e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])),r=e.datepicker._get(n,"beforeShow"),s=r?r.apply(t,[t,n]):{};if(s===!1)return;a(n.settings,s),n.lastVal=null,e.datepicker._lastInput=t,e.datepicker._setDateFromField(n),e.datepicker._inDialog&&(t.value=""),e.datepicker._pos||(e.datepicker._pos=e.datepicker._findPos(t),e.datepicker._pos[1]+=t.offsetHeight),o=!1,e(t).parents().each(function(){return o|=e(this).css("position")==="fixed",!o}),u={left:e.datepicker._pos[0],top:e.datepicker._pos[1]},e.datepicker._pos=null,n.dpDiv.empty(),n.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),e.datepicker._updateDatepicker(n),u=e.datepicker._checkOffset(n,u,o),n.dpDiv.css({position:e.datepicker._inDialog&&e.blockUI?"static":o?"fixed":"absolute",display:"none",left:u.left+"px",top:u.top+"px"}),n.inline||(f=e.datepicker._get(n,"showAnim"),l=e.datepicker._get(n,"duration"),n.dpDiv.css("z-index",i(e(t))+1),e.datepicker._datepickerShowing=!0,e.effects&&e.effects.effect[f]?n.dpDiv.show(f,e.datepicker._get(n,"showOptions"),l):n.dpDiv[f||"show"](f?l:null),e.datepicker._shouldFocusInput(n)&&n.input.focus(),e.datepicker._curInst=n)},_updateDatepicker:function(t){this.maxRows=4,r=t,t.dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t);var n,i=this._getNumberOfMonths(t),s=i[1],o=17,a=t.dpDiv.find("."+this._dayOverClass+" a");a.length>0&&u.apply(a.get(0)),t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),s>1&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",o*s+"em"),t.dpDiv[(i[0]!==1||i[1]!==1?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===e.datepicker._curInst&&e.datepicker._datepickerShowing&&e.datepicker._shouldFocusInput(t)&&t.input.focus(),t.yearshtml&&(n=t.yearshtml,setTimeout(function(){n===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml),n=t.yearshtml=null},0))},_shouldFocusInput:function(e){return e.input&&e.input.is(":visible")&&!e.input.is(":disabled")&&!e.input.is(":focus")},_checkOffset:function(t,n,r){var i=t.dpDiv.outerWidth(),s=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,u=t.input?t.input.outerHeight():0,a=document.documentElement.clientWidth+(r?0:e(document).scrollLeft()),f=document.documentElement.clientHeight+(r?0:e(document).scrollTop());return n.left-=this._get(t,"isRTL")?i-o:0,n.left-=r&&n.left===t.input.offset().left?e(document).scrollLeft():0,n.top-=r&&n.top===t.input.offset().top+u?e(document).scrollTop():0,n.left-=Math.min(n.left,n.left+i>a&&a>i?Math.abs(n.left+i-a):0),n.top-=Math.min(n.top,n.top+s>f&&f>s?Math.abs(s+u):0),n},_findPos:function(t){var n,r=this._getInst(t),i=this._get(r,"isRTL");while(t&&(t.type==="hidden"||t.nodeType!==1||e.expr.filters.hidden(t)))t=t[i?"previousSibling":"nextSibling"];return n=e(t).offset(),[n.left,n.top]},_hideDatepicker:function(t){var n,r,i,s,o=this._curInst;if(!o||t&&o!==e.data(t,"datepicker"))return;this._datepickerShowing&&(n=this._get(o,"showAnim"),r=this._get(o,"duration"),i=function(){e.datepicker._tidyDialog(o)},e.effects&&(e.effects.effect[n]||e.effects[n])?o.dpDiv.hide(n,e.datepicker._get(o,"showOptions"),r,i):o.dpDiv[n==="slideDown"?"slideUp":n==="fadeIn"?"fadeOut":"hide"](n?r:null,i),n||i(),this._datepickerShowing=!1,s=this._get(o,"onClose"),s&&s.apply(o.input?o.input[0]:null,[o.input?o.input.val():"",o]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),e.blockUI&&(e.unblockUI(),e("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(t){if(!e.datepicker._curInst)return;var n=e(t.target),r=e.datepicker._getInst(n[0]);(n[0].id!==e.datepicker._mainDivId&&n.parents("#"+e.datepicker._mainDivId).length===0&&!n.hasClass(e.datepicker.markerClassName)&&!n.closest("."+e.datepicker._triggerClass).length&&e.datepicker._datepickerShowing&&(!e.datepicker._inDialog||!e.blockUI)||n.hasClass(e.datepicker.markerClassName)&&e.datepicker._curInst!==r)&&e.datepicker._hideDatepicker()},_adjustDate:function(t,n,r){var i=e(t),s=this._getInst(i[0]);if(this._isDisabledDatepicker(i[0]))return;this._adjustInstDate(s,n+(r==="M"?this._get(s,"showCurrentAtPos"):0),r),this._updateDatepicker(s)},_gotoToday:function(t){var n,r=e(t),i=this._getInst(r[0]);this._get(i,"gotoCurrent")&&i.currentDay?(i.selectedDay=i.currentDay,i.drawMonth=i.selectedMonth=i.currentMonth,i.drawYear=i.selectedYear=i.currentYear):(n=new Date,i.selectedDay=n.getDate(),i.drawMonth=i.selectedMonth=n.getMonth(),i.drawYear=i.selectedYear=n.getFullYear()),this._notifyChange(i),this._adjustDate(r)},_selectMonthYear:function(t,n,r){var i=e(t),s=this._getInst(i[0]);s["selected"+(r==="M"?"Month":"Year")]=s["draw"+(r==="M"?"Month":"Year")]=parseInt(n.options[n.selectedIndex].value,10),this._notifyChange(s),this._adjustDate(i)},_selectDay:function(t,n,r,i){var s,o=e(t);if(e(i).hasClass(this._unselectableClass)||this._isDisabledDatepicker(o[0]))return;s=this._getInst(o[0]),s.selectedDay=s.currentDay=e("a",i).html(),s.selectedMonth=s.currentMonth=n,s.selectedYear=s.currentYear=r,this._selectDate(t,this._formatDate(s,s.currentDay,s.currentMonth,s.currentYear))},_clearDate:function(t){var n=e(t);this._selectDate(n,"")},_selectDate:function(t,n){var r,i=e(t),s=this._getInst(i[0]);n=n!=null?n:this._formatDate(s),s.input&&s.input.val(n),this._updateAlternate(s),r=this._get(s,"onSelect"),r?r.apply(s.input?s.input[0]:null,[n,s]):s.input&&s.input.trigger("change"),s.inline?this._updateDatepicker(s):(this._hideDatepicker(),this._lastInput=s.input[0],typeof s.input[0]!="object"&&s.input.focus(),this._lastInput=null)},_updateAlternate:function(t){var n,r,i,s=this._get(t,"altField");s&&(n=this._get(t,"altFormat")||this._get(t,"dateFormat"),r=this._getDate(t),i=this.formatDate(n,r,this._getFormatConfig(t)),e(s).each(function(){e(this).val(i)}))},noWeekends:function(e){var t=e.getDay();return[t>0&&t<6,""]},iso8601Week:function(e){var t,n=new Date(e.getTime());return n.setDate(n.getDate()+4-(n.getDay()||7)),t=n.getTime(),n.setMonth(0),n.setDate(1),Math.floor(Math.round((t-n)/864e5)/7)+1},parseDate:function(t,n,r){if(t==null||n==null)throw"Invalid arguments";n=typeof n=="object"?n.toString():n+"";if(n==="")return null;var i,s,o,u=0,a=(r?r.shortYearCutoff:null)||this._defaults.shortYearCutoff,f=typeof a!="string"?a:(new Date).getFullYear()%100+parseInt(a,10),l=(r?r.dayNamesShort:null)||this._defaults.dayNamesShort,c=(r?r.dayNames:null)||this._defaults.dayNames,h=(r?r.monthNamesShort:null)||this._defaults.monthNamesShort,p=(r?r.monthNames:null)||this._defaults.monthNames,d=-1,v=-1,m=-1,g=-1,y=!1,b,w=function(e){var n=i+1<t.length&&t.charAt(i+1)===e;return n&&i++,n},E=function(e){var t=w(e),r=e==="@"?14:e==="!"?20:e==="y"&&t?4:e==="o"?3:2,i=e==="y"?r:1,s=new RegExp("^\\d{"+i+","+r+"}"),o=n.substring(u).match(s);if(!o)throw"Missing number at position "+u;return u+=o[0].length,parseInt(o[0],10)},S=function(t,r,i){var s=-1,o=e.map(w(t)?i:r,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});e.each(o,function(e,t){var r=t[1];if(n.substr(u,r.length).toLowerCase()===r.toLowerCase())return s=t[0],u+=r.length,!1});if(s!==-1)return s+1;throw"Unknown name at position "+u},x=function(){if(n.charAt(u)!==t.charAt(i))throw"Unexpected literal at position "+u;u++};for(i=0;i<t.length;i++)if(y)t.charAt(i)==="'"&&!w("'")?y=!1:x();else switch(t.charAt(i)){case"d":m=E("d");break;case"D":S("D",l,c);break;case"o":g=E("o");break;case"m":v=E("m");break;case"M":v=S("M",h,p);break;case"y":d=E("y");break;case"@":b=new Date(E("@")),d=b.getFullYear(),v=b.getMonth()+1,m=b.getDate();break;case"!":b=new Date((E("!")-this._ticksTo1970)/1e4),d=b.getFullYear(),v=b.getMonth()+1,m=b.getDate();break;case"'":w("'")?x():y=!0;break;default:x()}if(u<n.length){o=n.substr(u);if(!/^\s+/.test(o))throw"Extra/unparsed characters found in date: "+o}d===-1?d=(new Date).getFullYear():d<100&&(d+=(new Date).getFullYear()-(new Date).getFullYear()%100+(d<=f?0:-100));if(g>-1){v=1,m=g;do{s=this._getDaysInMonth(d,v-1);if(m<=s)break;v++,m-=s}while(!0)}b=this._daylightSavingAdjust(new Date(d,v-1,m));if(b.getFullYear()!==d||b.getMonth()+1!==v||b.getDate()!==m)throw"Invalid date";return b},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*24*60*60*1e7,formatDate:function(e,t,n){if(!t)return"";var r,i=(n?n.dayNamesShort:null)||this._defaults.dayNamesShort,s=(n?n.dayNames:null)||this._defaults.dayNames,o=(n?n.monthNamesShort:null)||this._defaults.monthNamesShort,u=(n?n.monthNames:null)||this._defaults.monthNames,a=function(t){var n=r+1<e.length&&e.charAt(r+1)===t;return n&&r++,n},f=function(e,t,n){var r=""+t;if(a(e))while(r.length<n)r="0"+r;return r},l=function(e,t,n,r){return a(e)?r[t]:n[t]},c="",h=!1;if(t)for(r=0;r<e.length;r++)if(h)e.charAt(r)==="'"&&!a("'")?h=!1:c+=e.charAt(r);else switch(e.charAt(r)){case"d":c+=f("d",t.getDate(),2);break;case"D":c+=l("D",t.getDay(),i,s);break;case"o":c+=f("o",Math.round(((new Date(t.getFullYear(),t.getMonth(),t.getDate())).getTime()-(new Date(t.getFullYear(),0,0)).getTime())/864e5),3);break;case"m":c+=f("m",t.getMonth()+1,2);break;case"M":c+=l("M",t.getMonth(),o,u);break;case"y":c+=a("y")?t.getFullYear():(t.getYear()%100<10?"0":"")+t.getYear()%100;break;case"@":c+=t.getTime();break;case"!":c+=t.getTime()*1e4+this._ticksTo1970;break;case"'":a("'")?c+="'":h=!0;break;default:c+=e.charAt(r)}return c},_possibleChars:function(e){var t,n="",r=!1,i=function(n){var r=t+1<e.length&&e.charAt(t+1)===n;return r&&t++,r};for(t=0;t<e.length;t++)if(r)e.charAt(t)==="'"&&!i("'")?r=!1:n+=e.charAt(t);else switch(e.charAt(t)){case"d":case"m":case"y":case"@":n+="0123456789";break;case"D":case"M":return null;case"'":i("'")?n+="'":r=!0;break;default:n+=e.charAt(t)}return n},_get:function(e,t){return e.settings[t]!==undefined?e.settings[t]:this._defaults[t]},_setDateFromField:function(e,t){if(e.input.val()===e.lastVal)return;var n=this._get(e,"dateFormat"),r=e.lastVal=e.input?e.input.val():null,i=this._getDefaultDate(e),s=i,o=this._getFormatConfig(e);try{s=this.parseDate(n,r,o)||i}catch(u){r=t?"":r}e.selectedDay=s.getDate(),e.drawMonth=e.selectedMonth=s.getMonth(),e.drawYear=e.selectedYear=s.getFullYear(),e.currentDay=r?s.getDate():0,e.currentMonth=r?s.getMonth():0,e.currentYear=r?s.getFullYear():0,this._adjustInstDate(e)},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,"defaultDate"),new Date))},_determineDate:function(t,n,r){var i=function(e){var t=new Date;return t.setDate(t.getDate()+e),t},s=function(n){try{return e.datepicker.parseDate(e.datepicker._get(t,"dateFormat"),n,e.datepicker._getFormatConfig(t))}catch(r){}var i=(n.toLowerCase().match(/^c/)?e.datepicker._getDate(t):null)||new Date,s=i.getFullYear(),o=i.getMonth(),u=i.getDate(),a=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,f=a.exec(n);while(f){switch(f[2]||"d"){case"d":case"D":u+=parseInt(f[1],10);break;case"w":case"W":u+=parseInt(f[1],10)*7;break;case"m":case"M":o+=parseInt(f[1],10),u=Math.min(u,e.datepicker._getDaysInMonth(s,o));break;case"y":case"Y":s+=parseInt(f[1],10),u=Math.min(u,e.datepicker._getDaysInMonth(s,o))}f=a.exec(n)}return new Date(s,o,u)},o=n==null||n===""?r:typeof n=="string"?s(n):typeof n=="number"?isNaN(n)?r:i(n):new Date(n.getTime());return o=o&&o.toString()==="Invalid Date"?r:o,o&&(o.setHours(0),o.setMinutes(0),o.setSeconds(0),o.setMilliseconds(0)),this._daylightSavingAdjust(o)},_daylightSavingAdjust:function(e){return e?(e.setHours(e.getHours()>12?e.getHours()+2:0),e):null},_setDate:function(e,t,n){var r=!t,i=e.selectedMonth,s=e.selectedYear,o=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=o.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=o.getMonth(),e.drawYear=e.selectedYear=e.currentYear=o.getFullYear(),(i!==e.selectedMonth||s!==e.selectedYear)&&!n&&this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(r?"":this._formatDate(e))},_getDate:function(e){var t=!e.currentYear||e.input&&e.input.val()===""?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return t},_attachHandlers:function(t){var n=this._get(t,"stepMonths"),r="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){e.datepicker._adjustDate(r,-n,"M")},next:function(){e.datepicker._adjustDate(r,+n,"M")},hide:function(){e.datepicker._hideDatepicker()},today:function(){e.datepicker._gotoToday(r)},selectDay:function(){return e.datepicker._selectDay(r,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return e.datepicker._selectMonthYear(r,this,"M"),!1},selectYear:function(){return e.datepicker._selectMonthYear(r,this,"Y"),!1}};e(this).bind(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(e){var t,n,r,i,s,o,u,a,f,l,c,h,p,d,v,m,g,y,b,w,E,S,x,T,N,C,k,L,A,O,M,_,D,P,H,B,j,F,I,q=new Date,R=this._daylightSavingAdjust(new Date(q.getFullYear(),q.getMonth(),q.getDate())),U=this._get(e,"isRTL"),z=this._get(e,"showButtonPanel"),W=this._get(e,"hideIfNoPrevNext"),X=this._get(e,"navigationAsDateFormat"),V=this._getNumberOfMonths(e),$=this._get(e,"showCurrentAtPos"),J=this._get(e,"stepMonths"),K=V[0]!==1||V[1]!==1,Q=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),G=this._getMinMaxDate(e,"min"),Y=this._getMinMaxDate(e,"max"),Z=e.drawMonth-$,et=e.drawYear;Z<0&&(Z+=12,et--);if(Y){t=this._daylightSavingAdjust(new Date(Y.getFullYear(),Y.getMonth()-V[0]*V[1]+1,Y.getDate())),t=G&&t<G?G:t;while(this._daylightSavingAdjust(new Date(et,Z,1))>t)Z--,Z<0&&(Z=11,et--)}e.drawMonth=Z,e.drawYear=et,n=this._get(e,"prevText"),n=X?this.formatDate(n,this._daylightSavingAdjust(new Date(et,Z-J,1)),this._getFormatConfig(e)):n,r=this._canAdjustMonth(e,-1,et,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"e":"w")+"'>"+n+"</span></a>":W?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"e":"w")+"'>"+n+"</span></a>",i=this._get(e,"nextText"),i=X?this.formatDate(i,this._daylightSavingAdjust(new Date(et,Z+J,1)),this._getFormatConfig(e)):i,s=this._canAdjustMonth(e,1,et,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"w":"e")+"'>"+i+"</span></a>":W?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"w":"e")+"'>"+i+"</span></a>",o=this._get(e,"currentText"),u=this._get(e,"gotoCurrent")&&e.currentDay?Q:R,o=X?this.formatDate(o,u,this._getFormatConfig(e)):o,a=e.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(e,"closeText")+"</button>",f=z?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(U?a:"")+(this._isInRange(e,u)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+
o+"</button>":"")+(U?"":a)+"</div>":"",l=parseInt(this._get(e,"firstDay"),10),l=isNaN(l)?0:l,c=this._get(e,"showWeek"),h=this._get(e,"dayNames"),p=this._get(e,"dayNamesMin"),d=this._get(e,"monthNames"),v=this._get(e,"monthNamesShort"),m=this._get(e,"beforeShowDay"),g=this._get(e,"showOtherMonths"),y=this._get(e,"selectOtherMonths"),b=this._getDefaultDate(e),w="",E;for(S=0;S<V[0];S++){x="",this.maxRows=4;for(T=0;T<V[1];T++){N=this._daylightSavingAdjust(new Date(et,Z,e.selectedDay)),C=" ui-corner-all",k="";if(K){k+="<div class='ui-datepicker-group";if(V[1]>1)switch(T){case 0:k+=" ui-datepicker-group-first",C=" ui-corner-"+(U?"right":"left");break;case V[1]-1:k+=" ui-datepicker-group-last",C=" ui-corner-"+(U?"left":"right");break;default:k+=" ui-datepicker-group-middle",C=""}k+="'>"}k+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+C+"'>"+(/all|left/.test(C)&&S===0?U?s:r:"")+(/all|right/.test(C)&&S===0?U?r:s:"")+this._generateMonthYearHeader(e,Z,et,G,Y,S>0||T>0,d,v)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",L=c?"<th class='ui-datepicker-week-col'>"+this._get(e,"weekHeader")+"</th>":"";for(E=0;E<7;E++)A=(E+l)%7,L+="<th scope='col'"+((E+l+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+h[A]+"'>"+p[A]+"</span></th>";k+=L+"</tr></thead><tbody>",O=this._getDaysInMonth(et,Z),et===e.selectedYear&&Z===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,O)),M=(this._getFirstDayOfMonth(et,Z)-l+7)%7,_=Math.ceil((M+O)/7),D=K?this.maxRows>_?this.maxRows:_:_,this.maxRows=D,P=this._daylightSavingAdjust(new Date(et,Z,1-M));for(H=0;H<D;H++){k+="<tr>",B=c?"<td class='ui-datepicker-week-col'>"+this._get(e,"calculateWeek")(P)+"</td>":"";for(E=0;E<7;E++)j=m?m.apply(e.input?e.input[0]:null,[P]):[!0,""],F=P.getMonth()!==Z,I=F&&!y||!j[0]||G&&P<G||Y&&P>Y,B+="<td class='"+((E+l+6)%7>=5?" ui-datepicker-week-end":"")+(F?" ui-datepicker-other-month":"")+(P.getTime()===N.getTime()&&Z===e.selectedMonth&&e._keyEvent||b.getTime()===P.getTime()&&b.getTime()===N.getTime()?" "+this._dayOverClass:"")+(I?" "+this._unselectableClass+" ui-state-disabled":"")+(F&&!g?"":" "+j[1]+(P.getTime()===Q.getTime()?" "+this._currentClass:"")+(P.getTime()===R.getTime()?" ui-datepicker-today":""))+"'"+((!F||g)&&j[2]?" title='"+j[2].replace(/'/g,"&#39;")+"'":"")+(I?"":" data-handler='selectDay' data-event='click' data-month='"+P.getMonth()+"' data-year='"+P.getFullYear()+"'")+">"+(F&&!g?"&#xa0;":I?"<span class='ui-state-default'>"+P.getDate()+"</span>":"<a class='ui-state-default"+(P.getTime()===R.getTime()?" ui-state-highlight":"")+(P.getTime()===Q.getTime()?" ui-state-active":"")+(F?" ui-priority-secondary":"")+"' href='#'>"+P.getDate()+"</a>")+"</td>",P.setDate(P.getDate()+1),P=this._daylightSavingAdjust(P);k+=B+"</tr>"}Z++,Z>11&&(Z=0,et++),k+="</tbody></table>"+(K?"</div>"+(V[0]>0&&T===V[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=k}w+=x}return w+=f,e._keyEvent=!1,w},_generateMonthYearHeader:function(e,t,n,r,i,s,o,u){var a,f,l,c,h,p,d,v,m=this._get(e,"changeMonth"),g=this._get(e,"changeYear"),y=this._get(e,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",w="";if(s||!m)w+="<span class='ui-datepicker-month'>"+o[t]+"</span>";else{a=r&&r.getFullYear()===n,f=i&&i.getFullYear()===n,w+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";for(l=0;l<12;l++)(!a||l>=r.getMonth())&&(!f||l<=i.getMonth())&&(w+="<option value='"+l+"'"+(l===t?" selected='selected'":"")+">"+u[l]+"</option>");w+="</select>"}y||(b+=w+(s||!m||!g?"&#xa0;":""));if(!e.yearshtml){e.yearshtml="";if(s||!g)b+="<span class='ui-datepicker-year'>"+n+"</span>";else{c=this._get(e,"yearRange").split(":"),h=(new Date).getFullYear(),p=function(e){var t=e.match(/c[+\-].*/)?n+parseInt(e.substring(1),10):e.match(/[+\-].*/)?h+parseInt(e,10):parseInt(e,10);return isNaN(t)?h:t},d=p(c[0]),v=Math.max(d,p(c[1]||"")),d=r?Math.max(d,r.getFullYear()):d,v=i?Math.min(v,i.getFullYear()):v,e.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";for(;d<=v;d++)e.yearshtml+="<option value='"+d+"'"+(d===n?" selected='selected'":"")+">"+d+"</option>";e.yearshtml+="</select>",b+=e.yearshtml,e.yearshtml=null}}return b+=this._get(e,"yearSuffix"),y&&(b+=(s||!m||!g?"&#xa0;":"")+w),b+="</div>",b},_adjustInstDate:function(e,t,n){var r=e.drawYear+(n==="Y"?t:0),i=e.drawMonth+(n==="M"?t:0),s=Math.min(e.selectedDay,this._getDaysInMonth(r,i))+(n==="D"?t:0),o=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(r,i,s)));e.selectedDay=o.getDate(),e.drawMonth=e.selectedMonth=o.getMonth(),e.drawYear=e.selectedYear=o.getFullYear(),(n==="M"||n==="Y")&&this._notifyChange(e)},_restrictMinMax:function(e,t){var n=this._getMinMaxDate(e,"min"),r=this._getMinMaxDate(e,"max"),i=n&&t<n?n:t;return r&&i>r?r:i},_notifyChange:function(e){var t=this._get(e,"onChangeMonthYear");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){var t=this._get(e,"numberOfMonths");return t==null?[1,1]:typeof t=="number"?[1,t]:t},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+"Date"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return(new Date(e,t,1)).getDay()},_canAdjustMonth:function(e,t,n,r){var i=this._getNumberOfMonths(e),s=this._daylightSavingAdjust(new Date(n,r+(t<0?t:i[0]*i[1]),1));return t<0&&s.setDate(this._getDaysInMonth(s.getFullYear(),s.getMonth())),this._isInRange(e,s)},_isInRange:function(e,t){var n,r,i=this._getMinMaxDate(e,"min"),s=this._getMinMaxDate(e,"max"),o=null,u=null,a=this._get(e,"yearRange");return a&&(n=a.split(":"),r=(new Date).getFullYear(),o=parseInt(n[0],10),u=parseInt(n[1],10),n[0].match(/[+\-].*/)&&(o+=r),n[1].match(/[+\-].*/)&&(u+=r)),(!i||t.getTime()>=i.getTime())&&(!s||t.getTime()<=s.getTime())&&(!o||t.getFullYear()>=o)&&(!u||t.getFullYear()<=u)},_getFormatConfig:function(e){var t=this._get(e,"shortYearCutoff");return t=typeof t!="string"?t:(new Date).getFullYear()%100+parseInt(t,10),{shortYearCutoff:t,dayNamesShort:this._get(e,"dayNamesShort"),dayNames:this._get(e,"dayNames"),monthNamesShort:this._get(e,"monthNamesShort"),monthNames:this._get(e,"monthNames")}},_formatDate:function(e,t,n,r){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);var i=t?typeof t=="object"?t:this._daylightSavingAdjust(new Date(r,n,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,"dateFormat"),i,this._getFormatConfig(e))}}),e.fn.datepicker=function(t){if(!this.length)return this;e.datepicker.initialized||(e(document).mousedown(e.datepicker._checkExternalClick),e.datepicker.initialized=!0),e("#"+e.datepicker._mainDivId).length===0&&e("body").append(e.datepicker.dpDiv);var n=Array.prototype.slice.call(arguments,1);return typeof t!="string"||t!=="isDisabled"&&t!=="getDate"&&t!=="widget"?t==="option"&&arguments.length===2&&typeof arguments[1]=="string"?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(n)):this.each(function(){typeof t=="string"?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this].concat(n)):e.datepicker._attachDatepicker(this,t)}):e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(n))},e.datepicker=new s,e.datepicker.initialized=!1,e.datepicker.uuid=(new Date).getTime(),e.datepicker.version="1.11.4";var f=e.datepicker}); 
/** **************************************************** **/
/** ********************** iscroll ****************************** **/
 /*!
 * iScroll v4.2.5 ~ Copyright (c) 2012 Matteo Spinelli, http://cubiq.org
 * Released under MIT license, http://cubiq.org/license
 */
(function(window, doc){
var m = Math,
	dummyStyle = doc.createElement('div').style,
	vendor = (function () {
		var vendors = 't,webkitT,MozT,msT,OT'.split(','),
			t,
			i = 0,
			l = vendors.length;

		for ( ; i < l; i++ ) {
			t = vendors[i] + 'ransform';
			if ( t in dummyStyle ) {
				return vendors[i].substr(0, vendors[i].length - 1);
			}
		}

		return false;
	})(),
	cssVendor = vendor ? '-' + vendor.toLowerCase() + '-' : '',

	// Style properties
	transform = prefixStyle('transform'),
	transitionProperty = prefixStyle('transitionProperty'),
	transitionDuration = prefixStyle('transitionDuration'),
	transformOrigin = prefixStyle('transformOrigin'),
	transitionTimingFunction = prefixStyle('transitionTimingFunction'),
	transitionDelay = prefixStyle('transitionDelay'),

    // Browser capabilities
	isAndroid = (/android/gi).test(navigator.appVersion),
	isIDevice = (/iphone|ipad/gi).test(navigator.appVersion),
	isTouchPad = (/hp-tablet/gi).test(navigator.appVersion),

    has3d = prefixStyle('perspective') in dummyStyle,
    hasTouch = 'ontouchstart' in window && !isTouchPad,
    hasTransform = vendor !== false,
    hasTransitionEnd = prefixStyle('transition') in dummyStyle,

	RESIZE_EV = 'onorientationchange' in window ? 'orientationchange' : 'resize',
	START_EV = hasTouch ? 'touchstart' : 'mousedown',
	MOVE_EV = hasTouch ? 'touchmove' : 'mousemove',
	END_EV = hasTouch ? 'touchend' : 'mouseup',
	CANCEL_EV = hasTouch ? 'touchcancel' : 'mouseup',
	TRNEND_EV = (function () {
		if ( vendor === false ) return false;

		var transitionEnd = {
				''			: 'transitionend',
				'webkit'	: 'webkitTransitionEnd',
				'Moz'		: 'transitionend',
				'O'			: 'otransitionend',
				'ms'		: 'MSTransitionEnd'
			};

		return transitionEnd[vendor];
	})(),

	nextFrame = (function() {
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) { return setTimeout(callback, 1); };
	})(),
	cancelFrame = (function () {
		return window.cancelRequestAnimationFrame ||
			window.webkitCancelAnimationFrame ||
			window.webkitCancelRequestAnimationFrame ||
			window.mozCancelRequestAnimationFrame ||
			window.oCancelRequestAnimationFrame ||
			window.msCancelRequestAnimationFrame ||
			clearTimeout;
	})(),

	// Helpers
	translateZ = has3d ? ' translateZ(0)' : '',

	// Constructor
	iScroll = function (el, options) {
		var that = this,
			i;

		that.wrapper = typeof el == 'object' ? el : doc.getElementById(el);
		that.wrapper.style.overflow = 'hidden';
		that.scroller = that.wrapper.children[0];

		// Default options
		that.options = {
			hScroll: true,
			vScroll: true,
			x: 0,
			y: 0,
			bounce: true,
			bounceLock: false,
			momentum: true,
			lockDirection: true,
			useTransform: true,
			useTransition: false,
			topOffset: 0,
			checkDOMChanges: false,		// Experimental
			handleClick: true,

			// Scrollbar
			hScrollbar: true,
			vScrollbar: true,
			fixedScrollbar: isAndroid,
			hideScrollbar: isIDevice,
			fadeScrollbar: isIDevice && has3d,
			scrollbarClass: '',

			// Zoom
			zoom: false,
			zoomMin: 1,
			zoomMax: 4,
			doubleTapZoom: 2,
			wheelAction: 'scroll',

			// Snap
			snap: false,
			snapThreshold: 1,

			// Events
			onRefresh: null,
			onBeforeScrollStart: function (e) { e.preventDefault(); },
			onScrollStart: null,
			onBeforeScrollMove: null,
			onScrollMove: null,
			onBeforeScrollEnd: null,
			onScrollEnd: null,
			onTouchEnd: null,
			onDestroy: null,
			onZoomStart: null,
			onZoom: null,
			onZoomEnd: null
		};

		// User defined options
		for (i in options) that.options[i] = options[i];
		
		// Set starting position
		that.x = that.options.x;
		that.y = that.options.y;

		// Normalize options
		that.options.useTransform = hasTransform && that.options.useTransform;
		that.options.hScrollbar = that.options.hScroll && that.options.hScrollbar;
		that.options.vScrollbar = that.options.vScroll && that.options.vScrollbar;
		that.options.zoom = that.options.useTransform && that.options.zoom;
		that.options.useTransition = hasTransitionEnd && that.options.useTransition;

		// Helpers FIX ANDROID BUG!
		// translate3d and scale doesn't work together!
		// Ignoring 3d ONLY WHEN YOU SET that.options.zoom
		if ( that.options.zoom && isAndroid ){
			translateZ = '';
		}
		
		// Set some default styles
		that.scroller.style[transitionProperty] = that.options.useTransform ? cssVendor + 'transform' : 'top left';
		that.scroller.style[transitionDuration] = '0';
		that.scroller.style[transformOrigin] = '0 0';
		if (that.options.useTransition) that.scroller.style[transitionTimingFunction] = 'cubic-bezier(0.33,0.66,0.66,1)';
		
		if (that.options.useTransform) that.scroller.style[transform] = 'translate(' + that.x + 'px,' + that.y + 'px)' + translateZ;
		else that.scroller.style.cssText += ';position:absolute;top:' + that.y + 'px;left:' + that.x + 'px';

		if (that.options.useTransition) that.options.fixedScrollbar = true;

		that.refresh();

		that._bind(RESIZE_EV, window);
		that._bind(START_EV);
		if (!hasTouch) {
			if (that.options.wheelAction != 'none') {
				that._bind('DOMMouseScroll');
				that._bind('mousewheel');
			}
		}

		if (that.options.checkDOMChanges) that.checkDOMTime = setInterval(function () {
			that._checkDOMChanges();
		}, 500);
	};

// Prototype
iScroll.prototype = {
	enabled: true,
	x: 0,
	y: 0,
	steps: [],
	scale: 1,
	currPageX: 0, currPageY: 0,
	pagesX: [], pagesY: [],
	aniTime: null,
	wheelZoomCount: 0,
	
	handleEvent: function (e) {
		var that = this;
		switch(e.type) {
			case START_EV:
				if (!hasTouch && e.button !== 0) return;
				that._start(e);
				break;
			case MOVE_EV: that._move(e); break;
			case END_EV:
			case CANCEL_EV: that._end(e); break;
			case RESIZE_EV: that._resize(); break;
			case 'DOMMouseScroll': case 'mousewheel': that._wheel(e); break;
			case TRNEND_EV: that._transitionEnd(e); break;
		}
	},
	
	_checkDOMChanges: function () {
		if (this.moved || this.zoomed || this.animating ||
			(this.scrollerW == this.scroller.offsetWidth * this.scale && this.scrollerH == this.scroller.offsetHeight * this.scale)) return;

		this.refresh();
	},
	
	_scrollbar: function (dir) {
		var that = this,
			bar;

		if (!that[dir + 'Scrollbar']) {
			if (that[dir + 'ScrollbarWrapper']) {
				if (hasTransform) that[dir + 'ScrollbarIndicator'].style[transform] = '';
				that[dir + 'ScrollbarWrapper'].parentNode.removeChild(that[dir + 'ScrollbarWrapper']);
				that[dir + 'ScrollbarWrapper'] = null;
				that[dir + 'ScrollbarIndicator'] = null;
			}

			return;
		}

		if (!that[dir + 'ScrollbarWrapper']) {
			// Create the scrollbar wrapper
			bar = doc.createElement('div');

			if (that.options.scrollbarClass) bar.className = that.options.scrollbarClass + dir.toUpperCase();
			else bar.style.cssText = 'position:absolute;z-index:100;' + (dir == 'h' ? 'height:7px;bottom:1px;left:2px;right:' + (that.vScrollbar ? '7' : '2') + 'px' : 'width:7px;bottom:' + (that.hScrollbar ? '7' : '2') + 'px;top:2px;right:1px');

			bar.style.cssText += ';pointer-events:none;' + cssVendor + 'transition-property:opacity;' + cssVendor + 'transition-duration:' + (that.options.fadeScrollbar ? '350ms' : '0') + ';overflow:hidden;opacity:' + (that.options.hideScrollbar ? '0' : '1');

			that.wrapper.appendChild(bar);
			that[dir + 'ScrollbarWrapper'] = bar;

			// Create the scrollbar indicator
			bar = doc.createElement('div');
			if (!that.options.scrollbarClass) {
				bar.style.cssText = 'position:absolute;z-index:100;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);' + cssVendor + 'background-clip:padding-box;' + cssVendor + 'box-sizing:border-box;' + (dir == 'h' ? 'height:100%' : 'width:100%') + ';' + cssVendor + 'border-radius:3px;border-radius:3px';
			}
			bar.style.cssText += ';pointer-events:none;' + cssVendor + 'transition-property:' + cssVendor + 'transform;' + cssVendor + 'transition-timing-function:cubic-bezier(0.33,0.66,0.66,1);' + cssVendor + 'transition-duration:0;' + cssVendor + 'transform: translate(0,0)' + translateZ;
			if (that.options.useTransition) bar.style.cssText += ';' + cssVendor + 'transition-timing-function:cubic-bezier(0.33,0.66,0.66,1)';

			that[dir + 'ScrollbarWrapper'].appendChild(bar);
			that[dir + 'ScrollbarIndicator'] = bar;
		}

		if (dir == 'h') {
			that.hScrollbarSize = that.hScrollbarWrapper.clientWidth;
			that.hScrollbarIndicatorSize = m.max(m.round(that.hScrollbarSize * that.hScrollbarSize / that.scrollerW), 8);
			that.hScrollbarIndicator.style.width = that.hScrollbarIndicatorSize + 'px';
			that.hScrollbarMaxScroll = that.hScrollbarSize - that.hScrollbarIndicatorSize;
			that.hScrollbarProp = that.hScrollbarMaxScroll / that.maxScrollX;
		} else {
			that.vScrollbarSize = that.vScrollbarWrapper.clientHeight;
			that.vScrollbarIndicatorSize = m.max(m.round(that.vScrollbarSize * that.vScrollbarSize / that.scrollerH), 8);
			that.vScrollbarIndicator.style.height = that.vScrollbarIndicatorSize + 'px';
			that.vScrollbarMaxScroll = that.vScrollbarSize - that.vScrollbarIndicatorSize;
			that.vScrollbarProp = that.vScrollbarMaxScroll / that.maxScrollY;
		}

		// Reset position
		that._scrollbarPos(dir, true);
	},
	
	_resize: function () {
		var that = this;
		setTimeout(function () { that.refresh(); }, isAndroid ? 200 : 0);
	},
	
	_pos: function (x, y) {
		if (this.zoomed) return;

		x = this.hScroll ? x : 0;
		y = this.vScroll ? y : 0;

		if (this.options.useTransform) {
			this.scroller.style[transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + this.scale + ')' + translateZ;
		} else {
			x = m.round(x);
			y = m.round(y);
			this.scroller.style.left = x + 'px';
			this.scroller.style.top = y + 'px';
		}

		this.x = x;
		this.y = y;

		this._scrollbarPos('h');
		this._scrollbarPos('v');
	},

	_scrollbarPos: function (dir, hidden) {
		var that = this,
			pos = dir == 'h' ? that.x : that.y,
			size;

		if (!that[dir + 'Scrollbar']) return;

		pos = that[dir + 'ScrollbarProp'] * pos;

		if (pos < 0) {
			if (!that.options.fixedScrollbar) {
				size = that[dir + 'ScrollbarIndicatorSize'] + m.round(pos * 3);
				if (size < 8) size = 8;
				that[dir + 'ScrollbarIndicator'].style[dir == 'h' ? 'width' : 'height'] = size + 'px';
			}
			pos = 0;
		} else if (pos > that[dir + 'ScrollbarMaxScroll']) {
			if (!that.options.fixedScrollbar) {
				size = that[dir + 'ScrollbarIndicatorSize'] - m.round((pos - that[dir + 'ScrollbarMaxScroll']) * 3);
				if (size < 8) size = 8;
				that[dir + 'ScrollbarIndicator'].style[dir == 'h' ? 'width' : 'height'] = size + 'px';
				pos = that[dir + 'ScrollbarMaxScroll'] + (that[dir + 'ScrollbarIndicatorSize'] - size);
			} else {
				pos = that[dir + 'ScrollbarMaxScroll'];
			}
		}

		that[dir + 'ScrollbarWrapper'].style[transitionDelay] = '0';
		that[dir + 'ScrollbarWrapper'].style.opacity = hidden && that.options.hideScrollbar ? '0' : '1';
		that[dir + 'ScrollbarIndicator'].style[transform] = 'translate(' + (dir == 'h' ? pos + 'px,0)' : '0,' + pos + 'px)') + translateZ;
	},
	
	_start: function (e) {
		var that = this,
			point = hasTouch ? e.touches[0] : e,
			matrix, x, y,
			c1, c2;

		if (!that.enabled) return;

		if (that.options.onBeforeScrollStart) that.options.onBeforeScrollStart.call(that, e);

		if (that.options.useTransition || that.options.zoom) that._transitionTime(0);

		that.moved = false;
		that.animating = false;
		that.zoomed = false;
		that.distX = 0;
		that.distY = 0;
		that.absDistX = 0;
		that.absDistY = 0;
		that.dirX = 0;
		that.dirY = 0;

		// Gesture start
		if (that.options.zoom && hasTouch && e.touches.length > 1) {
			c1 = m.abs(e.touches[0].pageX-e.touches[1].pageX);
			c2 = m.abs(e.touches[0].pageY-e.touches[1].pageY);
			that.touchesDistStart = m.sqrt(c1 * c1 + c2 * c2);

			that.originX = m.abs(e.touches[0].pageX + e.touches[1].pageX - that.wrapperOffsetLeft * 2) / 2 - that.x;
			that.originY = m.abs(e.touches[0].pageY + e.touches[1].pageY - that.wrapperOffsetTop * 2) / 2 - that.y;

			if (that.options.onZoomStart) that.options.onZoomStart.call(that, e);
		}

		if (that.options.momentum) {
			if (that.options.useTransform) {
				// Very lame general purpose alternative to CSSMatrix
				matrix = getComputedStyle(that.scroller, null)[transform].replace(/[^0-9\-.,]/g, '').split(',');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +getComputedStyle(that.scroller, null).left.replace(/[^0-9-]/g, '');
				y = +getComputedStyle(that.scroller, null).top.replace(/[^0-9-]/g, '');
			}
			
			if (x != that.x || y != that.y) {
				if (that.options.useTransition) that._unbind(TRNEND_EV);
				else cancelFrame(that.aniTime);
				that.steps = [];
				that._pos(x, y);
				if (that.options.onScrollEnd) that.options.onScrollEnd.call(that);
			}
		}

		that.absStartX = that.x;	// Needed by snap threshold
		that.absStartY = that.y;

		that.startX = that.x;
		that.startY = that.y;
		that.pointX = point.pageX;
		that.pointY = point.pageY;

		that.startTime = e.timeStamp || Date.now();

		if (that.options.onScrollStart) that.options.onScrollStart.call(that, e);

		that._bind(MOVE_EV, window);
		that._bind(END_EV, window);
		that._bind(CANCEL_EV, window);
	},
	
	_move: function (e) {
		var that = this,
			point = hasTouch ? e.touches[0] : e,
			deltaX = point.pageX - that.pointX,
			deltaY = point.pageY - that.pointY,
			newX = that.x + deltaX,
			newY = that.y + deltaY,
			c1, c2, scale,
			timestamp = e.timeStamp || Date.now();

		if (that.options.onBeforeScrollMove) that.options.onBeforeScrollMove.call(that, e);

		// Zoom
		if (that.options.zoom && hasTouch && e.touches.length > 1) {
			c1 = m.abs(e.touches[0].pageX - e.touches[1].pageX);
			c2 = m.abs(e.touches[0].pageY - e.touches[1].pageY);
			that.touchesDist = m.sqrt(c1*c1+c2*c2);

			that.zoomed = true;

			scale = 1 / that.touchesDistStart * that.touchesDist * this.scale;

			if (scale < that.options.zoomMin) scale = 0.5 * that.options.zoomMin * Math.pow(2.0, scale / that.options.zoomMin);
			else if (scale > that.options.zoomMax) scale = 2.0 * that.options.zoomMax * Math.pow(0.5, that.options.zoomMax / scale);

			that.lastScale = scale / this.scale;

			newX = this.originX - this.originX * that.lastScale + this.x,
			newY = this.originY - this.originY * that.lastScale + this.y;

			this.scroller.style[transform] = 'translate(' + newX + 'px,' + newY + 'px) scale(' + scale + ')' + translateZ;

			if (that.options.onZoom) that.options.onZoom.call(that, e);
			return;
		}

		that.pointX = point.pageX;
		that.pointY = point.pageY;

		// Slow down if outside of the boundaries
		if (newX > 0 || newX < that.maxScrollX) {
			newX = that.options.bounce ? that.x + (deltaX / 2) : newX >= 0 || that.maxScrollX >= 0 ? 0 : that.maxScrollX;
		}
		if (newY > that.minScrollY || newY < that.maxScrollY) {
			newY = that.options.bounce ? that.y + (deltaY / 2) : newY >= that.minScrollY || that.maxScrollY >= 0 ? that.minScrollY : that.maxScrollY;
		}

		that.distX += deltaX;
		that.distY += deltaY;
		that.absDistX = m.abs(that.distX);
		that.absDistY = m.abs(that.distY);

		if (that.absDistX < 6 && that.absDistY < 6) {
			return;
		}

		// Lock direction
		if (that.options.lockDirection) {
			if (that.absDistX > that.absDistY + 5) {
				newY = that.y;
				deltaY = 0;
			} else if (that.absDistY > that.absDistX + 5) {
				newX = that.x;
				deltaX = 0;
			}
		}

		that.moved = true;
		that._pos(newX, newY);
		that.dirX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		that.dirY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

		if (timestamp - that.startTime > 300) {
			that.startTime = timestamp;
			that.startX = that.x;
			that.startY = that.y;
		}
		
		if (that.options.onScrollMove) that.options.onScrollMove.call(that, e);
	},
	
	_end: function (e) {
		if (hasTouch && e.touches.length !== 0) return;

		var that = this,
			point = hasTouch ? e.changedTouches[0] : e,
			target, ev,
			momentumX = { dist:0, time:0 },
			momentumY = { dist:0, time:0 },
			duration = (e.timeStamp || Date.now()) - that.startTime,
			newPosX = that.x,
			newPosY = that.y,
			distX, distY,
			newDuration,
			snap,
			scale;

		that._unbind(MOVE_EV, window);
		that._unbind(END_EV, window);
		that._unbind(CANCEL_EV, window);

		if (that.options.onBeforeScrollEnd) that.options.onBeforeScrollEnd.call(that, e);

		if (that.zoomed) {
			scale = that.scale * that.lastScale;
			scale = Math.max(that.options.zoomMin, scale);
			scale = Math.min(that.options.zoomMax, scale);
			that.lastScale = scale / that.scale;
			that.scale = scale;

			that.x = that.originX - that.originX * that.lastScale + that.x;
			that.y = that.originY - that.originY * that.lastScale + that.y;
			
			that.scroller.style[transitionDuration] = '200ms';
			that.scroller.style[transform] = 'translate(' + that.x + 'px,' + that.y + 'px) scale(' + that.scale + ')' + translateZ;
			
			that.zoomed = false;
			that.refresh();

			if (that.options.onZoomEnd) that.options.onZoomEnd.call(that, e);
			return;
		}

		if (!that.moved) {
			if (hasTouch) {
				if (that.doubleTapTimer && that.options.zoom) {
					// Double tapped
					clearTimeout(that.doubleTapTimer);
					that.doubleTapTimer = null;
					if (that.options.onZoomStart) that.options.onZoomStart.call(that, e);
					that.zoom(that.pointX, that.pointY, that.scale == 1 ? that.options.doubleTapZoom : 1);
					if (that.options.onZoomEnd) {
						setTimeout(function() {
							that.options.onZoomEnd.call(that, e);
						}, 200); // 200 is default zoom duration
					}
				} else if (this.options.handleClick) {
					that.doubleTapTimer = setTimeout(function () {
						that.doubleTapTimer = null;

						// Find the last touched element
						target = point.target;
						while (target.nodeType != 1) target = target.parentNode;

						if (target.tagName != 'SELECT' && target.tagName != 'INPUT' && target.tagName != 'TEXTAREA') {
							ev = doc.createEvent('MouseEvents');
							ev.initMouseEvent('click', true, true, e.view, 1,
								point.screenX, point.screenY, point.clientX, point.clientY,
								e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
								0, null);
							ev._fake = true;
							target.dispatchEvent(ev);
						}
					}, that.options.zoom ? 250 : 0);
				}
			}

			that._resetPos(400);

			if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
			return;
		}

		if (duration < 300 && that.options.momentum) {
			momentumX = newPosX ? that._momentum(newPosX - that.startX, duration, -that.x, that.scrollerW - that.wrapperW + that.x, that.options.bounce ? that.wrapperW : 0) : momentumX;
			momentumY = newPosY ? that._momentum(newPosY - that.startY, duration, -that.y, (that.maxScrollY < 0 ? that.scrollerH - that.wrapperH + that.y - that.minScrollY : 0), that.options.bounce ? that.wrapperH : 0) : momentumY;

			newPosX = that.x + momentumX.dist;
			newPosY = that.y + momentumY.dist;

			if ((that.x > 0 && newPosX > 0) || (that.x < that.maxScrollX && newPosX < that.maxScrollX)) momentumX = { dist:0, time:0 };
			if ((that.y > that.minScrollY && newPosY > that.minScrollY) || (that.y < that.maxScrollY && newPosY < that.maxScrollY)) momentumY = { dist:0, time:0 };
		}

		if (momentumX.dist || momentumY.dist) {
			newDuration = m.max(m.max(momentumX.time, momentumY.time), 10);

			// Do we need to snap?
			if (that.options.snap) {
				distX = newPosX - that.absStartX;
				distY = newPosY - that.absStartY;
				if (m.abs(distX) < that.options.snapThreshold && m.abs(distY) < that.options.snapThreshold) { that.scrollTo(that.absStartX, that.absStartY, 200); }
				else {
					snap = that._snap(newPosX, newPosY);
					newPosX = snap.x;
					newPosY = snap.y;
					newDuration = m.max(snap.time, newDuration);
				}
			}

			that.scrollTo(m.round(newPosX), m.round(newPosY), newDuration);

			if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
			return;
		}

		// Do we need to snap?
		if (that.options.snap) {
			distX = newPosX - that.absStartX;
			distY = newPosY - that.absStartY;
			if (m.abs(distX) < that.options.snapThreshold && m.abs(distY) < that.options.snapThreshold) that.scrollTo(that.absStartX, that.absStartY, 200);
			else {
				snap = that._snap(that.x, that.y);
				if (snap.x != that.x || snap.y != that.y) that.scrollTo(snap.x, snap.y, snap.time);
			}

			if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
			return;
		}

		that._resetPos(200);
		if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
	},
	
	_resetPos: function (time) {
		var that = this,
			resetX = that.x >= 0 ? 0 : that.x < that.maxScrollX ? that.maxScrollX : that.x,
			resetY = that.y >= that.minScrollY || that.maxScrollY > 0 ? that.minScrollY : that.y < that.maxScrollY ? that.maxScrollY : that.y;

		if (resetX == that.x && resetY == that.y) {
			if (that.moved) {
				that.moved = false;
				if (that.options.onScrollEnd) that.options.onScrollEnd.call(that);		// Execute custom code on scroll end
			}

			if (that.hScrollbar && that.options.hideScrollbar) {
				if (vendor == 'webkit') that.hScrollbarWrapper.style[transitionDelay] = '300ms';
				that.hScrollbarWrapper.style.opacity = '0';
			}
			if (that.vScrollbar && that.options.hideScrollbar) {
				if (vendor == 'webkit') that.vScrollbarWrapper.style[transitionDelay] = '300ms';
				that.vScrollbarWrapper.style.opacity = '0';
			}

			return;
		}

		that.scrollTo(resetX, resetY, time || 0);
	},

	_wheel: function (e) {
		var that = this,
			wheelDeltaX, wheelDeltaY,
			deltaX, deltaY,
			deltaScale;

		if ('wheelDeltaX' in e) {
			wheelDeltaX = e.wheelDeltaX / 12;
			wheelDeltaY = e.wheelDeltaY / 12;
		} else if('wheelDelta' in e) {
			wheelDeltaX = wheelDeltaY = e.wheelDelta / 12;
		} else if ('detail' in e) {
			wheelDeltaX = wheelDeltaY = -e.detail * 3;
		} else {
			return;
		}
		
		if (that.options.wheelAction == 'zoom') {
			deltaScale = that.scale * Math.pow(2, 1/3 * (wheelDeltaY ? wheelDeltaY / Math.abs(wheelDeltaY) : 0));
			if (deltaScale < that.options.zoomMin) deltaScale = that.options.zoomMin;
			if (deltaScale > that.options.zoomMax) deltaScale = that.options.zoomMax;
			
			if (deltaScale != that.scale) {
				if (!that.wheelZoomCount && that.options.onZoomStart) that.options.onZoomStart.call(that, e);
				that.wheelZoomCount++;
				
				that.zoom(e.pageX, e.pageY, deltaScale, 400);
				
				setTimeout(function() {
					that.wheelZoomCount--;
					if (!that.wheelZoomCount && that.options.onZoomEnd) that.options.onZoomEnd.call(that, e);
				}, 400);
			}
			
			return;
		}
		
		deltaX = that.x + wheelDeltaX;
		deltaY = that.y + wheelDeltaY;

		if (deltaX > 0) deltaX = 0;
		else if (deltaX < that.maxScrollX) deltaX = that.maxScrollX;

		if (deltaY > that.minScrollY) deltaY = that.minScrollY;
		else if (deltaY < that.maxScrollY) deltaY = that.maxScrollY;
    
		if (that.maxScrollY < 0) {
			that.scrollTo(deltaX, deltaY, 0);
		}
	},
	
	_transitionEnd: function (e) {
		var that = this;

		if (e.target != that.scroller) return;

		that._unbind(TRNEND_EV);
		
		that._startAni();
	},


	/**
	*
	* Utilities
	*
	*/
	_startAni: function () {
		var that = this,
			startX = that.x, startY = that.y,
			startTime = Date.now(),
			step, easeOut,
			animate;

		if (that.animating) return;
		
		if (!that.steps.length) {
			that._resetPos(400);
			return;
		}
		
		step = that.steps.shift();
		
		if (step.x == startX && step.y == startY) step.time = 0;

		that.animating = true;
		that.moved = true;
		
		if (that.options.useTransition) {
			that._transitionTime(step.time);
			that._pos(step.x, step.y);
			that.animating = false;
			if (step.time) that._bind(TRNEND_EV);
			else that._resetPos(0);
			return;
		}

		animate = function () {
			var now = Date.now(),
				newX, newY;

			if (now >= startTime + step.time) {
				that._pos(step.x, step.y);
				that.animating = false;
				if (that.options.onAnimationEnd) that.options.onAnimationEnd.call(that);			// Execute custom code on animation end
				that._startAni();
				return;
			}

			now = (now - startTime) / step.time - 1;
			easeOut = m.sqrt(1 - now * now);
			newX = (step.x - startX) * easeOut + startX;
			newY = (step.y - startY) * easeOut + startY;
			that._pos(newX, newY);
			if (that.animating) that.aniTime = nextFrame(animate);
		};

		animate();
	},

	_transitionTime: function (time) {
		time += 'ms';
		this.scroller.style[transitionDuration] = time;
		if (this.hScrollbar) this.hScrollbarIndicator.style[transitionDuration] = time;
		if (this.vScrollbar) this.vScrollbarIndicator.style[transitionDuration] = time;
	},

	_momentum: function (dist, time, maxDistUpper, maxDistLower, size) {
		var deceleration = 0.0006,
			speed = m.abs(dist) / time,
			newDist = (speed * speed) / (2 * deceleration),
			newTime = 0, outsideDist = 0;

		// Proportinally reduce speed if we are outside of the boundaries
		if (dist > 0 && newDist > maxDistUpper) {
			outsideDist = size / (6 / (newDist / speed * deceleration));
			maxDistUpper = maxDistUpper + outsideDist;
			speed = speed * maxDistUpper / newDist;
			newDist = maxDistUpper;
		} else if (dist < 0 && newDist > maxDistLower) {
			outsideDist = size / (6 / (newDist / speed * deceleration));
			maxDistLower = maxDistLower + outsideDist;
			speed = speed * maxDistLower / newDist;
			newDist = maxDistLower;
		}

		newDist = newDist * (dist < 0 ? -1 : 1);
		newTime = speed / deceleration;

		return { dist: newDist, time: m.round(newTime) };
	},

	_offset: function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;
			
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		
		if (el != this.wrapper) {
			left *= this.scale;
			top *= this.scale;
		}

		return { left: left, top: top };
	},

	_snap: function (x, y) {
		var that = this,
			i, l,
			page, time,
			sizeX, sizeY;

		// Check page X
		page = that.pagesX.length - 1;
		for (i=0, l=that.pagesX.length; i<l; i++) {
			if (x >= that.pagesX[i]) {
				page = i;
				break;
			}
		}
		if (page == that.currPageX && page > 0 && that.dirX < 0) page--;
		x = that.pagesX[page];
		sizeX = m.abs(x - that.pagesX[that.currPageX]);
		sizeX = sizeX ? m.abs(that.x - x) / sizeX * 500 : 0;
		that.currPageX = page;

		// Check page Y
		page = that.pagesY.length-1;
		for (i=0; i<page; i++) {
			if (y >= that.pagesY[i]) {
				page = i;
				break;
			}
		}
		if (page == that.currPageY && page > 0 && that.dirY < 0) page--;
		y = that.pagesY[page];
		sizeY = m.abs(y - that.pagesY[that.currPageY]);
		sizeY = sizeY ? m.abs(that.y - y) / sizeY * 500 : 0;
		that.currPageY = page;

		// Snap with constant speed (proportional duration)
		time = m.round(m.max(sizeX, sizeY)) || 200;

		return { x: x, y: y, time: time };
	},

	_bind: function (type, el, bubble) {
		(el || this.scroller).addEventListener(type, this, !!bubble);
	},

	_unbind: function (type, el, bubble) {
		(el || this.scroller).removeEventListener(type, this, !!bubble);
	},


	/**
	*
	* Public methods
	*
	*/
	destroy: function () {
		var that = this;

		that.scroller.style[transform] = '';

		// Remove the scrollbars
		that.hScrollbar = false;
		that.vScrollbar = false;
		that._scrollbar('h');
		that._scrollbar('v');

		// Remove the event listeners
		that._unbind(RESIZE_EV, window);
		that._unbind(START_EV);
		that._unbind(MOVE_EV, window);
		that._unbind(END_EV, window);
		that._unbind(CANCEL_EV, window);
		
		if (!that.options.hasTouch) {
			that._unbind('DOMMouseScroll');
			that._unbind('mousewheel');
		}
		
		if (that.options.useTransition) that._unbind(TRNEND_EV);
		
		if (that.options.checkDOMChanges) clearInterval(that.checkDOMTime);
		
		if (that.options.onDestroy) that.options.onDestroy.call(that);
	},

	refresh: function () {
		var that = this,
			offset,
			i, l,
			els,
			pos = 0,
			page = 0;

		if (that.scale < that.options.zoomMin) that.scale = that.options.zoomMin;
		that.wrapperW = that.wrapper.clientWidth || 1;
		that.wrapperH = that.wrapper.clientHeight || 1;

		that.minScrollY = -that.options.topOffset || 0;
		that.scrollerW = m.round(that.scroller.offsetWidth * that.scale);
		that.scrollerH = m.round((that.scroller.offsetHeight + that.minScrollY) * that.scale);
		that.maxScrollX = that.wrapperW - that.scrollerW;
		that.maxScrollY = that.wrapperH - that.scrollerH + that.minScrollY;
		that.dirX = 0;
		that.dirY = 0;

		if (that.options.onRefresh) that.options.onRefresh.call(that);

		that.hScroll = that.options.hScroll && that.maxScrollX < 0;
		that.vScroll = that.options.vScroll && (!that.options.bounceLock && !that.hScroll || that.scrollerH > that.wrapperH);

		that.hScrollbar = that.hScroll && that.options.hScrollbar;
		that.vScrollbar = that.vScroll && that.options.vScrollbar && that.scrollerH > that.wrapperH;

		offset = that._offset(that.wrapper);
		that.wrapperOffsetLeft = -offset.left;
		that.wrapperOffsetTop = -offset.top;

		// Prepare snap
		if (typeof that.options.snap == 'string') {
			that.pagesX = [];
			that.pagesY = [];
			els = that.scroller.querySelectorAll(that.options.snap);
			for (i=0, l=els.length; i<l; i++) {
				pos = that._offset(els[i]);
				pos.left += that.wrapperOffsetLeft;
				pos.top += that.wrapperOffsetTop;
				that.pagesX[i] = pos.left < that.maxScrollX ? that.maxScrollX : pos.left * that.scale;
				that.pagesY[i] = pos.top < that.maxScrollY ? that.maxScrollY : pos.top * that.scale;
			}
		} else if (that.options.snap) {
			that.pagesX = [];
			while (pos >= that.maxScrollX) {
				that.pagesX[page] = pos;
				pos = pos - that.wrapperW;
				page++;
			}
			if (that.maxScrollX%that.wrapperW) that.pagesX[that.pagesX.length] = that.maxScrollX - that.pagesX[that.pagesX.length-1] + that.pagesX[that.pagesX.length-1];

			pos = 0;
			page = 0;
			that.pagesY = [];
			while (pos >= that.maxScrollY) {
				that.pagesY[page] = pos;
				pos = pos - that.wrapperH;
				page++;
			}
			if (that.maxScrollY%that.wrapperH) that.pagesY[that.pagesY.length] = that.maxScrollY - that.pagesY[that.pagesY.length-1] + that.pagesY[that.pagesY.length-1];
		}

		// Prepare the scrollbars
		that._scrollbar('h');
		that._scrollbar('v');

		if (!that.zoomed) {
			that.scroller.style[transitionDuration] = '0';
			that._resetPos(400);
		}
	},

	scrollTo: function (x, y, time, relative) {
		var that = this,
			step = x,
			i, l;

		that.stop();

		if (!step.length) step = [{ x: x, y: y, time: time, relative: relative }];
		
		for (i=0, l=step.length; i<l; i++) {
			if (step[i].relative) { step[i].x = that.x - step[i].x; step[i].y = that.y - step[i].y; }
			that.steps.push({ x: step[i].x, y: step[i].y, time: step[i].time || 0 });
		}

		that._startAni();
	},

	scrollToElement: function (el, time) {
		var that = this, pos;
		el = el.nodeType ? el : that.scroller.querySelector(el);
		if (!el) return;

		pos = that._offset(el);
		pos.left += that.wrapperOffsetLeft;
		pos.top += that.wrapperOffsetTop;

		pos.left = pos.left > 0 ? 0 : pos.left < that.maxScrollX ? that.maxScrollX : pos.left;
		pos.top = pos.top > that.minScrollY ? that.minScrollY : pos.top < that.maxScrollY ? that.maxScrollY : pos.top;
		time = time === undefined ? m.max(m.abs(pos.left)*2, m.abs(pos.top)*2) : time;

		that.scrollTo(pos.left, pos.top, time);
	},

	scrollToPage: function (pageX, pageY, time) {
		var that = this, x, y;
		
		time = time === undefined ? 400 : time;

		if (that.options.onScrollStart) that.options.onScrollStart.call(that);

		if (that.options.snap) {
			pageX = pageX == 'next' ? that.currPageX+1 : pageX == 'prev' ? that.currPageX-1 : pageX;
			pageY = pageY == 'next' ? that.currPageY+1 : pageY == 'prev' ? that.currPageY-1 : pageY;

			pageX = pageX < 0 ? 0 : pageX > that.pagesX.length-1 ? that.pagesX.length-1 : pageX;
			pageY = pageY < 0 ? 0 : pageY > that.pagesY.length-1 ? that.pagesY.length-1 : pageY;

			that.currPageX = pageX;
			that.currPageY = pageY;
			x = that.pagesX[pageX];
			y = that.pagesY[pageY];
		} else {
			x = -that.wrapperW * pageX;
			y = -that.wrapperH * pageY;
			if (x < that.maxScrollX) x = that.maxScrollX;
			if (y < that.maxScrollY) y = that.maxScrollY;
		}

		that.scrollTo(x, y, time);
	},

	disable: function () {
		this.stop();
		this._resetPos(0);
		this.enabled = false;

		// If disabled after touchstart we make sure that there are no left over events
		this._unbind(MOVE_EV, window);
		this._unbind(END_EV, window);
		this._unbind(CANCEL_EV, window);
	},
	
	enable: function () {
		this.enabled = true;
	},
	
	stop: function () {
		if (this.options.useTransition) this._unbind(TRNEND_EV);
		else cancelFrame(this.aniTime);
		this.steps = [];
		this.moved = false;
		this.animating = false;
	},
	
	zoom: function (x, y, scale, time) {
		var that = this,
			relScale = scale / that.scale;

		if (!that.options.useTransform) return;

		that.zoomed = true;
		time = time === undefined ? 200 : time;
		x = x - that.wrapperOffsetLeft - that.x;
		y = y - that.wrapperOffsetTop - that.y;
		that.x = x - x * relScale + that.x;
		that.y = y - y * relScale + that.y;

		that.scale = scale;
		that.refresh();

		that.x = that.x > 0 ? 0 : that.x < that.maxScrollX ? that.maxScrollX : that.x;
		that.y = that.y > that.minScrollY ? that.minScrollY : that.y < that.maxScrollY ? that.maxScrollY : that.y;

		that.scroller.style[transitionDuration] = time + 'ms';
		that.scroller.style[transform] = 'translate(' + that.x + 'px,' + that.y + 'px) scale(' + scale + ')' + translateZ;
		that.zoomed = false;
	},
	
	isReady: function () {
		return !this.moved && !this.zoomed && !this.animating;
	}
};

function prefixStyle (style) {
	if ( vendor === '' ) return style;

	style = style.charAt(0).toUpperCase() + style.substr(1);
	return vendor + style;
}

dummyStyle = null;	// for the sake of it

if (typeof exports !== 'undefined') exports.iScroll = iScroll;
else window.iScroll = iScroll;

})(window, document);
 
/** **************************************************** **/
/** ********************** isotope-layout ****************************** **/
 /*!
 * Isotope PACKAGED v2.2.0
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * http://isotope.metafizzy.co
 * Copyright 2015 Metafizzy
 */

(function(t){function e(){}function i(t){function i(e){e.prototype.option||(e.prototype.option=function(e){t.isPlainObject(e)&&(this.options=t.extend(!0,this.options,e))})}function n(e,i){t.fn[e]=function(n){if("string"==typeof n){for(var s=o.call(arguments,1),a=0,u=this.length;u>a;a++){var p=this[a],h=t.data(p,e);if(h)if(t.isFunction(h[n])&&"_"!==n.charAt(0)){var f=h[n].apply(h,s);if(void 0!==f)return f}else r("no such method '"+n+"' for "+e+" instance");else r("cannot call methods on "+e+" prior to initialization; "+"attempted to call '"+n+"'")}return this}return this.each(function(){var o=t.data(this,e);o?(o.option(n),o._init()):(o=new i(this,n),t.data(this,e,o))})}}if(t){var r="undefined"==typeof console?e:function(t){console.error(t)};return t.bridget=function(t,e){i(e),n(t,e)},t.bridget}}var o=Array.prototype.slice;"function"==typeof define&&define.amd?define("jquery-bridget/jquery.bridget",["jquery"],i):"object"==typeof exports?i(require("jquery")):i(t.jQuery)})(window),function(t){function e(e){var i=t.event;return i.target=i.target||i.srcElement||e,i}var i=document.documentElement,o=function(){};i.addEventListener?o=function(t,e,i){t.addEventListener(e,i,!1)}:i.attachEvent&&(o=function(t,i,o){t[i+o]=o.handleEvent?function(){var i=e(t);o.handleEvent.call(o,i)}:function(){var i=e(t);o.call(t,i)},t.attachEvent("on"+i,t[i+o])});var n=function(){};i.removeEventListener?n=function(t,e,i){t.removeEventListener(e,i,!1)}:i.detachEvent&&(n=function(t,e,i){t.detachEvent("on"+e,t[e+i]);try{delete t[e+i]}catch(o){t[e+i]=void 0}});var r={bind:o,unbind:n};"function"==typeof define&&define.amd?define("eventie/eventie",r):"object"==typeof exports?module.exports=r:t.eventie=r}(window),function(){function t(){}function e(t,e){for(var i=t.length;i--;)if(t[i].listener===e)return i;return-1}function i(t){return function(){return this[t].apply(this,arguments)}}var o=t.prototype,n=this,r=n.EventEmitter;o.getListeners=function(t){var e,i,o=this._getEvents();if(t instanceof RegExp){e={};for(i in o)o.hasOwnProperty(i)&&t.test(i)&&(e[i]=o[i])}else e=o[t]||(o[t]=[]);return e},o.flattenListeners=function(t){var e,i=[];for(e=0;t.length>e;e+=1)i.push(t[e].listener);return i},o.getListenersAsObject=function(t){var e,i=this.getListeners(t);return i instanceof Array&&(e={},e[t]=i),e||i},o.addListener=function(t,i){var o,n=this.getListenersAsObject(t),r="object"==typeof i;for(o in n)n.hasOwnProperty(o)&&-1===e(n[o],i)&&n[o].push(r?i:{listener:i,once:!1});return this},o.on=i("addListener"),o.addOnceListener=function(t,e){return this.addListener(t,{listener:e,once:!0})},o.once=i("addOnceListener"),o.defineEvent=function(t){return this.getListeners(t),this},o.defineEvents=function(t){for(var e=0;t.length>e;e+=1)this.defineEvent(t[e]);return this},o.removeListener=function(t,i){var o,n,r=this.getListenersAsObject(t);for(n in r)r.hasOwnProperty(n)&&(o=e(r[n],i),-1!==o&&r[n].splice(o,1));return this},o.off=i("removeListener"),o.addListeners=function(t,e){return this.manipulateListeners(!1,t,e)},o.removeListeners=function(t,e){return this.manipulateListeners(!0,t,e)},o.manipulateListeners=function(t,e,i){var o,n,r=t?this.removeListener:this.addListener,s=t?this.removeListeners:this.addListeners;if("object"!=typeof e||e instanceof RegExp)for(o=i.length;o--;)r.call(this,e,i[o]);else for(o in e)e.hasOwnProperty(o)&&(n=e[o])&&("function"==typeof n?r.call(this,o,n):s.call(this,o,n));return this},o.removeEvent=function(t){var e,i=typeof t,o=this._getEvents();if("string"===i)delete o[t];else if(t instanceof RegExp)for(e in o)o.hasOwnProperty(e)&&t.test(e)&&delete o[e];else delete this._events;return this},o.removeAllListeners=i("removeEvent"),o.emitEvent=function(t,e){var i,o,n,r,s=this.getListenersAsObject(t);for(n in s)if(s.hasOwnProperty(n))for(o=s[n].length;o--;)i=s[n][o],i.once===!0&&this.removeListener(t,i.listener),r=i.listener.apply(this,e||[]),r===this._getOnceReturnValue()&&this.removeListener(t,i.listener);return this},o.trigger=i("emitEvent"),o.emit=function(t){var e=Array.prototype.slice.call(arguments,1);return this.emitEvent(t,e)},o.setOnceReturnValue=function(t){return this._onceReturnValue=t,this},o._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},o._getEvents=function(){return this._events||(this._events={})},t.noConflict=function(){return n.EventEmitter=r,t},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return t}):"object"==typeof module&&module.exports?module.exports=t:n.EventEmitter=t}.call(this),function(t){function e(t){if(t){if("string"==typeof o[t])return t;t=t.charAt(0).toUpperCase()+t.slice(1);for(var e,n=0,r=i.length;r>n;n++)if(e=i[n]+t,"string"==typeof o[e])return e}}var i="Webkit Moz ms Ms O".split(" "),o=document.documentElement.style;"function"==typeof define&&define.amd?define("get-style-property/get-style-property",[],function(){return e}):"object"==typeof exports?module.exports=e:t.getStyleProperty=e}(window),function(t){function e(t){var e=parseFloat(t),i=-1===t.indexOf("%")&&!isNaN(e);return i&&e}function i(){}function o(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0,i=s.length;i>e;e++){var o=s[e];t[o]=0}return t}function n(i){function n(){if(!d){d=!0;var o=t.getComputedStyle;if(p=function(){var t=o?function(t){return o(t,null)}:function(t){return t.currentStyle};return function(e){var i=t(e);return i||r("Style returned "+i+". Are you running this code in a hidden iframe on Firefox? "+"See http://bit.ly/getsizebug1"),i}}(),h=i("boxSizing")){var n=document.createElement("div");n.style.width="200px",n.style.padding="1px 2px 3px 4px",n.style.borderStyle="solid",n.style.borderWidth="1px 2px 3px 4px",n.style[h]="border-box";var s=document.body||document.documentElement;s.appendChild(n);var a=p(n);f=200===e(a.width),s.removeChild(n)}}}function a(t){if(n(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var i=p(t);if("none"===i.display)return o();var r={};r.width=t.offsetWidth,r.height=t.offsetHeight;for(var a=r.isBorderBox=!(!h||!i[h]||"border-box"!==i[h]),d=0,l=s.length;l>d;d++){var c=s[d],m=i[c];m=u(t,m);var y=parseFloat(m);r[c]=isNaN(y)?0:y}var g=r.paddingLeft+r.paddingRight,v=r.paddingTop+r.paddingBottom,_=r.marginLeft+r.marginRight,I=r.marginTop+r.marginBottom,z=r.borderLeftWidth+r.borderRightWidth,L=r.borderTopWidth+r.borderBottomWidth,x=a&&f,E=e(i.width);E!==!1&&(r.width=E+(x?0:g+z));var b=e(i.height);return b!==!1&&(r.height=b+(x?0:v+L)),r.innerWidth=r.width-(g+z),r.innerHeight=r.height-(v+L),r.outerWidth=r.width+_,r.outerHeight=r.height+I,r}}function u(e,i){if(t.getComputedStyle||-1===i.indexOf("%"))return i;var o=e.style,n=o.left,r=e.runtimeStyle,s=r&&r.left;return s&&(r.left=e.currentStyle.left),o.left=i,i=o.pixelLeft,o.left=n,s&&(r.left=s),i}var p,h,f,d=!1;return a}var r="undefined"==typeof console?i:function(t){console.error(t)},s=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"];"function"==typeof define&&define.amd?define("get-size/get-size",["get-style-property/get-style-property"],n):"object"==typeof exports?module.exports=n(require("desandro-get-style-property")):t.getSize=n(t.getStyleProperty)}(window),function(t){function e(t){"function"==typeof t&&(e.isReady?t():s.push(t))}function i(t){var i="readystatechange"===t.type&&"complete"!==r.readyState;e.isReady||i||o()}function o(){e.isReady=!0;for(var t=0,i=s.length;i>t;t++){var o=s[t];o()}}function n(n){return"complete"===r.readyState?o():(n.bind(r,"DOMContentLoaded",i),n.bind(r,"readystatechange",i),n.bind(t,"load",i)),e}var r=t.document,s=[];e.isReady=!1,"function"==typeof define&&define.amd?define("doc-ready/doc-ready",["eventie/eventie"],n):"object"==typeof exports?module.exports=n(require("eventie")):t.docReady=n(t.eventie)}(window),function(t){function e(t,e){return t[s](e)}function i(t){if(!t.parentNode){var e=document.createDocumentFragment();e.appendChild(t)}}function o(t,e){i(t);for(var o=t.parentNode.querySelectorAll(e),n=0,r=o.length;r>n;n++)if(o[n]===t)return!0;return!1}function n(t,o){return i(t),e(t,o)}var r,s=function(){if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0,o=e.length;o>i;i++){var n=e[i],r=n+"MatchesSelector";if(t[r])return r}}();if(s){var a=document.createElement("div"),u=e(a,"div");r=u?e:n}else r=o;"function"==typeof define&&define.amd?define("matches-selector/matches-selector",[],function(){return r}):"object"==typeof exports?module.exports=r:window.matchesSelector=r}(Element.prototype),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["doc-ready/doc-ready","matches-selector/matches-selector"],function(i,o){return e(t,i,o)}):"object"==typeof exports?module.exports=e(t,require("doc-ready"),require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.docReady,t.matchesSelector)}(window,function(t,e,i){var o={};o.extend=function(t,e){for(var i in e)t[i]=e[i];return t},o.modulo=function(t,e){return(t%e+e)%e};var n=Object.prototype.toString;o.isArray=function(t){return"[object Array]"==n.call(t)},o.makeArray=function(t){var e=[];if(o.isArray(t))e=t;else if(t&&"number"==typeof t.length)for(var i=0,n=t.length;n>i;i++)e.push(t[i]);else e.push(t);return e},o.indexOf=Array.prototype.indexOf?function(t,e){return t.indexOf(e)}:function(t,e){for(var i=0,o=t.length;o>i;i++)if(t[i]===e)return i;return-1},o.removeFrom=function(t,e){var i=o.indexOf(t,e);-1!=i&&t.splice(i,1)},o.isElement="function"==typeof HTMLElement||"object"==typeof HTMLElement?function(t){return t instanceof HTMLElement}:function(t){return t&&"object"==typeof t&&1==t.nodeType&&"string"==typeof t.nodeName},o.setText=function(){function t(t,i){e=e||(void 0!==document.documentElement.textContent?"textContent":"innerText"),t[e]=i}var e;return t}(),o.getParent=function(t,e){for(;t!=document.body;)if(t=t.parentNode,i(t,e))return t},o.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},o.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},o.filterFindElements=function(t,e){t=o.makeArray(t);for(var n=[],r=0,s=t.length;s>r;r++){var a=t[r];if(o.isElement(a))if(e){i(a,e)&&n.push(a);for(var u=a.querySelectorAll(e),p=0,h=u.length;h>p;p++)n.push(u[p])}else n.push(a)}return n},o.debounceMethod=function(t,e,i){var o=t.prototype[e],n=e+"Timeout";t.prototype[e]=function(){var t=this[n];t&&clearTimeout(t);var e=arguments,r=this;this[n]=setTimeout(function(){o.apply(r,e),delete r[n]},i||100)}},o.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var r=t.console;return o.htmlInit=function(i,n){e(function(){for(var e=o.toDashed(n),s=document.querySelectorAll(".js-"+e),a="data-"+e+"-options",u=0,p=s.length;p>u;u++){var h,f=s[u],d=f.getAttribute(a);try{h=d&&JSON.parse(d)}catch(l){r&&r.error("Error parsing "+a+" on "+f.nodeName.toLowerCase()+(f.id?"#"+f.id:"")+": "+l);continue}var c=new i(f,h),m=t.jQuery;m&&m.data(f,n,c)}})},o}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["eventEmitter/EventEmitter","get-size/get-size","get-style-property/get-style-property","fizzy-ui-utils/utils"],function(i,o,n,r){return e(t,i,o,n,r)}):"object"==typeof exports?module.exports=e(t,require("wolfy87-eventemitter"),require("get-size"),require("desandro-get-style-property"),require("fizzy-ui-utils")):(t.Outlayer={},t.Outlayer.Item=e(t,t.EventEmitter,t.getSize,t.getStyleProperty,t.fizzyUIUtils))}(window,function(t,e,i,o,n){function r(t){for(var e in t)return!1;return e=null,!0}function s(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}var a=t.getComputedStyle,u=a?function(t){return a(t,null)}:function(t){return t.currentStyle},p=o("transition"),h=o("transform"),f=p&&h,d=!!o("perspective"),l={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"otransitionend",transition:"transitionend"}[p],c=["transform","transition","transitionDuration","transitionProperty"],m=function(){for(var t={},e=0,i=c.length;i>e;e++){var n=c[e],r=o(n);r&&r!==n&&(t[n]=r)}return t}();n.extend(s.prototype,e.prototype),s.prototype._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},s.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},s.prototype.getSize=function(){this.size=i(this.element)},s.prototype.css=function(t){var e=this.element.style;for(var i in t){var o=m[i]||i;e[o]=t[i]}},s.prototype.getPosition=function(){var t=u(this.element),e=this.layout.options,i=e.isOriginLeft,o=e.isOriginTop,n=parseInt(t[i?"left":"right"],10),r=parseInt(t[o?"top":"bottom"],10);n=isNaN(n)?0:n,r=isNaN(r)?0:r;var s=this.layout.size;n-=i?s.paddingLeft:s.paddingRight,r-=o?s.paddingTop:s.paddingBottom,this.position.x=n,this.position.y=r},s.prototype.layoutPosition=function(){var t=this.layout.size,e=this.layout.options,i={},o=e.isOriginLeft?"paddingLeft":"paddingRight",n=e.isOriginLeft?"left":"right",r=e.isOriginLeft?"right":"left",s=this.position.x+t[o];s=e.percentPosition&&!e.isHorizontal?100*(s/t.width)+"%":s+"px",i[n]=s,i[r]="";var a=e.isOriginTop?"paddingTop":"paddingBottom",u=e.isOriginTop?"top":"bottom",p=e.isOriginTop?"bottom":"top",h=this.position.y+t[a];h=e.percentPosition&&e.isHorizontal?100*(h/t.height)+"%":h+"px",i[u]=h,i[p]="",this.css(i),this.emitEvent("layout",[this])};var y=d?function(t,e){return"translate3d("+t+"px, "+e+"px, 0)"}:function(t,e){return"translate("+t+"px, "+e+"px)"};s.prototype._transitionTo=function(t,e){this.getPosition();var i=this.position.x,o=this.position.y,n=parseInt(t,10),r=parseInt(e,10),s=n===this.position.x&&r===this.position.y;if(this.setPosition(t,e),s&&!this.isTransitioning)return this.layoutPosition(),void 0;var a=t-i,u=e-o,p={},h=this.layout.options;a=h.isOriginLeft?a:-a,u=h.isOriginTop?u:-u,p.transform=y(a,u),this.transition({to:p,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},s.prototype.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},s.prototype.moveTo=f?s.prototype._transitionTo:s.prototype.goTo,s.prototype.setPosition=function(t,e){this.position.x=parseInt(t,10),this.position.y=parseInt(e,10)},s.prototype._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},s.prototype._transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return this._nonTransition(t),void 0;var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var o=this.element.offsetHeight;o=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var g=h&&n.toDashed(h)+",opacity";s.prototype.enableTransition=function(){this.isTransitioning||(this.css({transitionProperty:g,transitionDuration:this.layout.options.transitionDuration}),this.element.addEventListener(l,this,!1))},s.prototype.transition=s.prototype[p?"_transition":"_nonTransition"],s.prototype.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},s.prototype.onotransitionend=function(t){this.ontransitionend(t)};var v={"-webkit-transform":"transform","-moz-transform":"transform","-o-transform":"transform"};s.prototype.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,i=v[t.propertyName]||t.propertyName;if(delete e.ingProperties[i],r(e.ingProperties)&&this.disableTransition(),i in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[i]),i in e.onEnd){var o=e.onEnd[i];o.call(this),delete e.onEnd[i]}this.emitEvent("transitionEnd",[this])}},s.prototype.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(l,this,!1),this.isTransitioning=!1},s.prototype._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var _={transitionProperty:"",transitionDuration:""};return s.prototype.removeTransitionStyles=function(){this.css(_)},s.prototype.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},s.prototype.remove=function(){if(!p||!parseFloat(this.layout.options.transitionDuration))return this.removeElem(),void 0;var t=this;this.once("transitionEnd",function(){t.removeElem()}),this.hide()},s.prototype.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("visibleStyle");e[i]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},s.prototype.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},s.prototype.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var i in e)return i},s.prototype.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("hiddenStyle");e[i]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},s.prototype.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},s.prototype.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},s}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/outlayer",["eventie/eventie","eventEmitter/EventEmitter","get-size/get-size","fizzy-ui-utils/utils","./item"],function(i,o,n,r,s){return e(t,i,o,n,r,s)}):"object"==typeof exports?module.exports=e(t,require("eventie"),require("wolfy87-eventemitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.eventie,t.EventEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,function(t,e,i,o,n,r){function s(t,e){var i=n.getQueryElement(t);if(!i)return a&&a.error("Bad element for "+this.constructor.namespace+": "+(i||t)),void 0;this.element=i,u&&(this.$element=u(this.element)),this.options=n.extend({},this.constructor.defaults),this.option(e);var o=++h;this.element.outlayerGUID=o,f[o]=this,this._create(),this.options.isInitLayout&&this.layout()}var a=t.console,u=t.jQuery,p=function(){},h=0,f={};return s.namespace="outlayer",s.Item=r,s.defaults={containerStyle:{position:"relative"},isInitLayout:!0,isOriginLeft:!0,isOriginTop:!0,isResizeBound:!0,isResizingContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}},n.extend(s.prototype,i.prototype),s.prototype.option=function(t){n.extend(this.options,t)},s.prototype._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),n.extend(this.element.style,this.options.containerStyle),this.options.isResizeBound&&this.bindResize()},s.prototype.reloadItems=function(){this.items=this._itemize(this.element.children)},s.prototype._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,o=[],n=0,r=e.length;r>n;n++){var s=e[n],a=new i(s,this);o.push(a)}return o},s.prototype._filterFindItemElements=function(t){return n.filterFindElements(t,this.options.itemSelector)},s.prototype.getItemElements=function(){for(var t=[],e=0,i=this.items.length;i>e;e++)t.push(this.items[e].element);return t},s.prototype.layout=function(){this._resetLayout(),this._manageStamps();var t=void 0!==this.options.isLayoutInstant?this.options.isLayoutInstant:!this._isLayoutInited;this.layoutItems(this.items,t),this._isLayoutInited=!0},s.prototype._init=s.prototype.layout,s.prototype._resetLayout=function(){this.getSize()},s.prototype.getSize=function(){this.size=o(this.element)},s.prototype._getMeasurement=function(t,e){var i,r=this.options[t];r?("string"==typeof r?i=this.element.querySelector(r):n.isElement(r)&&(i=r),this[t]=i?o(i)[e]:r):this[t]=0},s.prototype.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},s.prototype._getItemsForLayout=function(t){for(var e=[],i=0,o=t.length;o>i;i++){var n=t[i];n.isIgnored||e.push(n)}return e},s.prototype._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){for(var i=[],o=0,n=t.length;n>o;o++){var r=t[o],s=this._getItemLayoutPosition(r);s.item=r,s.isInstant=e||r.isLayoutInstant,i.push(s)}this._processLayoutQueue(i)}},s.prototype._getItemLayoutPosition=function(){return{x:0,y:0}},s.prototype._processLayoutQueue=function(t){for(var e=0,i=t.length;i>e;e++){var o=t[e];this._positionItem(o.item,o.x,o.y,o.isInstant)}},s.prototype._positionItem=function(t,e,i,o){o?t.goTo(e,i):t.moveTo(e,i)},s.prototype._postLayout=function(){this.resizeContainer()},s.prototype.resizeContainer=function(){if(this.options.isResizingContainer){var t=this._getContainerSize();t&&(this._setContainerMeasure(t.width,!0),this._setContainerMeasure(t.height,!1))}},s.prototype._getContainerSize=p,s.prototype._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},s.prototype._emitCompleteOnItems=function(t,e){function i(){n.emitEvent(t+"Complete",[e])}function o(){s++,s===r&&i()}var n=this,r=e.length;if(!e||!r)return i(),void 0;for(var s=0,a=0,u=e.length;u>a;a++){var p=e[a];p.once(t,o)}},s.prototype.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},s.prototype.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},s.prototype.stamp=function(t){if(t=this._find(t)){this.stamps=this.stamps.concat(t);for(var e=0,i=t.length;i>e;e++){var o=t[e];this.ignore(o)}}},s.prototype.unstamp=function(t){if(t=this._find(t))for(var e=0,i=t.length;i>e;e++){var o=t[e];n.removeFrom(this.stamps,o),this.unignore(o)}},s.prototype._find=function(t){return t?("string"==typeof t&&(t=this.element.querySelectorAll(t)),t=n.makeArray(t)):void 0},s.prototype._manageStamps=function(){if(this.stamps&&this.stamps.length){this._getBoundingRect();for(var t=0,e=this.stamps.length;e>t;t++){var i=this.stamps[t];this._manageStamp(i)}}},s.prototype._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},s.prototype._manageStamp=p,s.prototype._getElementOffset=function(t){var e=t.getBoundingClientRect(),i=this._boundingRect,n=o(t),r={left:e.left-i.left-n.marginLeft,top:e.top-i.top-n.marginTop,right:i.right-e.right-n.marginRight,bottom:i.bottom-e.bottom-n.marginBottom};return r},s.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},s.prototype.bindResize=function(){this.isResizeBound||(e.bind(t,"resize",this),this.isResizeBound=!0)},s.prototype.unbindResize=function(){this.isResizeBound&&e.unbind(t,"resize",this),this.isResizeBound=!1},s.prototype.onresize=function(){function t(){e.resize(),delete e.resizeTimeout}this.resizeTimeout&&clearTimeout(this.resizeTimeout);var e=this;this.resizeTimeout=setTimeout(t,100)},s.prototype.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},s.prototype.needsResizeLayout=function(){var t=o(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},s.prototype.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},s.prototype.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},s.prototype.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},s.prototype.reveal=function(t){this._emitCompleteOnItems("reveal",t);for(var e=t&&t.length,i=0;e&&e>i;i++){var o=t[i];o.reveal()}},s.prototype.hide=function(t){this._emitCompleteOnItems("hide",t);for(var e=t&&t.length,i=0;e&&e>i;i++){var o=t[i];o.hide()}},s.prototype.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},s.prototype.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},s.prototype.getItem=function(t){for(var e=0,i=this.items.length;i>e;e++){var o=this.items[e];if(o.element===t)return o}},s.prototype.getItems=function(t){t=n.makeArray(t);for(var e=[],i=0,o=t.length;o>i;i++){var r=t[i],s=this.getItem(r);s&&e.push(s)}return e},s.prototype.remove=function(t){var e=this.getItems(t);if(this._emitCompleteOnItems("remove",e),e&&e.length)for(var i=0,o=e.length;o>i;i++){var r=e[i];r.remove(),n.removeFrom(this.items,r)}},s.prototype.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="";for(var e=0,i=this.items.length;i>e;e++){var o=this.items[e];o.destroy()}this.unbindResize();var n=this.element.outlayerGUID;delete f[n],delete this.element.outlayerGUID,u&&u.removeData(this.element,this.constructor.namespace)},s.data=function(t){t=n.getQueryElement(t);var e=t&&t.outlayerGUID;return e&&f[e]},s.create=function(t,e){function i(){s.apply(this,arguments)}return Object.create?i.prototype=Object.create(s.prototype):n.extend(i.prototype,s.prototype),i.prototype.constructor=i,i.defaults=n.extend({},s.defaults),n.extend(i.defaults,e),i.prototype.settings={},i.namespace=t,i.data=s.data,i.Item=function(){r.apply(this,arguments)},i.Item.prototype=new r,n.htmlInit(i,t),u&&u.bridget&&u.bridget(t,i),i},s.Item=r,s}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/item",["outlayer/outlayer"],e):"object"==typeof exports?module.exports=e(require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.Item=e(t.Outlayer))}(window,function(t){function e(){t.Item.apply(this,arguments)}e.prototype=new t.Item,e.prototype._create=function(){this.id=this.layout.itemGUID++,t.Item.prototype._create.call(this),this.sortData={}},e.prototype.updateSortData=function(){if(!this.isIgnored){this.sortData.id=this.id,this.sortData["original-order"]=this.id,this.sortData.random=Math.random();var t=this.layout.options.getSortData,e=this.layout._sorters;for(var i in t){var o=e[i];this.sortData[i]=o(this.element,this)}}};var i=e.prototype.destroy;return e.prototype.destroy=function(){i.apply(this,arguments),this.css({display:""})},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-mode",["get-size/get-size","outlayer/outlayer"],e):"object"==typeof exports?module.exports=e(require("get-size"),require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.LayoutMode=e(t.getSize,t.Outlayer))}(window,function(t,e){function i(t){this.isotope=t,t&&(this.options=t.options[this.namespace],this.element=t.element,this.items=t.filteredItems,this.size=t.size)}return function(){function t(t){return function(){return e.prototype[t].apply(this.isotope,arguments)}}for(var o=["_resetLayout","_getItemLayoutPosition","_manageStamp","_getContainerSize","_getElementOffset","needsResizeLayout"],n=0,r=o.length;r>n;n++){var s=o[n];i.prototype[s]=t(s)}}(),i.prototype.needsVerticalResizeLayout=function(){var e=t(this.isotope.element),i=this.isotope.size&&e;return i&&e.innerHeight!=this.isotope.size.innerHeight},i.prototype._getMeasurement=function(){this.isotope._getMeasurement.apply(this,arguments)},i.prototype.getColumnWidth=function(){this.getSegmentSize("column","Width")},i.prototype.getRowHeight=function(){this.getSegmentSize("row","Height")},i.prototype.getSegmentSize=function(t,e){var i=t+e,o="outer"+e;if(this._getMeasurement(i,o),!this[i]){var n=this.getFirstItemSize();this[i]=n&&n[o]||this.isotope.size["inner"+e]}},i.prototype.getFirstItemSize=function(){var e=this.isotope.filteredItems[0];return e&&e.element&&t(e.element)},i.prototype.layout=function(){this.isotope.layout.apply(this.isotope,arguments)},i.prototype.getSize=function(){this.isotope.getSize(),this.size=this.isotope.size},i.modes={},i.create=function(t,e){function o(){i.apply(this,arguments)}return o.prototype=new i,e&&(o.options=e),o.prototype.namespace=t,i.modes[t]=o,o},i}),function(t,e){"function"==typeof define&&define.amd?define("masonry/masonry",["outlayer/outlayer","get-size/get-size","fizzy-ui-utils/utils"],e):"object"==typeof exports?module.exports=e(require("outlayer"),require("get-size"),require("fizzy-ui-utils")):t.Masonry=e(t.Outlayer,t.getSize,t.fizzyUIUtils)}(window,function(t,e,i){var o=t.create("masonry");return o.prototype._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns();var t=this.cols;for(this.colYs=[];t--;)this.colYs.push(0);this.maxY=0},o.prototype.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],i=t&&t.element;this.columnWidth=i&&e(i).outerWidth||this.containerWidth}var o=this.columnWidth+=this.gutter,n=this.containerWidth+this.gutter,r=n/o,s=o-n%o,a=s&&1>s?"round":"floor";r=Math[a](r),this.cols=Math.max(r,1)},o.prototype.getContainerWidth=function(){var t=this.options.isFitWidth?this.element.parentNode:this.element,i=e(t);this.containerWidth=i&&i.innerWidth},o.prototype._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,o=e&&1>e?"round":"ceil",n=Math[o](t.size.outerWidth/this.columnWidth);n=Math.min(n,this.cols);for(var r=this._getColGroup(n),s=Math.min.apply(Math,r),a=i.indexOf(r,s),u={x:this.columnWidth*a,y:s},p=s+t.size.outerHeight,h=this.cols+1-r.length,f=0;h>f;f++)this.colYs[a+f]=p;return u},o.prototype._getColGroup=function(t){if(2>t)return this.colYs;for(var e=[],i=this.cols+1-t,o=0;i>o;o++){var n=this.colYs.slice(o,o+t);e[o]=Math.max.apply(Math,n)}return e},o.prototype._manageStamp=function(t){var i=e(t),o=this._getElementOffset(t),n=this.options.isOriginLeft?o.left:o.right,r=n+i.outerWidth,s=Math.floor(n/this.columnWidth);s=Math.max(0,s);var a=Math.floor(r/this.columnWidth);a-=r%this.columnWidth?0:1,a=Math.min(this.cols-1,a);for(var u=(this.options.isOriginTop?o.top:o.bottom)+i.outerHeight,p=s;a>=p;p++)this.colYs[p]=Math.max(u,this.colYs[p])},o.prototype._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this.options.isFitWidth&&(t.width=this._getContainerFitWidth()),t},o.prototype._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},o.prototype.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!==this.containerWidth},o}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-modes/masonry",["../layout-mode","masonry/masonry"],e):"object"==typeof exports?module.exports=e(require("../layout-mode"),require("masonry-layout")):e(t.Isotope.LayoutMode,t.Masonry)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}var o=t.create("masonry"),n=o.prototype._getElementOffset,r=o.prototype.layout,s=o.prototype._getMeasurement;i(o.prototype,e.prototype),o.prototype._getElementOffset=n,o.prototype.layout=r,o.prototype._getMeasurement=s;var a=o.prototype.measureColumns;o.prototype.measureColumns=function(){this.items=this.isotope.filteredItems,a.call(this)};var u=o.prototype._manageStamp;return o.prototype._manageStamp=function(){this.options.isOriginLeft=this.isotope.options.isOriginLeft,this.options.isOriginTop=this.isotope.options.isOriginTop,u.apply(this,arguments)},o}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-modes/fit-rows",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){var e=t.create("fitRows");return e.prototype._resetLayout=function(){this.x=0,this.y=0,this.maxY=0,this._getMeasurement("gutter","outerWidth")
},e.prototype._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth+this.gutter,i=this.isotope.size.innerWidth+this.gutter;0!==this.x&&e+this.x>i&&(this.x=0,this.y=this.maxY);var o={x:this.x,y:this.y};return this.maxY=Math.max(this.maxY,this.y+t.size.outerHeight),this.x+=e,o},e.prototype._getContainerSize=function(){return{height:this.maxY}},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-modes/vertical",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){var e=t.create("vertical",{horizontalAlignment:0});return e.prototype._resetLayout=function(){this.y=0},e.prototype._getItemLayoutPosition=function(t){t.getSize();var e=(this.isotope.size.innerWidth-t.size.outerWidth)*this.options.horizontalAlignment,i=this.y;return this.y+=t.size.outerHeight,{x:e,y:i}},e.prototype._getContainerSize=function(){return{height:this.y}},e}),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size","matches-selector/matches-selector","fizzy-ui-utils/utils","isotope/js/item","isotope/js/layout-mode","isotope/js/layout-modes/masonry","isotope/js/layout-modes/fit-rows","isotope/js/layout-modes/vertical"],function(i,o,n,r,s,a){return e(t,i,o,n,r,s,a)}):"object"==typeof exports?module.exports=e(t,require("outlayer"),require("get-size"),require("desandro-matches-selector"),require("fizzy-ui-utils"),require("./item"),require("./layout-mode"),require("./layout-modes/masonry"),require("./layout-modes/fit-rows"),require("./layout-modes/vertical")):t.Isotope=e(t,t.Outlayer,t.getSize,t.matchesSelector,t.fizzyUIUtils,t.Isotope.Item,t.Isotope.LayoutMode)}(window,function(t,e,i,o,n,r,s){function a(t,e){return function(i,o){for(var n=0,r=t.length;r>n;n++){var s=t[n],a=i.sortData[s],u=o.sortData[s];if(a>u||u>a){var p=void 0!==e[s]?e[s]:e,h=p?1:-1;return(a>u?1:-1)*h}}return 0}}var u=t.jQuery,p=String.prototype.trim?function(t){return t.trim()}:function(t){return t.replace(/^\s+|\s+$/g,"")},h=document.documentElement,f=h.textContent?function(t){return t.textContent}:function(t){return t.innerText},d=e.create("isotope",{layoutMode:"masonry",isJQueryFiltering:!0,sortAscending:!0});d.Item=r,d.LayoutMode=s,d.prototype._create=function(){this.itemGUID=0,this._sorters={},this._getSorters(),e.prototype._create.call(this),this.modes={},this.filteredItems=this.items,this.sortHistory=["original-order"];for(var t in s.modes)this._initLayoutMode(t)},d.prototype.reloadItems=function(){this.itemGUID=0,e.prototype.reloadItems.call(this)},d.prototype._itemize=function(){for(var t=e.prototype._itemize.apply(this,arguments),i=0,o=t.length;o>i;i++){var n=t[i];n.id=this.itemGUID++}return this._updateItemsSortData(t),t},d.prototype._initLayoutMode=function(t){var e=s.modes[t],i=this.options[t]||{};this.options[t]=e.options?n.extend(e.options,i):i,this.modes[t]=new e(this)},d.prototype.layout=function(){return!this._isLayoutInited&&this.options.isInitLayout?(this.arrange(),void 0):(this._layout(),void 0)},d.prototype._layout=function(){var t=this._getIsInstant();this._resetLayout(),this._manageStamps(),this.layoutItems(this.filteredItems,t),this._isLayoutInited=!0},d.prototype.arrange=function(t){function e(){o.reveal(i.needReveal),o.hide(i.needHide)}this.option(t),this._getIsInstant();var i=this._filter(this.items);this.filteredItems=i.matches;var o=this;this._bindArrangeComplete(),this._isInstant?this._noTransition(e):e(),this._sort(),this._layout()},d.prototype._init=d.prototype.arrange,d.prototype._getIsInstant=function(){var t=void 0!==this.options.isLayoutInstant?this.options.isLayoutInstant:!this._isLayoutInited;return this._isInstant=t,t},d.prototype._bindArrangeComplete=function(){function t(){e&&i&&o&&n.emitEvent("arrangeComplete",[n.filteredItems])}var e,i,o,n=this;this.once("layoutComplete",function(){e=!0,t()}),this.once("hideComplete",function(){i=!0,t()}),this.once("revealComplete",function(){o=!0,t()})},d.prototype._filter=function(t){var e=this.options.filter;e=e||"*";for(var i=[],o=[],n=[],r=this._getFilterTest(e),s=0,a=t.length;a>s;s++){var u=t[s];if(!u.isIgnored){var p=r(u);p&&i.push(u),p&&u.isHidden?o.push(u):p||u.isHidden||n.push(u)}}return{matches:i,needReveal:o,needHide:n}},d.prototype._getFilterTest=function(t){return u&&this.options.isJQueryFiltering?function(e){return u(e.element).is(t)}:"function"==typeof t?function(e){return t(e.element)}:function(e){return o(e.element,t)}},d.prototype.updateSortData=function(t){var e;t?(t=n.makeArray(t),e=this.getItems(t)):e=this.items,this._getSorters(),this._updateItemsSortData(e)},d.prototype._getSorters=function(){var t=this.options.getSortData;for(var e in t){var i=t[e];this._sorters[e]=l(i)}},d.prototype._updateItemsSortData=function(t){for(var e=t&&t.length,i=0;e&&e>i;i++){var o=t[i];o.updateSortData()}};var l=function(){function t(t){if("string"!=typeof t)return t;var i=p(t).split(" "),o=i[0],n=o.match(/^\[(.+)\]$/),r=n&&n[1],s=e(r,o),a=d.sortDataParsers[i[1]];return t=a?function(t){return t&&a(s(t))}:function(t){return t&&s(t)}}function e(t,e){var i;return i=t?function(e){return e.getAttribute(t)}:function(t){var i=t.querySelector(e);return i&&f(i)}}return t}();d.sortDataParsers={parseInt:function(t){return parseInt(t,10)},parseFloat:function(t){return parseFloat(t)}},d.prototype._sort=function(){var t=this.options.sortBy;if(t){var e=[].concat.apply(t,this.sortHistory),i=a(e,this.options.sortAscending);this.filteredItems.sort(i),t!=this.sortHistory[0]&&this.sortHistory.unshift(t)}},d.prototype._mode=function(){var t=this.options.layoutMode,e=this.modes[t];if(!e)throw Error("No layout mode: "+t);return e.options=this.options[t],e},d.prototype._resetLayout=function(){e.prototype._resetLayout.call(this),this._mode()._resetLayout()},d.prototype._getItemLayoutPosition=function(t){return this._mode()._getItemLayoutPosition(t)},d.prototype._manageStamp=function(t){this._mode()._manageStamp(t)},d.prototype._getContainerSize=function(){return this._mode()._getContainerSize()},d.prototype.needsResizeLayout=function(){return this._mode().needsResizeLayout()},d.prototype.appended=function(t){var e=this.addItems(t);if(e.length){var i=this._filterRevealAdded(e);this.filteredItems=this.filteredItems.concat(i)}},d.prototype.prepended=function(t){var e=this._itemize(t);if(e.length){this._resetLayout(),this._manageStamps();var i=this._filterRevealAdded(e);this.layoutItems(this.filteredItems),this.filteredItems=i.concat(this.filteredItems),this.items=e.concat(this.items)}},d.prototype._filterRevealAdded=function(t){var e=this._filter(t);return this.hide(e.needHide),this.reveal(e.matches),this.layoutItems(e.matches,!0),e.matches},d.prototype.insert=function(t){var e=this.addItems(t);if(e.length){var i,o,n=e.length;for(i=0;n>i;i++)o=e[i],this.element.appendChild(o.element);var r=this._filter(e).matches;for(i=0;n>i;i++)e[i].isLayoutInstant=!0;for(this.arrange(),i=0;n>i;i++)delete e[i].isLayoutInstant;this.reveal(r)}};var c=d.prototype.remove;return d.prototype.remove=function(t){t=n.makeArray(t);var e=this.getItems(t);c.call(this,t);var i=e&&e.length;if(i)for(var o=0;i>o;o++){var r=e[o];n.removeFrom(this.filteredItems,r)}},d.prototype.shuffle=function(){for(var t=0,e=this.items.length;e>t;t++){var i=this.items[t];i.sortData.random=Math.random()}this.options.sortBy="random",this._sort(),this._layout()},d.prototype._noTransition=function(t){var e=this.options.transitionDuration;this.options.transitionDuration=0;var i=t.call(this);return this.options.transitionDuration=e,i},d.prototype.getFilteredItemElements=function(){for(var t=[],e=0,i=this.filteredItems.length;i>e;e++)t.push(this.filteredItems[e].element);return t},d}); 
/** **************************************************** **/
/** ********************** slick-carousel ****************************** **/
 !function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
 
/** **************************************************** **/
/** ********************** ouibounce ****************************** **/
 !function(e,n){"function"==typeof define&&define.amd?define(n):"object"==typeof exports?module.exports=n(require,exports,module):e.ouibounce=n()}(this,function(e,n,o){return function(e,n){"use strict";function o(e,n){return"undefined"==typeof e?n:e}function i(e){var n=24*e*60*60*1e3,o=new Date;return o.setTime(o.getTime()+n),"; expires="+o.toUTCString()}function t(){s()||(L.addEventListener("mouseleave",u),L.addEventListener("mouseenter",r),L.addEventListener("keydown",c))}function u(e){e.clientY>k||(D=setTimeout(m,y))}function r(){D&&(clearTimeout(D),D=null)}function c(e){g||e.metaKey&&76===e.keyCode&&(g=!0,D=setTimeout(m,y))}function d(e,n){return a()[e]===n}function a(){for(var e=document.cookie.split("; "),n={},o=e.length-1;o>=0;o--){var i=e[o].split("=");n[i[0]]=i[1]}return n}function s(){return d(T,"true")&&!v}function m(){s()||(e&&(e.style.display="block"),E(),f())}function f(e){var n=e||{};"undefined"!=typeof n.cookieExpire&&(b=i(n.cookieExpire)),n.sitewide===!0&&(w=";path=/"),"undefined"!=typeof n.cookieDomain&&(x=";domain="+n.cookieDomain),"undefined"!=typeof n.cookieName&&(T=n.cookieName),document.cookie=T+"=true"+b+x+w,L.removeEventListener("mouseleave",u),L.removeEventListener("mouseenter",r),L.removeEventListener("keydown",c)}var l=n||{},v=l.aggressive||!1,k=o(l.sensitivity,20),p=o(l.timer,1e3),y=o(l.delay,0),E=l.callback||function(){},b=i(l.cookieExpire)||"",x=l.cookieDomain?";domain="+l.cookieDomain:"",T=l.cookieName?l.cookieName:"viewedOuibounceModal",w=l.sitewide===!0?";path=/":"",D=null,L=document.documentElement;setTimeout(t,p);var g=!1;return{fire:m,disable:f,isDisabled:s}}}); 
/** **************************************************** **/
/** ********************** angular ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(T,V,s){'use strict';function F(b){return function(){var a=arguments[0],c;c="["+(b?b+":":"")+a+"] http://errors.angularjs.org/1.3.16/"+(b?b+"/":"")+a;for(a=1;a<arguments.length;a++){c=c+(1==a?"?":"&")+"p"+(a-1)+"=";var d=encodeURIComponent,e;e=arguments[a];e="function"==typeof e?e.toString().replace(/ \{[\s\S]*$/,""):"undefined"==typeof e?"undefined":"string"!=typeof e?JSON.stringify(e):e;c+=d(e)}return Error(c)}}function Sa(b){if(null==b||Ta(b))return!1;var a="length"in Object(b)&&b.length;
return b.nodeType===ma&&a?!0:O(b)||w(b)||0===a||"number"===typeof a&&0<a&&a-1 in b}function q(b,a,c){var d,e;if(b)if(E(b))for(d in b)"prototype"==d||"length"==d||"name"==d||b.hasOwnProperty&&!b.hasOwnProperty(d)||a.call(c,b[d],d,b);else if(w(b)||Sa(b)){var f="object"!==typeof b;d=0;for(e=b.length;d<e;d++)(f||d in b)&&a.call(c,b[d],d,b)}else if(b.forEach&&b.forEach!==q)b.forEach(a,c,b);else for(d in b)b.hasOwnProperty(d)&&a.call(c,b[d],d,b);return b}function Jd(b,a,c){for(var d=Object.keys(b).sort(),
e=0;e<d.length;e++)a.call(c,b[d[e]],d[e]);return d}function pc(b){return function(a,c){b(c,a)}}function Kd(){return++rb}function qc(b,a){a?b.$$hashKey=a:delete b.$$hashKey}function x(b){for(var a=b.$$hashKey,c=1,d=arguments.length;c<d;c++){var e=arguments[c];if(e)for(var f=Object.keys(e),g=0,h=f.length;g<h;g++){var l=f[g];b[l]=e[l]}}qc(b,a);return b}function aa(b){return parseInt(b,10)}function Pb(b,a){return x(Object.create(b),a)}function A(){}function na(b){return b}function ca(b){return function(){return b}}
function C(b){return"undefined"===typeof b}function y(b){return"undefined"!==typeof b}function I(b){return null!==b&&"object"===typeof b}function O(b){return"string"===typeof b}function Q(b){return"number"===typeof b}function ea(b){return"[object Date]"===Aa.call(b)}function E(b){return"function"===typeof b}function Ua(b){return"[object RegExp]"===Aa.call(b)}function Ta(b){return b&&b.window===b}function Va(b){return b&&b.$evalAsync&&b.$watch}function Wa(b){return"boolean"===typeof b}function rc(b){return!(!b||
!(b.nodeName||b.prop&&b.attr&&b.find))}function Ld(b){var a={};b=b.split(",");var c;for(c=0;c<b.length;c++)a[b[c]]=!0;return a}function sa(b){return L(b.nodeName||b[0]&&b[0].nodeName)}function Xa(b,a){var c=b.indexOf(a);0<=c&&b.splice(c,1);return a}function Ba(b,a,c,d){if(Ta(b)||Va(b))throw Ja("cpws");if(a){if(b===a)throw Ja("cpi");c=c||[];d=d||[];if(I(b)){var e=c.indexOf(b);if(-1!==e)return d[e];c.push(b);d.push(a)}if(w(b))for(var f=a.length=0;f<b.length;f++)e=Ba(b[f],null,c,d),I(b[f])&&(c.push(b[f]),
d.push(e)),a.push(e);else{var g=a.$$hashKey;w(a)?a.length=0:q(a,function(b,c){delete a[c]});for(f in b)b.hasOwnProperty(f)&&(e=Ba(b[f],null,c,d),I(b[f])&&(c.push(b[f]),d.push(e)),a[f]=e);qc(a,g)}}else if(a=b)w(b)?a=Ba(b,[],c,d):ea(b)?a=new Date(b.getTime()):Ua(b)?(a=new RegExp(b.source,b.toString().match(/[^\/]*$/)[0]),a.lastIndex=b.lastIndex):I(b)&&(e=Object.create(Object.getPrototypeOf(b)),a=Ba(b,e,c,d));return a}function oa(b,a){if(w(b)){a=a||[];for(var c=0,d=b.length;c<d;c++)a[c]=b[c]}else if(I(b))for(c in a=
a||{},b)if("$"!==c.charAt(0)||"$"!==c.charAt(1))a[c]=b[c];return a||b}function fa(b,a){if(b===a)return!0;if(null===b||null===a)return!1;if(b!==b&&a!==a)return!0;var c=typeof b,d;if(c==typeof a&&"object"==c)if(w(b)){if(!w(a))return!1;if((c=b.length)==a.length){for(d=0;d<c;d++)if(!fa(b[d],a[d]))return!1;return!0}}else{if(ea(b))return ea(a)?fa(b.getTime(),a.getTime()):!1;if(Ua(b))return Ua(a)?b.toString()==a.toString():!1;if(Va(b)||Va(a)||Ta(b)||Ta(a)||w(a)||ea(a)||Ua(a))return!1;c={};for(d in b)if("$"!==
d.charAt(0)&&!E(b[d])){if(!fa(b[d],a[d]))return!1;c[d]=!0}for(d in a)if(!c.hasOwnProperty(d)&&"$"!==d.charAt(0)&&a[d]!==s&&!E(a[d]))return!1;return!0}return!1}function Ya(b,a,c){return b.concat(Za.call(a,c))}function sc(b,a){var c=2<arguments.length?Za.call(arguments,2):[];return!E(a)||a instanceof RegExp?a:c.length?function(){return arguments.length?a.apply(b,Ya(c,arguments,0)):a.apply(b,c)}:function(){return arguments.length?a.apply(b,arguments):a.call(b)}}function Md(b,a){var c=a;"string"===typeof b&&
"$"===b.charAt(0)&&"$"===b.charAt(1)?c=s:Ta(a)?c="$WINDOW":a&&V===a?c="$DOCUMENT":Va(a)&&(c="$SCOPE");return c}function $a(b,a){if("undefined"===typeof b)return s;Q(a)||(a=a?2:null);return JSON.stringify(b,Md,a)}function tc(b){return O(b)?JSON.parse(b):b}function ta(b){b=z(b).clone();try{b.empty()}catch(a){}var c=z("<div>").append(b).html();try{return b[0].nodeType===ab?L(c):c.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/,function(a,b){return"<"+L(b)})}catch(d){return L(c)}}function uc(b){try{return decodeURIComponent(b)}catch(a){}}
function vc(b){var a={},c,d;q((b||"").split("&"),function(b){b&&(c=b.replace(/\+/g,"%20").split("="),d=uc(c[0]),y(d)&&(b=y(c[1])?uc(c[1]):!0,wc.call(a,d)?w(a[d])?a[d].push(b):a[d]=[a[d],b]:a[d]=b))});return a}function Qb(b){var a=[];q(b,function(b,d){w(b)?q(b,function(b){a.push(Ca(d,!0)+(!0===b?"":"="+Ca(b,!0)))}):a.push(Ca(d,!0)+(!0===b?"":"="+Ca(b,!0)))});return a.length?a.join("&"):""}function sb(b){return Ca(b,!0).replace(/%26/gi,"&").replace(/%3D/gi,"=").replace(/%2B/gi,"+")}function Ca(b,a){return encodeURIComponent(b).replace(/%40/gi,
"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%3B/gi,";").replace(/%20/g,a?"%20":"+")}function Nd(b,a){var c,d,e=tb.length;b=z(b);for(d=0;d<e;++d)if(c=tb[d]+a,O(c=b.attr(c)))return c;return null}function Od(b,a){var c,d,e={};q(tb,function(a){a+="app";!c&&b.hasAttribute&&b.hasAttribute(a)&&(c=b,d=b.getAttribute(a))});q(tb,function(a){a+="app";var e;!c&&(e=b.querySelector("["+a.replace(":","\\:")+"]"))&&(c=e,d=e.getAttribute(a))});c&&(e.strictDi=null!==Nd(c,"strict-di"),
a(c,d?[d]:[],e))}function xc(b,a,c){I(c)||(c={});c=x({strictDi:!1},c);var d=function(){b=z(b);if(b.injector()){var d=b[0]===V?"document":ta(b);throw Ja("btstrpd",d.replace(/</,"&lt;").replace(/>/,"&gt;"));}a=a||[];a.unshift(["$provide",function(a){a.value("$rootElement",b)}]);c.debugInfoEnabled&&a.push(["$compileProvider",function(a){a.debugInfoEnabled(!0)}]);a.unshift("ng");d=bb(a,c.strictDi);d.invoke(["$rootScope","$rootElement","$compile","$injector",function(a,b,c,d){a.$apply(function(){b.data("$injector",
d);c(b)(a)})}]);return d},e=/^NG_ENABLE_DEBUG_INFO!/,f=/^NG_DEFER_BOOTSTRAP!/;T&&e.test(T.name)&&(c.debugInfoEnabled=!0,T.name=T.name.replace(e,""));if(T&&!f.test(T.name))return d();T.name=T.name.replace(f,"");ba.resumeBootstrap=function(b){q(b,function(b){a.push(b)});return d()};E(ba.resumeDeferredBootstrap)&&ba.resumeDeferredBootstrap()}function Pd(){T.name="NG_ENABLE_DEBUG_INFO!"+T.name;T.location.reload()}function Qd(b){b=ba.element(b).injector();if(!b)throw Ja("test");return b.get("$$testability")}
function yc(b,a){a=a||"_";return b.replace(Rd,function(b,d){return(d?a:"")+b.toLowerCase()})}function Sd(){var b;zc||((pa=T.jQuery)&&pa.fn.on?(z=pa,x(pa.fn,{scope:Ka.scope,isolateScope:Ka.isolateScope,controller:Ka.controller,injector:Ka.injector,inheritedData:Ka.inheritedData}),b=pa.cleanData,pa.cleanData=function(a){var c;if(Rb)Rb=!1;else for(var d=0,e;null!=(e=a[d]);d++)(c=pa._data(e,"events"))&&c.$destroy&&pa(e).triggerHandler("$destroy");b(a)}):z=R,ba.element=z,zc=!0)}function Sb(b,a,c){if(!b)throw Ja("areq",
a||"?",c||"required");return b}function La(b,a,c){c&&w(b)&&(b=b[b.length-1]);Sb(E(b),a,"not a function, got "+(b&&"object"===typeof b?b.constructor.name||"Object":typeof b));return b}function Ma(b,a){if("hasOwnProperty"===b)throw Ja("badname",a);}function Ac(b,a,c){if(!a)return b;a=a.split(".");for(var d,e=b,f=a.length,g=0;g<f;g++)d=a[g],b&&(b=(e=b)[d]);return!c&&E(b)?sc(e,b):b}function ub(b){var a=b[0];b=b[b.length-1];var c=[a];do{a=a.nextSibling;if(!a)break;c.push(a)}while(a!==b);return z(c)}function ga(){return Object.create(null)}
function Td(b){function a(a,b,c){return a[b]||(a[b]=c())}var c=F("$injector"),d=F("ng");b=a(b,"angular",Object);b.$$minErr=b.$$minErr||F;return a(b,"module",function(){var b={};return function(f,g,h){if("hasOwnProperty"===f)throw d("badname","module");g&&b.hasOwnProperty(f)&&(b[f]=null);return a(b,f,function(){function a(c,d,e,f){f||(f=b);return function(){f[e||"push"]([c,d,arguments]);return u}}if(!g)throw c("nomod",f);var b=[],d=[],e=[],n=a("$injector","invoke","push",d),u={_invokeQueue:b,_configBlocks:d,
_runBlocks:e,requires:g,name:f,provider:a("$provide","provider"),factory:a("$provide","factory"),service:a("$provide","service"),value:a("$provide","value"),constant:a("$provide","constant","unshift"),animation:a("$animateProvider","register"),filter:a("$filterProvider","register"),controller:a("$controllerProvider","register"),directive:a("$compileProvider","directive"),config:n,run:function(a){e.push(a);return this}};h&&n(h);return u})}})}function Ud(b){x(b,{bootstrap:xc,copy:Ba,extend:x,equals:fa,
element:z,forEach:q,injector:bb,noop:A,bind:sc,toJson:$a,fromJson:tc,identity:na,isUndefined:C,isDefined:y,isString:O,isFunction:E,isObject:I,isNumber:Q,isElement:rc,isArray:w,version:Vd,isDate:ea,lowercase:L,uppercase:vb,callbacks:{counter:0},getTestability:Qd,$$minErr:F,$$csp:cb,reloadWithDebugInfo:Pd});db=Td(T);try{db("ngLocale")}catch(a){db("ngLocale",[]).provider("$locale",Wd)}db("ng",["ngLocale"],["$provide",function(a){a.provider({$$sanitizeUri:Xd});a.provider("$compile",Bc).directive({a:Yd,
input:Cc,textarea:Cc,form:Zd,script:$d,select:ae,style:be,option:ce,ngBind:de,ngBindHtml:ee,ngBindTemplate:fe,ngClass:ge,ngClassEven:he,ngClassOdd:ie,ngCloak:je,ngController:ke,ngForm:le,ngHide:me,ngIf:ne,ngInclude:oe,ngInit:pe,ngNonBindable:qe,ngPluralize:re,ngRepeat:se,ngShow:te,ngStyle:ue,ngSwitch:ve,ngSwitchWhen:we,ngSwitchDefault:xe,ngOptions:ye,ngTransclude:ze,ngModel:Ae,ngList:Be,ngChange:Ce,pattern:Dc,ngPattern:Dc,required:Ec,ngRequired:Ec,minlength:Fc,ngMinlength:Fc,maxlength:Gc,ngMaxlength:Gc,
ngValue:De,ngModelOptions:Ee}).directive({ngInclude:Fe}).directive(wb).directive(Hc);a.provider({$anchorScroll:Ge,$animate:He,$browser:Ie,$cacheFactory:Je,$controller:Ke,$document:Le,$exceptionHandler:Me,$filter:Ic,$interpolate:Ne,$interval:Oe,$http:Pe,$httpBackend:Qe,$location:Re,$log:Se,$parse:Te,$rootScope:Ue,$q:Ve,$$q:We,$sce:Xe,$sceDelegate:Ye,$sniffer:Ze,$templateCache:$e,$templateRequest:af,$$testability:bf,$timeout:cf,$window:df,$$rAF:ef,$$asyncCallback:ff,$$jqLite:gf})}])}function eb(b){return b.replace(hf,
function(a,b,d,e){return e?d.toUpperCase():d}).replace(jf,"Moz$1")}function Jc(b){b=b.nodeType;return b===ma||!b||9===b}function Kc(b,a){var c,d,e=a.createDocumentFragment(),f=[];if(Tb.test(b)){c=c||e.appendChild(a.createElement("div"));d=(kf.exec(b)||["",""])[1].toLowerCase();d=ha[d]||ha._default;c.innerHTML=d[1]+b.replace(lf,"<$1></$2>")+d[2];for(d=d[0];d--;)c=c.lastChild;f=Ya(f,c.childNodes);c=e.firstChild;c.textContent=""}else f.push(a.createTextNode(b));e.textContent="";e.innerHTML="";q(f,function(a){e.appendChild(a)});
return e}function R(b){if(b instanceof R)return b;var a;O(b)&&(b=U(b),a=!0);if(!(this instanceof R)){if(a&&"<"!=b.charAt(0))throw Ub("nosel");return new R(b)}if(a){a=V;var c;b=(c=mf.exec(b))?[a.createElement(c[1])]:(c=Kc(b,a))?c.childNodes:[]}Lc(this,b)}function Vb(b){return b.cloneNode(!0)}function xb(b,a){a||yb(b);if(b.querySelectorAll)for(var c=b.querySelectorAll("*"),d=0,e=c.length;d<e;d++)yb(c[d])}function Mc(b,a,c,d){if(y(d))throw Ub("offargs");var e=(d=zb(b))&&d.events,f=d&&d.handle;if(f)if(a)q(a.split(" "),
function(a){if(y(c)){var d=e[a];Xa(d||[],c);if(d&&0<d.length)return}b.removeEventListener(a,f,!1);delete e[a]});else for(a in e)"$destroy"!==a&&b.removeEventListener(a,f,!1),delete e[a]}function yb(b,a){var c=b.ng339,d=c&&Ab[c];d&&(a?delete d.data[a]:(d.handle&&(d.events.$destroy&&d.handle({},"$destroy"),Mc(b)),delete Ab[c],b.ng339=s))}function zb(b,a){var c=b.ng339,c=c&&Ab[c];a&&!c&&(b.ng339=c=++nf,c=Ab[c]={events:{},data:{},handle:s});return c}function Wb(b,a,c){if(Jc(b)){var d=y(c),e=!d&&a&&!I(a),
f=!a;b=(b=zb(b,!e))&&b.data;if(d)b[a]=c;else{if(f)return b;if(e)return b&&b[a];x(b,a)}}}function Bb(b,a){return b.getAttribute?-1<(" "+(b.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ").indexOf(" "+a+" "):!1}function Cb(b,a){a&&b.setAttribute&&q(a.split(" "),function(a){b.setAttribute("class",U((" "+(b.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ").replace(" "+U(a)+" "," ")))})}function Db(b,a){if(a&&b.setAttribute){var c=(" "+(b.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ");
q(a.split(" "),function(a){a=U(a);-1===c.indexOf(" "+a+" ")&&(c+=a+" ")});b.setAttribute("class",U(c))}}function Lc(b,a){if(a)if(a.nodeType)b[b.length++]=a;else{var c=a.length;if("number"===typeof c&&a.window!==a){if(c)for(var d=0;d<c;d++)b[b.length++]=a[d]}else b[b.length++]=a}}function Nc(b,a){return Eb(b,"$"+(a||"ngController")+"Controller")}function Eb(b,a,c){9==b.nodeType&&(b=b.documentElement);for(a=w(a)?a:[a];b;){for(var d=0,e=a.length;d<e;d++)if((c=z.data(b,a[d]))!==s)return c;b=b.parentNode||
11===b.nodeType&&b.host}}function Oc(b){for(xb(b,!0);b.firstChild;)b.removeChild(b.firstChild)}function Pc(b,a){a||xb(b);var c=b.parentNode;c&&c.removeChild(b)}function of(b,a){a=a||T;if("complete"===a.document.readyState)a.setTimeout(b);else z(a).on("load",b)}function Qc(b,a){var c=Fb[a.toLowerCase()];return c&&Rc[sa(b)]&&c}function pf(b,a){var c=b.nodeName;return("INPUT"===c||"TEXTAREA"===c)&&Sc[a]}function qf(b,a){var c=function(c,e){c.isDefaultPrevented=function(){return c.defaultPrevented};var f=
a[e||c.type],g=f?f.length:0;if(g){if(C(c.immediatePropagationStopped)){var h=c.stopImmediatePropagation;c.stopImmediatePropagation=function(){c.immediatePropagationStopped=!0;c.stopPropagation&&c.stopPropagation();h&&h.call(c)}}c.isImmediatePropagationStopped=function(){return!0===c.immediatePropagationStopped};1<g&&(f=oa(f));for(var l=0;l<g;l++)c.isImmediatePropagationStopped()||f[l].call(b,c)}};c.elem=b;return c}function gf(){this.$get=function(){return x(R,{hasClass:function(b,a){b.attr&&(b=b[0]);
return Bb(b,a)},addClass:function(b,a){b.attr&&(b=b[0]);return Db(b,a)},removeClass:function(b,a){b.attr&&(b=b[0]);return Cb(b,a)}})}}function Na(b,a){var c=b&&b.$$hashKey;if(c)return"function"===typeof c&&(c=b.$$hashKey()),c;c=typeof b;return c="function"==c||"object"==c&&null!==b?b.$$hashKey=c+":"+(a||Kd)():c+":"+b}function fb(b,a){if(a){var c=0;this.nextUid=function(){return++c}}q(b,this.put,this)}function rf(b){return(b=b.toString().replace(Tc,"").match(Uc))?"function("+(b[1]||"").replace(/[\s\r\n]+/,
" ")+")":"fn"}function bb(b,a){function c(a){return function(b,c){if(I(b))q(b,pc(a));else return a(b,c)}}function d(a,b){Ma(a,"service");if(E(b)||w(b))b=n.instantiate(b);if(!b.$get)throw Da("pget",a);return r[a+"Provider"]=b}function e(a,b){return function(){var c=v.invoke(b,this);if(C(c))throw Da("undef",a);return c}}function f(a,b,c){return d(a,{$get:!1!==c?e(a,b):b})}function g(a){var b=[],c;q(a,function(a){function d(a){var b,c;b=0;for(c=a.length;b<c;b++){var e=a[b],f=n.get(e[0]);f[e[1]].apply(f,
e[2])}}if(!m.get(a)){m.put(a,!0);try{O(a)?(c=db(a),b=b.concat(g(c.requires)).concat(c._runBlocks),d(c._invokeQueue),d(c._configBlocks)):E(a)?b.push(n.invoke(a)):w(a)?b.push(n.invoke(a)):La(a,"module")}catch(e){throw w(a)&&(a=a[a.length-1]),e.message&&e.stack&&-1==e.stack.indexOf(e.message)&&(e=e.message+"\n"+e.stack),Da("modulerr",a,e.stack||e.message||e);}}});return b}function h(b,c){function d(a,e){if(b.hasOwnProperty(a)){if(b[a]===l)throw Da("cdep",a+" <- "+k.join(" <- "));return b[a]}try{return k.unshift(a),
b[a]=l,b[a]=c(a,e)}catch(f){throw b[a]===l&&delete b[a],f;}finally{k.shift()}}function e(b,c,f,g){"string"===typeof f&&(g=f,f=null);var k=[],l=bb.$$annotate(b,a,g),h,n,m;n=0;for(h=l.length;n<h;n++){m=l[n];if("string"!==typeof m)throw Da("itkn",m);k.push(f&&f.hasOwnProperty(m)?f[m]:d(m,g))}w(b)&&(b=b[h]);return b.apply(c,k)}return{invoke:e,instantiate:function(a,b,c){var d=Object.create((w(a)?a[a.length-1]:a).prototype||null);a=e(a,d,b,c);return I(a)||E(a)?a:d},get:d,annotate:bb.$$annotate,has:function(a){return r.hasOwnProperty(a+
"Provider")||b.hasOwnProperty(a)}}}a=!0===a;var l={},k=[],m=new fb([],!0),r={$provide:{provider:c(d),factory:c(f),service:c(function(a,b){return f(a,["$injector",function(a){return a.instantiate(b)}])}),value:c(function(a,b){return f(a,ca(b),!1)}),constant:c(function(a,b){Ma(a,"constant");r[a]=b;u[a]=b}),decorator:function(a,b){var c=n.get(a+"Provider"),d=c.$get;c.$get=function(){var a=v.invoke(d,c);return v.invoke(b,null,{$delegate:a})}}}},n=r.$injector=h(r,function(a,b){ba.isString(b)&&k.push(b);
throw Da("unpr",k.join(" <- "));}),u={},v=u.$injector=h(u,function(a,b){var c=n.get(a+"Provider",b);return v.invoke(c.$get,c,s,a)});q(g(b),function(a){v.invoke(a||A)});return v}function Ge(){var b=!0;this.disableAutoScrolling=function(){b=!1};this.$get=["$window","$location","$rootScope",function(a,c,d){function e(a){var b=null;Array.prototype.some.call(a,function(a){if("a"===sa(a))return b=a,!0});return b}function f(b){if(b){b.scrollIntoView();var c;c=g.yOffset;E(c)?c=c():rc(c)?(c=c[0],c="fixed"!==
a.getComputedStyle(c).position?0:c.getBoundingClientRect().bottom):Q(c)||(c=0);c&&(b=b.getBoundingClientRect().top,a.scrollBy(0,b-c))}else a.scrollTo(0,0)}function g(){var a=c.hash(),b;a?(b=h.getElementById(a))?f(b):(b=e(h.getElementsByName(a)))?f(b):"top"===a&&f(null):f(null)}var h=a.document;b&&d.$watch(function(){return c.hash()},function(a,b){a===b&&""===a||of(function(){d.$evalAsync(g)})});return g}]}function ff(){this.$get=["$$rAF","$timeout",function(b,a){return b.supported?function(a){return b(a)}:
function(b){return a(b,0,!1)}}]}function sf(b,a,c,d){function e(a){try{a.apply(null,Za.call(arguments,1))}finally{if(p--,0===p)for(;H.length;)try{H.pop()()}catch(b){c.error(b)}}}function f(a,b){(function Xb(){q(J,function(a){a()});B=b(Xb,a)})()}function g(){h();l()}function h(){a:{try{M=u.state;break a}catch(a){}M=void 0}M=C(M)?null:M;fa(M,S)&&(M=S);S=M}function l(){if(G!==m.url()||D!==M)G=m.url(),D=M,q($,function(a){a(m.url(),M)})}function k(a){try{return decodeURIComponent(a)}catch(b){return a}}
var m=this,r=a[0],n=b.location,u=b.history,v=b.setTimeout,P=b.clearTimeout,t={};m.isMock=!1;var p=0,H=[];m.$$completeOutstandingRequest=e;m.$$incOutstandingRequestCount=function(){p++};m.notifyWhenNoOutstandingRequests=function(a){q(J,function(a){a()});0===p?a():H.push(a)};var J=[],B;m.addPollFn=function(a){C(B)&&f(100,v);J.push(a);return a};var M,D,G=n.href,N=a.find("base"),Y=null;h();D=M;m.url=function(a,c,e){C(e)&&(e=null);n!==b.location&&(n=b.location);u!==b.history&&(u=b.history);if(a){var f=
D===e;if(G===a&&(!d.history||f))return m;var g=G&&Ea(G)===Ea(a);G=a;D=e;!d.history||g&&f?(g||(Y=a),c?n.replace(a):g?(c=n,e=a.indexOf("#"),a=-1===e?"":a.substr(e+1),c.hash=a):n.href=a):(u[c?"replaceState":"pushState"](e,"",a),h(),D=M);return m}return Y||n.href.replace(/%27/g,"'")};m.state=function(){return M};var $=[],W=!1,S=null;m.onUrlChange=function(a){if(!W){if(d.history)z(b).on("popstate",g);z(b).on("hashchange",g);W=!0}$.push(a);return a};m.$$checkUrlChange=l;m.baseHref=function(){var a=N.attr("href");
return a?a.replace(/^(https?\:)?\/\/[^\/]*/,""):""};var Fa={},y="",hb=m.baseHref();m.cookies=function(a,b){var d,e,f,g;if(a)b===s?r.cookie=encodeURIComponent(a)+"=;path="+hb+";expires=Thu, 01 Jan 1970 00:00:00 GMT":O(b)&&(d=(r.cookie=encodeURIComponent(a)+"="+encodeURIComponent(b)+";path="+hb).length+1,4096<d&&c.warn("Cookie '"+a+"' possibly not set or overflowed because it was too large ("+d+" > 4096 bytes)!"));else{if(r.cookie!==y)for(y=r.cookie,d=y.split("; "),Fa={},f=0;f<d.length;f++)e=d[f],g=
e.indexOf("="),0<g&&(a=k(e.substring(0,g)),Fa[a]===s&&(Fa[a]=k(e.substring(g+1))));return Fa}};m.defer=function(a,b){var c;p++;c=v(function(){delete t[c];e(a)},b||0);t[c]=!0;return c};m.defer.cancel=function(a){return t[a]?(delete t[a],P(a),e(A),!0):!1}}function Ie(){this.$get=["$window","$log","$sniffer","$document",function(b,a,c,d){return new sf(b,d,a,c)}]}function Je(){this.$get=function(){function b(b,d){function e(a){a!=r&&(n?n==a&&(n=a.n):n=a,f(a.n,a.p),f(a,r),r=a,r.n=null)}function f(a,b){a!=
b&&(a&&(a.p=b),b&&(b.n=a))}if(b in a)throw F("$cacheFactory")("iid",b);var g=0,h=x({},d,{id:b}),l={},k=d&&d.capacity||Number.MAX_VALUE,m={},r=null,n=null;return a[b]={put:function(a,b){if(k<Number.MAX_VALUE){var c=m[a]||(m[a]={key:a});e(c)}if(!C(b))return a in l||g++,l[a]=b,g>k&&this.remove(n.key),b},get:function(a){if(k<Number.MAX_VALUE){var b=m[a];if(!b)return;e(b)}return l[a]},remove:function(a){if(k<Number.MAX_VALUE){var b=m[a];if(!b)return;b==r&&(r=b.p);b==n&&(n=b.n);f(b.n,b.p);delete m[a]}delete l[a];
g--},removeAll:function(){l={};g=0;m={};r=n=null},destroy:function(){m=h=l=null;delete a[b]},info:function(){return x({},h,{size:g})}}}var a={};b.info=function(){var b={};q(a,function(a,e){b[e]=a.info()});return b};b.get=function(b){return a[b]};return b}}function $e(){this.$get=["$cacheFactory",function(b){return b("templates")}]}function Bc(b,a){function c(a,b){var c=/^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/,d={};q(a,function(a,e){var f=a.match(c);if(!f)throw da("iscp",b,e,a);d[e]={mode:f[1][0],collection:"*"===
f[2],optional:"?"===f[3],attrName:f[4]||e}});return d}function d(a){var b=a.charAt(0);if(!b||b!==L(b))throw da("baddir",a);return a}var e={},f=/^\s*directive\:\s*([\w\-]+)\s+(.*)$/,g=/(([\w\-]+)(?:\:([^;]+))?;?)/,h=Ld("ngSrc,ngSrcset,src,srcset"),l=/^(?:(\^\^?)?(\?)?(\^\^?)?)?/,k=/^(on[a-z]+|formaction)$/;this.directive=function n(a,f){Ma(a,"directive");O(a)?(d(a),Sb(f,"directiveFactory"),e.hasOwnProperty(a)||(e[a]=[],b.factory(a+"Directive",["$injector","$exceptionHandler",function(b,d){var f=[];
q(e[a],function(e,g){try{var h=b.invoke(e);E(h)?h={compile:ca(h)}:!h.compile&&h.link&&(h.compile=ca(h.link));h.priority=h.priority||0;h.index=g;h.name=h.name||a;h.require=h.require||h.controller&&h.name;h.restrict=h.restrict||"EA";I(h.scope)&&(h.$$isolateBindings=c(h.scope,h.name));f.push(h)}catch(l){d(l)}});return f}])),e[a].push(f)):q(a,pc(n));return this};this.aHrefSanitizationWhitelist=function(b){return y(b)?(a.aHrefSanitizationWhitelist(b),this):a.aHrefSanitizationWhitelist()};this.imgSrcSanitizationWhitelist=
function(b){return y(b)?(a.imgSrcSanitizationWhitelist(b),this):a.imgSrcSanitizationWhitelist()};var m=!0;this.debugInfoEnabled=function(a){return y(a)?(m=a,this):m};this.$get=["$injector","$interpolate","$exceptionHandler","$templateRequest","$parse","$controller","$rootScope","$document","$sce","$animate","$$sanitizeUri",function(a,b,c,d,t,p,H,J,B,M,D){function G(a,b){try{a.addClass(b)}catch(c){}}function N(a,b,c,d,e){a instanceof z||(a=z(a));q(a,function(b,c){b.nodeType==ab&&b.nodeValue.match(/\S+/)&&
(a[c]=z(b).wrap("<span></span>").parent()[0])});var f=Y(a,b,a,c,d,e);N.$$addScopeClass(a);var g=null;return function(b,c,d){Sb(b,"scope");d=d||{};var e=d.parentBoundTranscludeFn,h=d.transcludeControllers;d=d.futureParentElement;e&&e.$$boundTransclude&&(e=e.$$boundTransclude);g||(g=(d=d&&d[0])?"foreignobject"!==sa(d)&&d.toString().match(/SVG/)?"svg":"html":"html");d="html"!==g?z(T(g,z("<div>").append(a).html())):c?Ka.clone.call(a):a;if(h)for(var l in h)d.data("$"+l+"Controller",h[l].instance);N.$$addScopeInfo(d,
b);c&&c(d,b);f&&f(b,d,d,e);return d}}function Y(a,b,c,d,e,f){function g(a,c,d,e){var f,l,k,n,m,v,u;if(p)for(u=Array(c.length),n=0;n<h.length;n+=3)f=h[n],u[f]=c[f];else u=c;n=0;for(m=h.length;n<m;)l=u[h[n++]],c=h[n++],f=h[n++],c?(c.scope?(k=a.$new(),N.$$addScopeInfo(z(l),k)):k=a,v=c.transcludeOnThisElement?$(a,c.transclude,e,c.elementTranscludeOnThisElement):!c.templateOnThisElement&&e?e:!e&&b?$(a,b):null,c(f,k,l,d,v)):f&&f(a,l.childNodes,s,e)}for(var h=[],l,k,n,m,p,v=0;v<a.length;v++){l=new $b;k=
W(a[v],[],l,0===v?d:s,e);(f=k.length?y(k,a[v],l,b,c,null,[],[],f):null)&&f.scope&&N.$$addScopeClass(l.$$element);l=f&&f.terminal||!(n=a[v].childNodes)||!n.length?null:Y(n,f?(f.transcludeOnThisElement||!f.templateOnThisElement)&&f.transclude:b);if(f||l)h.push(v,f,l),m=!0,p=p||f;f=null}return m?g:null}function $(a,b,c,d){return function(d,e,f,g,h){d||(d=a.$new(!1,h),d.$$transcluded=!0);return b(d,e,{parentBoundTranscludeFn:c,transcludeControllers:f,futureParentElement:g})}}function W(a,b,c,d,e){var h=
c.$attr,l;switch(a.nodeType){case ma:C(b,va(sa(a)),"E",d,e);for(var k,n,m,p=a.attributes,v=0,u=p&&p.length;v<u;v++){var B=!1,P=!1;k=p[v];l=k.name;n=U(k.value);k=va(l);if(m=ac.test(k))l=l.replace(Wc,"").substr(8).replace(/_(.)/g,function(a,b){return b.toUpperCase()});var M=k.replace(/(Start|End)$/,"");F(M)&&k===M+"Start"&&(B=l,P=l.substr(0,l.length-5)+"end",l=l.substr(0,l.length-6));k=va(l.toLowerCase());h[k]=l;if(m||!c.hasOwnProperty(k))c[k]=n,Qc(a,k)&&(c[k]=!0);R(a,b,n,k,m);C(b,k,"A",d,e,B,P)}a=
a.className;I(a)&&(a=a.animVal);if(O(a)&&""!==a)for(;l=g.exec(a);)k=va(l[2]),C(b,k,"C",d,e)&&(c[k]=U(l[3])),a=a.substr(l.index+l[0].length);break;case ab:ia(b,a.nodeValue);break;case 8:try{if(l=f.exec(a.nodeValue))k=va(l[1]),C(b,k,"M",d,e)&&(c[k]=U(l[2]))}catch(t){}}b.sort(xa);return b}function S(a,b,c){var d=[],e=0;if(b&&a.hasAttribute&&a.hasAttribute(b)){do{if(!a)throw da("uterdir",b,c);a.nodeType==ma&&(a.hasAttribute(b)&&e++,a.hasAttribute(c)&&e--);d.push(a);a=a.nextSibling}while(0<e)}else d.push(a);
return z(d)}function Fa(a,b,c){return function(d,e,f,g,h){e=S(e[0],b,c);return a(d,e,f,g,h)}}function y(a,d,e,f,g,h,k,n,m){function B(a,b,c,d){if(a){c&&(a=Fa(a,c,d));a.require=K.require;a.directiveName=ia;if(J===K||K.$$isolateScope)a=X(a,{isolateScope:!0});k.push(a)}if(b){c&&(b=Fa(b,c,d));b.require=K.require;b.directiveName=ia;if(J===K||K.$$isolateScope)b=X(b,{isolateScope:!0});n.push(b)}}function P(a,b,c,d){var e,f="data",g=!1,h=c,k;if(O(b)){k=b.match(l);b=b.substring(k[0].length);k[3]&&(k[1]?k[3]=
null:k[1]=k[3]);"^"===k[1]?f="inheritedData":"^^"===k[1]&&(f="inheritedData",h=c.parent());"?"===k[2]&&(g=!0);e=null;d&&"data"===f&&(e=d[b])&&(e=e.instance);e=e||h[f]("$"+b+"Controller");if(!e&&!g)throw da("ctreq",b,a);return e||null}w(b)&&(e=[],q(b,function(b){e.push(P(a,b,c,d))}));return e}function M(a,c,f,g,h){function l(a,b,c){var d;Va(a)||(c=b,b=a,a=s);A&&(d=G);c||(c=A?S.parent():S);return h(a,b,d,c,Zb)}var m,v,B,D,G,ib,S,W;d===f?(W=e,S=e.$$element):(S=z(f),W=new $b(S,e));J&&(D=c.$new(!0));h&&
(ib=l,ib.$$boundTransclude=h);H&&($={},G={},q(H,function(a){var b={$scope:a===J||a.$$isolateScope?D:c,$element:S,$attrs:W,$transclude:ib};B=a.controller;"@"==B&&(B=W[a.name]);b=p(B,b,!0,a.controllerAs);G[a.name]=b;A||S.data("$"+a.name+"Controller",b.instance);$[a.name]=b}));if(J){N.$$addScopeInfo(S,D,!0,!(Y&&(Y===J||Y===J.$$originalDirective)));N.$$addScopeClass(S,!0);g=$&&$[J.name];var ua=D;g&&g.identifier&&!0===J.bindToController&&(ua=g.instance);q(D.$$isolateBindings=J.$$isolateBindings,function(a,
d){var e=a.attrName,f=a.optional,g,h,k,l;switch(a.mode){case "@":W.$observe(e,function(a){ua[d]=a});W.$$observers[e].$$scope=c;W[e]&&(ua[d]=b(W[e])(c));break;case "=":if(f&&!W[e])break;h=t(W[e]);l=h.literal?fa:function(a,b){return a===b||a!==a&&b!==b};k=h.assign||function(){g=ua[d]=h(c);throw da("nonassign",W[e],J.name);};g=ua[d]=h(c);f=function(a){l(a,ua[d])||(l(a,g)?k(c,a=ua[d]):ua[d]=a);return g=a};f.$stateful=!0;f=a.collection?c.$watchCollection(W[e],f):c.$watch(t(W[e],f),null,h.literal);D.$on("$destroy",
f);break;case "&":h=t(W[e]),ua[d]=function(a){return h(c,a)}}})}$&&(q($,function(a){a()}),$=null);g=0;for(m=k.length;g<m;g++)v=k[g],Xc(v,v.isolateScope?D:c,S,W,v.require&&P(v.directiveName,v.require,S,G),ib);var Zb=c;J&&(J.template||null===J.templateUrl)&&(Zb=D);a&&a(Zb,f.childNodes,s,h);for(g=n.length-1;0<=g;g--)v=n[g],Xc(v,v.isolateScope?D:c,S,W,v.require&&P(v.directiveName,v.require,S,G),ib)}m=m||{};for(var D=-Number.MAX_VALUE,G,H=m.controllerDirectives,$,J=m.newIsolateScopeDirective,Y=m.templateDirective,
Ga=m.nonTlbTranscludeDirective,C=!1,Yb=!1,A=m.hasElementTranscludeDirective,x=e.$$element=z(d),K,ia,F,gb=f,xa,qa=0,L=a.length;qa<L;qa++){K=a[qa];var R=K.$$start,jb=K.$$end;R&&(x=S(d,R,jb));F=s;if(D>K.priority)break;if(F=K.scope)K.templateUrl||(I(F)?(Oa("new/isolated scope",J||G,K,x),J=K):Oa("new/isolated scope",J,K,x)),G=G||K;ia=K.name;!K.templateUrl&&K.controller&&(F=K.controller,H=H||{},Oa("'"+ia+"' controller",H[ia],K,x),H[ia]=K);if(F=K.transclude)C=!0,K.$$tlb||(Oa("transclusion",Ga,K,x),Ga=K),
"element"==F?(A=!0,D=K.priority,F=x,x=e.$$element=z(V.createComment(" "+ia+": "+e[ia]+" ")),d=x[0],Q(g,Za.call(F,0),d),gb=N(F,f,D,h&&h.name,{nonTlbTranscludeDirective:Ga})):(F=z(Vb(d)).contents(),x.empty(),gb=N(F,f));if(K.template)if(Yb=!0,Oa("template",Y,K,x),Y=K,F=E(K.template)?K.template(x,e):K.template,F=Yc(F),K.replace){h=K;F=Tb.test(F)?Zc(T(K.templateNamespace,U(F))):[];d=F[0];if(1!=F.length||d.nodeType!==ma)throw da("tplrt",ia,"");Q(g,x,d);L={$attr:{}};F=W(d,[],L);var tf=a.splice(qa+1,a.length-
(qa+1));J&&hb(F);a=a.concat(F).concat(tf);Vc(e,L);L=a.length}else x.html(F);if(K.templateUrl)Yb=!0,Oa("template",Y,K,x),Y=K,K.replace&&(h=K),M=Xb(a.splice(qa,a.length-qa),x,e,g,C&&gb,k,n,{controllerDirectives:H,newIsolateScopeDirective:J,templateDirective:Y,nonTlbTranscludeDirective:Ga}),L=a.length;else if(K.compile)try{xa=K.compile(x,e,gb),E(xa)?B(null,xa,R,jb):xa&&B(xa.pre,xa.post,R,jb)}catch(ac){c(ac,ta(x))}K.terminal&&(M.terminal=!0,D=Math.max(D,K.priority))}M.scope=G&&!0===G.scope;M.transcludeOnThisElement=
C;M.elementTranscludeOnThisElement=A;M.templateOnThisElement=Yb;M.transclude=gb;m.hasElementTranscludeDirective=A;return M}function hb(a){for(var b=0,c=a.length;b<c;b++)a[b]=Pb(a[b],{$$isolateScope:!0})}function C(b,d,f,g,h,k,l){if(d===h)return null;h=null;if(e.hasOwnProperty(d)){var m;d=a.get(d+"Directive");for(var p=0,B=d.length;p<B;p++)try{m=d[p],(g===s||g>m.priority)&&-1!=m.restrict.indexOf(f)&&(k&&(m=Pb(m,{$$start:k,$$end:l})),b.push(m),h=m)}catch(u){c(u)}}return h}function F(b){if(e.hasOwnProperty(b))for(var c=
a.get(b+"Directive"),d=0,f=c.length;d<f;d++)if(b=c[d],b.multiElement)return!0;return!1}function Vc(a,b){var c=b.$attr,d=a.$attr,e=a.$$element;q(a,function(d,e){"$"!=e.charAt(0)&&(b[e]&&b[e]!==d&&(d+=("style"===e?";":" ")+b[e]),a.$set(e,d,!0,c[e]))});q(b,function(b,f){"class"==f?(G(e,b),a["class"]=(a["class"]?a["class"]+" ":"")+b):"style"==f?(e.attr("style",e.attr("style")+";"+b),a.style=(a.style?a.style+";":"")+b):"$"==f.charAt(0)||a.hasOwnProperty(f)||(a[f]=b,d[f]=c[f])})}function Xb(a,b,c,e,f,g,
h,k){var l=[],n,m,p=b[0],v=a.shift(),u=Pb(v,{templateUrl:null,transclude:null,replace:null,$$originalDirective:v}),M=E(v.templateUrl)?v.templateUrl(b,c):v.templateUrl,D=v.templateNamespace;b.empty();d(B.getTrustedResourceUrl(M)).then(function(d){var B,P;d=Yc(d);if(v.replace){d=Tb.test(d)?Zc(T(D,U(d))):[];B=d[0];if(1!=d.length||B.nodeType!==ma)throw da("tplrt",v.name,M);d={$attr:{}};Q(e,b,B);var t=W(B,[],d);I(v.scope)&&hb(t);a=t.concat(a);Vc(c,d)}else B=p,b.html(d);a.unshift(u);n=y(a,B,c,f,b,v,g,h,
k);q(e,function(a,c){a==B&&(e[c]=b[0])});for(m=Y(b[0].childNodes,f);l.length;){d=l.shift();P=l.shift();var H=l.shift(),N=l.shift(),t=b[0];if(!d.$$destroyed){if(P!==p){var J=P.className;k.hasElementTranscludeDirective&&v.replace||(t=Vb(B));Q(H,z(P),t);G(z(t),J)}P=n.transcludeOnThisElement?$(d,n.transclude,N):N;n(m,d,t,e,P)}}l=null});return function(a,b,c,d,e){a=e;b.$$destroyed||(l?l.push(b,c,d,a):(n.transcludeOnThisElement&&(a=$(b,n.transclude,e)),n(m,b,c,d,a)))}}function xa(a,b){var c=b.priority-
a.priority;return 0!==c?c:a.name!==b.name?a.name<b.name?-1:1:a.index-b.index}function Oa(a,b,c,d){if(b)throw da("multidir",b.name,c.name,a,ta(d));}function ia(a,c){var d=b(c,!0);d&&a.push({priority:0,compile:function(a){a=a.parent();var b=!!a.length;b&&N.$$addBindingClass(a);return function(a,c){var e=c.parent();b||N.$$addBindingClass(e);N.$$addBindingInfo(e,d.expressions);a.$watch(d,function(a){c[0].nodeValue=a})}}})}function T(a,b){a=L(a||"html");switch(a){case "svg":case "math":var c=V.createElement("div");
c.innerHTML="<"+a+">"+b+"</"+a+">";return c.childNodes[0].childNodes;default:return b}}function jb(a,b){if("srcdoc"==b)return B.HTML;var c=sa(a);if("xlinkHref"==b||"form"==c&&"action"==b||"img"!=c&&("src"==b||"ngSrc"==b))return B.RESOURCE_URL}function R(a,c,d,e,f){var g=jb(a,e);f=h[e]||f;var l=b(d,!0,g,f);if(l){if("multiple"===e&&"select"===sa(a))throw da("selmulti",ta(a));c.push({priority:100,compile:function(){return{pre:function(a,c,h){c=h.$$observers||(h.$$observers={});if(k.test(e))throw da("nodomevents");
var n=h[e];n!==d&&(l=n&&b(n,!0,g,f),d=n);l&&(h[e]=l(a),(c[e]||(c[e]=[])).$$inter=!0,(h.$$observers&&h.$$observers[e].$$scope||a).$watch(l,function(a,b){"class"===e&&a!=b?h.$updateClass(a,b):h.$set(e,a)}))}}}})}}function Q(a,b,c){var d=b[0],e=b.length,f=d.parentNode,g,h;if(a)for(g=0,h=a.length;g<h;g++)if(a[g]==d){a[g++]=c;h=g+e-1;for(var l=a.length;g<l;g++,h++)h<l?a[g]=a[h]:delete a[g];a.length-=e-1;a.context===d&&(a.context=c);break}f&&f.replaceChild(c,d);a=V.createDocumentFragment();a.appendChild(d);
z(c).data(z(d).data());pa?(Rb=!0,pa.cleanData([d])):delete z.cache[d[z.expando]];d=1;for(e=b.length;d<e;d++)f=b[d],z(f).remove(),a.appendChild(f),delete b[d];b[0]=c;b.length=1}function X(a,b){return x(function(){return a.apply(null,arguments)},a,b)}function Xc(a,b,d,e,f,g){try{a(b,d,e,f,g)}catch(h){c(h,ta(d))}}var $b=function(a,b){if(b){var c=Object.keys(b),d,e,f;d=0;for(e=c.length;d<e;d++)f=c[d],this[f]=b[f]}else this.$attr={};this.$$element=a};$b.prototype={$normalize:va,$addClass:function(a){a&&
0<a.length&&M.addClass(this.$$element,a)},$removeClass:function(a){a&&0<a.length&&M.removeClass(this.$$element,a)},$updateClass:function(a,b){var c=$c(a,b);c&&c.length&&M.addClass(this.$$element,c);(c=$c(b,a))&&c.length&&M.removeClass(this.$$element,c)},$set:function(a,b,d,e){var f=this.$$element[0],g=Qc(f,a),h=pf(f,a),f=a;g?(this.$$element.prop(a,b),e=g):h&&(this[h]=b,f=h);this[a]=b;e?this.$attr[a]=e:(e=this.$attr[a])||(this.$attr[a]=e=yc(a,"-"));g=sa(this.$$element);if("a"===g&&"href"===a||"img"===
g&&"src"===a)this[a]=b=D(b,"src"===a);else if("img"===g&&"srcset"===a){for(var g="",h=U(b),l=/(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/,l=/\s/.test(h)?l:/(,)/,h=h.split(l),l=Math.floor(h.length/2),k=0;k<l;k++)var n=2*k,g=g+D(U(h[n]),!0),g=g+(" "+U(h[n+1]));h=U(h[2*k]).split(/\s/);g+=D(U(h[0]),!0);2===h.length&&(g+=" "+U(h[1]));this[a]=b=g}!1!==d&&(null===b||b===s?this.$$element.removeAttr(e):this.$$element.attr(e,b));(a=this.$$observers)&&q(a[f],function(a){try{a(b)}catch(d){c(d)}})},$observe:function(a,
b){var c=this,d=c.$$observers||(c.$$observers=ga()),e=d[a]||(d[a]=[]);e.push(b);H.$evalAsync(function(){!e.$$inter&&c.hasOwnProperty(a)&&b(c[a])});return function(){Xa(e,b)}}};var Ga=b.startSymbol(),qa=b.endSymbol(),Yc="{{"==Ga||"}}"==qa?na:function(a){return a.replace(/\{\{/g,Ga).replace(/}}/g,qa)},ac=/^ngAttr[A-Z]/;N.$$addBindingInfo=m?function(a,b){var c=a.data("$binding")||[];w(b)?c=c.concat(b):c.push(b);a.data("$binding",c)}:A;N.$$addBindingClass=m?function(a){G(a,"ng-binding")}:A;N.$$addScopeInfo=
m?function(a,b,c,d){a.data(c?d?"$isolateScopeNoTemplate":"$isolateScope":"$scope",b)}:A;N.$$addScopeClass=m?function(a,b){G(a,b?"ng-isolate-scope":"ng-scope")}:A;return N}]}function va(b){return eb(b.replace(Wc,""))}function $c(b,a){var c="",d=b.split(/\s+/),e=a.split(/\s+/),f=0;a:for(;f<d.length;f++){for(var g=d[f],h=0;h<e.length;h++)if(g==e[h])continue a;c+=(0<c.length?" ":"")+g}return c}function Zc(b){b=z(b);var a=b.length;if(1>=a)return b;for(;a--;)8===b[a].nodeType&&uf.call(b,a,1);return b}function Ke(){var b=
{},a=!1,c=/^(\S+)(\s+as\s+(\w+))?$/;this.register=function(a,c){Ma(a,"controller");I(a)?x(b,a):b[a]=c};this.allowGlobals=function(){a=!0};this.$get=["$injector","$window",function(d,e){function f(a,b,c,d){if(!a||!I(a.$scope))throw F("$controller")("noscp",d,b);a.$scope[b]=c}return function(g,h,l,k){var m,r,n;l=!0===l;k&&O(k)&&(n=k);if(O(g)){k=g.match(c);if(!k)throw vf("ctrlfmt",g);r=k[1];n=n||k[3];g=b.hasOwnProperty(r)?b[r]:Ac(h.$scope,r,!0)||(a?Ac(e,r,!0):s);La(g,r,!0)}if(l)return l=(w(g)?g[g.length-
1]:g).prototype,m=Object.create(l||null),n&&f(h,n,m,r||g.name),x(function(){d.invoke(g,m,h,r);return m},{instance:m,identifier:n});m=d.instantiate(g,h,r);n&&f(h,n,m,r||g.name);return m}}]}function Le(){this.$get=["$window",function(b){return z(b.document)}]}function Me(){this.$get=["$log",function(b){return function(a,c){b.error.apply(b,arguments)}}]}function bc(b,a){if(O(b)){var c=b.replace(wf,"").trim();if(c){var d=a("Content-Type");(d=d&&0===d.indexOf(ad))||(d=(d=c.match(xf))&&yf[d[0]].test(c));
d&&(b=tc(c))}}return b}function bd(b){var a=ga(),c,d,e;if(!b)return a;q(b.split("\n"),function(b){e=b.indexOf(":");c=L(U(b.substr(0,e)));d=U(b.substr(e+1));c&&(a[c]=a[c]?a[c]+", "+d:d)});return a}function cd(b){var a=I(b)?b:s;return function(c){a||(a=bd(b));return c?(c=a[L(c)],void 0===c&&(c=null),c):a}}function dd(b,a,c,d){if(E(d))return d(b,a,c);q(d,function(d){b=d(b,a,c)});return b}function Pe(){var b=this.defaults={transformResponse:[bc],transformRequest:[function(a){return I(a)&&"[object File]"!==
Aa.call(a)&&"[object Blob]"!==Aa.call(a)&&"[object FormData]"!==Aa.call(a)?$a(a):a}],headers:{common:{Accept:"application/json, text/plain, */*"},post:oa(cc),put:oa(cc),patch:oa(cc)},xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN"},a=!1;this.useApplyAsync=function(b){return y(b)?(a=!!b,this):a};var c=this.interceptors=[];this.$get=["$httpBackend","$browser","$cacheFactory","$rootScope","$q","$injector",function(d,e,f,g,h,l){function k(a){function c(a){var b=x({},a);b.data=a.data?dd(a.data,
a.headers,a.status,e.transformResponse):a.data;a=a.status;return 200<=a&&300>a?b:h.reject(b)}function d(a){var b,c={};q(a,function(a,d){E(a)?(b=a(),null!=b&&(c[d]=b)):c[d]=a});return c}if(!ba.isObject(a))throw F("$http")("badreq",a);var e=x({method:"get",transformRequest:b.transformRequest,transformResponse:b.transformResponse},a);e.headers=function(a){var c=b.headers,e=x({},a.headers),f,g,c=x({},c.common,c[L(a.method)]);a:for(f in c){a=L(f);for(g in e)if(L(g)===a)continue a;e[f]=c[f]}return d(e)}(a);
e.method=vb(e.method);var f=[function(a){var d=a.headers,e=dd(a.data,cd(d),s,a.transformRequest);C(e)&&q(d,function(a,b){"content-type"===L(b)&&delete d[b]});C(a.withCredentials)&&!C(b.withCredentials)&&(a.withCredentials=b.withCredentials);return m(a,e).then(c,c)},s],g=h.when(e);for(q(u,function(a){(a.request||a.requestError)&&f.unshift(a.request,a.requestError);(a.response||a.responseError)&&f.push(a.response,a.responseError)});f.length;){a=f.shift();var l=f.shift(),g=g.then(a,l)}g.success=function(a){La(a,
"fn");g.then(function(b){a(b.data,b.status,b.headers,e)});return g};g.error=function(a){La(a,"fn");g.then(null,function(b){a(b.data,b.status,b.headers,e)});return g};return g}function m(c,f){function l(b,c,d,e){function f(){m(c,b,d,e)}D&&(200<=b&&300>b?D.put(q,[b,c,bd(d),e]):D.remove(q));a?g.$applyAsync(f):(f(),g.$$phase||g.$apply())}function m(a,b,d,e){b=Math.max(b,0);(200<=b&&300>b?B.resolve:B.reject)({data:a,status:b,headers:cd(d),config:c,statusText:e})}function u(a){m(a.data,a.status,oa(a.headers()),
a.statusText)}function J(){var a=k.pendingRequests.indexOf(c);-1!==a&&k.pendingRequests.splice(a,1)}var B=h.defer(),M=B.promise,D,G,N=c.headers,q=r(c.url,c.params);k.pendingRequests.push(c);M.then(J,J);!c.cache&&!b.cache||!1===c.cache||"GET"!==c.method&&"JSONP"!==c.method||(D=I(c.cache)?c.cache:I(b.cache)?b.cache:n);D&&(G=D.get(q),y(G)?G&&E(G.then)?G.then(u,u):w(G)?m(G[1],G[0],oa(G[2]),G[3]):m(G,200,{},"OK"):D.put(q,M));C(G)&&((G=ed(c.url)?e.cookies()[c.xsrfCookieName||b.xsrfCookieName]:s)&&(N[c.xsrfHeaderName||
b.xsrfHeaderName]=G),d(c.method,q,f,l,N,c.timeout,c.withCredentials,c.responseType));return M}function r(a,b){if(!b)return a;var c=[];Jd(b,function(a,b){null===a||C(a)||(w(a)||(a=[a]),q(a,function(a){I(a)&&(a=ea(a)?a.toISOString():$a(a));c.push(Ca(b)+"="+Ca(a))}))});0<c.length&&(a+=(-1==a.indexOf("?")?"?":"&")+c.join("&"));return a}var n=f("$http"),u=[];q(c,function(a){u.unshift(O(a)?l.get(a):l.invoke(a))});k.pendingRequests=[];(function(a){q(arguments,function(a){k[a]=function(b,c){return k(x(c||
{},{method:a,url:b}))}})})("get","delete","head","jsonp");(function(a){q(arguments,function(a){k[a]=function(b,c,d){return k(x(d||{},{method:a,url:b,data:c}))}})})("post","put","patch");k.defaults=b;return k}]}function zf(){return new T.XMLHttpRequest}function Qe(){this.$get=["$browser","$window","$document",function(b,a,c){return Af(b,zf,b.defer,a.angular.callbacks,c[0])}]}function Af(b,a,c,d,e){function f(a,b,c){var f=e.createElement("script"),m=null;f.type="text/javascript";f.src=a;f.async=!0;
m=function(a){f.removeEventListener("load",m,!1);f.removeEventListener("error",m,!1);e.body.removeChild(f);f=null;var g=-1,u="unknown";a&&("load"!==a.type||d[b].called||(a={type:"error"}),u=a.type,g="error"===a.type?404:200);c&&c(g,u)};f.addEventListener("load",m,!1);f.addEventListener("error",m,!1);e.body.appendChild(f);return m}return function(e,h,l,k,m,r,n,u){function v(){p&&p();H&&H.abort()}function P(a,d,e,f,g){B!==s&&c.cancel(B);p=H=null;a(d,e,f,g);b.$$completeOutstandingRequest(A)}b.$$incOutstandingRequestCount();
h=h||b.url();if("jsonp"==L(e)){var t="_"+(d.counter++).toString(36);d[t]=function(a){d[t].data=a;d[t].called=!0};var p=f(h.replace("JSON_CALLBACK","angular.callbacks."+t),t,function(a,b){P(k,a,d[t].data,"",b);d[t]=A})}else{var H=a();H.open(e,h,!0);q(m,function(a,b){y(a)&&H.setRequestHeader(b,a)});H.onload=function(){var a=H.statusText||"",b="response"in H?H.response:H.responseText,c=1223===H.status?204:H.status;0===c&&(c=b?200:"file"==ya(h).protocol?404:0);P(k,c,b,H.getAllResponseHeaders(),a)};e=
function(){P(k,-1,null,null,"")};H.onerror=e;H.onabort=e;n&&(H.withCredentials=!0);if(u)try{H.responseType=u}catch(J){if("json"!==u)throw J;}H.send(l||null)}if(0<r)var B=c(v,r);else r&&E(r.then)&&r.then(v)}}function Ne(){var b="{{",a="}}";this.startSymbol=function(a){return a?(b=a,this):b};this.endSymbol=function(b){return b?(a=b,this):a};this.$get=["$parse","$exceptionHandler","$sce",function(c,d,e){function f(a){return"\\\\\\"+a}function g(f,g,u,v){function P(c){return c.replace(k,b).replace(m,
a)}function t(a){try{var b=a;a=u?e.getTrusted(u,b):e.valueOf(b);var c;if(v&&!y(a))c=a;else if(null==a)c="";else{switch(typeof a){case "string":break;case "number":a=""+a;break;default:a=$a(a)}c=a}return c}catch(g){c=dc("interr",f,g.toString()),d(c)}}v=!!v;for(var p,H,q=0,B=[],M=[],D=f.length,G=[],N=[];q<D;)if(-1!=(p=f.indexOf(b,q))&&-1!=(H=f.indexOf(a,p+h)))q!==p&&G.push(P(f.substring(q,p))),q=f.substring(p+h,H),B.push(q),M.push(c(q,t)),q=H+l,N.push(G.length),G.push("");else{q!==D&&G.push(P(f.substring(q)));
break}if(u&&1<G.length)throw dc("noconcat",f);if(!g||B.length){var Y=function(a){for(var b=0,c=B.length;b<c;b++){if(v&&C(a[b]))return;G[N[b]]=a[b]}return G.join("")};return x(function(a){var b=0,c=B.length,e=Array(c);try{for(;b<c;b++)e[b]=M[b](a);return Y(e)}catch(g){a=dc("interr",f,g.toString()),d(a)}},{exp:f,expressions:B,$$watchDelegate:function(a,b,c){var d;return a.$watchGroup(M,function(c,e){var f=Y(c);E(b)&&b.call(this,f,c!==e?d:f,a);d=f},c)}})}}var h=b.length,l=a.length,k=new RegExp(b.replace(/./g,
f),"g"),m=new RegExp(a.replace(/./g,f),"g");g.startSymbol=function(){return b};g.endSymbol=function(){return a};return g}]}function Oe(){this.$get=["$rootScope","$window","$q","$$q",function(b,a,c,d){function e(e,h,l,k){var m=a.setInterval,r=a.clearInterval,n=0,u=y(k)&&!k,v=(u?d:c).defer(),P=v.promise;l=y(l)?l:0;P.then(null,null,e);P.$$intervalId=m(function(){v.notify(n++);0<l&&n>=l&&(v.resolve(n),r(P.$$intervalId),delete f[P.$$intervalId]);u||b.$apply()},h);f[P.$$intervalId]=v;return P}var f={};
e.cancel=function(b){return b&&b.$$intervalId in f?(f[b.$$intervalId].reject("canceled"),a.clearInterval(b.$$intervalId),delete f[b.$$intervalId],!0):!1};return e}]}function Wd(){this.$get=function(){return{id:"en-us",NUMBER_FORMATS:{DECIMAL_SEP:".",GROUP_SEP:",",PATTERNS:[{minInt:1,minFrac:0,maxFrac:3,posPre:"",posSuf:"",negPre:"-",negSuf:"",gSize:3,lgSize:3},{minInt:1,minFrac:2,maxFrac:2,posPre:"\u00a4",posSuf:"",negPre:"(\u00a4",negSuf:")",gSize:3,lgSize:3}],CURRENCY_SYM:"$"},DATETIME_FORMATS:{MONTH:"January February March April May June July August September October November December".split(" "),
SHORTMONTH:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),DAY:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),SHORTDAY:"Sun Mon Tue Wed Thu Fri Sat".split(" "),AMPMS:["AM","PM"],medium:"MMM d, y h:mm:ss a","short":"M/d/yy h:mm a",fullDate:"EEEE, MMMM d, y",longDate:"MMMM d, y",mediumDate:"MMM d, y",shortDate:"M/d/yy",mediumTime:"h:mm:ss a",shortTime:"h:mm a",ERANAMES:["Before Christ","Anno Domini"],ERAS:["BC","AD"]},pluralCat:function(b){return 1===b?"one":"other"}}}}
function ec(b){b=b.split("/");for(var a=b.length;a--;)b[a]=sb(b[a]);return b.join("/")}function fd(b,a){var c=ya(b);a.$$protocol=c.protocol;a.$$host=c.hostname;a.$$port=aa(c.port)||Bf[c.protocol]||null}function gd(b,a){var c="/"!==b.charAt(0);c&&(b="/"+b);var d=ya(b);a.$$path=decodeURIComponent(c&&"/"===d.pathname.charAt(0)?d.pathname.substring(1):d.pathname);a.$$search=vc(d.search);a.$$hash=decodeURIComponent(d.hash);a.$$path&&"/"!=a.$$path.charAt(0)&&(a.$$path="/"+a.$$path)}function wa(b,a){if(0===
a.indexOf(b))return a.substr(b.length)}function Ea(b){var a=b.indexOf("#");return-1==a?b:b.substr(0,a)}function Gb(b){return b.replace(/(#.+)|#$/,"$1")}function fc(b){return b.substr(0,Ea(b).lastIndexOf("/")+1)}function gc(b,a){this.$$html5=!0;a=a||"";var c=fc(b);fd(b,this);this.$$parse=function(a){var b=wa(c,a);if(!O(b))throw Hb("ipthprfx",a,c);gd(b,this);this.$$path||(this.$$path="/");this.$$compose()};this.$$compose=function(){var a=Qb(this.$$search),b=this.$$hash?"#"+sb(this.$$hash):"";this.$$url=
ec(this.$$path)+(a?"?"+a:"")+b;this.$$absUrl=c+this.$$url.substr(1)};this.$$parseLinkUrl=function(d,e){if(e&&"#"===e[0])return this.hash(e.slice(1)),!0;var f,g;(f=wa(b,d))!==s?(g=f,g=(f=wa(a,f))!==s?c+(wa("/",f)||f):b+g):(f=wa(c,d))!==s?g=c+f:c==d+"/"&&(g=c);g&&this.$$parse(g);return!!g}}function hc(b,a){var c=fc(b);fd(b,this);this.$$parse=function(d){d=wa(b,d)||wa(c,d);var e;"#"===d.charAt(0)?(e=wa(a,d),C(e)&&(e=d)):e=this.$$html5?d:"";gd(e,this);d=this.$$path;var f=/^\/[A-Z]:(\/.*)/;0===e.indexOf(b)&&
(e=e.replace(b,""));f.exec(e)||(d=(e=f.exec(d))?e[1]:d);this.$$path=d;this.$$compose()};this.$$compose=function(){var c=Qb(this.$$search),e=this.$$hash?"#"+sb(this.$$hash):"";this.$$url=ec(this.$$path)+(c?"?"+c:"")+e;this.$$absUrl=b+(this.$$url?a+this.$$url:"")};this.$$parseLinkUrl=function(a,c){return Ea(b)==Ea(a)?(this.$$parse(a),!0):!1}}function hd(b,a){this.$$html5=!0;hc.apply(this,arguments);var c=fc(b);this.$$parseLinkUrl=function(d,e){if(e&&"#"===e[0])return this.hash(e.slice(1)),!0;var f,
g;b==Ea(d)?f=d:(g=wa(c,d))?f=b+a+g:c===d+"/"&&(f=c);f&&this.$$parse(f);return!!f};this.$$compose=function(){var c=Qb(this.$$search),e=this.$$hash?"#"+sb(this.$$hash):"";this.$$url=ec(this.$$path)+(c?"?"+c:"")+e;this.$$absUrl=b+a+this.$$url}}function Ib(b){return function(){return this[b]}}function id(b,a){return function(c){if(C(c))return this[b];this[b]=a(c);this.$$compose();return this}}function Re(){var b="",a={enabled:!1,requireBase:!0,rewriteLinks:!0};this.hashPrefix=function(a){return y(a)?
(b=a,this):b};this.html5Mode=function(b){return Wa(b)?(a.enabled=b,this):I(b)?(Wa(b.enabled)&&(a.enabled=b.enabled),Wa(b.requireBase)&&(a.requireBase=b.requireBase),Wa(b.rewriteLinks)&&(a.rewriteLinks=b.rewriteLinks),this):a};this.$get=["$rootScope","$browser","$sniffer","$rootElement","$window",function(c,d,e,f,g){function h(a,b,c){var e=k.url(),f=k.$$state;try{d.url(a,b,c),k.$$state=d.state()}catch(g){throw k.url(e),k.$$state=f,g;}}function l(a,b){c.$broadcast("$locationChangeSuccess",k.absUrl(),
a,k.$$state,b)}var k,m;m=d.baseHref();var r=d.url(),n;if(a.enabled){if(!m&&a.requireBase)throw Hb("nobase");n=r.substring(0,r.indexOf("/",r.indexOf("//")+2))+(m||"/");m=e.history?gc:hd}else n=Ea(r),m=hc;k=new m(n,"#"+b);k.$$parseLinkUrl(r,r);k.$$state=d.state();var u=/^\s*(javascript|mailto):/i;f.on("click",function(b){if(a.rewriteLinks&&!b.ctrlKey&&!b.metaKey&&!b.shiftKey&&2!=b.which&&2!=b.button){for(var e=z(b.target);"a"!==sa(e[0]);)if(e[0]===f[0]||!(e=e.parent())[0])return;var h=e.prop("href"),
l=e.attr("href")||e.attr("xlink:href");I(h)&&"[object SVGAnimatedString]"===h.toString()&&(h=ya(h.animVal).href);u.test(h)||!h||e.attr("target")||b.isDefaultPrevented()||!k.$$parseLinkUrl(h,l)||(b.preventDefault(),k.absUrl()!=d.url()&&(c.$apply(),g.angular["ff-684208-preventDefault"]=!0))}});Gb(k.absUrl())!=Gb(r)&&d.url(k.absUrl(),!0);var v=!0;d.onUrlChange(function(a,b){c.$evalAsync(function(){var d=k.absUrl(),e=k.$$state,f;k.$$parse(a);k.$$state=b;f=c.$broadcast("$locationChangeStart",a,d,b,e).defaultPrevented;
k.absUrl()===a&&(f?(k.$$parse(d),k.$$state=e,h(d,!1,e)):(v=!1,l(d,e)))});c.$$phase||c.$digest()});c.$watch(function(){var a=Gb(d.url()),b=Gb(k.absUrl()),f=d.state(),g=k.$$replace,n=a!==b||k.$$html5&&e.history&&f!==k.$$state;if(v||n)v=!1,c.$evalAsync(function(){var b=k.absUrl(),d=c.$broadcast("$locationChangeStart",b,a,k.$$state,f).defaultPrevented;k.absUrl()===b&&(d?(k.$$parse(a),k.$$state=f):(n&&h(b,g,f===k.$$state?null:k.$$state),l(a,f)))});k.$$replace=!1});return k}]}function Se(){var b=!0,a=this;
this.debugEnabled=function(a){return y(a)?(b=a,this):b};this.$get=["$window",function(c){function d(a){a instanceof Error&&(a.stack?a=a.message&&-1===a.stack.indexOf(a.message)?"Error: "+a.message+"\n"+a.stack:a.stack:a.sourceURL&&(a=a.message+"\n"+a.sourceURL+":"+a.line));return a}function e(a){var b=c.console||{},e=b[a]||b.log||A;a=!1;try{a=!!e.apply}catch(l){}return a?function(){var a=[];q(arguments,function(b){a.push(d(b))});return e.apply(b,a)}:function(a,b){e(a,null==b?"":b)}}return{log:e("log"),
info:e("info"),warn:e("warn"),error:e("error"),debug:function(){var c=e("debug");return function(){b&&c.apply(a,arguments)}}()}}]}function ra(b,a){if("__defineGetter__"===b||"__defineSetter__"===b||"__lookupGetter__"===b||"__lookupSetter__"===b||"__proto__"===b)throw ja("isecfld",a);return b}function ka(b,a){if(b){if(b.constructor===b)throw ja("isecfn",a);if(b.window===b)throw ja("isecwindow",a);if(b.children&&(b.nodeName||b.prop&&b.attr&&b.find))throw ja("isecdom",a);if(b===Object)throw ja("isecobj",
a);}return b}function ic(b){return b.constant}function kb(b,a,c,d,e){ka(b,e);ka(a,e);c=c.split(".");for(var f,g=0;1<c.length;g++){f=ra(c.shift(),e);var h=0===g&&a&&a[f]||b[f];h||(h={},b[f]=h);b=ka(h,e)}f=ra(c.shift(),e);ka(b[f],e);return b[f]=d}function Pa(b){return"constructor"==b}function jd(b,a,c,d,e,f,g){ra(b,f);ra(a,f);ra(c,f);ra(d,f);ra(e,f);var h=function(a){return ka(a,f)},l=g||Pa(b)?h:na,k=g||Pa(a)?h:na,m=g||Pa(c)?h:na,r=g||Pa(d)?h:na,n=g||Pa(e)?h:na;return function(f,g){var h=g&&g.hasOwnProperty(b)?
g:f;if(null==h)return h;h=l(h[b]);if(!a)return h;if(null==h)return s;h=k(h[a]);if(!c)return h;if(null==h)return s;h=m(h[c]);if(!d)return h;if(null==h)return s;h=r(h[d]);return e?null==h?s:h=n(h[e]):h}}function Cf(b,a){return function(c,d){return b(c,d,ka,a)}}function Df(b,a,c){var d=a.expensiveChecks,e=d?Ef:Ff,f=e[b];if(f)return f;var g=b.split("."),h=g.length;if(a.csp)f=6>h?jd(g[0],g[1],g[2],g[3],g[4],c,d):function(a,b){var e=0,f;do f=jd(g[e++],g[e++],g[e++],g[e++],g[e++],c,d)(a,b),b=s,a=f;while(e<
h);return f};else{var l="";d&&(l+="s = eso(s, fe);\nl = eso(l, fe);\n");var k=d;q(g,function(a,b){ra(a,c);var e=(b?"s":'((l&&l.hasOwnProperty("'+a+'"))?l:s)')+"."+a;if(d||Pa(a))e="eso("+e+", fe)",k=!0;l+="if(s == null) return undefined;\ns="+e+";\n"});l+="return s;";a=new Function("s","l","eso","fe",l);a.toString=ca(l);k&&(a=Cf(a,c));f=a}f.sharedGetter=!0;f.assign=function(a,c,d){return kb(a,d,b,c,b)};return e[b]=f}function jc(b){return E(b.valueOf)?b.valueOf():Gf.call(b)}function Te(){var b=ga(),
a=ga();this.$get=["$filter","$sniffer",function(c,d){function e(a){var b=a;a.sharedGetter&&(b=function(b,c){return a(b,c)},b.literal=a.literal,b.constant=a.constant,b.assign=a.assign);return b}function f(a,b){for(var c=0,d=a.length;c<d;c++){var e=a[c];e.constant||(e.inputs?f(e.inputs,b):-1===b.indexOf(e)&&b.push(e))}return b}function g(a,b){return null==a||null==b?a===b:"object"===typeof a&&(a=jc(a),"object"===typeof a)?!1:a===b||a!==a&&b!==b}function h(a,b,c,d){var e=d.$$inputs||(d.$$inputs=f(d.inputs,
[])),h;if(1===e.length){var l=g,e=e[0];return a.$watch(function(a){var b=e(a);g(b,l)||(h=d(a),l=b&&jc(b));return h},b,c)}for(var k=[],n=0,m=e.length;n<m;n++)k[n]=g;return a.$watch(function(a){for(var b=!1,c=0,f=e.length;c<f;c++){var l=e[c](a);if(b||(b=!g(l,k[c])))k[c]=l&&jc(l)}b&&(h=d(a));return h},b,c)}function l(a,b,c,d){var e,f;return e=a.$watch(function(a){return d(a)},function(a,c,d){f=a;E(b)&&b.apply(this,arguments);y(a)&&d.$$postDigest(function(){y(f)&&e()})},c)}function k(a,b,c,d){function e(a){var b=
!0;q(a,function(a){y(a)||(b=!1)});return b}var f,g;return f=a.$watch(function(a){return d(a)},function(a,c,d){g=a;E(b)&&b.call(this,a,c,d);e(a)&&d.$$postDigest(function(){e(g)&&f()})},c)}function m(a,b,c,d){var e;return e=a.$watch(function(a){return d(a)},function(a,c,d){E(b)&&b.apply(this,arguments);e()},c)}function r(a,b){if(!b)return a;var c=a.$$watchDelegate,c=c!==k&&c!==l?function(c,d){var e=a(c,d);return b(e,c,d)}:function(c,d){var e=a(c,d),f=b(e,c,d);return y(e)?f:e};a.$$watchDelegate&&a.$$watchDelegate!==
h?c.$$watchDelegate=a.$$watchDelegate:b.$stateful||(c.$$watchDelegate=h,c.inputs=[a]);return c}var n={csp:d.csp,expensiveChecks:!1},u={csp:d.csp,expensiveChecks:!0};return function(d,f,g){var p,q,s;switch(typeof d){case "string":s=d=d.trim();var B=g?a:b;p=B[s];p||(":"===d.charAt(0)&&":"===d.charAt(1)&&(q=!0,d=d.substring(2)),g=g?u:n,p=new kc(g),p=(new lb(p,c,g)).parse(d),p.constant?p.$$watchDelegate=m:q?(p=e(p),p.$$watchDelegate=p.literal?k:l):p.inputs&&(p.$$watchDelegate=h),B[s]=p);return r(p,f);
case "function":return r(d,f);default:return r(A,f)}}}]}function Ve(){this.$get=["$rootScope","$exceptionHandler",function(b,a){return kd(function(a){b.$evalAsync(a)},a)}]}function We(){this.$get=["$browser","$exceptionHandler",function(b,a){return kd(function(a){b.defer(a)},a)}]}function kd(b,a){function c(a,b,c){function d(b){return function(c){e||(e=!0,b.call(a,c))}}var e=!1;return[d(b),d(c)]}function d(){this.$$state={status:0}}function e(a,b){return function(c){b.call(a,c)}}function f(c){!c.processScheduled&&
c.pending&&(c.processScheduled=!0,b(function(){var b,d,e;e=c.pending;c.processScheduled=!1;c.pending=s;for(var f=0,g=e.length;f<g;++f){d=e[f][0];b=e[f][c.status];try{E(b)?d.resolve(b(c.value)):1===c.status?d.resolve(c.value):d.reject(c.value)}catch(h){d.reject(h),a(h)}}}))}function g(){this.promise=new d;this.resolve=e(this,this.resolve);this.reject=e(this,this.reject);this.notify=e(this,this.notify)}var h=F("$q",TypeError);d.prototype={then:function(a,b,c){var d=new g;this.$$state.pending=this.$$state.pending||
[];this.$$state.pending.push([d,a,b,c]);0<this.$$state.status&&f(this.$$state);return d.promise},"catch":function(a){return this.then(null,a)},"finally":function(a,b){return this.then(function(b){return k(b,!0,a)},function(b){return k(b,!1,a)},b)}};g.prototype={resolve:function(a){this.promise.$$state.status||(a===this.promise?this.$$reject(h("qcycle",a)):this.$$resolve(a))},$$resolve:function(b){var d,e;e=c(this,this.$$resolve,this.$$reject);try{if(I(b)||E(b))d=b&&b.then;E(d)?(this.promise.$$state.status=
-1,d.call(b,e[0],e[1],this.notify)):(this.promise.$$state.value=b,this.promise.$$state.status=1,f(this.promise.$$state))}catch(g){e[1](g),a(g)}},reject:function(a){this.promise.$$state.status||this.$$reject(a)},$$reject:function(a){this.promise.$$state.value=a;this.promise.$$state.status=2;f(this.promise.$$state)},notify:function(c){var d=this.promise.$$state.pending;0>=this.promise.$$state.status&&d&&d.length&&b(function(){for(var b,e,f=0,g=d.length;f<g;f++){e=d[f][0];b=d[f][3];try{e.notify(E(b)?
b(c):c)}catch(h){a(h)}}})}};var l=function(a,b){var c=new g;b?c.resolve(a):c.reject(a);return c.promise},k=function(a,b,c){var d=null;try{E(c)&&(d=c())}catch(e){return l(e,!1)}return d&&E(d.then)?d.then(function(){return l(a,b)},function(a){return l(a,!1)}):l(a,b)},m=function(a,b,c,d){var e=new g;e.resolve(a);return e.promise.then(b,c,d)},r=function u(a){if(!E(a))throw h("norslvr",a);if(!(this instanceof u))return new u(a);var b=new g;a(function(a){b.resolve(a)},function(a){b.reject(a)});return b.promise};
r.defer=function(){return new g};r.reject=function(a){var b=new g;b.reject(a);return b.promise};r.when=m;r.all=function(a){var b=new g,c=0,d=w(a)?[]:{};q(a,function(a,e){c++;m(a).then(function(a){d.hasOwnProperty(e)||(d[e]=a,--c||b.resolve(d))},function(a){d.hasOwnProperty(e)||b.reject(a)})});0===c&&b.resolve(d);return b.promise};return r}function ef(){this.$get=["$window","$timeout",function(b,a){function c(){for(var a=0;a<m.length;a++){var b=m[a];b&&(m[a]=null,b())}k=m.length=0}function d(a){var b=
m.length;k++;m.push(a);0===b&&(l=h(c));return function(){0<=b&&(b=m[b]=null,0===--k&&l&&(l(),l=null,m.length=0))}}var e=b.requestAnimationFrame||b.webkitRequestAnimationFrame,f=b.cancelAnimationFrame||b.webkitCancelAnimationFrame||b.webkitCancelRequestAnimationFrame,g=!!e,h=g?function(a){var b=e(a);return function(){f(b)}}:function(b){var c=a(b,16.66,!1);return function(){a.cancel(c)}};d.supported=g;var l,k=0,m=[];return d}]}function Ue(){function b(a){function b(){this.$$watchers=this.$$nextSibling=
this.$$childHead=this.$$childTail=null;this.$$listeners={};this.$$listenerCount={};this.$id=++rb;this.$$ChildScope=null}b.prototype=a;return b}var a=10,c=F("$rootScope"),d=null,e=null;this.digestTtl=function(b){arguments.length&&(a=b);return a};this.$get=["$injector","$exceptionHandler","$parse","$browser",function(f,g,h,l){function k(a){a.currentScope.$$destroyed=!0}function m(){this.$id=++rb;this.$$phase=this.$parent=this.$$watchers=this.$$nextSibling=this.$$prevSibling=this.$$childHead=this.$$childTail=
null;this.$root=this;this.$$destroyed=!1;this.$$listeners={};this.$$listenerCount={};this.$$isolateBindings=null}function r(a){if(t.$$phase)throw c("inprog",t.$$phase);t.$$phase=a}function n(a,b,c){do a.$$listenerCount[c]-=b,0===a.$$listenerCount[c]&&delete a.$$listenerCount[c];while(a=a.$parent)}function u(){}function v(){for(;J.length;)try{J.shift()()}catch(a){g(a)}e=null}function s(){null===e&&(e=l.defer(function(){t.$apply(v)}))}m.prototype={constructor:m,$new:function(a,c){var d;c=c||this;a?
(d=new m,d.$root=this.$root):(this.$$ChildScope||(this.$$ChildScope=b(this)),d=new this.$$ChildScope);d.$parent=c;d.$$prevSibling=c.$$childTail;c.$$childHead?(c.$$childTail.$$nextSibling=d,c.$$childTail=d):c.$$childHead=c.$$childTail=d;(a||c!=this)&&d.$on("$destroy",k);return d},$watch:function(a,b,c){var e=h(a);if(e.$$watchDelegate)return e.$$watchDelegate(this,b,c,e);var f=this.$$watchers,g={fn:b,last:u,get:e,exp:a,eq:!!c};d=null;E(b)||(g.fn=A);f||(f=this.$$watchers=[]);f.unshift(g);return function(){Xa(f,
g);d=null}},$watchGroup:function(a,b){function c(){h=!1;l?(l=!1,b(e,e,g)):b(e,d,g)}var d=Array(a.length),e=Array(a.length),f=[],g=this,h=!1,l=!0;if(!a.length){var k=!0;g.$evalAsync(function(){k&&b(e,e,g)});return function(){k=!1}}if(1===a.length)return this.$watch(a[0],function(a,c,f){e[0]=a;d[0]=c;b(e,a===c?e:d,f)});q(a,function(a,b){var l=g.$watch(a,function(a,f){e[b]=a;d[b]=f;h||(h=!0,g.$evalAsync(c))});f.push(l)});return function(){for(;f.length;)f.shift()()}},$watchCollection:function(a,b){function c(a){e=
a;var b,d,g,h;if(!C(e)){if(I(e))if(Sa(e))for(f!==n&&(f=n,u=f.length=0,k++),a=e.length,u!==a&&(k++,f.length=u=a),b=0;b<a;b++)h=f[b],g=e[b],d=h!==h&&g!==g,d||h===g||(k++,f[b]=g);else{f!==r&&(f=r={},u=0,k++);a=0;for(b in e)e.hasOwnProperty(b)&&(a++,g=e[b],h=f[b],b in f?(d=h!==h&&g!==g,d||h===g||(k++,f[b]=g)):(u++,f[b]=g,k++));if(u>a)for(b in k++,f)e.hasOwnProperty(b)||(u--,delete f[b])}else f!==e&&(f=e,k++);return k}}c.$stateful=!0;var d=this,e,f,g,l=1<b.length,k=0,m=h(a,c),n=[],r={},p=!0,u=0;return this.$watch(m,
function(){p?(p=!1,b(e,e,d)):b(e,g,d);if(l)if(I(e))if(Sa(e)){g=Array(e.length);for(var a=0;a<e.length;a++)g[a]=e[a]}else for(a in g={},e)wc.call(e,a)&&(g[a]=e[a]);else g=e})},$digest:function(){var b,f,h,k,m,n,q=a,s,S=[],P,J;r("$digest");l.$$checkUrlChange();this===t&&null!==e&&(l.defer.cancel(e),v());d=null;do{n=!1;for(s=this;p.length;){try{J=p.shift(),J.scope.$eval(J.expression,J.locals)}catch(y){g(y)}d=null}a:do{if(k=s.$$watchers)for(m=k.length;m--;)try{if(b=k[m])if((f=b.get(s))!==(h=b.last)&&
!(b.eq?fa(f,h):"number"===typeof f&&"number"===typeof h&&isNaN(f)&&isNaN(h)))n=!0,d=b,b.last=b.eq?Ba(f,null):f,b.fn(f,h===u?f:h,s),5>q&&(P=4-q,S[P]||(S[P]=[]),S[P].push({msg:E(b.exp)?"fn: "+(b.exp.name||b.exp.toString()):b.exp,newVal:f,oldVal:h}));else if(b===d){n=!1;break a}}catch(F){g(F)}if(!(k=s.$$childHead||s!==this&&s.$$nextSibling))for(;s!==this&&!(k=s.$$nextSibling);)s=s.$parent}while(s=k);if((n||p.length)&&!q--)throw t.$$phase=null,c("infdig",a,S);}while(n||p.length);for(t.$$phase=null;H.length;)try{H.shift()()}catch(x){g(x)}},
$destroy:function(){if(!this.$$destroyed){var a=this.$parent;this.$broadcast("$destroy");this.$$destroyed=!0;if(this!==t){for(var b in this.$$listenerCount)n(this,this.$$listenerCount[b],b);a.$$childHead==this&&(a.$$childHead=this.$$nextSibling);a.$$childTail==this&&(a.$$childTail=this.$$prevSibling);this.$$prevSibling&&(this.$$prevSibling.$$nextSibling=this.$$nextSibling);this.$$nextSibling&&(this.$$nextSibling.$$prevSibling=this.$$prevSibling);this.$destroy=this.$digest=this.$apply=this.$evalAsync=
this.$applyAsync=A;this.$on=this.$watch=this.$watchGroup=function(){return A};this.$$listeners={};this.$parent=this.$$nextSibling=this.$$prevSibling=this.$$childHead=this.$$childTail=this.$root=this.$$watchers=null}}},$eval:function(a,b){return h(a)(this,b)},$evalAsync:function(a,b){t.$$phase||p.length||l.defer(function(){p.length&&t.$digest()});p.push({scope:this,expression:a,locals:b})},$$postDigest:function(a){H.push(a)},$apply:function(a){try{return r("$apply"),this.$eval(a)}catch(b){g(b)}finally{t.$$phase=
null;try{t.$digest()}catch(c){throw g(c),c;}}},$applyAsync:function(a){function b(){c.$eval(a)}var c=this;a&&J.push(b);s()},$on:function(a,b){var c=this.$$listeners[a];c||(this.$$listeners[a]=c=[]);c.push(b);var d=this;do d.$$listenerCount[a]||(d.$$listenerCount[a]=0),d.$$listenerCount[a]++;while(d=d.$parent);var e=this;return function(){var d=c.indexOf(b);-1!==d&&(c[d]=null,n(e,1,a))}},$emit:function(a,b){var c=[],d,e=this,f=!1,h={name:a,targetScope:e,stopPropagation:function(){f=!0},preventDefault:function(){h.defaultPrevented=
!0},defaultPrevented:!1},l=Ya([h],arguments,1),k,m;do{d=e.$$listeners[a]||c;h.currentScope=e;k=0;for(m=d.length;k<m;k++)if(d[k])try{d[k].apply(null,l)}catch(n){g(n)}else d.splice(k,1),k--,m--;if(f)return h.currentScope=null,h;e=e.$parent}while(e);h.currentScope=null;return h},$broadcast:function(a,b){var c=this,d=this,e={name:a,targetScope:this,preventDefault:function(){e.defaultPrevented=!0},defaultPrevented:!1};if(!this.$$listenerCount[a])return e;for(var f=Ya([e],arguments,1),h,l;c=d;){e.currentScope=
c;d=c.$$listeners[a]||[];h=0;for(l=d.length;h<l;h++)if(d[h])try{d[h].apply(null,f)}catch(k){g(k)}else d.splice(h,1),h--,l--;if(!(d=c.$$listenerCount[a]&&c.$$childHead||c!==this&&c.$$nextSibling))for(;c!==this&&!(d=c.$$nextSibling);)c=c.$parent}e.currentScope=null;return e}};var t=new m,p=t.$$asyncQueue=[],H=t.$$postDigestQueue=[],J=t.$$applyAsyncQueue=[];return t}]}function Xd(){var b=/^\s*(https?|ftp|mailto|tel|file):/,a=/^\s*((https?|ftp|file|blob):|data:image\/)/;this.aHrefSanitizationWhitelist=
function(a){return y(a)?(b=a,this):b};this.imgSrcSanitizationWhitelist=function(b){return y(b)?(a=b,this):a};this.$get=function(){return function(c,d){var e=d?a:b,f;f=ya(c).href;return""===f||f.match(e)?c:"unsafe:"+f}}}function Hf(b){if("self"===b)return b;if(O(b)){if(-1<b.indexOf("***"))throw za("iwcard",b);b=ld(b).replace("\\*\\*",".*").replace("\\*","[^:/.?&;]*");return new RegExp("^"+b+"$")}if(Ua(b))return new RegExp("^"+b.source+"$");throw za("imatcher");}function md(b){var a=[];y(b)&&q(b,function(b){a.push(Hf(b))});
return a}function Ye(){this.SCE_CONTEXTS=la;var b=["self"],a=[];this.resourceUrlWhitelist=function(a){arguments.length&&(b=md(a));return b};this.resourceUrlBlacklist=function(b){arguments.length&&(a=md(b));return a};this.$get=["$injector",function(c){function d(a,b){return"self"===a?ed(b):!!a.exec(b.href)}function e(a){var b=function(a){this.$$unwrapTrustedValue=function(){return a}};a&&(b.prototype=new a);b.prototype.valueOf=function(){return this.$$unwrapTrustedValue()};b.prototype.toString=function(){return this.$$unwrapTrustedValue().toString()};
return b}var f=function(a){throw za("unsafe");};c.has("$sanitize")&&(f=c.get("$sanitize"));var g=e(),h={};h[la.HTML]=e(g);h[la.CSS]=e(g);h[la.URL]=e(g);h[la.JS]=e(g);h[la.RESOURCE_URL]=e(h[la.URL]);return{trustAs:function(a,b){var c=h.hasOwnProperty(a)?h[a]:null;if(!c)throw za("icontext",a,b);if(null===b||b===s||""===b)return b;if("string"!==typeof b)throw za("itype",a);return new c(b)},getTrusted:function(c,e){if(null===e||e===s||""===e)return e;var g=h.hasOwnProperty(c)?h[c]:null;if(g&&e instanceof
g)return e.$$unwrapTrustedValue();if(c===la.RESOURCE_URL){var g=ya(e.toString()),r,n,u=!1;r=0;for(n=b.length;r<n;r++)if(d(b[r],g)){u=!0;break}if(u)for(r=0,n=a.length;r<n;r++)if(d(a[r],g)){u=!1;break}if(u)return e;throw za("insecurl",e.toString());}if(c===la.HTML)return f(e);throw za("unsafe");},valueOf:function(a){return a instanceof g?a.$$unwrapTrustedValue():a}}}]}function Xe(){var b=!0;this.enabled=function(a){arguments.length&&(b=!!a);return b};this.$get=["$parse","$sceDelegate",function(a,c){if(b&&
8>Qa)throw za("iequirks");var d=oa(la);d.isEnabled=function(){return b};d.trustAs=c.trustAs;d.getTrusted=c.getTrusted;d.valueOf=c.valueOf;b||(d.trustAs=d.getTrusted=function(a,b){return b},d.valueOf=na);d.parseAs=function(b,c){var e=a(c);return e.literal&&e.constant?e:a(c,function(a){return d.getTrusted(b,a)})};var e=d.parseAs,f=d.getTrusted,g=d.trustAs;q(la,function(a,b){var c=L(b);d[eb("parse_as_"+c)]=function(b){return e(a,b)};d[eb("get_trusted_"+c)]=function(b){return f(a,b)};d[eb("trust_as_"+
c)]=function(b){return g(a,b)}});return d}]}function Ze(){this.$get=["$window","$document",function(b,a){var c={},d=aa((/android (\d+)/.exec(L((b.navigator||{}).userAgent))||[])[1]),e=/Boxee/i.test((b.navigator||{}).userAgent),f=a[0]||{},g,h=/^(Moz|webkit|ms)(?=[A-Z])/,l=f.body&&f.body.style,k=!1,m=!1;if(l){for(var r in l)if(k=h.exec(r)){g=k[0];g=g.substr(0,1).toUpperCase()+g.substr(1);break}g||(g="WebkitOpacity"in l&&"webkit");k=!!("transition"in l||g+"Transition"in l);m=!!("animation"in l||g+"Animation"in
l);!d||k&&m||(k=O(f.body.style.webkitTransition),m=O(f.body.style.webkitAnimation))}return{history:!(!b.history||!b.history.pushState||4>d||e),hasEvent:function(a){if("input"===a&&11>=Qa)return!1;if(C(c[a])){var b=f.createElement("div");c[a]="on"+a in b}return c[a]},csp:cb(),vendorPrefix:g,transitions:k,animations:m,android:d}}]}function af(){this.$get=["$templateCache","$http","$q",function(b,a,c){function d(e,f){d.totalPendingRequests++;var g=a.defaults&&a.defaults.transformResponse;w(g)?g=g.filter(function(a){return a!==
bc}):g===bc&&(g=null);return a.get(e,{cache:b,transformResponse:g})["finally"](function(){d.totalPendingRequests--}).then(function(a){return a.data},function(a){if(!f)throw da("tpload",e);return c.reject(a)})}d.totalPendingRequests=0;return d}]}function bf(){this.$get=["$rootScope","$browser","$location",function(b,a,c){return{findBindings:function(a,b,c){a=a.getElementsByClassName("ng-binding");var g=[];q(a,function(a){var d=ba.element(a).data("$binding");d&&q(d,function(d){c?(new RegExp("(^|\\s)"+
ld(b)+"(\\s|\\||$)")).test(d)&&g.push(a):-1!=d.indexOf(b)&&g.push(a)})});return g},findModels:function(a,b,c){for(var g=["ng-","data-ng-","ng\\:"],h=0;h<g.length;++h){var l=a.querySelectorAll("["+g[h]+"model"+(c?"=":"*=")+'"'+b+'"]');if(l.length)return l}},getLocation:function(){return c.url()},setLocation:function(a){a!==c.url()&&(c.url(a),b.$digest())},whenStable:function(b){a.notifyWhenNoOutstandingRequests(b)}}}]}function cf(){this.$get=["$rootScope","$browser","$q","$$q","$exceptionHandler",
function(b,a,c,d,e){function f(f,l,k){var m=y(k)&&!k,r=(m?d:c).defer(),n=r.promise;l=a.defer(function(){try{r.resolve(f())}catch(a){r.reject(a),e(a)}finally{delete g[n.$$timeoutId]}m||b.$apply()},l);n.$$timeoutId=l;g[l]=r;return n}var g={};f.cancel=function(b){return b&&b.$$timeoutId in g?(g[b.$$timeoutId].reject("canceled"),delete g[b.$$timeoutId],a.defer.cancel(b.$$timeoutId)):!1};return f}]}function ya(b){Qa&&(X.setAttribute("href",b),b=X.href);X.setAttribute("href",b);return{href:X.href,protocol:X.protocol?
X.protocol.replace(/:$/,""):"",host:X.host,search:X.search?X.search.replace(/^\?/,""):"",hash:X.hash?X.hash.replace(/^#/,""):"",hostname:X.hostname,port:X.port,pathname:"/"===X.pathname.charAt(0)?X.pathname:"/"+X.pathname}}function ed(b){b=O(b)?ya(b):b;return b.protocol===nd.protocol&&b.host===nd.host}function df(){this.$get=ca(T)}function Ic(b){function a(c,d){if(I(c)){var e={};q(c,function(b,c){e[c]=a(c,b)});return e}return b.factory(c+"Filter",d)}this.register=a;this.$get=["$injector",function(a){return function(b){return a.get(b+
"Filter")}}];a("currency",od);a("date",pd);a("filter",If);a("json",Jf);a("limitTo",Kf);a("lowercase",Lf);a("number",qd);a("orderBy",rd);a("uppercase",Mf)}function If(){return function(b,a,c){if(!w(b))return b;var d;switch(null!==a?typeof a:"null"){case "function":break;case "boolean":case "null":case "number":case "string":d=!0;case "object":a=Nf(a,c,d);break;default:return b}return b.filter(a)}}function Nf(b,a,c){var d=I(b)&&"$"in b;!0===a?a=fa:E(a)||(a=function(a,b){if(C(a))return!1;if(null===a||
null===b)return a===b;if(I(a)||I(b))return!1;a=L(""+a);b=L(""+b);return-1!==a.indexOf(b)});return function(e){return d&&!I(e)?Ha(e,b.$,a,!1):Ha(e,b,a,c)}}function Ha(b,a,c,d,e){var f=null!==b?typeof b:"null",g=null!==a?typeof a:"null";if("string"===g&&"!"===a.charAt(0))return!Ha(b,a.substring(1),c,d);if(w(b))return b.some(function(b){return Ha(b,a,c,d)});switch(f){case "object":var h;if(d){for(h in b)if("$"!==h.charAt(0)&&Ha(b[h],a,c,!0))return!0;return e?!1:Ha(b,a,c,!1)}if("object"===g){for(h in a)if(e=
a[h],!E(e)&&!C(e)&&(f="$"===h,!Ha(f?b:b[h],e,c,f,f)))return!1;return!0}return c(b,a);case "function":return!1;default:return c(b,a)}}function od(b){var a=b.NUMBER_FORMATS;return function(b,d,e){C(d)&&(d=a.CURRENCY_SYM);C(e)&&(e=a.PATTERNS[1].maxFrac);return null==b?b:sd(b,a.PATTERNS[1],a.GROUP_SEP,a.DECIMAL_SEP,e).replace(/\u00A4/g,d)}}function qd(b){var a=b.NUMBER_FORMATS;return function(b,d){return null==b?b:sd(b,a.PATTERNS[0],a.GROUP_SEP,a.DECIMAL_SEP,d)}}function sd(b,a,c,d,e){if(!isFinite(b)||
I(b))return"";var f=0>b;b=Math.abs(b);var g=b+"",h="",l=[],k=!1;if(-1!==g.indexOf("e")){var m=g.match(/([\d\.]+)e(-?)(\d+)/);m&&"-"==m[2]&&m[3]>e+1?b=0:(h=g,k=!0)}if(k)0<e&&1>b&&(h=b.toFixed(e),b=parseFloat(h));else{g=(g.split(td)[1]||"").length;C(e)&&(e=Math.min(Math.max(a.minFrac,g),a.maxFrac));b=+(Math.round(+(b.toString()+"e"+e)).toString()+"e"+-e);var g=(""+b).split(td),k=g[0],g=g[1]||"",r=0,n=a.lgSize,u=a.gSize;if(k.length>=n+u)for(r=k.length-n,m=0;m<r;m++)0===(r-m)%u&&0!==m&&(h+=c),h+=k.charAt(m);
for(m=r;m<k.length;m++)0===(k.length-m)%n&&0!==m&&(h+=c),h+=k.charAt(m);for(;g.length<e;)g+="0";e&&"0"!==e&&(h+=d+g.substr(0,e))}0===b&&(f=!1);l.push(f?a.negPre:a.posPre,h,f?a.negSuf:a.posSuf);return l.join("")}function Jb(b,a,c){var d="";0>b&&(d="-",b=-b);for(b=""+b;b.length<a;)b="0"+b;c&&(b=b.substr(b.length-a));return d+b}function Z(b,a,c,d){c=c||0;return function(e){e=e["get"+b]();if(0<c||e>-c)e+=c;0===e&&-12==c&&(e=12);return Jb(e,a,d)}}function Kb(b,a){return function(c,d){var e=c["get"+b](),
f=vb(a?"SHORT"+b:b);return d[f][e]}}function ud(b){var a=(new Date(b,0,1)).getDay();return new Date(b,0,(4>=a?5:12)-a)}function vd(b){return function(a){var c=ud(a.getFullYear());a=+new Date(a.getFullYear(),a.getMonth(),a.getDate()+(4-a.getDay()))-+c;a=1+Math.round(a/6048E5);return Jb(a,b)}}function lc(b,a){return 0>=b.getFullYear()?a.ERAS[0]:a.ERAS[1]}function pd(b){function a(a){var b;if(b=a.match(c)){a=new Date(0);var f=0,g=0,h=b[8]?a.setUTCFullYear:a.setFullYear,l=b[8]?a.setUTCHours:a.setHours;
b[9]&&(f=aa(b[9]+b[10]),g=aa(b[9]+b[11]));h.call(a,aa(b[1]),aa(b[2])-1,aa(b[3]));f=aa(b[4]||0)-f;g=aa(b[5]||0)-g;h=aa(b[6]||0);b=Math.round(1E3*parseFloat("0."+(b[7]||0)));l.call(a,f,g,h,b)}return a}var c=/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;return function(c,e,f){var g="",h=[],l,k;e=e||"mediumDate";e=b.DATETIME_FORMATS[e]||e;O(c)&&(c=Of.test(c)?aa(c):a(c));Q(c)&&(c=new Date(c));if(!ea(c))return c;for(;e;)(k=Pf.exec(e))?(h=Ya(h,k,1),
e=h.pop()):(h.push(e),e=null);f&&"UTC"===f&&(c=new Date(c.getTime()),c.setMinutes(c.getMinutes()+c.getTimezoneOffset()));q(h,function(a){l=Qf[a];g+=l?l(c,b.DATETIME_FORMATS):a.replace(/(^'|'$)/g,"").replace(/''/g,"'")});return g}}function Jf(){return function(b,a){C(a)&&(a=2);return $a(b,a)}}function Kf(){return function(b,a){Q(b)&&(b=b.toString());return w(b)||O(b)?(a=Infinity===Math.abs(Number(a))?Number(a):aa(a))?0<a?b.slice(0,a):b.slice(a):O(b)?"":[]:b}}function rd(b){return function(a,c,d){function e(a,
b){return b?function(b,c){return a(c,b)}:a}function f(a){switch(typeof a){case "number":case "boolean":case "string":return!0;default:return!1}}function g(a){return null===a?"null":"function"===typeof a.valueOf&&(a=a.valueOf(),f(a))||"function"===typeof a.toString&&(a=a.toString(),f(a))?a:""}function h(a,b){var c=typeof a,d=typeof b;c===d&&"object"===c&&(a=g(a),b=g(b));return c===d?("string"===c&&(a=a.toLowerCase(),b=b.toLowerCase()),a===b?0:a<b?-1:1):c<d?-1:1}if(!Sa(a))return a;c=w(c)?c:[c];0===
c.length&&(c=["+"]);c=c.map(function(a){var c=!1,d=a||na;if(O(a)){if("+"==a.charAt(0)||"-"==a.charAt(0))c="-"==a.charAt(0),a=a.substring(1);if(""===a)return e(h,c);d=b(a);if(d.constant){var f=d();return e(function(a,b){return h(a[f],b[f])},c)}}return e(function(a,b){return h(d(a),d(b))},c)});return Za.call(a).sort(e(function(a,b){for(var d=0;d<c.length;d++){var e=c[d](a,b);if(0!==e)return e}return 0},d))}}function Ia(b){E(b)&&(b={link:b});b.restrict=b.restrict||"AC";return ca(b)}function wd(b,a,c,
d,e){var f=this,g=[],h=f.$$parentForm=b.parent().controller("form")||Lb;f.$error={};f.$$success={};f.$pending=s;f.$name=e(a.name||a.ngForm||"")(c);f.$dirty=!1;f.$pristine=!0;f.$valid=!0;f.$invalid=!1;f.$submitted=!1;h.$addControl(f);f.$rollbackViewValue=function(){q(g,function(a){a.$rollbackViewValue()})};f.$commitViewValue=function(){q(g,function(a){a.$commitViewValue()})};f.$addControl=function(a){Ma(a.$name,"input");g.push(a);a.$name&&(f[a.$name]=a)};f.$$renameControl=function(a,b){var c=a.$name;
f[c]===a&&delete f[c];f[b]=a;a.$name=b};f.$removeControl=function(a){a.$name&&f[a.$name]===a&&delete f[a.$name];q(f.$pending,function(b,c){f.$setValidity(c,null,a)});q(f.$error,function(b,c){f.$setValidity(c,null,a)});q(f.$$success,function(b,c){f.$setValidity(c,null,a)});Xa(g,a)};xd({ctrl:this,$element:b,set:function(a,b,c){var d=a[b];d?-1===d.indexOf(c)&&d.push(c):a[b]=[c]},unset:function(a,b,c){var d=a[b];d&&(Xa(d,c),0===d.length&&delete a[b])},parentForm:h,$animate:d});f.$setDirty=function(){d.removeClass(b,
Ra);d.addClass(b,Mb);f.$dirty=!0;f.$pristine=!1;h.$setDirty()};f.$setPristine=function(){d.setClass(b,Ra,Mb+" ng-submitted");f.$dirty=!1;f.$pristine=!0;f.$submitted=!1;q(g,function(a){a.$setPristine()})};f.$setUntouched=function(){q(g,function(a){a.$setUntouched()})};f.$setSubmitted=function(){d.addClass(b,"ng-submitted");f.$submitted=!0;h.$setSubmitted()}}function mc(b){b.$formatters.push(function(a){return b.$isEmpty(a)?a:a.toString()})}function mb(b,a,c,d,e,f){var g=L(a[0].type);if(!e.android){var h=
!1;a.on("compositionstart",function(a){h=!0});a.on("compositionend",function(){h=!1;l()})}var l=function(b){k&&(f.defer.cancel(k),k=null);if(!h){var e=a.val();b=b&&b.type;"password"===g||c.ngTrim&&"false"===c.ngTrim||(e=U(e));(d.$viewValue!==e||""===e&&d.$$hasNativeValidators)&&d.$setViewValue(e,b)}};if(e.hasEvent("input"))a.on("input",l);else{var k,m=function(a,b,c){k||(k=f.defer(function(){k=null;b&&b.value===c||l(a)}))};a.on("keydown",function(a){var b=a.keyCode;91===b||15<b&&19>b||37<=b&&40>=
b||m(a,this,this.value)});if(e.hasEvent("paste"))a.on("paste cut",m)}a.on("change",l);d.$render=function(){a.val(d.$isEmpty(d.$viewValue)?"":d.$viewValue)}}function Nb(b,a){return function(c,d){var e,f;if(ea(c))return c;if(O(c)){'"'==c.charAt(0)&&'"'==c.charAt(c.length-1)&&(c=c.substring(1,c.length-1));if(Rf.test(c))return new Date(c);b.lastIndex=0;if(e=b.exec(c))return e.shift(),f=d?{yyyy:d.getFullYear(),MM:d.getMonth()+1,dd:d.getDate(),HH:d.getHours(),mm:d.getMinutes(),ss:d.getSeconds(),sss:d.getMilliseconds()/
1E3}:{yyyy:1970,MM:1,dd:1,HH:0,mm:0,ss:0,sss:0},q(e,function(b,c){c<a.length&&(f[a[c]]=+b)}),new Date(f.yyyy,f.MM-1,f.dd,f.HH,f.mm,f.ss||0,1E3*f.sss||0)}return NaN}}function nb(b,a,c,d){return function(e,f,g,h,l,k,m){function r(a){return a&&!(a.getTime&&a.getTime()!==a.getTime())}function n(a){return y(a)?ea(a)?a:c(a):s}yd(e,f,g,h);mb(e,f,g,h,l,k);var u=h&&h.$options&&h.$options.timezone,v;h.$$parserName=b;h.$parsers.push(function(b){return h.$isEmpty(b)?null:a.test(b)?(b=c(b,v),"UTC"===u&&b.setMinutes(b.getMinutes()-
b.getTimezoneOffset()),b):s});h.$formatters.push(function(a){if(a&&!ea(a))throw Ob("datefmt",a);if(r(a)){if((v=a)&&"UTC"===u){var b=6E4*v.getTimezoneOffset();v=new Date(v.getTime()+b)}return m("date")(a,d,u)}v=null;return""});if(y(g.min)||g.ngMin){var q;h.$validators.min=function(a){return!r(a)||C(q)||c(a)>=q};g.$observe("min",function(a){q=n(a);h.$validate()})}if(y(g.max)||g.ngMax){var t;h.$validators.max=function(a){return!r(a)||C(t)||c(a)<=t};g.$observe("max",function(a){t=n(a);h.$validate()})}}}
function yd(b,a,c,d){(d.$$hasNativeValidators=I(a[0].validity))&&d.$parsers.push(function(b){var c=a.prop("validity")||{};return c.badInput&&!c.typeMismatch?s:b})}function zd(b,a,c,d,e){if(y(d)){b=b(d);if(!b.constant)throw F("ngModel")("constexpr",c,d);return b(a)}return e}function nc(b,a){b="ngClass"+b;return["$animate",function(c){function d(a,b){var c=[],d=0;a:for(;d<a.length;d++){for(var e=a[d],m=0;m<b.length;m++)if(e==b[m])continue a;c.push(e)}return c}function e(a){if(!w(a)){if(O(a))return a.split(" ");
if(I(a)){var b=[];q(a,function(a,c){a&&(b=b.concat(c.split(" ")))});return b}}return a}return{restrict:"AC",link:function(f,g,h){function l(a,b){var c=g.data("$classCounts")||{},d=[];q(a,function(a){if(0<b||c[a])c[a]=(c[a]||0)+b,c[a]===+(0<b)&&d.push(a)});g.data("$classCounts",c);return d.join(" ")}function k(b){if(!0===a||f.$index%2===a){var k=e(b||[]);if(!m){var u=l(k,1);h.$addClass(u)}else if(!fa(b,m)){var q=e(m),u=d(k,q),k=d(q,k),u=l(u,1),k=l(k,-1);u&&u.length&&c.addClass(g,u);k&&k.length&&c.removeClass(g,
k)}}m=oa(b)}var m;f.$watch(h[b],k,!0);h.$observe("class",function(a){k(f.$eval(h[b]))});"ngClass"!==b&&f.$watch("$index",function(c,d){var g=c&1;if(g!==(d&1)){var k=e(f.$eval(h[b]));g===a?(g=l(k,1),h.$addClass(g)):(g=l(k,-1),h.$removeClass(g))}})}}}]}function xd(b){function a(a,b){b&&!f[a]?(k.addClass(e,a),f[a]=!0):!b&&f[a]&&(k.removeClass(e,a),f[a]=!1)}function c(b,c){b=b?"-"+yc(b,"-"):"";a(ob+b,!0===c);a(Ad+b,!1===c)}var d=b.ctrl,e=b.$element,f={},g=b.set,h=b.unset,l=b.parentForm,k=b.$animate;f[Ad]=
!(f[ob]=e.hasClass(ob));d.$setValidity=function(b,e,f){e===s?(d.$pending||(d.$pending={}),g(d.$pending,b,f)):(d.$pending&&h(d.$pending,b,f),Bd(d.$pending)&&(d.$pending=s));Wa(e)?e?(h(d.$error,b,f),g(d.$$success,b,f)):(g(d.$error,b,f),h(d.$$success,b,f)):(h(d.$error,b,f),h(d.$$success,b,f));d.$pending?(a(Cd,!0),d.$valid=d.$invalid=s,c("",null)):(a(Cd,!1),d.$valid=Bd(d.$error),d.$invalid=!d.$valid,c("",d.$valid));e=d.$pending&&d.$pending[b]?s:d.$error[b]?!1:d.$$success[b]?!0:null;c(b,e);l.$setValidity(b,
e,d)}}function Bd(b){if(b)for(var a in b)return!1;return!0}var Sf=/^\/(.+)\/([a-z]*)$/,L=function(b){return O(b)?b.toLowerCase():b},wc=Object.prototype.hasOwnProperty,vb=function(b){return O(b)?b.toUpperCase():b},Qa,z,pa,Za=[].slice,uf=[].splice,Tf=[].push,Aa=Object.prototype.toString,Ja=F("ng"),ba=T.angular||(T.angular={}),db,rb=0;Qa=V.documentMode;A.$inject=[];na.$inject=[];var w=Array.isArray,U=function(b){return O(b)?b.trim():b},ld=function(b){return b.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,
"\\$1").replace(/\x08/g,"\\x08")},cb=function(){if(y(cb.isActive_))return cb.isActive_;var b=!(!V.querySelector("[ng-csp]")&&!V.querySelector("[data-ng-csp]"));if(!b)try{new Function("")}catch(a){b=!0}return cb.isActive_=b},tb=["ng-","data-ng-","ng:","x-ng-"],Rd=/[A-Z]/g,zc=!1,Rb,ma=1,ab=3,Vd={full:"1.3.16",major:1,minor:3,dot:16,codeName:"cookie-oatmealification"};R.expando="ng339";var Ab=R.cache={},nf=1;R._data=function(b){return this.cache[b[this.expando]]||{}};var hf=/([\:\-\_]+(.))/g,jf=/^moz([A-Z])/,
Uf={mouseleave:"mouseout",mouseenter:"mouseover"},Ub=F("jqLite"),mf=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,Tb=/<|&#?\w+;/,kf=/<([\w:]+)/,lf=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ha={option:[1,'<select multiple="multiple">',"</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ha.optgroup=ha.option;ha.tbody=ha.tfoot=ha.colgroup=
ha.caption=ha.thead;ha.th=ha.td;var Ka=R.prototype={ready:function(b){function a(){c||(c=!0,b())}var c=!1;"complete"===V.readyState?setTimeout(a):(this.on("DOMContentLoaded",a),R(T).on("load",a))},toString:function(){var b=[];q(this,function(a){b.push(""+a)});return"["+b.join(", ")+"]"},eq:function(b){return 0<=b?z(this[b]):z(this[this.length+b])},length:0,push:Tf,sort:[].sort,splice:[].splice},Fb={};q("multiple selected checked disabled readOnly required open".split(" "),function(b){Fb[L(b)]=b});
var Rc={};q("input select option textarea button form details".split(" "),function(b){Rc[b]=!0});var Sc={ngMinlength:"minlength",ngMaxlength:"maxlength",ngMin:"min",ngMax:"max",ngPattern:"pattern"};q({data:Wb,removeData:yb},function(b,a){R[a]=b});q({data:Wb,inheritedData:Eb,scope:function(b){return z.data(b,"$scope")||Eb(b.parentNode||b,["$isolateScope","$scope"])},isolateScope:function(b){return z.data(b,"$isolateScope")||z.data(b,"$isolateScopeNoTemplate")},controller:Nc,injector:function(b){return Eb(b,
"$injector")},removeAttr:function(b,a){b.removeAttribute(a)},hasClass:Bb,css:function(b,a,c){a=eb(a);if(y(c))b.style[a]=c;else return b.style[a]},attr:function(b,a,c){var d=b.nodeType;if(d!==ab&&2!==d&&8!==d)if(d=L(a),Fb[d])if(y(c))c?(b[a]=!0,b.setAttribute(a,d)):(b[a]=!1,b.removeAttribute(d));else return b[a]||(b.attributes.getNamedItem(a)||A).specified?d:s;else if(y(c))b.setAttribute(a,c);else if(b.getAttribute)return b=b.getAttribute(a,2),null===b?s:b},prop:function(b,a,c){if(y(c))b[a]=c;else return b[a]},
text:function(){function b(a,b){if(C(b)){var d=a.nodeType;return d===ma||d===ab?a.textContent:""}a.textContent=b}b.$dv="";return b}(),val:function(b,a){if(C(a)){if(b.multiple&&"select"===sa(b)){var c=[];q(b.options,function(a){a.selected&&c.push(a.value||a.text)});return 0===c.length?null:c}return b.value}b.value=a},html:function(b,a){if(C(a))return b.innerHTML;xb(b,!0);b.innerHTML=a},empty:Oc},function(b,a){R.prototype[a]=function(a,d){var e,f,g=this.length;if(b!==Oc&&(2==b.length&&b!==Bb&&b!==Nc?
a:d)===s){if(I(a)){for(e=0;e<g;e++)if(b===Wb)b(this[e],a);else for(f in a)b(this[e],f,a[f]);return this}e=b.$dv;g=e===s?Math.min(g,1):g;for(f=0;f<g;f++){var h=b(this[f],a,d);e=e?e+h:h}return e}for(e=0;e<g;e++)b(this[e],a,d);return this}});q({removeData:yb,on:function a(c,d,e,f){if(y(f))throw Ub("onargs");if(Jc(c)){var g=zb(c,!0);f=g.events;var h=g.handle;h||(h=g.handle=qf(c,f));for(var g=0<=d.indexOf(" ")?d.split(" "):[d],l=g.length;l--;){d=g[l];var k=f[d];k||(f[d]=[],"mouseenter"===d||"mouseleave"===
d?a(c,Uf[d],function(a){var c=a.relatedTarget;c&&(c===this||this.contains(c))||h(a,d)}):"$destroy"!==d&&c.addEventListener(d,h,!1),k=f[d]);k.push(e)}}},off:Mc,one:function(a,c,d){a=z(a);a.on(c,function f(){a.off(c,d);a.off(c,f)});a.on(c,d)},replaceWith:function(a,c){var d,e=a.parentNode;xb(a);q(new R(c),function(c){d?e.insertBefore(c,d.nextSibling):e.replaceChild(c,a);d=c})},children:function(a){var c=[];q(a.childNodes,function(a){a.nodeType===ma&&c.push(a)});return c},contents:function(a){return a.contentDocument||
a.childNodes||[]},append:function(a,c){var d=a.nodeType;if(d===ma||11===d){c=new R(c);for(var d=0,e=c.length;d<e;d++)a.appendChild(c[d])}},prepend:function(a,c){if(a.nodeType===ma){var d=a.firstChild;q(new R(c),function(c){a.insertBefore(c,d)})}},wrap:function(a,c){c=z(c).eq(0).clone()[0];var d=a.parentNode;d&&d.replaceChild(c,a);c.appendChild(a)},remove:Pc,detach:function(a){Pc(a,!0)},after:function(a,c){var d=a,e=a.parentNode;c=new R(c);for(var f=0,g=c.length;f<g;f++){var h=c[f];e.insertBefore(h,
d.nextSibling);d=h}},addClass:Db,removeClass:Cb,toggleClass:function(a,c,d){c&&q(c.split(" "),function(c){var f=d;C(f)&&(f=!Bb(a,c));(f?Db:Cb)(a,c)})},parent:function(a){return(a=a.parentNode)&&11!==a.nodeType?a:null},next:function(a){return a.nextElementSibling},find:function(a,c){return a.getElementsByTagName?a.getElementsByTagName(c):[]},clone:Vb,triggerHandler:function(a,c,d){var e,f,g=c.type||c,h=zb(a);if(h=(h=h&&h.events)&&h[g])e={preventDefault:function(){this.defaultPrevented=!0},isDefaultPrevented:function(){return!0===
this.defaultPrevented},stopImmediatePropagation:function(){this.immediatePropagationStopped=!0},isImmediatePropagationStopped:function(){return!0===this.immediatePropagationStopped},stopPropagation:A,type:g,target:a},c.type&&(e=x(e,c)),c=oa(h),f=d?[e].concat(d):[e],q(c,function(c){e.isImmediatePropagationStopped()||c.apply(a,f)})}},function(a,c){R.prototype[c]=function(c,e,f){for(var g,h=0,l=this.length;h<l;h++)C(g)?(g=a(this[h],c,e,f),y(g)&&(g=z(g))):Lc(g,a(this[h],c,e,f));return y(g)?g:this};R.prototype.bind=
R.prototype.on;R.prototype.unbind=R.prototype.off});fb.prototype={put:function(a,c){this[Na(a,this.nextUid)]=c},get:function(a){return this[Na(a,this.nextUid)]},remove:function(a){var c=this[a=Na(a,this.nextUid)];delete this[a];return c}};var Uc=/^function\s*[^\(]*\(\s*([^\)]*)\)/m,Vf=/,/,Wf=/^\s*(_?)(\S+?)\1\s*$/,Tc=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg,Da=F("$injector");bb.$$annotate=function(a,c,d){var e;if("function"===typeof a){if(!(e=a.$inject)){e=[];if(a.length){if(c)throw O(d)&&d||(d=a.name||
rf(a)),Da("strictdi",d);c=a.toString().replace(Tc,"");c=c.match(Uc);q(c[1].split(Vf),function(a){a.replace(Wf,function(a,c,d){e.push(d)})})}a.$inject=e}}else w(a)?(c=a.length-1,La(a[c],"fn"),e=a.slice(0,c)):La(a,"fn",!0);return e};var Xf=F("$animate"),He=["$provide",function(a){this.$$selectors={};this.register=function(c,d){var e=c+"-animation";if(c&&"."!=c.charAt(0))throw Xf("notcsel",c);this.$$selectors[c.substr(1)]=e;a.factory(e,d)};this.classNameFilter=function(a){1===arguments.length&&(this.$$classNameFilter=
a instanceof RegExp?a:null);return this.$$classNameFilter};this.$get=["$$q","$$asyncCallback","$rootScope",function(a,d,e){function f(d){var f,g=a.defer();g.promise.$$cancelFn=function(){f&&f()};e.$$postDigest(function(){f=d(function(){g.resolve()})});return g.promise}function g(a,c){var d=[],e=[],f=ga();q((a.attr("class")||"").split(/\s+/),function(a){f[a]=!0});q(c,function(a,c){var g=f[c];!1===a&&g?e.push(c):!0!==a||g||d.push(c)});return 0<d.length+e.length&&[d.length?d:null,e.length?e:null]}function h(a,
c,d){for(var e=0,f=c.length;e<f;++e)a[c[e]]=d}function l(){m||(m=a.defer(),d(function(){m.resolve();m=null}));return m.promise}function k(a,c){if(ba.isObject(c)){var d=x(c.from||{},c.to||{});a.css(d)}}var m;return{animate:function(a,c,d){k(a,{from:c,to:d});return l()},enter:function(a,c,d,e){k(a,e);d?d.after(a):c.prepend(a);return l()},leave:function(a,c){k(a,c);a.remove();return l()},move:function(a,c,d,e){return this.enter(a,c,d,e)},addClass:function(a,c,d){return this.setClass(a,c,[],d)},$$addClassImmediately:function(a,
c,d){a=z(a);c=O(c)?c:w(c)?c.join(" "):"";q(a,function(a){Db(a,c)});k(a,d);return l()},removeClass:function(a,c,d){return this.setClass(a,[],c,d)},$$removeClassImmediately:function(a,c,d){a=z(a);c=O(c)?c:w(c)?c.join(" "):"";q(a,function(a){Cb(a,c)});k(a,d);return l()},setClass:function(a,c,d,e){var k=this,l=!1;a=z(a);var m=a.data("$$animateClasses");m?e&&m.options&&(m.options=ba.extend(m.options||{},e)):(m={classes:{},options:e},l=!0);e=m.classes;c=w(c)?c:c.split(" ");d=w(d)?d:d.split(" ");h(e,c,!0);
h(e,d,!1);l&&(m.promise=f(function(c){var d=a.data("$$animateClasses");a.removeData("$$animateClasses");if(d){var e=g(a,d.classes);e&&k.$$setClassImmediately(a,e[0],e[1],d.options)}c()}),a.data("$$animateClasses",m));return m.promise},$$setClassImmediately:function(a,c,d,e){c&&this.$$addClassImmediately(a,c);d&&this.$$removeClassImmediately(a,d);k(a,e);return l()},enabled:A,cancel:A}}]}],da=F("$compile");Bc.$inject=["$provide","$$sanitizeUriProvider"];var Wc=/^((?:x|data)[\:\-_])/i,vf=F("$controller"),
ad="application/json",cc={"Content-Type":ad+";charset=utf-8"},xf=/^\[|^\{(?!\{)/,yf={"[":/]$/,"{":/}$/},wf=/^\)\]\}',?\n/,dc=F("$interpolate"),Yf=/^([^\?#]*)(\?([^#]*))?(#(.*))?$/,Bf={http:80,https:443,ftp:21},Hb=F("$location"),Zf={$$html5:!1,$$replace:!1,absUrl:Ib("$$absUrl"),url:function(a){if(C(a))return this.$$url;var c=Yf.exec(a);(c[1]||""===a)&&this.path(decodeURIComponent(c[1]));(c[2]||c[1]||""===a)&&this.search(c[3]||"");this.hash(c[5]||"");return this},protocol:Ib("$$protocol"),host:Ib("$$host"),
port:Ib("$$port"),path:id("$$path",function(a){a=null!==a?a.toString():"";return"/"==a.charAt(0)?a:"/"+a}),search:function(a,c){switch(arguments.length){case 0:return this.$$search;case 1:if(O(a)||Q(a))a=a.toString(),this.$$search=vc(a);else if(I(a))a=Ba(a,{}),q(a,function(c,e){null==c&&delete a[e]}),this.$$search=a;else throw Hb("isrcharg");break;default:C(c)||null===c?delete this.$$search[a]:this.$$search[a]=c}this.$$compose();return this},hash:id("$$hash",function(a){return null!==a?a.toString():
""}),replace:function(){this.$$replace=!0;return this}};q([hd,hc,gc],function(a){a.prototype=Object.create(Zf);a.prototype.state=function(c){if(!arguments.length)return this.$$state;if(a!==gc||!this.$$html5)throw Hb("nostate");this.$$state=C(c)?null:c;return this}});var ja=F("$parse"),$f=Function.prototype.call,ag=Function.prototype.apply,bg=Function.prototype.bind,pb=ga();q({"null":function(){return null},"true":function(){return!0},"false":function(){return!1},undefined:function(){}},function(a,
c){a.constant=a.literal=a.sharedGetter=!0;pb[c]=a});pb["this"]=function(a){return a};pb["this"].sharedGetter=!0;var qb=x(ga(),{"+":function(a,c,d,e){d=d(a,c);e=e(a,c);return y(d)?y(e)?d+e:d:y(e)?e:s},"-":function(a,c,d,e){d=d(a,c);e=e(a,c);return(y(d)?d:0)-(y(e)?e:0)},"*":function(a,c,d,e){return d(a,c)*e(a,c)},"/":function(a,c,d,e){return d(a,c)/e(a,c)},"%":function(a,c,d,e){return d(a,c)%e(a,c)},"===":function(a,c,d,e){return d(a,c)===e(a,c)},"!==":function(a,c,d,e){return d(a,c)!==e(a,c)},"==":function(a,
c,d,e){return d(a,c)==e(a,c)},"!=":function(a,c,d,e){return d(a,c)!=e(a,c)},"<":function(a,c,d,e){return d(a,c)<e(a,c)},">":function(a,c,d,e){return d(a,c)>e(a,c)},"<=":function(a,c,d,e){return d(a,c)<=e(a,c)},">=":function(a,c,d,e){return d(a,c)>=e(a,c)},"&&":function(a,c,d,e){return d(a,c)&&e(a,c)},"||":function(a,c,d,e){return d(a,c)||e(a,c)},"!":function(a,c,d){return!d(a,c)},"=":!0,"|":!0}),cg={n:"\n",f:"\f",r:"\r",t:"\t",v:"\v","'":"'",'"':'"'},kc=function(a){this.options=a};kc.prototype={constructor:kc,
lex:function(a){this.text=a;this.index=0;for(this.tokens=[];this.index<this.text.length;)if(a=this.text.charAt(this.index),'"'===a||"'"===a)this.readString(a);else if(this.isNumber(a)||"."===a&&this.isNumber(this.peek()))this.readNumber();else if(this.isIdent(a))this.readIdent();else if(this.is(a,"(){}[].,;:?"))this.tokens.push({index:this.index,text:a}),this.index++;else if(this.isWhitespace(a))this.index++;else{var c=a+this.peek(),d=c+this.peek(2),e=qb[c],f=qb[d];qb[a]||e||f?(a=f?d:e?c:a,this.tokens.push({index:this.index,
text:a,operator:!0}),this.index+=a.length):this.throwError("Unexpected next character ",this.index,this.index+1)}return this.tokens},is:function(a,c){return-1!==c.indexOf(a)},peek:function(a){a=a||1;return this.index+a<this.text.length?this.text.charAt(this.index+a):!1},isNumber:function(a){return"0"<=a&&"9">=a&&"string"===typeof a},isWhitespace:function(a){return" "===a||"\r"===a||"\t"===a||"\n"===a||"\v"===a||"\u00a0"===a},isIdent:function(a){return"a"<=a&&"z">=a||"A"<=a&&"Z">=a||"_"===a||"$"===
a},isExpOperator:function(a){return"-"===a||"+"===a||this.isNumber(a)},throwError:function(a,c,d){d=d||this.index;c=y(c)?"s "+c+"-"+this.index+" ["+this.text.substring(c,d)+"]":" "+d;throw ja("lexerr",a,c,this.text);},readNumber:function(){for(var a="",c=this.index;this.index<this.text.length;){var d=L(this.text.charAt(this.index));if("."==d||this.isNumber(d))a+=d;else{var e=this.peek();if("e"==d&&this.isExpOperator(e))a+=d;else if(this.isExpOperator(d)&&e&&this.isNumber(e)&&"e"==a.charAt(a.length-
1))a+=d;else if(!this.isExpOperator(d)||e&&this.isNumber(e)||"e"!=a.charAt(a.length-1))break;else this.throwError("Invalid exponent")}this.index++}this.tokens.push({index:c,text:a,constant:!0,value:Number(a)})},readIdent:function(){for(var a=this.index;this.index<this.text.length;){var c=this.text.charAt(this.index);if(!this.isIdent(c)&&!this.isNumber(c))break;this.index++}this.tokens.push({index:a,text:this.text.slice(a,this.index),identifier:!0})},readString:function(a){var c=this.index;this.index++;
for(var d="",e=a,f=!1;this.index<this.text.length;){var g=this.text.charAt(this.index),e=e+g;if(f)"u"===g?(f=this.text.substring(this.index+1,this.index+5),f.match(/[\da-f]{4}/i)||this.throwError("Invalid unicode escape [\\u"+f+"]"),this.index+=4,d+=String.fromCharCode(parseInt(f,16))):d+=cg[g]||g,f=!1;else if("\\"===g)f=!0;else{if(g===a){this.index++;this.tokens.push({index:c,text:e,constant:!0,value:d});return}d+=g}this.index++}this.throwError("Unterminated quote",c)}};var lb=function(a,c,d){this.lexer=
a;this.$filter=c;this.options=d};lb.ZERO=x(function(){return 0},{sharedGetter:!0,constant:!0});lb.prototype={constructor:lb,parse:function(a){this.text=a;this.tokens=this.lexer.lex(a);a=this.statements();0!==this.tokens.length&&this.throwError("is an unexpected token",this.tokens[0]);a.literal=!!a.literal;a.constant=!!a.constant;return a},primary:function(){var a;this.expect("(")?(a=this.filterChain(),this.consume(")")):this.expect("[")?a=this.arrayDeclaration():this.expect("{")?a=this.object():this.peek().identifier&&
this.peek().text in pb?a=pb[this.consume().text]:this.peek().identifier?a=this.identifier():this.peek().constant?a=this.constant():this.throwError("not a primary expression",this.peek());for(var c,d;c=this.expect("(","[",".");)"("===c.text?(a=this.functionCall(a,d),d=null):"["===c.text?(d=a,a=this.objectIndex(a)):"."===c.text?(d=a,a=this.fieldAccess(a)):this.throwError("IMPOSSIBLE");return a},throwError:function(a,c){throw ja("syntax",c.text,a,c.index+1,this.text,this.text.substring(c.index));},peekToken:function(){if(0===
this.tokens.length)throw ja("ueoe",this.text);return this.tokens[0]},peek:function(a,c,d,e){return this.peekAhead(0,a,c,d,e)},peekAhead:function(a,c,d,e,f){if(this.tokens.length>a){a=this.tokens[a];var g=a.text;if(g===c||g===d||g===e||g===f||!(c||d||e||f))return a}return!1},expect:function(a,c,d,e){return(a=this.peek(a,c,d,e))?(this.tokens.shift(),a):!1},consume:function(a){if(0===this.tokens.length)throw ja("ueoe",this.text);var c=this.expect(a);c||this.throwError("is unexpected, expecting ["+a+
"]",this.peek());return c},unaryFn:function(a,c){var d=qb[a];return x(function(a,f){return d(a,f,c)},{constant:c.constant,inputs:[c]})},binaryFn:function(a,c,d,e){var f=qb[c];return x(function(c,e){return f(c,e,a,d)},{constant:a.constant&&d.constant,inputs:!e&&[a,d]})},identifier:function(){for(var a=this.consume().text;this.peek(".")&&this.peekAhead(1).identifier&&!this.peekAhead(2,"(");)a+=this.consume().text+this.consume().text;return Df(a,this.options,this.text)},constant:function(){var a=this.consume().value;
return x(function(){return a},{constant:!0,literal:!0})},statements:function(){for(var a=[];;)if(0<this.tokens.length&&!this.peek("}",")",";","]")&&a.push(this.filterChain()),!this.expect(";"))return 1===a.length?a[0]:function(c,d){for(var e,f=0,g=a.length;f<g;f++)e=a[f](c,d);return e}},filterChain:function(){for(var a=this.expression();this.expect("|");)a=this.filter(a);return a},filter:function(a){var c=this.$filter(this.consume().text),d,e;if(this.peek(":"))for(d=[],e=[];this.expect(":");)d.push(this.expression());
var f=[a].concat(d||[]);return x(function(f,h){var l=a(f,h);if(e){e[0]=l;for(l=d.length;l--;)e[l+1]=d[l](f,h);return c.apply(s,e)}return c(l)},{constant:!c.$stateful&&f.every(ic),inputs:!c.$stateful&&f})},expression:function(){return this.assignment()},assignment:function(){var a=this.ternary(),c,d;return(d=this.expect("="))?(a.assign||this.throwError("implies assignment but ["+this.text.substring(0,d.index)+"] can not be assigned to",d),c=this.ternary(),x(function(d,f){return a.assign(d,c(d,f),f)},
{inputs:[a,c]})):a},ternary:function(){var a=this.logicalOR(),c;if(this.expect("?")&&(c=this.assignment(),this.consume(":"))){var d=this.assignment();return x(function(e,f){return a(e,f)?c(e,f):d(e,f)},{constant:a.constant&&c.constant&&d.constant})}return a},logicalOR:function(){for(var a=this.logicalAND(),c;c=this.expect("||");)a=this.binaryFn(a,c.text,this.logicalAND(),!0);return a},logicalAND:function(){for(var a=this.equality(),c;c=this.expect("&&");)a=this.binaryFn(a,c.text,this.equality(),!0);
return a},equality:function(){for(var a=this.relational(),c;c=this.expect("==","!=","===","!==");)a=this.binaryFn(a,c.text,this.relational());return a},relational:function(){for(var a=this.additive(),c;c=this.expect("<",">","<=",">=");)a=this.binaryFn(a,c.text,this.additive());return a},additive:function(){for(var a=this.multiplicative(),c;c=this.expect("+","-");)a=this.binaryFn(a,c.text,this.multiplicative());return a},multiplicative:function(){for(var a=this.unary(),c;c=this.expect("*","/","%");)a=
this.binaryFn(a,c.text,this.unary());return a},unary:function(){var a;return this.expect("+")?this.primary():(a=this.expect("-"))?this.binaryFn(lb.ZERO,a.text,this.unary()):(a=this.expect("!"))?this.unaryFn(a.text,this.unary()):this.primary()},fieldAccess:function(a){var c=this.identifier();return x(function(d,e,f){d=f||a(d,e);return null==d?s:c(d)},{assign:function(d,e,f){var g=a(d,f);g||a.assign(d,g={},f);return c.assign(g,e)}})},objectIndex:function(a){var c=this.text,d=this.expression();this.consume("]");
return x(function(e,f){var g=a(e,f),h=d(e,f);ra(h,c);return g?ka(g[h],c):s},{assign:function(e,f,g){var h=ra(d(e,g),c),l=ka(a(e,g),c);l||a.assign(e,l={},g);return l[h]=f}})},functionCall:function(a,c){var d=[];if(")"!==this.peekToken().text){do d.push(this.expression());while(this.expect(","))}this.consume(")");var e=this.text,f=d.length?[]:null;return function(g,h){var l=c?c(g,h):y(c)?s:g,k=a(g,h,l)||A;if(f)for(var m=d.length;m--;)f[m]=ka(d[m](g,h),e);ka(l,e);if(k){if(k.constructor===k)throw ja("isecfn",
e);if(k===$f||k===ag||k===bg)throw ja("isecff",e);}l=k.apply?k.apply(l,f):k(f[0],f[1],f[2],f[3],f[4]);f&&(f.length=0);return ka(l,e)}},arrayDeclaration:function(){var a=[];if("]"!==this.peekToken().text){do{if(this.peek("]"))break;a.push(this.expression())}while(this.expect(","))}this.consume("]");return x(function(c,d){for(var e=[],f=0,g=a.length;f<g;f++)e.push(a[f](c,d));return e},{literal:!0,constant:a.every(ic),inputs:a})},object:function(){var a=[],c=[];if("}"!==this.peekToken().text){do{if(this.peek("}"))break;
var d=this.consume();d.constant?a.push(d.value):d.identifier?a.push(d.text):this.throwError("invalid key",d);this.consume(":");c.push(this.expression())}while(this.expect(","))}this.consume("}");return x(function(d,f){for(var g={},h=0,l=c.length;h<l;h++)g[a[h]]=c[h](d,f);return g},{literal:!0,constant:c.every(ic),inputs:c})}};var Ff=ga(),Ef=ga(),Gf=Object.prototype.valueOf,za=F("$sce"),la={HTML:"html",CSS:"css",URL:"url",RESOURCE_URL:"resourceUrl",JS:"js"},da=F("$compile"),X=V.createElement("a"),
nd=ya(T.location.href);Ic.$inject=["$provide"];od.$inject=["$locale"];qd.$inject=["$locale"];var td=".",Qf={yyyy:Z("FullYear",4),yy:Z("FullYear",2,0,!0),y:Z("FullYear",1),MMMM:Kb("Month"),MMM:Kb("Month",!0),MM:Z("Month",2,1),M:Z("Month",1,1),dd:Z("Date",2),d:Z("Date",1),HH:Z("Hours",2),H:Z("Hours",1),hh:Z("Hours",2,-12),h:Z("Hours",1,-12),mm:Z("Minutes",2),m:Z("Minutes",1),ss:Z("Seconds",2),s:Z("Seconds",1),sss:Z("Milliseconds",3),EEEE:Kb("Day"),EEE:Kb("Day",!0),a:function(a,c){return 12>a.getHours()?
c.AMPMS[0]:c.AMPMS[1]},Z:function(a){a=-1*a.getTimezoneOffset();return a=(0<=a?"+":"")+(Jb(Math[0<a?"floor":"ceil"](a/60),2)+Jb(Math.abs(a%60),2))},ww:vd(2),w:vd(1),G:lc,GG:lc,GGG:lc,GGGG:function(a,c){return 0>=a.getFullYear()?c.ERANAMES[0]:c.ERANAMES[1]}},Pf=/((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,Of=/^\-?\d+$/;pd.$inject=["$locale"];var Lf=ca(L),Mf=ca(vb);rd.$inject=["$parse"];var Yd=ca({restrict:"E",compile:function(a,c){if(!c.href&&!c.xlinkHref&&
!c.name)return function(a,c){if("a"===c[0].nodeName.toLowerCase()){var f="[object SVGAnimatedString]"===Aa.call(c.prop("href"))?"xlink:href":"href";c.on("click",function(a){c.attr(f)||a.preventDefault()})}}}}),wb={};q(Fb,function(a,c){if("multiple"!=a){var d=va("ng-"+c);wb[d]=function(){return{restrict:"A",priority:100,link:function(a,f,g){a.$watch(g[d],function(a){g.$set(c,!!a)})}}}}});q(Sc,function(a,c){wb[c]=function(){return{priority:100,link:function(a,e,f){if("ngPattern"===c&&"/"==f.ngPattern.charAt(0)&&
(e=f.ngPattern.match(Sf))){f.$set("ngPattern",new RegExp(e[1],e[2]));return}a.$watch(f[c],function(a){f.$set(c,a)})}}}});q(["src","srcset","href"],function(a){var c=va("ng-"+a);wb[c]=function(){return{priority:99,link:function(d,e,f){var g=a,h=a;"href"===a&&"[object SVGAnimatedString]"===Aa.call(e.prop("href"))&&(h="xlinkHref",f.$attr[h]="xlink:href",g=null);f.$observe(c,function(c){c?(f.$set(h,c),Qa&&g&&e.prop(g,f[h])):"href"===a&&f.$set(h,null)})}}}});var Lb={$addControl:A,$$renameControl:function(a,
c){a.$name=c},$removeControl:A,$setValidity:A,$setDirty:A,$setPristine:A,$setSubmitted:A};wd.$inject=["$element","$attrs","$scope","$animate","$interpolate"];var Dd=function(a){return["$timeout",function(c){return{name:"form",restrict:a?"EAC":"E",controller:wd,compile:function(d,e){d.addClass(Ra).addClass(ob);var f=e.name?"name":a&&e.ngForm?"ngForm":!1;return{pre:function(a,d,e,k){if(!("action"in e)){var m=function(c){a.$apply(function(){k.$commitViewValue();k.$setSubmitted()});c.preventDefault()};
d[0].addEventListener("submit",m,!1);d.on("$destroy",function(){c(function(){d[0].removeEventListener("submit",m,!1)},0,!1)})}var r=k.$$parentForm;f&&(kb(a,null,k.$name,k,k.$name),e.$observe(f,function(c){k.$name!==c&&(kb(a,null,k.$name,s,k.$name),r.$$renameControl(k,c),kb(a,null,k.$name,k,k.$name))}));d.on("$destroy",function(){r.$removeControl(k);f&&kb(a,null,e[f],s,k.$name);x(k,Lb)})}}}}}]},Zd=Dd(),le=Dd(!0),Rf=/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/,dg=/^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/,
eg=/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,fg=/^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/,Ed=/^(\d{4})-(\d{2})-(\d{2})$/,Fd=/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/,oc=/^(\d{4})-W(\d\d)$/,Gd=/^(\d{4})-(\d\d)$/,Hd=/^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/,Id={text:function(a,c,d,e,f,g){mb(a,c,d,e,f,g);mc(e)},date:nb("date",Ed,Nb(Ed,["yyyy","MM","dd"]),"yyyy-MM-dd"),"datetime-local":nb("datetimelocal",Fd,Nb(Fd,"yyyy MM dd HH mm ss sss".split(" ")),
"yyyy-MM-ddTHH:mm:ss.sss"),time:nb("time",Hd,Nb(Hd,["HH","mm","ss","sss"]),"HH:mm:ss.sss"),week:nb("week",oc,function(a,c){if(ea(a))return a;if(O(a)){oc.lastIndex=0;var d=oc.exec(a);if(d){var e=+d[1],f=+d[2],g=d=0,h=0,l=0,k=ud(e),f=7*(f-1);c&&(d=c.getHours(),g=c.getMinutes(),h=c.getSeconds(),l=c.getMilliseconds());return new Date(e,0,k.getDate()+f,d,g,h,l)}}return NaN},"yyyy-Www"),month:nb("month",Gd,Nb(Gd,["yyyy","MM"]),"yyyy-MM"),number:function(a,c,d,e,f,g){yd(a,c,d,e);mb(a,c,d,e,f,g);e.$$parserName=
"number";e.$parsers.push(function(a){return e.$isEmpty(a)?null:fg.test(a)?parseFloat(a):s});e.$formatters.push(function(a){if(!e.$isEmpty(a)){if(!Q(a))throw Ob("numfmt",a);a=a.toString()}return a});if(y(d.min)||d.ngMin){var h;e.$validators.min=function(a){return e.$isEmpty(a)||C(h)||a>=h};d.$observe("min",function(a){y(a)&&!Q(a)&&(a=parseFloat(a,10));h=Q(a)&&!isNaN(a)?a:s;e.$validate()})}if(y(d.max)||d.ngMax){var l;e.$validators.max=function(a){return e.$isEmpty(a)||C(l)||a<=l};d.$observe("max",function(a){y(a)&&
!Q(a)&&(a=parseFloat(a,10));l=Q(a)&&!isNaN(a)?a:s;e.$validate()})}},url:function(a,c,d,e,f,g){mb(a,c,d,e,f,g);mc(e);e.$$parserName="url";e.$validators.url=function(a,c){var d=a||c;return e.$isEmpty(d)||dg.test(d)}},email:function(a,c,d,e,f,g){mb(a,c,d,e,f,g);mc(e);e.$$parserName="email";e.$validators.email=function(a,c){var d=a||c;return e.$isEmpty(d)||eg.test(d)}},radio:function(a,c,d,e){C(d.name)&&c.attr("name",++rb);c.on("click",function(a){c[0].checked&&e.$setViewValue(d.value,a&&a.type)});e.$render=
function(){c[0].checked=d.value==e.$viewValue};d.$observe("value",e.$render)},checkbox:function(a,c,d,e,f,g,h,l){var k=zd(l,a,"ngTrueValue",d.ngTrueValue,!0),m=zd(l,a,"ngFalseValue",d.ngFalseValue,!1);c.on("click",function(a){e.$setViewValue(c[0].checked,a&&a.type)});e.$render=function(){c[0].checked=e.$viewValue};e.$isEmpty=function(a){return!1===a};e.$formatters.push(function(a){return fa(a,k)});e.$parsers.push(function(a){return a?k:m})},hidden:A,button:A,submit:A,reset:A,file:A},Cc=["$browser",
"$sniffer","$filter","$parse",function(a,c,d,e){return{restrict:"E",require:["?ngModel"],link:{pre:function(f,g,h,l){l[0]&&(Id[L(h.type)]||Id.text)(f,g,h,l[0],c,a,d,e)}}}}],gg=/^(true|false|\d+)$/,De=function(){return{restrict:"A",priority:100,compile:function(a,c){return gg.test(c.ngValue)?function(a,c,f){f.$set("value",a.$eval(f.ngValue))}:function(a,c,f){a.$watch(f.ngValue,function(a){f.$set("value",a)})}}}},de=["$compile",function(a){return{restrict:"AC",compile:function(c){a.$$addBindingClass(c);
return function(c,e,f){a.$$addBindingInfo(e,f.ngBind);e=e[0];c.$watch(f.ngBind,function(a){e.textContent=a===s?"":a})}}}}],fe=["$interpolate","$compile",function(a,c){return{compile:function(d){c.$$addBindingClass(d);return function(d,f,g){d=a(f.attr(g.$attr.ngBindTemplate));c.$$addBindingInfo(f,d.expressions);f=f[0];g.$observe("ngBindTemplate",function(a){f.textContent=a===s?"":a})}}}}],ee=["$sce","$parse","$compile",function(a,c,d){return{restrict:"A",compile:function(e,f){var g=c(f.ngBindHtml),
h=c(f.ngBindHtml,function(a){return(a||"").toString()});d.$$addBindingClass(e);return function(c,e,f){d.$$addBindingInfo(e,f.ngBindHtml);c.$watch(h,function(){e.html(a.getTrustedHtml(g(c))||"")})}}}}],Ce=ca({restrict:"A",require:"ngModel",link:function(a,c,d,e){e.$viewChangeListeners.push(function(){a.$eval(d.ngChange)})}}),ge=nc("",!0),ie=nc("Odd",0),he=nc("Even",1),je=Ia({compile:function(a,c){c.$set("ngCloak",s);a.removeClass("ng-cloak")}}),ke=[function(){return{restrict:"A",scope:!0,controller:"@",
priority:500}}],Hc={},hg={blur:!0,focus:!0};q("click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "),function(a){var c=va("ng-"+a);Hc[c]=["$parse","$rootScope",function(d,e){return{restrict:"A",compile:function(f,g){var h=d(g[c],null,!0);return function(c,d){d.on(a,function(d){var f=function(){h(c,{$event:d})};hg[a]&&e.$$phase?c.$evalAsync(f):c.$apply(f)})}}}}]});var ne=["$animate",function(a){return{multiElement:!0,
transclude:"element",priority:600,terminal:!0,restrict:"A",$$tlb:!0,link:function(c,d,e,f,g){var h,l,k;c.$watch(e.ngIf,function(c){c?l||g(function(c,f){l=f;c[c.length++]=V.createComment(" end ngIf: "+e.ngIf+" ");h={clone:c};a.enter(c,d.parent(),d)}):(k&&(k.remove(),k=null),l&&(l.$destroy(),l=null),h&&(k=ub(h.clone),a.leave(k).then(function(){k=null}),h=null))})}}}],oe=["$templateRequest","$anchorScroll","$animate","$sce",function(a,c,d,e){return{restrict:"ECA",priority:400,terminal:!0,transclude:"element",
controller:ba.noop,compile:function(f,g){var h=g.ngInclude||g.src,l=g.onload||"",k=g.autoscroll;return function(f,g,n,q,v){var s=0,t,p,H,J=function(){p&&(p.remove(),p=null);t&&(t.$destroy(),t=null);H&&(d.leave(H).then(function(){p=null}),p=H,H=null)};f.$watch(e.parseAsResourceUrl(h),function(e){var h=function(){!y(k)||k&&!f.$eval(k)||c()},n=++s;e?(a(e,!0).then(function(a){if(n===s){var c=f.$new();q.template=a;a=v(c,function(a){J();d.enter(a,null,g).then(h)});t=c;H=a;t.$emit("$includeContentLoaded",
e);f.$eval(l)}},function(){n===s&&(J(),f.$emit("$includeContentError",e))}),f.$emit("$includeContentRequested",e)):(J(),q.template=null)})}}}}],Fe=["$compile",function(a){return{restrict:"ECA",priority:-400,require:"ngInclude",link:function(c,d,e,f){/SVG/.test(d[0].toString())?(d.empty(),a(Kc(f.template,V).childNodes)(c,function(a){d.append(a)},{futureParentElement:d})):(d.html(f.template),a(d.contents())(c))}}}],pe=Ia({priority:450,compile:function(){return{pre:function(a,c,d){a.$eval(d.ngInit)}}}}),
Be=function(){return{restrict:"A",priority:100,require:"ngModel",link:function(a,c,d,e){var f=c.attr(d.$attr.ngList)||", ",g="false"!==d.ngTrim,h=g?U(f):f;e.$parsers.push(function(a){if(!C(a)){var c=[];a&&q(a.split(h),function(a){a&&c.push(g?U(a):a)});return c}});e.$formatters.push(function(a){return w(a)?a.join(f):s});e.$isEmpty=function(a){return!a||!a.length}}}},ob="ng-valid",Ad="ng-invalid",Ra="ng-pristine",Mb="ng-dirty",Cd="ng-pending",Ob=new F("ngModel"),ig=["$scope","$exceptionHandler","$attrs",
"$element","$parse","$animate","$timeout","$rootScope","$q","$interpolate",function(a,c,d,e,f,g,h,l,k,m){this.$modelValue=this.$viewValue=Number.NaN;this.$$rawModelValue=s;this.$validators={};this.$asyncValidators={};this.$parsers=[];this.$formatters=[];this.$viewChangeListeners=[];this.$untouched=!0;this.$touched=!1;this.$pristine=!0;this.$dirty=!1;this.$valid=!0;this.$invalid=!1;this.$error={};this.$$success={};this.$pending=s;this.$name=m(d.name||"",!1)(a);var r=f(d.ngModel),n=r.assign,u=r,v=n,
P=null,t,p=this;this.$$setOptions=function(a){if((p.$options=a)&&a.getterSetter){var c=f(d.ngModel+"()"),g=f(d.ngModel+"($$$p)");u=function(a){var d=r(a);E(d)&&(d=c(a));return d};v=function(a,c){E(r(a))?g(a,{$$$p:p.$modelValue}):n(a,p.$modelValue)}}else if(!r.assign)throw Ob("nonassign",d.ngModel,ta(e));};this.$render=A;this.$isEmpty=function(a){return C(a)||""===a||null===a||a!==a};var H=e.inheritedData("$formController")||Lb,J=0;xd({ctrl:this,$element:e,set:function(a,c){a[c]=!0},unset:function(a,
c){delete a[c]},parentForm:H,$animate:g});this.$setPristine=function(){p.$dirty=!1;p.$pristine=!0;g.removeClass(e,Mb);g.addClass(e,Ra)};this.$setDirty=function(){p.$dirty=!0;p.$pristine=!1;g.removeClass(e,Ra);g.addClass(e,Mb);H.$setDirty()};this.$setUntouched=function(){p.$touched=!1;p.$untouched=!0;g.setClass(e,"ng-untouched","ng-touched")};this.$setTouched=function(){p.$touched=!0;p.$untouched=!1;g.setClass(e,"ng-touched","ng-untouched")};this.$rollbackViewValue=function(){h.cancel(P);p.$viewValue=
p.$$lastCommittedViewValue;p.$render()};this.$validate=function(){if(!Q(p.$modelValue)||!isNaN(p.$modelValue)){var a=p.$$rawModelValue,c=p.$valid,d=p.$modelValue,e=p.$options&&p.$options.allowInvalid;p.$$runValidators(a,p.$$lastCommittedViewValue,function(f){e||c===f||(p.$modelValue=f?a:s,p.$modelValue!==d&&p.$$writeModelToScope())})}};this.$$runValidators=function(a,c,d){function e(){var d=!0;q(p.$validators,function(e,f){var h=e(a,c);d=d&&h;g(f,h)});return d?!0:(q(p.$asyncValidators,function(a,
c){g(c,null)}),!1)}function f(){var d=[],e=!0;q(p.$asyncValidators,function(f,h){var k=f(a,c);if(!k||!E(k.then))throw Ob("$asyncValidators",k);g(h,s);d.push(k.then(function(){g(h,!0)},function(a){e=!1;g(h,!1)}))});d.length?k.all(d).then(function(){h(e)},A):h(!0)}function g(a,c){l===J&&p.$setValidity(a,c)}function h(a){l===J&&d(a)}J++;var l=J;(function(){var a=p.$$parserName||"parse";if(t===s)g(a,null);else return t||(q(p.$validators,function(a,c){g(c,null)}),q(p.$asyncValidators,function(a,c){g(c,
null)})),g(a,t),t;return!0})()?e()?f():h(!1):h(!1)};this.$commitViewValue=function(){var a=p.$viewValue;h.cancel(P);if(p.$$lastCommittedViewValue!==a||""===a&&p.$$hasNativeValidators)p.$$lastCommittedViewValue=a,p.$pristine&&this.$setDirty(),this.$$parseAndValidate()};this.$$parseAndValidate=function(){var c=p.$$lastCommittedViewValue;if(t=C(c)?s:!0)for(var d=0;d<p.$parsers.length;d++)if(c=p.$parsers[d](c),C(c)){t=!1;break}Q(p.$modelValue)&&isNaN(p.$modelValue)&&(p.$modelValue=u(a));var e=p.$modelValue,
f=p.$options&&p.$options.allowInvalid;p.$$rawModelValue=c;f&&(p.$modelValue=c,p.$modelValue!==e&&p.$$writeModelToScope());p.$$runValidators(c,p.$$lastCommittedViewValue,function(a){f||(p.$modelValue=a?c:s,p.$modelValue!==e&&p.$$writeModelToScope())})};this.$$writeModelToScope=function(){v(a,p.$modelValue);q(p.$viewChangeListeners,function(a){try{a()}catch(d){c(d)}})};this.$setViewValue=function(a,c){p.$viewValue=a;p.$options&&!p.$options.updateOnDefault||p.$$debounceViewValueCommit(c)};this.$$debounceViewValueCommit=
function(c){var d=0,e=p.$options;e&&y(e.debounce)&&(e=e.debounce,Q(e)?d=e:Q(e[c])?d=e[c]:Q(e["default"])&&(d=e["default"]));h.cancel(P);d?P=h(function(){p.$commitViewValue()},d):l.$$phase?p.$commitViewValue():a.$apply(function(){p.$commitViewValue()})};a.$watch(function(){var c=u(a);if(c!==p.$modelValue&&(p.$modelValue===p.$modelValue||c===c)){p.$modelValue=p.$$rawModelValue=c;t=s;for(var d=p.$formatters,e=d.length,f=c;e--;)f=d[e](f);p.$viewValue!==f&&(p.$viewValue=p.$$lastCommittedViewValue=f,p.$render(),
p.$$runValidators(c,f,A))}return c})}],Ae=["$rootScope",function(a){return{restrict:"A",require:["ngModel","^?form","^?ngModelOptions"],controller:ig,priority:1,compile:function(c){c.addClass(Ra).addClass("ng-untouched").addClass(ob);return{pre:function(a,c,f,g){var h=g[0],l=g[1]||Lb;h.$$setOptions(g[2]&&g[2].$options);l.$addControl(h);f.$observe("name",function(a){h.$name!==a&&l.$$renameControl(h,a)});a.$on("$destroy",function(){l.$removeControl(h)})},post:function(c,e,f,g){var h=g[0];if(h.$options&&
h.$options.updateOn)e.on(h.$options.updateOn,function(a){h.$$debounceViewValueCommit(a&&a.type)});e.on("blur",function(e){h.$touched||(a.$$phase?c.$evalAsync(h.$setTouched):c.$apply(h.$setTouched))})}}}}}],jg=/(\s+|^)default(\s+|$)/,Ee=function(){return{restrict:"A",controller:["$scope","$attrs",function(a,c){var d=this;this.$options=a.$eval(c.ngModelOptions);this.$options.updateOn!==s?(this.$options.updateOnDefault=!1,this.$options.updateOn=U(this.$options.updateOn.replace(jg,function(){d.$options.updateOnDefault=
!0;return" "}))):this.$options.updateOnDefault=!0}]}},qe=Ia({terminal:!0,priority:1E3}),re=["$locale","$interpolate",function(a,c){var d=/{}/g,e=/^when(Minus)?(.+)$/;return{restrict:"EA",link:function(f,g,h){function l(a){g.text(a||"")}var k=h.count,m=h.$attr.when&&g.attr(h.$attr.when),r=h.offset||0,n=f.$eval(m)||{},u={},m=c.startSymbol(),s=c.endSymbol(),y=m+k+"-"+r+s,t=ba.noop,p;q(h,function(a,c){var d=e.exec(c);d&&(d=(d[1]?"-":"")+L(d[2]),n[d]=g.attr(h.$attr[c]))});q(n,function(a,e){u[e]=c(a.replace(d,
y))});f.$watch(k,function(c){c=parseFloat(c);var d=isNaN(c);d||c in n||(c=a.pluralCat(c-r));c===p||d&&isNaN(p)||(t(),t=f.$watch(u[c],l),p=c)})}}}],se=["$parse","$animate",function(a,c){var d=F("ngRepeat"),e=function(a,c,d,e,k,m,q){a[d]=e;k&&(a[k]=m);a.$index=c;a.$first=0===c;a.$last=c===q-1;a.$middle=!(a.$first||a.$last);a.$odd=!(a.$even=0===(c&1))};return{restrict:"A",multiElement:!0,transclude:"element",priority:1E3,terminal:!0,$$tlb:!0,compile:function(f,g){var h=g.ngRepeat,l=V.createComment(" end ngRepeat: "+
h+" "),k=h.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);if(!k)throw d("iexp",h);var m=k[1],r=k[2],n=k[3],u=k[4],k=m.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);if(!k)throw d("iidexp",m);var v=k[3]||k[1],y=k[2];if(n&&(!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(n)||/^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(n)))throw d("badident",n);var t,p,H,F,B={$id:Na};u?t=a(u):(H=function(a,c){return Na(c)},
F=function(a){return a});return function(a,f,g,k,m){t&&(p=function(c,d,e){y&&(B[y]=c);B[v]=d;B.$index=e;return t(a,B)});var u=ga();a.$watchCollection(r,function(g){var k,r,t=f[0],G,B=ga(),x,C,A,N,E,w,I;n&&(a[n]=g);if(Sa(g))E=g,r=p||H;else{r=p||F;E=[];for(I in g)g.hasOwnProperty(I)&&"$"!=I.charAt(0)&&E.push(I);E.sort()}x=E.length;I=Array(x);for(k=0;k<x;k++)if(C=g===E?k:E[k],A=g[C],N=r(C,A,k),u[N])w=u[N],delete u[N],B[N]=w,I[k]=w;else{if(B[N])throw q(I,function(a){a&&a.scope&&(u[a.id]=a)}),d("dupes",
h,N,A);I[k]={id:N,scope:s,clone:s};B[N]=!0}for(G in u){w=u[G];N=ub(w.clone);c.leave(N);if(N[0].parentNode)for(k=0,r=N.length;k<r;k++)N[k].$$NG_REMOVED=!0;w.scope.$destroy()}for(k=0;k<x;k++)if(C=g===E?k:E[k],A=g[C],w=I[k],w.scope){G=t;do G=G.nextSibling;while(G&&G.$$NG_REMOVED);w.clone[0]!=G&&c.move(ub(w.clone),null,z(t));t=w.clone[w.clone.length-1];e(w.scope,k,v,A,y,C,x)}else m(function(a,d){w.scope=d;var f=l.cloneNode(!1);a[a.length++]=f;c.enter(a,null,z(t));t=f;w.clone=a;B[w.id]=w;e(w.scope,k,v,
A,y,C,x)});u=B})}}}}],te=["$animate",function(a){return{restrict:"A",multiElement:!0,link:function(c,d,e){c.$watch(e.ngShow,function(c){a[c?"removeClass":"addClass"](d,"ng-hide",{tempClasses:"ng-hide-animate"})})}}}],me=["$animate",function(a){return{restrict:"A",multiElement:!0,link:function(c,d,e){c.$watch(e.ngHide,function(c){a[c?"addClass":"removeClass"](d,"ng-hide",{tempClasses:"ng-hide-animate"})})}}}],ue=Ia(function(a,c,d){a.$watch(d.ngStyle,function(a,d){d&&a!==d&&q(d,function(a,d){c.css(d,
"")});a&&c.css(a)},!0)}),ve=["$animate",function(a){return{restrict:"EA",require:"ngSwitch",controller:["$scope",function(){this.cases={}}],link:function(c,d,e,f){var g=[],h=[],l=[],k=[],m=function(a,c){return function(){a.splice(c,1)}};c.$watch(e.ngSwitch||e.on,function(c){var d,e;d=0;for(e=l.length;d<e;++d)a.cancel(l[d]);d=l.length=0;for(e=k.length;d<e;++d){var s=ub(h[d].clone);k[d].$destroy();(l[d]=a.leave(s)).then(m(l,d))}h.length=0;k.length=0;(g=f.cases["!"+c]||f.cases["?"])&&q(g,function(c){c.transclude(function(d,
e){k.push(e);var f=c.element;d[d.length++]=V.createComment(" end ngSwitchWhen: ");h.push({clone:d});a.enter(d,f.parent(),f)})})})}}}],we=Ia({transclude:"element",priority:1200,require:"^ngSwitch",multiElement:!0,link:function(a,c,d,e,f){e.cases["!"+d.ngSwitchWhen]=e.cases["!"+d.ngSwitchWhen]||[];e.cases["!"+d.ngSwitchWhen].push({transclude:f,element:c})}}),xe=Ia({transclude:"element",priority:1200,require:"^ngSwitch",multiElement:!0,link:function(a,c,d,e,f){e.cases["?"]=e.cases["?"]||[];e.cases["?"].push({transclude:f,
element:c})}}),ze=Ia({restrict:"EAC",link:function(a,c,d,e,f){if(!f)throw F("ngTransclude")("orphan",ta(c));f(function(a){c.empty();c.append(a)})}}),$d=["$templateCache",function(a){return{restrict:"E",terminal:!0,compile:function(c,d){"text/ng-template"==d.type&&a.put(d.id,c[0].text)}}}],kg=F("ngOptions"),ye=ca({restrict:"A",terminal:!0}),ae=["$compile","$parse",function(a,c){var d=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/,
e={$setViewValue:A};return{restrict:"E",require:["select","?ngModel"],controller:["$element","$scope","$attrs",function(a,c,d){var l=this,k={},m=e,q;l.databound=d.ngModel;l.init=function(a,c,d){m=a;q=d};l.addOption=function(c,d){Ma(c,'"option value"');k[c]=!0;m.$viewValue==c&&(a.val(c),q.parent()&&q.remove());d&&d[0].hasAttribute("selected")&&(d[0].selected=!0)};l.removeOption=function(a){this.hasOption(a)&&(delete k[a],m.$viewValue===a&&this.renderUnknownOption(a))};l.renderUnknownOption=function(c){c=
"? "+Na(c)+" ?";q.val(c);a.prepend(q);a.val(c);q.prop("selected",!0)};l.hasOption=function(a){return k.hasOwnProperty(a)};c.$on("$destroy",function(){l.renderUnknownOption=A})}],link:function(e,g,h,l){function k(a,c,d,e){d.$render=function(){var a=d.$viewValue;e.hasOption(a)?(B.parent()&&B.remove(),c.val(a),""===a&&t.prop("selected",!0)):null==a&&t?c.val(""):e.renderUnknownOption(a)};c.on("change",function(){a.$apply(function(){B.parent()&&B.remove();d.$setViewValue(c.val())})})}function m(a,c,d){var e;
d.$render=function(){var a=new fb(d.$viewValue);q(c.find("option"),function(c){c.selected=y(a.get(c.value))})};a.$watch(function(){fa(e,d.$viewValue)||(e=oa(d.$viewValue),d.$render())});c.on("change",function(){a.$apply(function(){var a=[];q(c.find("option"),function(c){c.selected&&a.push(c.value)});d.$setViewValue(a)})})}function r(e,f,g){function h(a,c,d){U[A]=d;I&&(U[I]=c);return a(e,U)}function k(a){var c;if(u)if(L&&w(a)){c=new fb([]);for(var d=0;d<a.length;d++)c.put(h(L,null,a[d]),!0)}else c=
new fb(a);else L&&(a=h(L,null,a));return function(d,e){var f;f=L?L:z?z:D;return u?y(c.remove(h(f,d,e))):a===h(f,d,e)}}function l(){p||(e.$$postDigest(r),p=!0)}function m(a,c,d){a[c]=a[c]||0;a[c]+=d?1:-1}function r(){p=!1;var a={"":[]},c=[""],d,l,s,t,v;s=g.$viewValue;t=O(e)||[];var A=I?Object.keys(t).sort():t,w,z,E,D,S={};v=k(s);var Q=!1,V,X;R={};for(D=0;E=A.length,D<E;D++){w=D;if(I&&(w=A[D],"$"===w.charAt(0)))continue;z=t[w];d=h(M,w,z)||"";(l=a[d])||(l=a[d]=[],c.push(d));d=v(w,z);Q=Q||d;z=h(B,w,z);
z=y(z)?z:"";X=L?L(e,U):I?A[D]:D;L&&(R[X]=w);l.push({id:X,label:z,selected:d})}u||(x||null===s?a[""].unshift({id:"",label:"",selected:!Q}):Q||a[""].unshift({id:"?",label:"",selected:!0}));w=0;for(A=c.length;w<A;w++){d=c[w];l=a[d];T.length<=w?(s={element:F.clone().attr("label",d),label:l.label},t=[s],T.push(t),f.append(s.element)):(t=T[w],s=t[0],s.label!=d&&s.element.attr("label",s.label=d));Q=null;D=0;for(E=l.length;D<E;D++)d=l[D],(v=t[D+1])?(Q=v.element,v.label!==d.label&&(m(S,v.label,!1),m(S,d.label,
!0),Q.text(v.label=d.label),Q.prop("label",v.label)),v.id!==d.id&&Q.val(v.id=d.id),Q[0].selected!==d.selected&&(Q.prop("selected",v.selected=d.selected),Qa&&Q.prop("selected",v.selected))):(""===d.id&&x?V=x:(V=C.clone()).val(d.id).prop("selected",d.selected).attr("selected",d.selected).prop("label",d.label).text(d.label),t.push(v={element:V,label:d.label,id:d.id,selected:d.selected}),m(S,d.label,!0),Q?Q.after(V):s.element.append(V),Q=V);for(D++;t.length>D;)d=t.pop(),m(S,d.label,!1),d.element.remove()}for(;T.length>
w;){l=T.pop();for(D=1;D<l.length;++D)m(S,l[D].label,!1);l[0].element.remove()}q(S,function(a,c){0<a?n.addOption(c):0>a&&n.removeOption(c)})}var t;if(!(t=v.match(d)))throw kg("iexp",v,ta(f));var B=c(t[2]||t[1]),A=t[4]||t[6],E=/ as /.test(t[0])&&t[1],z=E?c(E):null,I=t[5],M=c(t[3]||""),D=c(t[2]?t[1]:A),O=c(t[7]),L=t[8]?c(t[8]):null,R={},T=[[{element:f,label:""}]],U={};x&&(a(x)(e),x.removeClass("ng-scope"),x.remove());f.empty();f.on("change",function(){e.$apply(function(){var a=O(e)||[],c;if(u)c=[],q(f.val(),
function(d){d=L?R[d]:d;c.push("?"===d?s:""===d?null:h(z?z:D,d,a[d]))});else{var d=L?R[f.val()]:f.val();c="?"===d?s:""===d?null:h(z?z:D,d,a[d])}g.$setViewValue(c);r()})});g.$render=r;e.$watchCollection(O,l);e.$watchCollection(function(){var a=O(e),c;if(a&&w(a)){c=Array(a.length);for(var d=0,f=a.length;d<f;d++)c[d]=h(B,d,a[d])}else if(a)for(d in c={},a)a.hasOwnProperty(d)&&(c[d]=h(B,d,a[d]));return c},l);u&&e.$watchCollection(function(){return g.$modelValue},l)}if(l[1]){var n=l[0];l=l[1];var u=h.multiple,
v=h.ngOptions,x=!1,t,p=!1,C=z(V.createElement("option")),F=z(V.createElement("optgroup")),B=C.clone();h=0;for(var A=g.children(),E=A.length;h<E;h++)if(""===A[h].value){t=x=A.eq(h);break}n.init(l,x,B);u&&(l.$isEmpty=function(a){return!a||0===a.length});v?r(e,g,l):u?m(e,g,l):k(e,g,l,n)}}}}],ce=["$interpolate",function(a){var c={addOption:A,removeOption:A};return{restrict:"E",priority:100,compile:function(d,e){if(C(e.value)){var f=a(d.text(),!0);f||e.$set("value",d.text())}return function(a,d,e){var k=
d.parent(),m=k.data("$selectController")||k.parent().data("$selectController");m&&m.databound||(m=c);f?a.$watch(f,function(a,c){e.$set("value",a);c!==a&&m.removeOption(c);m.addOption(a,d)}):m.addOption(e.value,d);d.on("$destroy",function(){m.removeOption(e.value)})}}}}],be=ca({restrict:"E",terminal:!1}),Ec=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){e&&(d.required=!0,e.$validators.required=function(a,c){return!d.required||!e.$isEmpty(c)},d.$observe("required",function(){e.$validate()}))}}},
Dc=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){if(e){var f,g=d.ngPattern||d.pattern;d.$observe("pattern",function(a){O(a)&&0<a.length&&(a=new RegExp("^"+a+"$"));if(a&&!a.test)throw F("ngPattern")("noregexp",g,a,ta(c));f=a||s;e.$validate()});e.$validators.pattern=function(a){return e.$isEmpty(a)||C(f)||f.test(a)}}}}},Gc=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){if(e){var f=-1;d.$observe("maxlength",function(a){a=aa(a);f=isNaN(a)?-1:a;e.$validate()});
e.$validators.maxlength=function(a,c){return 0>f||e.$isEmpty(c)||c.length<=f}}}}},Fc=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){if(e){var f=0;d.$observe("minlength",function(a){f=aa(a)||0;e.$validate()});e.$validators.minlength=function(a,c){return e.$isEmpty(c)||c.length>=f}}}}};T.angular.bootstrap?console.log("WARNING: Tried to load angular more than once."):(Sd(),Ud(ba),z(V).ready(function(){Od(V,xc)}))})(window,document);!window.angular.$$csp()&&window.angular.element(document).find("head").prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}</style>');
//# sourceMappingURL=angular.min.js.map
 
/** **************************************************** **/
/** ********************** angularjs-slider ****************************** **/
 /*! angularjs-slider - v6.7.0 -  (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervi.eu>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> -  https://github.com/angular-slider/angularjs-slider -  2019-02-23 */
!function(a,b){"use strict";if("function"==typeof define&&define.amd)define(["angular"],b);else if("object"==typeof module&&module.exports){var c=angular||require("angular");c&&c.module||"undefined"==typeof angular||(c=angular),module.exports=b(c)}else b(a.angular)}(this,function(a){"use strict";var b=a.module("rzModule",[]).factory("RzSliderOptions",function(){var b={floor:0,ceil:null,step:1,precision:0,minRange:null,maxRange:null,restrictedRange:null,pushRange:!1,minLimit:null,maxLimit:null,id:null,translate:null,getLegend:null,stepsArray:null,bindIndexForStepsArray:!1,draggableRange:!1,draggableRangeOnly:!1,showSelectionBar:!1,showSelectionBarEnd:!1,showSelectionBarFromValue:null,showOuterSelectionBars:!1,hidePointerLabels:!1,hideLimitLabels:!1,autoHideLimitLabels:!0,readOnly:!1,disabled:!1,interval:350,showTicks:!1,showTicksValues:!1,ticksArray:null,ticksTooltip:null,ticksValuesTooltip:null,vertical:!1,getSelectionBarColor:null,getTickColor:null,getPointerColor:null,keyboardSupport:!0,scale:1,enforceStep:!0,enforceRange:!1,noSwitching:!1,onlyBindHandles:!1,onStart:null,onChange:null,onEnd:null,rightToLeft:!1,reversedControls:!1,boundPointerLabels:!0,mergeRangeLabelsIfSame:!1,labelOverlapSeparator:" - ",customTemplateScope:null,logScale:!1,customValueToPosition:null,customPositionToValue:null,selectionBarGradient:null,ariaLabel:null,ariaLabelledBy:null,ariaLabelHigh:null,ariaLabelledByHigh:null},c={},d={};return d.options=function(b){a.extend(c,b)},d.getOptions=function(d){return a.extend({},b,c,d)},d}).factory("rzThrottle",["$timeout",function(a){return function(b,c,d){var e,f,g,h=Date.now||function(){return(new Date).getTime()},i=null,j=0;d=d||{};var k=function(){j=h(),i=null,g=b.apply(e,f),e=f=null};return function(){var l=h(),m=c-(l-j);return e=this,f=arguments,0>=m?(a.cancel(i),i=null,j=l,g=b.apply(e,f),e=f=null):i||d.trailing===!1||(i=a(k,m)),g}}}]).factory("RzSlider",["$timeout","$document","$window","$compile","RzSliderOptions","rzThrottle",function(b,c,d,e,f,g){var h=function(a,b){this.scope=a,this.lowValue=0,this.highValue=0,this.sliderElem=b,this.range=void 0!==this.scope.rzSliderModel&&void 0!==this.scope.rzSliderHigh,this.dragging={active:!1,value:0,difference:0,position:0,lowLimit:0,highLimit:0},this.positionProperty="left",this.dimensionProperty="width",this.handleHalfDim=0,this.maxPos=0,this.precision=0,this.step=1,this.tracking="",this.minValue=0,this.maxValue=0,this.valueRange=0,this.intermediateTicks=!1,this.initHasRun=!1,this.firstKeyDown=!1,this.internalChange=!1,this.cmbLabelShown=!1,this.currentFocusElement=null,this.fullBar=null,this.selBar=null,this.minH=null,this.maxH=null,this.flrLab=null,this.ceilLab=null,this.minLab=null,this.maxLab=null,this.cmbLab=null,this.ticks=null,this.init()};return h.prototype={init:function(){var b,c,e=this,f=function(){e.calcViewDimensions()};this.applyOptions(),this.syncLowValue(),this.range&&this.syncHighValue(),this.initElemHandles(),this.manageElementsStyle(),this.setDisabledState(),this.calcViewDimensions(),this.setMinAndMax(),this.updateRestrictionBar(),this.addAccessibility(),this.updateCeilLab(),this.updateFloorLab(),this.initHandles(),this.manageEventsBindings(),this.scope.$on("reCalcViewDimensions",f),a.element(d).on("resize",f),this.initHasRun=!0,b=g(function(){e.onLowHandleChange()},e.options.interval),c=g(function(){e.onHighHandleChange()},e.options.interval),this.scope.$on("rzSliderForceRender",function(){e.resetLabelsValue(),b(),e.range&&c(),e.resetSlider()}),this.scope.$watchCollection("rzSliderOptions()",function(a,b){a!==b&&(e.applyOptions(),e.syncLowValue(),e.range&&e.syncHighValue(),e.resetSlider())}),this.scope.$watch("rzSliderModel",function(a,c){e.internalChange||a!==c&&b()}),this.scope.$watch("rzSliderHigh",function(a,b){e.internalChange||a!==b&&(null!=a&&c(),(e.range&&null==a||!e.range&&null!=a)&&(e.applyOptions(),e.resetSlider()))}),this.scope.$on("$destroy",function(){e.unbindEvents(),a.element(d).off("resize",f),e.currentFocusElement=null})},findStepIndex:function(b){for(var c=0,d=0;d<this.options.stepsArray.length;d++){var e=this.options.stepsArray[d];if(e===b){c=d;break}if(a.isDate(e)){if(e.getTime()===b.getTime()){c=d;break}}else if(a.isObject(e)&&(a.isDate(e.value)&&e.value.getTime()===b.getTime()||e.value===b)){c=d;break}}return c},syncLowValue:function(){this.options.stepsArray?this.options.bindIndexForStepsArray?this.lowValue=this.scope.rzSliderModel:this.lowValue=this.findStepIndex(this.scope.rzSliderModel):this.lowValue=this.scope.rzSliderModel},syncHighValue:function(){this.options.stepsArray?this.options.bindIndexForStepsArray?this.highValue=this.scope.rzSliderHigh:this.highValue=this.findStepIndex(this.scope.rzSliderHigh):this.highValue=this.scope.rzSliderHigh},getStepValue:function(b){var c=this.options.stepsArray[b];return a.isDate(c)?c:a.isObject(c)?c.value:c},applyLowValue:function(){this.options.stepsArray?this.options.bindIndexForStepsArray?this.scope.rzSliderModel=this.lowValue:this.scope.rzSliderModel=this.getStepValue(this.lowValue):this.scope.rzSliderModel=this.lowValue},applyHighValue:function(){this.options.stepsArray?this.options.bindIndexForStepsArray?this.scope.rzSliderHigh=this.highValue:this.scope.rzSliderHigh=this.getStepValue(this.highValue):this.scope.rzSliderHigh=this.highValue},onLowHandleChange:function(){this.syncLowValue(),this.range&&this.syncHighValue(),this.setMinAndMax(),this.updateLowHandle(this.valueToPosition(this.lowValue)),this.updateSelectionBar(),this.updateTicksScale(),this.updateAriaAttributes(),this.range&&this.updateCmbLabel()},onHighHandleChange:function(){this.syncLowValue(),this.syncHighValue(),this.setMinAndMax(),this.updateHighHandle(this.valueToPosition(this.highValue)),this.updateSelectionBar(),this.updateTicksScale(),this.updateCmbLabel(),this.updateAriaAttributes()},applyOptions:function(){var b;b=this.scope.rzSliderOptions?this.scope.rzSliderOptions():{},this.options=f.getOptions(b),this.options.step<=0&&(this.options.step=1),this.range=void 0!==this.scope.rzSliderModel&&void 0!==this.scope.rzSliderHigh,this.options.draggableRange=this.range&&this.options.draggableRange,this.options.draggableRangeOnly=this.range&&this.options.draggableRangeOnly,this.options.draggableRangeOnly&&(this.options.draggableRange=!0),this.options.showTicks=this.options.showTicks||this.options.showTicksValues||!!this.options.ticksArray,this.scope.showTicks=this.options.showTicks,(a.isNumber(this.options.showTicks)||this.options.ticksArray)&&(this.intermediateTicks=!0),this.options.showSelectionBar=this.options.showSelectionBar||this.options.showSelectionBarEnd||null!==this.options.showSelectionBarFromValue,this.options.stepsArray?this.parseStepsArray():(this.options.translate?this.customTrFn=this.options.translate:this.customTrFn=function(a){return String(a)},this.getLegend=this.options.getLegend),this.options.vertical&&(this.positionProperty="bottom",this.dimensionProperty="height"),this.options.customTemplateScope&&(this.scope.custom=this.options.customTemplateScope)},parseStepsArray:function(){this.options.floor=0,this.options.ceil=this.options.stepsArray.length-1,this.options.step=1,this.options.translate?this.customTrFn=this.options.translate:this.customTrFn=function(a){return this.options.bindIndexForStepsArray?this.getStepValue(a):a},this.getLegend=function(b){var c=this.options.stepsArray[b];return a.isObject(c)?c.legend:null}},resetSlider:function(){this.manageElementsStyle(),this.addAccessibility(),this.setMinAndMax(),this.updateCeilLab(),this.updateFloorLab(),this.unbindEvents(),this.manageEventsBindings(),this.setDisabledState(),this.calcViewDimensions(),this.updateRestrictionBar(),this.refocusPointerIfNeeded()},refocusPointerIfNeeded:function(){this.currentFocusElement&&(this.onPointerFocus(this.currentFocusElement.pointer,this.currentFocusElement.ref),this.focusElement(this.currentFocusElement.pointer))},initElemHandles:function(){a.forEach(this.sliderElem.children(),function(b,c){var d=a.element(b);switch(c){case 0:this.leftOutSelBar=d;break;case 1:this.rightOutSelBar=d;break;case 2:this.fullBar=d;break;case 3:this.selBar=d;break;case 4:this.restrictedBar=d;break;case 5:this.minH=d;break;case 6:this.maxH=d;break;case 7:this.flrLab=d;break;case 8:this.ceilLab=d;break;case 9:this.minLab=d;break;case 10:this.maxLab=d;break;case 11:this.cmbLab=d;break;case 12:this.ticks=d}},this),this.selBar.rzsp=0,this.minH.rzsp=0,this.maxH.rzsp=0,this.flrLab.rzsp=0,this.ceilLab.rzsp=0,this.minLab.rzsp=0,this.maxLab.rzsp=0,this.cmbLab.rzsp=0},manageElementsStyle:function(){this.range?this.maxH.css("display",""):this.maxH.css("display","none"),this.alwaysHide(this.flrLab,this.options.showTicksValues||this.options.hideLimitLabels),this.alwaysHide(this.ceilLab,this.options.showTicksValues||this.options.hideLimitLabels);var a=this.options.showTicksValues&&!this.intermediateTicks;this.alwaysHide(this.minLab,a||this.options.hidePointerLabels),this.alwaysHide(this.maxLab,a||!this.range||this.options.hidePointerLabels),this.alwaysHide(this.cmbLab,a||!this.range||this.options.hidePointerLabels),this.alwaysHide(this.selBar,!this.range&&!this.options.showSelectionBar),this.alwaysHide(this.leftOutSelBar,!this.range||!this.options.showOuterSelectionBars),this.alwaysHide(this.restrictedBar,!this.options.restrictedRange),this.alwaysHide(this.rightOutSelBar,!this.range||!this.options.showOuterSelectionBars),this.range&&this.options.showOuterSelectionBars&&this.fullBar.addClass("rz-transparent"),this.options.vertical&&this.sliderElem.addClass("rz-vertical"),this.options.draggableRange?this.selBar.addClass("rz-draggable"):this.selBar.removeClass("rz-draggable"),this.intermediateTicks&&this.options.showTicksValues&&this.ticks.addClass("rz-ticks-values-under")},alwaysHide:function(a,b){a.rzAlwaysHide=b,b?this.hideEl(a):this.showEl(a)},manageEventsBindings:function(){this.options.disabled||this.options.readOnly?this.unbindEvents():this.bindEvents()},setDisabledState:function(){this.options.disabled?this.sliderElem.attr("disabled","disabled"):this.sliderElem.attr("disabled",null)},resetLabelsValue:function(){this.minLab.rzsv=void 0,this.maxLab.rzsv=void 0},initHandles:function(){this.updateLowHandle(this.valueToPosition(this.lowValue)),this.range&&this.updateHighHandle(this.valueToPosition(this.highValue)),this.updateSelectionBar(),this.range&&this.updateCmbLabel(),this.updateTicksScale()},translateFn:function(a,b,c,d){d=void 0===d?!0:d;var e="",f=!1,g=b.hasClass("no-label-injection");d?(this.options.stepsArray&&!this.options.bindIndexForStepsArray&&(a=this.getStepValue(a)),e=String(this.customTrFn(a,this.options.id,c))):e=String(a),(void 0===b.rzsv||b.rzsv.length!==e.length||b.rzsv.length>0&&0===b.rzsd)&&(f=!0,b.rzsv=e),g||b.html(e),this.scope[c+"Label"]=e,f&&this.getDimension(b)},setMinAndMax:function(){if(this.step=+this.options.step,this.precision=+this.options.precision,this.minValue=this.options.floor,this.options.logScale&&0===this.minValue)throw Error("Can't use floor=0 with logarithmic scale");this.options.enforceStep&&(this.lowValue=this.roundStep(this.lowValue),this.range&&(this.highValue=this.roundStep(this.highValue))),null!=this.options.ceil?this.maxValue=this.options.ceil:this.maxValue=this.options.ceil=this.range?this.highValue:this.lowValue,this.options.enforceRange&&(this.lowValue=this.sanitizeValue(this.lowValue),this.range&&(this.highValue=this.sanitizeValue(this.highValue))),this.applyLowValue(),this.range&&this.applyHighValue(),this.valueRange=this.maxValue-this.minValue},addAccessibility:function(){this.minH.attr("role","slider"),this.updateAriaAttributes(),!this.options.keyboardSupport||this.options.readOnly||this.options.disabled?this.minH.attr("tabindex",""):this.minH.attr("tabindex","0"),this.options.vertical&&this.minH.attr("aria-orientation","vertical"),this.options.ariaLabel?this.minH.attr("aria-label",this.options.ariaLabel):this.options.ariaLabelledBy&&this.minH.attr("aria-labelledby",this.options.ariaLabelledBy),this.range&&(this.maxH.attr("role","slider"),!this.options.keyboardSupport||this.options.readOnly||this.options.disabled?this.maxH.attr("tabindex",""):this.maxH.attr("tabindex","0"),this.options.vertical&&this.maxH.attr("aria-orientation","vertical"),this.options.ariaLabelHigh?this.maxH.attr("aria-label",this.options.ariaLabelHigh):this.options.ariaLabelledByHigh&&this.maxH.attr("aria-labelledby",this.options.ariaLabelledByHigh))},updateAriaAttributes:function(){this.minH.attr({"aria-valuenow":this.scope.rzSliderModel,"aria-valuetext":this.customTrFn(this.scope.rzSliderModel,this.options.id,"model"),"aria-valuemin":this.minValue,"aria-valuemax":this.maxValue}),this.range&&this.maxH.attr({"aria-valuenow":this.scope.rzSliderHigh,"aria-valuetext":this.customTrFn(this.scope.rzSliderHigh,this.options.id,"high"),"aria-valuemin":this.minValue,"aria-valuemax":this.maxValue})},calcViewDimensions:function(){var a=this.getDimension(this.minH);if(this.handleHalfDim=a/2,this.barDimension=this.getDimension(this.fullBar),this.maxPos=this.barDimension-a,this.getDimension(this.sliderElem),this.sliderElem.rzsp=this.sliderElem[0].getBoundingClientRect()[this.positionProperty],this.initHasRun){this.updateFloorLab(),this.updateCeilLab(),this.initHandles();var c=this;b(function(){c.updateTicksScale()})}},updateTicksScale:function(){if(this.options.showTicks){var b=this.options.ticksArray||this.getTicksArray(),c=this.options.vertical?"translateY":"translateX",d=this;this.options.rightToLeft&&b.reverse(),this.scope.ticks=b.map(function(b){var e=null;a.isObject(b)&&(e=b.legend,b=b.value);var f=d.valueToPosition(b);d.options.vertical&&(f=d.maxPos-f);var g=c+"("+Math.round(f)+"px)",h={legend:e,selected:d.isTickSelected(b),style:{"-webkit-transform":g,"-moz-transform":g,"-o-transform":g,"-ms-transform":g,transform:g}};return h.selected&&d.options.getSelectionBarColor&&(h.style["background-color"]=d.getSelectionBarColor()),!h.selected&&d.options.getTickColor&&(h.style["background-color"]=d.getTickColor(b)),d.options.ticksTooltip&&(h.tooltip=d.options.ticksTooltip(b),h.tooltipPlacement=d.options.vertical?"right":"top"),(d.options.showTicksValues===!0||b%d.options.showTicksValues===0)&&(h.value=d.getDisplayValue(b,"tick-value"),d.options.ticksValuesTooltip&&(h.valueTooltip=d.options.ticksValuesTooltip(b),h.valueTooltipPlacement=d.options.vertical?"right":"top")),d.getLegend&&(e=d.getLegend(b,d.options.id),e&&(h.legend=e)),h})}},getTicksArray:function(){var a=this.step,b=[];this.intermediateTicks&&(a=this.options.showTicks);for(var c=this.minValue;c<=this.maxValue;c+=a)b.push(c);return b},isTickSelected:function(a){if(!this.range)if(null!==this.options.showSelectionBarFromValue){var b=this.options.showSelectionBarFromValue;if(this.lowValue>b&&a>=b&&a<=this.lowValue)return!0;if(this.lowValue<b&&b>=a&&a>=this.lowValue)return!0}else if(this.options.showSelectionBarEnd){if(a>=this.lowValue)return!0}else if(this.options.showSelectionBar&&a<=this.lowValue)return!0;return this.range&&a>=this.lowValue&&a<=this.highValue?!0:!1},updateFloorLab:function(){this.translateFn(this.minValue,this.flrLab,"floor"),this.getDimension(this.flrLab);var a=this.options.rightToLeft?this.barDimension-this.flrLab.rzsd:0;this.setPosition(this.flrLab,a)},updateCeilLab:function(){this.translateFn(this.maxValue,this.ceilLab,"ceil"),this.getDimension(this.ceilLab);var a=this.options.rightToLeft?0:this.barDimension-this.ceilLab.rzsd;this.setPosition(this.ceilLab,a)},updateHandles:function(a,b){"lowValue"===a?this.updateLowHandle(b):this.updateHighHandle(b),this.updateSelectionBar(),this.updateTicksScale(),this.range&&this.updateCmbLabel()},getHandleLabelPos:function(a,b){var c=this[a].rzsd,d=b-c/2+this.handleHalfDim,e=this.barDimension-c;return this.options.boundPointerLabels?this.options.rightToLeft&&"minLab"===a||!this.options.rightToLeft&&"maxLab"===a?Math.min(d,e):Math.min(Math.max(d,0),e):d},updateLowHandle:function(a){if(this.setPosition(this.minH,a),this.translateFn(this.lowValue,this.minLab,"model"),this.setPosition(this.minLab,this.getHandleLabelPos("minLab",a)),this.options.getPointerColor){var b=this.getPointerColor("min");this.scope.minPointerStyle={backgroundColor:b}}this.options.autoHideLimitLabels&&this.shFloorCeil()},updateHighHandle:function(a){if(this.setPosition(this.maxH,a),this.translateFn(this.highValue,this.maxLab,"high"),this.setPosition(this.maxLab,this.getHandleLabelPos("maxLab",a)),this.options.getPointerColor){var b=this.getPointerColor("max");this.scope.maxPointerStyle={backgroundColor:b}}this.options.autoHideLimitLabels&&this.shFloorCeil()},shFloorCeil:function(){if(!this.options.hidePointerLabels){var a=!1,b=!1,c=this.isLabelBelowFloorLab(this.minLab),d=this.isLabelAboveCeilLab(this.minLab),e=this.isLabelAboveCeilLab(this.maxLab),f=this.isLabelBelowFloorLab(this.cmbLab),g=this.isLabelAboveCeilLab(this.cmbLab);if(c?(a=!0,this.hideEl(this.flrLab)):(a=!1,this.showEl(this.flrLab)),d?(b=!0,this.hideEl(this.ceilLab)):(b=!1,this.showEl(this.ceilLab)),this.range){var h=this.cmbLabelShown?g:e,i=this.cmbLabelShown?f:c;h?this.hideEl(this.ceilLab):b||this.showEl(this.ceilLab),i?this.hideEl(this.flrLab):a||this.showEl(this.flrLab)}}},isLabelBelowFloorLab:function(a){var b=this.options.rightToLeft,c=a.rzsp,d=a.rzsd,e=this.flrLab.rzsp,f=this.flrLab.rzsd;return b?c+d>=e-2:e+f+2>=c},isLabelAboveCeilLab:function(a){var b=this.options.rightToLeft,c=a.rzsp,d=a.rzsd,e=this.ceilLab.rzsp,f=this.ceilLab.rzsd;return b?e+f+2>=c:c+d>=e-2},updateRestrictionBar:function(){var a=0,b=0;if(this.options.restrictedRange){var c=this.valueToPosition(this.options.restrictedRange.from),d=this.valueToPosition(this.options.restrictedRange.to);b=Math.abs(d-c),a=this.options.rightToLeft?d+this.handleHalfDim:c+this.handleHalfDim,this.setDimension(this.restrictedBar,b),this.setPosition(this.restrictedBar,a)}},updateSelectionBar:function(){var a=0,b=0,c=this.options.rightToLeft?!this.options.showSelectionBarEnd:this.options.showSelectionBarEnd,d=this.options.rightToLeft?this.maxH.rzsp+this.handleHalfDim:this.minH.rzsp+this.handleHalfDim;if(this.range)b=Math.abs(this.maxH.rzsp-this.minH.rzsp),a=d;else if(null!==this.options.showSelectionBarFromValue){var e=this.options.showSelectionBarFromValue,f=this.valueToPosition(e),g=this.options.rightToLeft?this.lowValue<=e:this.lowValue>e;g?(b=this.minH.rzsp-f,a=f+this.handleHalfDim):(b=f-this.minH.rzsp,a=this.minH.rzsp+this.handleHalfDim)}else c?(b=Math.abs(this.maxPos-this.minH.rzsp)+this.handleHalfDim,a=this.minH.rzsp+this.handleHalfDim):(b=this.minH.rzsp+this.handleHalfDim,a=0);if(this.setDimension(this.selBar,b),this.setPosition(this.selBar,a),this.range&&this.options.showOuterSelectionBars&&(this.options.rightToLeft?(this.setDimension(this.rightOutSelBar,a),this.setPosition(this.rightOutSelBar,0),this.setDimension(this.leftOutSelBar,this.getDimension(this.fullBar)-(a+b)),this.setPosition(this.leftOutSelBar,a+b)):(this.setDimension(this.leftOutSelBar,a),this.setPosition(this.leftOutSelBar,0),this.setDimension(this.rightOutSelBar,this.getDimension(this.fullBar)-(a+b)),this.setPosition(this.rightOutSelBar,a+b))),this.options.getSelectionBarColor){var h=this.getSelectionBarColor();this.scope.barStyle={backgroundColor:h}}else if(this.options.selectionBarGradient){var i=null!==this.options.showSelectionBarFromValue?this.valueToPosition(this.options.showSelectionBarFromValue):0,j=i-a>0^c,k=this.options.vertical?j?"bottom":"top":j?"left":"right";this.scope.barStyle={backgroundImage:"linear-gradient(to "+k+", "+this.options.selectionBarGradient.from+" 0%,"+this.options.selectionBarGradient.to+" 100%)"},this.options.vertical?(this.scope.barStyle.backgroundPosition="center "+(i+b+a+(j?-this.handleHalfDim:0))+"px",this.scope.barStyle.backgroundSize="100% "+(this.barDimension-this.handleHalfDim)+"px"):(this.scope.barStyle.backgroundPosition=i-a+(j?this.handleHalfDim:0)+"px center",this.scope.barStyle.backgroundSize=this.barDimension-this.handleHalfDim+"px 100%")}},getSelectionBarColor:function(){return this.range?this.options.getSelectionBarColor(this.scope.rzSliderModel,this.scope.rzSliderHigh):this.options.getSelectionBarColor(this.scope.rzSliderModel)},getPointerColor:function(a){return"max"===a?this.options.getPointerColor(this.scope.rzSliderHigh,a):this.options.getPointerColor(this.scope.rzSliderModel,a)},getTickColor:function(a){return this.options.getTickColor(a)},updateCmbLabel:function(){var a=null;if(a=this.options.rightToLeft?this.minLab.rzsp-this.minLab.rzsd-10<=this.maxLab.rzsp:this.minLab.rzsp+this.minLab.rzsd+10>=this.maxLab.rzsp){var b=this.getDisplayValue(this.lowValue,"model"),c=this.getDisplayValue(this.highValue,"high"),d="";d=this.options.mergeRangeLabelsIfSame&&b===c?b:this.options.rightToLeft?c+this.options.labelOverlapSeparator+b:b+this.options.labelOverlapSeparator+c,this.translateFn(d,this.cmbLab,"cmb",!1);var e=this.options.boundPointerLabels?Math.min(Math.max(this.selBar.rzsp+this.selBar.rzsd/2-this.cmbLab.rzsd/2,0),this.barDimension-this.cmbLab.rzsd):this.selBar.rzsp+this.selBar.rzsd/2-this.cmbLab.rzsd/2;this.setPosition(this.cmbLab,e),this.cmbLabelShown=!0,this.hideEl(this.minLab),this.hideEl(this.maxLab),this.showEl(this.cmbLab)}else this.cmbLabelShown=!1,this.updateHighHandle(this.valueToPosition(this.highValue)),this.updateLowHandle(this.valueToPosition(this.lowValue)),this.showEl(this.maxLab),this.showEl(this.minLab),this.hideEl(this.cmbLab);this.options.autoHideLimitLabels&&this.shFloorCeil()},getDisplayValue:function(a,b){return this.options.stepsArray&&!this.options.bindIndexForStepsArray&&(a=this.getStepValue(a)),this.customTrFn(a,this.options.id,b)},roundStep:function(a,b){var c=b?b:this.step,d=parseFloat((a-this.minValue)/c).toPrecision(12);d=Math.round(+d)*c;var e=(this.minValue+d).toFixed(this.precision);return+e},hideEl:function(a){return a.css({visibility:"hidden"})},showEl:function(a){return a.rzAlwaysHide?a:a.css({visibility:"visible"})},setPosition:function(a,b){a.rzsp=b;var c={};return c[this.positionProperty]=Math.round(b)+"px",a.css(c),b},getDimension:function(a){var b=a[0].getBoundingClientRect();return this.options.vertical?a.rzsd=(b.bottom-b.top)*this.options.scale:a.rzsd=(b.right-b.left)*this.options.scale,a.rzsd},setDimension:function(a,b){a.rzsd=b;var c={};return c[this.dimensionProperty]=Math.round(b)+"px",a.css(c),b},sanitizeValue:function(a){return Math.min(Math.max(a,this.minValue),this.maxValue)},valueToPosition:function(a){var b=this.linearValueToPosition;this.options.customValueToPosition?b=this.options.customValueToPosition:this.options.logScale&&(b=this.logValueToPosition),a=this.sanitizeValue(a);var c=b(a,this.minValue,this.maxValue)||0;return this.options.rightToLeft&&(c=1-c),c*this.maxPos},linearValueToPosition:function(a,b,c){var d=c-b;return(a-b)/d},logValueToPosition:function(a,b,c){a=Math.log(a),b=Math.log(b),c=Math.log(c);var d=c-b;return(a-b)/d},positionToValue:function(a){var b=a/this.maxPos;this.options.rightToLeft&&(b=1-b);var c=this.linearPositionToValue;return this.options.customPositionToValue?c=this.options.customPositionToValue:this.options.logScale&&(c=this.logPositionToValue),c(b,this.minValue,this.maxValue)||0},linearPositionToValue:function(a,b,c){return a*(c-b)+b},logPositionToValue:function(a,b,c){b=Math.log(b),c=Math.log(c);var d=a*(c-b)+b;return Math.exp(d)},getEventAttr:function(a,b){return void 0===a.originalEvent?a[b]:a.originalEvent[b]},getEventXY:function(a,b){var c=this.options.vertical?"clientY":"clientX";if(void 0!==a[c])return a[c];var d=this.getEventAttr(a,"touches");if(void 0!==b)for(var e=0;e<d.length;e++)if(d[e].identifier===b)return d[e][c];return d[0][c]},getEventPosition:function(a,b){var c=this.sliderElem.rzsp,d=0;return d=this.options.vertical?-this.getEventXY(a,b)+c:this.getEventXY(a,b)-c,d*this.options.scale-this.handleHalfDim},getEventNames:function(a){var b={moveEvent:"",endEvent:""};return this.getEventAttr(a,"touches")?(b.moveEvent="touchmove",b.endEvent="touchend"):(b.moveEvent="mousemove",b.endEvent="mouseup"),b},getNearestHandle:function(a){if(!this.range)return this.minH;var b=this.getEventPosition(a),c=Math.abs(b-this.minH.rzsp),d=Math.abs(b-this.maxH.rzsp);return d>c?this.minH:c>d?this.maxH:this.options.rightToLeft?b>this.minH.rzsp?this.minH:this.maxH:b<this.minH.rzsp?this.minH:this.maxH},focusElement:function(a){var b=0;a[b].focus()},bindEvents:function(){var b,c,d;this.options.draggableRange?(b="rzSliderDrag",c=this.onDragStart,d=this.onDragMove):(b="lowValue",c=this.onStart,d=this.onMove),this.options.onlyBindHandles||(this.selBar.on("mousedown",a.bind(this,c,null,b)),this.selBar.on("mousedown",a.bind(this,d,this.selBar))),this.options.draggableRangeOnly?(this.minH.on("mousedown",a.bind(this,c,null,b)),this.maxH.on("mousedown",a.bind(this,c,null,b))):(this.minH.on("mousedown",a.bind(this,this.onStart,this.minH,"lowValue")),this.range&&this.maxH.on("mousedown",a.bind(this,this.onStart,this.maxH,"highValue")),this.options.onlyBindHandles||(this.fullBar.on("mousedown",a.bind(this,this.onStart,null,null)),this.fullBar.on("mousedown",a.bind(this,this.onMove,this.fullBar)),this.ticks.on("mousedown",a.bind(this,this.onStart,null,null)),this.ticks.on("mousedown",a.bind(this,this.onTickClick,this.ticks)))),this.options.onlyBindHandles||(this.selBar.on("touchstart",a.bind(this,c,null,b)),this.selBar.on("touchstart",a.bind(this,d,this.selBar))),this.options.draggableRangeOnly?(this.minH.on("touchstart",a.bind(this,c,null,b)),this.maxH.on("touchstart",a.bind(this,c,null,b))):(this.minH.on("touchstart",a.bind(this,this.onStart,this.minH,"lowValue")),this.range&&this.maxH.on("touchstart",a.bind(this,this.onStart,this.maxH,"highValue")),this.options.onlyBindHandles||(this.fullBar.on("touchstart",a.bind(this,this.onStart,null,null)),this.fullBar.on("touchstart",a.bind(this,this.onMove,this.fullBar)),this.ticks.on("touchstart",a.bind(this,this.onStart,null,null)),this.ticks.on("touchstart",a.bind(this,this.onTickClick,this.ticks)))),this.options.keyboardSupport&&(this.minH.on("focus",a.bind(this,this.onPointerFocus,this.minH,"lowValue")),this.range&&this.maxH.on("focus",a.bind(this,this.onPointerFocus,this.maxH,"highValue")))},unbindEvents:function(){this.minH.off(),this.maxH.off(),this.fullBar.off(),this.selBar.off(),this.ticks.off()},onStart:function(b,d,e){var f,g,h=this.getEventNames(e);e.stopPropagation(),e.preventDefault(),this.calcViewDimensions(),b?this.tracking=d:(b=this.getNearestHandle(e),this.tracking=b===this.minH?"lowValue":"highValue"),b.addClass("rz-active"),this.options.keyboardSupport&&this.focusElement(b),f=a.bind(this,this.dragging.active?this.onDragMove:this.onMove,b),g=a.bind(this,this.onEnd,f),c.on(h.moveEvent,f),c.on(h.endEvent,g),this.endHandlerToBeRemovedOnEnd=g,this.callOnStart();var i=this.getEventAttr(e,"changedTouches");i&&(this.touchId||(this.isDragging=!0,this.touchId=i[0].identifier))},onMove:function(b,c,d){var e,f=this.getEventAttr(c,"changedTouches");if(f)for(var g=0;g<f.length;g++)if(f[g].identifier===this.touchId){e=f[g];break}if(!f||e){var h,i=this.getEventPosition(c,e?e.identifier:void 0),j=this.options.rightToLeft?this.minValue:this.maxValue,k=this.options.rightToLeft?this.maxValue:this.minValue;0>=i?h=k:i>=this.maxPos?h=j:(h=this.positionToValue(i),h=d&&a.isNumber(this.options.showTicks)?this.roundStep(h,this.options.showTicks):this.roundStep(h)),this.positionTrackingHandle(h)}},onEnd:function(a,b){var d=this.getEventAttr(b,"changedTouches");if(!d||d[0].identifier===this.touchId){this.isDragging=!1,this.touchId=null,this.options.keyboardSupport||(this.minH.removeClass("rz-active"),this.maxH.removeClass("rz-active"),this.tracking=""),this.dragging.active=!1;var e=this.getEventNames(b);c.off(e.moveEvent,a),c.off(e.endEvent,this.endHandlerToBeRemovedOnEnd),this.endHandlerToBeRemovedOnEnd=null,this.callOnEnd()}},onTickClick:function(a,b){this.onMove(a,b,!0)},onPointerFocus:function(b,c){this.tracking=c,b.one("blur",a.bind(this,this.onPointerBlur,b)),b.on("keydown",a.bind(this,this.onKeyboardEvent)),b.on("keyup",a.bind(this,this.onKeyUp)),this.firstKeyDown=!0,b.addClass("rz-active"),this.currentFocusElement={pointer:b,ref:c}},onKeyUp:function(){this.firstKeyDown=!0,this.callOnEnd()},onPointerBlur:function(a){a.off("keydown"),a.off("keyup"),a.removeClass("rz-active"),this.isDragging||(this.tracking="",this.currentFocusElement=null)},getKeyActions:function(a){var b=a+this.step,c=a-this.step,d=a+this.valueRange/10,e=a-this.valueRange/10;this.options.reversedControls&&(b=a-this.step,c=a+this.step,d=a-this.valueRange/10,e=a+this.valueRange/10);var f={UP:b,DOWN:c,LEFT:c,RIGHT:b,PAGEUP:d,PAGEDOWN:e,HOME:this.options.reversedControls?this.maxValue:this.minValue,END:this.options.reversedControls?this.minValue:this.maxValue};return this.options.rightToLeft&&(f.LEFT=b,f.RIGHT=c,this.options.vertical&&(f.UP=c,f.DOWN=b)),f},onKeyboardEvent:function(a){var c=this[this.tracking],d=a.keyCode||a.which,e={38:"UP",40:"DOWN",37:"LEFT",39:"RIGHT",33:"PAGEUP",34:"PAGEDOWN",36:"HOME",35:"END"},f=this.getKeyActions(c),g=e[d],h=f[g];if(null!=h&&""!==this.tracking){a.preventDefault(),this.firstKeyDown&&(this.firstKeyDown=!1,this.callOnStart());var i=this;b(function(){var a=i.roundStep(i.sanitizeValue(h));if(i.options.draggableRangeOnly){var b,c,d=i.highValue-i.lowValue;"lowValue"===i.tracking?(b=a,c=a+d,c>i.maxValue&&(c=i.maxValue,b=c-d)):(c=a,b=a-d,b<i.minValue&&(b=i.minValue,c=b+d)),i.positionTrackingBar(b,c)}else i.positionTrackingHandle(a)})}},onDragStart:function(a,b,c){var d=this.getEventPosition(c);this.dragging={active:!0,value:this.positionToValue(d),difference:this.highValue-this.lowValue,lowLimit:this.options.rightToLeft?this.minH.rzsp-d:d-this.minH.rzsp,highLimit:this.options.rightToLeft?d-this.maxH.rzsp:this.maxH.rzsp-d},this.onStart(a,b,c)},getValue:function(a,b,c,d){var e=this.options.rightToLeft,f=null;return f="min"===a?c?d?e?this.minValue:this.maxValue-this.dragging.difference:e?this.maxValue-this.dragging.difference:this.minValue:e?this.positionToValue(b+this.dragging.lowLimit):this.positionToValue(b-this.dragging.lowLimit):c?d?e?this.minValue+this.dragging.difference:this.maxValue:e?this.maxValue:this.minValue+this.dragging.difference:e?this.positionToValue(b+this.dragging.lowLimit)+this.dragging.difference:this.positionToValue(b-this.dragging.lowLimit)+this.dragging.difference,this.roundStep(f)},onDragMove:function(a,b){var c,d,e,f,g,h,i,j,k=this.getEventPosition(b);if(this.options.rightToLeft?(e=this.dragging.lowLimit,f=this.dragging.highLimit,i=this.maxH,j=this.minH):(e=this.dragging.highLimit,f=this.dragging.lowLimit,i=this.minH,j=this.maxH),g=f>=k,h=k>=this.maxPos-e,g){if(0===i.rzsp)return;c=this.getValue("min",k,!0,!1),d=this.getValue("max",k,!0,!1)}else if(h){if(j.rzsp===this.maxPos)return;d=this.getValue("max",k,!0,!0),c=this.getValue("min",k,!0,!0)}else c=this.getValue("min",k,!1),d=this.getValue("max",k,!1);this.positionTrackingBar(c,d)},positionTrackingBar:function(a,b){null!=this.options.minLimit&&a<this.options.minLimit&&(a=this.options.minLimit,b=a+this.dragging.difference),null!=this.options.maxLimit&&b>this.options.maxLimit&&(b=this.options.maxLimit,a=b-this.dragging.difference),this.lowValue=a,this.highValue=b,this.applyLowValue(),this.range&&this.applyHighValue(),this.applyModel(!0),this.updateHandles("lowValue",this.valueToPosition(a)),this.updateHandles("highValue",this.valueToPosition(b))},positionTrackingHandle:function(a){var b=!1;a=this.applyMinMaxLimit(a),a=this.applyRestrictedRange(a),this.range&&(this.options.pushRange?(a=this.applyPushRange(a),b=!0):(this.options.noSwitching&&("lowValue"===this.tracking&&a>this.highValue?a=this.applyMinMaxRange(this.highValue):"highValue"===this.tracking&&a<this.lowValue&&(a=this.applyMinMaxRange(this.lowValue))),a=this.applyMinMaxRange(a),"lowValue"===this.tracking&&a>this.highValue?(this.lowValue=this.highValue,this.applyLowValue(),this.applyModel(),this.updateHandles(this.tracking,this.maxH.rzsp),this.updateAriaAttributes(),this.tracking="highValue",this.minH.removeClass("rz-active"),this.maxH.addClass("rz-active"),
this.options.keyboardSupport&&this.focusElement(this.maxH),b=!0):"highValue"===this.tracking&&a<this.lowValue&&(this.highValue=this.lowValue,this.applyHighValue(),this.applyModel(),this.updateHandles(this.tracking,this.minH.rzsp),this.updateAriaAttributes(),this.tracking="lowValue",this.maxH.removeClass("rz-active"),this.minH.addClass("rz-active"),this.options.keyboardSupport&&this.focusElement(this.minH),b=!0))),this[this.tracking]!==a&&(this[this.tracking]=a,"lowValue"===this.tracking?this.applyLowValue():this.applyHighValue(),this.applyModel(),this.updateHandles(this.tracking,this.valueToPosition(a)),this.updateAriaAttributes(),b=!0),b&&this.applyModel(!0)},applyMinMaxLimit:function(a){return null!=this.options.minLimit&&a<this.options.minLimit?this.options.minLimit:null!=this.options.maxLimit&&a>this.options.maxLimit?this.options.maxLimit:a},applyMinMaxRange:function(a){var b="lowValue"===this.tracking?this.highValue:this.lowValue,c=Math.abs(a-b);return null!=this.options.minRange&&c<this.options.minRange?"lowValue"===this.tracking?this.highValue-this.options.minRange:this.lowValue+this.options.minRange:null!=this.options.maxRange&&c>this.options.maxRange?"lowValue"===this.tracking?this.highValue-this.options.maxRange:this.lowValue+this.options.maxRange:a},applyRestrictedRange:function(a){if(null!=this.options.restrictedRange&&a>this.options.restrictedRange.from&&a<this.options.restrictedRange.to){var b=(this.options.restrictedRange.to-this.options.restrictedRange.from)/2;if("lowValue"===this.tracking)return a>this.options.restrictedRange.from+b?this.options.restrictedRange.to:this.options.restrictedRange.from;if("highValue"===this.tracking)return a<this.options.restrictedRange.to-b?this.options.restrictedRange.from:this.options.restrictedRange.to}return a},applyPushRange:function(a){var b="lowValue"===this.tracking?this.highValue-a:a-this.lowValue,c=null!==this.options.minRange?this.options.minRange:this.options.step,d=this.options.maxRange;return c>b?("lowValue"===this.tracking?(this.highValue=Math.min(a+c,this.maxValue),a=this.highValue-c,this.applyHighValue(),this.updateHandles("highValue",this.valueToPosition(this.highValue))):(this.lowValue=Math.max(a-c,this.minValue),a=this.lowValue+c,this.applyLowValue(),this.updateHandles("lowValue",this.valueToPosition(this.lowValue))),this.updateAriaAttributes()):null!==d&&b>d&&("lowValue"===this.tracking?(this.highValue=a+d,this.applyHighValue(),this.updateHandles("highValue",this.valueToPosition(this.highValue))):(this.lowValue=a-d,this.applyLowValue(),this.updateHandles("lowValue",this.valueToPosition(this.lowValue))),this.updateAriaAttributes()),a},applyModel:function(a){this.internalChange=!0,this.scope.$apply(),a&&this.callOnChange(),this.internalChange=!1},callOnStart:function(){if(this.options.onStart){var a=this,b="lowValue"===this.tracking?"min":"max";this.scope.$evalAsync(function(){a.options.onStart(a.options.id,a.scope.rzSliderModel,a.scope.rzSliderHigh,b)})}},callOnChange:function(){if(this.options.onChange){var a=this,b="lowValue"===this.tracking?"min":"max";this.scope.$evalAsync(function(){a.options.onChange(a.options.id,a.scope.rzSliderModel,a.scope.rzSliderHigh,b)})}},callOnEnd:function(){if(this.options.onEnd){var a=this,b="lowValue"===this.tracking?"min":"max";this.scope.$evalAsync(function(){a.options.onEnd(a.options.id,a.scope.rzSliderModel,a.scope.rzSliderHigh,b)})}this.scope.$emit("slideEnded")}},h}]).directive("rzslider",["RzSlider",function(a){return{restrict:"AE",replace:!0,scope:{rzSliderModel:"=?",rzSliderHigh:"=?",rzSliderOptions:"&?",rzSliderTplUrl:"@"},templateUrl:function(a,b){return b.rzSliderTplUrl||"rzSliderTpl.html"},link:function(b,c){b.slider=new a(b,c)}}}]);return b.run(["$templateCache",function(a){a.put("rzSliderTpl.html",'<div class=rzslider><span class="rz-bar-wrapper rz-left-out-selection"><span class=rz-bar></span></span> <span class="rz-bar-wrapper rz-right-out-selection"><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class="rz-bar rz-selection" ng-style=barStyle></span></span> <span class=rz-bar-wrapper><span class="rz-bar rz-restricted" ng-style=restrictionStyle></span></span> <span class="rz-pointer rz-pointer-min" ng-style=minPointerStyle></span> <span class="rz-pointer rz-pointer-max" ng-style=maxPointerStyle></span> <span class="rz-bubble rz-limit rz-floor"></span> <span class="rz-bubble rz-limit rz-ceil"></span> <span class="rz-bubble rz-model-value"></span> <span class="rz-bubble rz-model-high"></span> <span class=rz-bubble></span><ul ng-show=showTicks class=rz-ticks><li ng-repeat="t in ticks track by $index" class=rz-tick ng-class="{\'rz-selected\': t.selected}" ng-style=t.style ng-attr-uib-tooltip="{{ t.tooltip }}" ng-attr-tooltip-placement={{t.tooltipPlacement}} ng-attr-tooltip-append-to-body="{{ t.tooltip ? true : undefined}}"><span ng-if="t.value != null" class=rz-tick-value ng-attr-uib-tooltip="{{ t.valueTooltip }}" ng-attr-tooltip-placement={{t.valueTooltipPlacement}}>{{ t.value }}</span> <span ng-if="t.legend != null" class=rz-tick-legend>{{ t.legend }}</span></li></ul></div>')}]),b.name}); 
/** **************************************************** **/
/** ********************** angular-cookies ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(p,g,n){'use strict';g.module("ngCookies",["ng"]).factory("$cookies",["$rootScope","$browser",function(e,b){var c={},f={},h,k=!1,l=g.copy,m=g.isUndefined;b.addPollFn(function(){var a=b.cookies();h!=a&&(h=a,l(a,f),l(a,c),k&&e.$apply())})();k=!0;e.$watch(function(){var a,d,e;for(a in f)m(c[a])&&(b.cookies(a,n),delete f[a]);for(a in c)d=c[a],g.isString(d)||(d=""+d,c[a]=d),d!==f[a]&&(b.cookies(a,d),f[a]=d,e=!0);if(e)for(a in d=b.cookies(),c)c[a]!==d[a]&&(m(d[a])?(delete c[a],delete f[a]):c[a]=
f[a]=d[a])});return c}]).factory("$cookieStore",["$cookies",function(e){return{get:function(b){return(b=e[b])?g.fromJson(b):b},put:function(b,c){e[b]=g.toJson(c)},remove:function(b){delete e[b]}}}])})(window,window.angular);
//# sourceMappingURL=angular-cookies.min.js.map
 
/** **************************************************** **/
/** ********************** angular-route ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(q,d,C){'use strict';function v(r,k,h){return{restrict:"ECA",terminal:!0,priority:400,transclude:"element",link:function(a,f,b,c,y){function z(){l&&(h.cancel(l),l=null);m&&(m.$destroy(),m=null);n&&(l=h.leave(n),l.then(function(){l=null}),n=null)}function x(){var b=r.current&&r.current.locals;if(d.isDefined(b&&b.$template)){var b=a.$new(),c=r.current;n=y(b,function(b){h.enter(b,null,n||f).then(function(){!d.isDefined(t)||t&&!a.$eval(t)||k()});z()});m=c.scope=b;m.$emit("$viewContentLoaded");
m.$eval(w)}else z()}var m,n,l,t=b.autoscroll,w=b.onload||"";a.$on("$routeChangeSuccess",x);x()}}}function A(d,k,h){return{restrict:"ECA",priority:-400,link:function(a,f){var b=h.current,c=b.locals;f.html(c.$template);var y=d(f.contents());b.controller&&(c.$scope=a,c=k(b.controller,c),b.controllerAs&&(a[b.controllerAs]=c),f.data("$ngControllerController",c),f.children().data("$ngControllerController",c));y(a)}}}q=d.module("ngRoute",["ng"]).provider("$route",function(){function r(a,f){return d.extend(Object.create(a),
f)}function k(a,d){var b=d.caseInsensitiveMatch,c={originalPath:a,regexp:a},h=c.keys=[];a=a.replace(/([().])/g,"\\$1").replace(/(\/)?:(\w+)([\?\*])?/g,function(a,d,b,c){a="?"===c?c:null;c="*"===c?c:null;h.push({name:b,optional:!!a});d=d||"";return""+(a?"":d)+"(?:"+(a?d:"")+(c&&"(.+?)"||"([^/]+)")+(a||"")+")"+(a||"")}).replace(/([\/$\*])/g,"\\$1");c.regexp=new RegExp("^"+a+"$",b?"i":"");return c}var h={};this.when=function(a,f){var b=d.copy(f);d.isUndefined(b.reloadOnSearch)&&(b.reloadOnSearch=!0);
d.isUndefined(b.caseInsensitiveMatch)&&(b.caseInsensitiveMatch=this.caseInsensitiveMatch);h[a]=d.extend(b,a&&k(a,b));if(a){var c="/"==a[a.length-1]?a.substr(0,a.length-1):a+"/";h[c]=d.extend({redirectTo:a},k(c,b))}return this};this.caseInsensitiveMatch=!1;this.otherwise=function(a){"string"===typeof a&&(a={redirectTo:a});this.when(null,a);return this};this.$get=["$rootScope","$location","$routeParams","$q","$injector","$templateRequest","$sce",function(a,f,b,c,k,q,x){function m(b){var e=s.current;
(v=(p=l())&&e&&p.$$route===e.$$route&&d.equals(p.pathParams,e.pathParams)&&!p.reloadOnSearch&&!w)||!e&&!p||a.$broadcast("$routeChangeStart",p,e).defaultPrevented&&b&&b.preventDefault()}function n(){var u=s.current,e=p;if(v)u.params=e.params,d.copy(u.params,b),a.$broadcast("$routeUpdate",u);else if(e||u)w=!1,(s.current=e)&&e.redirectTo&&(d.isString(e.redirectTo)?f.path(t(e.redirectTo,e.params)).search(e.params).replace():f.url(e.redirectTo(e.pathParams,f.path(),f.search())).replace()),c.when(e).then(function(){if(e){var a=
d.extend({},e.resolve),b,g;d.forEach(a,function(b,e){a[e]=d.isString(b)?k.get(b):k.invoke(b,null,null,e)});d.isDefined(b=e.template)?d.isFunction(b)&&(b=b(e.params)):d.isDefined(g=e.templateUrl)&&(d.isFunction(g)&&(g=g(e.params)),g=x.getTrustedResourceUrl(g),d.isDefined(g)&&(e.loadedTemplateUrl=g,b=q(g)));d.isDefined(b)&&(a.$template=b);return c.all(a)}}).then(function(c){e==s.current&&(e&&(e.locals=c,d.copy(e.params,b)),a.$broadcast("$routeChangeSuccess",e,u))},function(b){e==s.current&&a.$broadcast("$routeChangeError",
e,u,b)})}function l(){var a,b;d.forEach(h,function(c,h){var g;if(g=!b){var k=f.path();g=c.keys;var m={};if(c.regexp)if(k=c.regexp.exec(k)){for(var l=1,n=k.length;l<n;++l){var p=g[l-1],q=k[l];p&&q&&(m[p.name]=q)}g=m}else g=null;else g=null;g=a=g}g&&(b=r(c,{params:d.extend({},f.search(),a),pathParams:a}),b.$$route=c)});return b||h[null]&&r(h[null],{params:{},pathParams:{}})}function t(a,b){var c=[];d.forEach((a||"").split(":"),function(a,d){if(0===d)c.push(a);else{var f=a.match(/(\w+)(?:[?*])?(.*)/),
h=f[1];c.push(b[h]);c.push(f[2]||"");delete b[h]}});return c.join("")}var w=!1,p,v,s={routes:h,reload:function(){w=!0;a.$evalAsync(function(){m();n()})},updateParams:function(a){if(this.current&&this.current.$$route)a=d.extend({},this.current.params,a),f.path(t(this.current.$$route.originalPath,a)),f.search(a);else throw B("norout");}};a.$on("$locationChangeStart",m);a.$on("$locationChangeSuccess",n);return s}]});var B=d.$$minErr("ngRoute");q.provider("$routeParams",function(){this.$get=function(){return{}}});
q.directive("ngView",v);q.directive("ngView",A);v.$inject=["$route","$anchorScroll","$animate"];A.$inject=["$compile","$controller","$route"]})(window,window.angular);
//# sourceMappingURL=angular-route.min.js.map
 
/** **************************************************** **/
/** ********************** angular-resource ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(I,d,B){'use strict';function D(f,q){q=q||{};d.forEach(q,function(d,h){delete q[h]});for(var h in f)!f.hasOwnProperty(h)||"$"===h.charAt(0)&&"$"===h.charAt(1)||(q[h]=f[h]);return q}var w=d.$$minErr("$resource"),C=/^(\.[a-zA-Z_$][0-9a-zA-Z_$]*)+$/;d.module("ngResource",["ng"]).provider("$resource",function(){var f=this;this.defaults={stripTrailingSlashes:!0,actions:{get:{method:"GET"},save:{method:"POST"},query:{method:"GET",isArray:!0},remove:{method:"DELETE"},"delete":{method:"DELETE"}}};
this.$get=["$http","$q",function(q,h){function t(d,g){this.template=d;this.defaults=s({},f.defaults,g);this.urlParams={}}function v(x,g,l,m){function c(b,k){var c={};k=s({},g,k);r(k,function(a,k){u(a)&&(a=a());var d;if(a&&a.charAt&&"@"==a.charAt(0)){d=b;var e=a.substr(1);if(null==e||""===e||"hasOwnProperty"===e||!C.test("."+e))throw w("badmember",e);for(var e=e.split("."),n=0,g=e.length;n<g&&d!==B;n++){var h=e[n];d=null!==d?d[h]:B}}else d=a;c[k]=d});return c}function F(b){return b.resource}function e(b){D(b||
{},this)}var G=new t(x,m);l=s({},f.defaults.actions,l);e.prototype.toJSON=function(){var b=s({},this);delete b.$promise;delete b.$resolved;return b};r(l,function(b,k){var g=/^(POST|PUT|PATCH)$/i.test(b.method);e[k]=function(a,y,m,x){var n={},f,l,z;switch(arguments.length){case 4:z=x,l=m;case 3:case 2:if(u(y)){if(u(a)){l=a;z=y;break}l=y;z=m}else{n=a;f=y;l=m;break}case 1:u(a)?l=a:g?f=a:n=a;break;case 0:break;default:throw w("badargs",arguments.length);}var t=this instanceof e,p=t?f:b.isArray?[]:new e(f),
A={},v=b.interceptor&&b.interceptor.response||F,C=b.interceptor&&b.interceptor.responseError||B;r(b,function(b,a){"params"!=a&&"isArray"!=a&&"interceptor"!=a&&(A[a]=H(b))});g&&(A.data=f);G.setUrlParams(A,s({},c(f,b.params||{}),n),b.url);n=q(A).then(function(a){var c=a.data,g=p.$promise;if(c){if(d.isArray(c)!==!!b.isArray)throw w("badcfg",k,b.isArray?"array":"object",d.isArray(c)?"array":"object");b.isArray?(p.length=0,r(c,function(a){"object"===typeof a?p.push(new e(a)):p.push(a)})):(D(c,p),p.$promise=
g)}p.$resolved=!0;a.resource=p;return a},function(a){p.$resolved=!0;(z||E)(a);return h.reject(a)});n=n.then(function(a){var b=v(a);(l||E)(b,a.headers);return b},C);return t?n:(p.$promise=n,p.$resolved=!1,p)};e.prototype["$"+k]=function(a,b,c){u(a)&&(c=b,b=a,a={});a=e[k].call(this,a,this,b,c);return a.$promise||a}});e.bind=function(b){return v(x,s({},g,b),l)};return e}var E=d.noop,r=d.forEach,s=d.extend,H=d.copy,u=d.isFunction;t.prototype={setUrlParams:function(f,g,l){var m=this,c=l||m.template,h,
e,q=m.urlParams={};r(c.split(/\W/),function(b){if("hasOwnProperty"===b)throw w("badname");!/^\d+$/.test(b)&&b&&(new RegExp("(^|[^\\\\]):"+b+"(\\W|$)")).test(c)&&(q[b]=!0)});c=c.replace(/\\:/g,":");g=g||{};r(m.urlParams,function(b,k){h=g.hasOwnProperty(k)?g[k]:m.defaults[k];d.isDefined(h)&&null!==h?(e=encodeURIComponent(h).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"%20").replace(/%26/gi,"&").replace(/%3D/gi,"=").replace(/%2B/gi,"+"),c=c.replace(new RegExp(":"+
k+"(\\W|$)","g"),function(b,a){return e+a})):c=c.replace(new RegExp("(/?):"+k+"(\\W|$)","g"),function(b,a,c){return"/"==c.charAt(0)?c:a+c})});m.defaults.stripTrailingSlashes&&(c=c.replace(/\/+$/,"")||"/");c=c.replace(/\/\.(?=\w+($|\?))/,".");f.url=c.replace(/\/\\\./,"/.");r(g,function(b,c){m.urlParams[c]||(f.params=f.params||{},f.params[c]=b)})}};return v}]})})(window,window.angular);
//# sourceMappingURL=angular-resource.min.js.map
 
/** **************************************************** **/
/** ********************** angular-animate ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(N,f,W){'use strict';f.module("ngAnimate",["ng"]).directive("ngAnimateChildren",function(){return function(X,r,g){g=g.ngAnimateChildren;f.isString(g)&&0===g.length?r.data("$$ngAnimateChildren",!0):X.$watch(g,function(f){r.data("$$ngAnimateChildren",!!f)})}}).factory("$$animateReflow",["$$rAF","$document",function(f,r){var g=r[0].body;return function(r){return f(function(){r(g.offsetWidth)})}}]).config(["$provide","$animateProvider",function(X,r){function g(f){for(var n=0;n<f.length;n++){var g=
f[n];if(1==g.nodeType)return g}}function ba(f,n){return g(f)==g(n)}var t=f.noop,n=f.forEach,da=r.$$selectors,aa=f.isArray,ea=f.isString,ga=f.isObject,w={running:!0},u;X.decorator("$animate",["$delegate","$$q","$injector","$sniffer","$rootElement","$$asyncCallback","$rootScope","$document","$templateRequest","$$jqLite",function(O,N,M,Y,y,H,P,W,Z,Q){function R(a,c){var b=a.data("$$ngAnimateState")||{};c&&(b.running=!0,b.structural=!0,a.data("$$ngAnimateState",b));return b.disabled||b.running&&b.structural}
function D(a){var c,b=N.defer();b.promise.$$cancelFn=function(){c&&c()};P.$$postDigest(function(){c=a(function(){b.resolve()})});return b.promise}function I(a){if(ga(a))return a.tempClasses&&ea(a.tempClasses)&&(a.tempClasses=a.tempClasses.split(/\s+/)),a}function S(a,c,b){b=b||{};var d={};n(b,function(e,a){n(a.split(" "),function(a){d[a]=e})});var h=Object.create(null);n((a.attr("class")||"").split(/\s+/),function(e){h[e]=!0});var f=[],l=[];n(c&&c.classes||[],function(e,a){var b=h[a],c=d[a]||{};!1===
e?(b||"addClass"==c.event)&&l.push(a):!0===e&&(b&&"removeClass"!=c.event||f.push(a))});return 0<f.length+l.length&&[f.join(" "),l.join(" ")]}function T(a){if(a){var c=[],b={};a=a.substr(1).split(".");(Y.transitions||Y.animations)&&c.push(M.get(da[""]));for(var d=0;d<a.length;d++){var f=a[d],k=da[f];k&&!b[f]&&(c.push(M.get(k)),b[f]=!0)}return c}}function U(a,c,b,d){function h(e,a){var b=e[a],c=e["before"+a.charAt(0).toUpperCase()+a.substr(1)];if(b||c)return"leave"==a&&(c=b,b=null),u.push({event:a,
fn:b}),J.push({event:a,fn:c}),!0}function k(c,l,x){var E=[];n(c,function(a){a.fn&&E.push(a)});var m=0;n(E,function(c,f){var p=function(){a:{if(l){(l[f]||t)();if(++m<E.length)break a;l=null}x()}};switch(c.event){case "setClass":l.push(c.fn(a,e,A,p,d));break;case "animate":l.push(c.fn(a,b,d.from,d.to,p));break;case "addClass":l.push(c.fn(a,e||b,p,d));break;case "removeClass":l.push(c.fn(a,A||b,p,d));break;default:l.push(c.fn(a,p,d))}});l&&0===l.length&&x()}var l=a[0];if(l){d&&(d.to=d.to||{},d.from=
d.from||{});var e,A;aa(b)&&(e=b[0],A=b[1],e?A?b=e+" "+A:(b=e,c="addClass"):(b=A,c="removeClass"));var x="setClass"==c,E=x||"addClass"==c||"removeClass"==c||"animate"==c,p=a.attr("class")+" "+b;if(B(p)){var ca=t,m=[],J=[],g=t,s=[],u=[],p=(" "+p).replace(/\s+/g,".");n(T(p),function(a){!h(a,c)&&x&&(h(a,"addClass"),h(a,"removeClass"))});return{node:l,event:c,className:b,isClassBased:E,isSetClassOperation:x,applyStyles:function(){d&&a.css(f.extend(d.from||{},d.to||{}))},before:function(a){ca=a;k(J,m,function(){ca=
t;a()})},after:function(a){g=a;k(u,s,function(){g=t;a()})},cancel:function(){m&&(n(m,function(a){(a||t)(!0)}),ca(!0));s&&(n(s,function(a){(a||t)(!0)}),g(!0))}}}}}function G(a,c,b,d,h,k,l,e){function A(e){var l="$animate:"+e;J&&J[l]&&0<J[l].length&&H(function(){b.triggerHandler(l,{event:a,className:c})})}function x(){A("before")}function E(){A("after")}function p(){p.hasBeenRun||(p.hasBeenRun=!0,k())}function g(){if(!g.hasBeenRun){m&&m.applyStyles();g.hasBeenRun=!0;l&&l.tempClasses&&n(l.tempClasses,
function(a){u.removeClass(b,a)});var x=b.data("$$ngAnimateState");x&&(m&&m.isClassBased?C(b,c):(H(function(){var e=b.data("$$ngAnimateState")||{};fa==e.index&&C(b,c,a)}),b.data("$$ngAnimateState",x)));A("close");e()}}var m=U(b,a,c,l);if(!m)return p(),x(),E(),g(),t;a=m.event;c=m.className;var J=f.element._data(m.node),J=J&&J.events;d||(d=h?h.parent():b.parent());if(z(b,d))return p(),x(),E(),g(),t;d=b.data("$$ngAnimateState")||{};var L=d.active||{},s=d.totalActive||0,q=d.last;h=!1;if(0<s){s=[];if(m.isClassBased)"setClass"==
q.event?(s.push(q),C(b,c)):L[c]&&(v=L[c],v.event==a?h=!0:(s.push(v),C(b,c)));else if("leave"==a&&L["ng-leave"])h=!0;else{for(var v in L)s.push(L[v]);d={};C(b,!0)}0<s.length&&n(s,function(a){a.cancel()})}!m.isClassBased||m.isSetClassOperation||"animate"==a||h||(h="addClass"==a==b.hasClass(c));if(h)return p(),x(),E(),A("close"),e(),t;L=d.active||{};s=d.totalActive||0;if("leave"==a)b.one("$destroy",function(a){a=f.element(this);var e=a.data("$$ngAnimateState");e&&(e=e.active["ng-leave"])&&(e.cancel(),
C(a,"ng-leave"))});u.addClass(b,"ng-animate");l&&l.tempClasses&&n(l.tempClasses,function(a){u.addClass(b,a)});var fa=K++;s++;L[c]=m;b.data("$$ngAnimateState",{last:m,active:L,index:fa,totalActive:s});x();m.before(function(e){var l=b.data("$$ngAnimateState");e=e||!l||!l.active[c]||m.isClassBased&&l.active[c].event!=a;p();!0===e?g():(E(),m.after(g))});return m.cancel}function q(a){if(a=g(a))a=f.isFunction(a.getElementsByClassName)?a.getElementsByClassName("ng-animate"):a.querySelectorAll(".ng-animate"),
n(a,function(a){a=f.element(a);(a=a.data("$$ngAnimateState"))&&a.active&&n(a.active,function(a){a.cancel()})})}function C(a,c){if(ba(a,y))w.disabled||(w.running=!1,w.structural=!1);else if(c){var b=a.data("$$ngAnimateState")||{},d=!0===c;!d&&b.active&&b.active[c]&&(b.totalActive--,delete b.active[c]);if(d||!b.totalActive)u.removeClass(a,"ng-animate"),a.removeData("$$ngAnimateState")}}function z(a,c){if(w.disabled)return!0;if(ba(a,y))return w.running;var b,d,g;do{if(0===c.length)break;var k=ba(c,y),
l=k?w:c.data("$$ngAnimateState")||{};if(l.disabled)return!0;k&&(g=!0);!1!==b&&(k=c.data("$$ngAnimateChildren"),f.isDefined(k)&&(b=k));d=d||l.running||l.last&&!l.last.isClassBased}while(c=c.parent());return!g||!b&&d}u=Q;y.data("$$ngAnimateState",w);var $=P.$watch(function(){return Z.totalPendingRequests},function(a,c){0===a&&($(),P.$$postDigest(function(){P.$$postDigest(function(){w.running=!1})}))}),K=0,V=r.classNameFilter(),B=V?function(a){return V.test(a)}:function(){return!0};return{animate:function(a,
c,b,d,h){d=d||"ng-inline-animate";h=I(h)||{};h.from=b?c:null;h.to=b?b:c;return D(function(b){return G("animate",d,f.element(g(a)),null,null,t,h,b)})},enter:function(a,c,b,d){d=I(d);a=f.element(a);c=c&&f.element(c);b=b&&f.element(b);R(a,!0);O.enter(a,c,b);return D(function(h){return G("enter","ng-enter",f.element(g(a)),c,b,t,d,h)})},leave:function(a,c){c=I(c);a=f.element(a);q(a);R(a,!0);return D(function(b){return G("leave","ng-leave",f.element(g(a)),null,null,function(){O.leave(a)},c,b)})},move:function(a,
c,b,d){d=I(d);a=f.element(a);c=c&&f.element(c);b=b&&f.element(b);q(a);R(a,!0);O.move(a,c,b);return D(function(h){return G("move","ng-move",f.element(g(a)),c,b,t,d,h)})},addClass:function(a,c,b){return this.setClass(a,c,[],b)},removeClass:function(a,c,b){return this.setClass(a,[],c,b)},setClass:function(a,c,b,d){d=I(d);a=f.element(a);a=f.element(g(a));if(R(a))return O.$$setClassImmediately(a,c,b,d);var h,k=a.data("$$animateClasses"),l=!!k;k||(k={classes:{}});h=k.classes;c=aa(c)?c:c.split(" ");n(c,
function(a){a&&a.length&&(h[a]=!0)});b=aa(b)?b:b.split(" ");n(b,function(a){a&&a.length&&(h[a]=!1)});if(l)return d&&k.options&&(k.options=f.extend(k.options||{},d)),k.promise;a.data("$$animateClasses",k={classes:h,options:d});return k.promise=D(function(e){var l=a.parent(),b=g(a),c=b.parentNode;if(!c||c.$$NG_REMOVED||b.$$NG_REMOVED)e();else{b=a.data("$$animateClasses");a.removeData("$$animateClasses");var c=a.data("$$ngAnimateState")||{},d=S(a,b,c.active);return d?G("setClass",d,a,l,null,function(){d[0]&&
O.$$addClassImmediately(a,d[0]);d[1]&&O.$$removeClassImmediately(a,d[1])},b.options,e):e()}})},cancel:function(a){a.$$cancelFn()},enabled:function(a,c){switch(arguments.length){case 2:if(a)C(c);else{var b=c.data("$$ngAnimateState")||{};b.disabled=!0;c.data("$$ngAnimateState",b)}break;case 1:w.disabled=!a;break;default:a=!w.disabled}return!!a}}}]);r.register("",["$window","$sniffer","$timeout","$$animateReflow",function(r,w,M,Y){function y(){b||(b=Y(function(){c=[];b=null;B={}}))}function H(a,e){b&&
b();c.push(e);b=Y(function(){n(c,function(a){a()});c=[];b=null;B={}})}function P(a,e){var b=g(a);a=f.element(b);k.push(a);b=Date.now()+e;b<=h||(M.cancel(d),h=b,d=M(function(){X(k);k=[]},e,!1))}function X(a){n(a,function(a){(a=a.data("$$ngAnimateCSS3Data"))&&n(a.closeAnimationFns,function(a){a()})})}function Z(a,e){var b=e?B[e]:null;if(!b){var c=0,d=0,f=0,g=0;n(a,function(a){if(1==a.nodeType){a=r.getComputedStyle(a)||{};c=Math.max(Q(a[z+"Duration"]),c);d=Math.max(Q(a[z+"Delay"]),d);g=Math.max(Q(a[K+
"Delay"]),g);var e=Q(a[K+"Duration"]);0<e&&(e*=parseInt(a[K+"IterationCount"],10)||1);f=Math.max(e,f)}});b={total:0,transitionDelay:d,transitionDuration:c,animationDelay:g,animationDuration:f};e&&(B[e]=b)}return b}function Q(a){var e=0;a=ea(a)?a.split(/\s*,\s*/):[];n(a,function(a){e=Math.max(parseFloat(a)||0,e)});return e}function R(b,e,c,d){b=0<=["ng-enter","ng-leave","ng-move"].indexOf(c);var f,p=e.parent(),h=p.data("$$ngAnimateKey");h||(p.data("$$ngAnimateKey",++a),h=a);f=h+"-"+g(e).getAttribute("class");
var p=f+" "+c,h=B[p]?++B[p].total:0,m={};if(0<h){var n=c+"-stagger",m=f+" "+n;(f=!B[m])&&u.addClass(e,n);m=Z(e,m);f&&u.removeClass(e,n)}u.addClass(e,c);var n=e.data("$$ngAnimateCSS3Data")||{},k=Z(e,p);f=k.transitionDuration;k=k.animationDuration;if(b&&0===f&&0===k)return u.removeClass(e,c),!1;c=d||b&&0<f;b=0<k&&0<m.animationDelay&&0===m.animationDuration;e.data("$$ngAnimateCSS3Data",{stagger:m,cacheKey:p,running:n.running||0,itemIndex:h,blockTransition:c,closeAnimationFns:n.closeAnimationFns||[]});
p=g(e);c&&(I(p,!0),d&&e.css(d));b&&(p.style[K+"PlayState"]="paused");return!0}function D(a,e,b,c,d){function f(){e.off(D,h);u.removeClass(e,k);u.removeClass(e,t);z&&M.cancel(z);G(e,b);var a=g(e),c;for(c in s)a.style.removeProperty(s[c])}function h(a){a.stopPropagation();var b=a.originalEvent||a;a=b.$manualTimeStamp||b.timeStamp||Date.now();b=parseFloat(b.elapsedTime.toFixed(3));Math.max(a-H,0)>=B&&b>=y&&c()}var m=g(e);a=e.data("$$ngAnimateCSS3Data");if(-1!=m.getAttribute("class").indexOf(b)&&a){var k=
"",t="";n(b.split(" "),function(a,b){var e=(0<b?" ":"")+a;k+=e+"-active";t+=e+"-pending"});var s=[],q=a.itemIndex,v=a.stagger,r=0;if(0<q){r=0;0<v.transitionDelay&&0===v.transitionDuration&&(r=v.transitionDelay*q);var w=0;0<v.animationDelay&&0===v.animationDuration&&(w=v.animationDelay*q,s.push(C+"animation-play-state"));r=Math.round(100*Math.max(r,w))/100}r||(u.addClass(e,k),a.blockTransition&&I(m,!1));var F=Z(e,a.cacheKey+" "+k),y=Math.max(F.transitionDuration,F.animationDuration);if(0===y)u.removeClass(e,
k),G(e,b),c();else{!r&&d&&0<Object.keys(d).length&&(F.transitionDuration||(e.css("transition",F.animationDuration+"s linear all"),s.push("transition")),e.css(d));var q=Math.max(F.transitionDelay,F.animationDelay),B=1E3*q;0<s.length&&(v=m.getAttribute("style")||"",";"!==v.charAt(v.length-1)&&(v+=";"),m.setAttribute("style",v+" "));var H=Date.now(),D=V+" "+$,q=1E3*(r+1.5*(q+y)),z;0<r&&(u.addClass(e,t),z=M(function(){z=null;0<F.transitionDuration&&I(m,!1);0<F.animationDuration&&(m.style[K+"PlayState"]=
"");u.addClass(e,k);u.removeClass(e,t);d&&(0===F.transitionDuration&&e.css("transition",F.animationDuration+"s linear all"),e.css(d),s.push("transition"))},1E3*r,!1));e.on(D,h);a.closeAnimationFns.push(function(){f();c()});a.running++;P(e,q);return f}}else c()}function I(a,b){a.style[z+"Property"]=b?"none":""}function S(a,b,c,d){if(R(a,b,c,d))return function(a){a&&G(b,c)}}function T(a,b,c,d,f){if(b.data("$$ngAnimateCSS3Data"))return D(a,b,c,d,f);G(b,c);d()}function U(a,b,c,d,f){var g=S(a,b,c,f.from);
if(g){var h=g;H(b,function(){h=T(a,b,c,d,f.to)});return function(a){(h||t)(a)}}y();d()}function G(a,b){u.removeClass(a,b);var c=a.data("$$ngAnimateCSS3Data");c&&(c.running&&c.running--,c.running&&0!==c.running||a.removeData("$$ngAnimateCSS3Data"))}function q(a,b){var c="";a=aa(a)?a:a.split(/\s+/);n(a,function(a,d){a&&0<a.length&&(c+=(0<d?" ":"")+a+b)});return c}var C="",z,$,K,V;N.ontransitionend===W&&N.onwebkittransitionend!==W?(C="-webkit-",z="WebkitTransition",$="webkitTransitionEnd transitionend"):
(z="transition",$="transitionend");N.onanimationend===W&&N.onwebkitanimationend!==W?(C="-webkit-",K="WebkitAnimation",V="webkitAnimationEnd animationend"):(K="animation",V="animationend");var B={},a=0,c=[],b,d=null,h=0,k=[];return{animate:function(a,b,c,d,f,g){g=g||{};g.from=c;g.to=d;return U("animate",a,b,f,g)},enter:function(a,b,c){c=c||{};return U("enter",a,"ng-enter",b,c)},leave:function(a,b,c){c=c||{};return U("leave",a,"ng-leave",b,c)},move:function(a,b,c){c=c||{};return U("move",a,"ng-move",
b,c)},beforeSetClass:function(a,b,c,d,f){f=f||{};b=q(c,"-remove")+" "+q(b,"-add");if(f=S("setClass",a,b,f.from))return H(a,d),f;y();d()},beforeAddClass:function(a,b,c,d){d=d||{};if(b=S("addClass",a,q(b,"-add"),d.from))return H(a,c),b;y();c()},beforeRemoveClass:function(a,b,c,d){d=d||{};if(b=S("removeClass",a,q(b,"-remove"),d.from))return H(a,c),b;y();c()},setClass:function(a,b,c,d,f){f=f||{};c=q(c,"-remove");b=q(b,"-add");return T("setClass",a,c+" "+b,d,f.to)},addClass:function(a,b,c,d){d=d||{};return T("addClass",
a,q(b,"-add"),c,d.to)},removeClass:function(a,b,c,d){d=d||{};return T("removeClass",a,q(b,"-remove"),c,d.to)}}}])}])})(window,window.angular);
//# sourceMappingURL=angular-animate.min.js.map
 
/** **************************************************** **/
/** ********************** angular-touch ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(y,s,z){'use strict';function t(f,k,p){n.directive(f,["$parse","$swipe",function(d,e){return function(l,m,g){function h(a){if(!b)return!1;var c=Math.abs(a.y-b.y);a=(a.x-b.x)*k;return q&&75>c&&0<a&&30<a&&.3>c/a}var c=d(g[f]),b,q,a=["touch"];s.isDefined(g.ngSwipeDisableMouse)||a.push("mouse");e.bind(m,{start:function(a,c){b=a;q=!0},cancel:function(a){q=!1},end:function(a,b){h(a)&&l.$apply(function(){m.triggerHandler(p);c(l,{$event:b})})}},a)}}])}var n=s.module("ngTouch",[]);n.factory("$swipe",
[function(){function f(d){d=d.originalEvent||d;var e=d.touches&&d.touches.length?d.touches:[d];d=d.changedTouches&&d.changedTouches[0]||e[0];return{x:d.clientX,y:d.clientY}}function k(d,e){var l=[];s.forEach(d,function(d){(d=p[d][e])&&l.push(d)});return l.join(" ")}var p={mouse:{start:"mousedown",move:"mousemove",end:"mouseup"},touch:{start:"touchstart",move:"touchmove",end:"touchend",cancel:"touchcancel"}};return{bind:function(d,e,l){var m,g,h,c,b=!1;l=l||["mouse","touch"];d.on(k(l,"start"),function(a){h=
f(a);b=!0;g=m=0;c=h;e.start&&e.start(h,a)});var q=k(l,"cancel");if(q)d.on(q,function(a){b=!1;e.cancel&&e.cancel(a)});d.on(k(l,"move"),function(a){if(b&&h){var d=f(a);m+=Math.abs(d.x-c.x);g+=Math.abs(d.y-c.y);c=d;10>m&&10>g||(g>m?(b=!1,e.cancel&&e.cancel(a)):(a.preventDefault(),e.move&&e.move(d,a)))}});d.on(k(l,"end"),function(a){b&&(b=!1,e.end&&e.end(f(a),a))})}}}]);n.config(["$provide",function(f){f.decorator("ngClickDirective",["$delegate",function(k){k.shift();return k}])}]);n.directive("ngClick",
["$parse","$timeout","$rootElement",function(f,k,p){function d(c,b,d){for(var a=0;a<c.length;a+=2){var e=c[a+1],g=d;if(25>Math.abs(c[a]-b)&&25>Math.abs(e-g))return c.splice(a,a+2),!0}return!1}function e(c){if(!(2500<Date.now()-m)){var b=c.touches&&c.touches.length?c.touches:[c],e=b[0].clientX,b=b[0].clientY;if(!(1>e&&1>b||h&&h[0]===e&&h[1]===b)){h&&(h=null);var a=c.target;"label"===s.lowercase(a.nodeName||a[0]&&a[0].nodeName)&&(h=[e,b]);d(g,e,b)||(c.stopPropagation(),c.preventDefault(),c.target&&
c.target.blur&&c.target.blur())}}}function l(c){c=c.touches&&c.touches.length?c.touches:[c];var b=c[0].clientX,d=c[0].clientY;g.push(b,d);k(function(){for(var a=0;a<g.length;a+=2)if(g[a]==b&&g[a+1]==d){g.splice(a,a+2);break}},2500,!1)}var m,g,h;return function(c,b,h){function a(){n=!1;b.removeClass("ng-click-active")}var k=f(h.ngClick),n=!1,r,t,v,w;b.on("touchstart",function(a){n=!0;r=a.target?a.target:a.srcElement;3==r.nodeType&&(r=r.parentNode);b.addClass("ng-click-active");t=Date.now();a=a.originalEvent||
a;a=(a.touches&&a.touches.length?a.touches:[a])[0];v=a.clientX;w=a.clientY});b.on("touchmove",function(b){a()});b.on("touchcancel",function(b){a()});b.on("touchend",function(c){var k=Date.now()-t,f=c.originalEvent||c,u=(f.changedTouches&&f.changedTouches.length?f.changedTouches:f.touches&&f.touches.length?f.touches:[f])[0],f=u.clientX,u=u.clientY,x=Math.sqrt(Math.pow(f-v,2)+Math.pow(u-w,2));n&&750>k&&12>x&&(g||(p[0].addEventListener("click",e,!0),p[0].addEventListener("touchstart",l,!0),g=[]),m=Date.now(),
d(g,f,u),r&&r.blur(),s.isDefined(h.disabled)&&!1!==h.disabled||b.triggerHandler("click",[c]));a()});b.onclick=function(a){};b.on("click",function(a,b){c.$apply(function(){k(c,{$event:b||a})})});b.on("mousedown",function(a){b.addClass("ng-click-active")});b.on("mousemove mouseup",function(a){b.removeClass("ng-click-active")})}}]);t("ngSwipeLeft",-1,"swipeleft");t("ngSwipeRight",1,"swiperight")})(window,window.angular);
//# sourceMappingURL=angular-touch.min.js.map
 
/** **************************************************** **/
/** ********************** angular-sanitize ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(n,h,p){'use strict';function E(a){var e=[];r(e,h.noop).chars(a);return e.join("")}function g(a){var e={};a=a.split(",");var d;for(d=0;d<a.length;d++)e[a[d]]=!0;return e}function F(a,e){function d(a,b,d,l){b=h.lowercase(b);if(s[b])for(;f.last()&&t[f.last()];)c("",f.last());u[b]&&f.last()==b&&c("",b);(l=v[b]||!!l)||f.push(b);var m={};d.replace(G,function(a,b,e,c,d){m[b]=q(e||c||d||"")});e.start&&e.start(b,m,l)}function c(a,b){var c=0,d;if(b=h.lowercase(b))for(c=f.length-1;0<=c&&f[c]!=b;c--);
if(0<=c){for(d=f.length-1;d>=c;d--)e.end&&e.end(f[d]);f.length=c}}"string"!==typeof a&&(a=null===a||"undefined"===typeof a?"":""+a);var b,k,f=[],m=a,l;for(f.last=function(){return f[f.length-1]};a;){l="";k=!0;if(f.last()&&w[f.last()])a=a.replace(new RegExp("([\\W\\w]*)<\\s*\\/\\s*"+f.last()+"[^>]*>","i"),function(a,b){b=b.replace(H,"$1").replace(I,"$1");e.chars&&e.chars(q(b));return""}),c("",f.last());else{if(0===a.indexOf("\x3c!--"))b=a.indexOf("--",4),0<=b&&a.lastIndexOf("--\x3e",b)===b&&(e.comment&&
e.comment(a.substring(4,b)),a=a.substring(b+3),k=!1);else if(x.test(a)){if(b=a.match(x))a=a.replace(b[0],""),k=!1}else if(J.test(a)){if(b=a.match(y))a=a.substring(b[0].length),b[0].replace(y,c),k=!1}else K.test(a)&&((b=a.match(z))?(b[4]&&(a=a.substring(b[0].length),b[0].replace(z,d)),k=!1):(l+="<",a=a.substring(1)));k&&(b=a.indexOf("<"),l+=0>b?a:a.substring(0,b),a=0>b?"":a.substring(b),e.chars&&e.chars(q(l)))}if(a==m)throw L("badparse",a);m=a}c()}function q(a){if(!a)return"";A.innerHTML=a.replace(/</g,
"&lt;");return A.textContent}function B(a){return a.replace(/&/g,"&amp;").replace(M,function(a){var d=a.charCodeAt(0);a=a.charCodeAt(1);return"&#"+(1024*(d-55296)+(a-56320)+65536)+";"}).replace(N,function(a){return"&#"+a.charCodeAt(0)+";"}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}function r(a,e){var d=!1,c=h.bind(a,a.push);return{start:function(a,k,f){a=h.lowercase(a);!d&&w[a]&&(d=a);d||!0!==C[a]||(c("<"),c(a),h.forEach(k,function(d,f){var k=h.lowercase(f),g="img"===a&&"src"===k||"background"===
k;!0!==O[k]||!0===D[k]&&!e(d,g)||(c(" "),c(f),c('="'),c(B(d)),c('"'))}),c(f?"/>":">"))},end:function(a){a=h.lowercase(a);d||!0!==C[a]||(c("</"),c(a),c(">"));a==d&&(d=!1)},chars:function(a){d||c(B(a))}}}var L=h.$$minErr("$sanitize"),z=/^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,y=/^<\/\s*([\w:-]+)[^>]*>/,G=/([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,K=/^</,J=/^<\//,H=/\x3c!--(.*?)--\x3e/g,x=/<!DOCTYPE([^>]*?)>/i,
I=/<!\[CDATA\[(.*?)]]\x3e/g,M=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,N=/([^\#-~| |!])/g,v=g("area,br,col,hr,img,wbr");n=g("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr");p=g("rp,rt");var u=h.extend({},p,n),s=h.extend({},n,g("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul")),t=h.extend({},p,g("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
n=g("animate,animateColor,animateMotion,animateTransform,circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set,stop,svg,switch,text,title,tspan,use");var w=g("script,style"),C=h.extend({},v,s,t,u,n),D=g("background,cite,href,longdesc,src,usemap,xlink:href");n=g("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,target,title,type,valign,value,vspace,width");
p=g("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan");
var O=h.extend({},D,p,n),A=document.createElement("pre");h.module("ngSanitize",[]).provider("$sanitize",function(){this.$get=["$$sanitizeUri",function(a){return function(e){var d=[];F(e,r(d,function(c,b){return!/^unsafe/.test(a(c,b))}));return d.join("")}}]});h.module("ngSanitize").filter("linky",["$sanitize",function(a){var e=/((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/,d=/^mailto:/;return function(c,b){function k(a){a&&g.push(E(a))}function f(a,c){g.push("<a ");
h.isDefined(b)&&g.push('target="',b,'" ');g.push('href="',a.replace(/"/g,"&quot;"),'">');k(c);g.push("</a>")}if(!c)return c;for(var m,l=c,g=[],n,p;m=l.match(e);)n=m[0],m[2]||m[4]||(n=(m[3]?"http://":"mailto:")+n),p=m.index,k(l.substr(0,p)),f(n,m[0].replace(d,"")),l=l.substring(p+m[0].length);k(l);return a(g.join(""))}}])})(window,window.angular);
//# sourceMappingURL=angular-sanitize.min.js.map
 
/** **************************************************** **/
/** ********************** angular-file-upload ****************************** **/
 /*
 angular-file-upload v1.1.6
 https://github.com/nervgh/angular-file-upload
*/
(function(angular, factory) {
    if (typeof define === 'function' && define.amd) {
        define('angular-file-upload', ['angular'], function(angular) {
            return factory(angular);
        });
    } else {
        return factory(angular);
    }
}(typeof angular === 'undefined' ? null : angular, function(angular) {

var module = angular.module('angularFileUpload', []);

'use strict';

/**
 * Classes
 *
 * FileUploader
 * FileUploader.FileLikeObject
 * FileUploader.FileItem
 * FileUploader.FileDirective
 * FileUploader.FileSelect
 * FileUploader.FileDrop
 * FileUploader.FileOver
 */

module


    .value('fileUploaderOptions', {
        url: '/',
        alias: 'file',
        headers: {},
        queue: [],
        progress: 0,
        autoUpload: false,
        removeAfterUpload: false,
        method: 'POST',
        filters: [],
        formData: [],
        queueLimit: Number.MAX_VALUE,
        withCredentials: false
    })


    .factory('FileUploader', ['fileUploaderOptions', '$rootScope', '$http', '$window', '$compile',
        function(fileUploaderOptions, $rootScope, $http, $window, $compile) {
            /**
             * Creates an instance of FileUploader
             * @param {Object} [options]
             * @constructor
             */
            function FileUploader(options) {
                var settings = angular.copy(fileUploaderOptions);
                angular.extend(this, settings, options, {
                    isUploading: false,
                    _nextIndex: 0,
                    _failFilterIndex: -1,
                    _directives: {select: [], drop: [], over: []}
                });

                // add default filters
                this.filters.unshift({name: 'queueLimit', fn: this._queueLimitFilter});
                this.filters.unshift({name: 'folder', fn: this._folderFilter});
            }
            /**********************
             * PUBLIC
             **********************/
            /**
             * Checks a support the html5 uploader
             * @returns {Boolean}
             * @readonly
             */
            FileUploader.prototype.isHTML5 = !!($window.File && $window.FormData);
            /**
             * Adds items to the queue
             * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
             * @param {Object} [options]
             * @param {Array<Function>|String} filters
             */
            FileUploader.prototype.addToQueue = function(files, options, filters) {
                var list = this.isArrayLikeObject(files) ? files: [files];
                var arrayOfFilters = this._getFilters(filters);
                var count = this.queue.length;
                var addedFileItems = [];

                angular.forEach(list, function(some /*{File|HTMLInputElement|Object}*/) {
                    var temp = new FileUploader.FileLikeObject(some);

                    if (this._isValidFile(temp, arrayOfFilters, options)) {
                        var fileItem = new FileUploader.FileItem(this, some, options);
                        addedFileItems.push(fileItem);
                        this.queue.push(fileItem);
                        this._onAfterAddingFile(fileItem);
                    } else {
                        var filter = arrayOfFilters[this._failFilterIndex];
                        this._onWhenAddingFileFailed(temp, filter, options);
                    }
                }, this);

                if(this.queue.length !== count) {
                    this._onAfterAddingAll(addedFileItems);
                    this.progress = this._getTotalProgress();
                }

                this._render();
                if (this.autoUpload) this.uploadAll();
            };
            /**
             * Remove items from the queue. Remove last: index = -1
             * @param {FileItem|Number} value
             */
            FileUploader.prototype.removeFromQueue = function(value) {
                var index = this.getIndexOfItem(value);
                var item = this.queue[index];
                if (item.isUploading) item.cancel();
                this.queue.splice(index, 1);
                item._destroy();
                this.progress = this._getTotalProgress();
            };
            /**
             * Clears the queue
             */
            FileUploader.prototype.clearQueue = function() {
                while(this.queue.length) {
                    this.queue[0].remove();
                }
                this.progress = 0;
            };
            /**
             * Uploads a item from the queue
             * @param {FileItem|Number} value
             */
            FileUploader.prototype.uploadItem = function(value) {
                var index = this.getIndexOfItem(value);
                var item = this.queue[index];
                var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';

                item._prepareToUploading();
                if(this.isUploading) return;

                this.isUploading = true;
                this[transport](item);
            };
            /**
             * Cancels uploading of item from the queue
             * @param {FileItem|Number} value
             */
            FileUploader.prototype.cancelItem = function(value) {
                var index = this.getIndexOfItem(value);
                var item = this.queue[index];
                var prop = this.isHTML5 ? '_xhr' : '_form';
                if (item && item.isUploading) item[prop].abort();
            };
            /**
             * Uploads all not uploaded items of queue
             */
            FileUploader.prototype.uploadAll = function() {
                var items = this.getNotUploadedItems().filter(function(item) {
                    return !item.isUploading;
                });
                if (!items.length) return;

                angular.forEach(items, function(item) {
                    item._prepareToUploading();
                });
                items[0].upload();
            };
            /**
             * Cancels all uploads
             */
            FileUploader.prototype.cancelAll = function() {
                var items = this.getNotUploadedItems();
                angular.forEach(items, function(item) {
                    item.cancel();
                });
            };
            /**
             * Returns "true" if value an instance of File
             * @param {*} value
             * @returns {Boolean}
             * @private
             */
            FileUploader.prototype.isFile = function(value) {
                var fn = $window.File;
                return (fn && value instanceof fn);
            };
            /**
             * Returns "true" if value an instance of FileLikeObject
             * @param {*} value
             * @returns {Boolean}
             * @private
             */
            FileUploader.prototype.isFileLikeObject = function(value) {
                return value instanceof FileUploader.FileLikeObject;
            };
            /**
             * Returns "true" if value is array like object
             * @param {*} value
             * @returns {Boolean}
             */
            FileUploader.prototype.isArrayLikeObject = function(value) {
                return (angular.isObject(value) && 'length' in value);
            };
            /**
             * Returns a index of item from the queue
             * @param {Item|Number} value
             * @returns {Number}
             */
            FileUploader.prototype.getIndexOfItem = function(value) {
                return angular.isNumber(value) ? value : this.queue.indexOf(value);
            };
            /**
             * Returns not uploaded items
             * @returns {Array}
             */
            FileUploader.prototype.getNotUploadedItems = function() {
                return this.queue.filter(function(item) {
                    return !item.isUploaded;
                });
            };
            /**
             * Returns items ready for upload
             * @returns {Array}
             */
            FileUploader.prototype.getReadyItems = function() {
                return this.queue
                    .filter(function(item) {
                        return (item.isReady && !item.isUploading);
                    })
                    .sort(function(item1, item2) {
                        return item1.index - item2.index;
                    });
            };
            /**
             * Destroys instance of FileUploader
             */
            FileUploader.prototype.destroy = function() {
                angular.forEach(this._directives, function(key) {
                    angular.forEach(this._directives[key], function(object) {
                        object.destroy();
                    }, this);
                }, this);
            };
            /**
             * Callback
             * @param {Array} fileItems
             */
            FileUploader.prototype.onAfterAddingAll = function(fileItems) {};
            /**
             * Callback
             * @param {FileItem} fileItem
             */
            FileUploader.prototype.onAfterAddingFile = function(fileItem) {};
            /**
             * Callback
             * @param {File|Object} item
             * @param {Object} filter
             * @param {Object} options
             * @private
             */
            FileUploader.prototype.onWhenAddingFileFailed = function(item, filter, options) {};
            /**
             * Callback
             * @param {FileItem} fileItem
             */
            FileUploader.prototype.onBeforeUploadItem = function(fileItem) {};
            /**
             * Callback
             * @param {FileItem} fileItem
             * @param {Number} progress
             */
            FileUploader.prototype.onProgressItem = function(fileItem, progress) {};
            /**
             * Callback
             * @param {Number} progress
             */
            FileUploader.prototype.onProgressAll = function(progress) {};
            /**
             * Callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileUploader.prototype.onSuccessItem = function(item, response, status, headers) {};
            /**
             * Callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileUploader.prototype.onErrorItem = function(item, response, status, headers) {};
            /**
             * Callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileUploader.prototype.onCancelItem = function(item, response, status, headers) {};
            /**
             * Callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileUploader.prototype.onCompleteItem = function(item, response, status, headers) {};
            /**
             * Callback
             */
            FileUploader.prototype.onCompleteAll = function() {};
            /**********************
             * PRIVATE
             **********************/
            /**
             * Returns the total progress
             * @param {Number} [value]
             * @returns {Number}
             * @private
             */
            FileUploader.prototype._getTotalProgress = function(value) {
                if(this.removeAfterUpload) return value || 0;

                var notUploaded = this.getNotUploadedItems().length;
                var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
                var ratio = 100 / this.queue.length;
                var current = (value || 0) * ratio / 100;

                return Math.round(uploaded * ratio + current);
            };
            /**
             * Returns array of filters
             * @param {Array<Function>|String} filters
             * @returns {Array<Function>}
             * @private
             */
            FileUploader.prototype._getFilters = function(filters) {
                if (angular.isUndefined(filters)) return this.filters;
                if (angular.isArray(filters)) return filters;
                var names = filters.match(/[^\s,]+/g);
                return this.filters.filter(function(filter) {
                    return names.indexOf(filter.name) !== -1;
                }, this);
            };
            /**
             * Updates html
             * @private
             */
            FileUploader.prototype._render = function() {
                if (!$rootScope.$$phase) $rootScope.$apply();
            };
            /**
             * Returns "true" if item is a file (not folder)
             * @param {File|FileLikeObject} item
             * @returns {Boolean}
             * @private
             */
            FileUploader.prototype._folderFilter = function(item) {
                return !!(item.size || item.type);
            };
            /**
             * Returns "true" if the limit has not been reached
             * @returns {Boolean}
             * @private
             */
            FileUploader.prototype._queueLimitFilter = function() {
                return this.queue.length < this.queueLimit;
            };
            /**
             * Returns "true" if file pass all filters
             * @param {File|Object} file
             * @param {Array<Function>} filters
             * @param {Object} options
             * @returns {Boolean}
             * @private
             */
            FileUploader.prototype._isValidFile = function(file, filters, options) {
                this._failFilterIndex = -1;
                return !filters.length ? true : filters.every(function(filter) {
                    this._failFilterIndex++;
                    return filter.fn.call(this, file, options);
                }, this);
            };
            /**
             * Checks whether upload successful
             * @param {Number} status
             * @returns {Boolean}
             * @private
             */
            FileUploader.prototype._isSuccessCode = function(status) {
                return (status >= 200 && status < 300) || status === 304;
            };
            /**
             * Transforms the server response
             * @param {*} response
             * @param {Object} headers
             * @returns {*}
             * @private
             */
            FileUploader.prototype._transformResponse = function(response, headers) {
                var headersGetter = this._headersGetter(headers);
                angular.forEach($http.defaults.transformResponse, function(transformFn) {
                    response = transformFn(response, headersGetter);
                });
                return response;
            };
            /**
             * Parsed response headers
             * @param headers
             * @returns {Object}
             * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
             * @private
             */
            FileUploader.prototype._parseHeaders = function(headers) {
                var parsed = {}, key, val, i;

                if (!headers) return parsed;

                angular.forEach(headers.split('\n'), function(line) {
                    i = line.indexOf(':');
                    key = line.slice(0, i).trim().toLowerCase();
                    val = line.slice(i + 1).trim();

                    if (key) {
                        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
                    }
                });

                return parsed;
            };
            /**
             * Returns function that returns headers
             * @param {Object} parsedHeaders
             * @returns {Function}
             * @private
             */
            FileUploader.prototype._headersGetter = function(parsedHeaders) {
                return function(name) {
                    if (name) {
                        return parsedHeaders[name.toLowerCase()] || null;
                    }
                    return parsedHeaders;
                };
            };
            /**
             * The XMLHttpRequest transport
             * @param {FileItem} item
             * @private
             */
            FileUploader.prototype._xhrTransport = function(item) {
                var xhr = item._xhr = new XMLHttpRequest();
                var form = new FormData();
                var that = this;

                that._onBeforeUploadItem(item);

                angular.forEach(item.formData, function(obj) {
                    angular.forEach(obj, function(value, key) {
                        form.append(key, value);
                    });
                });

                if ( typeof(item._file.size) != 'number' ) {
                    throw new TypeError('The file specified is no longer valid');
                }

                form.append(item.alias, item._file, item.file.name);

                xhr.upload.onprogress = function(event) {
                    var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
                    that._onProgressItem(item, progress);
                };

                xhr.onload = function() {
                    var headers = that._parseHeaders(xhr.getAllResponseHeaders());
                    var response = that._transformResponse(xhr.response, headers);
                    var gist = that._isSuccessCode(xhr.status) ? 'Success' : 'Error';
                    var method = '_on' + gist + 'Item';
                    that[method](item, response, xhr.status, headers);
                    that._onCompleteItem(item, response, xhr.status, headers);
                };

                xhr.onerror = function() {
                    var headers = that._parseHeaders(xhr.getAllResponseHeaders());
                    var response = that._transformResponse(xhr.response, headers);
                    that._onErrorItem(item, response, xhr.status, headers);
                    that._onCompleteItem(item, response, xhr.status, headers);
                };

                xhr.onabort = function() {
                    var headers = that._parseHeaders(xhr.getAllResponseHeaders());
                    var response = that._transformResponse(xhr.response, headers);
                    that._onCancelItem(item, response, xhr.status, headers);
                    that._onCompleteItem(item, response, xhr.status, headers);
                };

                xhr.open(item.method, item.url, true);

                xhr.withCredentials = item.withCredentials;

                angular.forEach(item.headers, function(value, name) {
                    xhr.setRequestHeader(name, value);
                });

                xhr.send(form);
                this._render();
            };
            /**
             * The IFrame transport
             * @param {FileItem} item
             * @private
             */
            FileUploader.prototype._iframeTransport = function(item) {
                var form = angular.element('<form style="display: none;" />');
                var iframe = angular.element('<iframe name="iframeTransport' + Date.now() + '">');
                var input = item._input;
                var that = this;

                if (item._form) item._form.replaceWith(input); // remove old form
                item._form = form; // save link to new form

                that._onBeforeUploadItem(item);

                input.prop('name', item.alias);

                angular.forEach(item.formData, function(obj) {
                    angular.forEach(obj, function(value, key) {
                        var element = angular.element('<input type="hidden" name="' + key + '" />');
                        element.val(value);
                        form.append(element);
                    });
                });

                form.prop({
                    action: item.url,
                    method: 'POST',
                    target: iframe.prop('name'),
                    enctype: 'multipart/form-data',
                    encoding: 'multipart/form-data' // old IE
                });

                iframe.bind('load', function() {
                    try {
                        // Fix for legacy IE browsers that loads internal error page
                        // when failed WS response received. In consequence iframe
                        // content access denied error is thrown becouse trying to
                        // access cross domain page. When such thing occurs notifying
                        // with empty response object. See more info at:
                        // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
                        // Note that if non standard 4xx or 5xx error code returned
                        // from WS then response content can be accessed without error
                        // but 'XHR' status becomes 200. In order to avoid confusion
                        // returning response via same 'success' event handler.

                        // fixed angular.contents() for iframes
                        var html = iframe[0].contentDocument.body.innerHTML;
                    } catch (e) {}

                    var xhr = {response: html, status: 200, dummy: true};
                    var headers = {};
                    var response = that._transformResponse(xhr.response, headers);

                    that._onSuccessItem(item, response, xhr.status, headers);
                    that._onCompleteItem(item, response, xhr.status, headers);
                });

                form.abort = function() {
                    var xhr = {status: 0, dummy: true};
                    var headers = {};
                    var response;

                    iframe.unbind('load').prop('src', 'javascript:false;');
                    form.replaceWith(input);

                    that._onCancelItem(item, response, xhr.status, headers);
                    that._onCompleteItem(item, response, xhr.status, headers);
                };

                input.after(form);
                form.append(input).append(iframe);

                form[0].submit();
                this._render();
            };
            /**
             * Inner callback
             * @param {File|Object} item
             * @param {Object} filter
             * @param {Object} options
             * @private
             */
            FileUploader.prototype._onWhenAddingFileFailed = function(item, filter, options) {
                this.onWhenAddingFileFailed(item, filter, options);
            };
            /**
             * Inner callback
             * @param {FileItem} item
             */
            FileUploader.prototype._onAfterAddingFile = function(item) {
                this.onAfterAddingFile(item);
            };
            /**
             * Inner callback
             * @param {Array<FileItem>} items
             */
            FileUploader.prototype._onAfterAddingAll = function(items) {
                this.onAfterAddingAll(items);
            };
            /**
             *  Inner callback
             * @param {FileItem} item
             * @private
             */
            FileUploader.prototype._onBeforeUploadItem = function(item) {
                item._onBeforeUpload();
                this.onBeforeUploadItem(item);
            };
            /**
             * Inner callback
             * @param {FileItem} item
             * @param {Number} progress
             * @private
             */
            FileUploader.prototype._onProgressItem = function(item, progress) {
                var total = this._getTotalProgress(progress);
                this.progress = total;
                item._onProgress(progress);
                this.onProgressItem(item, progress);
                this.onProgressAll(total);
                this._render();
            };
            /**
             * Inner callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileUploader.prototype._onSuccessItem = function(item, response, status, headers) {
                item._onSuccess(response, status, headers);
                this.onSuccessItem(item, response, status, headers);
            };
            /**
             * Inner callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileUploader.prototype._onErrorItem = function(item, response, status, headers) {
                item._onError(response, status, headers);
                this.onErrorItem(item, response, status, headers);
            };
            /**
             * Inner callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileUploader.prototype._onCancelItem = function(item, response, status, headers) {
                item._onCancel(response, status, headers);
                this.onCancelItem(item, response, status, headers);
            };
            /**
             * Inner callback
             * @param {FileItem} item
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileUploader.prototype._onCompleteItem = function(item, response, status, headers) {
                item._onComplete(response, status, headers);
                this.onCompleteItem(item, response, status, headers);

                var nextItem = this.getReadyItems()[0];
                this.isUploading = false;

                if(angular.isDefined(nextItem)) {
                    nextItem.upload();
                    return;
                }

                this.onCompleteAll();
                this.progress = this._getTotalProgress();
                this._render();
            };
            /**********************
             * STATIC
             **********************/
            /**
             * @borrows FileUploader.prototype.isFile
             */
            FileUploader.isFile = FileUploader.prototype.isFile;
            /**
             * @borrows FileUploader.prototype.isFileLikeObject
             */
            FileUploader.isFileLikeObject = FileUploader.prototype.isFileLikeObject;
            /**
             * @borrows FileUploader.prototype.isArrayLikeObject
             */
            FileUploader.isArrayLikeObject = FileUploader.prototype.isArrayLikeObject;
            /**
             * @borrows FileUploader.prototype.isHTML5
             */
            FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
            /**
             * Inherits a target (Class_1) by a source (Class_2)
             * @param {Function} target
             * @param {Function} source
             */
            FileUploader.inherit = function(target, source) {
                target.prototype = Object.create(source.prototype);
                target.prototype.constructor = target;
                target.super_ = source;
            };
            FileUploader.FileLikeObject = FileLikeObject;
            FileUploader.FileItem = FileItem;
            FileUploader.FileDirective = FileDirective;
            FileUploader.FileSelect = FileSelect;
            FileUploader.FileDrop = FileDrop;
            FileUploader.FileOver = FileOver;

            // ---------------------------

            /**
             * Creates an instance of FileLikeObject
             * @param {File|HTMLInputElement|Object} fileOrInput
             * @constructor
             */
            function FileLikeObject(fileOrInput) {
                var isInput = angular.isElement(fileOrInput);
                var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
                var postfix = angular.isString(fakePathOrObject) ? 'FakePath' : 'Object';
                var method = '_createFrom' + postfix;
                this[method](fakePathOrObject);
            }

            /**
             * Creates file like object from fake path string
             * @param {String} path
             * @private
             */
            FileLikeObject.prototype._createFromFakePath = function(path) {
                this.lastModifiedDate = null;
                this.size = null;
                this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
                this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
            };
            /**
             * Creates file like object from object
             * @param {File|FileLikeObject} object
             * @private
             */
            FileLikeObject.prototype._createFromObject = function(object) {
                this.lastModifiedDate = angular.copy(object.lastModifiedDate);
                this.size = object.size;
                this.type = object.type;
                this.name = object.name;
            };

            // ---------------------------

            /**
             * Creates an instance of FileItem
             * @param {FileUploader} uploader
             * @param {File|HTMLInputElement|Object} some
             * @param {Object} options
             * @constructor
             */
            function FileItem(uploader, some, options) {
                var isInput = angular.isElement(some);
                var input = isInput ? angular.element(some) : null;
                var file = !isInput ? some : null;

                angular.extend(this, {
                    url: uploader.url,
                    alias: uploader.alias,
                    headers: angular.copy(uploader.headers),
                    formData: angular.copy(uploader.formData),
                    removeAfterUpload: uploader.removeAfterUpload,
                    withCredentials: uploader.withCredentials,
                    method: uploader.method
                }, options, {
                    uploader: uploader,
                    file: new FileUploader.FileLikeObject(some),
                    isReady: false,
                    isUploading: false,
                    isUploaded: false,
                    isSuccess: false,
                    isCancel: false,
                    isError: false,
                    progress: 0,
                    index: null,
                    _file: file,
                    _input: input
                });

                if (input) this._replaceNode(input);
            }
            /**********************
             * PUBLIC
             **********************/
            /**
             * Uploads a FileItem
             */
            FileItem.prototype.upload = function() {
                try {
                    this.uploader.uploadItem(this);
                } catch (e) {
                    this.uploader._onCompleteItem( this, '', 0, [] );
                    this.uploader._onErrorItem( this, '', 0, [] );
                }
            };
            /**
             * Cancels uploading of FileItem
             */
            FileItem.prototype.cancel = function() {
                this.uploader.cancelItem(this);
            };
            /**
             * Removes a FileItem
             */
            FileItem.prototype.remove = function() {
                this.uploader.removeFromQueue(this);
            };
            /**
             * Callback
             * @private
             */
            FileItem.prototype.onBeforeUpload = function() {};
            /**
             * Callback
             * @param {Number} progress
             * @private
             */
            FileItem.prototype.onProgress = function(progress) {};
            /**
             * Callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileItem.prototype.onSuccess = function(response, status, headers) {};
            /**
             * Callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileItem.prototype.onError = function(response, status, headers) {};
            /**
             * Callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileItem.prototype.onCancel = function(response, status, headers) {};
            /**
             * Callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             */
            FileItem.prototype.onComplete = function(response, status, headers) {};
            /**********************
             * PRIVATE
             **********************/
            /**
             * Inner callback
             */
            FileItem.prototype._onBeforeUpload = function() {
                this.isReady = true;
                this.isUploading = true;
                this.isUploaded = false;
                this.isSuccess = false;
                this.isCancel = false;
                this.isError = false;
                this.progress = 0;
                this.onBeforeUpload();
            };
            /**
             * Inner callback
             * @param {Number} progress
             * @private
             */
            FileItem.prototype._onProgress = function(progress) {
                this.progress = progress;
                this.onProgress(progress);
            };
            /**
             * Inner callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileItem.prototype._onSuccess = function(response, status, headers) {
                this.isReady = false;
                this.isUploading = false;
                this.isUploaded = true;
                this.isSuccess = true;
                this.isCancel = false;
                this.isError = false;
                this.progress = 100;
                this.index = null;
                this.onSuccess(response, status, headers);
            };
            /**
             * Inner callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileItem.prototype._onError = function(response, status, headers) {
                this.isReady = false;
                this.isUploading = false;
                this.isUploaded = true;
                this.isSuccess = false;
                this.isCancel = false;
                this.isError = true;
                this.progress = 0;
                this.index = null;
                this.onError(response, status, headers);
            };
            /**
             * Inner callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileItem.prototype._onCancel = function(response, status, headers) {
                this.isReady = false;
                this.isUploading = false;
                this.isUploaded = false;
                this.isSuccess = false;
                this.isCancel = true;
                this.isError = false;
                this.progress = 0;
                this.index = null;
                this.onCancel(response, status, headers);
            };
            /**
             * Inner callback
             * @param {*} response
             * @param {Number} status
             * @param {Object} headers
             * @private
             */
            FileItem.prototype._onComplete = function(response, status, headers) {
                this.onComplete(response, status, headers);
                if (this.removeAfterUpload) this.remove();
            };
            /**
             * Destroys a FileItem
             */
            FileItem.prototype._destroy = function() {
                if (this._input) this._input.remove();
                if (this._form) this._form.remove();
                delete this._form;
                delete this._input;
            };
            /**
             * Prepares to uploading
             * @private
             */
            FileItem.prototype._prepareToUploading = function() {
                this.index = this.index || ++this.uploader._nextIndex;
                this.isReady = true;
            };
            /**
             * Replaces input element on his clone
             * @param {JQLite|jQuery} input
             * @private
             */
            FileItem.prototype._replaceNode = function(input) {
                var clone = $compile(input.clone())(input.scope());
                clone.prop('value', null); // FF fix
                input.css('display', 'none');
                input.after(clone); // remove jquery dependency
            };

            // ---------------------------

            /**
             * Creates instance of {FileDirective} object
             * @param {Object} options
             * @param {Object} options.uploader
             * @param {HTMLElement} options.element
             * @param {Object} options.events
             * @param {String} options.prop
             * @constructor
             */
            function FileDirective(options) {
                angular.extend(this, options);
                this.uploader._directives[this.prop].push(this);
                this._saveLinks();
                this.bind();
            }
            /**
             * Map of events
             * @type {Object}
             */
            FileDirective.prototype.events = {};
            /**
             * Binds events handles
             */
            FileDirective.prototype.bind = function() {
                for(var key in this.events) {
                    var prop = this.events[key];
                    this.element.bind(key, this[prop]);
                }
            };
            /**
             * Unbinds events handles
             */
            FileDirective.prototype.unbind = function() {
                for(var key in this.events) {
                    this.element.unbind(key, this.events[key]);
                }
            };
            /**
             * Destroys directive
             */
            FileDirective.prototype.destroy = function() {
                var index = this.uploader._directives[this.prop].indexOf(this);
                this.uploader._directives[this.prop].splice(index, 1);
                this.unbind();
                // this.element = null;
            };
            /**
             * Saves links to functions
             * @private
             */
            FileDirective.prototype._saveLinks = function() {
                for(var key in this.events) {
                    var prop = this.events[key];
                    this[prop] = this[prop].bind(this);
                }
            };

            // ---------------------------

            FileUploader.inherit(FileSelect, FileDirective);

            /**
             * Creates instance of {FileSelect} object
             * @param {Object} options
             * @constructor
             */
            function FileSelect(options) {
                FileSelect.super_.apply(this, arguments);

                if(!this.uploader.isHTML5) {
                    this.element.removeAttr('multiple');
                }
                this.element.prop('value', null); // FF fix
            }
            /**
             * Map of events
             * @type {Object}
             */
            FileSelect.prototype.events = {
                $destroy: 'destroy',
                change: 'onChange'
            };
            /**
             * Name of property inside uploader._directive object
             * @type {String}
             */
            FileSelect.prototype.prop = 'select';
            /**
             * Returns options
             * @return {Object|undefined}
             */
            FileSelect.prototype.getOptions = function() {};
            /**
             * Returns filters
             * @return {Array<Function>|String|undefined}
             */
            FileSelect.prototype.getFilters = function() {};
            /**
             * If returns "true" then HTMLInputElement will be cleared
             * @returns {Boolean}
             */
            FileSelect.prototype.isEmptyAfterSelection = function() {
                return !!this.element.attr('multiple');
            };
            /**
             * Event handler
             */
            FileSelect.prototype.onChange = function() {
                var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
                var options = this.getOptions();
                var filters = this.getFilters();

                if (!this.uploader.isHTML5) this.destroy();
                this.uploader.addToQueue(files, options, filters);
                if (this.isEmptyAfterSelection()) this.element.prop('value', null);
            };

            // ---------------------------

            FileUploader.inherit(FileDrop, FileDirective);

            /**
             * Creates instance of {FileDrop} object
             * @param {Object} options
             * @constructor
             */
            function FileDrop(options) {
                FileDrop.super_.apply(this, arguments);
            }
            /**
             * Map of events
             * @type {Object}
             */
            FileDrop.prototype.events = {
                $destroy: 'destroy',
                drop: 'onDrop',
                dragover: 'onDragOver',
                dragleave: 'onDragLeave'
            };
            /**
             * Name of property inside uploader._directive object
             * @type {String}
             */
            FileDrop.prototype.prop = 'drop';
            /**
             * Returns options
             * @return {Object|undefined}
             */
            FileDrop.prototype.getOptions = function() {};
            /**
             * Returns filters
             * @return {Array<Function>|String|undefined}
             */
            FileDrop.prototype.getFilters = function() {};
            /**
             * Event handler
             */
            FileDrop.prototype.onDrop = function(event) {
                var transfer = this._getTransfer(event);
                if (!transfer) return;
                var options = this.getOptions();
                var filters = this.getFilters();
                this._preventAndStop(event);
                angular.forEach(this.uploader._directives.over, this._removeOverClass, this);
                this.uploader.addToQueue(transfer.files, options, filters);
            };
            /**
             * Event handler
             */
            FileDrop.prototype.onDragOver = function(event) {
                var transfer = this._getTransfer(event);
                if(!this._haveFiles(transfer.types)) return;
                transfer.dropEffect = 'copy';
                this._preventAndStop(event);
                angular.forEach(this.uploader._directives.over, this._addOverClass, this);
            };
            /**
             * Event handler
             */
            FileDrop.prototype.onDragLeave = function(event) {
                if (event.currentTarget !== this.element[0]) return;
                this._preventAndStop(event);
                angular.forEach(this.uploader._directives.over, this._removeOverClass, this);
            };
            /**
             * Helper
             */
            FileDrop.prototype._getTransfer = function(event) {
                return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
            };
            /**
             * Helper
             */
            FileDrop.prototype._preventAndStop = function(event) {
                event.preventDefault();
                event.stopPropagation();
            };
            /**
             * Returns "true" if types contains files
             * @param {Object} types
             */
            FileDrop.prototype._haveFiles = function(types) {
                if (!types) return false;
                if (types.indexOf) {
                    return types.indexOf('Files') !== -1;
                } else if(types.contains) {
                    return types.contains('Files');
                } else {
                    return false;
                }
            };
            /**
             * Callback
             */
            FileDrop.prototype._addOverClass = function(item) {
                item.addOverClass();
            };
            /**
             * Callback
             */
            FileDrop.prototype._removeOverClass = function(item) {
                item.removeOverClass();
            };

            // ---------------------------

            FileUploader.inherit(FileOver, FileDirective);

            /**
             * Creates instance of {FileDrop} object
             * @param {Object} options
             * @constructor
             */
            function FileOver(options) {
                FileOver.super_.apply(this, arguments);
            }
            /**
             * Map of events
             * @type {Object}
             */
            FileOver.prototype.events = {
                $destroy: 'destroy'
            };
            /**
             * Name of property inside uploader._directive object
             * @type {String}
             */
            FileOver.prototype.prop = 'over';
            /**
             * Over class
             * @type {string}
             */
            FileOver.prototype.overClass = 'nv-file-over';
            /**
             * Adds over class
             */
            FileOver.prototype.addOverClass = function() {
                this.element.addClass(this.getOverClass());
            };
            /**
             * Removes over class
             */
            FileOver.prototype.removeOverClass = function() {
                this.element.removeClass(this.getOverClass());
            };
            /**
             * Returns over class
             * @returns {String}
             */
            FileOver.prototype.getOverClass = function() {
                return this.overClass;
            };

            return FileUploader;
        }])


    .directive('nvFileSelect', ['$parse', 'FileUploader', function($parse, FileUploader) {
        return {
            link: function(scope, element, attributes) {
                var uploader = scope.$eval(attributes.uploader);

                if (!(uploader instanceof FileUploader)) {
                    throw new TypeError('"Uploader" must be an instance of FileUploader');
                }

                var object = new FileUploader.FileSelect({
                    uploader: uploader,
                    element: element
                });

                object.getOptions = $parse(attributes.options).bind(object, scope);
                object.getFilters = function() {return attributes.filters;};
            }
        };
    }])


    .directive('nvFileDrop', ['$parse', 'FileUploader', function($parse, FileUploader) {
        return {
            link: function(scope, element, attributes) {
                var uploader = scope.$eval(attributes.uploader);

                if (!(uploader instanceof FileUploader)) {
                    throw new TypeError('"Uploader" must be an instance of FileUploader');
                }

                if (!uploader.isHTML5) return;

                var object = new FileUploader.FileDrop({
                    uploader: uploader,
                    element: element
                });

                object.getOptions = $parse(attributes.options).bind(object, scope);
                object.getFilters = function() {return attributes.filters;};
            }
        };
    }])


    .directive('nvFileOver', ['FileUploader', function(FileUploader) {
        return {
            link: function(scope, element, attributes) {
                var uploader = scope.$eval(attributes.uploader);

                if (!(uploader instanceof FileUploader)) {
                    throw new TypeError('"Uploader" must be an instance of FileUploader');
                }

                var object = new FileUploader.FileOver({
                    uploader: uploader,
                    element: element
                });

                object.getOverClass = function() {
                    return attributes.overClass || this.overClass;
                };
            }
        };
    }])

    return module;
})); 
/** **************************************************** **/
/** ********************** angular-isotope ****************************** **/
 /*! angular-isotope 26-05-2014 */
!function(a){angular.module("iso.config",[]).value("iso.config",{debug:!0}),angular.module("iso.directives",["iso.services"]),angular.module("iso.services",[]),angular.module("iso",["iso.config","iso.directives","iso.services"]),angular.module("iso.controllers",["iso.config","iso.services"]).controller("angularIsotopeController",["iso.config","iso.topics","$scope","$timeout","optionsStore",function(b,c,d,e,f){"use strict";var g,h,i,j,k,l,m,n,o;l="isotope.onLayout",n=!1,j=null,g=[],o="",i="",d.$on(l,function(){}),d.layoutEventEmit=function(){return e(function(){return d.$apply(function(){return d.$emit(l)})})},f.store({onLayout:d.layoutEventEmit}),h=function(a,b,c){return b?a.call(d,b,c):void 0},d.delayInit=function(a){f.storeInit(a)},d.delayedInit=function(){var a=f.retrieveInit();d.init(a)},d.$on("iso-init",function(){d.delayedInit()}),d.init=function(b){return f.storeInit(b),j=b.element,h(d.$on,b.isoOptionsEvent||c.MSG_OPTIONS,m),h(d.$on,b.isoMethodEvent||c.MSG_METHOD,k),d.isoMode=b.isoMode||"addItems",e(function(){var b=f.retrieve();if(!a.jQuery||!j.isotope(b)){var c=new Isotope(j[0],b);j.isotope=function(a,b){var d=Array.prototype.slice.call(arguments,1);return"string"==typeof a?c[a].apply(c,d):(c.option(a),void c._init(b))}}n=!0})},d.setIsoElement=function(a){return n?e(function(){return j.isotope(d.isoMode,a)}):void 0},d.refreshIso=function(){return n?j.isotope():void 0},d.updateOptions=function(a){j?j.isotope(a):f.store(a)},d.updateMethod=function(a,b,c){return j.isotope(a,b,c)},m=function(a,b){return d.updateOptions(b)},k=function(a,b){var c,e;return c=b.name,e=b.params,d.updateMethod(c,e,null)},d.removeAll=function(a){return j.isotope("remove",j.data("isotope").$allAtoms,a)},d.refresh=function(){return j.isotope()},d.$on(b.refreshEvent,function(){return d.refreshIso()}),d.$on(c.MSG_REMOVE,function(a,b){return d.removeElement(b)}),d.$on(c.MSG_OPTIONS,function(a,b){return m(a,b)}),d.$on(c.MSG_METHOD,function(a,b){return k(a,b)}),d.removeElement=function(a){return j&&j.isotope("remove",a)}}]).controller("isoSortByDataController",["iso.config","$scope","optionsStore",function(a,b,c){var d,e;b.getHash=function(a){return"opt"+a},b.storeMethods=function(a){return c.store({getSortData:a})},b.optSortData=function(a,c){var e,f,g,h,i,j,k;return f={},e=angular.element(c),i=e.attr("ok-sel"),k=e.attr("ok-type"),j=b.getHash(i),g=e.attr("opt-convert")?eval_("["+e.attr("opt-convert")+"]")[0]:null,h=function(a,b,c){return function(e){return d(a,e,b,c)}},f[j]=h(i,k,g),f},b.createSortByDataMethods=function(a){var c,d;return c=$(a),d=e(c.map(b.optSortData))},e=function(a){var b;return b={},angular.forEach(a,function(a){return angular.extend(b,a)}),b},d=function(a,b,c,d){var e,f,g,h,i;return e=function(a,b,c){var d;if(!b.length)return a.text();switch(d="",c.charAt(0)){case"#":d=b.text();break;case".":d=b.text();break;case"[":d=b.attr(c.replace("[","").replace("]","").split()[0])}return d},h=function(a,b){var c,d;return c=function(a){return isNaN(a)?Number.POSITIVE_INFINITY:a},d={text:function(a){return a.toString()},integer:function(a){return c(parseInt(a,10))},"float":function(a){return c(parseFloat(a))},"boolean":function(a){return"true"===a}},d[b]?d[b](a):a},f=b.find(a),g=e(b,f,a),i=h(g,c),d?d(i):i}}]),angular.module("iso.directives",["iso.config","iso.services","iso.controllers"]),angular.module("iso.directives").directive("isotopeContainer",["$injector","$parse",function(a,b){"use strict";var c;return c={},{controller:"angularIsotopeController",link:function(a,c,d){var e,f,g;return g=[],f=d.isoOptions,e={},f&&(g=b(f)(a),angular.isObject(g)&&a.updateOptions(g)),e.element=c,e.isoOptionsEvent=d.isoOptionsSubscribe,e.isoMethodEvent=d.isoMethodSubscribe,e.isoMode=d.isoMode,"true"===d.isoUseInitEvent?a.delayInit(e):a.init(e),c}}}]).directive("isotopeItem",["$rootScope","iso.config","iso.topics","$timeout",function(a,b,c,d){return{restrict:"A",require:"^isotopeContainer",link:function(e,f,g){return e.setIsoElement(f),e.$on("$destroy",function(){a.$broadcast(c.MSG_REMOVE,f)}),g.ngRepeat&&!0===e.$last&&"addItems"===e.isoMode&&f.ready(function(){return d(function(){return e.refreshIso()},b.refreshDelay||0)}),g.ngRepeat||f.ready(function(){return d(function(){return e.refreshIso()},b.refreshDelay||0)}),f}}}]).directive("isoSortbyData",function(){return{restrict:"A",controller:"isoSortByDataController",link:function(a,b){var c,d,e,f,g,h;return g=angular.element(b),f=g.attr("ok-key"),e="iso-opts",h={},c=g.find("[ok-sel]"),c.each(function(){var b;return b=angular.element(this),b.attr("ok-sortby-key",a.getHash(b.attr("ok-sel")))}),d=a.createSortByDataMethods(c),a.storeMethods(d)}}}).directive("optKind",["optionsStore","iso.topics",function(a,b){return{restrict:"A",controller:"isoSortByDataController",link:function(c,d,e){var f,g,h,i,j,k,l,m,n,o,p;if(m=$(d),k=e.okPublish||e.okOptionsPublish||b.MSG_OPTIONS,l=e.okMethodPublish||b.MSG_METHOD,j=m.attr("ok-key"),determineActiveClass=function(){n=e.okActiveClass,n||(n=m.find(".selected").length?"selected":"active"),o="."+n,p=m.find(o)},f=function(a){var b,d,e,f;return e=a.attr("ok-key"),"sortBy"===e?(f={},b=a.find("[ok-sel]"),b.each(function(){var a;return a=angular.element(this),a.attr("ok-sortby-key",c.getHash(a.attr("ok-sel")))}),d=c.createSortByDataMethods(b),c.storeMethods(d)):void 0},g=function(a){var b,c,d,e;return a?(d={},e=a.attr("ok-sortby-key"),b=a.attr("opt-ascending"),c=e||a.attr("ok-sel"),e&&(d.sortAscending=b?"true"===b:!0),d[j]=c,d):void 0},i=function(b){return a.store(b),c.$emit(k,b)},h=function(a){var b;return a.preventDefault(),b=angular.element(a.target),b.hasClass(n)?!1:(m.find(o).removeClass(n),b.addClass(n),i(g(b)),!1)},determineActiveClass(),f(m),p.length){var q=g(p);a.store(q)}return m.on("click",function(a){return h(a)})}}}]),angular.module("iso.services",["iso.config"],["$provide",function(a){return a.factory("optionsStore",["iso.config",function(a){"use strict";var b,c;return b=a.defaultOptions||{},{store:function(a){return angular.extend(b,a),b},retrieve:function(){return b},storeInit:function(a){c=a},retrieveInit:function(){return c}}}])}]).value("iso.topics",{MSG_OPTIONS:"iso-option",MSG_METHOD:"iso-method",MSG_REMOVE:"iso-remove"})}(window,document); 
/** **************************************************** **/
/** ********************** angular-ui-date ****************************** **/
 (function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("angular"), require("jquery-ui/datepicker"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "angular", "jquery-ui/datepicker"], factory);
	else if(typeof exports === 'object')
		exports["angularUiDate"] = factory(require("jquery"), require("angular"), require("jquery-ui/datepicker"));
	else
		root["angularUiDate"] = factory(root["jQuery"], root["angular"], root["jquery-ui/datepicker"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _jquery = __webpack_require__(1);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _angular = __webpack_require__(2);

	var _angular2 = _interopRequireDefault(_angular);

	var _datepicker = __webpack_require__(3);

	var _datepicker2 = _interopRequireDefault(_datepicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// sets up jQuery with the datepicker plugin

	exports.default = _angular2.default.module('ui.date', []).constant('uiDateConfig', {}).constant('uiDateFormatConfig', '').factory('uiDateConverter', ['uiDateFormatConfig', function (uiDateFormatConfig) {
	  return {
	    stringToDate: stringToDate,
	    dateToString: dateToString
	  };

	  function dateToString(uiDateFormat, value) {
	    var dateFormat = uiDateFormat || uiDateFormatConfig;
	    if (value) {
	      if (dateFormat) {
	        try {
	          return _jquery2.default.datepicker.formatDate(dateFormat, value);
	        } catch (formatException) {
	          return undefined;
	        }
	      }

	      if (value.toISOString) {
	        return value.toISOString();
	      }
	    }
	    return null;
	  }

	  function stringToDate(dateFormat, valueToParse) {
	    dateFormat = dateFormat || uiDateFormatConfig;

	    if (_angular2.default.isDate(valueToParse) && !isNaN(valueToParse)) {
	      return valueToParse;
	    }

	    if (_angular2.default.isString(valueToParse)) {
	      if (dateFormat) {
	        return _jquery2.default.datepicker.parseDate(dateFormat, valueToParse);
	      }

	      var isoDate = new Date(valueToParse);
	      return isNaN(isoDate.getTime()) ? null : isoDate;
	    }

	    if (_angular2.default.isNumber(valueToParse)) {
	      // presumably timestamp to date object
	      return new Date(valueToParse);
	    }

	    return null;
	  }
	}]).directive('uiDate', ['uiDateConfig', 'uiDateConverter', function uiDateDirective(uiDateConfig, uiDateConverter) {

	  return {
	    require: '?ngModel',
	    link: function link(scope, element, attrs, controller) {

	      var $element = (0, _jquery2.default)(element);

	      var getOptions = function getOptions() {
	        return _angular2.default.extend({}, uiDateConfig, scope.$eval(attrs.uiDate));
	      };
	      var initDateWidget = function initDateWidget() {
	        var showing = false;
	        var opts = getOptions();

	        function setVal(forcedUpdate) {
	          var keys = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
	          var isDate = _angular2.default.isDate(controller.$modelValue);
	          var preserve = {};

	          if (!forcedUpdate && isDate && controller.$modelValue.toDateString() === $element.datepicker('getDate').toDateString()) {
	            return;
	          }

	          if (isDate) {
	            _angular2.default.forEach(keys, function (key) {
	              preserve[key] = controller.$modelValue['get' + key]();
	            });
	          }

	          var newViewValue = $element.datepicker('getDate');

	          if (isDate) {
	            _angular2.default.forEach(keys, function (key) {
	              newViewValue['set' + key](preserve[key]);
	            });
	          }

	          controller.$setViewValue(newViewValue);
	        }

	        // If we have a controller (i.e. ngModelController) then wire it up
	        if (controller) {
	          // Set the view value in a $apply block when users selects
	          // (calling directive user's function too if provided)
	          var _onSelect = opts.onSelect || _angular2.default.noop;
	          opts.onSelect = function (value, picker) {
	            scope.$apply(function () {
	              showing = true;
	              setVal();
	              $element.blur();
	              _onSelect(value, picker, $element);
	            });
	          };

	          var _beforeShow = opts.beforeShow || _angular2.default.noop;
	          opts.beforeShow = function (input, picker) {
	            showing = true;
	            _beforeShow(input, picker, $element);
	          };

	          var _onClose = opts.onClose || _angular2.default.noop;
	          opts.onClose = function (value, picker) {
	            showing = false;
	            _onClose(value, picker, $element);
	          };

	          element.on('focus', function (focusEvent) {
	            if (attrs.readonly) {
	              focusEvent.stopImmediatePropagation();
	            }
	          });

	          $element.off('blur.datepicker').on('blur.datepicker', function () {
	            if (!showing) {
	              scope.$apply(function () {
	                $element.datepicker('setDate', $element.datepicker('getDate'));
	                setVal();
	              });
	            }
	          });

	          controller.$validators.uiDateValidator = function uiDateValidator(modelValue, viewValue) {
	            return viewValue === null || viewValue === '' || _angular2.default.isDate(uiDateConverter.stringToDate(attrs.uiDateFormat, viewValue));
	          };

	          controller.$parsers.push(function uiDateParser(valueToParse) {
	            return uiDateConverter.stringToDate(attrs.uiDateFormat, valueToParse);
	          });

	          // Update the date picker when the model changes
	          controller.$render = function () {
	            // Force a render to override whatever is in the input text box
	            if (_angular2.default.isDate(controller.$modelValue) === false && _angular2.default.isString(controller.$modelValue)) {
	              controller.$modelValue = uiDateConverter.stringToDate(attrs.uiDateFormat, controller.$modelValue);
	            }
	            $element.datepicker('setDate', controller.$modelValue);
	          };
	        }
	        // Check if the $element already has a datepicker.
	        //

	        if ($element.data('datepicker')) {
	          // Updates the datepicker options
	          $element.datepicker('option', opts);
	          $element.datepicker('refresh');
	        } else {
	          // Creates the new datepicker widget
	          $element.datepicker(opts);

	          // Cleanup on destroy, prevent memory leaking
	          $element.on('$destroy', function () {
	            $element.datepicker('hide');
	            $element.datepicker('destroy');
	          });
	        }

	        if (controller) {
	          controller.$render();
	          // Update the model with the value from the datepicker after parsed
	          setVal(true);
	        }
	      };

	      // Watch for changes to the directives options
	      scope.$watch(getOptions, initDateWidget, true);
	    }
	  };
	}]).directive('uiDateFormat', ['uiDateConverter', function (uiDateConverter) {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, modelCtrl) {
	      var dateFormat = attrs.uiDateFormat;

	      // Use the datepicker with the attribute value as the dateFormat string to convert to and from a string
	      modelCtrl.$formatters.unshift(function (value) {
	        return uiDateConverter.stringToDate(dateFormat, value);
	      });

	      modelCtrl.$parsers.push(function (value) {
	        return uiDateConverter.dateToString(dateFormat, value);
	      });
	    }
	  };
	}]);

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }
/******/ ])
});
;
//# sourceMappingURL=date.js.map 
/** **************************************************** **/
/** ********************** angular-ui-mask ****************************** **/
 /*!
 * angular-ui-mask
 * https://github.com/angular-ui/ui-mask
 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
 * License: MIT
 */
!function(){"use strict";angular.module("ui.mask",[]).value("uiMaskConfig",{maskDefinitions:{9:/\d/,A:/[a-zA-Z]/,"*":/[a-zA-Z0-9]/},clearOnBlur:!0,clearOnBlurPlaceholder:!1,escChar:"\\",eventsToHandle:["input","keyup","click","focus"],addDefaultPlaceholder:!0,allowInvalidValue:!1}).provider("uiMask.Config",function(){var e={};this.maskDefinitions=function(n){return e.maskDefinitions=n},this.clearOnBlur=function(n){return e.clearOnBlur=n},this.clearOnBlurPlaceholder=function(n){return e.clearOnBlurPlaceholder=n},this.eventsToHandle=function(n){return e.eventsToHandle=n},this.addDefaultPlaceholder=function(n){return e.addDefaultPlaceholder=n},this.allowInvalidValue=function(n){return e.allowInvalidValue=n},this.$get=["uiMaskConfig",function(n){var t=n;for(var a in e)angular.isObject(e[a])&&!angular.isArray(e[a])?angular.extend(t[a],e[a]):t[a]=e[a];return t}]}).directive("uiMask",["uiMask.Config",function(e){function n(e){return e===document.activeElement&&(!document.hasFocus||document.hasFocus())&&!!(e.type||e.href||~e.tabIndex)}return{priority:100,require:"ngModel",restrict:"A",compile:function(){var t=angular.copy(e);return function(e,a,i,r){function l(e){return angular.isDefined(e)?(w(e),L?(h(),d(),!0):f()):f()}function u(e){e&&(B=e,!L||0===a.val().length&&angular.isDefined(i.placeholder)||a.val(m(p(a.val()))))}function o(){return l(i.uiMask)}function c(e){return L?(j=p(e||""),R=g(j),r.$setValidity("mask",R),j.length&&(R||Q.allowInvalidValue)?m(j):void 0):e}function s(e){return L?(j=p(e||""),R=g(j),r.$viewValue=j.length?m(j):"",r.$setValidity("mask",R),R||Q.allowInvalidValue?J?r.$viewValue:j:void 0):e}function f(){return L=!1,v(),angular.isDefined(q)?a.attr("placeholder",q):a.removeAttr("placeholder"),angular.isDefined(W)?a.attr("maxlength",W):a.removeAttr("maxlength"),a.val(r.$modelValue),r.$viewValue=r.$modelValue,!1}function h(){j=F=p(r.$modelValue||""),H=_=m(j),R=g(j),i.maxlength&&a.attr("maxlength",2*S[S.length-1]),!q&&Q.addDefaultPlaceholder&&a.attr("placeholder",B);for(var e=r.$modelValue,n=r.$formatters.length;n--;)e=r.$formatters[n](e);r.$viewValue=e||"",r.$render()}function d(){Z||(a.bind("blur",$),a.bind("mousedown mouseup",V),a.bind("keydown",E),a.bind(Q.eventsToHandle.join(" "),O),Z=!0)}function v(){Z&&(a.unbind("blur",$),a.unbind("mousedown",V),a.unbind("mouseup",V),a.unbind("keydown",E),a.unbind("input",O),a.unbind("keyup",O),a.unbind("click",O),a.unbind("focus",O),Z=!1)}function g(e){return e.length?e.length>=T:!0}function p(e){var n,t,i="",r=a[0],l=A.slice(),u=N,o=u+C(r),c="";return e=e.toString(),n=0,t=e.length-B.length,angular.forEach(I,function(a){var i=a.position;i>=u&&o>i||(i>=u&&(i+=t),e.substring(i,i+a.value.length)===a.value&&(c+=e.slice(n,i),n=i+a.value.length))}),e=c+e.slice(n),angular.forEach(e.split(""),function(e){l.length&&l[0].test(e)&&(i+=e,l.shift())}),i}function m(e){var n="",t=S.slice();return angular.forEach(B.split(""),function(a,i){e.length&&i===t[0]?(n+=e.charAt(0)||"_",e=e.substr(1),t.shift()):n+=a}),n}function b(e){var n,t=angular.isDefined(i.uiMaskPlaceholder)?i.uiMaskPlaceholder:i.placeholder;return angular.isDefined(t)&&t[e]?t[e]:(n=angular.isDefined(i.uiMaskPlaceholderChar)&&i.uiMaskPlaceholderChar?i.uiMaskPlaceholderChar:"_","space"===n.toLowerCase()?" ":n[0])}function k(){var e,n,t=B.split("");S&&!isNaN(S[0])&&angular.forEach(S,function(e){t[e]="_"}),e=t.join(""),n=e.replace(/[_]+/g,"_").split("_"),n=n.filter(function(e){return""!==e});var a=0;return n.map(function(n){var t=e.indexOf(n,a);return a=t+1,{value:n,position:t}})}function w(e){var n=0;if(S=[],A=[],B="",angular.isString(e)){T=0;var t=!1,a=0,i=e.split(""),r=!1;angular.forEach(i,function(e,i){r?(r=!1,B+=e,n++):Q.escChar===e?r=!0:Q.maskDefinitions[e]?(S.push(n),B+=b(i-a),A.push(Q.maskDefinitions[e]),n++,t||T++,t=!1):"?"===e?(t=!0,a++):(B+=e,n++)})}S.push(S.slice().pop()+1),I=k(),L=S.length>1?!0:!1}function $(){if((Q.clearOnBlur||Q.clearOnBlurPlaceholder&&0===j.length&&i.placeholder)&&(N=0,z=0,R&&0!==j.length||(H="",a.val(""),e.$apply(function(){r.$pristine||r.$setViewValue("")}))),j!==U){var n=a.val(),t=""===j&&n&&angular.isDefined(i.uiMaskPlaceholderChar)&&"space"===i.uiMaskPlaceholderChar;t&&a.val(""),y(a[0]),t&&a.val(n)}U=j}function y(e){var n;angular.isFunction(window.Event)&&!e.fireEvent?(n=new Event("change",{view:window,bubbles:!0,cancelable:!1}),e.dispatchEvent(n)):"createEvent"in document?(n=document.createEvent("HTMLEvents"),n.initEvent("change",!1,!0),e.dispatchEvent(n)):e.fireEvent&&e.fireEvent("onchange")}function V(e){"mousedown"===e.type?a.bind("mouseout",M):a.unbind("mouseout",M)}function M(){z=C(this),a.unbind("mouseout",M)}function E(e){var n=8===e.which,t=P(this)-1||0,i=90===e.which&&e.ctrlKey;if(n){for(;t>=0;){if(D(t)){x(this,t+1);break}t--}K=-1===t}i&&(a.val(""),e.preventDefault())}function O(n){n=n||{};var t=n.which,i=n.type;if(16!==t&&91!==t){var l,u=a.val(),o=_,c=!1,s=p(u),f=F,h=P(this)||0,d=N||0,v=h-d,g=S[0],b=S[s.length]||S.slice().shift(),k=z||0,w=C(this)>0,$=k>0,y=u.length>o.length||k&&u.length>o.length-k,V=u.length<o.length||k&&u.length===o.length-k,M=t>=37&&40>=t&&n.shiftKey,E=37===t,O=8===t||"keyup"!==i&&V&&-1===v,A=46===t||"keyup"!==i&&V&&0===v&&!$,I=(E||O||"click"===i)&&h>g;if(z=C(this),!M&&(!w||"click"!==i&&"keyup"!==i&&"focus"!==i)){if(O&&K)return a.val(B),e.$apply(function(){r.$setViewValue("")}),void x(this,d);if("input"===i&&V&&!$&&s===f){for(;O&&h>g&&!D(h);)h--;for(;A&&b>h&&-1===S.indexOf(h);)h++;var T=S.indexOf(h);s=s.substring(0,T)+s.substring(T+1),s!==f&&(c=!0)}for(l=m(s),_=l,F=s,!c&&u.length>l.length&&(c=!0),a.val(l),c&&e.$apply(function(){r.$setViewValue(l)}),y&&g>=h&&(h=g+1),I&&h--,h=h>b?b:g>h?g:h;!D(h)&&h>g&&b>h;)h+=I?-1:1;(I&&b>h||y&&!D(d))&&h++,N=h,x(this,h)}}}function D(e){return S.indexOf(e)>-1}function P(e){if(!e)return 0;if(void 0!==e.selectionStart)return e.selectionStart;if(document.selection&&n(a[0])){e.focus();var t=document.selection.createRange();return t.moveStart("character",e.value?-e.value.length:0),t.text.length}return 0}function x(e,t){if(!e)return 0;if(0!==e.offsetWidth&&0!==e.offsetHeight)if(e.setSelectionRange)n(a[0])&&(e.focus(),e.setSelectionRange(t,t));else if(e.createTextRange){var i=e.createTextRange();i.collapse(!0),i.moveEnd("character",t),i.moveStart("character",t),i.select()}}function C(e){return e?void 0!==e.selectionStart?e.selectionEnd-e.selectionStart:window.getSelection?window.getSelection().toString().length:document.selection?document.selection.createRange().text.length:0:0}var S,A,B,I,T,j,H,R,_,F,N,z,K,L=!1,Z=!1,q=i.placeholder,W=i.maxlength,G=r.$isEmpty;r.$isEmpty=function(e){return G(L?p(e||""):e)};var J=!1;i.$observe("modelViewValue",function(e){"true"===e&&(J=!0)}),i.$observe("allowInvalidValue",function(e){Q.allowInvalidValue=""===e?!0:!!e,c(r.$modelValue)});var Q={};i.uiOptions?(Q=e.$eval("["+i.uiOptions+"]"),Q=angular.isObject(Q[0])?function(e,n){for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&(void 0===n[t]?n[t]=angular.copy(e[t]):angular.isObject(n[t])&&!angular.isArray(n[t])&&(n[t]=angular.extend({},e[t],n[t])));return n}(t,Q[0]):t):Q=t,i.$observe("uiMask",l),angular.isDefined(i.uiMaskPlaceholder)?i.$observe("uiMaskPlaceholder",u):i.$observe("placeholder",u),angular.isDefined(i.uiMaskPlaceholderChar)&&i.$observe("uiMaskPlaceholderChar",o),r.$formatters.unshift(c),r.$parsers.unshift(s);var U=a.val();a.bind("mousedown mouseup",V),Array.prototype.indexOf||(Array.prototype.indexOf=function(e){if(null===this)throw new TypeError;var n=Object(this),t=n.length>>>0;if(0===t)return-1;var a=0;if(arguments.length>1&&(a=Number(arguments[1]),a!==a?a=0:0!==a&&a!==1/0&&a!==-(1/0)&&(a=(a>0||-1)*Math.floor(Math.abs(a)))),a>=t)return-1;for(var i=a>=0?a:Math.max(t-Math.abs(a),0);t>i;i++)if(i in n&&n[i]===e)return i;return-1})}}}}])}(); 
/** **************************************************** **/
/** ********************** angular-socialshare ****************************** **/
 /*
 * angular-socialshare
 * 2.2.1
 * 
 * A social media url and content share module for angularjs.
 * http://720kb.githb.io/angular-socialshare
 * 
 * MIT license
 * Tue Jun 21 2016
 */
!function(e){"use strict";var o="socialshare",i="Socialshare",a=["facebook","facebook-messenger","twitter","linkedin","google","pinterest","tumblr","reddit","stumbleupon","buffer","digg","delicious","vk","pocket","wordpress","flipboard","xing","hackernews","evernote","whatsapp","telegram","viber","skype","email","ok"],s=function(){var o=[{provider:"email",conf:{subject:"",body:"",to:"",cc:"",bcc:"",trigger:"click"}},{provider:"facebook",conf:{url:"",text:"",media:"",type:"",via:"",to:"",from:"",ref:"",display:"",source:"",caption:"",redirectUri:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"facebook-messenger",conf:{url:""}},{provider:"twitter",conf:{url:"",text:"",via:"",hashtags:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"linkedin",conf:{url:"",text:"",description:"",source:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"reddit",conf:{url:"",text:"",subreddit:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"vk",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"ok",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"digg",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"delicious",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"stumbleupon",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"pinterest",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"google",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"tumblr",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"buffer",conf:{url:"",text:"",via:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"pocket",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"flipboard",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"hackernews",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"wordpress",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"xing",conf:{url:"",text:"",media:"",follow:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"evernote",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"whatsapp",conf:{url:"",text:""}},{provider:"telegram",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"viber",conf:{url:"",text:""}},{provider:"skype",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}}];return{configure:function(i){var s,t,r,h,c=0,p=0,n=e.injector(["ng"]).get("$log");if(i&&i.length>0)for(;c<i.length;c+=1)if(i[c].provider&&a.indexOf(i[c].provider)>-1){for(;p<o.length;p+=1)if(h=o[p],h&&h.provider&&i[c].provider===h.provider){for(s=Object.keys(h.conf),t=0;t<s.length;t+=1)r=s[t],r&&i[c].conf[r]&&(h.conf[r]=i[c].conf[r]);p=0;break}}else n.warn("Invalid provider at element "+c+" with name:"+i[c].provider)},$get:function(){return o}}},t=function(e,o,i){var a;i.socialshareType&&"feed"===i.socialshareType?(a="https://www.facebook.com/dialog/feed?",i.socialshareVia&&(a+="&app_id="+encodeURIComponent(i.socialshareVia)),i.socialshareRedirectUri&&(a+="&redirect_uri="+encodeURIComponent(i.socialshareRedirectUri)),i.socialshareUrl&&(a+="&link="+encodeURIComponent(i.socialshareUrl)),i.socialshareTo&&(a+="&to="+encodeURIComponent(i.socialshareTo)),i.socialshareDisplay&&(a+="&display="+encodeURIComponent(i.socialshareDisplay)),i.socialshareRef&&(a+="&ref="+encodeURIComponent(i.socialshareRef)),i.socialshareFrom&&(a+="&from="+encodeURIComponent(i.socialshareFrom)),i.socialshareDescription&&(a+="&description="+encodeURIComponent(i.socialshareDescription)),i.socialshareText&&(a+="&name="+encodeURIComponent(i.socialshareText)),i.socialshareCaption&&(a+="&caption="+encodeURIComponent(i.socialshareCaption)),i.socialshareMedia&&(a+="&picture="+encodeURIComponent(i.socialshareMedia)),i.socialshareSource&&(a+="&source="+encodeURIComponent(i.socialshareSource)),e.open(a,"Facebook","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)):i.socialshareType&&"send"===i.socialshareType?(a="https://www.facebook.com/dialog/send?",i.socialshareVia&&(a+="&app_id="+encodeURIComponent(i.socialshareVia)),i.socialshareRedirectUri&&(a+="&redirect_uri="+encodeURIComponent(i.socialshareRedirectUri)),i.socialshareUrl&&(a+="&link="+encodeURIComponent(i.socialshareUrl)),i.socialshareTo&&(a+="&to="+encodeURIComponent(i.socialshareTo)),i.socialshareDisplay&&(a+="&display="+encodeURIComponent(i.socialshareDisplay)),i.socialshareRef&&(a+="&ref="+encodeURIComponent(i.socialshareRef)),e.open(a,"Facebook","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)):e.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(i.socialshareUrl||o.absUrl()),"Facebook","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},r=function(e,o,i){var a="mailto:";i.socialshareTo&&(a+=encodeURIComponent(i.socialshareTo)),a+="?",i.socialshareBody&&(a+="body="+i.socialshareBody),i.socialshareSubject&&(a+="&subject="+encodeURIComponent(i.socialshareSubject)),i.socialshareCc&&(a+="&cc="+encodeURIComponent(i.socialshareCc)),i.socialshareBcc&&(a+="&bcc="+encodeURIComponent(i.socialshareBcc)),e.open(a,"_self")},h=function(e,o,i,a){var s="fb-messenger://share?link="+encodeURIComponent(i.socialshareUrl||o.absUrl());a.attr("href",s)},c=function(e,o,i){var a="https://www.twitter.com/intent/tweet?";i.socialshareText&&(a+="text="+encodeURIComponent(i.socialshareText)),i.socialshareVia&&(a+="&via="+encodeURIComponent(i.socialshareVia)),i.socialshareHashtags&&(a+="&hashtags="+encodeURIComponent(i.socialshareHashtags)),a+="&url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Twitter","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},p=function(e,o,i){e.open("https://plus.google.com/share?url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),"Google+","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},n=function(e,o,i){var a="https://www.reddit.com/";a+=i.socialshareSubreddit?"r/"+i.socialshareSubreddit+"/submit?url=":"submit?url=",i.socialsharePopupWidth<900&&(i.socialsharePopupWidth=900),i.socialsharePopupHeight<650&&(i.socialsharePopupHeight=650),e.open(a+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"Reddit","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},l=function(e,o,i){e.open("https://www.stumbleupon.com/submit?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"StumbleUpon","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},d=function(e,o,i){var a="https://www.linkedin.com/shareArticle?mini=true";a+="&url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),i.socialshareText&&(a+="&title="+encodeURIComponent(i.socialshareText)),i.socialshareDescription&&(a+="&summary="+encodeURIComponent(i.socialshareDescription)),i.socialshareSource&&(a+="&source="+encodeURIComponent(i.socialshareSource)),e.open(a,"Linkedin","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},u=function(e,o,i){e.open("https://www.pinterest.com/pin/create/button/?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&media="+encodeURIComponent(i.socialshareMedia)+"&description="+encodeURIComponent(i.socialshareText),"Pinterest","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},g=function(e,o,i){e.open("https://www.digg.com/submit?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"Digg","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},f=function(e,o,i){if(i.socialshareMedia){var a="https://www.tumblr.com/share/photo?source="+encodeURIComponent(i.socialshareMedia);i.socialshareText&&(a+="&caption="+encodeURIComponent(i.socialshareText)),e.open(a,"Tumblr","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)}else e.open("https://www.tumblr.com/share/link?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&description="+encodeURIComponent(i.socialshareText),"Tumblr","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},b=function(e,o,i){var a="https://www.vk.com/share.php?url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&title="+encodeURIComponent(i.socialshareText)),i.socialshareMedia&&(a+="&image="+encodeURIComponent(i.socialshareMedia)),i.socialshareDescription&&(a+="&description="+encodeURIComponent(i.socialshareDescription)),e.open(a,"Vk","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},m=function(e,o,i){e.open("http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&st.comments="+encodeURIComponent(i.socialshareText),"Ok","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},U=function(e,o,i){e.open("https://www.delicious.com/save?v=5&noui&jump=close&url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"Delicious","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},k=function(e,o,i){var a="https://bufferapp.com/add?";i.socialshareText&&(a+="text="+encodeURIComponent(i.socialshareText)),i.socialshareVia&&(a+="&via="+encodeURIComponent(i.socialshareVia)),a+="&url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Buffer","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},w=function(e,o,i){var a="https://news.ycombinator.com/submitlink?";i.socialshareText&&(a+="t="+encodeURIComponent(i.socialshareText)+"&"),a+="u="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Hackernews","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},P=function(e,o,i){var a="https://share.flipboard.com/bookmarklet/popout?v=2&";i.socialshareText&&(a+="title="+encodeURIComponent(i.socialshareText)+"&"),a+="url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Flipboard","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},H=function(e,o,i){var a="https://getpocket.com/save?";i.socialshareText&&(a+="text="+encodeURIComponent(i.socialshareText)+"&"),a+="url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Pocket","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},v=function(e,o,i){var a="http://wordpress.com/press-this.php?";i.socialshareText&&(a+="t="+encodeURIComponent(i.socialshareText)+"&"),i.socialshareMedia&&(a+="i="+encodeURIComponent(i.socialshareMedia)+"&"),a+="u="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Wordpress","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},W=function(e,o,i){var a="";i.socialshareFollow&&(a="&follow_url="+encodeURIComponent(i.socialshareFollow)),e.open("https://www.xing.com/spi/shares/new?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+a,"Xing","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},R=function(e,o,i){var a="http://www.evernote.com/clip.action?url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&title="+encodeURIComponent(i.socialshareText)),e.open(a,"Evernote","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},C=function(e,o,i,a){var s="whatsapp://send?text="+encodeURIComponent(i.socialshareText+" ")+encodeURIComponent(i.socialshareUrl||o.absUrl());a.attr("href",s)},I=function(e,o,i,a){var s="viber://forward?text="+encodeURIComponent(i.socialshareText+" ")+encodeURIComponent(i.socialshareUrl||o.absUrl());a.attr("href",s)},x=function(e,o,i){var a="https://telegram.me/share/url?url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&text="+encodeURIComponent(i.socialshareText)),e.open(a,"Telegram","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},S=function(e,o,i){var a="https://web.skype.com/share?source=button&url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&text="+encodeURIComponent(i.socialshareText)),e.open(a,"Skype","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},y=["$window","$location",function(e,o){this.emailShare=r,this.facebookShare=t,this.twitterShare=c,this.stumbleuponShare=l,this.pinterestShare=u,this.googleShare=p,this.bufferShare=k,this.hackernewsShare=w,this.okShare=m,this.deliciousShare=U,this.pocketShare=H,this.vkShare=b,this.flipboardShare=P,this.xingShare=W,this.diggShare=g,this.linkedinShare=d,this.wordpressShare=v,this.telegramShare=x,this.redditShare=n,this.evernoteShare=R,this.tumblrShare=f,this.skypeShare=S,this.share=function(i){switch(i.provider){case"email":this.emailShare(e,o,i.attrs);break;case"facebook":this.facebookShare(e,o,i.attrs);break;case"twitter":this.twitterShare(e,o,i.attrs);break;case"pinterest":this.pinterestShare(e,o,i.attrs);break;case"ok":this.okShare(e,o,i.attrs);break;case"vk":this.vkShare(e,o,i.attrs);break;case"delicious":this.deliciousShare(e,o,i.attrs);break;case"digg":this.diggShare(e,o,i.attrs);break;case"google+":this.googleShare(e,o,i.attrs);break;case"reddit":this.redditShare(e,o,i.attrs);break;case"hackernews":this.hackernewsShare(e,o,i.attrs);break;case"skype":this.skypeShare(e,o,i.attrs);break;case"evernote":this.evernoteShare(e,o,i.attrs);break;case"pocket":this.pocketShare(e,o,i.attrs);break;case"tumblr":this.tumblrShare(e,o,i.attrs);break;case"telegram":this.telegramShare(e,o,i.attrs);break;case"xing":this.xingShare(e,o,i.attrs);break;case"buffer":this.bufferShare(e,o,i.attrs);break;case"stumbleupon":this.stumbleuponShare(e,o,i.attrs);break;case"linkedin":this.linkedinShare(e,o,i.attrs);break;case"wordpress":this.wordpressShare(e,o,i.attrs);break;case"flipboard":this.flipboardShare(e,o,i.attrs);break;default:return}}}],T=["$window","$location","socialshareConf","Socialshare","$log",function(e,o,i,s){var t=function(t,r,h){for(var c,p=0,n=(function(){return h.socialshareProvider in z?void z[h.socialshareProvider](e,o,h,r):!0});p<i.length;p+=1)if(i[p].provider===h.socialshareProvider){c=i[p];break}-1===a.indexOf(c.provider)&&s.warn("Invalid Provider Name : "+h.socialshareProvider),h.socialshareUrl=h.socialshareUrl||c.conf.url,h.socialshareText=h.socialshareText||c.conf.text,h.socialshareMedia=h.socialshareMedia||c.conf.media,h.socialshareType=h.socialshareType||c.conf.type,h.socialshareVia=h.socialshareVia||c.conf.via,h.socialshareTo=h.socialshareTo||c.conf.to,h.socialshareFrom=h.socialshareFrom||c.conf.from,h.socialshareRef=h.socialshareRef||c.conf.ref,h.socialshareDislay=h.socialshareDislay||c.conf.display,h.socialshareSource=h.socialshareSource||c.conf.source,h.socialshareCaption=h.socialshareCaption||c.conf.caption,h.socialshareRedirectUri=h.socialshareRedirectUri||c.conf.redirectUri,h.socialshareTrigger=h.socialshareTrigger||c.conf.trigger,h.socialsharePopupHeight=h.socialsharePopupHeight||c.conf.popupHeight,h.socialsharePopupWidth=h.socialsharePopupWidth||c.conf.popupWidth,h.socialshareSubreddit=h.socialshareSubreddit||c.conf.subreddit,h.socialshareDescription=h.socialshareDescription||c.conf.description,h.socialshareFollow=h.socialshareFollow||c.conf.follow,h.socialshareHashtags=h.socialshareHashtags||c.conf.hashtags,h.socialshareBody=h.socialshareBody||c.conf.body,h.socialshareSubject=h.socialshareSubject||c.conf.subject,h.socialshareCc=h.socialshareCc||c.conf.cc,h.socialshareBcc=h.socialshareBcc||c.conf.bcc,h.socialshareTrigger?r.bind(h.socialshareTrigger,n):n()};return{restrict:"A",link:t}}],z={email:r,facebook:t,"facebook-messenger":h,twitter:c,google:p,reddit:n,stumbleupon:l,linkedin:d,pinterest:u,digg:g,tumblr:f,vk:b,ok:m,delicious:U,buffer:k,hackernews:w,flipboard:P,pocket:H,wordpress:v,xing:W,evernote:R,whatsapp:C,telegram:x,viber:I,skype:S};e.module("720kb.socialshare",[]).provider(o+"Conf",s).service(i,y).directive(o,T)}(angular);
//# sourceMappingURL=angular-socialshare.js.map
 
/** **************************************************** **/;

/** ****************************************************
  Module mrShared.controllers
**************************************************** **/
angular.module('mrShared.controllers', ['ngResource']).
controller('DynoCtl', ['$scope', '$injector', function($scope, $injector) {
  var thisCtl = this;

  $scope.injectAs = function(modules) {
    Object.keys(modules).forEach(function(scopeName) {
      $scope[scopeName] = $injector.get(modules[scopeName]);
    });
  };

  $scope.require = function(requirements) {
    if (Array.isArray(requirements)) {
      requirements.forEach(function(requirement) {
        $scope[requirement] = $injector.get(requirement);
      });
    } else {
      $scope[requirements] = $injector.get(requirements);
    }
  };

  $scope.defineFunc = function(name, args, code) {
    if (arguments.length === 2) {
      code = args;
      args = [];
    }
    args.unshift('$scope');
    var theFunc = new Function(args, code);
    $scope[name] = theFunc.bind(thisCtl, $scope);
  };


}])
.
controller('searchPaginatorCtl', ['$scope', '$location', 'cmsSvc', function($scope, $location, cmsSvc) {

  $scope.page = 1;
  $scope.pageOneSize = 10;
  $scope.pageSize = 10;
  $scope.searchField = '_all';
  $scope.searchType = '';
  $scope.searchVal = '';
  $scope.searchFunc = 'queryAll';
  $scope.numResults = 0;
  $scope.searchResults = [];

  $scope.initVals = function initVals(page, pageSize, numResults, searchFunc, searchType, searchVal, pageOneSize) {
    if (typeof page === 'object') {
      Object.keys(page).forEach(function(key) {
        $scope[key] = page[key];
      });
      return;
    }

    $scope.page = page || $scope.page;
    $scope.renderedPage = page;
    $scope.pageSize = pageSize || $scope.pageSize;
    $scope.numResults = numResults || $scope.numResults;
    $scope.searchFunc = searchFunc || $scope.searchFunc;
    $scope.searchType = searchType || $scope.searchType;
    $scope.searchVal = searchVal || $scope.searchVal;
    $scope.pageOneSize = pageOneSize || $scope.pageOneSize;
  };

  $scope.pageUp = function pageUp() {
    if (lastItemIndex() < $scope.numResults) {
      $scope.page++;
      doSearch();
    }
  };

  $scope.pageDown = function pageDown() {
    $scope.page--;
    doSearch();
  };

  $scope.hasNextPage = function hasNextPage() {
    return $scope.nextPageSize();
  };

  $scope.nextPageSize = function nextPageSize() {
    var size = $scope.page === 1 ? ($scope.pageOneSize * $scope.page) : (($scope.pageSize * $scope.page) + Math.abs($scope.pageOneSize - $scope.pageSize));
    var remaining = $scope.numResults - size;

    remaining = remaining <= 0 ? 0 : remaining;
    return remaining < $scope.pageSize ? remaining : $scope.pageSize;
  };

  $scope.prevPageSize = function prevPageSize() {
    if ($scope.page === 2) {
      return $scope.pageOneSize;
    }
    return $scope.pageSize;
  };

  function lastItemIndex() {
    return (($scope.page - 1) * $scope.pageSize) + $scope.pageOneSize;
  }

  function getSearchFieldParams($scope, packet) {
    packet.params = {
      s: $scope.pageSize,
      p: $scope.page,
      searchType: $scope.searchType,
      searchVal: $scope.searchVal
    };
  }

  function getSearchParams($scope, packet) {
    packet.params = {
      s: $scope.pageSize,
      p: getPageCount(),
      searchType: $scope.searchType,
      searchVal: $scope.searchVal
    };
  }

  function doSearch() {
    var packet = {
      moduleName: 'content',
      methodName: 'searchBlogContent'
    };

    if ($scope.searchType !== 'search' && $scope.searchVal) {
      getSearchFieldParams($scope, packet);
    } else if ($scope.searchType === 'search' && $scope.searchVal) {
      getSearchParams($scope, packet);
    } else {
      packet.params = {
        s: $scope.pageSize,
        s1: $scope.pageOneSize,
        p: $scope.page,
        searchType: $scope.searchType,
        searchVal: $scope.searchVal
      };
    }

    if ($scope.searchVal) {
      packet.q = $scope.searchVal;
    }

    cmsSvc.callDeferedGetterMethod(packet, function(results) {
      $scope.numResults = results.total;
      $scope.searchResults = results.hits;

      //punting on saving paginated history
      // window.history.pushState({}, 'Madison Reed | Blog', '?p=' + $scope.page);
      // window.history.pushState({}, 'M.reload(false);

      var loc = window.location;
      var baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
      var thisUrl = baseUrl;
      if ($scope.page !== 1) {
        thisUrl += '?p=' + $scope.page;
      }

      var prevUrl = $scope.page === 1 ? '' : $scope.page === 2 ? baseUrl : baseUrl + '?p=' + ($scope.page - 1);
      var nextUrl = $scope.nextPageSize() ? baseUrl + '?p=' + ($scope.page + 1) : '';

      $('link[rel=canonical]').attr('href', thisUrl);

      var prevLink = $('link[rel=prev]');

      if (prevUrl) {
        if (prevLink.length) {
          prevLink.attr('href', prevUrl);
        } else {
          $('head').append('<link rel="prev" href="' + prevUrl + '" />');
        }
      } else if (prevLink.length) {
        prevLink.remove();
      }

      var nextLink = $('link[rel=next]');
      if (nextUrl) {
        if (nextLink.length) {
          nextLink.attr('href', nextUrl);
        } else {
          $('head').append('<link rel="next" href="' + nextUrl + '" />');
        }
      } else {
        nextLink.remove();
      }


    }, function(err) {
      // eslint-disable-next-line no-console
      console.log('Search err', err);
    });
  }

  function getPageCount() {
    return $scope.page === 1 ? 0 : (($scope.page - 2) * $scope.pageSize) + ($scope.pageOneSize == $scope.pageSize ? $scope.pageOneSize + 1 : $scope.pageOneSize);
  }

}]).
controller('siteSearchCtl', ['$scope', 'cmsSvc', 'trackerSvc', function($scope, cmsSvc, trackerSvc) {

  $scope.page = 1;
  $scope.pageOneSize = 10;

  $scope.pageSize = 10;
  $scope.searchVal = '';
  $scope.searchFunc = '';
  $scope.numResults = 0;
  $scope.searchResults = [];

  $scope.initVals = function initVals(paginatorData) {
    if (typeof paginatorData.currentPage === 'object') {
      Object.keys(paginatorData.currentPage).forEach(function(key) {
        $scope[key] = paginatorData.currentPage[key];
      });
      return;
    }

    $scope.page = paginatorData.currentPage || $scope.page;
    $scope.pageSize = paginatorData.pageSize || $scope.pageSize;
    $scope.numResults = paginatorData.totalSearchMatches || $scope.numResults;
    $scope.searchFunc = paginatorData.searchFunc || '';
    $scope.searchVal = paginatorData.searchVal || $scope.searchVal;
    $scope.pageOneSize = paginatorData.pageOneSize || $scope.pageSize;
    $scope.searchResults = paginatorData.searchResults || [];

    trackerSvc.trackEvent('Site Search', {
      term: $scope.searchVal,
      hits: $scope.numResults
    });
  };


  $scope.pageUp = function pageUp() {
    if (lastItemIndex() < $scope.numResults) {
      $scope.page++;
      doSearch();
    }
  };
  $scope.pageDown = function pageDown() {
    $scope.page--;
    doSearch();
  };

  $scope.hasNextPage = function hasNextPage() {
    return $scope.nextPageSize();
  };

  $scope.nextPageSize = function nextPageSize() {
    var size = $scope.page === 1 ? ($scope.pageOneSize * $scope.page) : (($scope.pageSize * $scope.page) + Math.abs($scope.pageOneSize - $scope.pageSize));
    var remaining = $scope.numResults - size;

    remaining = remaining <= 0 ? 0 : remaining;
    return remaining < $scope.pageSize ? remaining : $scope.pageSize;
  };

  $scope.prevPageSize = function prevPageSize() {
    if ($scope.page === 2) {
      return $scope.pageOneSize;
    }
    return $scope.pageSize;
  };

  function lastItemIndex() {
    return (($scope.page - 1) * $scope.pageSize) + $scope.pageOneSize;
  }

  function doSearch() {
    // set results to nothing so that on page refresh is noticable
    $scope.searchResults = [];
    var packet = {
      moduleName: 'content',
      methodName: $scope.searchFunc,
      params: {
        pageSize: $scope.pageSize,
        currentPage: $scope.page,
        searchVal: $scope.searchVal
      }
    };

    if ($scope.searchVal) {
      packet.q = $scope.searchVal;
    }

    cmsSvc.callDeferedGetterMethod(packet, function(results) {
      $scope.numResults = results.total;
      $scope.searchResults = results.hits;
    }, function() {
      $scope.notify('warn', 'We could not complete the request.');
    });
  }
}]);

/** ****************************************************
  Module mrShared.directives
**************************************************** **/
angular.module('mrShared.directives', ['ngResource']).
directive('convertToNumber', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attr, ngModel) {
      ngModel.$parsers.push(function(val) {
        return val != null ? parseInt(val, 10) : null;
      });
      ngModel.$formatters.push(function(val) {
        return val != null ? '' + val : null;
      });
    }
  };
})
.
/* global directive */
directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      element.bind('change', function(){
        scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
}])
.
/* global useCloudinary */
directive('imgBox', ['$window', '$compile', '$timeout', 'imgCropUtilSvc', function($window, $compile, $timeout, imgCropUtilSvc) {
  return {
    template: '<div></div>',
    replace: true,
    restrict: 'E',
    scope: {
      src: '@',
      alt: '@',
      altText: '@',
      image: '=',
      autoResize: '@',
      resizeInterval: '@',
      crop: '=?',
      cropSettings: '@',
      deferredSrc: '@?',
      cacheBust: '=?',
      watermark: '=',
    },
    link: function(scope, iElement) {
      scope.imgSrc = scope.src ? scope.src : scope.deferredSrc;
      if (scope.deferredSrc) {
        scope.$watch('deferredSrc', function(newSrc, oldSrc) {
          if (newSrc == oldSrc) {
            return;
          }
          scope.imgSrc = newSrc;
          //force redraw
          drawImg(iElement.width(), iElement.height());
        });
      }
      scope.autoResize = scope.autoResize || true;

      if (typeof scope.autoResize === 'string') {
        scope.autoResize = scope.autoResize !== 'false';
      }
      scope.resizeInterval = scope.resizeInterval || 50;
      scope.crop = scope.crop || false;

      if (scope.image) {
        if (scope.image.file_type == 'mp4' && scope.image.video_thumb) {
          scope.imgSrc = scope.image.video_thumb;
        } else if (scope.image.url) {
          scope.imgSrc = scope.image.url;
        }
      }

      if (scope.crop) {
        iElement.addClass('full-height');
      }

      var imgElement, lastWidth, baseUrl, timeoutPromise, lastAspect, lastUrl;
      // the following line may look bizarre but I assure you it is necessary...
      // the crops may or may not be populated before this link function runs
      var crops = scope.crops = scope.crops || [];
      var cropsInited = false;
      var wndw = angular.element($window);

      if (scope.cropSettings) {
        scope.crops = eval(scope.cropSettings);
        scope.crops.forEach(function(crop) {
          if (crop.url) {
            crop.url = imgCropUtilSvc.remapUrl(crop.url);
          }
        });
        initCrops();
      }

      scope.windowWidth = function() {
        return wndw.width();
      };

      scope.$watch('image', function(newImage) {
        if (!(newImage && (newImage.url || typeof newImage === 'string' || newImage.file_type === 'an'))) {
          return;
        }
        if (typeof newImage === 'string') {
          scope.imgSrc = newImage;
        } else {
          scope.imgSrc = newImage.url;
        }

        if (newImage.file_type == 'mp4' && newImage.video_thumb) {
          scope.imgSrc = newImage.video_thumb;
        }

        baseUrl = imgCropUtilSvc.remapUrl(scope.imgSrc);

        if (newImage.aspects && newImage.aspects.length) {
          scope.crops = newImage.aspects.map(convertToCrop);
          initCrops();
        }
        lastWidth = -1; // force redraw
        doRedraw(iElement.width(), iElement.height());
      });

      scope.setCrops = function(cropArray) {
        scope.crops = cropArray;
        initCrops();
      };

      if (!scope.image || scope.image.file_type !== 'an') {

        scope.$watch("src", function(newSrc, oldSrc) {
          if (newSrc != oldSrc) {
            doRedraw(iElement.width() || lastWidth, iElement.height());
          }
        });

        if (scope.autoResize) {
          scope.$watch(scope.windowWidth, function() {
            doRedraw(iElement.width(), iElement.height());
          });
        }

        scope.$watch(elementWidth, function(newVal) {
          doRedraw(newVal, iElement.height());
        });

        scope.$watch(elementHeight, function(newHeight) {
          if (scope.crop && newHeight) {
            doRedraw(iElement.width() || lastWidth, newHeight);
          }
        });

        scope.$watch('crop', function() {
          if (typeof scope.crop === 'string') {
            scope.crop = /(1|true|TRUE)/.test(scope.crop);
          }
        });

        scope.$watch('crops', function() {
          doRedraw(iElement.width(), iElement.height());
        });
      }

      function doRedraw(newWidth, newHeight) {
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(redrawImg.bind(this, newWidth, newHeight), 75);
      }

      function drawImg(width, height) {
        if (!scope.imgSrc && !(scope.image && scope.image.file_type === 'an')) {
          return;
        }

        if (scope.image && scope.image.file_type === 'an') {
          imgElement = angular.element(scope.image.data.html);
          iElement.append(imgElement);
          iElement.append(angular.element('<script>' + scope.image.data.js + '</script>'));
          return;
        }

        var isSvg = scope.image && scope.image.file_type == 'svg+xml';

        baseUrl = imgCropUtilSvc.remapUrl(scope.imgSrc);
        lastUrl = baseUrl;
        lastWidth = width;
        lastAspect = Math.round((height / lastWidth) * 100);

        var url = getUrl(width, height);

        if (scope.image && scope.image.file_type == 'mp4') {
          url = scope.image.video_thumb;
        }
        // we only provide alt_text if it exists.  alt-text=undefined can hurt SEO
        var imgHtml = [
          '<img',
        ];

        imgHtml.push('src="' + url + '"');

        if (scope.alt) {
          imgHtml.push('alt="' + scope.alt + '"');
        }

        // Proper way to present alt text otherwise the div above gets the html 'alt' text
        if (scope.altText) {
          imgHtml.push('alt="' + scope.altText + '"');
        }

        if (!isSvg) {
          imgHtml.push('style="width:100%"');
        }

        imgHtml.push('/>');

        imgElement = angular.element(imgHtml.join(' '));
        iElement.empty();
        iElement.append(imgElement);
      }

      function redrawImg(newWidth, newHeight) {
        newWidth = newWidth || iElement.width();
        newHeight = newHeight || iElement.height();
        if (!newWidth) {
          return;
        }
        if (!imgElement) {
          return drawImg(newWidth, newHeight);
        }

        var newAspect = Math.round((newHeight / newWidth) * 100);
        if (!lastWidth || (newWidth > lastWidth && (newWidth - lastWidth) / lastWidth * 100 >= scope.resizeInterval) || newAspect !== lastAspect || lastUrl != baseUrl) {
          lastWidth = newWidth;
          lastAspect = newAspect;
          lastUrl = baseUrl;
          var url = getUrl(newWidth, newHeight);
          if (scope.image && scope.image.file_type == 'mp4') {
            url = scope.image.video_thumb;
          }
          imgElement.attr('src', url);
        }
      }

      function getUrl(w, h) {
        var url = [
          baseUrl,
          '?w=', w
        ];

        if (scope.cacheBust) {
          url.push('&ts=', Date.now());
        }

        if (scope.crop) {
          url.push('&h=', h + 1);
          var cropSettings = getCropSettings(w, h);
          url.push('&' + cropSettings.cropQuery);
          if (cropSettings.url) {
            url.splice(0, 1, cropSettings.url);
          }

          if (scope.watermark && scope.watermark.url) {
            url.push('&mark=' + scope.watermark.url);
            var markalign = cropSettings.markalign || scope.watermark.markalign;
            var markpad = cropSettings.markpad || scope.watermark.markpad;
            var markw = cropSettings.markw || scope.watermark.markw;
            var markh = cropSettings.markh || scope.watermark.markh;
            url.push('&markalign=' + markalign);
            url.push('&markpad=' + markpad);
            url.push('&markfit=clip&markw=' + markw + '&markh=' + markh);
          }
        }

        if (isRetina()) {
          url.push('&dpr=1.7&q=50');
        }

        url.push('&auto=format');
        url = url.join('');
        if (typeof useCloudinary != 'undefined' && useCloudinary) {
          url = imgCropUtilSvc.getCloudinaryUrl(url);
        }
        return url;
      }

      function isRetina() {
        var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)";
        if (window.devicePixelRatio > 1) {
          return true;
        }
        if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
          return true;
        }
        return false;
      }

      function getCropSettings(w, h) {
        var crop;
        if (!cropsInited) {
          initCrops();
        }
        var targetIndex = w / h;
        for (var i = 0; i < crops.length; i++) {
          crop = crops[i];
          if (targetIndex <= crop.cutoff) {
            return crop;
          }
        }
        return { cropQuery: 'fit=crop&crop=faces' };
      }

      function initCrops() {
        if (!(scope.crops && scope.crops.length)) {
          return;
        }
        crops = scope.crops;
        crops.sort(function(a, b) {
          return a.aspectIndex < b.aspectIndex ? -1 : a.aspectIndex === b.aspectIndex ? 0 : 1;
        });
        // note that crops is the same array as scope.crops
        var lastIndex = crops[0].aspectIndex;

        for (var i = 1; i < crops.length; i++) {
          var diff = (crops[i].aspectIndex - lastIndex) / 2;
          crops[i - 1].cutoff = lastIndex + diff;
          lastIndex = crops[i].aspectIndex;
        }
        crops[crops.length - 1].cutoff = Infinity;
      }

      function convertToCrop(aspect) {
        var cropObj = {};
        if (aspect.k) {
          cropObj.key = aspect.k,
            cropObj.aspectIndex = aspect.m,
            cropObj.cropQuery = aspect.q;
        } else {
          cropObj.key = aspect.key;
          cropObj.aspectIndex = aspect.aspectIndex || aspect.m;
          cropObj.cropQuery = aspect.cropQuery;
        }
        if (aspect.url) {
          cropObj.url = imgCropUtilSvc.remapUrl(aspect.url);
        }
        return cropObj;
      }

      function elementWidth() {
        return iElement.width();
      }

      function elementHeight() {
        return iElement.height();
      }
    }
  };
}]).
// easy copy paste directive
directive('mrCopy', [function() {
  return {
    restrict: 'E',
    template: "<textarea ng-model='dataString' style='width: 1px; height: 1px; border: none; padding: 0 !important; background: transparent; color: transparent;' readonly></textarea><a ng-click='copy($event)' style='cursor: pointer;' title='{{title}}'>{{text}}<i ng-if='showIcon' class='fa fa-copy ibtn ibtn-bubble mr-copy'></i></a>",
    scope: {
      copyData: '=', // data to copy
      isObject: '@', // set to true if the data is an object
      text: '@', // optional text field,
      showIcon: '@', // use iconic representation
      title: '@', // optional anchor title on hover
      cleanupFunction: '&?' // optional data cleanup function
    },
    link: function(scope, element) {
      if (!scope.showIcon) {
        scope.text = scope.text || 'Copy';
      }

      scope.title = scope.title || 'Copy';

      scope.dataString = '';
      scope.$watch('copyData', function() {
        let finalCopyData = scope.copyData;

        // Angular always returns a function for the & binding
        // If the binding isn't actually present, this function will just be angular.noop()
        // So only overwrite the finalCopyData if the results of the cleanup function are not undefined
        let cleaned = scope.cleanupFunction(finalCopyData);
        if (cleaned !== undefined) {
          finalCopyData = cleaned;
        }
        
        if (finalCopyData && scope.isObject) {
          scope.dataString = JSON.stringify(finalCopyData);
        } else {
          scope.dataString = finalCopyData;
        }
      }, true);

      scope.copy = function(event) {
        event.stopPropagation();
        var inp = element[0].firstChild;
        var button = element[0].lastChild;
        var icon;
        if (button && button.children[0] && button.children[0].classList.contains('fa')) {
          icon = button.children[0];
        }

        if (inp && inp.select) {
          inp.select();
          document.execCommand('copy');
          inp.blur();
        }

        if (icon) {
          icon.classList.replace('fa-copy', 'fa-check');
          setTimeout(function() {
            icon.classList.replace('fa-check', 'fa-copy');
          }, 1000);
        }
      };
    }
  };
}]).
directive('mrPhoneInput', [function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attrs, ngModel) {
      var viewTimeout;
      var oldValue = null;
      scope.$watch(function() {
        if (ngModel.$viewValue && ngModel.$viewValue != oldValue) {
          oldValue = ngModel.$viewValue;
          var newView = onChange(ngModel.$viewValue);
          if (newView) {
            clearTimeout(viewTimeout);
            viewTimeout = setTimeout(function() {
              ngModel.$setViewValue(newView);
              ngModel.$render();
            }, 150); // slowing down the time!
          }
        }
      });

      var phoneSize = 0;
      var oldSize = 0;

      function onChange(val) {
        var hasWhiteSpace = /\s/g.test(val);
        var digits = val.replace(/\D/g, '');

        if (digits.length != phoneSize || val.length > oldSize || !hasWhiteSpace) {
          phoneSize = digits.length;
          var response = formatPhoneNum(val);
          oldSize = response.length;
          return response;
        }
      }

      function formatPhoneNum(input) {
        var digits = input.replace(/\D/g, '');
        var format = '(???) ???-????';
        var international = false;

        var digitLen = Math.min(digits.length, 15);
        if (digits[0] == 1) {
          digitLen--;
        }

        if (digitLen > 10) {
          international = true;
          var countryCodeLen = Math.min(digitLen - 10, 3);
          var extraLen = 15 - digitLen;
          var countryCode = '';
          var i = 0;
          for (i = 0; i < countryCodeLen; i++) {
            countryCode += '?';
          }

          format = countryCode + ' ??? ??? ?? ??';
          for (i = 0; i < extraLen; i++) {
            format += '?';
          }
        }

        if (digits[0] == 1) {
          format = '? ' + format;
        }

        if (international) {
          format = '+' + format;
        }

        digits = digits.split('');

        var lastIdx = digits.reduce(function(lastIdx) {
          return Math.max(format.indexOf('?', lastIdx) + 1, lastIdx);
        }, -1);

        format = format.substring(0, lastIdx);

        digits.forEach(function(digit) {
          format = format.replace('?', digit);
        });

        return format;
      }
    }
  };
}]).
/* global dataLayer */
directive('mrQuiz', ['$location', '$cookieStore', '$cookies', '$window', '$sce', '$timeout', 'notifySvc', 'quizSvc', 'sharedProductSvc', function($location, $cookieStore, $cookies, $window, $sce, $timeout, notifySvc, quizSvc, sharedProductSvc) {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: '/ngpartials/directives/mr-quiz.html',
    scope: {
      quizName: '@', // The name of the quiz to be looked up in mongo
      customerId: '=?', // Bi-directional customer ID for rendering the quiz, only useful if no customer is present in the session
      queryString: '=?', // Bi-directional object corresponding to the URL query paramets
      prefillData: '=?', // Bi-directional object full of data to be loaded into answers with the setAnswerFromSource action
      persistPayload: '=?', // Bi-directional object to be populated with the payload used to persist the quiz information, useful for when you know you need to save the quiz somewhere outside of this directive's scope
      quickEdit: '=?', // Bi-directional boolean for determining whether or not to render this as minimal display, if true will expand the questions to display all answers, if false will only show selected answers
      getAllProducts: '=?', // Bi-directional boolean for determining whether or not to load product data for to support product_code question types
      isInvalid: '=?', // Bi-directional boolean for determining whether the quiz is invalid or not, useful for disabling buttons outside of this directive
      onSaveRecommendations: '&', // Function to be performed when the recommendations get saved
      onComplete: '&', // Function to be perfomed when the finish button is clicked and the quiz is completed
      onIncomplete: '&', // Function to be perfomed when the finish button is clicked and the quiz is incompleted
      answers: '=?', // Bi-directional object of all the answers for the quiz, useful for when you need to look up specific answers outside of the directive
      info: '=?', // Bi-direction object for storing miscellaneous info about the quiz, useful when you need this info outside of the directive
      questionNumberFormat: '@', // The format the question number should take, replacing # with the actual question number, defaults to "#."
      displayMode: '@', // The mode to display the questions as. Either answered, all, or single
      setAnswerDelay: '@' // Adds a delay from when an answer is click to when the answer gets set, useful for animations
    },
    link: function(scope, element, attrs, ctrl, $transclude) {
      /**
       * NOT THIS AGAIN
       *
       */
function noOp() {}

      var flags = [
        'noQuestionNumber', // Flag to turn off the display of question numbers
        'noTracking', // Flag to stop tracking events from firing
        'noScrolling', // Flag to stop auto-scrolling
        'noAnimate', // Flag to stop animating question expansion
        'noRedirect', // Flag to stop redirecting
        'noQuestionText', // Flag to turn off the display of question text
        'noButtons', // Flag to hide all buttons
        'noContinueButtons', // Flag to hide continue buttons on multiple-choice questions
        'noHistory', // Flag to turn off pre-population of past customer answers
        'noSurveyHistory', // Flag to turn off pre-population of past customer survey answers
        'noHintText', // Flag to turn off the display of question hint text
        'noCheckAllText', // Flag to turn off the display of "check all that apply" text for multi-select
        'noBorder', // Flag to turn off the border between questions
        'noAutoSave', // Flag to stop persisting questions after they've been answered
        'noNullifyAnswers' // Flag to prevent hidden answers from being set to null
      ];

      var DISPLAY_MODES = {
        ANSWERED: 'answered',
        ALL: 'all',
        SINGLE: 'single'
      };

      var displayTypes = {
        RADIO_LIST: 'radio-list',
        RADIO_BLOCKS: 'radio-blocks',
        SWATCHES: 'swatches',
        CIRCLE_OPTION: 'circle-options',
        MULTI_SELECT: 'multi-select',
        DROPDOWN: 'dropdown'
      };

      var validDisplayModes = Object.keys(DISPLAY_MODES).map(function(key) {
        return DISPLAY_MODES[key];
      });

      if (validDisplayModes.indexOf(scope.displayMode) == -1) {
        scope.displayMode = validDisplayModes[0];
      }

      /**
       * I'm not even sure but it's probably useful
       *
       */
function isSingleMode() {
        return scope.displayMode === DISPLAY_MODES.SINGLE;
      }

      flags.forEach(function(flag) {
        scope[flag] = Object.hasOwnProperty.call(attrs, flag);
      });

      if (scope.quickEdit !== undefined) {
        scope.displayMode = DISPLAY_MODES.ALL;
        scope.noHintText = true;
        scope.noQuestionNumber = true;
        scope.noAnimate = true;
        scope.noCheckAllText = true;
        scope.noButtons = true;
        scope.noScrolling = true;
        scope.noRedirect = true;
      }

      if (scope.getAllProducts) {
        sharedProductSvc.getAllWithExtraData(function(products) {
          // filter to just active color kits
          scope.products = [];
          products.forEach(function(product) {
            if (product.productType.code == 'color_kit' && product.status && product.visible) {
              scope.products.push(product);
            }
          });
        });
      }

      $transclude(scope, function(clone) {
        if (!clone.length) {
          return;
        }

        angular.element(element[0]).find('quiz-transclude').html(clone);
      });

      scope.questionNumberFormat = scope.questionNumberFormat || '#';
      scope.queryString = scope.queryString || {};
      scope.prefillData = scope.prefillData || {};
      scope.info = scope.info || {};
      scope.info.loaded = false;

      if (scope.queryString.noScrolling === 'true') {
        scope.noScrolling = true;
      }

      var initialLoad = false;

      var continueTypes = ['checkbox', 'short-text'];

      /**
       * Checks if question is continuable lol
       *
       * @param {object} questionDef
       */
function isQuestionContinuable(questionDef) {
        return continueTypes.indexOf(questionDef.type) > -1 || questionDef.requireContinue;
      }

      scope.textInput = {};
      scope.answers = {};
      scope.surveys = {};

      var customerDataLoaded = false;
      var historyId = -1;

      scope.experiments = {};
      scope.loadCustomerData = function() {
        var answersLoaded = false;
        var experimentsLoaded = false;
        quizSvc.getCustomerAnswers({ customerId: scope.customerId }, function(response) {
          scope.answers = response.answers || {};
          scope.surveys = response.surveys || {};
          answersLoaded = true;
          customerDataLoaded = answersLoaded && experimentsLoaded;
          scope.initializeQuiz();
        });

        quizSvc.getAllExperimentsForQuiz({}, function(experiments) {
          experimentsLoaded = true;
          customerDataLoaded = answersLoaded && experimentsLoaded;
          scope.experiments = experiments;
          scope.initializeQuiz();
        });
      };

      scope.quiz = {};
      var previewing = false;
      scope.loadQuizFlow = function(previewFlow) {
        scope.info.loaded = false;
        initialLoad = false;

        if (previewFlow) {
          scope.answers = {};
          scope.surveys = {};
          previewing = true;
          customerDataLoaded = true;
          scope.quiz.$resolved = false;
          scope.quiz = quizSvc.enrichQuizWithQuestions({ quiz: previewFlow }, function() {
            scope.initializeQuiz();
          });
          return;
        }

        if (!scope.quizName) {
          return;
        }

        scope.quiz = quizSvc.getQuizFlow({ name: scope.quizName }, function() {
          scope.initializeQuiz();
        });
      };

      scope.loadCustomerData();
      scope.loadQuizFlow();
      scope.currentQuestion = null;
      scope.currentQuestionIndex = 0;

      scope.$watch('customerId', function(val) {
        if (val) {
          scope.loadCustomerData();
        }
      });

      scope.$watch('quizName', function(val) {
        if (val) {
          scope.loadQuizFlow();
        }
      });

      scope.$on('previewQuiz', function(event, previewFlow) {
        scope.loadQuizFlow(previewFlow);
      });

      var previousHairToneRequest;
      scope.updateHairToneOptions = function(callback) {
        callback = callback || angular.noop;
        if (!scope.answers) {
          return callback();
        }
        var index = getQuestionIndex('hair_tone');

        if (index < 0) {
          return callback();
        }

        var checks = [
          'hair_color',
          'hair_shade',
          'natural_hair_color',
          'natural_hair_shade',
          'want_level',
          'gray_quantity',
          'color_resistant_grays',
        ];

        if (getQuestionIndex('demi_or_perm') >= 0) {
          checks.push('demi_or_perm');
        }

        var requestKey = checks.map(function(key) {
          return scope.answers[key];
        }).join(',');

        var initialRequest = false;
        if (!previousHairToneRequest) {
          initialRequest = true;
        }

        if (previousHairToneRequest == requestKey) {
          return callback();
        }
        previousHairToneRequest = requestKey;

        var payload = {
          answers: scope.answers || {},
          quizKey: scope.quiz.key
        };
        var questionDef = scope.quiz.questions[index];
        quizSvc.getHairToneOptions(payload, function(options) {
          var answerOverrides = [];
          var hide = [];
          questionDef._defaults.answers.forEach(function(answer) {
            if (options[answer.value]) {
              answerOverrides.push({
                value: answer.value,
                image: {
                  url: options[answer.value],
                  alt_text: answer.text
                },
                infoText: answer.infoText
              });
            } else {
              hide.push(answer.value);
            }
          });
          questionDef.presentationConditions = [{
            hide: hide,
            answerOverrides: answerOverrides
          }];

          if (!initialRequest) {
            scope.clearAnswer({ keys: ['hair_tone'] });
          }

          var isRequired = Object.keys(answerOverrides).length >= 2;
          if (questionDef.required == -1 && isRequired) {
            isRequired = scope.checkAnyConditions(questionDef.requireConditions);
          }

          questionDef.hidden = !isRequired;
          questionDef.required = isRequired;

          scope.handlePresentationConditions();

          if (questionDef._visible) {
            scope.scrollToFirstMissing(null, questionDef);
          }
          callback();
        }, function() {
          callback();
        });
      };

      // Actions

      scope.url = function(params) {
        if (scope.noRedirect) {
          return;
        }

        var url;
        if (params.query && scope.queryString[params.query]) {
          url = decodeURIComponent(scope.queryString[params.query]);
        } else if (params.url) {
          url = params.url;
        }

        if (url) {
          url = scope.parseTemplateString(url).replace(/[:()<>]/g, '');

          if (!previewing) {
            setTimeout(function() {
              document.location.href = url;
            }, 500);
          } else {
            window.alert('Redirecting to ' + url);
          }
        }
      };
      scope.url.allowInitialLoad = true;

      scope.track = function(params, questionDef) {
        if (scope.noTracking) {
          return;
        }

        var payload = {
          eventName: scope.parseTemplateString(params.eventName)
        };

        if (questionDef && questionDef.key) {
          payload.questionKey = questionDef.key;
        }

        if (questionDef && typeof questionDef.visible == 'boolean') {
          payload.questionVisible = scope.isQuestionVisible(questionDef);
        }

        if (questionDef && typeof questionDef.hidden == 'boolean') {
          payload.questionHidden = questionDef.hidden;
        }

        if (params.includeIndex) {
          payload.questionIndex = scope.getQuestionNumber(questionDef);
        }

        if (params.includeAnswers) {
          payload.answers = scope.answers;
        }

        if (params.includeQuizType) {
          payload.quizType = scope.quizName;
        }

        if (typeof dataLayer != 'undefined' && scope.quizName == 'advisor') {
          if (payload.eventName == 'Start Color Advisor') {
            dataLayer.push({
              'event': 'StartColorAdvisor',
              'quizName': scope.quizName
            });
          }

          if (payload.eventName == 'Advisor Completed') {
            dataLayer.push({
              'event': 'AdvisorCompleted',
              'quizName': scope.quizName
            });
          }
        }

        if (payload.eventName) {
          return new window.Promise(function(resolve) { quizSvc.trackQuizEvent(payload, resolve);});
        }
      };
      scope.track.allowInitialLoad = true;

      scope.saveRecommendations = function() {
        var payload = {
          customerId: scope.customerId,
          answers: scope.answers,
          quizKey: scope.quizName,
          customerAnswersHistoryId: historyId,
        };
        return new window.Promise(function(resolve) {
          quizSvc.saveRecommendations(payload, function() {
            if (scope.onSaveRecommendations) {
              scope.onSaveRecommendations();
            }
            resolve();
          });
        });
      };
      scope.saveRecommendations.allowInitialLoad = true;

      var scrollingInProgress = false;

      scope.scrollTo = function(question) {
        // Don't scroll for initial loads on single display modes
        if (initialLoad && scope.displayMode == DISPLAY_MODES.SINGLE) {
          return;
        }
        scope.setCurrentQuestion(question);
        if (scope.noScrolling || scrollingInProgress) {
          return;
        }

        scrollToElement('#' + question._key);
      };

      scope.parseTemplateString = function(str) {
        if (typeof str != 'string') {
          return str;
        }

        return str.replace(/\{\{(.*?)\}\}/g, function(match, p1) {
          var parsed = safeGetProperty.call(scope, p1);
          if (parsed === undefined) {
            return match;
          }

          return '' + parsed;
        });
      };

      /**
       * Scrolls to an element and apparently uses jQuery to do so
       *
       * @param {string} selector
       * @param {number} extraOffset
       */
function scrollToElement(selector, extraOffset) {
        extraOffset = extraOffset || 0;

        var elem = $(selector);
        if (!elem || !elem.length) {
          return;
        }

        scrollingInProgress = true;

        var offset = elem.offset().top + extraOffset;
        var opts = {
          duration: 900,
          step: function(now, fx) {
            var curOffset = elem.offset().top + extraOffset;
            if (fx.end != curOffset) {
              fx.end = curOffset;
            }
          },
          complete: function() {
            scrollingInProgress = false;
          }
        };

        $("body, html").animate({ scrollTop: offset }, opts);
      }

      scope.scrollToNext = function(params, questionDef) {
        // Don't scroll if you're a hidden question or multi-select question unless your continuing or have max allowed
        if (questionDef.hidden || (questionDef.displayType == displayTypes.MULTI_SELECT && !questionDef.continuing && scope.answers[questionDef.key] && scope.answers[questionDef.key].length < questionDef.maxAllowed) || scope.noScrolling || initialLoad) {
          return;
        }
        if (questionDef.continuing) {
          questionDef.continuing = false;
        }

        var next = scope.getNextQuestion(questionDef);
        if (next) {
          if (scope.displayMode == DISPLAY_MODES.SINGLE) {
            scope.goInDirection('+');
          } else {
            scope.scrollTo(next);
          }
        } else if (scope.quiz.completionButton && !scope.noButtons && scope.isQuizComplete()) {
          //- scroll to finish button with some offset.
          var wHeight = $(window).height();
          var wTop = $(window).scrollTop();
          var fHeight = $('#finish-quiz').outerHeight();
          var fTop = $('#finish-quiz').offset().top;

          if (wHeight && wTop && fHeight && fTop) {
            if ((wHeight + wTop) < (fHeight + fTop)) {
              //- set offset as percentage of the screen
              var finishOffset = wHeight - wHeight / 100 * 50;
              scrollToElement('#finish-quiz', -finishOffset);
            }
          }
        }
      };
      scope.scrollToNext.allowInitialLoad = true;

      scope.scrollToFirstMissing = function(params, questionDef) {
        if (!questionDef) {
          return;
        }
        // dont scroll multi-select question unless your continuing or have max allowed
        if (questionDef.displayType == displayTypes.MULTI_SELECT && !questionDef.continuing && scope.answers[questionDef.key] && scope.answers[questionDef.key].length < questionDef.maxAllowed) {
          return;
        }
        if (questionDef.continuing) {
          questionDef.continuing = false;
        }
        var firstMissing = scope.getFirstMissingQuestion();
        if (firstMissing && scope.displayMode != DISPLAY_MODES.SINGLE) {
          scope.scrollTo(firstMissing);
        } else {
          scope.scrollToNext(null, questionDef);
        }
      };
      scope.scrollToFirstMissing.allowInitialLoad = true;

      scope.highlightAllMissing = function() {
        scope.quiz.questions.forEach(function(question) {
          question._missing = scope.isQuestionRequired(question) && !scope.isQuestionAnswered(question);
        });
      };

      scope.saveQuiz = function() {
        return new window.Promise(function(resolve) {
          scope.persistQuizAnswers(true, resolve);
        });
      };
      scope.saveQuiz.allowInitialLoad = true;

      scope.createCustomerServiceTicket = function(params) {
        params.customerId = scope.customerId;
        params.quizName = scope.quizName;
        return new window.Promise(function(resolve) { quizSvc.createCustomerServiceTicket(params, resolve); });
      };

      scope.dequeueCustomerServiceTicket = function(params) {
        params.customerId = scope.customerId;
        params.quizName = scope.quizName;
        return new window.Promise(function(resolve) { quizSvc.dequeueCustomerServiceTicket(params, resolve); });
      };

      scope.setAnswerAction = function(params) {
        var questionDef = getQuestionDefByKey(params.key);
        if (!questionDef) {
          return;
        }
        scope.setAnswer(questionDef, params.value);
      };
      scope.setAnswerAction.allowInitialLoad = true;

      scope.setAnswerByFormula = function(params) {
        var questionDef = getQuestionDefByKey(params.key);
        if (!questionDef) {
          return;
        }
        var formula = params.formula;
        var value;

        if (formula && formula.length) {
          value = scope.getValueForFormulaPart(formula[0]);
        }

        for (var x = 1; x < formula.length; x++) {
          var part = formula[x];
          var partValue = scope.getValueForFormulaPart(part);

          if (part.op == '+') {
            value = value + partValue;
          } else if (part.op == '-') {
            value = value - partValue;
          } else if (part.op == '*') {
            value = value * partValue;
          } else if (part.op == '/') {
            value = value / partValue;
          }
        }

        if (!isNonValue(value) && scope.isValidValueForQuestion(value, questionDef)) {
          value = castToAnswerType(value, questionDef);
          scope.setAnswer(questionDef, value);
        }
      };
      scope.setAnswerByFormula.allowInitialLoad = true;

      scope.getValueForFormulaPart = function(part) {
        var value = scope.answers[part.key];

        if (part.split && !isNonValue(part.splitIndex)) {
          value = ('' + value).split(':')[part.splitIndex];
        }

        if (part.regEx && !isNonValue(part.regExIndex)) {
          var exp = new RegExp(part.regEx, 'g');
          value = ('' + value).match(exp);
        }

        if (!isNaN(Number(value))) {
          return Number(value);
        } else {
          return value;
        }
      };

      scope.isValidValueForQuestion = function(value, questionDef) {
        if (questionDef.type == 'short-text') {
          return true;
        }
        var isValid = false;

        for (var x = 0; x < questionDef.answers.length; x++) {
          if (value == questionDef.answers[x].value) {
            isValid = true;
            break;
          }
        }

        return isValid;
      };

      scope.setAnswerFromSource = function(params) {
        var value;
        switch (params.dataSource) {
          case 'cookie':
            value = $cookies[params.sourceKey];
            break;

          case 'query':
            value = scope.queryString[params.sourceKey];
            break;

          case 'prefillData':
            value = scope.prefillData[params.sourceKey];
            break;
        }

        if (value === undefined) {
          return;
        }

        var questionDef = getQuestionDefByKey(params.key);
        if (!questionDef) {
          return;
        }

        value = castToAnswerType(value, questionDef);
        scope.setAnswer(questionDef, value);
      };
      scope.setAnswerFromSource.allowInitialLoad = true;

      scope.notify = function(params) {
        notifySvc.notify(params.type, scope.parseTemplateString(params.message), params.duration);
      };
      scope.notify.allowInitialLoad = true;

      scope.setCookie = function(params) {
        if (params.deleteCookie) {
          $cookieStore.remove(params.key);
        } else {
          $cookieStore.put(params.key, scope.parseTemplateString(params.value));
        }
      };
      scope.setCookie.allowInitialLoad = true;

      scope.clearAnswer = function(params) {
        params.keys.forEach(function(key) {
          scope.answers[key] = null;
          var index = getQuestionIndex(key);
          if (index < 0) {
            return;
          }

          var questionDef = scope.quiz.questions[index];
          if (scope.noButtons || scope.noContinueButtons || !isQuestionContinuable(questionDef)) {
            return;
          }

          questionDef._continueButton = !scope.isQuestionAnswered(questionDef) || questionDef.requireContinue;
          questionDef._skipped = false;

          // Special logic for initially visible continue buttons
          if (questionDef.visible) {
            var next = scope.getNextQuestion(questionDef);
            if (questionDef._continueButton && next) {
              questionDef._continueButton = !scope.isQuestionVisible(next);
            }
          }
        });
        scope.updateHairToneOptions();
      };
      scope.clearAnswer.allowInitialLoad = true;

      scope.checkValidity = function(question, val) {
        if (val && val.length > 2) {
          question.incompleteAnswer = false;
        } else {
          question.incompleteAnswer = true;
        }
      };

      scope.finishQuiz = function() {
        if (scope.finishingQuiz) {
          return;
        }
        scope.finishingQuiz = true;
        setTimeout(function() {
          scope.finishingQuiz = false;
        }, 600);
        scope.quiz.questions.forEach(function(questionDef) {
          if (questionDef.type == 'checkbox' && !Array.isArray(scope.answers[questionDef.key])) {
            scope.answers[questionDef.key] = [];
          }
        });

        var actions = filterConditionalActions(scope.quiz.complete);
        const performedActions = scope.performActions(actions);
        window.Promise.all(performedActions)
          .then(function() {
            if (scope.isQuizComplete()) {
              // special event for facebook tracking
              if (typeof window.fbq != 'undefined' && window.fbq) {
                var fbqAnswers = {};
                Object.keys(scope.answers).forEach(function(key) {
                  if (scope.answers[key]) {
                    fbqAnswers[key] = scope.answers[key];
                  }
                });
                window.fbq('trackCustom', scope.quiz.key + 'Complete', fbqAnswers);
              }

              if (scope.onComplete) {
                scope.onComplete();
              }
            }

            if (!scope.isQuizComplete() && scope.onIncomplete) {
              scope.quiz.questions.forEach(function(question) {
                var answered = scope.isQuestionAnswered(question);

                if (!answered) {
                  question.incompleteAnswer = true;
                }
              });

              scope.onIncomplete();
            }
          });

      };
      scope.info.finishQuiz = scope.finishQuiz;
      scope.finishQuiz.allowInitialLoad = true;

      scope.updateSubscriptionFrequency = function(params) {
        var frequency;
        if (params.value) {
          frequency = params.value;
        } else if (params.key) {
          frequency = scope.answers[params.key];
        }
        var payload = {
          subscriptionId: scope.answers.subscription_id,
          frequency: frequency
        };

        if (!payload.subscriptionId || !payload.frequency) {
          return;
        }
        return new window.Promise(function(resolve) { quizSvc.updateSubscriptionFrequency(payload, resolve); });
      };

      scope.saveNPS = function(params) {
        var payload = {
          score: scope.answers[params.scoreKey],
          invoiceId: (scope.answers.additionalText ? scope.answers.additionalText[params.invoiceKey] : null) || scope.answers[params.invoiceKey],
        };

        if (params.commentKey) {
          payload.comment = (scope.answers.additionalText ? scope.answers.additionalText[params.commentKey] : null) || scope.answers[params.commentKey];
        }

        if (!payload.invoiceId) {
          return;
        }
        return new window.Promise(function(resolve) { quizSvc.saveNPS(payload, resolve); });
      };

      /**
       * assignCustomerPromo
       * @param {object} params
       * @param {number} params.promoId
       * @param {boolean} params.applyOnce
       */
      scope.assignCustomerPromo = function(params) {
        params.customerId = scope.customerId;
        return new window.Promise(function (resolve) { quizSvc.assignCustomerPromo(params, resolve); });
      };

      scope.actions = {
        url: scope.url,
        track: scope.track,
        saveRecommendations: scope.saveRecommendations,
        scrollToNext: scope.scrollToNext,
        scrollToFirstMissing: scope.scrollToFirstMissing,
        saveQuiz: scope.saveQuiz,
        highlightAllMissing: scope.highlightAllMissing,
        createCustomerServiceTicket: scope.createCustomerServiceTicket,
        dequeueCustomerServiceTicket: scope.dequeueCustomerServiceTicket,
        setAnswer: scope.setAnswerAction,
        setAnswerByFormula: scope.setAnswerByFormula,
        setAnswerFromSource: scope.setAnswerFromSource,
        notify: scope.notify,
        setCookie: scope.setCookie,
        clearAnswer: scope.clearAnswer,
        finishQuiz: scope.finishQuiz,
        updateSubscriptionFrequency: scope.updateSubscriptionFrequency,
        saveNPS: scope.saveNPS,
        assignCustomerPromo: scope.assignCustomerPromo
      };

      // Conditions

      scope.answer = function(params) {
        return testObject(scope.answers, params.op, params.key, scope.parseTemplateString(params.value));
      };

      scope.experiment = function(params) {
        var experimentVariant = scope.experiments[params.experiment] || 'A';
        return experimentVariant == params.variant;
      };

      scope.quizComplete = function(params) {
        return scope.isQuizComplete() == params.value;
      };

      scope.queryParam = function(params) {
        return testObject(scope.queryString, params.op, params.key, scope.parseTemplateString(params.value));
      };

      scope.whenVisible = function(params) {
        var visible = scope.quiz.questions.some(function(question) {
          if (question.key == params.key) {
            return question._visible;
          }
        });

        return visible;
      };

      scope.allRequiredQuestionsVisible = function(params) {
        if (!scope.quiz.$resolved) {
          return;
        }

        var incomplete = scope.quiz.questions.some(function(question) {
          return scope.isQuestionRequired(question) && !scope.isQuestionVisible(question);
        });
        return incomplete != params.value;
      };

      scope.andGroup = function(params) {
        return scope.checkAllConditions(params.conditions);
      };

      scope.orGroup = function(params) {
        return scope.checkAnyConditions(params.conditions);
      };

      scope.cookie = function(params) {
        return testObject($cookies, params.op, params.key, scope.parseTemplateString(params.value));
      };

      scope.quizHasAnyAnswer = function(params) {
        var hasAnAnswer = scope.quiz.questions.some(function(questionDef) {
          // Ignore hidden questions
          if (questionDef.hidden) {
            return false;
          }

          return !isNonValue(scope.answers[questionDef.key]);
        });
        return hasAnAnswer == params.value;
      };

      scope.conditions = {
        answer: scope.answer,
        experiment: scope.experiment,
        quizComplete: scope.quizComplete,
        queryParam: scope.queryParam,
        cookie: scope.cookie,
        whenVisible: scope.whenVisible,
        allRequiredQuestionsVisible: scope.allRequiredQuestionsVisible,
        andGroup: scope.andGroup,
        orGroup: scope.orGroup,
        quizHasAnyAnswer: scope.quizHasAnyAnswer,
      };

      // Read From

      /**
       * Casts a value to the expected type
       *
       * @param {any} value
       * @param {object} questionDef
       */
function castToAnswerType(value, questionDef) {
        switch (questionDef.dataType) {
          case 'boolean':
            value = Boolean(+value);
            break;
          case 'number':
            value = Number(value);
            break;
          default:
            value = '' + value;
        }

        if (questionDef.answers && questionDef.answers.length) {
          questionDef.answers.some(function(answer) {
            if (answer.value == value) {
              value = answer.value;
              return true;
            }
          });
        }

        return value;
      }

      // Other functions

      scope.initializeQuiz = function() {
        if (!scope.quiz.$resolved || !customerDataLoaded || !scope.quiz.questions) {
          return;
        }
        initialLoad = true;

        if (!scope.noSurveyHistory && scope.quiz.saveAsSurvey && scope.surveys[scope.quiz.surveyKey]) {
          var surveyAnswers = scope.surveys[scope.quiz.surveyKey] || {};
          Object.keys(surveyAnswers).forEach(function(key) {
            scope.answers[key] = surveyAnswers[key];
          });
        }

        if (scope.noHistory) {
          scope.answers = {};
        }

        // scope.answers.additionalText is an Object with all short-text question answers stored as key/value pairs
        //
        // textInput is the data model used to record short-text type inputs
        //  it becomes a sub-thing to scope.answers under scope.answers.additionalText
        if (scope.answers.additionalText) {
          scope.textInput = scope.answers.additionalText;
        }

        // First we set the default text and other properties on each question
        scope.quiz.questions.forEach(function(question, i) {
          question._visible = scope.shouldQuestionBeVisible(question);
          question._key = question.key + '-' + i;

          if (question.additionalText) {
            question._additionalText = question.additionalText;
          }

          if (question.openResponseModal) {
            question._openResponseModal = question.openResponseModal;
          }

          if (question.type == 'image-upload') {
            question._uploader = getNewUploader(question);
          }

          if (question.randomizeAnswers) {
            var addlTextAnswers = [];
            var answers = [];
            question.answers.forEach(function(answer) {
              if (answer.additionalText) {
                addlTextAnswers.push(answer);
              } else {
                answers.push(answer);
              }
            });

            question.answers = shuffle(answers);
            question.answers = question.answers.concat(addlTextAnswers);
          }

          if (!Object.hasOwnProperty.call(question, '_defaults')) {
            question._defaults = {
              text: question.text,
              hint: question.hint,
              answers: angular.copy(question.answers)
            };
          }
        });

        var lastVisible;
        scope.quiz.questions.forEach(function(question) {
          if (scope.displayMode == DISPLAY_MODES.ALL) {
            question.displayType = 'minimal';
          }
          scope.prepareAdditionalText(question);
          if (question._visible) {
            lastVisible = question;
          }

          question._continueButton = false;

          if (scope.noButtons || scope.noContinueButtons || !isQuestionContinuable(question)) {
            return;
          }

          question._continueButton = !scope.isQuestionAnswered(question);

          // Special logic for initially visible continue buttons
          if (question.visible) {
            var next = scope.getNextQuestion(question);
            if (question._continueButton) {
              if (next) {
                question._continueButton = !scope.isQuestionVisible(next);
              } else {
                // If there's no next, there's no continue
                question._continueButton = false;
              }
            }
          }
        });
        scope.handlePresentationConditions();

        scope.isQuizComplete();

        scope.updateHairToneOptions(function() {
          scope.quiz.initializeActions.forEach(function(action) {
            var filtered = filterConditionalActions([action]);
            scope.performActions(filtered);
          });

          var firstMissing = scope.getFirstMissingQuestion();
          if (firstMissing) {
            scope.setCurrentQuestion(firstMissing);
          } else if (lastVisible) {
            scope.setCurrentQuestion(lastVisible);
          }

          initialLoad = false;
          scope.info.surveys = scope.surveys;
          scope.info.quiz = scope.quiz;
          scope.info.loaded = true;
        });
      };

      scope.handlePresentationConditionsForQuestion = function(questionDef) {
        if (!questionDef.presentationConditions) {
          return;
        }

        var changes = {};
        // Check each condition for changes and populate the changes object with it
        questionDef.presentationConditions.forEach(function(pc) {
          if (!scope.checkAnyConditions(pc.conditions)) {
            return;
          }

          if (!isNonValue(pc.textOverride)) {
            changes.text = pc.textOverride;
          }

          if (!isNonValue(pc.hintOverride)) {
            changes.hint = pc.hintOverride;
          }

          if (pc.answerOverrides && pc.answerOverrides.length) {
            if (!changes.answerOverrides) {
              changes.answerOverrides = [];
            }
            changes.answerOverrides = changes.answerOverrides.concat(pc.answerOverrides);
          }

          if (pc.hide && pc.hide.length) {
            if (!changes.hide) {
              changes.hide = [];
            }
            changes.hide = changes.hide.concat(pc.hide);
          }
        });

        // After checking each condition, reset the values to their defaults
        Object.keys(questionDef._defaults).forEach(function(key) {
          questionDef[key] = angular.copy(questionDef._defaults[key]);
        });

        // Now apply the changes
        if (changes.text) {
          questionDef.text = changes.text;
        }

        if (changes.hint) {
          questionDef.hint = changes.hint;
        }

        if (changes.answerOverrides) {
          var overrides = {};
          changes.answerOverrides.forEach(function(override) {
            overrides[override.value] = override;
          });
          questionDef.answers.forEach(function(answer) {
            var override = overrides[answer.value];
            if (!override) {
              return;
            }

            answer.text = override.text || answer.text;
            answer.infoText = override.infoText || answer.infoText;
            answer.image = override.image || answer.image;
          });
        }

        if (changes.hide) {
          questionDef.answers = questionDef.answers.filter(function(answer) {
            return changes.hide.indexOf(answer.value) == -1;
          });

          var hasValidAnswer = questionDef.answers.some(function(answer) {
            return testObject(scope.answers, '=', questionDef.key, answer.value);
          });

          if (!hasValidAnswer && testObject(scope.answers, 'exists', questionDef.key) && !scope.noNullifyAnswers) {
            scope.clearAnswer({ keys: [questionDef.key] });
            scope.handlePresentationConditionsForQuestion(questionDef);
          }
        }

        if (questionDef.type == 'checkbox' && scope.displayMode == DISPLAY_MODES.ALL && !Array.isArray(scope.answers[questionDef.key])) {
          scope.answers[questionDef.key] = [];
        }
      };

      scope.handlePresentationConditions = function() {
        var num = 0;
        scope.quiz.questions.forEach(function(question) {
          var previousVisibility = question._visible;
          question._visible = scope.shouldQuestionBeVisible(question);

          if (question._visible) {
            scope.handlePresentationConditionsForQuestion(question);
            num++;
            question._number = num;
          }

          var isAnyVisible = getQuestionsByKey(question.key).some(function(questionDef) {
            return questionDef._visible;
          });

          if (previousVisibility != question._visible && !isAnyVisible && !question._skipped) {
            scope.clearAnswer({ keys: [question.key] });
          }
        });
      };

      scope.shouldQuestionBeVisible = function(questionDef) {
        if (questionDef.hidden) {
          return false;
        }

        if (questionDef._skipped) {
          return false;
        }

        var isRequired = Boolean(questionDef.required);

        if (questionDef.required == -1) {
          isRequired = scope.checkAnyConditions(questionDef.requireConditions);
        }

        switch (scope.displayMode) {
          case DISPLAY_MODES.ALL:
            if (questionDef.visible) {
              return questionDef.visible;
            }

            return isRequired;

          default:
          case DISPLAY_MODES.ANSWERED:
            if (questionDef.visible) {
              if (initialLoad) {
                return true;
              } else {
                return isRequired;
              }
            }

            if (scope.isQuestionAnswered(questionDef) && isRequired) {
              return true;
            }

            var firstMissing = scope.getFirstMissingQuestion();
            return Boolean(isRequired && firstMissing && firstMissing.key == questionDef.key && firstMissing._number == questionDef._number);
        }
      };

      scope.isQuestionSkipped = function(questionDef) {
        return Boolean(questionDef._skipped);
      };

      scope.isQuestionVisible = function(questionDef) {
        if (questionDef._skipped) {
          return false;
        }
        return questionDef._visible;
      };

      scope.isQuestionRequired = function(questionDef) {
        if (questionDef.required == -1) {
          return scope.checkAnyConditions(questionDef.requireConditions);
        }

        return Boolean(questionDef.required);
      };

      scope.getCheckAllText = function(questionDef) {
        var any = '';
        if (questionDef.minRequired || questionDef.maxAllowed) {
          any = questionDef.minRequired ? ' at least ' + questionDef.minRequired : '';
          any += questionDef.maxAllowed ? ' at most ' + questionDef.maxAllowed : '';
        } else {
          any = ' any that apply';
        }
        return '(Check' + any + ')';
      };

      scope.getContinueButtonText = function(questionDef) {
        var text = 'Continue...';
        var answers = scope.answers[questionDef.key] || [];
        if (questionDef.buttonText && ((!questionDef.minRequired && !answers.length) || questionDef.requireContinue)) {
          text = scope.parseTemplateString(questionDef.buttonText);
        }
        return text;
      };

      scope.getSkipText = function(questionDef) {
        var text = 'Skip...';
        if (questionDef.skipText && questionDef.skippable) {
          text = scope.parseTemplateString(questionDef.skipText);
        }
        return text;
      };

      scope.getNextQuestion = function(questionDef) {
        var next;
        for (var i = getQuestionIndexByUniqueKey(questionDef._key) + 1; i < scope.quiz.questions.length; i++) {
          var potentialNext = scope.quiz.questions[i];
          if (potentialNext && scope.isQuestionRequired(potentialNext)) {
            next = potentialNext;
            break;
          }
        }
        return next;
      };

      scope.getPreviousQuestion = function(questionDef) {
        var prev;
        for (var i = getQuestionIndexByUniqueKey(questionDef._key) - 1; i >= 0; i--) {
          var potentialPrev = scope.quiz.questions[i];
          if (potentialPrev && scope.isQuestionRequired(potentialPrev)) {
            prev = potentialPrev;
            break;
          }
        }
        return prev;
      };

      /**
       * Checks whether a question has satisfied its answer requirements
       *  requirements are enformed based on the question's question type
       * @param {object} questionDef
       * @returns {boolean}
       */
      scope.isQuestionAnswered = function(questionDef) {
        var answered = !isNonValue(scope.answers[questionDef.key]);
        var minRequired = questionDef.minRequired || 0;
        if (questionDef.type == 'checkbox') {
          if (!scope.answers[questionDef.key]) {
            answered = false;
          } else {
            var numAnswered = (scope.answers[questionDef.key] || []).length;
            answered = numAnswered >= minRequired;
          }
        }

        if (questionDef.type == 'short-text') {
          // answers that are set through initialization setAnswerFromSource are found under scope.answers
          var sizeOfAnswer = (scope.answers[questionDef.key] || scope.textInput[questionDef.key] || '').toString().length;
          answered = sizeOfAnswer >= minRequired;
        }

        // image-upload is always optional,
        // so we always return answered as true
        if (questionDef.type == 'image-upload') {
          answered = true;
        }

        if (answered && questionDef._additionalText && questionDef.type != 'short-text' && questionDef._additionalText.required && isNonValue(scope.textInput[questionDef.key])) {
          answered = false;
        }

        if (questionDef._skipped) {
          answered = true;
        }

        return answered;
      };

      scope.shouldShowContinueButton = function(questionDef) {
        return questionDef._continueButton;
      };

      scope.isInitialLoadAllowed = function(action) {
        if (!initialLoad) {
          return true;
        }

        return Object.hasOwnProperty.call(scope.actions, action) && scope.actions[action].allowInitialLoad;
      };

      scope.getValidQuestionActions = function(questionDef) {
        var actions = [].concat(filterConditionalActions(questionDef.completionActions), filterConditionalActions(scope.quiz.forEach));

        actions = actions.filter(function(action) {
          return scope.isInitialLoadAllowed(action.action);
        });

        return actions;
      };

      scope.continueQuestion = function(questionDef) {
        if (questionDef.type == 'checkbox' && !Array.isArray(scope.answers[questionDef.key])) {
          scope.answers[questionDef.key] = [];
        }

        questionDef._continueButton = false;
        questionDef.continuing = true;

        scope.persistQuizAnswers();
        scope.handlePresentationConditions();
        scope.checkQuestion(questionDef);
      };

      scope.skipQuestion = function(questionDef) {
        if (!questionDef.skippable) {
          return;
        }

        scope.clearAnswer({ keys: [questionDef.key] });

        questionDef._skipped = true;
        questionDef._continueButton = false;

        scope.handlePresentationConditions();
        scope.checkQuestion(questionDef);
      };

      scope.checkQuestion = function(questionDef) {
        var actions = scope.getValidQuestionActions(questionDef);

        scope.updateHairToneOptions(function() {
          scope.performActions(actions, questionDef);
          scope.handlePresentationConditions();
        });
      };

      scope.removeImage = function(questionDef, index) {
        var url = scope.answers[questionDef.key][index];
        questionDef._uploader.removeFromQueue(index);
        scope.setAnswer(questionDef, url);
      };

      scope.performActions = function(actions, questionDef) {
        const performed = [];
        if (actions) {
          actions.forEach(function(action) {
            if (!Object.hasOwnProperty.call(scope.actions, action.action)) {
              return;
            }
            performed.push(scope.actions[action.action](action.params, questionDef));
          });
        }
        return performed;
      };

      scope.getPersistPayload = function() {
        var textInput = {};
        Object.keys(scope.textInput).forEach(function(key) {
          var index = getQuestionIndex(key);
          if (index < 0) {
            return;
          }

          var questionDef = scope.quiz.questions[index];
          if (questionDef._additionalText) {
            textInput[key] = scope.textInput[key];
          }
        });

        var payload = {
          customerId: scope.customerId,
          id: historyId,
          quizName: scope.quizName,
          quizKey: scope.quizName,
          answers: scope.answers
        };
        if (Object.keys(textInput).length) {
          payload.answers.additionalText = textInput;
        }

        scope.persistPayload = payload;
        return payload;
      };

      scope.persistQuizAnswers = function(forcePersist, callback) {
        callback = callback || noOp;
        scope.getPersistPayload(); // This populates the exposed payload variable for anyone that's listening

        if (!forcePersist) {
          // Don't persist during the initial load or if the noAutoSave flag is set
          if (initialLoad || scope.noAutoSave) {
            return callback();
          }
        }

        quizSvc.persistCustomerAnswers(scope.persistPayload, function(response) {
          historyId = response.historyId;
          callback();
        }, callback);
      };

      /**
       * Updates AnswersData with a new response value for the question given by questionDef
       *  and makes request to persist the current state of AnswersData to the backend
       * @param {object} questionDef
       * @param {any} value
       */
      scope.setAnswer = function(questionDef, value) {
        if (questionDef.type == 'checkbox' || questionDef.type == 'image-upload') {
          if (!Array.isArray(scope.answers[questionDef.key])) {
            scope.answers[questionDef.key] = [];
          }

          var idx = scope.answers[questionDef.key].indexOf(value);

          if (idx < 0) {
            scope.answers[questionDef.key].push(value);
          } else {
            scope.answers[questionDef.key].splice(idx, 1);
          }
        } else {
          scope.answers[questionDef.key] = value;
        }

        scope.prepareAdditionalText(questionDef);
        scope.isQuizComplete();

        if (questionDef._missing) {
          questionDef._missing = !scope.isQuestionAnswered(questionDef);
        }

        scope.persistQuizAnswers(false, function() {
          if (questionDef.type == 'image-upload') {
            return;
          }

          if (questionDef.type == 'checkbox' && questionDef._continueButton) {
            if (questionDef.displayType == displayTypes.MULTI_SELECT) {
              if (scope.answers[questionDef.key] && scope.answers[questionDef.key].length < questionDef.maxAllowed) {
                return;
              } else {
                questionDef._continueButton = false;
              }
            } else {
              return;
            }
          }

          if (questionDef.requireContinue && questionDef._continueButton) {
            return;
          }

          if (!isNonValue(value)) {
            scope.checkQuestion(questionDef);
          }
        });
      };

      /**
       * Updates AnswersData with a new response value for the question given by questionDef
       *  and creates an ephemeral block on any further attempts at updating the same field.
       *  AT max multi-select type questions can be updated once every 10ms
       *  and other types once every 600ms
       * @param {object} questionDef
       * @param {any} value
       */
      scope.setAnswerWithTimeout = function(questionDef, value) {
        if (scope.setAnswerTimeout) {
          return;
        }
        var delay = scope.setAnswerDelay || 0;
        $timeout(function() {
          scope.setAnswerTimeout = true;
          scope.setAnswer(questionDef, value);
          var setDelay = questionDef.displayType == displayTypes.MULTI_SELECT ? 10 : 600;
          $timeout(function() {
            scope.setAnswerTimeout = false;
          }, setDelay);
        }, delay);
      };

      scope.checkAllConditions = function(tests) {
        if (!Array.isArray(tests)) {
          return false;
        }

        return !tests.some(function(test) {
          return !scope.checkCondition(test);
        });
      };

      scope.checkCondition = function(test) {
        if (!Object.hasOwnProperty.call(scope.conditions, test.condition)) {
          return;
        }
        return scope.conditions[test.condition](test.params);
      };

      scope.checkAnyConditions = function(tests, defaultResponse) {
        if (defaultResponse === undefined) {
          defaultResponse = true;
        }

        if (!Array.isArray(tests) || !tests.length) {
          return defaultResponse;
        }

        return tests.some(function(test) {
          return scope.checkCondition(test);
        });
      };

      scope.getQuestionNumber = function(questionDef) {
        return scope.questionNumberFormat.replace('#', questionDef._number);
      };

      scope.doesQuestionHaveAnswer = function(questionDef, value) {
        var key = questionDef.key;
        var compare = scope.answers[key];
        if (Array.isArray(compare)) {
          return compare.indexOf(value) >= 0;
        } else {
          return compare == value;
        }
      };

      scope.prepareAdditionalText = function(questionDef) {
        if (!scope.quiz.$resolved) {
          return;
        }

        if (questionDef.type == 'short-text') {
          questionDef._additionalText = {
            placeholder: questionDef.placeholder,
            required: scope.isQuestionRequired(questionDef)
          };
          return;
        }

        if (!questionDef._visible || !questionDef.answers.length) {
          return;
        }

        var additionalText;
        questionDef.answers.some(function(answer) {
          if (!answer.additionalText) {
            return;
          }

          if (scope.doesQuestionHaveAnswer(questionDef, answer.value)) {
            additionalText = answer.additionalText;
            return true;
          }
        });

        questionDef._additionalText = additionalText;
        return Boolean(additionalText);
      };

      scope.getFirstMissingQuestion = function() {
        var firstMissing;
        scope.quiz.questions.some(function(question) {
          var answered = scope.isQuestionAnswered(question);
          if (scope.isQuestionRequired(question) && !answered && !question.hidden) {
            firstMissing = question;
            return true;
          }
        });
        return firstMissing;
      };

      scope.getFirstQuestion = function() {
        if (!scope.quiz.$resolved) {
          return;
        }

        var first;
        scope.quiz.questions.some(function(question) {
          if (!first && scope.isQuestionVisible(question)) {
            first = question;
            return true;
          }
        });
        return first;
      };

      scope.getContinueButtonClass = function(questionDef) {
        var answered = scope.isQuestionAnswered(questionDef);
        if (questionDef.type == 'checkbox' && !answered) {
          var minRequired = questionDef.minRequired || 0;
          answered = (scope.answers[questionDef.key] || []).length >= minRequired;
        }

        if (!answered) {
          return 'disabled';
        }
      };

      /**
       * Provides the list of css classes that must be applied to the question for render
       * @param {object} questionDef
       * @param {number} index
       * @returns {string[]}
       */
      scope.getQuestionClass = function(questionDef, index) {
        var theClass = 'hidden';
        var classes = [];
        if (scope.isQuestionVisible(questionDef)) {
          theClass = 'visible';

          if (scope.displayMode == DISPLAY_MODES.SINGLE) {
            //- this is as insurance in case when currentQuestion has not been set
            if (!scope.currentQuestion) {
              scope.setCurrentQuestion(questionDef);
            }

            if (scope.currentQuestion._key == questionDef._key) {
              theClass = 'visible';
            } else {
              theClass = 'hidden';
            }
          }
        } else {
          classes.push('never-visible');
        }

        classes.unshift(theClass);

        if (scope.isBeforeCurrentQuestion(index)) {
          classes.push('is-before-current-question');
        } else if (scope.currentQuestionIndex != index) {
          classes.push('is-after-current-question');
        }

        classes.push('q-' + questionDef.key);

        if (!scope.noAnimate) {
          classes.push('animate');
        }

        classes.push(questionDef.displayType + '-question');
        if (questionDef._missing) {
          classes.push('missing');
        }
        if (scope.displayMode == DISPLAY_MODES.ALL) {
          classes.push('minimal');
        }

        var firstQuestion = scope.getFirstQuestion();

        if (!scope.noBorder && firstQuestion && firstQuestion._key != questionDef._key) {
          classes.push('top-border');
        }

        classes.push(questionDef.answers.length % 2 ? 'odd-answers' : 'even-answers');

        if (questionDef.key == 'highlights_type' || questionDef.key == 'hair_length') {
          classes.push('stay-vertical');
        }

        return classes;
      };

      scope.isAnswerSelected = function(questionDef, value) {
        var compare = scope.answers[questionDef.key];

        var selected = compare == value;
        if (Array.isArray(compare)) {
          selected = compare.indexOf(value) >= 0;
        }

        return selected;
      };

      scope.maxAllowedReached = function(questionDef) {
        if (questionDef.displayType != displayTypes.MULTI_SELECT || !questionDef.maxAllowed || !scope.answers[questionDef.key]) {
          return false;
        }
        return scope.answers[questionDef.key].length >= questionDef.maxAllowed;
      };

      scope.getMinimalIconClass = function(questionDef, answer) {
        var classes = ['fa'];
        var selected = scope.isAnswerSelected(questionDef, answer.value);
        if (questionDef.type == 'checkbox') {
          classes.push(selected ? 'fa-check-square' : 'fa-square-o');
        } else {
          classes.push(selected ? 'fa-check-circle' : 'fa-circle-o');
        }
        return classes;
      };

      scope.getAnswerClass = function(questionDef, value) {
        var selected = scope.isAnswerSelected(questionDef, value);
        var classes = [];

        if (selected) {
          classes.push('selected');
        } else {
          classes.push('not-selected');
          if (scope.displayMode == DISPLAY_MODES.ALL && !scope.quickEdit) {
            classes.push('hidden');
          }
        }

        if (scope.displayMode == DISPLAY_MODES.ALL && scope.quickEdit) {
          classes.push('clickable');
        }

        if (questionDef.displayType == displayTypes.MULTI_SELECT && questionDef.maxAllowed) {
          if (!selected && scope.maxAllowedReached(questionDef)) {
            classes.push('disabled');
          }
        }

        return classes;
      };


      /**
       *  Iterates over quiz requirements to determine the disabled button's state
       *  @returns {string} to be applied on an element as class
       */
      scope.getCompleteButtonClass = function() {
        if (!scope.quiz.$resolved) {
          return;
        }

        // If the default is disabled and the conditions are false,
        // Or the default is enabled and the conditions are true

        // If the button is disabled by default and the enable conditions are false,
        // Or the button is enabled by default and the disable conditions are true

        if (scope.quiz.completionButton.disabledDefault != scope.checkAnyConditions(scope.quiz.completionButton.disabledConditions, false)) {
          return 'disabled';
        }
      };

      scope.shouldShowCompleteButton = function() {
        if (!scope.quiz.$resolved || !scope.quiz.completionButton) {
          return;
        }

        // If the default is hidden (true) and the conditions are true, then we show.
        // Or the default is visible (false) and the conditions are false, then we show.
        // Anything else, we hide the button

        return scope.quiz.completionButton.hideDefault == scope.checkAnyConditions(scope.quiz.completionButton.hideConditions, false);
      };

      /**
       * A computed property that is determined by whether the current state has any
       *  required questions that have not been answered yet
       *  Also makes copies of data elsewhere
       *
       * @returns {boolean}
       */
      scope.isQuizComplete = function() {
        if (!scope.quiz.$resolved) {
          return;
        }

        var missing = scope.quiz.questions.filter(function(question) {
          return scope.isQuestionRequired(question) && !scope.isQuestionAnswered(question);
        });

        scope.isInvalid = Boolean(missing.length);

        scope.info.completed = !scope.isInvalid;
        return !scope.isInvalid;
      };

      scope.getMrAssSelector = function(answer) {
        if (typeof answer.value == 'boolean') {
          return answer.value ? 'true' : 'false';
        }
        return answer.value;
      };

      scope.uploadSupport = function() {
        return Boolean($window.FileReader && $window.CanvasRenderingContext2D);
      };

      scope.getTrustedHTML = function(value) {
        return $sce.trustAsHtml(scope.parseTemplateString(value));
      };

      scope.goInDirection = function(direction) {
        if (!scope.currentQuestion || scope.goingInDirection) {
          return;
        }
        scope.goingInDirection = true;

        var question;
        switch (direction) {
          case '+':
            question = scope.getNextQuestion(scope.currentQuestion);
            break;
          case '-':
            question = scope.getPreviousQuestion(scope.currentQuestion);
            break;
        }

        if (question) {
          scope.continueQuestion(scope.currentQuestion);
          scope.setCurrentQuestion(question);
        }

        setTimeout(function() {
          scope.goingInDirection = false;
        }, 600);
      };

      scope.canGoInDirection = function(direction) {
        if (!scope.currentQuestion) {
          return false;
        }

        var question;
        switch (direction) {
          case '+':
            if (scope.shouldShowContinueButton(scope.currentQuestion)) {
              return true;
            }

            if (!scope.isQuestionAnswered(scope.currentQuestion)) {
              return false;
            }

            question = scope.getNextQuestion(scope.currentQuestion);
            break;
          case '-':
            question = scope.getPreviousQuestion(scope.currentQuestion);
            break;
        }

        if (!question) {
          return false;
        }

        return question._visible;
      };

      scope.setCurrentQuestion = function(questionDef) {
        if (!questionDef) {
          return;
        }
        scope.currentQuestion = questionDef;
        scope.currentQuestionIndex = scope.quiz.questions.reduce(function(cur, question, idx) {
          if (question._key === questionDef._key) {
            return idx;
          }
          return cur;
        }, 0);

        if (isSingleMode() && !scope.info.visible) {
          // we want to update the height of the modal based on the height
          // of the question when going visible for the first time.
          var unbind = scope.$watch('info.visible', function(after, before) {
            if (!before && after) {
              unbind();
              // give the question time to render
              $timeout(function() {
                var res = getNewMrQuizHeight();
                if (res.$container) {
                  res.$container.attr('style', 'height: ' + res.height + 'px');
                }
              }, 100);
            }
          });
        }
      };

      var questionLowerBuffer = 72;
      var oldHeight = 0;

      /**
       * questions are absolute position in single mode
       * make height of question container same as question
       *
       */
function getNewMrQuizHeight() {
        var res = { height: oldHeight };
        var questionKey = scope.currentQuestion && scope.currentQuestion._key;
        if (!questionKey && !isSingleMode()) {
          return res;
        }
        // use the directive element to scope query to this instance of Mr.Quiz
        var $question = element.find('#' + questionKey);
        var $container = element.find('.mr-quiz');
        if (!$question || !$container) {
          return res;
        }

        res.$container = $container;
        // modal hasn't opened yet
        if (!$question.length) {
          return res;
        }

        var containerHeight = $container.height();
        var questionHeight = $question.height();
        if (oldHeight < containerHeight) {
          res.height = oldHeight = containerHeight;
        }
        // only update height if new height is larger than the last and is non-zero
        if (!questionHeight || oldHeight >= (questionHeight + questionLowerBuffer)) {
          return res;
        }
        res.height = oldHeight = (questionHeight + questionLowerBuffer);
        return res;
      }

      scope.getMrQuizHeight = function() {
        var res = getNewMrQuizHeight();
        if (isSingleMode()) {
          return { height: res.height + 'px' };
        }
        return;
      };

      scope.isBeforeCurrentQuestion = function(questionIndex) {
        return scope.currentQuestionIndex > questionIndex;
      };

      /**
       * Uploads customer image. Possibly.
       *
       * @param {object} question
       */
function getNewUploader(question) {
        return new quizSvc.FileUploader({
          url: '/api/customer/uploadCustomerImage',
          autoUpload: true,
          formData: [{
            id: scope.customerId
          }],
          filters: [{
            name: 'checkMaxSize',
            fn: function(item) {
              // Check if file is over maxSize
              var maxSize = 10000000;
              var hitLimit = item.size > maxSize;
              if (hitLimit) {
                notifySvc.notify('error', item.name + ' is too large. Photos must be less than 7 MB in size.');
              }
              return !hitLimit;
            }
          }, {
            name: 'checkFileLimit',
            fn: function() {
              // Make sure the amount of files being uploaded is not over maxLimit
              var maxLimit = 3;
              var hitLimit = question._uploader.queue.length >= maxLimit;
              if (question._uploader.queue.length >= maxLimit) {
                notifySvc.notify('error', "We're sorry. We currently allow up to " + maxLimit + " photos per request.");
              }
              return !hitLimit;
            }
          }, {
            name: 'imageFilter',
            fn: function(item) {
              var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
              var isImage = '|jpg|png|jpeg|bmp|'.indexOf(type) !== -1;
              if (!isImage) {
                notifySvc.notify('error', item.name + ' is not a recognized image type.');
              }
              return isImage;
            }
          }, {
            name: 'alreadyQueued',
            fn: function(item) {
              var alreadyQueued = question._uploader.queue.some(function(queueItem) {
                return queueItem.file.name == item.name && queueItem.file.size == item.size;
              });

              if (alreadyQueued) {
                notifySvc.notify('error', "You've already uploaded this photo.");
              }
              return !alreadyQueued;
            }
          }],
          onCompleteItem: function(item, response) {
            scope.setAnswer(question, response.url);
          }
        });
      }

      /**
       * Filters conditional actions?
       * I'm impressed that the comment in the body uses both "it's" and "its" correctly.
       *
       * @param {object}actions
       */
function filterConditionalActions(actions) {
        var filtered = [];
        (actions || []).forEach(function(action) {
          // If it's an action group, then check its conditions before appending the actions
          if (action.action == 'actionGroup' && scope.checkAnyConditions(action.params.conditions)) {
            filtered = filtered.concat(action.params.actions);
          } else if (action.action != 'actionGroup') {
            filtered.push(action);
          }
        });
        return filtered;
      }

      /**
       * Checks if value is null/undefined/empty omg just read the code
       *
       * @param {any} value
       */
function isNonValue(value) {
        return value === null || value === undefined || value === '';
      }

      /**
       * Shuffles an array, but not the fun Harlem-type of shuffle
       *
       * @param {array} arr
       */
function shuffle(arr) {
        //noinspection StatementWithEmptyBodyJS
        for (var j, x, i = arr.length; i; j = Math.floor(Math.random() * i), x = arr[--i], arr[i] = arr[j], arr[j] = x);
        return arr;
      }

      /**
       * Gets questionDef by its key
       *
       * @param {string} key
       */
function getQuestionDefByKey(key) {
        var index = -1;
        scope.quiz.questions.some(function(question, i) {
          if (question.key == key) {
            index = i;
            return true;
          }
        });

        if (index > -1) {
          return scope.quiz.questions[index];
        }
      }

      /**
       * Gets question index by unique key I guess
       *
       * @param {string} key
       */
function getQuestionIndexByUniqueKey(key) {
        var index = -1;
        scope.quiz.questions.some(function(question, i) {
          if (question._key == key) {
            index = i;
            return true;
          }
        });
        return index;
      }

      /**
       * Gets the index of a question
       *
       * @param {string} key
       */
function getQuestionIndex(key) {
        var index = -1;
        scope.quiz.questions.some(function(question, i) {
          if (question.key == key) {
            index = i;
            return true;
          }
        });
        return index;
      }

      /**
       * Gets questions by key. I am having déjà vu.
       *
       * @param {string} key
       */
function getQuestionsByKey(key) {
        return scope.quiz.questions.filter(function(question) {
          return question.key == key;
        });
      }

      /**
       * Yes, I had to look up how to spell déjà vu
       *
       */
function safeGetProperty() {
        /* jshint validthis:true */
        var args = Array.prototype.map.call(arguments, function(arg) {
          return ('' + arg).split('.');
        });

        var all = Array.prototype.concat.apply([], args);

        var key = all.shift();
        var remainingKeys = all.map(function(key) {
          return key;
        });

        var prop = (this || {})[key];

        // If the property is undefined but we have more keys, maybe there's a . in those keys...
        // keep trying until we run out of keys or find a property that matches
        while (remainingKeys.length && prop === undefined) {
          key += '.' + remainingKeys.shift();
          prop = (this || {})[key];
        }
        all = remainingKeys;

        if (prop === undefined || !all.length) {
          return prop;
        }

        return safeGetProperty.apply(prop, all);
      }

      /**
       * Testing for a key/value pair in an object
       *
       * @param {object} obj
       * @param {string} op
       * @param {string} key
       * @param {any} value
       */
function testObject(obj, op, key, value) {
        op = op || '=';

        var exists = Object.hasOwnProperty.call(obj, key) && !isNonValue(obj[key]);

        // If we're checking that it isn't equal to something, make sure it exists
        if (op == '!=' && !exists) {
          return false;
        }

        var negate = false;
        if (op.substring(0, 1) == '!') {
          negate = true;
          op = op.substring(1);
        }

        var cmp;
        switch (op) {
          case '<':
            cmp = +obj[key] < +value;
            break;

          case '>':
            cmp = +obj[key] > +value;
            break;

          case '<=':
            cmp = +obj[key] <= +value;
            break;

          case '>=':
            cmp = +obj[key] >= +value;
            break;

          case 'exists':
            cmp = exists;
            break;

          default:
          case '=':
            if (Array.isArray(obj[key])) {
              cmp = obj[key].some(function(elem) {
                return elem == value;
              });
            } else {
              cmp = obj[key] == value;
            }
            break;
        }

        return negate ? !cmp : cmp;
      }
    }
  };
}])
.
/* global DataView */
/**
 * The ng-thumb directive
 * @author: nerv
 * @version: 0.1.2, 2014-01-09
 */
// Mostly used to show thumbnails in FileUploader
directive('mrThumb', ['$window', function($window) {
  var helper = {
    support: !!($window.FileReader && $window.CanvasRenderingContext2D),
    isFile: function(item) {
      return angular.isObject(item) && item instanceof $window.File;
    },
    isImage: function(file) {
      var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
      return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
    }
  };

  return {
    restrict: 'A',
    template: '<canvas/>',
    link: function(scope, element, attributes) {
      if (!helper.support) {
        return;
      }

      var params = scope.$eval(attributes.mrThumb);

      if (!helper.isFile(params.file)) {
        return;
      }

      if (!helper.isImage(params.file)) {
        return;
      }

      var canvas = element.find('canvas');
      var reader = new FileReader();
      var orientation = 0;

      reader.onloadend = function(e) {
        orientation = getOrientation(e);
        reader.onloadend = onLoadFile;
        reader.readAsDataURL(params.file);
      };

      function getOrientation(e) {
        var view = new DataView(e.target.result);

        if (view.getUint16(0, false) != 0xFFD8) {
          return -2;
        }

        var length = view.byteLength;
        var offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return -1;
            }
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                return view.getUint16(offset + (i * 12) + 8, little);
              }
            }
          } else if ((marker & 0xFF00) != 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }

        return -1;
      }

      reader.readAsArrayBuffer(params.file);

      function onLoadFile(event) {
        var img = new Image();
        img.onload = onLoadImage;
        img.src = event.target.result;
      }

      function onLoadImage() {
        var width = this.width;
        var height = this.height;
        var marginTop = 0;

        if (params.width && !params.height) {
          width = params.width;
          height = this.height * params.width / this.width;
        }

        if (params.height && !params.width) {
          height = params.height;
          width = this.width * params.height / this.height;
        }

        if (params.width && params.height) {
          if (width < height) {
            width = params.width;
            height = this.height * params.width / this.width;
            marginTop = Math.floor((params.height - height) / 2);
          } else {
            height = params.height;
            width = this.width * params.height / this.height;
          }
        }

        var rotation = 'rotate-0';

        switch (orientation) {
          case 8:
            rotation = 'rotate-270';
            break;
          case 3:
            rotation = 'rotate-180';
            break;
          case 6:
            rotation = 'rotate-90';
            break;
        }

        canvas.attr({ width: width, height: height });
        canvas.css({ 'margin-top': marginTop });
        canvas.addClass(rotation);
        canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
      }
    }
  };
}]).
/**
 * Description
 * @module scrollIntoView
 * @moduleType ngDirective
 */
directive('scrollIntoView', ['$compile', function() {
  return {
    restrict: 'A',
    scope: {
      onEnterView: '&',
      onLeaveView: '&',
      triggerViewOnce: '=',
      triggerOnPartial: '=',
      elemName: '@'
    },
    link: function(scope, iElement) {
      var triggerOnce = castAsBoolean(scope.triggerViewOnce);
      var usePartial = castAsBoolean(scope.triggerOnPartial, true);
      var onEnter = scope.onEnterView;
      var onLeave = scope.onLeaveView;
      var $window = $(window);

      var inView = false;
      var inViewTriggered = false;

      $window.on('scroll', checkViewable);

      checkViewable();

      function checkViewable() {
        if (isInView()) {
          // call the function if it just entered and (it hasn't been triggered before or triggerOnce is false
          if (!inView) {
            // just showed up
            if (onEnter && (!inViewTriggered || !triggerOnce)) {
              onEnter();
              inViewTriggered = true;
            }
            inView = true;
          }
        } else if (onLeave && inView) {
          onLeave();
          inView = false;
        }
      }

      function isInView() {
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = iElement.offset().top;
        var elemBottom = elemTop + iElement.height();

        if (usePartial) {
          return ((elemBottom <= docViewBottom) || (elemTop >= docViewTop));
        }
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
      }

      function castAsBoolean(value, defaultValue) {
        if (arguments.length === 1) {
          defaultValue = false;
        }
        switch (typeof value) {
          case 'boolean':
            return value;
          case 'string':
            return ['true', '1'].indexOf(value.toLowerCase()) === 0;
          case 'number':
            return value !== 0;
          default:
            return defaultValue;
        }
      }
    }
  };
}]).
/**
 * Description
 * @module toggle
 * @moduleType ngDirective
 */
directive('toggle', ['$timeout', function($timeout) {
  return {
    templateUrl: '/ngpartials/directives/toggle.html',
    replace: true,
    restrict: 'E',
    scope: {
      inline: '@',
      model: '=ngModel',
      label: '@',
      onChange: '=',
      helpText: '@?',
      helpPlacement: '@?',
      disabled: '&?',
      trueValue: '=?',
      falseValue: '=?',
    },
    link: function(scope) {
      if (!scope.hasOwnProperty('helpPlacement')) {
        scope.helpPlacement = 'right';
      }

      scope.doToggle = function() {
        if (scope.disabled && scope.disabled()) {
          return;
        }

        var trueValue = scope.trueValue;
        var falseValue = scope.falseValue;

        if (trueValue === undefined) {
          switch (typeof scope.model) {
            case 'boolean':
              trueValue = true;
              break;
            case 'number':
              trueValue = 1;
              break;
            default:
              trueValue = true;
          }
        }

        if (falseValue == undefined) {
          switch (typeof scope.model) {
            case 'boolean':
              falseValue = false;
              break;
            case 'number':
              falseValue = 0;
              break;
            default:
              falseValue = null;
          }
        }

        scope.model = scope.model ? falseValue : trueValue;

        if (scope.onChange) {
          $timeout(function() {
            scope.onChange(scope.model);
          }, 0);
        }
      };
    }
  };
}]);

/** ****************************************************
  Module mrShared.filters
**************************************************** **/
angular.module('mrShared.filters', ['ngResource']).
/**
 formats mintues into hour-minutes format
 **/
filter('appointmentTime', function() {
  return function(val) {
    val = parseInt(val);
    if (val < 60) {
      return val + ' minutes';
    }
    if (val / 60 < 2) {
      if (val % 60 == 0) {
        return '1 hour';
      } else {
        return '1 hour ' + (val % 60) + ' minutes';
      }
    } else {
      if (val % 60 == 0) {
        return Math.floor(val / 60) + ' hours';
      } else {
        return Math.floor(val / 60) + ' hours ' + val % 60 + ' minutes';
      }
    }
  };
}).
/**
 formats mintues into hour-minutes format
 **/
filter('appointmentTimeShort', function() {
  return function(val) {
    val = parseInt(val);
    if (val < 60) {
      return val + 'min';
    }
    if (val / 60 < 2) {
      if (val % 60 == 0) {
        return '1hr';
      } else {
        return '1hr\u00A0' + (val % 60) + 'min';
      }
    } else {
      if (val % 60 == 0) {
        return Math.floor(val / 60) + 'hrs';
      } else {
        return Math.floor(val / 60) + 'hrs\u00A0' + val % 60 + 'min';
      }
    }
  };
}).
/**
  formats a duration of time expressed in minutes into a string
**/
filter('duration', function() {
  return function(val) {
    if (typeof val != 'number') {
      return val;
    }
    var hrs = Math.floor(val / 60);
    var mins = val % 60;
    var rslt = [mins + ' minute' + (mins != 1 ? 's' : '')];
    if (hrs) {
      rslt.unshift(hrs + ' hour' + (hrs > 1 ? 's' : ''));
    }
    return rslt.join(' ');
  };
}).
/**
 * Created by donkaiser on 6/24/16.
 */
filter('ifEmpty', function() {
  var re = /\[object (Undefined|Null)\]/;
  return function(val, defText) {
    defText = defText || 'n/a';
    if (isNonValue(val)) {
      return defText;
    }
    return val;
  };

  function isNonValue(val) {
    var valType = Object.prototype.toString.call(val);
    return re.test(valType) || val === '';
  }
}).
/**
  formats a phone number
**/
filter('phone', function() {
  return function(input) {
    if (!input) {
      return '';
    }

    var digits = input.replace(/\D/g, '');
    var format = '(???) ???-????';
    var international = false;

    var digitLen = Math.min(digits.length, 15);
    if (digits[0] == 1) {
      digitLen--;
    }

    if (digitLen > 10) {
      international = true;
      var countryCodeLen = Math.min(digitLen - 10, 3);
      var extraLen = 15 - digitLen;
      var countryCode = '';
      var i = 0;
      for (i = 0; i < countryCodeLen; i++) {
        countryCode += '?';
      }

      format = countryCode + ' ??? ??? ?? ??';
      for (i = 0; i < extraLen; i++) {
        format += '?';
      }
    }

    if (digits[0] == 1) {
      format = '? ' + format;
    }

    if (international) {
      format = '+' + format;
    }

    digits.split('').forEach(function(digit) {
      format = format.replace('?', digit);
    });

    return format.split('?')[0];
  };
}).
filter('prettyLabel', function() {

  function fixCase(ltr, toUpper) {
    if (toUpper) {
      return ltr.toUpperCase();
    } else {
      return ltr.toLowerCase();
    }
  }

  return function (theStr, wordcaps) {
    wordcaps = arguments.length === 2 ? wordcaps : true;
    if (theStr != null) {
      theStr = '' + theStr;
      theStr = theStr.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
      theStr = theStr.replace(/([a-zA-Z])([0-9])/g, '$1 $2');
      theStr = theStr.replace(/_/g, ' ');
      theStr = theStr.replace(/([0-9])([a-zA-Z])/g, '$1 $2');
      theStr = theStr.replace(/^([a-z])/, function(ltr) {
        return ltr.toUpperCase();
      });
      theStr = theStr.replace(/ (\w)/g, function(m, ltr) {
        return ' ' + fixCase(ltr, wordcaps);
      });
    }
    return theStr;
  };
});

/** ****************************************************
  Module mrShared.ngpartials
**************************************************** **/
angular.module('mrShared.ngpartials', ['ngResource']);

/** ****************************************************
  Module mrShared.services
**************************************************** **/
angular.module('mrShared.services', ['ngResource']).
factory('imgCropUtilSvc', [function() {
  return {
    standardAspects: standardAspects,
    remapUrl: remapUrl,
    getCloudinaryUrl: getCloudinaryUrl,
    getCropQueryString: getCropQueryString,
    getStaticImageUrl: getStaticImageUrl,
    getStaticCroppedImageUrl: getStaticCroppedImageUrl,
    getCustomMediaObj: getCustomMediaObj
  };

  function standardAspects() {
    return [
      { key: '1x1', w: 400, h: 400, m: 1 / 1 },
      { key: '1x2', w: 200, h: 400, m: 1 / 2 },
      { key: '1x3', w: 110, h: 330, m: 1 / 3 },
      { key: '1x4', w: 100, h: 400, m: 1 / 4 },
      { key: '2x1', w: 400, h: 200, m: 2 / 1 },
      { key: '2x3', w: 300, h: 450, m: 2 / 3 },
      { key: '3x1', w: 600, h: 200, m: 3 / 1 },
      { key: '3x2', w: 600, h: 400, m: 3 / 2 },
      { key: '3x4', w: 300, h: 400, m: 3 / 4 },
      { key: '4x1', w: 800, h: 200, m: 4 / 1 },
      { key: '4x3', w: 400, h: 300, m: 4 / 3 },
      { key: '4x5', w: 300, h: 375, m: 4 / 5 },
      { key: '5x6', w: 300, h: 360, m: 5 / 6 },
      { key: '6x5', w: 360, h: 300, m: 6 / 5 },
      { key: '7x2', w: 400, h: 130, m: 7 / 2 },
      { key: '8x5', w: 400, h: 250, m: 8 / 5 },
      { key: '9x10', w:360, h: 400, m: 9 / 10 },
      { key: '10x9', w: 400, h: 360, m: 10 / 9 },
      { key: '12x5', w: 600, h: 250, m: 12 / 5 },
      { key: '16x9', w: 400, h: 225, m: 16 / 9 }
    ];
  }

  function remapUrl(url) {
    if (!url) {
      return;
    }

    const mediaDomain = 'https://media.madison-reed.com/';

    if (url.startsWith(mediaDomain) || url.includes('/avatars/')) {
      return url;
    }

    const imgixPrefix = 'https://mr-cdn.imgix.net/';
    const imgixPrefixStaging = 'https://mr-cdn-staging.imgix.net';
    const cloudfrontPrefix = `${mediaDomain}d3ewrnwdcmri66.cloudfront.net/`;
    const cloudfrontPrefixStaging = `${mediaDomain}ddxs94deh28np.cloudfront.net/`;

    if (url.startsWith(imgixPrefix)) {
      return cloudfrontPrefix + url.substring(imgixPrefix.length);
    }

    if (url.startsWith(imgixPrefixStaging)) {
      return cloudfrontPrefixStaging + url.substring(imgixPrefixStaging.length);
    }

    return mediaDomain + url.replace('https://', '');
  }

  function getWatermarkParams(mediaObj, cropSettings) {
    cropSettings = cropSettings || {};
    if (mediaObj.watermark && mediaObj.watermark.url) {
      var markparams = [];
      var markalign = cropSettings.markalign || mediaObj.watermark.markalign;
      var markpad = cropSettings.markpad || mediaObj.watermark.markpad;
      var markw = cropSettings.markw || mediaObj.watermark.markw;
      var markh = cropSettings.markh || mediaObj.watermark.markh;
      markparams.push('&mark=' + mediaObj.watermark.url);
      markparams.push('&markalign=' + markalign);
      markparams.push('&markpad=' + markpad);
      markparams.push('&markfit=clip&markw=' + markw + '&markh=' + markh);
      return markparams.join('');
    } else {
      return '';
    }
  }

  function getCloudinaryUrl(url) {
    var cloudinaryHostMap = {
      'mr-cdn.imgix.net': {
        base: 'res.cloudinary.com/madisonreed/image/upload/',
        end: 'v1538069478/mr-cdn/'
      },
      'mr-cdn-staging.imgix.net': {
        base: 'res.cloudinary.com/madisonreed/image/upload/',
        end: 'v1538069478/mr-cdn-stage/'
      }
    };
    var hostRE = /https?:\/\/([^/]+)\/.*$/;
    var host = url.replace(hostRE, '$1');
    var cloudHost = cloudinaryHostMap[host] ? cloudinaryHostMap[host].base : null;

    if (cloudHost) {
      var queryStr = url.substring(url.indexOf('?') + 1, url.length);
      url.replace('?' + queryStr, '');

      if (queryStr.length) {
        var query = {};
        var queryParams = queryStr.split('&');
        queryParams.forEach(function(param) {
          param = param.split('=');
          query[param[0]] = param[1];
        });

        if (query.rect) {
          var rect = query.rect.split(',');
          cloudHost += 'c_crop,x_' + rect[0] + ',y_' + rect[1] + ',w_' + rect[2] + ',h_' + rect[3] + '/';
        }
        if (query.w && query.h) {
          cloudHost += 'w_' + Math.floor(query.w) + ',h_' + Math.floor(query.h) + ',f_auto,q_auto,c_fill';
          if (query.crop == 'faces') {
            cloudHost += ',g_faces';
          }
          cloudHost += '/';
        } else {
          cloudHost += 'f_auto,q_auto/';
        }
        if (query.dpr) {
          cloudHost += 'dpr_' + query.dpr + '/';
        }

        cloudHost += cloudinaryHostMap[host].end;
      }

      url = url.substring(0, url.indexOf('?'));
      return url.replace(host, cloudHost);
    }
    return url;
  }

  function getCropQueryString(aspect) {
    var params = [
      'fit=' + aspect.fit
    ];
    if (aspect.fit === 'crop' && !aspect.useRect) {
      params.push('crop=' + aspect.crop.txt);
    }
    if (aspect.useRect) {
      var r = aspect.rect;
      params.push('rect=' + [r.x, r.y, r.w, r.h].join(','));
    }
    return params.join('&');
  }

  function getStaticImageUrl(mediaObj) {
    var baseUrl = remapUrl(mediaObj.url);
    var hasAutoFormat = baseUrl.includes('?auto=format') || baseUrl.includes('&auto=format');
    var url = hasAutoFormat ? baseUrl : baseUrl + '?auto=format';
    if (mediaObj.watermark && mediaObj.watermark.url) {
      url += getWatermarkParams(mediaObj);
    }
    return url;
  }

  function getStaticCroppedImageUrl(mediaObj, aspectRatio, width, quality) {
    var cropSettings = mediaObj.aspects.find(function(aspect) {
      return aspect.key == aspectRatio.key;
    });
    var m = cropSettings ? cropSettings.m : aspectRatio.m;
    var url = [remapUrl(mediaObj.url)];
    var height = Math.ceil((width / m));

    url.push('?w=', width);
    url.push('&h=', height);
    if (cropSettings) {
      url.push('&' + cropSettings.cropQuery);
    } else {
      url.push('&fit=crop&crop=edges');
    }
    url.push('&auto=format');

    if (quality) {
      url.push('&q=' + quality);
    }

    if (mediaObj.watermark && mediaObj.watermark.url) {
      url.push(getWatermarkParams(mediaObj, cropSettings));
    }

    url = url.join('');

    return url;
  }

  function getCustomMediaObj(mediaObj, crops) {
    var newMediaObj = angular.copy(mediaObj);
    newMediaObj.aspects = newMediaObj.aspects.filter(function(aspect) {
      var isCrop = false;
      crops.forEach(function(crop) {
        if (aspect.key == crop.key) {
          isCrop = true;
        }
      });
      return isCrop;
    });
    return newMediaObj;
  }
}]).
factory('sharedProductSvc', ['$resource', function($resource) {
 return $resource('/rest/products', {}, {
    getAllWithExtraData: { method: 'POST', url: '/rest/products/getAllWithExtraData', isArray: true }
  });
}])
;

/** ****************************************************
  Module mrWebsite.directives
**************************************************** **/
angular.module('mrWebsite.directives', ['ngResource']).
/* global YMK */
/* requires YMK to be included on the page */

directive('ymkWrap', ['trackerSvc', function(trackerSvc) {
  return {
    restrict: 'E',
    template: "<div id='YMK-module'></div>",
    scope: {
      control: '=',
      code: '=',
      startOpen: '@'
    },
    link: function(scope, element) {
      scope.control = scope.control || {};
      scope.control.initialized = false;
      scope.control.loaded = false;
      scope.control.initialized = false;
      
      var YMKShadeMap = {
        "2.5NNN": "BCC-17143_20180622_DYE_01_20",
        "2NAA": "BCC-17143_20180622_DYE_01_21",
        "3.5NNN": "BCC-17143_20180622_DYE_01_22",
        "2NNA": "BCC-17143_20180622_DYE_01_01",
        "3NVV": "BCC-17143_20180622_DYE_01_23",
        "3NNA": "BCC-17143_20180622_DYE_01_02",
        "4.5NNN": "BCC-17143_20180622_DYE_01_03",
        "4VR": "BCC-17143_20180622_DYE_01_118",
        "4NA": "BCC-17143_20180622_DYE_01_24",
        "4NGV": "BCC-17143_20180622_DYE_01_04",
        "4NMG": "BCC-17143_20180622_DYE_01_11",
        "5.5NNN": "BCC-17143_20180622_DYE_01_12",
        "5.5NNA": "BCC-17143_20180622_DYE_01_163",
        "5RV": "BCC-17143_20180622_DYE_01_154",
        "5NRM": "BCC-17143_20180622_DYE_01_25",
        "5NA": "BCC-17143_20180622_DYE_01_13",
        "5NAC": "BCC-17143_20180622_DYE_01_14",
        "5NGM": "BCC-17143_20180622_DYE_01_15",
        "5NGV": "BCC-17143_20180622_DYE_01_16",
        "6.5NNN": "BCC-17143_20180622_DYE_01_26",
        "6.5NNA": "BCC-17143_20180622_DYE_01_159",
        "6N": "BCC-17143_20180622_DYE_01_173",
        "6RR": "BCC-17143_20180622_DYE_01_155",
        "6NAV": "BCC-17143_20180622_DYE_01_27",
        "6NMG": "BCC-17143_20180622_DYE_01_28",
        "6NRR": "BCC-17143_20180622_DYE_01_29",
        "6NAC": "BCC-17143_20180622_DYE_01_17",
        "6NCG": "BCC-17143_20180622_DYE_01_18",
        "6NGV": "BCC-17143_20180622_DYE_01_19",
        "7.5NNA": "BCC-17143_20180622_DYE_01_172",
        "7N": "BCC-17143_20180622_DYE_01_158",
        "7RC": "BCC-17143_20180622_DYE_01_156",
        "7NCG": "BCC-17143_20180622_DYE_01_30",
        "7NCR": "BCC-17143_20180622_DYE_01_31",
        "7NGM": "BCC-17143_20180622_DYE_01_87",
        "7NGV": "BCC-17143_20180622_DYE_01_88",
        "7NVA": "BCC-17143_20180622_DYE_01_89",
        "8CC": "BCC-17143_20180622_DYE_01_157",
        "8AV": "BCC-17143_20180622_DYE_01_90",
        "8NGC": "BCC-17143_20180622_DYE_01_91",
        "8NGV": "BCC-17143_20180622_DYE_01_92",
        "8NVA": "BCC-17143_20180622_DYE_01_93",
        "9AV": "BCC-17143_20180622_DYE_01_94",
        "9NA": "BCC-17143_20180622_DYE_01_95",
        "9NG": "BCC-17143_20180622_DYE_01_96",
        "9NGV": "BCC-17143_20180622_DYE_01_107",
        "9NV": "BCC-17143_20180622_DYE_01_108",
        "10NA": "BCC-17143_20180622_DYE_01_109",
        "10NGV": "BCC-17143_20180622_DYE_01_110",
        "10NVA": "BCC-17143_20180622_DYE_01_111",
        "11AA": "BCC-17143_20180622_DYE_01_115",
        "11GV": "BCC-17143_20180622_DYE_01_116",
        "11VA": "BCC-17143_20180622_DYE_01_117"
      };
      
      scope.control.open = function() {
        setTimeout(function() {
          if (!scope.control.initialized) {
            var trys = 0;
            var initYMKInterval = setInterval(function() {
              var width = element.width();
              trys += 1;
              if (typeof YMK !== 'undefined' && width > 0) {
                YMK.init({
                  width: width,
                  height: width,
                  disable2ColorComparison: true,
                  enableFBSharing: true,
                  enableEmailSharing: true,
                  skinSmoothStrength: 0
                });
                scope.control.initialized = true;
                clearInterval(initYMKInterval);
                addEventListeners();
                YMK.open();
              }
              if (trys >= 10) {
                clearInterval(initYMKInterval);
              }
            }, 250);
          } else {
            addEventListeners();
            YMK.open();
          }
        }, 250);
      };

      scope.control.close = function() {
        removeEventListeners();
        YMK.close();
      };

      function addEventListeners() {
        scope.YMKLoadedEventListener = YMK.addEventListener('loaded', function() {
          scope.control.loaded = true;
          if (scope.code) {
            scope.control.setColor(scope.code);
          }
          scope.$apply();
        });

        scope.YMKClosedEventListener = YMK.addEventListener('closed', function() {
          scope.control.loaded = false;
        });

        scope.YMKVideoLoadedEventListener = YMK.addEventListener('videoLoaded', function() {
          trackerSvc.trackEvent('AR Try it On Live', {
            product_code: scope.code
          });
        });

        scope.YMKPhotoLoadedEventListener = YMK.addEventListener('photoLoaded', function() {
          trackerSvc.trackEvent('AR Try it On Upload Photo', {
            product_code: scope.code
          });
        });

        scope.YMKPhotoSavedEventListener = YMK.addEventListener('photoSaved', function() {
          trackerSvc.trackEvent('AR Photo Saved', {
            product_code: scope.code
          });
        });

        scope.YMKFBShareEventListener = YMK.addEventListener('shareToFBSuccess', function() {
          trackerSvc.trackEvent('AR FB Share', {
            product_code: scope.code
          });
        });

        scope.YMKEmailShareEventListener = YMK.addEventListener('shareToEmailSuccess', function() {
          trackerSvc.trackEvent('AR Email Share', {
            product_code: scope.code
          });
        });
      }

      function removeEventListeners() {
        YMK.removeEventListener(scope.YMKLoadedEventListener);
        YMK.removeEventListener(scope.YMKClosedEventListener);
        YMK.removeEventListener(scope.YMKVideoLoadedEventListener);
        YMK.removeEventListener(scope.YMKPhotoLoadedEventListener);
        YMK.removeEventListener(scope.YMKPhotoSavedEventListener);
        YMK.removeEventListener(scope.YMKFBShareEventListener);
        YMK.removeEventListener(scope.YMKEmailShareEventListener);
      }

      scope.control.setColor = function(code) {
        if (scope.control.initialized && scope.control.loaded && YMKShadeMap[code]) {
          YMK.applyMakeupBySku(YMKShadeMap[code]);
        }
      };

      scope.$watch('code', function() {
        if (scope.code) {
          scope.control.setColor(scope.code);
        }
      });

      if (scope.startOpen) {
        scope.control.open();
      }

      console.log('control: ', scope.control);

      scope.$on('$destroy', function() {
        removeEventListeners();
      });
    }
  };
}])
.
directive('addToCart', ['newCartSvc', function(newCartSvc) {
  return {
    restrict: 'A',
    scope: {
      addToCart: '='
    },
    link: function(scope, elem) {
      elem.click(function() {
        newCartSvc.addProduct(scope.addToCart, function() {
          window.location = elem.attr('href');
        });
      });
    }
  };
}]).
directive('mrAssociatedSubsModal', [function() {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/associated-subs-modal',
    scope: {
      modal: '='
    }
  };
}])
.
directive('blogGetter', ['$compile', '$anchorScroll', '$location', 'cmsSvc', function($compile, $anchorScroll, $location, cmsSvc) {
  return {
    restrict: 'EA',
    transclude: true,
    scope: {
      contentId: '@',
      moduleName: '@',
      methodName: '@',
      params: '@'
    },
    link: function(scope, element, attrs, controller, transclude) {
      scope.getter = {};
      scope.getter.data = null;
      scope.getter.params = JSON.parse(scope.params);
      scope.isOriginalPage = false;

      var originalPage = scope.getter.params.fromLanding ? scope.getter.params.p - 1 : null;
      var width = window.innerWidth;
      var mediaRange = {
        mobile: {
          min: 0,
          max: 559
        },
        tablet: {
          min: 560,
          max: 759
        }
      };

      if (width <= mediaRange.mobile.max) {
        if (scope.getter.params.mobileLimit) {
          scope.getter.params.s = scope.getter.params.mobileLimit + 1;
        }
      }

      if (width >= mediaRange.tablet.min && width <= mediaRange.tablet.max) {
        if (scope.getter.params.tabletLimit) {
          scope.getter.params.s = scope.getter.params.tabletLimit + 1;
        }
      }

      var getterScope = scope;
      var transclusionScope;

      transclude(function(clone, scope) {
        element.append(clone);
        $compile(element.contents())(getterScope);
        transclusionScope = scope;
      });

      scope.scrollToElement = function() {
        $location.hash('topAnchor');
        $anchorScroll();
      };

      scope.$watch('getter.params', function(newValue) {
        if (newValue.p == originalPage) {
          scope.isOriginalPage = true;
        } else {
          scope.isOriginalPage = false;
        }

        cmsSvc.callDeferedGetterMethod({
          moduleName: scope.moduleName,
          methodName: scope.methodName,
          params: newValue
        }, function(data) {
          if (!scope.isOriginalPage) {
            data.blogPosts.unshift({});
            data.blogPosts.pop();
          }

          transclusionScope.data = data;
          transclusionScope.isOriginalPage = scope.isOriginalPage;
          scope.getter.data = data;
          scope.getter.isOriginalPage = scope.isOriginalPage;
        });
      }, true);
    }
  };
}])
.
directive('bundleBuilderModal', ['$cookies', function($cookies) {
  return {
    templateUrl: '/ngpartials/directives/bundle-builder-modal',
    scope: {
      cartItems: '=',
      subTotal: '=',
      recentAddedProduct: '=',
      bundleBuilderProducts: '=',
      freeShip: '=',
      addToCartMethod: '='
    },
    link: function(scope) {
      scope.bundleBuilderModal = {
        visible: true,
        products: []
      };
      scope.setCookie = scope.$parent.setCookie || scope.$parent.$parent.setCookie || scope.$parent.$parent.$parent.setCookie;
      var bundlesViewed = angular.fromJson($cookies.bundlesViewed) || [];

      scope.calculateDiscount = function() {
        var total = scope.subTotal ? scope.subTotal : 0;
        var percentages = [0, 15, 20, 25];
        var currentPercentage = 0;

        scope.bundleBuilderModal.products.forEach(function(product) {
          if (product.selected) {
            currentPercentage++;
            total += product.price;
          }
        });

        var threshold = 44.90;

        scope.cartItems.forEach(function(item) {
          if (item.subscription) {
            threshold = 39.90;
          }
        });

        scope.currentDiscount = currentPercentage ? total * percentages[currentPercentage] / 100 : 0;

        scope.willFreeShip = false;
        if (total - scope.currentDiscount >= threshold && scope.freeShip) {
          scope.willFreeShip = true;
        }
      };

      function updateProducts(products) {
        products.forEach(function(product) {
          product.selected = true;
          scope.bundleBuilderModal.products.push(product);

          if (product.colorFamily) {
            scope.bundleBuilderModal.colorFamily = product.colorFamily == 'Brown' ? 'Brunette' : product.colorFamily;
          }

          var productViewed = bundlesViewed.some(function(code) {
            code == product.code;
          });

          if (!productViewed) {
            bundlesViewed.push(product.code);
            scope.setCookie('bundlesViewed', angular.toJson(bundlesViewed), 2);
          } else {
            scope.bundleBuilderModal.visible = false;
          }
        });

        scope.calculateDiscount();
      }

      updateProducts(scope.bundleBuilderProducts);

      if (scope.recentAddedProduct) {
        scope.cartItems.forEach(function(item) {
          if (item.id == scope.recentAddedProduct) {
            scope.bundleBuilderModal.addedProduct = item;
          }
        });
      }

      scope.addProducts = function() {
        if (scope.addingBundleProducts) {
          return;
        }
        scope.addingBundleProducts = true;
        var payload = [];

        scope.bundleBuilderModal.products.forEach(function(product) {
          if (product.selected) {
            payload.push({
              product_id: product.id,
              qty: 1,
              ctaSource: 'bundle-builder-modal'
            });
          }
        });

        scope.addToCartMethod(payload);
        scope.bundleBuilderModal.visible = false;
      };
    }
  };
}]).
directive('captcha', [function() {
  return {
    restrict: 'E',
    template: "<label><span class='ada-tooltip'>captcha response</span><div id='captcha-div_{{$id}}'></div></label>",
    scope: {
      captchaResponse: '='
    },
    link: function(scope) {
      scope.checkCaptcha = function(res) {
        if (res && res.length) {
          scope.captchaResponse = res;
          scope.$apply();
        }
      };

      scope.expireCaptcha = function() {
        scope.captchaResponse = null;
        scope.$apply();
      };

      window.allCaptchaIds = window.allCaptchaIds || {};
      window.allCaptchaIds[scope.$id] = {
        div: 'captcha-div_' + scope.$id,
        widgetId: null,
        callback: scope.checkCaptcha,
        expireCallback: scope.expireCaptcha
      };

      window.captchaLoaded = window.captchaLoaded || function() {
        Object.keys(window.allCaptchaIds).forEach(function(id) {
          var data = window.allCaptchaIds[id];
          if (data.widgetId === null && window.grecaptcha) {
            data.widgetId = window.grecaptcha.render(data.div, {
              sitekey: '6Ldd1lUUAAAAAGFyZRgmEl-ukTlH-zqulbRoCoJp',
              callback: data.callback,
              "expired-callback": data.expireCallback
            });
          }
        });
      };

      setTimeout(function() {
        var existing = document.getElementById('captcha-script');
        if (existing) {
          window.captchaLoaded();
          return;
        }

        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?hl=en&onload=captchaLoaded&render=explicit';
        script.async = true;
        script.defer = true;
        script.id = 'captcha-script';
        document.body.appendChild(script);
      }, 50);

      scope.$on('$destroy', function() {
        if (window.grecaptcha) {
          window.grecaptcha.reset(window.allCaptchaIds[scope.$id].widgetId);
        }
      });
    }
  };
}])
.
/**
* @module centerSelected
* @moduleType angular directive
* @desc This angular directive is useful whenever you want a swipable nav that centers the selected nav item. It will attempt to center the first child element that has the .selected class.
*
*/

directive('centerSelected', [function() {
  return {
    restrict: 'E',
    scope: {
      onSwipeLeft: '&',
      onSwipeRight: '&'
    },
    replace: true,
    transclude: true,
    template: '<div class="center-selected" style="position: relative; width: 100%;"><div class="center-selected-inner" style="white-space: nowrap;" ng-click="centerSelectedChild()" mr-swipe left="centerSelectedChild(); swipeLeft();" right="centerSelectedChild(); swipeRight();" ng-transclude></div></div>',
    link: function(scope, element) {
      var childElement = element[0].children[0];

      scope.swipeLeft = function() {
        if (scope.onSwipeLeft) {
          scope.onSwipeLeft();
        }
      };

      scope.swipeRight = function() {
        if (scope.onSwipeRight) {
          scope.onSwipeRight();
        }
      };

      function getTotalWidth() {
        var totalWidth = 0;
        for (var x = 0; x < childElement.children.length; x++) {
          totalWidth += $(childElement.children[x]).outerWidth();
        }
        return totalWidth;
      }

      function getSelectedChildIndex() {
        var index = -1;
        if (!$(childElement).children.length) {
          return index;
        }
        var innerChildren = $(childElement)[0].children;
        for (var x = 0; x < innerChildren.length; x++) {
          if ($(innerChildren[x]).hasClass('selected')) {
            index = x;
          }
        }

        return index;
      }

      scope.centerSelectedChild = function() {
        setTimeout(function() {
          var innerChildIndex = getSelectedChildIndex();
          if (innerChildIndex == -1) {
            $(childElement).css('margin', '0 auto');
          }
          var elementWidth = $(element).outerWidth();
          var childWidth = $(childElement).outerWidth();

          if (childWidth > elementWidth) {
            var offset = 0;
            var innerChildren = $(childElement)[0].children;

            for (var x = 0; x < innerChildIndex; x++) {
              offset += $(innerChildren[x]).outerWidth();
            }

            offset = offset + ($(innerChildren[innerChildIndex]).outerWidth() / 2);
            offset = offset * -1;
            offset = offset + (elementWidth / 2);

            $(childElement).css('margin', '0 0 0 ' + Math.ceil(offset) + 'px');
          } else {
            $(childElement).css('margin', '0 auto');
          }
        }, 100);
      };

      scope.$watch(getTotalWidth, function(newValue) {
        $(childElement).css('width', Math.ceil(newValue) + 1 + 'px');
        scope.centerSelectedChild();
      });

      setTimeout(scope.centerSelectedChild, 10);
    }
  };
}])
.
directive('component', [function() {
  return {
    restrict: 'E',
    scope: {
      namespace: '@'
    },
    link: function() {
      // TODO: renderDeferedComponent
      // cmsSvc.renderDeferedComponent({ namespace: scope.namespace }, function(result) {
      //   element.html(result);
      //   $compile(element.contents())(scope);
      // });
    }
  };
}]).
directive('datepicker', function() {
  return {
    link: function(scope, element) {
      var opts = {
        defaultDate: scope.date,
        onSelect: function(date) {
          scope.date = date;
          scope.$apply();
          if (scope.control.onDateChange) {
            scope.control.onDateChange(date);
          }
        }
      };

      scope.control.setDate = function(date) {
        element.datepicker("setDate", date);
        scope.$parent.dateIsSet = true;
      };

      if (scope.minDate) {
        opts.minDate = opts.defaultDate = new Date(scope.minDate);

        scope.$watch('minDate', function(newVal, oldVal) {
          if (!angular.equals(newVal, oldVal)) {
            element.datepicker('destroy');
          }

          opts.minDate = new Date(newVal);
          scope.$apply();
          element.datepicker(opts);
        });
        return;
      }
    },
    scope: {
      date: '=',
      control: '=',
      minDate: '=?'
    }
  };
}).
directive('dropdown', function($timeout) {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      ngModel: '='
    },
    link: function(scope, element) {
      scope.$watch('ngModel', function() {
        delayApply();
      });

      var oldLength;
      scope.$watch(function() {
        var changed = element[0].childNodes.length != oldLength;
        oldLength = element[0].childNodes.length;
        return changed;
      }, delayApply);

      element.on('focus', function() {
        element.parent().find('div.customDropdown')[0].classList.add('focused');
      });

      element.on('blur', function() {
        element.parent().find('div.customDropdown')[0].classList.remove('focused');
      });

      function delayApply() {
        $timeout(function() {
          element.customDropdown();
        }, 100);
      }
    }
  };
}).
directive('dropdownItem', [function() {
  return {
    require: '^mrDropdown',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="dropdown-item" ng-click="changeModel(header)" ng-class="{unselected: !dropDowns[header].selected}" ng-transclude>' +
      '</div>',
    scope: {
      value: '=',
      header: '='
    },
    link: function(scope, element, attrs, ctrl) {
      scope.changeModel = ctrl.changeModel;
      scope.dropDowns = ctrl.dropDowns;
      ctrl.addItem(scope.header, scope.value, element);
    }
  };
}])
.
//This attribute directive emits an 'init' event after it has been initialized
directive('elementInit', function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.on('load', function() {
        scope.$emit('init');
      });
    }
  };
}).
directive('elementReady', ['$parse', function($parse) {
  //tag this directive onto an element in order to tell angular to parse it once it and its children are finished initializing
  //initialization is considered finished on an element when all synchronous tasks within angular-core, dependency-injection,
  //and our own synchronous JS is finished
  return {
     restrict: 'A',
     link: function($scope, element, attrs) {
        element.ready(function(){
          $scope.$apply(function() {
            var parseFunc = $parse(attrs.elementReady);
            parseFunc($scope);
            performance.mark('angularFinished'); // custom perf metric
          });
        });
     }
  };
}])
.
directive('errSrc', function() {
  return {
    scope: {
      errClassTarget: '='
    },
    link: function(scope, element, attrs) {
      element.bind('error', function() {
        element.attr('src', attrs.errSrc);
        if (scope.errClassTarget) {
          $(scope.errClassTarget).addClass('ng-err-src');
        } else {
          element.addClass('ng-err-src');
        }
      });
    }
  };
}).
directive('fbSignIn', ['$window', '$location', 'customerSvc', 'mrNgUtils', function($window, $location, customerSvc, mrNgUtils) {
  return {
    scope: {
      callback: '=',
      extraBody: '=',
    },
    link: function(scope, element) {
      element.bind('click', signIn);
      var qs = {};
      if ($location.search().next) {
        qs = $location.search();
      }
      if (mrNgUtils.locationSearchParams().next) {
        qs = mrNgUtils.locationSearchParams();
      }
      var redirectUrl = decodeURIComponent(qs.next || '/');

      /**
       * Sign in
       */
      function signIn() {
        var FB = $window.FB;
        if (!FB) {
          setTimeout(signIn, 300);
          return;
        }

        FB.login(function(loginRes) {
          customerSvc.encodeFacebookUserId(loginRes, function() {
            var fields = [
              'id',
              'email',
              'name',
              'first_name',
              'last_name',
              'middle_name',
              'gender',
              'birthday',
              'hometown',
              'link',
              'locale',
              'location',
              'timezone',
              'updated_time',
              'verified',
            ];
            FB.api('/me', { fields: fields.join(',') }, function(resp) {
              FB.getLoginStatus(function(statusRes) {
                if (
                  statusRes.authResponse &&
                  statusRes.authResponse.accessToken &&
                  statusRes.authResponse.expiresIn
                ) {
                  resp.accessToken = statusRes.authResponse.accessToken;
                  resp.accessTokenExpires = statusRes.authResponse.expiresIn;
                }

                if (scope.extraBody) {
                  for (var k in scope.extraBody) {
                    if (resp[k] === undefined) {
                      resp[k] = scope.extraBody[k];
                    }
                  }
                }

                customerSvc.facebook(resp, function(data) {
                  if (data.success == 0 && data.err == 'bad-facebook-data') {
                    scope.$emit(data.err);
                    return;
                  }

                  if (scope.callback) {
                    scope.callback(data);
                  }

                  if (element.attr('href')) {
                    $window.location = element.attr('href');
                  } else if (redirectUrl) {
                    $window.location = redirectUrl.replace(/[:()<>]/g, '');
                  } else {
                    $window.location.reload(true);
                  }
                });
              });
            });
          }, {
            scope: ['email'].join(','),
          });
        });
      }
    }
  };
}, ]).
directive('fixedWidth', [function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var xs = attrs.xs ? parseInt(attrs.xs) : 'auto';
      var sm = attrs.sm ? parseInt(attrs.sm) : 'auto';
      var md = attrs.md ? parseInt(attrs.md) : 'auto';
      var lg = attrs.lg ? parseInt(attrs.lg) : 'auto';
      var xsMediaList = window.matchMedia("only screen and (min-width: 0px) and (max-width: 559px)");
      var smMediaList = window.matchMedia("only screen and (min-width: 560px) and (max-width: 759px)");
      var mdMediaList = window.matchMedia("only screen and (min-width: 760px) and (max-width: 959px)");
      var lgMediaList = window.matchMedia("only screen and (min-width: 960px)");

      if (xsMediaList.matches) {
        elem.css('width', xs);
      }
      if (smMediaList.matches) {
        elem.css('width', sm);
      }
      if (mdMediaList.matches) {
        elem.css('width', md);
      }
      if (lgMediaList.matches) {
        elem.css('width', lg);
      }

      xsMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', xs);
        }
      });
      smMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', sm);
        }
      });
      mdMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', md);
        }
      });
      lgMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', lg);
        }
      });
    }
  };
}])
.
directive('fixedWidthTweakUpper', [function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var xs = attrs.xs ? parseInt(attrs.xs) : 'auto';
      var sm = attrs.sm ? parseInt(attrs.sm) : 'auto';
      var md = attrs.md ? parseInt(attrs.md) : 'auto';
      var lg = attrs.lg ? parseInt(attrs.lg) : 'auto';
      var xsTweakLowerMediaList = window.matchMedia("only screen and (min-width: 0px) and (max-width: 439px)");
      var smTweakLowerMediaList = window.matchMedia("only screen and (min-width: 560px) and (max-width: 659px)");
      var mdTweakLowerMediaList = window.matchMedia("only screen and (min-width: 760px) and (max-width: 859px)");
      var lgTweakLowerMediaList = window.matchMedia("only screen and (min-width: 960px) and (max-width: 1079px)");
      var xsTweakUpperMediaList = window.matchMedia("only screen and (min-width: 439px) and (max-width: 559px)");
      var smTweakUpperMediaList = window.matchMedia("only screen and (min-width: 659px) and (max-width: 759px)");
      var mdTweakUpperMediaList = window.matchMedia("only screen and (min-width: 859px) and (max-width: 959px)");
      var lgTweakUpperMediaList = window.matchMedia("only screen and (min-width: 1080px)");

      if (xsTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (xsTweakUpperMediaList.matches) {
        elem.css('width', xs);
      }
      if (smTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (smTweakUpperMediaList.matches) {
        elem.css('width', sm);
      }
      if (mdTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (mdTweakUpperMediaList.matches) {
        elem.css('width', md);
      }
      if (lgTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (lgTweakUpperMediaList.matches) {
        elem.css('width', lg);
      }

      xsTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      xsTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', xs);
        }
      });
      smTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      smTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', sm);
        }
      });
      mdTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      mdTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', md);
        }
      });
      lgTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      lgTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', lg);
        }
      });
    }
  };
}])
.
directive('getter', ['$compile', '$anchorScroll', '$location', 'cmsSvc', function($compile, $anchorScroll, $location, cmsSvc) {
  return {
    restrict: 'EA',
    transclude: true,
    scope: {
      contentId: '@',
      moduleName: '@',
      methodName: '@',
      params: '@'
    },
    link: function(scope, element, attrs, controller, transclude) {
      scope.getter = {};
      scope.getter.data = null;
      scope.getter.params = JSON.parse(scope.params);

      var getterScope = scope;
      var transclusionScope;

      transclude(function(clone, scope) {
        element.append(clone);
        $compile(element.contents())(getterScope);
        transclusionScope = scope;
      });

      scope.scrollToElement = function() {
        $location.hash('topAnchor');
        $anchorScroll();
      };

      scope.$watch('getter.params', function(newValue) {
        cmsSvc.callDeferedGetterMethod({
          moduleName: scope.moduleName,
          methodName: scope.methodName,
          params: newValue
        }, function(data) {
          transclusionScope.data = data;
          scope.getter.data = data;
        });
      }, true);
    }
  };
}])
.
/* global google */

directive('greenhouseLocationContext', function() {
	return {
		require: 'ngModel',
		scope: {
			latitude: '=?',
			longitude: '=?'
		},
        
		link: function(scope, element, attrs, model) {

			var options = {
				types: [],
				componentRestrictions: { country: "us" },
				fields: ['address_components', 'geometry', 'place_id']
			};

			scope.gPlace = new google.maps.places.Autocomplete(element[0], options);

			google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
				var geoComponents = scope.gPlace.getPlace();
				var latitude = geoComponents.geometry.location.lat();
				var longitude = geoComponents.geometry.location.lng();
				var addressComponents = geoComponents.address_components;

				addressComponents.latitude = latitude;
				addressComponents.longitude = longitude;

				scope.$apply(function() {
					scope.latitude = latitude;
					scope.longitude = longitude;
					model.$setViewValue(element.val());
				});
			});
		}
	};
}).
directive('inputDate', ['$filter', function($filter) {
  var dateFilter = $filter('date');

  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      parentForm: '='
    },
    link: function(scope, element, attrs, ngModel) {
      var fakeBirthdayYear = 1896;
      var format = 'MM/dd';
      ngModel.$formatters.push(function(value) {
        return dateFilter(value, format);
      });

      scope.$watch(attrs.ngModel, function(val) {
        if (val === undefined || val === null || val === '') {
          setValidity(true);
        } else if (val.length >= format.length) {
          var date = new Date(val);
          if (~val.indexOf('/')) {
            date = new Date(val + '/' + fakeBirthdayYear);
          }
          var dateString = dateFilter(date, format);

          if (date != 'Invalid Date' && (val === dateString || dateFilter(val, format) === dateString)) {
            setValidity(true);
          } else {
            setValidity(false);
          }
        } else {
          setValidity(false);
        }

        function setValidity(value) {
          scope.parentForm.birthday.$setValidity("date", value);
        }
      });
    }
  };
}]).
directive('inverted', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(val) {
        return !val;
      });
      ngModel.$formatters.push(function(val) {
        return !val;
      });
    }
  };
}).
directive('match', function() {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      match: '='
    },
    link: function(scope, elem, attrs, ctrl) {
      scope.$watch(function() {
        return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || scope.match === ctrl.$modelValue;
      }, function(currentValue) {
        ctrl.$setValidity('match', currentValue);
      });
    }
  };
}).
// As many as all sections can be opened at a time
directive('mrAccordion', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: '<div class="mr-accordion" ng-transclude>' +
      '</div>',
    controller: function() {
      var sections = this.sections = {};

      this.toggleSection = function(section, options) {
        options = options || {};
        options.cancelToggle = options.hasOwnProperty('cancelToggle') ? options.cancelToggle : false;

        // If cancelToggle flag option is passed and section is already open, do not toggle
        if (options.cancelToggle && sections[section]) {
          return;
        } else if (!sections[section]) {
          sections[section] = true;
        } else {
          sections[section] = !sections[section];
        }
      };

      this.addSection = function(section) {
        sections[section] = false;
      };
    }
  };
}).
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
 
directive('mrAccountEditSubLeftNav', ['$location', function($location) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-account-edit-sub-left-nav',
    scope: {
       subs: '=',
       orderSubTotal: '=',
       annualSavings: '=',
       user: '='
    },
    link: function(scope) {
      //This is a cancel flag that is used to display alternative content
      //if a user is canceling a subscription
      scope.isCancel = ~$location.$$url.indexOf('cancel');
      //Make sure that subs is in array format
      scope.subsCopy = Array.isArray(scope.subs) ? scope.subs : [scope.subs];
    }
  };
}])
.
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
directive('mrAccountTopNav', [function() {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-account-top-nav',
    scope: {
      backToText: "@",
      backToUrl: "@"
    },
    link: function() {}
  };
}]).
directive('mrAddToCart', ['newCartSvc', function(newCartSvc) {
  return {
    restrict: 'E',
    transclude: true,
    template: '<a class="add-to-cart" ng-transclude ng-click="addToCart()" data-mr-ass="add-to-cart-directive"></a>',
    scope: {
      productId: '=',
      ctaSource: '@'
    },
    link: function(scope, elem) {
      scope.addToCart = function() {
        var payload = {
          product: {
            id: scope.productId
          },
          ctaSource: scope.ctaSource
        };

        newCartSvc.addToCart(payload, function() {
          if (elem.attr('href')) {
            window.location = elem.attr('href');
          } else {
            window.location = '/cart';
          }
        });
      };
    }
  };
}]).
directive('mrAddressInputs', ['$timeout', 'appLookupSvc', 'addressSvc', 'trackerSvc', function($timeout, appLookupSvc, addressSvc, trackerSvc) {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-address-inputs',
    scope: {
      addressForm: '=',
      address: '=',
      blur: '=?',
      showShippingMessage: '@'
    },
    link: function(scope) {
      scope.regions = [];
      scope.addressSvc = addressSvc;
      scope.blur = scope.blur || angular.noop;

      getRegions();
      var zipCheckTimeout;
      var lastZip;

      var errorKeys = {
        fname: 'first name',
        lname: 'last name',
        phone: 'phone number',
        address1: 'address line 1'
      };

      Object.keys(errorKeys).forEach(function(key) {
        scope.$watchCollection('addressForm.' + key, function(input) {
          if (!input) {
            return;
          }

          var dirty = input.$dirty;
          var invalid = input.$invalid;

          if (dirty && invalid) {
            var message = "Invalid " + errorKeys[key];
            trackerSvc.trackEvent('Address Error', {
              message: message
            });
          }
        });
      });

      scope.defferedZipCheck = function(address, input) {
        clearTimeout(zipCheckTimeout);
        zipCheckTimeout = setTimeout(function() {
          scope.zipCheck(address, input);
        }, 100);
      };

      var trackedInvalidZip = false;
      scope.zipCheck = function(address, input) {
        if (!address) {
          return;
        }

        var zip = input.$viewValue;

        if (lastZip == zip) {
          return;
        }

        lastZip = zip;

        if (!zip || zip.length < 5) {
          if (!trackedInvalidZip) {
            trackerSvc.trackEvent('Address Error', {
              message: 'Invalid zip code'
            });
            trackedInvalidZip = true;
          }
          address.validZip = false;
          input.$setValidity('validZip', address.validZip);
          return;
        }

        var payload = {
          zip: zip
        };

        addressSvc.zipCheck(payload, function(res) {
          //- if zipCheck is successful prepopulate city and state
          if (res.city && res.state) {
            address.city = res.city;
            address.region = res.state;
          }

          address.post_code = res.zip;
          address.validZip = true;
          trackedInvalidZip = false;

          input.$setValidity('validZip', address.validZip);
        }, function(err) {
          //- invalid zip code? clear city and state
          if (err.data && err.data.message == 'Invalid Zip Code.') {
            address.city = '';
            address.state = '';
            address.validZip = false;
            if (!trackedInvalidZip) {
              trackerSvc.trackEvent('Address Error', {
                message: 'Invalid zip code'
              });
              trackedInvalidZip = true;
            }
            return;
          }
          //- any other errors should not keep the user from filling out address form
          address.validZip = true;
          input.$setValidity('validZip', address.validZip);
        });
      };

      function getRegions(cb) {
        cb = cb || angular.noop;
        if (scope.regions.length) {
          return cb();
        }

        appLookupSvc.getRegionsByCountry({ country: 'US' }, function(regions) {
          scope.regions = regions;
          cb();
        });
      }
    }
  };
}]).
directive('mrAddressList', ['addressSvc', function(addressSvc) {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-address-list',
    scope: {
      saveCallback: '=?',
      regions: '=?'
    },
    link: function(scope) {
      scope.saveCallback ? scope.saveCallback : angular.noop;
      scope.addressSvc = addressSvc;
    }
  };
}])
.
// used to animate the height of a section based on the height of it's child
// Example:
// .some-element-with-dynamic-height(mr-animate-height open-when='section.open' time='400')
//   .more-dynamic-elements
//   .more-dynamic-elements
//   .more-dynamic-elements
//   .more-dynamic-elements

directive('mrAnimateHeight', ['$timeout', function($timeout) {
  return {
    restrict: 'EA',
    scope: {
      openWhen: '=',
      time: '@'
    },
    link: function(scope, el) {
      scope.time = scope.time || 400;
      el.css('transition', 'height ' + scope.time + 'ms ease-in-out');
      
      scope.$watch(function() {
        if (!el[0].children.length || !scope.openWhen) {
          return 0;
        }
        var totalHeight = 0;

        for (var x = 0; x < el[0].children.length; x++) {
          totalHeight += $(el[0].children[x]).outerHeight();
        }

        return totalHeight;
      }, function(newValue) {
        el.css('height', newValue + 'px');
        
        if (newValue == 0) {
          el.css('overflow', 'hidden');
        } else {
          $timeout(function() {
            if (scope.openWhen) {
              el.css('overflow', 'visible');
            }
          }, scope.time);
        }
      });
    }
  };
}])
.
directive('mrAutoFocus', function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.focus();
    }
  };
}).
directive('mrBlogCarousel', [function() {
  return {
    templateUrl: '/ngpartials/directives/blog-carousel',
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      blogPosts: '@'
    },
    link: function(scope) {
      scope.posts = JSON.parse(scope.blogPosts);
      scope.limit = scope.limit || scope.posts.length;
      scope.posts.forEach(function(post) {
        post.mainTag = post.tags[0] || 'madison reed';
      });
      scope.selected = scope.posts[0];
      scope.selectedPost = {
        0: true,
        1: false,
        2: false,
        3: false
      };

      var count = 1;
      var t = setInterval(animatePostImages, 5000);

      scope.selectPost = function(post) {
        scope.selected = post;
      };

      scope.stopTransitions = function() {
        clearInterval(t);
      };

      scope.hover = function(index) {
        scope.selected = scope.posts[index];
        Object.keys(scope.selectedPost).forEach(function(key) {
          scope.selectedPost[key] = false;
        });
        scope.selectedPost[index] = true;
        clearInterval(t);
      };

      function animatePostImages() {
        if (count == 3) {
          clearInterval(t);
        }
        scope.selected = scope.posts[count];
        Object.keys(scope.selectedPost).forEach(function(key) {
          scope.selectedPost[key] = false;
        });
        scope.selectedPost[count] = true;
        scope.$apply();
        count++;
      }
    }
  };
}]).
directive('mrCalendar', ['colorBarSvc', function(colorBarSvc) {
  return {
    templateUrl: '/ngpartials/directives/mr-calendar',
    restrict: 'E',
    scope: {
      dates: '=',
      getDatesForMonth: '=',
      getTimesForSelectedDate: '=',
      control: '=',
      location: '=',
      editDate: '=',
      firstCalendarLoad: '=',
      calOpen: '=',
      mobile: '='
    },

    link: function(scope) {
      var calendarBoxes = 42;
      var firstIndex;
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var firstCalendarDate = new Date();
      var currentMonth = firstCalendarDate.getMonth();
      var currentYear = firstCalendarDate.getFullYear();
      var selectedMonth = currentMonth;
      var selectedYear = currentYear;

      scope.loadEditMonth = true;
      scope.calendarDays = [];
      scope.currentMonth = currentMonth;
      scope.currentYear = currentYear;
      scope.futureMonthLimit = new Date(new Date(firstCalendarDate).setDate(firstCalendarDate.getDate() + scope.dates.maxDaysInAdvance)).getMonth();
      scope.futureYearLimit = new Date(new Date(firstCalendarDate).setDate(firstCalendarDate.getDate() + scope.dates.maxDaysInAdvance)).getFullYear();

      if (scope.control) {
        scope.control.redraw = drawCalendar;
      }

      //------- Functions
      function drawCalendar() {
        // Code to be executed only when the calendar is presented the first time, which will show first available dates.
        if (Object.keys(scope.dates.available).length !== 0 && scope.firstCalendarLoad) {
          firstIndex = Object.keys(scope.dates.available)[0];
          firstCalendarDate = colorBarSvc.fromCalDate(scope.dates.available[firstIndex].calDate);
          selectedMonth = firstCalendarDate.getMonth();
          selectedYear = firstCalendarDate.getFullYear();
          scope.currentMonth = currentMonth;
          scope.currentYear = currentYear;
          scope.futureMonthLimit = new Date(new Date(firstCalendarDate).setDate(firstCalendarDate.getDate() + scope.dates.maxDaysInAdvance)).getMonth();
          scope.futureYearLimit = new Date(new Date(firstCalendarDate).setDate(firstCalendarDate.getDate() + scope.dates.maxDaysInAdvance)).getFullYear();
        }

        var currentCal = {
          month: selectedMonth,
          year: selectedYear,
          calendarDays: new Date(selectedYear, (selectedMonth + 1), 0).getDate(),
          firstDay: new Date(selectedYear, (selectedMonth), 1).getDay() + 1,
          lastDay: new Date(selectedYear, (selectedMonth + 1), 0).getDay() + 1
        };

        scope.selectedMonth = selectedMonth;
        scope.selectedYear = selectedYear;
        scope.selectedMonthText = months[selectedMonth];

        var newDays = [];
        var monthDay = 1;
        for (var i = 1; i <= calendarBoxes; i++) {
          if (i / currentCal.firstDay < 1) {
            newDays.push({
              day: -1,
              open: false,
              available: false,
              month: selectedMonth,
              year: selectedYear
            });
          } else if (monthDay > currentCal.calendarDays) {
            newDays.push({
              day: -1,
              open: false,
              available: false,
              month: selectedMonth,
              year: selectedYear
            });
          } else {
            var obj = scope.dates.available[monthDay];
            if (!obj) {
              obj = {
                open: false,
                available: false
              };
            }
            obj.day = monthDay;
            obj.month = selectedMonth;
            obj.year = selectedYear;

            newDays.push(obj);
            monthDay++;
          }
        }

        scope.calendarDays = newDays;

        // If an appointment is being edited, jump to the month of that appointment when the calendar loads
        if (scope.editDate && scope.loadEditMonth) {
          scope.loadEditMonth = false;

          var editDate = new Date(scope.editDate);
          var editMonth = editDate.getMonth();
          var target = editMonth - selectedMonth;

          if (target < 0) {
            target = target + 12;
          }

          if (target) {
            scope.nextMonth(target);
          }
        }
      }

      scope.previousMonth = function() {
        if (selectedYear == currentYear && selectedMonth == currentMonth) {
          return;
        }

        var startDate = new Date(selectedYear, selectedMonth - 1, 1);
        selectedMonth = startDate.getMonth();
        selectedYear = startDate.getFullYear();
        var endDate = new Date(selectedYear, selectedMonth + 1, 0);
        var daysInMonth = endDate.getDate();

        scope.getDatesForMonth(startDate, endDate, daysInMonth);
      };

      scope.nextMonth = function(target) {
        if (!target) {
          target = 1;
        }

        if (selectedYear == scope.futureYearLimit && selectedMonth == scope.futureMonthLimit) {
          return;
        }

        var startDate = new Date(selectedYear, selectedMonth + target, 1);
        selectedMonth = startDate.getMonth();
        selectedYear = startDate.getFullYear();
        var endDate = new Date(selectedYear, selectedMonth + 1, 0);
        var daysInMonth = endDate.getDate();

        scope.getDatesForMonth(startDate, endDate, daysInMonth);
      };

      scope.handleCalOpen = function() {
        if (scope.mobile) {
          scope.calOpen = false;
        }
      };

      scope.getCalendarClass = function(box, index, dates) {
        var waitlist = box.waitlistEligible;

        var classes = [box.open ? 'open' : 'closed', box.available || (box.open && waitlist) ? 'available' : 'unavailable'];

        if (box.waitlistOnly) {
          classes.push('waitlist');
        }

        if (dates.selected && box.calDate == dates.selected.calDate) {
          classes.push('selected');
        }

        return classes;
      };

      drawCalendar();
    }
  };
}]).
directive('mrCarousel', [function() {
  return {
    templateUrl: '/ngpartials/directives/carousel',
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      images: '=',
      limit: '=?'
    },
    link: function(scope) {
      scope.limit = scope.limit || scope.images.length;

      scope.$watch('images', function() {
        scope.selected = scope.images[0];
      });

      scope.moveLeft = function() {
        var img = scope.images[scope.images.indexOf(scope.selected) - 1];
        if (scope.images.indexOf(img) !== -1) {
          scope.selected = img;
        } else {
          scope.selected = scope.images[scope.images.length - 1];
        }
      };

      scope.moveRight = function() {
        var img = scope.images[scope.images.indexOf(scope.selected) + 1];
        if (scope.images.indexOf(img) !== -1) {
          scope.selected = img;
        } else {
          scope.selected = scope.images[0];
        }
      };

      scope.selectImage = function(image) {
        scope.selected = image;
      };
    }
  };
}]).
directive('mrCartTimer', ['$interval', 'dateFilter', function($interval, dateFilter) {
  // This directive takes two attributes: time to the countdown and a
  // callback that should be executed when timer is finished
  function link(scope, element) {
    var timeOutRange;
    var timer;
    var timerDate;
    var counter;
    scope.twoMinsLeft = false;

    scope.$watch('reservedTime', function(value) {
      timer = value;
      $interval.cancel(counter);
      timeOutRange = new Date(timer) - new Date();

      counter = $interval(function() {
        if (timer && timeOutRange > 1000) {
          updateTimer();
        } else {
          $interval.cancel(counter);
          scope.timerCallback();
        }
      }, 1000);
    });

    scope.cancel = function() {
      $interval.cancel(counter);
    };

    function updateTimer() {
      timeOutRange = new Date(timer) - new Date();
      if (timeOutRange < 120 * 1000) {
        scope.twoMinsLeft = true;
      }

      timerDate = new Date(timeOutRange);
      scope.timeLeft = dateFilter(timerDate, 'mm:ss');
    }

    element.on('$destroy', function() {
      $interval.cancel(counter);
    });
  }

  return {
    template: '<div class="mr-cart-timer">' +
      '<span>Expires in:&nbsp;</span>' +
      '<span ng-class="{redTimer: twoMinsLeft }">{{timeLeft}}</span>' +
      '</div>',
    link: link,
    replace: true,
    scope: {
      timerCallback: '=',
      reservedTime: '=',
      cancel: '='
    }
  };
}]).
directive('mrCompile', ['$compile', function ($compile) {
  return function(scope, element, attrs) {
    var ensureCompileRunsOnce = scope.$watch(function(scope) {
        // watch the 'compile' expression for changes
        return scope.$eval(attrs.mrCompile);
      }, function(value) {
        // when the 'compile' expression changes
        // assign it into the current DOM
        element.html(value);

        // compile the new DOM and link it to the current
        // scope.
        // NOTE: we only compile .childNodes so that
        // we don't get into infinite loop compiling ourselves
        $compile(element.contents())(scope);

        // Use Angular's un-watch feature to ensure compilation only happens once.
        ensureCompileRunsOnce();
      }
    );
  };
}])
.
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
directive('mrConfirmationBtns', [function() {
    return {
      restrict: 'E',
      templateUrl: function(tElement, tAttrs) {
        var template = '/ngpartials/directives/mr-confirmation-btns';
        if (tAttrs.layout) {
          if (tAttrs.layout == 'sideBySide') {
            template = '/ngpartials/directives/mr-buttons-side-by-side';
          } else if (tAttrs.layout == 'stacked') {
            template = '/ngpartials/directives/mr-buttons-stacked';
          }
        }
        return template;
      },
      scope: {
        btnSaveText: '@?',
        btnSaveDisabledFlag: '=?',
        btnSaveMethod: '&',
        btnCancelText: '@?',
        btnCancelDisabledFlag: '=?',
        btnCancelShowFlag: '=?',
        btnCancelMethod: '&',
        leftAlign: '@',
        layout: '=?',
        hideCancel: '=?'
      },
      link: function(scope, element, attrs) {
        // Always show cancel button by default
        scope.btnCancelText = scope.btnCancelText ? scope.btnCancelText : 'Nevermind';
        scope.btnSaveText = scope.btnSaveText ? scope.btnSaveText : 'Save Changes';
        scope.btnCancelShowFlag = angular.isUndefined(scope.btnCancelShowFlag) ? true : scope.btnCancelShowFlag;
        scope.showCancel = true;
        scope.fixedWidth = false;

        if (attrs.hasOwnProperty('hideCancel')) {
          scope.showCancel = false;
        }

        if (attrs.hasOwnProperty('fixedWidth')) {
          scope.fixedWidth = true;
        }

        scope.hideKeyboard = function() {
          var textField = document.activeElement;
          textField.blur();
        };
      }
   };
}])
.
directive('mrContactPhone', ['$rootScope', function($rootScope) {
  return {
    restrict: 'E',
    template: '<a href="tel: {{phone}}" target="_self">{{ formatedPhone }}</a>',
    link: function(scope) {
      scope.phone = $rootScope.mrContactPhone;
      scope.formatedPhone = $rootScope.mrContactPhone.toString().replace(/-/g, '.');
    }
  };
}])

.
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
directive('mrCreditCardInputs', ['mrNgUtils', 'paymentProfileSvc', 'trackerSvc', function(mrNgUtils, paymentProfileSvc, trackerSvc) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-credit-card-inputs',
    scope: {
      billingForm: '=',
      billing: '=',
      blur: '=?',
      shippingAddress: '=',
      forBooking: '@',
      cdata: '=?'
    },
    link: function(scope) {
      scope.paymentProfileSvc = paymentProfileSvc;
      scope.blur = scope.blur || angular.noop;
      scope.ccType = 'default';
      scope.ccCvLength = paymentProfileSvc.ccTypes.default.cvc;
      scope.ccLength = paymentProfileSvc.ccTypes.default.formSize;
      scope.ccMask = paymentProfileSvc.ccTypes.default.mask;
      scope.cvvRegex = new RegExp('[0-9]{' + paymentProfileSvc.ccTypes.default.cvc + '}');
      scope.ccStandInType = 'Credit Card';
      scope.ccStandIn = '************0000';
      scope.settings = {
        showCvc: false,
        showLockMessage: false
      };
      paymentProfileSvc.billingForm = scope.billingForm;

      // Prevent scope.billing from becoming undefined on page reload.
      if (!scope.billing) {
        scope.billing = paymentProfileSvc.profileInEdit;
      }

      if (!scope.billing.address) {
        scope.billing.address = {};
      }

      var errorKeys = {
        cardNumber: 'credit card number',
        ccExpMonthYear: 'expiration date',
        cvc: 'CVV',
      };

      Object.keys(errorKeys).forEach(function(key) {
        scope.$watchCollection('billingForm.' + key, function(input) {
          if (!input) {
            return;
          }

          var dirty = input.$dirty;
          var invalid = input.$invalid;

          if (dirty && invalid) {
            var message = "Invalid " + errorKeys[key];
            trackerSvc.trackEvent('Credit Card Input Error', {
              message: message
            });
          }
        });
      });

      scope.now = new Date(Date.now());
      scope.cc_months = [];
      scope.cc_years = [];
      var currYear = scope.now.getFullYear();
      var lastCCNumber;

      for (var i = 1; i < 13; i++) {
        var m = {};
        m.val = i;
        m.key = i < 10 ? '0' + i : i.toString();
        scope.cc_months.push(m);
      }

      for (var y = currYear; y < currYear + 20; y++) {
        scope.cc_years.push(y);
      }

      if (!scope.shippingAddress || !scope.shippingAddress.id) {
        scope.billing.same_as_shipping = false;
      }

      scope.checkCard = function($event) {
        var num = scope.billing.cc_number;
        var key;
        if ($event && mrNgUtils.specialKey($event)) {
          return;
        }

        if (num == lastCCNumber) {
          scope.ccCvLength = paymentProfileSvc.ccTypes.default.cvc;
          scope.ccLength = paymentProfileSvc.ccTypes.default.formSize;
          scope.ccMask = paymentProfileSvc.ccTypes.default.mask;
          return;
        }

        if (num) {
          for (key in paymentProfileSvc.ccTypes) {
            if (paymentProfileSvc.ccTypes[key].regex.test(num)) {
              scope.ccType = key;
              scope.ccCvLength = paymentProfileSvc.ccTypes[key].cvc;
              scope.cvvRegex = new RegExp('[0-9]{' + scope.ccCvLength + '}');
              scope.ccLength = paymentProfileSvc.ccTypes[key].formSize;
              scope.ccMask = paymentProfileSvc.ccTypes[key].mask;
              scope.cvcMask = paymentProfileSvc.ccTypes[key].cvcMask;

              var valid = num.replace(/\D/g, '').length == paymentProfileSvc.ccTypes[key].size && paymentProfileSvc.mod10Check(num);
              scope.billingForm.cardNumber.$setValidity('cardNumber', valid);
              if (valid) {
                scope.blur();
              }
              lastCCNumber = num;
              return;
            }
          }
        } else {
          scope.ccType = 'default';
          scope.ccCvLength = paymentProfileSvc.ccTypes.default.cvc;
          scope.ccLength = paymentProfileSvc.ccTypes.default.formSize;
          scope.ccMask = paymentProfileSvc.ccTypes.default.mask;
          lastCCNumber = num;
        }
      };

      scope.checkMonthYear = function($event) {
        if ($event && mrNgUtils.specialKey($event)) {
          return;
        }
        var validMonth = true;
        var currentMonth = scope.now.getMonth() + 1;
        var currentYear = scope.now.getFullYear();

        if (scope.billing.cc_exp_year === currentYear) {
          validMonth = false;
          if (scope.billing.cc_exp_month >= currentMonth) {
            validMonth = true;
          }
        }
        scope.billingForm.ccmonth.$setValidity('ccmonth', validMonth);
      };
    }
  };
}]).
// As many as all sections can be opened at a time
directive('mrDropdown', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    require: 'ngModel',
    template: '<div class="mr-dropdown" ng-class="{open: open}">' +
    '<div class="selected-item", ng-click="toggleDropDown()">' +
    '{{selectedHeader}}<span class="arrow" ng-class="{\'icon-caret-down\': !open, \'icon-caret-up\': open}"></span>' +
    '</div>' +
    '<div class="mr-dropdown-items" ng-show="open" ng-transclude></div>' +
    '</div>',
    scope: {
      ngModel: '=',
      defaultHeader: '@'
    },
    controller: function($scope) {
      $scope.selectedHeader = $scope.defaultHeader;
      $scope.dropDowns = this.dropDowns = {};
      $scope.open = false;

      $scope.toggleDropDown = function() {
        $scope.open = !$scope.open;
        if ($scope.open) {
          $scope.selectedHeader = $scope.defaultHeader;
        }
      };

      this.changeModel = function(header) {
        var dropDown = $scope.dropDowns[header];
        dropDown.selected = true;
        $scope.selectedHeader = dropDown.header;
        $scope.ngModel = dropDown.value;
        $scope.open = false;
      };

      this.addItem = function(header, value, element) {
        $scope.dropDowns[header] = {
          element: element,
          value: value,
          header: header,
          selected: false
        };
      };
    }
  };
})
.
/*
This directive handles the email gate that appears in the hair-color recommendation page to new customers.
 */
directive('mrEmailGate', ['customerSvc', function(customerSvc) {
  return {
    templateUrl: '/ngpartials/directives/mr-email-gate',
    replace: true,
    restrict: 'E',
    link: function(scope, element) {
      //////////////////////////////////
      // Initialization
      //////////////////////////////////
      scope.email = "";

      //////////////////////////////////
      // Scope variables
      //////////////////////////////////
      scope.hideGate = function() {
        var noOp = function() {};
        element.hide();
        customerSvc.disableEmailGate({}, noOp);
      };

      scope.addEmail = function() {
        var params = {
          email: scope.email,
          email_source: 'quiz_email_gate'
        };

        customerSvc.createCustomer(params, function() {
          element.hide();
        });
      };
    }
  };
}]).
/*
This directive needs to be in a container
For example:
.sm-hide.md-hide.lg-hide
    !{components.fixedCtaScroll}
 */
directive('mrFixedSection', [function() {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-fixed-section',
    transclude: true,
    scope: {
      extraOffset: '@',
      useScreenTop: '@'
    },
    link: function(scope) {
      var stopElement = $('.stop-element');
      var fixedElement = $('.fixed-element');
      //Add extra offset to prevent scroll from passing element on mobile device
      var windowScrollTop = null;
      var windowBottom = null;
      var windowHeight = $(window).height();
      var elementTop = stopElement.offset().top - scope.extraOffset;
      var useTop = scope.useScreenTop || false;

      // Default to fixed
      scope.isFixed = true;

      // Add scroll event listener
      $(window).scroll(function() {
        windowHeight = $(window).height();
        elementTop = stopElement.offset().top - scope.extraOffset;
        scope.extraOffset = +scope.extraOffset ? +scope.extraOffset : 0;
        windowScrollTop = $(this).scrollTop() + fixedElement.outerHeight();
        windowBottom = windowScrollTop;
        if (!useTop) {
          windowBottom = windowBottom + windowHeight;
        }

        var fixIt = !(windowBottom > elementTop);

        if (fixIt === scope.isFixed) {
          return;
        }

        if (fixIt) {
          scope.$apply(function() {
            scope.isFixed = true;
          });
        } else {
          scope.$apply(function() {
            scope.isFixed = false;
          });
        }
      });
    }
  };
}]).
/*
 * Adds a class to an element when the top of the element scroll past the top of
 * the view port.
 *
 *
 * Example:
 * *.jade
 *   mr-fixed-wrap(fixed-class='fixed' stop-class='stopped' stop-at-element-selector='footer')
 *     .the-element-to-be-fixed
 *
 * *.styl
 *   mr-fixed-wrap
 *     &.fixed
 *       .the-element-to-be-fixed
 *         position fixed
 *         top 0
 *         left 0
 *         right 0
 */

directive('mrFixedWrap', [function() {
  return {
    restrict: 'EA',
    scope: {
      fixedClass: '@', // class to be applied when the element should become fixed
      stopClass: '@', // class to be applied when the element stops
      stopAtElementSelector: '@', // selector for the element to stop at
      // when true, the fixedClass will be applied when the bottom of the
      // element scrolls into the view port
      // use when element is initially below the fold
      useScreenBottom: '=',
      // when you want to disable the cta fixing when based on a boolean
      // variable on the scope (such as when a modal is open). Use in
      // conjunction with `$rootScope.isModalOpen`. Modals should use
      // setIsModalOpen when closing or opening
      disableSticky: '=',
      triggerFixedCta: '@'
    },
    link: function(scope, element) {
      var isFixed = false;
      var isStopped = false;


      scope.$on('windowScroll', function(event, windowData) {
        fixIt(windowData.scrollTop, windowData.scrollBottom, windowData);
      });

      function fixIt(windowScrollTop, windowScrollBottom, windowData) {
        var elementTop = element.offset().top;
        var elementBottom = elementTop + element.height();

        function isPassedThreshold() {
          // when top of element scrolls above view port
          var pos = elementTop;
          var threshold = windowScrollTop;
          if (scope.useScreenBottom) {
            // when bottom of element scrolls into the view port
            pos = elementBottom;
            threshold = windowScrollBottom;
          }
          return pos <= threshold;
        }

        if (!isFixed && isPassedThreshold() && !scope.disableSticky) {
          isFixed = true;
          element.addClass(scope.fixedClass);
          if (scope.triggerFixedCta) {
            scope.$emit('fixedCTAOn');
          }
        } else if (isFixed && !isPassedThreshold()) {
          isFixed = false;
          element.removeClass(scope.fixedClass);
          if (scope.triggerFixedCta) {
            scope.$emit('fixedCTAOff');
          }
        }


        if (scope.stopAtElementSelector && $(scope.stopAtElementSelector).length) {
          var stopAtHeight = $(scope.stopAtElementSelector).offset().top - $(window).height();

          if (stopAtHeight > 0 && windowScrollTop >= stopAtHeight && !isStopped) {
            isStopped = true;
            element.addClass(scope.stopClass);
          } else if (stopAtHeight > 0 && windowScrollTop < stopAtHeight && isStopped) {
            isStopped = false;
            element.removeClass(scope.stopClass);
          }
        }
        windowData.fixedCTA = isFixed && !isStopped;
        scope.$apply();
      }
    }
  };
}]).
/**
* Simple directive for playing/pausing videos on/off hover
*/

directive('mrHoverVideo', ['trackerSvc', function(trackerSvc) {
  return {
    restrict: 'A',
    scope: {
      control: '='
    },
    link: function(scope, element, attrs) {
      scope.control = scope.control || {};
      scope.control.playing = false;

      element.hover(function() {
        scope.control.playing = true;
        trackerSvc.trackEvent('Video Played', {src: attrs.src});
        element.get(0).play();
        scope.$apply();
      }, function() {
        scope.control.playing = false;
        trackerSvc.trackEvent('Video Paused', {src: attrs.src});
        element.get(0).pause();
        scope.$apply();
      });

      element.on("touchstart", function() {
        trackerSvc.trackEvent('Video Played', {src: attrs.src});
        scope.control.playing = true;
        element.get(0).play();
        scope.$apply();
      });
    }
  };
}])
.
directive('mrIframeModal', ['$sce', function($sce) {
  return {
    restrict: 'AE',
    scope: {
      url: '@',
      show: '=?'
    },
    templateUrl: '/ngpartials/directives/mr-iframe-modal',
    link: function(scope) {
      scope.iframeModal = {
        show: scope.show
      };

      scope.trustedUrl = $sce.trustAsResourceUrl(scope.url);
    }
  };
}]).
directive('mrInputCalendarDate', [function() {
  return {
    replace: true,
    require: '?ngModel',
    restrict: 'E',
    template: '<div class="mr-input-calendar-date">' +
      '<input type="text" ui-date="dateOptions" ng-model="ngModel" ng-change="onChangeMethod" />' +
      '<div class="calendar" ng-click="showDatePicker()">' +
      '<i class="icon-calendar xs-font-xgrande"><span class="ada-tooltip">calendar icons</span></i>' +
      '</div>' +
      '</div>',
    scope: {
      uiDate: '=',
      onChangeMethod: '=',
      ngModel: '=',
      dateOptions: '='
    },
    link: function(scope, elem) {
      scope.showDatePicker = function() {
        setTimeout(function() {
          angular.element(elem).datepicker('show');
        }, 1); //- Needs timeout or it will get closed by input element above
      };
    }
  };
}])
.
/*
 Validate two inputs where both values should match
 */
directive('mrInputMatch', ['$parse', function($parse) {
  return {
    require: '?ngModel',
    restrict: 'A',
    link: function(scope, elem, attrs, ctrl) {

      var matchGetter = $parse(attrs.mrInputMatch);
      var caselessGetter = $parse(attrs.matchCaseless);

      scope.$watch(getMatchValue, function(){
        ctrl.$$parseAndValidate();
      });

      ctrl.$validators.match = function(){
        var match = getMatchValue();
        if (caselessGetter(scope) && angular.isString(match) && angular.isString(ctrl.$viewValue)){
          return ctrl.$viewValue.toLowerCase() === match.toLowerCase();
        }
        return ctrl.$viewValue === match;
      };

      function getMatchValue(){
        var match = matchGetter(scope);
        if (angular.isObject(match) && match.hasOwnProperty('$viewValue')){
          match = match.$viewValue;
        }
        return match;
      }
    }
  };
}]).
directive('mrLoader', function() {
  return {
    restrict: 'E',
    replace: true,
    template: '<div ng-show="loading", class="mrloader-container">' +
    '<img src="/images/ajax-loader.gif"/>' +
    '</div>',
    scope: {
      loading: '='
    }
  };
}).
//- remove after mr-mask is removed from cms templates and replaced with ui-mask
directive('mrMask', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      attrs.$observe('usemask', applyMask);

      scope.$watch(function() {
        return ngModel.$modelValue;
      }, function(val) {
        if (val) {
          $timeout(function() {
            element.keyup();
            element.mask(attrs.usemask);
          }, 0);
        }
      });

      applyMask();

      function applyMask() {
        element.mask(attrs.usemask);
      }
    }
  };
}]).
/* global videojs */
/**
 * @module mrMultiVideo
 * @moduleType angular directive
 * @desc This is an angular directive that uses video.js to play videos, with support for pause, play, fullscreen, and changing the video being played.<br>
 *       Example .jade:
 * ```
 * .video-player-wrap(ng-init="myPlayer = { video: { title: 'initialVideoTitle', description: 'initialVideoDescription', code: 'initialVideoCode' }, autoplay: true, aspectRatio: 9/16 }")
 *   video(mr-multi-video control="myPlayer" player-id="myPlayerId" id="myPlayerId")
 *
 * .example-controls(ng-click="myPlayer.playing ? myPlayer.pause() : myPlayer.play()")
 * 
 * .example-change-video(ng-click="myPlayer.changeVideo('newVideoTitle', 'newVideoDescription', 'newVideoCode')")
 * ```
 */

directive('mrMultiVideo', ['$rootScope', 'trackerSvc', function($rootScope, trackerSvc) {
  return {
    restrict: 'A',
    scope: {
      control: '=',
      videoType: '@',
      playerId: '@'
    },
    link: function(scope) {
      $rootScope.mrVideoJsPlayers = $rootScope.mrVideoJsPlayers || [];
      $rootScope.autoPause = false;
      scope.control = scope.control || {}; // the control object lets you control the player from outside this directive
      scope.control.video = scope.control.video || {}; // the video to play
      scope.control.playing = scope.control.playing || false; // true when the video is playing
      scope.control.autoplay = scope.control.autoplay || false; // autoplay the video when ready
      scope.control.fullscreenMode = scope.control.fullscreenMode || false; // plays the video when requesting fullscreen, and pauses when leaving fullscreen
      scope.control.open = scope.control.open || false; // used for open and closed styles
      scope.control.ready = scope.control.ready || false; // true when the player is ready
      var aspectRatio = scope.control.aspectRatio || 9 / 16;
      var playerId = scope.playerId;
      var techOrder = ['youtube'];
      if (scope.videoType == 'mp4') {
        techOrder = ['html5'];
      }
      var playerSource = [];
      if (scope.control.video.code) {
        playerSource.push({
          type: 'video/youtube',
          src: 'https://www.youtube.com/watch?v=' + scope.control.video.code
        });
      } else if (scope.control.video.s3url) {
        playerSource.push({
          type: 'video/mp4',
          src: scope.control.video.s3url
        });
      }

      var player = videojs(playerId, {
        controls: true,
        autoplay: false,
        techOrder: techOrder,
        sources: playerSource,
        youtube: {
          "modestbranding": 1
        }
      }, function() {
        // the video ready calback
        var self = this;

        scope.control.play = function(open) {
          if (open) {
            scope.control.open = true;
          }
          player.play();
        };

        scope.control.pause = function(close) {
          if (close) {
            scope.control.open = false;
          }
          player.pause();
        };

        scope.control.requestFullscreen = function() {
          player.requestFullscreen();
          if (scope.control.fullscreenMode) {
            player.play();
          }
        };

        scope.control.changeVideo = function(title, description, codeOrUrl, open) {
          scope.control.video.title = title;
          scope.control.video.description = description;
          var newSrc = [];
          if (scope.videoType == 'mp4') {
            scope.control.video.s3url = codeOrUrl;
            playerSource = codeOrUrl;
            newSrc.push({
              type: 'video/mp4',
              src: playerSource
            });
          } else {
            scope.control.video.code = codeOrUrl;
            playerSource = 'https://www.youtube.com/watch?v=' + codeOrUrl;
            newSrc.push({
              type: 'video/youtube',
              src: playerSource
            });
          }

          if (open) {
            scope.control.open = true;
          }

          player.src(newSrc);
          player.play();
        };

        $(function() {
          // set up event handling

          self.on('play', function() {
            $rootScope.mrVideoJsPlayers.forEach(function(p) {
              if (p.id_ == playerId) {
                return;
              }

              if (p.paused()) {
                return;
              }

              $rootScope.autoPause = true;
              p.pause();
              $rootScope.autoPause = false;
            });

            if (!scope.control.autoplay) {
              trackerSvc.trackEvent('Video Played', {
                videoTitle: scope.control.video.title,
                videoSrc: playerSource
              });
            }

            scope.control.playing = true;
            scope.control.autoplay = false;
            scope.$apply();
          });

          self.on('fullscreenchange', function() {
            if (!self.isFullscreen()) {
              scope.control.isFullscreen = false;
              scope.$apply();

              if (scope.control.fullscreenMode) {
                player.pause();
              }

              return;
            }
            scope.control.isFullscreen = true;
            scope.$apply();

            if (!scope.control.fullscreenMode) {
              trackerSvc.trackEvent('Video Fullscreen', {
                videoTitle: scope.control.video.title,
                videoSrc: playerSource
              });
            }
          });

          self.on('pause', function() {
            if ($rootScope.autoPause) {
              // dont fire pause events when auto-pausing the video for the user (when multiple videos are playing)
              $rootScope.autoPause = false;
              scope.control.playing = false;
              return;
            }
            scope.control.playing = false;
            if (scope.control.fullscreenMode && player.isFullscreen()) {
              player.exitFullscreen();
              scope.control.isFullscreen = false;
            }
            scope.$apply();
            var pausedDuration = self.currentTime();
            var videoDuration = self.duration();

            trackerSvc.trackEvent('Video Paused', {
              videoTitle: scope.control.video.title,
              videoSrc: playerSource,
              videoPausedAt: +pausedDuration.toFixed(2),
              videoPercentWatched: +((pausedDuration / videoDuration) * 100).toFixed(2)
            });
          });

          self.on('ended', function() {
            scope.control.playing = false;
            scope.$apply();
            trackerSvc.trackEvent('Video Completed', {
              videoTitle: scope.videoTitle,
              videoSrc: playerSource
            });
          });

          self.on('error', function(e) {
            console.log('mr-video-js error:', e);
          });

          player.ready(function() {
            scope.control.ready = true;
            scope.$apply();

            // autoplay handling
            if (scope.control.autoplay) {
              player.play();
              scope.control.playing = true;
              scope.$apply();
            }
          });
        });

        resizeVideo(player);
        $rootScope.mrVideoJsPlayers.push(player);

        function resizeVideo(player) {
          var width = document.getElementById(player.id()).parentElement.offsetWidth;
          player.width(width).height(width * aspectRatio);
        }

        function resizeVideos() {
          $rootScope.mrVideoJsPlayers.forEach(function(player) {
            resizeVideo(player);
          });
        }

        if (!window.onresize) {
          //only assign this once as there can be multiple videos per page
          window.onresize = resizeVideos;
        }
      });
    }
  };
}]).
directive('mrNewsletterSubscription', ['customerSvc', function(customerSvc) {
  //- keeping this directive since its used in cms in various places
  //- this allows it to keep the same template accross all of them. logic currently resides in customerSvc
  return {
    templateUrl: '/ngpartials/directives/mr-newsletter-subscription',
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      source: '@',
      listId: '@',
      buttonText: '@'
    },
    link: function(scope) {
      scope.customerSvc = customerSvc;
    }
  };
}]).
directive('mrPaymentList', ['paymentProfileSvc', 'notifySvc', function(paymentProfileSvc, notifySvc) {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-payment-list',
    scope: {
      saveCallback: '=?',
      billingForm: '=?', //- used in checkout.js
      editUrl:'@',
      forBooking: '@',
      forBookingReview: '@',
      cdata: '=?'
    },
    link: function(scope) {
      function defaultSaveCallback(msg) {
        notifySvc.notify('success', msg);
      }
      scope.saveCallback ? scope.saveCallback : defaultSaveCallback;
      scope.paymentProfileSvc = paymentProfileSvc;
    }
  };
}]).
//- format phone nr from config.support.contact.phone ( 0-000-000-0000 to 0.000.000.0000 )

directive('mrPhone', [function() {
  return {
    restrict: 'A',
    template: '<span>{{ formatedPhone }}</span>',
    scope: {
      phone: '@'
    },
    link: function(scope) {
      scope.formatedPhone = scope.phone.toString().replace(/-/g, '.');
    }
  };
}]).
directive('mrPrice', ['productCatalogSvc', function(productCatalogSvc) {
  function link(scope, element) {
    productCatalogSvc.getProductPrices({ id: scope.productId }, function(prices) {
      var price = scope.subPrice && prices.subPrice ? prices.subPrice : prices.price;
      element.append(' $' + price);
    });
  }
  return {
    link: link,
    restrict: 'A',
    scope: {
      productId: '@',
      subPrice: '@'
    }
  };
}]).
directive('mrPromos', ['promoSvc', 'cdata', function(promoSvc, cdata) {
  return {
    templateUrl: '/ngpartials/directives/mr-promos',
    restrict: 'E',
    scope: {
      promos: '=',
      removeCoupon: '=?'
    },
    link: function(scope, elem, attrs) {
      var flags = ['noHeader'];
      flags.forEach(function(flag) {
        scope[flag] = attrs.hasOwnProperty(flag);
      });
      scope.cdata = cdata;
      scope.inCheckout = ~window.location.pathname.indexOf('/checkout');
    }
  };
}]).
/*
This directive handles the quick look modal that displays additional information for the x-sell items
 */
directive('mrQuickLook', ['$timeout', '$anchorScroll', 'newCartSvc', function($timeout, $anchorScroll, newCartSvc) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-quick-look',
    scope: {
      product: '=',
      promo: '=',
      ctaSource: '@?', //- used for segment tracking to identify from where product was added to cart
      addToBag: '=?',
      isMobile: '=',
      context: '=?',
      index: '=?',
      modalVersion: '=?',
      secondSection: '=?',
      addToString: '@?'
    },
    link: function(scope) {
      scope.addToString = scope.addToString || 'add to bag';
      scope.hideQuickLookByClickingOnX = function() {
        scope.$emit('hideQuickLookEvent');
      };

      scope.hideQuickLookByClickingOnVeil = function($event) {
        if ($event.target.id == 'quick-look-veil') {
          scope.$emit('hideQuickLookEvent');
        }
      };

      scope.$watch('product', function(newProduct) {
        scope.showMedia = false;
        scope.showCarousel = false;

        if (newProduct && newProduct.imagery) {
          if (newProduct.imagery.pdpCarousel && newProduct.imagery.pdpCarousel.length >= 1) {
            scope.showCarousel = true;
          }

          scope.prod = newProduct;

          if (!scope.addToBag) {
            scope.addToBag = function() {
              var product = scope.prod;
              // Add addon to cart
              var payload = {
                product: {
                  id: product.id
                },
                qty: 1,
                ctaSource: {
                  name: formatSourceName(scope.ctaSource)
                }
              };

              if (scope.prod.validOffer) {
                payload.validOffer = scope.prod.validOffer;
              }

              newCartSvc.addToCart(payload, function() {
                window.location.href = "/cart";
              });
            };
          }

          // This timeout is required due to a race condition bug happening in Safari.
          $timeout(function() {
            scope.showMedia = true;
          }, 75);
        }
      });

      // ADDS CROSS-SELL PRODUCT TO CART
      scope.addProdToBag = function() {
        if (scope.avoidCrossSellDoubleClick) {
          return;
        }
        // Flag to disable add to bag button and avoid double clicks
        scope.avoidCrossSellDoubleClick = true;
        var context = scope.context || {};
        var payload = {
          prod: scope.prod,
          context: context,
          idx: scope.index,
          ctaSource: {
            name: formatSourceName(scope.ctaSource),
            index: scope.index
          }
        };

        if (scope.prod.validOffer) {
          payload.validOffer = scope.prod.validOffer;
        }

        scope.addToBag(payload, context);
        scope.$emit('hideQuickLookEvent');
        $anchorScroll('#quick-look-veil');
      };

      // ADDS UPSELL PRODUCT TO CART
      scope.addUpSelledProdToCart = function(prod) {
        if (scope.avoidUpSellDoubleClick) {
          return;
        }
        // Flag to disable add to bag button and avoid double clicks
        scope.avoidUpSellDoubleClick = true;
        var eventData = {
          ctaSource: {
            name: formatSourceName(scope.ctaSource),
            index: scope.index
          },
          prod: prod
        };
        scope.$emit('addUpSelledProdToCart', eventData);
      };

      // ENABLES ADD TO BAG BUTTON AGAIN IN CASE THE XSELL ITEM WAS REMOVED FROM THE CART
      scope.$on('prodAddedToBag', function() {
        scope.avoidCrossSellDoubleClick = false;
      });

      // ENABLES ADD TO BAG BUTTON AGAIN IN CASE THE UPSELLED ITEM WAS REMOVED FROM THE CART
      scope.$on('upSellProdAdded', function() {
        scope.avoidUpSellDoubleClick = false;
      });

      scope.$on('prod_added_to_refill', function() {
        scope.avoidCrossSellDoubleClick = false;
      });

      function formatSourceName(source) {
        return source + scope.modalVersion.charAt(0).toUpperCase() + scope.modalVersion.slice(1);
      }
    }
  };
}]).
directive('mrReviewSection', [function() {
  return {
    require: '^mrAccordion',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="accordion-section", id="{{name}}" ng-class="{open: sections[name]}">' +
    '<a href="" ng-click="toggleSection(name)" ng-class="{\'icon-neg\': sections[name], \'icon-pos\': !sections[name]}">' +
    '<h5>{{header}}</h5>' +
    '<div class="ave">' +
    '<mr-stars rating="reviewAvg"></mr-stars>' +
    '<span>({{reviewCount}})</span>' +
    '</div>' +
    '</a>' +
    '<div class="details">' +
    '<div class="details-wrap review-details">' +
    '<mr-reviews product-id="productId" per-page="perPage" url-key="urlKey"></mr-reviews>' +
    '</div>' +
    '</div>' +
    '</div>',
    scope: {
      header: '@',
      name: '@',
      urlKey: '=',
      productId: '=',
      product: '=',
      reviewInfo: '=',
      perPage: '=?',
      openSection: '=?',
      open: '=?'
    },
    link: function(scope, element, attrs, ctrl) {
      scope.sections = ctrl.sections;
      scope.toggleSection = ctrl.toggleSection;
      scope.openSection = ctrl.toggleSection.bind(ctrl, scope.name);
      scope.reviewAvg = 0;
      scope.reviewCount = 0;

      scope.toggleSection(scope.name);
      
      scope.$watch('reviewInfo.productId', function(info) {
        if (info) {
          scope.reviewAvg = scope.reviewInfo.average;
          scope.reviewCount = scope.reviewInfo.count;
        }
      });
    }
  };
}]).
/*
This directive handles the product reviews widget found in the pdp page
 */
directive('mrReviews', ['$location', 'contentSvc', 'reviewSvc', function($location, contentSvc, reviewSvc) {
  return {
    replace: true,
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr_reviews',
    scope: {
      productId: '=',
      productName: '=',
      urlKey: '=',
      perPage: '=?',
      sortBy: '@'
    },
    link: function(scope) {
      scope.reviews = [];
      scope.reviewAverage = 0;
      scope.reviewCount = 0;
      scope.startPage = 1;
      scope.perPage = scope.perPage ? scope.perPage : 2;
      scope.reviewSortByConstants = {};
      scope.sortByOptions = [];

      scope.nextUrl = null;
      scope.prevUrl = null;
      scope.sortingBy = null;
      scope.canReview = true;

      reviewSvc.getSortByConstants(function(res) {
        scope.reviewSortByConstants = res;
        
        scope.sortByOptions = [
          { value: scope.reviewSortByConstants.NEWEST, label: 'DATE (Recent - Oldest)' },
          { value: scope.reviewSortByConstants.OLDEST, label: 'DATE (Oldest - Recent)' },
          { value: scope.reviewSortByConstants.HIGHEST, label: 'RATING (Highest - Lowest)' },
          { value: scope.reviewSortByConstants.LOWEST, label: 'RATING (Lowest - Highest)' },
          { value: scope.reviewSortByConstants.HELPFUL, label: 'MOST HELPFUL' }
        ];

        if (scope.sortBy) {
          scope.sortByOptions.forEach(function(option) {
            if (scope.sortBy == option.value) {
              scope.sortingBy = option.value;
            }
          });
        }
      });

      var params = $location.search();
      //- when reviews params is present ensure its a valid number and set page
      if (!isNaN(+params.reviews)) {
        scope.startPage = params.reviews;
      }

      contentSvc.canUserReview({
        product_id: scope.productId
      }, function(result) {
        scope.canReview = result.canReview;
      });

      getReviews(scope.startPage);

      scope.$watch('sortingBy', function(val) {
        if (val == null) {
          return;
        }

        getReviews(1, val);
      });

      function getReviews(page, sortingBy) {
        if (!scope.productId) {
          return;
        }

        var payload = {
          product_id: scope.productId,
          items_per_page: scope.perPage,
          start_page: page,
        };
        if (sortingBy != undefined && sortingBy != null) {
          payload.sort_by = sortingBy;
        } else {
          //- sorted by most helpful by default for SEO reasons
          payload.sort_by = 'helpful';
        }

        contentSvc.getProductReviews(payload, function(result) {
          scope.reviewAverage = result.average;
          scope.reviewCount = result.total_count;
          scope.numPages = Math.ceil(scope.reviewCount / scope.perPage);
          scope.reviews = result.reviews;
          scope.startPage = result.page;
          handlePaginationSEO(scope.startPage, scope.numPages);
        });
      }

      function handlePaginationSEO(currentPage, totalPages) {
        var loc = window.location;
        var baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
        var thisUrl = baseUrl;

        if (currentPage !== 1) {
          thisUrl += '?reviews=' + currentPage;
        }

        scope.prevUrl = currentPage === 1 ? '' : currentPage === 2 ? baseUrl : baseUrl + '?reviews=' + (currentPage - 1);
        scope.nextUrl = currentPage < totalPages ? baseUrl + '?reviews=' + (currentPage + 1) : '';

        $('link[rel=canonical]').attr('href', thisUrl);

        var prevLink = $('link[rel=prev]');

        if (scope.prevUrl) {
          if (prevLink.length) {
            prevLink.attr('href', scope.prevUrl);
          } else {
            $('head').append('<link rel="prev" href="' + scope.prevUrl + '" />');
          }
        } else if (prevLink.length) {
          prevLink.remove();
        }

        var nextLink = $('link[rel=next]');
        if (scope.nextUrl) {
          if (nextLink.length) {
            nextLink.attr('href', scope.nextUrl);
          } else {
            $('head').append('<link rel="next" href="' + scope.nextUrl + '" />');
          }
        } else {
          nextLink.remove();
        }
      }

      scope.$on("$locationChangeSuccess", function() {
        var page = $location.search().reviews;
        scope.startPage = page ? page : 1;
        getReviews(scope.startPage, scope.sortingBy);
      });

      function sendHelpful(rev, helpful) {
        rev.voted = true;
        var payload = {
          helpful: helpful,
          reviewId: rev.id,
          productId: scope.productId
        };
        contentSvc.voteForReview(payload);
      }

      scope.reviewHelpful = function(rev) {
        sendHelpful(rev, true);
      };

      scope.reviewUnhelpful = function(rev) {
        sendHelpful(rev, false);
      };
    }
  };
}]).
// used to animate the height of a section based on the height of it's child
// Example:
// .some-element-with-dynamic-height(mr-animate-height open-when='section.open' time='400')
//   .more-dynamic-elements
//   .more-dynamic-elements
//   .more-dynamic-elements
//   .more-dynamic-elements

directive('mrRollerWindow', function() {
  return {
    restrict: 'EA',
    scope: {
      openWhen: '='
    },
    link: function(scope, el) {
      scope.$watch(function() {
        return scope.openWhen;
      }, function(open) {
        var contentHeight = 0;

        if (open) {
          for (var x = 0; x < el[0].children.length; x++) {
            contentHeight += el[0].children[x].offsetHeight;
          }
          el.css('overflow', 'visible');
        } else {
          el.css('overflow', 'hidden');
        }

        if (contentHeight == el.height()) {
          return;
        }

        const rule = contentHeight > el.height()? 'ease-in 225ms': 'ease-out 195ms'; 
        el.css('transition', 'height ' + rule);
        el.css('height', contentHeight + 'px');
      });
    }
  };
})
.
// used to gather info about the scroll state of a div

directive('mrScrollInfo', [function() {
  return {
    restrict: 'A',
    scope: {
      scrollInfo: '='
    },
    link: function(scope, element) {
      scope.scrollInfo.scrollTop = element.scrollTop();
      scope.scrollInfo.scrollDirection = 0;
      scope.scrollInfo.scrolled = false;
      scope.interval = setInterval(scrollInfoWatcher, 250);
      function scrollInfoWatcher() {
        var oldScrollTop = scope.scrollInfo.scrollTop;
        scope.scrollInfo.scrollTop = element.scrollTop();
        if (oldScrollTop != scope.scrollInfo.scrollTop) {
          scope.scrollInfo.scrolled = true;
          if (oldScrollTop < scope.scrollInfo.scrollTop) {
            scope.scrollInfo.scrollDirection = 1;
          } else {
            scope.scrollInfo.scrollDirection = -1;
          }
        }
        scope.$apply();
      }
    }
  };
}])
.
directive('mrScrollTimePicker', ['trackerSvc', function(trackerSvc) {
  return {
    templateUrl: '/ngpartials/directives/mr-scroll-time-picker',
    restrict: 'E',
    scope: {
      times: '=',
      date: '=',
      selectTime: '=',
      location: '=',
      showWaitlistModal: '=',
      waitlistPhone: '='
    },
    link: function(scope) {
      scope.beforeNoon = function(time) {
        return time.indexOf('am') > -1;
      };

      scope.trackWaitlistClickEvent = function(eventName, location) {
        trackColorBarBookingEvent(eventName + ' - ' + location.name);
      };

      scope.trackPhoneClickEvent = function(eventName, location) {
        document.location.href = 'tel:' + location.phone;
        trackColorBarBookingEvent(eventName + ' - ' + location.name);
      };

      scope.trackMorningAfternoonClickEvent = function(eventType) {
        var eventName = 'Clicked ' + eventType;
        trackColorBarBookingEvent(eventName);
      };

      function trackColorBarBookingEvent(event) {
        var eventName = 'Color Bar Booking';
        event = event.replace('Color Bar Booking: ', ''); // Backwards compatibility
        trackerSvc.trackEvent(eventName, {
          source: event
        });
      }

      $('.big-time-picker .shift-table').css('min-height', $('.date-time-picker').height() - $('.big-time-picker .shift-select').outerHeight());

      scope.shift = 'pm';
      scope.disableAM = true;
      scope.disablePM = true;

      for (var key in scope.times.available) {
        var slot = scope.times.available[key];
        if (slot.hasOwnProperty('time') && slot.time.indexOf('am') > -1) {
          scope.disableAM = false;
          scope.shift = 'am';
        }
        if (slot.hasOwnProperty('time') && slot.time.indexOf('pm') > -1) {
          scope.disablePM = false;
        }
      }

    }
  };
}]).
directive('mrSection', ['$parse', function() {
  return {
    require: '^mrAccordion',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="accordion-section" id="{{name}}" ng-class="{open: sections[name]}">' +
      '<a ng-click="toggleSection(name)" ng-class="{\'icon-neg\': sections[name], \'icon-pos\': !sections[name]}">' +
      '<h5>{{header}}</h5>' +
      '</a>' +
      '<div class="details">' +
      '<div class="details-wrap" ng-transclude></div>' +
      '</div>' +
      '</div>',
    scope: {
      header: '@',
      name: '@',
      open: '=?'
    },
    link: function(scope, element, attrs, ctrl) {
      scope.sections = ctrl.sections;
      scope.toggleSection = ctrl.toggleSection;
      ctrl.addSection(scope.name);
      if (scope.open) {
        scope.toggleSection(scope.name);
      }
    }
  };
}])
.
directive('mrShippingMethods', function() {
  return {
    templateUrl: '/ngpartials/directives/mr-shipping-methods',
    restrict: 'EA', 
    scope: {
      freeCurrency: '@',
      shippingMethods: '=',
      selected: '=',
      updateShippingMethod: '='
    },
    link: function(scope) {
      scope.selectHandler = function(shippingMethod) {
        scope.updateShippingMethod({ code: shippingMethod.code });
        scope.selected = shippingMethod; 
      };
    }
  };
})
.
  directive('mrSignIn', [ function() {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-sign-in',
    scope: {
      control: '=',
      buyingSubscription: '=',
      view: '@?',
      type: '@?',
      createAccountHeading: '@?',
      defaultSubmitButton: '=?',
      data: '=?',
      next: '@?',
      authed: '=?',
      timeoutCookie: '@',
      focusOnEmailInput: '=?',
      backgroundImages: '=?',
    },
    link: function() {
      var currentUrl = window.location.pathname;
      if (window.location.search) {
        currentUrl += window.location.search;
      }
      //- redirect all angular signin to new Vue singin page which includes more features
      location.href = '/signin?next=' + currentUrl;
    }
  };
}]).
// Only one section open at a time
directive('mrSingleAccordion', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: '<div class="mr-single-accordion" ng-transclude>' +
      '</div>',
    controller: function() {
      var sections = this.sections = {};

      this.toggleSection = function(section) {
        Object.keys(sections).forEach(function(sectionKey) {
          sections[sectionKey] = false;
        });

        sections[section] = true;
      };

      this.addSection = function(section) {
        sections[section] = false;
      };
    }
  };
}).
directive('mrSingleSection', [function() {
  return {
    require: '^mrSingleAccordion',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="mr-single-section" id="{{name}}" ng-class="{open: sections[name]}">' +
      '<a href="" ng-click="toggleSection(name)", class="icon-caret-right">' +
      '<span class="ada-tooltip">caret right icon</span>' +
      '<h2>{{header}}</h2>' +
      '</a>' +
      '<div class="details">' +
      '<div class="wrap" ng-transclude></div>' +
      '</div>' +
      '</div>',
    scope: {
      header: '@',
      open: '@',
      name: '@',
      mrClick: '=?'
    },
    link: function(scope, element, attrs, ctrl) {
      scope.sections = ctrl.sections;
      scope.mrClick = scope.mrClick || function() {};

      scope.toggleSection = function(name) {
        ctrl.toggleSection(name);
        scope.mrClick();
      };
      ctrl.addSection(scope.name);
      if (scope.open == 'true') {
        ctrl.toggleSection(scope.name);
      }
    }
  };
}])
.
// usage: mr-site-messages(topics="cart, checkout")
// include mrDirectives styles in to your stylesheet: @import 'mrDirectives'
directive('mrSiteMessages', ['siteMessagesSvc', function(siteMessagesSvc) {
  return {
    templateUrl: '/ngpartials/directives/site-messages',
    restrict: 'EA',
    transclude: true,
    scope: {
      topics: '@?',
      hasMessages: '=?'
    },
    link: function(scope) {
      scope.siteMessages = [];
      siteMessagesSvc.getByTopics(scope.topics, function(messages) {
        if (messages && messages.length) {
          scope.siteMessages = messages;
          scope.hasMessages = true;
        }
      });

      scope.setMessageClass = function(val) {
        var msgClass = '';
        if (val == 'high') {
          msgClass = 'color-red';
        } else if (val == 'medium') {
          msgClass = 'color-mr-blue';
        }

        return msgClass;
      };
    }
  };
}]).
/* global dataLayer */
directive('mrSiteSearch', ['$window', 'notifySvc', function($window, notifySvc) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/ngpartials/directives/mr-site-search',
    scope: {
      control: '=?' // make bind optional
    },
    link: function(scope, element) {
      scope.control = scope.control || {};
      scope.control.open = scope.control.open || false;
      scope.control.searchTerm = scope.control.searchTerm || '';
      scope.searchPlaceholder = 'search';

      scope.control.focusSearch = function() {
        setTimeout(function() {
          element[0].querySelector('input').focus();
        }, 1);
      };

      scope.performSearch = function() {
        if (!scope.control.searchTerm.length) {
          return notifySvc.notify('warn', 'Nothing entered in the search form.');
        }
        scope.control.open = false;
        dataLayer.push({
          'event': 'Search',
          'searchString': '' + scope.control.searchTerm
        });

        $window.location = '/search/' + encodeURIComponent(scope.control.searchTerm);
      };

      scope.$on('breakpointChange', function(event, data) {
        if (data.breakpoint == 'mobile' || data.breakpoint == 'tablet' || data.breakpoint == 'desktop-md') {
          scope.searchPlaceholder = 'Search';
        } else {
          scope.searchPlaceholder = '';
        }
      });
    }
  };
}]).
/* global useCloudinary */
directive('mrSrc', ['imgCropUtilSvc', function(imgCropUtilSvc) {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      if (attrs.mrSrc) {
        if (typeof useCloudinary != 'undefined' && useCloudinary) {
          elem[0].setAttribute('src', imgCropUtilSvc.getCloudinaryUrl(attrs.mrSrc));
        } else {
          elem[0].setAttribute('src', attrs.mrSrc);
        }
      }
    }
  };
}])
.
// usage: mr-stars(rating="averageStars")
// include mrDirectives styles in to your stylesheet: @import 'mrDirectives'
directive('mrStars', function() {
  return {
    template: '<span class="ada-tooltip">{{rating}} out of 5 stars</span><div class="mr-stars"><span ng-repeat="star in stars", ng-class="getClass(star)"></span><span ng-transclude></span></div>',
    restrict: 'EA',
    transclude: true,
    scope: {
      rating: '='
    },
    link: function(scope) {
      scope.Math = window.Math;
      scope.stars = [1, 2, 3, 4, 5];

      scope.getClass = function(star) {
        var rating = Math.round(scope.rating * 2) / 2;
        var floorRating = Math.floor(rating);
        var ceilRating = Math.ceil(rating);

        if (star <= floorRating) {
          return 'icon-star-full';
        }

        if (star == ceilRating) {
          return 'icon-star-half';
        } else {
          return 'icon-star';
        }
      };
    }
  };
})
.
directive('mrSticky', function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      $(window).scroll(function() {
        if ($('body').hasClass('no-scroll')) {
          return;
        }

        if ($(this).scrollTop() > 1) {
          element.addClass("mr-sticky");
        } else {
          element.removeClass("mr-sticky");
        }
      });
    }
  };
}).
// used for stoping a bottom fixed element at a specific element on the page
// Example jade: .some-fixed-element(mr-stop-at="footer")

directive('mrStopAt', [function() {
  return {
    retrict: 'EA',
    link: function(scope, element, attrs) {
      var stopAtSelector = attrs.mrStopAt;
      var breakpoints = attrs.breakpoints || ['mobile', 'tablet', 'desktop-md', 'desktop'];
      var relativeToParent = attrs.relativeToParent;
      var win = $(window);
      var scopeWindowData = {};

      scope.$on('windowScroll', function(event, windowData) {
        scopeWindowData = windowData;
        scope.$apply();

        if (~breakpoints.indexOf(windowData.breakpoint)) {
          stopAtWatcher();
        }
      });

      scope.$on('pageHeightChanged', function() {
        stopAtWatcher();
      });

      scope.$on('breakpointChange', function(event, windowData) {
        if (~breakpoints.indexOf(windowData.breakpoint)) {
          stopAtWatcher();
        } else {
          reset();
        }
      });

      stopAtWatcher();

      function stopAtWatcher() {
        var stopAtElem = $(stopAtSelector);
        if (!stopAtSelector || !stopAtElem || !stopAtElem.offset()) {
          return;
        }

        var stopAt = stopAtElem.offset().top;
        var windowBottom = win.scrollTop() + win.height();
        var offsetHeight = element.outerHeight();
        if (relativeToParent) {
          offsetHeight += $(element[0].parentElement).offset().top;
        }

        if (windowBottom >= stopAt) {
          element.css('position', 'absolute');
          element.css('bottom', 'initial');
          element.css('top', stopAt - offsetHeight);
          element.addClass('stopped');
          scopeWindowData.fixedCTA = false;
        } else {
          reset();
        }
      }

      function reset() {
        element.css('position', '');
        element.css('bottom', '');
        element.css('top', '');
        element.removeClass('stopped');
        scopeWindowData.fixedCTA = true;
      }
    }
  };
}])
.
directive('mrSubDropdown', ['$timeout', '$filter', function($timeout, $filter) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr_sub_dropdown',
    scope: {
      product: '=',
      freqField: '@',
      freqModel: '=',
      idx: '=',
      onChange: '=',
      onChange2: '=',
      showPrice: '=?',
      oneTimePurchase: '=?',
      numMemberships: '=?'
    },
    link: function(scope, element) {
      var currency = $filter('currency');
      scope.show = false;
      scope.$watch('product', function(val) {
        if (val) {
          //Set frequency
          scope.freqModel[scope.freqField] = scope.freqModel[scope.freqField] || val.product_type_sub_frequency_default || 0;
          //Set select options
          updateSubDropdown(val.product_type_sub_frequencies);
        }
      });

      //When drop down value changes
      scope.updateSubFrequency = function() {
        if (scope.onChange) {
          scope.onChange(scope.idx, scope.freqModel[scope.freqField]);
        }

        if (scope.onChange2) {
          scope.onChange2();
        }
      };

      function updateSubDropdown(frequencyString) {
        frequencyString = frequencyString || '';
        var frequencyArray = frequencyString.split(',').map(Number);
        var subFrequency = parseInt(scope.freqModel.subFrequency);

        if (!frequencyArray.length) {
          frequencyArray = [2, 3, 4, 5, 6, 7, 8];
        }

        if (subFrequency > frequencyArray[frequencyArray.length - 1]) {
          frequencyArray.push(subFrequency);
        }

        if (scope.oneTimePurchase) {
          frequencyArray.unshift(0);
        }

        var membershipThreshold = scope.product.subscription ? 1 : 0;
        scope.freqModel[scope.freqField] = updateSubscription(frequencyArray, scope.freqModel[scope.freqField]);
        scope.subOptions = frequencyArray.map(function(val) {
          var price = '';
          var priceKey = scope.numMemberships > membershipThreshold ? 'price_active_sub' : 'one_time_price';
          var label = 'One time';
          if (val > 0) {
            priceKey = scope.numMemberships > membershipThreshold ? 'sub_price_active_sub' : 'sub_price';
            label = 'Every ' + val + ' weeks';
          }

          if (scope.showPrice) {
            price = ' - ' + currency(scope.product[priceKey]);
          }

          return {
            val: val,
            label: label + price
          };
        });

        $timeout(function() {
          element.find('select').customDropdown();
          scope.show = true;
        }, 0);
      }

      //If product is not in frequency list then change product to a higher product
      //ex. arr = [2,4,6] and product = 5, set product = 6
      function updateSubscription(arr, frequency) {
        var sub = null;

        //If frequency is undefined
        if (isNaN(parseInt(frequency, 10))) {
          return;
        }

        //Check if frequency is not in frequency list
        if (arr.indexOf(frequency) === -1) {

          //Set to next higher frequency
          sub = arr.filter(function(val) {
            if (val - frequency >= 1) {
              return val;
            }
          })[0];

          //If sub is not populated then set to the highest frequency
          if (isNaN(sub)) {
            sub = arr[arr.length - 1];
          }
        } else {
          sub = frequency;
        }

        return sub;
      }
    }
  };
}]).
directive('mrSwipe', [function() {
  return {
    restrict: 'A',
    scope: {
      left: '&',
      right: '&',
      up: '&',
      down: '&'
    },
    link: function(scope, element) {
      var offsetXStart = 0;
      var offsetXEnd = 0;
      var offsetYStart = 0;
      var offsetYEnd = 0;

      element.on('touchstart', function(event) {
        offsetXStart = event.touches[0].pageX - event.touches[0].target.offsetLeft;
        offsetXEnd = offsetXStart;

        offsetYStart = event.touches[0].pageY - event.touches[0].target.offsetTop;
        offsetYEnd = offsetYStart;
      });

      element.on('touchmove', function(event) {
        offsetXEnd = event.touches[0].pageX - event.touches[0].target.offsetLeft;
        offsetYEnd = event.touches[0].pageY - event.touches[0].target.offsetTop;
      });

      element.on('touchend', function() {
        if (scope.left && offsetXStart - offsetXEnd > 10) {
          scope.left();
        }
        if (scope.right && offsetXStart - offsetXEnd < -10) {
          scope.right();
        }
        if (scope.up && offsetYStart - offsetYEnd > 10) {
          scope.up();
        }
        if (scope.down && offsetYStart - offsetYEnd < -10) {
          scope.down();
        }
      });
    }
  };
}]).
directive('mrTab', function() {
  return {
    require: '^mrTabset',
    restrict: 'E',
    transclude: true,
    template: '<div class="tab-container"><div class="tab-content"ng-show="selected" id="{{header}}" ng-transclude></div></div>',
    scope: {
      header: '@',
      hideTab: '=?'
    },
    link: function(scope, element, attr, ctrl) {
      ctrl.addTab(scope);
    }
  };
})
.
directive('mrTabset', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: '<div class="mr-tabs">' +
    '<div class="wrap"><ul class="nav-tabs">' +
    '<li ng-repeat="tab in tabs" ng-class="{selected: tab.selected}" ng-if="!tab.hideTab">' +
    '<a href="" ng-click="select(tab); scrollToTab($event)">{{tab.header}}</a>' +
    '</li>' +
    '</ul></div>' +
    '<div class="tab-container", ng-transclude></div>' +
    '</div>',
    controller: function($scope) {
      var tabs = $scope.tabs = [];

      $scope.select = function(tab) {
        angular.forEach(tabs, function(tab) {
          tab.selected = false;
        });
        tab.selected = true;
      };

      $scope.scrollToTab = function(event) {
        var top = $(event.target).parent().offset().top;
        $('html, body').animate({
          scrollTop: top - 20
        }, 500, 'swing');
      };

      $scope.selectTab = function(header) {
        angular.forEach(tabs, function(tab) {
          tab.selected = false;
          if (tab.header == header) {
            tab.selected = true;
          }
        });
      };

      this.addTab = function(tab) {
        if (tabs.length === 0) {
          $scope.select(tab);
        }
        tabs.push(tab);
      };
    },
    scope: {
      selectTab: '=?'
    }
  };
}).
directive('mrThumbSelector', ['mrNgUtils', function(mrNgUtils) {
  return {
    templateUrl: '/ngpartials/directives/thumb-selector',
    transclude: true,
    restrict: 'E',
    scope: {
      products: '=',
      selectedUrlKey: '=?',
      bestMatch: '=?',
      titleOnBottom: '=',
      customFieldOne: '@',
      customFieldTwo: '@',
      itemsPerLine: '=?'
    },
    link: function(scope) {
      scope.showElement = false;

      scope.$on('init', function() {
        scope.$apply(function() {
          scope.showElement = true;
        });
      });

      scope.changeSwatchName = function(hoveredProduct, selectedName) {
        if (selectedName) {
          scope.hoveredProduct = scope.selectedProd;
        } else {
          scope.hoveredProduct = hoveredProduct;
        }
      };

      scope.$watch('products', function(val) {
        if (val) {
          scope.products.forEach(function(prod) {
            if (prod.url_key === scope.selectedUrlKey) {
              scope.hoveredProduct = prod;
              scope.selectedProd = prod;
            }
          });

          if (!scope.selectedProd) {
            scope.selectedProd = scope.products[0];
          }
          scope.chunkedProducts = mrNgUtils.chunkArray(scope.products, scope.itemsPerLine ? scope.itemsPerLine : 4);
        }
      });

      scope.selectProd = function(prod) {
        scope.selectedProd = prod;
      };
    }
  };
}]).
directive('mrTouch', function() {
  return {
    link: function(scope, element, attrs) {
      var touchOrClick = window.isMobileDevice ? 'touchstart' : 'click';
      // Older Androids don't like 'touchstart' so we switch to click
      if (/(android\s4)/i.test(navigator.userAgent)) {
        touchOrClick = 'click';
      }

      element.on(touchOrClick, function(event) {
        event.preventDefault();
        event.stopPropagation();
        scope.$event = event;
        scope.$apply(attrs.mrTouch);
      });
    }
  };
}).
/* global videojs */
directive('mrVideoJs', ['$rootScope', 'trackerSvc', function($rootScope, trackerSvc) {
  return {
    restrict: 'A',
    scope: {
      playerId: '@',
      playerSrc: '@',
      videoTitle: '@'
    },
    link: function(scope) {
      $rootScope.mrVideoJsPlayers = $rootScope.mrVideoJsPlayers || [];
      $rootScope.autoPause = false;
      var aspectRatio = 9 / 16;
      var playerId = scope.playerId;

      var player = videojs(playerId, {
        controls: true,
        autoplay: false,
        techOrder: ["youtube", "html5", "flash"],
        sources: [{
          type: "video/youtube",
          src: scope.playerSrc
        }],
        youtube: {
          "modestbranding": 1
        }
      }, function() {
        //the video ready calback;
        var self = this;
        //init google analytics with all tracking options
        self.ga();

        $(function() {
          var videoDescription = $('#' + playerId).next('.video-description');
          var videoDuration = self.duration();

          self.on('play', function() {
            //set a listener to show/hide video descriptions
            videoDescription.hide();

            //ensure all other players are paused
            $rootScope.mrVideoJsPlayers.forEach(function(p) {
              if (p.id_ == playerId) {
                return;
              }

              if (p.paused()) {
                return;
              }
              $rootScope.autoPause = true;
              p.pause();
              $rootScope.autoPause = false;
            });

            //fire segment event
            trackerSvc.trackEvent('Instruction Video Played', {
              videoTitle: scope.videoTitle,
              videoSrc: scope.playerSrc
            });
          });

          self.on('fullscreenchange', function() {
            if (!self.isFullscreen()) {
              return;
            }

            trackerSvc.trackEvent('Instruction Video Fullscreen', {
              videoTitle: scope.videoTitle,
              videoSrc: scope.playerSrc
            });
          });

          self.on('pause', function() {
            videoDescription.show();
            if ($rootScope.autoPause) {
              //dont fire pause events when auto-pausing the video for the user (whem multiple vids are playing);
              $rootScope.autoPause = false;
              return;
            }

            var pausedDuration = self.currentTime();

            trackerSvc.trackEvent('Instruction Video Paused', {
              videoTitle: scope.videoTitle,
              videoSrc: scope.playerSrc,
              videoPausedAt: +pausedDuration.toFixed(2),
              videoPercentWatched: +((pausedDuration / videoDuration) * 100).toFixed(2)
            });
          });

          self.on('ended', function() {
            videoDescription.show();

            trackerSvc.trackEvent('Instruction Video Completed', {
              videoTitle: scope.videoTitle,
              videoSrc: scope.playerSrc
            });
          });

          self.on('error', function(e) {
            console.log('mr-video-js error:', e);
          });
        }); //end jq ready
      });

      //we want to call this as soon as the instance has been started
      resizeVideoJs(player);
      $rootScope.mrVideoJsPlayers.push(player);

      function resizeVideos() {
        $rootScope.mrVideoJsPlayers.forEach(function(player) {
          resizeVideoJs(player);
        });
      }

      if (!window.onresize) {
        //only assign this once as there can be multiple videos per page
        window.onresize = resizeVideos;
      }

      // Resize a single player
      function resizeVideoJs(player) {
        // Get the parent element's actual width
        var width = document.getElementById(player.id()).parentElement.offsetWidth;
        // Set width to fill parent element, Set height
        player.width(width).height(width * aspectRatio);
      }

    }
  };
}]).

directive('mrVideoWrap', ['trackerSvc', function(trackerSvc) {
  return {
    restrict: 'E',
    scope: {
      control: '=',
      videoUrl: '=',
      thumbnailUrl: '=',
      altText: '='
    },
    link: function(scope, element) {
      scope.control = scope.control || {};
      scope.control.started = false;
      element.addClass('mr-video-wrap');
      element.addClass('not-started');

      scope.v = document.createElement("VIDEO");
      scope.v.setAttribute("src", scope.videoUrl);
      if (scope.thumbnailUrl) {
        scope.v.setAttribute("poster", scope.thumbnailUrl);
      }
      if (scope.altText) {
        scope.v.setAttribute("alt", scope.altText);
      }
      scope.v.setAttribute("width", "100%");
      scope.v.setAttribute("height", "100%");

      element.append(scope.v);

      element.click(function() {
        if (!scope.control.started) {
          scope.control.started = true;
          element.removeClass('not-started');
          scope.v.setAttribute("controls", "controls");
          trackerSvc.trackEvent("Video Played", { src: scope.videoUrl });
          setTimeout(function() {
            scope.v.play();
          }, 50);
        }
      });

      // needed for mobile
      element.on("touchstart", function() {
        if (!scope.control.started) {
          scope.control.started = true;
          scope.v.setAttribute("controls", "controls");
          trackerSvc.trackEvent("Video Played", { src: scope.videoUrl });
          setTimeout(function() {
            scope.v.play();
          }, 50);
        }
      });
    }
  };
}])
.
/* global MR */
directive('mrWaitlist', ['waitlistSvc', 'notifySvc', function(waitlistSvc, notifySvc) {
  return {
    restrict: 'A',
    scope: {
      control: '=',
      waitlistType: '@',
      email: '@', // optional default
      zip: '@', // optional default
      phone: '@' // optional default
    },
    link: function(scope) {
      scope.control.requiredFields = scope.control.requiredFields || ['email'];
      scope.control.missingFields = {};
      scope.control.email = scope.email || '';
      scope.control.zip = scope.zip || '';
      scope.control.phone = scope.phone || '';

      scope.control.addToWaitlist = function() {
        if (!checkRequiredFields() || scope.control.addingToWaitlist) {
          return;
        }
        scope.control.addingToWaitlist = true;
        var params = {
          waitlist_type: scope.waitlistType
        };

        scope.control.requiredFields.forEach(function(field) {
          params[field] = scope.control[field];
        });

        waitlistSvc.addToWaitlist(params, function() {
          scope.control.addingToWaitlist = false;
          scope.control.addedToWaitlist = true;
        }, function(err) {
          scope.control.addingToWaitlist = false;
          var error = 'We weren\'t able to update our waiting list. Please contact Color Crew at ' + MR.config.contactPhone; //- <- global
          if (err.data && err.data.message) {
            error = err.data.message;
          }

          notifySvc.notify('error', error);
        });
      };

      function checkRequiredFields() {
        var hasRequired = true;
        scope.control.requiredFields.forEach(function(field) {
          if (!scope.control[field]) {
            notifySvc.notify('warn', 'Please enter a valid ' + field + '.');
            scope.control.missingFields[field] = true;
            hasRequired = false;
          }
        });
        return hasRequired;
      }
    }
  };
}])
.
directive('mrXSell', [function() {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-x-sell',
    scope: {
      addons: '=',
      addToCartMethod: '=',
      ctaSource: '@?', //- used for segment tracking to identify from where product was added to cart
      showBundlesInXsell: '=?',
      context: '=?',
      addToString: '@?',
      isMember: '=?',
      membershipPricing: '=',
      testFlag: '=?'
    },
    link: function(scope) {
      scope.addToString = scope.addToString || 'add to bag';
      scope.addAddon = function(prod, idx) {
        // Ability to tie the parent context to the addon item being clicked on (added to cart)
        var context = scope.context || {};
        var payload = {
          prod: prod,
          idx: idx,
          context: context,
          ctaSource: {
            name: scope.ctaSource,
            index: idx
          }
        };

        if (scope.showBundlesInXsell && prod.validOffer) {
          payload.validOffer = prod.validOffer;
        } else {
          delete prod.validOffer;
        }
        // Call parent method and pass data from item being added
        scope.addToCartMethod(payload, context);
      };
    }
  };
}]).
directive('mrXSellMembership', ['$routeParams', '$location', 'xsellSvc', 'refillCartSvc', 'trackerSvc', function($routeParams, $location, xsellSvc, refillCartSvc, trackerSvc) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-xsell-membership',
    scope: {
      ctaSource: '@?', //- used for segment tracking to identify from where product was added to cart
      addToString: '@?',
      allAddedCallback: '&?' //- can be used to execute a method after all recommended items are added to refill cart
    },
    link: function(scope) {
      scope.trackerSvc = trackerSvc;
      scope.addToString = scope.addToString || 'add to order';
      scope.refillCart = refillCartSvc;
      scope.allAddedCallback = scope.allAddedCallback || angular.noop;
      scope.refillCart.loadMembershipXsellProducts();

      scope.addXsellProduct = function(recommendation, idx) {
        recommendation.addingInProgress = true;
        var payload = {
          prod: recommendation,
          idx: idx,
          validBundle: recommendation.validBundle,
          ctaSource: {
            name: scope.ctaSource,
            index: idx
          }
        };

        refillCartSvc.addToCart(payload, function() {
          if (refillCartSvc.allMemberRecsInCart) {
            scope.allAddedCallback();
          }
          recommendation.addingInProgress = false;
        });
      };
    }
  };
}])
.
/* global redirect */
directive('mrXSellMemberSection', ['$routeParams', '$location', '$cookies', 'xsellSvc', 'refillCartSvc', 'trackerSvc', 'Modal', function($routeParams, $location, $cookies, xsellSvc, refillCartSvc, trackerSvc, Modal) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-xsell-member-section',
    scope: {
      subId: '=',
      breakpoint: '=',
      ctaButton: '=?',
      location: '@'
    },
    link: function(scope, element, attrs) {
      //- cookie each location separately (https://trello.com/c/pn8FbRWq)
      var loc = scope.location || '';
      var cookie = 'memberXsellViewed' + loc.charAt(0).toUpperCase() + loc.slice(1);

      if (attrs.hasOwnProperty("ctaButton")) {
        scope.displayCtaButton = true;
      }

      scope.modals = {
        memberXsellModal: Modal.newModal('memberXsellModal'),
        memberXsellModalShowHalf: false,
        showMemberXsellSection: false
      };

      scope.memberXsellModalInit = function() {
        if (!scope.subId) {
          return;
        }

        refillCartSvc.getRefillCartDataForView(scope.subId, function() {
          modalDisplayLogic();
        });
      };

      function modalDisplayLogic() {
        //- have to ensure that memberXsellProducts are laoded before trying to display modal
        if (!refillCartSvc.memberXsellProductsLoaded) {
          return setTimeout(function() {
            scope.$parent.safeApply(function() {
              modalDisplayLogic();
            });
          }, 500);
        }
        //- do not display modal if all recomended products are already added
        if (refillCartSvc.allMemberRecsInCart) {
          return;
        }
        //- if user has seen in before show only section
        if ($cookies[cookie]) {
          scope.modals.showMemberXsellSection = true;
          return;
        }
        //- on mobile show half
        if (scope.breakpoint == 'mobile') {
          scope.modals.memberXsellModal.show = true;
          scope.modals.memberXsellModalShowHalf = true;
          trackModalEvent('Half Exposed');
          return;
        }
        //- desktop show whole modal from the get go
        scope.popMemberXsellModal();
      }

      scope.popMemberXsellModal = function() {
        scope.modals.memberXsellModalShowHalf = false;
        scope.modals.memberXsellModal.show = true;
        scope.modals.showMemberXsellSection = false;
        $cookies[cookie] = true;
        trackModalEvent('Fully Exposed');
      };

      scope.closeMemberXsellModal = function() {
        scope.modals.memberXsellModal.show = false;
        scope.modals.showMemberXsellSection = true;
        trackModalEvent('Closed');
      };

      scope.goToMembership = function() {
        trackModalEvent('Go to Membership');
        redirect('/account/next-delivery/' + scope.subId);
      };

      scope.swipeUpModal = function() {
        scope.$parent.safeApply(function() {
          scope.popMemberXsellModal();
        });
      };

      scope.swipeDownModal = function() {
        scope.$parent.safeApply(function() {
          scope.closeMemberXsellModal();
          //- don't bother customer anymore while cookie exists
          $cookies[cookie] = true;
        });
      };

      function trackModalEvent(customIdentifier) {
        trackerSvc.trackEvent('MemberXsellModal ' + customIdentifier, {
          page: scope.location
        });
      }

      scope.memberXsellModalInit();
    }
  };
}])
.
/*
  This directive handles the cross sell modal for bundles.
*/
/* global testVariant, isMember, hasMembershipPricing */
/* global isMember */
directive('mrXsellModal', ['trackerSvc', '$cookies', function(trackerSvc, $cookies) {
  return {
    templateUrl: function() {
      var url = '/ngpartials/directives/mr-xsell-modal-single';
      if (hasMembershipPricing) {
        url = '/ngpartials/directives/mr-xsell-modal-membership';
      }
      return url;
    },
    scope: {
      cartItems: '=',
      upsellModalProducts: '=',
      recentAddedProduct: '=',
      potentialMembershipSavings: '=?',
      membershipPricing: '=',
      testFlag: '=?'
    },
    link: function(scope) {
      scope.xsellModal = {
        visible: true,
        products: []
      };
      scope.testVariant = testVariant;
      scope.isMember = isMember;
      scope.setCookie = scope.$parent.setCookie || scope.$parent.$parent.setCookie || scope.$parent.$parent.$parent.setCookie;
      var bundlesViewed = angular.fromJson($cookies.bundlesViewed) || [];

      updateAddons(scope.upsellModalProducts);

      function updateAddons(modalProducts) {
        modalProducts.forEach(function(addon, index) {
          addon.index = index;
          if (addon.validOffer) {
            if (scope.membershipPricing) {
              delete addon.validOffer;
            }
            scope.xsellModal.products.push(addon);
            if (!scope.xsellModal.addon && !~bundlesViewed.indexOf(addon.code)) {
              scope.xsellModal.addon = addon;
              bundlesViewed.push(addon.code);
              scope.setCookie('bundlesViewed', angular.toJson(bundlesViewed), 2);
            }
          }
        });

        if (!scope.xsellModal.products.length) {
          scope.xsellModal.visible = false;
        }
      }

      scope.closeXsellModal = function() {
        trackerSvc.trackEvent('Xsell Modal Closed');
        scope.xsellModal.visible = false;
      };

      scope.$on('upsellProductsUpdated', function(event, data) {

        data.upsellModalProducts.forEach(function(prod) {
          if (prod.id == scope.recentAddedProduct) {
            scope.xsellModal.addedProduct = prod;
          }
        });

        updateAddons(data.upsellModalProducts);
      });

      if (!scope.xsellModal.addon) {
        scope.xsellModal.visible = false;
      }

      if (scope.recentAddedProduct) {
        scope.cartItems.forEach(function(item) {
          if (item.id == scope.recentAddedProduct) {
            scope.xsellModal.addedProduct = item;
          }
        });
      }

      scope.addProduct = function(prod) {
        if (prod.added) {
          return;
        }
        // Flag to disable add to bag button and avoid double clicks
        prod.added = true;
        scope.recentAddedProduct = prod.id;
        scope.xsellModal.recentProductDiscount = prod.id;
        scope.xsellModal.addedProduct = prod;
        scope.xsellModal.products = [];

        var eventData = {
          ctaSource: {
            name: 'mr-xsell-modal',
            index: scope.index
          },
          prod: prod
        };

        if (scope.membershipPricing) {
          eventData.ctaSource.name = eventData.ctaSource.name + '-membership-pricing';
        }

        if (scope.testFlag) {
          eventData.ctaSource.name = eventData.ctaSource.name + '-' + scope.testFlag;
        }

        scope.$emit('addUpSelledProdToCart', eventData);
      };
    }
  };
}]).
directive('mrYoutube', ['$sce', function($sce) {
  return {
    restrict: 'EA',
    replace: true,
    template: '<div class="mr-youtube"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" ng-src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
    scope: {
      code: '='
    },
    link: function(scope) {
      scope.$watch('code', function(newVal) {
        if (newVal) {
          scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
        }
      });
    }
  };
}]).
/* global YT */
directive('mrYoutubeVideo', function() {
  return {
    restrict: 'A',
    scope: {
      videoId: '@',
      autoPlay: '=?',
      autoMute: '=?',
      rel: '=?'
    },
    link: function(scope, element) {
      var playerId = 'player-' + scope.videoId;
      var tag = document.getElementById("YOUTUBE_IFRAME_API");
      element.append("<div id=" + playerId + "></div>");

      if (!tag) {
        tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        tag.id = "YOUTUBE_IFRAME_API";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = function() {
          initializePlayer();
        };
      } else {
        initializePlayer();
      }

      function initializePlayer() {
        new YT.Player(playerId, {
          //height and width should be handled on the parent/wrapper div in markup/css
          videoId: scope.videoId,
          playerVars: {
            'origin': window.location.origin,
            'rel': scope.rel ? 1 : 0
          },
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }

      function onPlayerReady(event) {
        var player = event.target;
        if (scope.autoMute) {
          player.mute();
        }
        if (scope.autoPlay) {
          player.playVideo();
        }
      }

      function onPlayerStateChange() {
        //register when play/pause occurs
      }
    }
  };
}).
directive('ngInvisible', ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngInvisible, function ngShowWatchAction(value) {
        $animate[value ? 'addClass' : 'removeClass'](element, 'ng-invisible');
      });
    }
  };
}]).
directive('productimages', [function() {
  return {
    link: function(scope, element, attrs) {
      scope.mainImage = {
        url: scope.item.images.pdp
      };

      scope.hostUrl = attrs.hostUrl;

      scope.images = [];

      function preload(item) {
        var imageCount = scope.images.length + 1;
        scope.images[imageCount] = new Image();
        scope.images[imageCount].src = item;
      }

      preload(scope.item.images.pdp);

      for (var i = 0; i < 3; i++) {
        var itemPath = scope.hostUrl + '/' + scope.item.similarImages[i].image;
        scope.item.similarImages[i].thumb = scope.hostUrl + '/' + scope.item.similarImages[i].image.replace('/pdp/', '/102/');
        preload(itemPath);
      }

      scope.changeImage = function() {
        var url = this.$parent.hostUrl;
        this.$parent.mainImage.url = url + '/' + this.thumb.image;
      };

      scope.changeBack = function() {
        this.$parent.mainImage.url = this.$parent.item.images.pdp;
      };
    },
    restrict: 'EA',
    template: [
      '<div class="main-image">',
      '<img ng-src="{{mainImage.url}}">',
      '</div>',
      '<div class="thumbs">',
      '<img ng-repeat="thumb in item.similarImages | limitTo: 3", ng-mouseover="changeImage()", ng-mouseleave="changeBack()", ng-src="{{thumb.thumb}}", err-src="/images/my-account/default-picture.png">',
      '</div>'
    ].join(''),
    scope: {
      item: '=',
      host_url: '='
    }
  };
}]).
directive('pullQuoteLeft', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="pull-quote-left"><div class="start-quote">&ldquo;</div><div class="quote-text"><span ng-transclude></span>&rdquo;</div></div>'
  };
}).
directive('pullQuoteRight', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="pull-quote-right"><div class="start-quote">&ldquo;</div><div class="quote-text"><span ng-transclude></span>&rdquo;</div></div>'
  };
}).
// scrollingCarousel directive for adding left and right nav buttons for scrolling a horizontally scrollable element
// scrollingCarousel assumes "element" is horizontally scrollable, and uses "element.children[0].width" divided by some number
// of "sections" to determine the amount to scroll each time "leftNav" or "rightNav" is clicked

directive('scrollingCarousel', [function() {
  return {
    restrict: 'EA',
    scope: {
      leftNav: '@', // (optional) jquery selector for the left nav element
      rightNav: '@', // (optional) jquery selector for the right nav element
      sections: '@', // (optional) number of section to divide the scrollable area into
      scrollTime: '@' // (optional) number of milliseconds for the animation
    },
    link: function(scope, element) {
      var leftNav = scope.leftNav ? $(scope.leftNav) : null;
      var rightNav = scope.rightNav ? $(scope.rightNav) : null;
      scope.scrollTime = scope.scrollTime ? scope.scrollTime : 400;

      setInterval(function() { // setInterval shows better performance than on scroll event
        checkNav();
      }, 200);

      // hide nav if all children are visible within element
      // hide left nav if within 15 pixels of the left side
      // hide right nav if within 15 pixels of the right side
      function checkNav() {
        var width = element.width();
        var widthInner = innerWidth();
        var left = element.scrollLeft();
        var right = widthInner - (left + width);
        var hideLeft = false;
        var hideRight = false;

        if (width >= innerWidth || left <= 15) {
          hideLeft = true;
        } else {
          hideLeft = false;
        }

        if (width >= innerWidth || right <= 15) {
          hideRight = true;
        } else {
          hideRight = false;
        }

        if (leftNav && hideLeft) {
          leftNav.hide();
        } else if (leftNav) {
          leftNav.show();
        }

        if (rightNav && hideRight) {
          rightNav.hide();
        } else if (rightNav) {
          rightNav.show();
        }
      }

      if (leftNav) {
        leftNav.click(function() {
          scrollCarousel(-1);
        });
      }

      if (rightNav) {
        rightNav.click(function() {
          scrollCarousel(1);
        });
      }

      // direction should be -1 for left and 1 for right
      function scrollCarousel(direction) {
        var numSections = scope.sections ? scope.sections : element[0].children.length;
        var leftPos = element.scrollLeft();
        var pixels = direction * innerWidth() / numSections;

        element.animate({ scrollLeft: leftPos + pixels }, scope.scrollTime);
      }

      function innerWidth() {
        var width = 0;
        for (var x = 0; x < element[0].children.length; x++) {
          width += element[0].children[x].clientWidth;
        }
        return width;
      }
    }
  };
}]).
directive('setInterval', ['$interval', function($interval) {
  return {
    restrict: 'AE',
    scope: {
      intervalModel: '=',
      paused: '=',
      numberValues: '=', // number of values, indexing from 1
      control: '='
    },
    link: function($scope) {
      $interval(function() {
        if (!$scope.paused) {
          $scope.intervalModel = $scope.intervalModel >= $scope.numberValues ? 1 : $scope.intervalModel + 1;
        }
      }, 2000);

      $scope.control.pause = function() {
        $scope.paused = true;
      };

      $scope.control.unpause = function() {
        $scope.paused = false;
      };
    }
  };
}]).
directive('showMore', ['$compile', function($compile) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element, attrs) {
      scope.collapsed = false;
      scope.toggle = function() {
        scope.collapsed = !scope.collapsed;
      };

      attrs.$observe('showMore', function() {
        var text = element.text();
        var maxLength = scope.$eval(attrs.showMore);
        var bodySpan;
        if (text.length > maxLength) {
          // split the text in two parts, the first always showing
          var firstPart = String(text).substring(0, maxLength);
          var secondPart = String(text).substring(maxLength, text.length);

          // create some new html elements to hold the separate info
          bodySpan = $compile('<span itemprop="reviewBody"><span>' + firstPart + '</span>' + '<span ng-class="{ hide: !collapsed }">' + secondPart + '</span></span>')(scope);
          var moreIndicatorSpan = $compile('<span ng-if="!collapsed">... </span>')(scope);
          var lineBreak = $compile('<br ng-if="collapsed">')(scope);
          var toggleButton = $compile('<span class="show-more-text" ng-click="toggle()">{{collapsed ? "less" : "more"}}</span>')(scope);

          // remove the current contents of the element
          // and add the new ones we created
          element.empty();
          element.append(bodySpan);
          element.append(moreIndicatorSpan);
          element.append(lineBreak);
          element.append(toggleButton);
        } else {
          bodySpan = $compile('<span itemprop="reviewBody">' + text + '</span>')(scope);
          element.empty();
          element.append(bodySpan);
        }
      });
    }
  };
}]).
directive('slick', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'AEC',
      scope: {
        initOnload: '@',
        data: '=',
        currentIndex: '=',
        accessibility: '@',
        adaptiveHeight: '@',
        arrows: '@',
        asNavFor: '@',
        appendArrows: '@',
        appendDots: '@',
        autoplay: '@',
        autoplaySpeed: '@',
        centerMode: '@',
        centerPadding: '@',
        cssEase: '@',
        customPaging: '&',
        dots: '@',
        draggable: '@',
        easing: '@',
        fade: '@',
        focusOnSelect: '@',
        infinite: '@',
        initialSlide: '@',
        lazyLoad: '@',
        onBeforeChange: '&',
        onAfterChange: '&',
        onInit: '&',
        onReInit: '&',
        onSetPosition: '&',
        pauseOnHover: '@',
        pauseOnDotsHover: '@',
        responsive: '=',
        rtl: '@',
        slide: '@',
        slidesToShow: '@',
        slidesToScroll: '@',
        speed: '@',
        swipe: '@',
        swipeToSlide: '@',
        touchMove: '@',
        touchThreshold: '@',
        useCSS: '@',
        variableWidth: '@',
        vertical: '@',
        prevArrow: '@',
        nextArrow: '@'
      },
      link: function(scope, element, attrs) {
        var destroySlick, initializeSlick, isInitialized;
        destroySlick = function() {
          return $timeout(function() {
            var slider;
            slider = $(element);
            slider.slick('unslick');
            slider.find('.slick-list').remove();
            return slider;
          });
        };
        initializeSlick = function() {
          return $timeout(function() {
            var currentIndex, customPaging, slider;
            slider = $(element);
            if (scope.currentIndex != null) {
              currentIndex = scope.currentIndex;
            }
            customPaging = function(slick, index) {
              return scope.customPaging({
                slick: slick,
                index: index
              });
            };

            // Init needs to be done before slick is called
            slider.on('init', function(event, slick) {
              checkForNoSlide(slick);
              if (attrs.onInit) {
                scope.onInit();
              }
              if (currentIndex != null) {
                return slick.slideHandler(currentIndex);
              }
            });

            slider.slick({
              accessibility: scope.accessibility !== 'false',
              adaptiveHeight: scope.adaptiveHeight === 'true',
              arrows: scope.arrows !== 'false',
              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
              appendArrows: scope.appendArrows ? $(scope.appendArrows) : $(element),
              appendDots: scope.appendDots ? $(scope.appendDots) : $(element),
              autoplay: scope.autoplay === 'true',
              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
              centerMode: scope.centerMode === 'true',
              centerPadding: scope.centerPadding || '50px',
              cssEase: scope.cssEase || 'ease',
              customPaging: attrs.customPaging ? customPaging : void 0,
              dots: scope.dots === 'true',
              draggable: scope.draggable !== 'false',
              easing: scope.easing || 'linear',
              fade: scope.fade === 'true',
              focusOnSelect: scope.focusOnSelect === 'true',
              infinite: scope.infinite !== 'false',
              initialSlide: scope.initialSlide || 0,
              lazyLoad: scope.lazyLoad || 'ondemand',
              beforeChange: attrs.onBeforeChange ? scope.onBeforeChange : void 0,
              onReInit: attrs.onReInit ? scope.onReInit : void 0,
              onSetPosition: attrs.onSetPosition ? scope.onSetPosition : void 0,
              pauseOnHover: scope.pauseOnHover !== 'false',
              responsive: scope.responsive || void 0,
              rtl: scope.rtl === 'true',
              slide: scope.slide || 'div',
              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
              swipe: scope.swipe !== 'false',
              swipeToSlide: scope.swipeToSlide === 'true',
              touchMove: scope.touchMove !== 'false',
              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
              useCSS: scope.useCSS !== 'false',
              variableWidth: scope.variableWidth === 'true',
              vertical: scope.vertical === 'true',
              prevArrow: scope.prevArrow ? $(scope.prevArrow) : void 0,
              nextArrow: scope.nextArrow ? $(scope.nextArrow) : void 0
            });

            slider.on('afterChange', function(event, slick, currentSlide) {
              checkForNoSlide(slick);
              if (scope.onAfterChange) {
                scope.onAfterChange();
              }
              if (currentIndex != null) {
                return scope.$apply(function() {
                  currentIndex = currentSlide;
                  return scope.currentIndex = currentSlide;
                });
              }
            });

            function checkForNoSlide(slick) {
              if (slick.slideCount <= slick.options.slidesToShow) {
                slider.addClass('slick-no-slide');
              } else {
                slider.removeClass('slick-no-slide');
              }
            }

            return scope.$watch('currentIndex', function(newVal) {
              if (currentIndex != null && newVal != null && newVal !== currentIndex) {
                return slider.slick('slickGoTo', newVal);
              }
            });
          });
        };

        if (scope.initOnload) {
          isInitialized = false;
          return scope.$watch('data', function(newVal) {
            if (newVal != null) {
              if (isInitialized) {
                destroySlick();
              }
              initializeSlick();
              return isInitialized = true;
            }
          }, true);
        } else {
          return initializeSlick();
        }
      }
    };
  }
]).
// Used to rate product, it will redirect to review page and pass
// rating as a param
directive('stars', [function() {
  function linker(scope) {
    scope.goToRanking = function(starRating) {
      if (scope.code === '41004' || scope.code === '41005') {
        scope.onSet(starRating, 'shampoo-and-conditioner');
      } else {
        scope.onSet(starRating, scope.url);
      }
    };
    scope.stars = [
      { rank: 5 },
      { rank: 4 },
      { rank: 3 },
      { rank: 2 },
      { rank: 1 }
    ];
  }

  return {
    link: linker,
    restrict: 'EA',
    template: '<span ng-repeat="star in stars" ng-class="{selected: star.rank <= review}" ng-click="goToRanking(star.rank)">&#x2605;</span>',
    scope: {
      review: '=',
      onSet: '=',
      code: '=',
      url: '='
    }
  };
}]).
/* global isMobileDevice */
directive('swatchDropdown', ['$location', function($location) {
  return {
    templateUrl: '/ngpartials/directives/swatch_dropdown',
    transclude: true,
    restrict: 'E',
    scope: {
      products: '=',
      callback: '=?',
      open: '=?',
      selectedUrlKey: '=?',
      bestMatch: '=?'

    },
    link: function(scope) {
      scope.showElement = false;
      scope.initOpen = true;
      scope.callback = scope.callback || function() {};

      var closeDropdown = function(e) {
        // Transverse up the parents of the clikced element (e.target and
        // search for the 'swatch-dropdown' tag/directive tag (using jQuery closest() method).
        // If found then then do nothing,
        // else unbind all click events on the document and a tags and close the swatch
        var swatchEl = $(e.target).closest('swatch-dropdown').length;
        var documentEl = $(document);
        var allLinks = $('.mr-accordion a');

        if (swatchEl) {
          return;
        }

        if (scope.open) {
          //unbind closeDropdown
          documentEl.unbind('click', closeDropdown);
          allLinks.unbind('click', closeDropdown);

          scope.$apply(function() {
            scope.open = false;
          });
        }
      };

      var addDropdownListener = function() {
        var documentEl = $(document);
        var allLinks = $('.mr-accordion a');

        setTimeout(function() {
          //If you click anywhere but on a swatch, and the swatch is open, it should close
          //Unbind just in case there are other click listeners else it will fire multiple times
          //Also, we are specifically listening to the a tags because ng-click on the accordion section  a tag
          //that calls toggleSection is preventing click event from bubbling up to the document
          //where we have the first click listener on.
          documentEl.unbind('click', closeDropdown);
          documentEl.bind('click', closeDropdown);
          allLinks.unbind('click', closeDropdown);
          allLinks.bind('click', closeDropdown);

        }, 100);
      };

      scope.$on('init', function() {
        scope.$parent.safeApply(function() {
          scope.showElement = true;
        });
      });

      scope.$watch('products', function(val) {

        if (val) {
          scope.products.forEach(function(prod) {
            if (prod.url_key === scope.selectedUrlKey) {
              scope.selectProd(prod);
            }
          });

          if (!scope.selectedProd) {
            scope.selectedProd = scope.products[0];
          }
        }
      });

      scope.toggleSwatches = function() {
        scope.open = !scope.open;

        // If the dropdown is open then bind closeDropdown handler
        if (scope.open) {
          addDropdownListener();
        }

      };

      scope.selectProd = function(prod, url) {
        scope.selectedProd = prod;
        if (scope.initOpen) {

          //If a (mobile and not comming from shop/hair-color) or (rtu) open dropdown
          if ((isMobileDevice && document.referrer.indexOf('shop/hair-color') < 0) || prod.product_type === 'root_touch_up') {
            addDropdownListener();
            scope.open = true;
          }

          scope.initOpen = false;
          scope.callback(prod);
        } else {
          scope.open = false;
          $location.path(url);
          scope.callback(prod);
        }
      };
    }
  };
}]).
directive('testimonial', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      quotes: '@',
      sig: '@'
    },
    template: '<div class="quote"><span class="quote-text">{{quotes}}</span><span class="sig"> — {{sig}}</span></div>'
  };
}).
directive('viewTracker', ['trackerSvc', function(trackerSvc) {
  return {
    retstrict: 'EA',
    scope: {
      trackEvent: '@'
    },
    link: function(scope, elem) {
      var hasBeenViewed = false;

      scope.$on('windowScroll', function() {
        if (!hasBeenViewed && isInView()) {
          hasBeenViewed = true;
          trackerSvc.trackEvent(scope.trackEvent);
        }
      });

      function isInView() {
        var elementTop = elem.offset().top;
        var elementBottom = elementTop + elem.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }
    }
  };
}])
.
/**
 * When page loses focus and regains focus the page will reload
 * Originally created for users that have a delinced amazon payment profile.
 * User will be directed to click the edit link on my account payment profile. A new browser tab opens to their amazon payments.
 * When user fixes payment info and they go back to the MR browser tab, the my account page will reload to reflect the updated amazon payments profile
 */
directive('windowFocusRefresh', [function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      var refresh;

      // Set variable refresh to true when target element is clicked
      $(element).on('click', function() {
        refresh = true;
      });

      // When page loses focus and regains focus the page will reload
      // if variable refresh is true, meaning user has clicked on the target element
      $(window).on('focus', function() {
        if (refresh) {
          location.reload();
        }
      });
    }
  };
}]);

/** ****************************************************
  Module mrWebsite.filters
**************************************************** **/
angular.module('mrWebsite.filters', ['ngResource']).
filter('YesNoBlank', function() {
  return function(val) {
    if (val === undefined || val === null || val === '') {
      return '';
    }

    return +val ? 'Yes' : 'No';
  };
}).
filter('advisorValue', function() {
  var mapping = {
    wantLevel: {
      darker: 'Darker',
      same: 'Stay same',
      lighter: 'Lighter'
    },
    hairTone: {
      red: 'Red',
      gold: 'Gold',
      mahogany: 'Mahogany',
      copper: 'Copper',
      ash: 'Ash/Violet',
    },
    colorTreated: {
      no: 'No',
      permanent_color: 'Permanent Color',
      semi_permanent_color: 'Semi-Permanent Color',
      henna: 'Henna',
      highlights: 'Highlights',
      all_over_color: 'All Over Color',
    },
    colorResistantGrays: {
      yes: 'Yes',
      no: 'No',
      maybe: 'Maybe',
      not_sure: 'Unsure'
    },
    grayQuantity: {
      no_gray: 'None',
      less_than_50: 'Some',
      more_than_50: 'Mostly',
      all: 'All',
      not_sure: 'Unsure',
    },
    level: function(value) {
      if (value) {
        return 'Level ' + value;
      }
    }
  };
  return function(value, key) {
    if (value === undefined) {
      return '';
    }

    value = ('' + value).toLowerCase();
    if (mapping[key] instanceof Function) {
      return mapping[key](value) || '';
    }
    return (mapping[key] || {})[value] || '';
  };
}).
filter('advisorWeeks', function() {
  return function(val, allFrequencies) {
    allFrequencies = allFrequencies || [];
    var max = allFrequencies.reduce(function(prev, cur) {
      return Math.max(prev, cur);
    }, 8);
    if (!val) {
      return 'Select frequency';
    }

    var plus = val == max ? '+' : '';
    var weeks = 'Week' + (val > 1 ? 's' : '');

    return 'Every ' + val + plus + ' ' + weeks;
  };
}).
filter('blogDate', ['$filter', function($filter) {
  return function(date, format) {
    format = format || 'MMMM d, y';
    var offset = 180 * 24 * 60 * 60 * 1000; // 6 months
    var dateFilter = $filter('date');
    date = new Date(date);

    if (+date > Date.now() - offset) {
      return 'on ' + dateFilter(date, format);
    }

    return '';
  };
}])
.
filter('capitalize', function() {
  //this filter will greedily capitalize the first character and lowercase all others unless the nameSafe argument is passsed
  //Ex. DrGene McSimmons => Drgene Mcsimmons
  //Ex. with nameSafe argument DrGene McSimmons => DrGene McSimmons
  return function(input, nameSafe) {
    if (input) {
      return input.replace(/([^\W_]+[^\s-]*) */g, function(txt){
        var subStr = txt.substr(1);
        if (!nameSafe) {
          subStr = subStr.toLowerCase();
        }
        return txt.charAt(0).toUpperCase() + subStr;
      });
    } else {
      return '';
    }
  };
})
.
filter('ccDeclinedFilter', function() {
  return function(orders) {
    var filtered = [];
    angular.forEach(orders, function(order) {
      if (order.payment_status != 'declined') {
        filtered.push(order);
      }
    });
    return filtered;
  };
}).
//- limits text based on character limit, also strips any html tags to avoid weird rendering issues
filter('characterLimit', function() {
  return function(input, characters) {

    if (isNaN(characters)) {
      return input;
    }

    if (characters <= 0) {
      return '';
    }

    if (input && typeof input == 'string' && input.length > characters) {
      var newLength = 0;
      var newInput = [];
      //- remove html from string to avoid weird cut offs
      var stripedHtml = input.replace(/<[^>]+>/g, '');
      var inputWords = stripedHtml.split(/\s+/);

      for (var i = 0; i < inputWords.length; i++) {
        if (newLength >= characters) {
          newInput.push('&hellip;');
          break;
        }

        newInput.push(inputWords[i]);
        newLength += inputWords[i].length +1;
      }

      input = newInput.join(' ');
    }

    return input;
  };
})
.
filter('checkStatus', function() {
  return function(status) {
    switch (status) {
      case 'pending':
        return 'Pending';
      case 'reshipped':
      case 'shipped':
        return 'Shipped';
      case 'declined':
        return 'Credit Card Failure';
      case 'canceled':
        return 'Canceled';
      case 'returned':
        return 'Returned';
      case 'completed':
        return 'Completed';
      case 'scheduled':
        return 'Scheduled';
      case 'backordered':
        return 'Back-ordered';
      case 'delivered':
        return 'Delivered';
      default:
      case 'processing':
        return 'Processing';
    }
  };
}).
filter('customCurrency', ["$filter", function ($filter) {
  return function(amount, currencySymbol){
    var currency = $filter('currency');

    if (amount < 0) {
      return currency(amount, currencySymbol).replace("(", "‑").replace(")", ""); // It may not look like it, but "‑" isn't the same as "-". The one used here is a non-breaking hyphen.
    }

    return currency(amount, currencySymbol);
  };
}]).
filter('removeDash', function() {
  return function(input) {
    if (input) {
      return input.replace(/-/g, ' ');
    } else {
      return '';
    }
  };
})
.
filter('freeCurrency', ['$filter', function($filter) {
  return function(amount, currencySymbol) {
    var currency = $filter('currency');
    if (amount == 0) {
      return 'FREE';
    } else {
      return currency(amount, currencySymbol);
    }
  };
}]).
filter('lpad', function() {
  return function(val, size, char) {
    if (val === undefined) {
      return;
    }
    size = size || 4;
    char = char ? String(char) : '0';
    val = String(val);
    while (val.length < size) {
      val = char + val;
    }
    return val;
  };
}).
filter('minMaxRange', function() {
  return function(input, min, max) {
    min = parseInt(min);
    max = parseInt(max);

    for (var i = min; i <= max; i++) {
      input.push(i);
    }
    return input;
  };
}).
filter('naturalSort', function() {
  function naturalSort(a, b) {
    var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
      sre = /(^[ ]*|[ ]*$)/g,
      dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
      hre = /^0x[0-9a-f]+$/i,
      ore = /^0/,
      i = function(s) { return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s; },
      // convert all to strings strip whitespace
      x = i(a).replace(sre, '') || '',
      y = i(b).replace(sre, '') || '',
      // chunk/tokenize
      xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      // numeric, hex or date detection
      xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
      yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
      oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD)
      if (xD < yD) return -1;
      else if (xD > yD) return 1;
    // natural sorting through split numeric strings and default strings
    for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
      oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) { return (isNaN(oFxNcL)) ? 1 : -1; }
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
        oFxNcL += '';
        oFyNcL += '';
      }
      if (oFxNcL < oFyNcL) return -1;
      if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
  }
  return function(arrInput) {
    var arr = arrInput.sort(function(a, b) {
      return naturalSort(a.booth, b.booth);
    });
    return arr;
  };
}).
filter('numberText', function() {
  return function (number) {
    var numText = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
    return numText[+number] || '';
  };
})
.
filter('orderObjectBy', function() {
  return function(items, field, reverse) {
    var filtered = [];
    angular.forEach(items, function(item) {
      filtered.push(item);
    });

    filtered.sort(function (a, b) {
      return (a[field] > b[field] ? 1 : -1);
    });

    if (reverse) {
      filtered.reverse();
    }
    
    return filtered;
  };
})
.
filter('orderYearsFilter', function() {
  return function(orders, year) {
    var filtered = [];
    angular.forEach(orders, function(order) {
      if (order.orderYear == year || year === 'all') {
        filtered.push(order);
      }
    });
    return filtered;
  };
}).
filter('partition', function() {
  var cache = {};
  var filter = function(arr, size) {
    if (!arr) { return; }
    var newArr = [];
    for (var i=0; i<arr.length; i+=size) {
      newArr.push(arr.slice(i, i+size));
    }
    var arrString = JSON.stringify(arr);
    var fromCache = cache[arrString+size];
    if (JSON.stringify(fromCache) === JSON.stringify(newArr)) {
      return fromCache;
    }
    cache[arrString+size] = newArr;
    return newArr;
  };
  return filter;
}).
filter('percent', function() {
  return function(number) {
    return Math.round(number * 100) + '%';
  };
}).
filter('phoneNumber', function() {
  return function (phoneNr) {

    if (!phoneNr) {
      return '';
    }

    var value = phoneNr.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return phoneNr;
    }

    var country, city, number;

    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;

      default:
        return phoneNr;
    }

    if (country == 1) {
      country = "";
    }

    number = number.slice(0, 3) + '-' + number.slice(3);

    return (country + " (" + city + ") " + number).trim();
  };
}).
filter('plural', function() {
  return function(txt, val, extra) {
    var end = 's';
    if (extra) {
      end = extra;
    }
    return val > 1 ? txt + end : txt;
  };
}).
filter('range', function() {
  return function(input, total) {
    total = parseInt(total);
    for (var i = 0; i < total; i++) {
      input.push(i);
    }
    return input;
  };
}).
filter('rpad', function() {
  return function(val, size, char) {
    if (val === undefined) {
      return;
    }
    size = size || 4;
    char = char ? String(char) : '0';
    val = String(val);
    while (val.length < size) {
      val += char;
    }
    return val;
  };
}).
filter('sortByParam', ['$filter', function($filter) {
  return function(arr, param, reverse) {
    if (reverse === '') {
      return arr;
    }

    return $filter('orderBy')(arr, param, reverse);
  };
}]).
filter('startFrom', function() {
  return function(input, start) {
    if (input === undefined) {
      return input;
    } else {
      return input.slice(+start);
    }
  };
}).
filter('subStatusFilter', function() {
  return function(subs, status) {
    var filtered = [];
    angular.forEach(subs, function(sub) {
      if (sub.status === status || status === 'All') {
        filtered.push(sub);
      }
    });
    return filtered;
  };
}).
filter('superscriptCurrency', ["$filter", '$sce', function ($filter, $sce) {
  return function(amount, currencySymbol){
    var currency = $filter('currency');

    var formatted;
    if (amount < 0) {
      formatted = currency(amount, currencySymbol).replace("(", "‑").replace(")", ""); // It may not look like it, but "‑" isn't the same as "-". The one used here is a non-breaking hyphen.
    } else {
      formatted = currency(amount, currencySymbol);
    }

    if (!formatted) {
      return formatted;
    }

    var symbol = formatted[0];
    var html = [];
    if (isNaN(symbol)) {
      formatted = formatted.replace(symbol, '');
      html.push('<sup>' + symbol + '</sup>');
    }
    var parts = formatted.split('.');
    html.push(parts[0]);
    html.push('<sup>' + parts[1] + '</sup>');
    return $sce.trustAsHtml(html.join(''));
  };
}]).
filter('trustHtml', ['$sce', function($sce) {
  return function(input) {
    return $sce.trustAsHtml(input);
  };
}]).
filter("trustUrl", ['$sce', function ($sce) {
  return function(url) {
    return $sce.trustAsResourceUrl(url);
  };
}])
.
filter('valueExists', function() {
  return function(val) {
    if (val === undefined || val === null || val === '') {
      return false;
    }

    return true;
  };
});

/** ****************************************************
  Module mrWebsite.services
**************************************************** **/
angular.module('mrWebsite.services', ['ngResource']).
/* global MR */
factory('addressSvc', ['$rootScope', 'resource', 'loader', 'notifySvc', 'subscriptionSvc', 'phoneNumberFilter', 'Modal', function($rootScope, resource, loader, notifySvc, subscriptionSvc, phoneNumberFilter, Modal) {

  var httpSvc = resource('/api/customer', {}, {
    getAllAddresses: { method: 'GET', url: '/api/customer/getAllAddresses' },
    deleteAddress: { method: 'POST', url: '/api/customer/deleteAddress' },
    addOrUpdateAddress: { method: 'POST', url: '/api/customer/addOrUpdateAddress' },
    setDefaultShipAddress: { method: 'POST', url: '/api/customer/setDefaultShipAddress' },
    validateAddressViaUsps: { method: 'POST', url: '/api/customer/validateAddressViaUsps' },
    getSubscriptionsWithItemsByAddressId: { method: 'GET', url: '/api/subscription/getSubscriptionsWithItemsByAddressId', isArray: true },
    updateShipAddressForSubscriptions: { method: 'POST', url: '/api/subscription/updateShipAddressForSubscriptions' },
    zipCheck: { method: 'GET', url: '/api/usps/zipCheck' }
  });

  var exports = {};

  exports.messages = {
    incomplete: 'Please complete your shipping information.',
    invalid: 'Your shipping information is invalid. Please review.',
    default: 'We were unable to save your shipping address. Please review your information or call us at ' + MR.config.contactPhone, //- <- global
    success: 'Thanks! Your default shipping information has been updated.',
    login: 'We were unable to authenticate your user, please log in again.'
  };

  exports.addressKeys = ['first_name', 'last_name', 'street_1', 'street_2', 'post_code', 'city', 'region', 'phone'];
  //- set up address validation and subscription check modals
  exports.confirmAddressModal = Modal.newModal('confirmAddressModal');

  exports.confirmAddressModal.confirmAddressSave = function() {
    stopSaveProcess();
    addOrUpdateAddress(exports.confirmAddressModal.addrToSave, exports.confirmAddressModal.finishAddrSave);
  };
  exports.confirmAddressModal.cancelAddressSave = function() {
    $rootScope.$broadcast('cancel_address_save');
    exports.savingShipping = false;
  };

  exports.addresses = {};
  exports.addressArr = [];
  exports.inEditMode = false; //- address form is visible when true
  exports.addressInEdit = {}; //- address object being edited
  exports.selectedAddress = {}; //- address currently selected (checkout, sub edit)
  exports.defaultShipAddress = null; //- address object based on is_default_shipping
  exports.hasExistingAddresses = false; //- indicates if user has any addresses
  exports.confirmedShippingAddress = false; //- used in checkout, when false order can not be placed

  exports.cancelEdit = cancelEdit;
  exports.editAddress = editAddress;
  exports.getAddresses = getAddresses;
  exports.deleteAddress = deleteAddress;
  exports.setSelectedAddress = setSelectedAddress;
  exports.startSaveShipAddress = startSaveShipAddress;
  exports.checkForDefaultAddrs = checkForDefaultAddrs;
  exports.runAddressValidation = runAddressValidation;
  exports.updateDefaultShipAddress = updateDefaultShipAddress;
  exports.updateAddressForAllSubs = updateAddressForAllSubs;

  exports.zipCheck = httpSvc.zipCheck;

  getAddresses();

  function Address() {
    this.first_name = '';
    this.last_name = '';
    this.street_1 = '';
    this.street_2 = '';
    this.city = '';
    this.post_code = '';
    this.region = '';
    this.phone = '';
    this.is_default_shipping = true;
    this.updateAllSubs = true;
  }

  $rootScope.$on('reload_addresses', function() {
    getAddresses();
  });

  function getAddresses(cb) {
    cb = cb || angular.noop;
    httpSvc.getAllAddresses(function(res) {
      exports.addressArr = [];
      exports.addresses = res.addresses;

      if (Object.keys(exports.addresses).length) {
        exports.hasExistingAddresses = true;
        Object.keys(exports.addresses).forEach(function(addressId) {
          //- make sure that address id exists on exports.addresses
          if (!Object.hasOwnProperty.call(exports.addresses, addressId)) {
            return;
          }
          exports.addressArr.push(exports.addresses[addressId]);
          exports.addresses[addressId].phone = phoneNumberFilter(exports.addresses[addressId].phone);
          // update object reference for angular
          if (exports.selectedAddress && exports.selectedAddress.id == addressId) {
            exports.selectedAddress = exports.addresses[addressId] || {};
          }
        });
      } else {
        exports.inEditMode = true;
      }

      $rootScope.$broadcast('address_loaded_all');
      checkForDefaultAddrs(cb);
    });
  }

  function checkForDefaultAddrs(callback) {
    var addressKeys = Object.keys(exports.addresses);
    if (addressKeys.length > 0) {
      addressKeys.forEach(function(key) {
        var addr = exports.addresses[key];
        addr.fullDisplayName = [addr.street_1, addr.street_2, addr.city, addr.region, addr.post_code].join(' ');
        if (addr.is_default_shipping) {
          exports.defaultShipAddress = addr;
          exports.defaultShipAddress.phone = phoneNumberFilter(exports.defaultShipAddress.phone);

          if (!exports.selectedAddress.id) {
            exports.selectedAddress = exports.defaultShipAddress || {};
          }
          exports.confirmedShippingAddress = true;
        }
      });
      callback();
    }
  }

  function updateDefaultShipAddress(addressId) {
    httpSvc.setDefaultShipAddress({ address_id: addressId }, function() {
      getAddresses();
      $rootScope.$broadcast('address_set_default');
      notifySvc.notify('success', exports.messages.success);
    }, function(err) {
      notifySvc.notify('error', err.message);
    });
  }

  function editAddress(addressId) {
    var address = exports.addresses[addressId] || new Address();
    //- isDefaultOnLoad tracks the state of is_default_shipping before edit was initiated
    address.isDefaultOnLoad = address.is_default_shipping;
    exports.shippingConfirmed = false;
    exports.addressInEdit = angular.copy(address);
    exports.addressInEdit.phone = phoneNumberFilter(exports.addressInEdit.phone);
    exports.inEditMode = true;
    $rootScope.$broadcast('edit_address');
  }

  function cancelEdit(form) {
    if (!exports.hasExistingAddresses) {
      return;
    }

    if (exports.selectedAddress && exports.selectedAddress.paymentProfileId) {
      exports.confirmedShippingAddress = true;
    }

    exports.inEditMode = false;
    exports.addressInEdit = null;

    if (form) {
      form.$setPristine();
    }
  }

  function setSelectedAddress(addressId) {
    exports.selectedAddress = exports.addresses[addressId] || {};
    exports.confirmedShippingAddress = true;
    $rootScope.$broadcast('address_new_selected', exports.selectedAddress);
  }

  function startSaveShipAddress(addressForm, callback) {
    if (!callback) {
      callback = angular.noop;
    }
    exports.confirmAddressModal.validatedAddress = {};

    if (exports.savingShipping) {
      return;
    }

    if (addressForm.$invalid) {
      addressForm.$setDirty();
      Object.keys(addressForm).forEach(function(key) {
        if (addressForm[key] && addressForm[key].$setDirty) {
          addressForm[key].$setDirty();
        }
      });
      return;
    }

    if (!addressForm.$dirty) {
      exports.selectedAddress = angular.copy(exports.addressInEdit);
      callback();
      return;
    }

    exports.savingShipping = true;
    //- pass address through validation
    runAddressValidation(exports.addressInEdit, function() {
      exports.inEditMode = false;
      addressForm.$setPristine();
      callback();
    });
  }

  //- takes address Obj and callback to execute after address has been saved
  function runAddressValidation(rawAddress, callback) {
    var modal = exports.confirmAddressModal;
    modal.finishAddrSave = callback;

    modal.validatedAddress = {};
    modal.notValidatedAddr = angular.copy(rawAddress);
    httpSvc.validateAddressViaUsps(modal.notValidatedAddr, function(validated) {
      modal.validatedAddress = validated;
      modal.addrToSave = modal.validatedAddress;

      //- compare validated and entered address
      var addrKeys = ["street_1", "street_2", "post_code", "city", "region"];
      for (var i = 0; i < addrKeys.length; i++) {
        // if address does't match open confirm modal
        var key = addrKeys[i];
        var addrPart = modal.notValidatedAddr[key] || '';
        var validPart = validated[key] || '';
        if (addrPart.toUpperCase() != validPart.toUpperCase()) {
          modal.open();
          // avoid validation on save if customer choses notValidated address
          modal.notValidatedAddr.skip_usps = true;
          stopSaveProcess();
          return;
        }
      }

      addOrUpdateAddress(modal.addrToSave, modal.finishAddrSave);
    }, function(err) {
      stopSaveProcess();
      if (err.data && err.data.code && err.data.code == 'INVALID_ADDRESS') {
        //- if address is not valid and doesn't have corrected suggestions prompt user to confirm save with invalid address skipping usps validation
        modal.addrToSave = modal.notValidatedAddr;
        modal.open();
        modal.notValidatedAddr.skip_usps = true;
        return;
      }

      notifySvc.notify('error', 'Your shipping information is invalid. Please review.');
    });
  }

  function stopSaveProcess() {
    exports.savingShipping = false;
    exports.confirmedShippingAddress = false;
    loader.finish();
  }

  function addOrUpdateAddress(address, callback) {
    if (address.updateAllSubs) {
      if (!Array.isArray(address.update_address_for_subs)) {
        address.update_address_for_subs = [];
      }

      angular.forEach(subscriptionSvc.subscriptions, function(sub) {
        address.update_address_for_subs.push(sub.id);
      });
    }

    httpSvc.addOrUpdateAddress(address, function(res) {
      if (res.err) {
        notifySvc.notify('error', exports.messages.default);
        return;
      }

      getAddresses(function() {
        setSelectedAddress(res.id);
        exports.savingShipping = false;
        $rootScope.$broadcast('address_save');
        callback();
      });
    }, function(err) {
      if (err && err.data && err.data.code == "REST_ACCESS_DENIED") {
        notifySvc.notify('error', exports.messages.login);
        window.location = window.location.pathname;
      } else {
        notifySvc.notify('error', exports.messages.invalid);
      }
      exports.savingShipping = false;
    });
  }

  function updateAddressForAllSubs(address) {
    address.updateAllSubs = true;
    //- this will also become customers default shipping
    address.is_default_shipping = true;
    exports.savingShipping = true;
    //- pass address through validation
    runAddressValidation(address, function() {
      exports.inEditMode = false;
      $rootScope.$broadcast('update_address_for_subs');
      notifySvc.notify('success', 'Shipping address for all auto-deliveries has been updated');
    });
  }

  function deleteAddress(address_id) {
    var payload = {
      address_id: address_id
    };

    httpSvc.deleteAddress(payload, function(res) {
      if (res.err) {
        notifySvc.notify("warn", exports.messages.cantDelete);
        return;
      }
      notifySvc.notify('success', 'Your address was successfully removed.');
      $rootScope.$broadcast('address_deleted');
      getAddresses();
    }, function(err) {
      notifySvc.notify('warn', err.data.message);
    });
  }

  return exports;
}]).
factory('advisorSvc', ['resource', function(resource) {
  return resource('/api/advisor', {}, {
    getBestMatch: { method: 'POST', url: '/api/advisor/getBestMatch', isArray: false },
    getAllColorMatches: { method: 'POST', url: '/api/advisor/getAllColorMatches', isArray: false },
    getCustomerMatch: { method: 'POST', url: '/api/advisor/getCustomerMatch' },
    getRecommendations: { method: 'POST', url: '/api/advisor/getRecommendations' },
    getLightWorksRecommendations: { method: 'GET', url: '/api/advisor/getLightWorksRecommendations', isArray: true },
    getBoostRecommendations: { method: 'GET', url: '/api/advisor/getBoostRecommendations', isArray: true },
    getSingleRecsData: { method: 'GET', url: '/api/advisor/getSingleRecsData' },
    getCompareShadesData: { method: 'GET', url: '/api/advisor/getCompareShadesData' },
    getTranslatorData: { method: 'GET', url: '/api/advisor/getTranslatorData' },
    trackTranslationComplete: { method: 'POST', url: '/api/advisor/trackTranslationComplete' },
    getRebootTranslatorData: { method: 'GET', url: '/api/advisor/getRebootTranslatorData' },
    getMoreColorOptions: { method: 'GET', url: '/api/advisor/getMoreColorOptions' },
    shouldSeeColorSolutions: { method: 'GET', url: '/api/advisor/shouldSeeColorSolutions'}
  });
}]).
factory('appLookupSvc', ['resource', function(resource) {
  var httpSvc = resource('/api/appLookup', {}, {
    getRegionsByCountry: { method: 'GET', url: '/api/appLookup/getRegionsByCountry', isArray: true }
  });

  var data = {};

  return {
    getRegionsByCountry: function(params, onSuccess, onError) {
      var country = params.country;
      if (data.regions && data.regions[country]) {
        return onSuccess(data.regions[country]);
      }
      onError = onError || angular.noop;
      httpSvc.getRegionsByCountry(params, function(regions) {
        data.regions = data.regions || {};
        data.regions[country] = regions;
        onSuccess(regions);
      }, onError);
    }
  };
}]).
factory('checkoutSvc', ['resource', function(resource) {
  return resource('/api/checkout', {}, {
    placeOrder: { method: 'POST', url: '/api/checkout/placeOrder' }
  });
}])
.
factory('clientLoggingSvc', ['resource', function(resource) {
  var httpSvc = resource('/api/clientLogging', {}, {
    logDebug: { method: 'POST', url: '/api/clientLogging/logDebug' },
    logError: { method: 'POST', url: '/api/clientLogging/logError' },
    logInfo: { method: 'POST', url: '/api/clientLogging/logInfo' },
    logSilly: { method: 'POST', url: '/api/clientLogging/logSilly' },
    logWarn: { method: 'POST', url: '/api/clientLogging/logWarn' },
  });

  function logDebug(origin, err, path) {
    httpSvc.logDebug({origin: origin, error: splitError(err), path: path});
  }
  
  function logError(origin, err, path) {
    httpSvc.logError({origin: origin, error: splitError(err), path: path});
  }

  function logInfo(origin, err, path) {
    httpSvc.logInfo({origin: origin, error: splitError(err), path: path});
  }

  function logSilly(origin, err, path) {
    httpSvc.logSilly({origin: origin, error: splitError(err), path: path});
  }

  function logWarn(origin, err, path) {
    httpSvc.logWarn({origin: origin, error: splitError(err), path: path});
  }

  // The only way to get stack trace to back end. JS errors are weird.
  function splitError(err) {
    if (!err.stack) {
      return err;
    }

    return err.stack.split('\n');
  }

  return {
    logDebug: logDebug,
    logError: logError,
    logInfo: logInfo,
    logSilly: logSilly,
    logWarn: logWarn
  };
}]).
factory('cmsSvc', ['resource', function(resource) {
  return resource('/api/cmsSvc', {}, {
    renderDeferedComponent: { method: 'GET', url: '/api/cmsSvc/renderDeferedComponent', isArray: false },
    //Must keep POST because we are passing query params or will break blog
    callDeferedGetterMethod: { method: 'POST', url: '/api/cmsSvc/callDeferedGetterMethod', isArray: false }
  });
}]).
factory('colorBarSvc', ['$rootScope', 'resource', 'notifySvc', 'dateFilter', '$window', 'trackerSvc', function($rootScope, resource, notifySvc, dateFilter, $window, trackerSvc) {
  var httpSvc = resource('/api/colorbar', {}, {
    getLocation: { method: 'GET', url: '/api/colorbar/getLocation' },
    loadLocationByCode: { method: 'GET', url: '/api/colorbar/loadLocationByCode' },
    getActiveLocationList: { method: 'GET', url: '/api/colorbar/getActiveLocationList', isArray: true },
    getLocationsGroupedByRegion: { methodL: 'GET', url: '/api/colorbar/getLocationsGroupedByRegion', isArray: true },
    getAvailableDates: { method: 'GET', url: '/api/colorbar/getAvailableDates' },
    getTheFirstAvailableDate: { method: 'GET', url: '/api/colorbar/getTheFirstAvailableDate' },
    getAvailableTimes: { method: 'GET', url: '/api/colorbar/getAvailableTimes', isArray: true },
    createHold: { method: 'POST', url: '/api/colorbar/createHold' },
    createHoldWithAltResource: { method: 'POST', url: '/api/colorbar/createHoldWithAltResource' },
    createAppointment: { method: 'POST', url: '/api/colorbar/createAppointment' },
    getAllCustomerReservations: { method: 'GET', url: '/api/colorbar/getAllCustomerReservations', isArray: true },
    loadCustomerUpcomingAppointments: { method: 'GET', url: '/api/colorbar/loadCustomerUpcomingAppointments', isArray: true },
    loadUnsavedAppointmentFromSession: { method: 'GET', url: '/api/colorbar/loadUnsavedAppointmentFromSession' },
    loadPreviousAppointment: { method: 'GET', url: '/api/colorbar/loadPreviousAppointment' },
    loadAppointment: { method: 'GET', url: '/api/colorbar/loadAppointment' },
    storeUnsavedBookingToSessionAndLogIn: { method: 'POST', url: '/api/colorbar/storeUnsavedBookingToSessionAndLogIn' },
    applyServicePromo: { method: 'POST', url: '/api/colorbar/applyServicePromo' },
    cancelAppointment: { method: 'POST', url: '/api/colorbar/cancelAppointment' },
    confirmAppointment: { method: 'POST', url: '/api/colorbar/confirmAppointment' },
    saveCustomerDetails: { method: 'POST', url: 'api/colorbar/saveCustomerDetails' },
    getOnlineBookingTimes: { method: 'GET', url: 'api/colorbar/getOnlineBookingTimes', isArray: true },
    getColorBarUnlimitedMemberData: { method: 'GET', url: 'api/colorbar/getColorBarUnlimitedMemberData' },
    getColorBarMembershipUsage: { method: 'GET', url: 'api/colorbar/getColorBarMembershipUsage' },
    createWaitlistEntry: { method: 'POST', url: 'api/colorbar/createWaitlistEntry' },
    checkWaitlistForDuplicate: { method: 'GET', url: 'api/colorbar/checkWaitlistForDuplicate', isArray: true },
    preSaveBookingInfo: { method: 'POST', url: '/api/colorbar/preSaveBookingInfo' },
    loadUnconfirmedBooking: { method: 'POST', url: '/api/colorbar/loadUnconfirmedBooking' },
  });

  var exports = {};

  exports.getLocation = httpSvc.getLocation;
  exports.loadLocationByCode = httpSvc.loadLocationByCode;
  exports.getActiveLocationList = httpSvc.getActiveLocationList;
  exports.getLocationsGroupedByRegion = httpSvc.getLocationsGroupedByRegion;
  exports.getAvailableDates = getAvailableDates;
  exports.getTheFirstAvailableDate = httpSvc.getTheFirstAvailableDate;
  exports.getAvailableTimes = httpSvc.getAvailableTimes;
  exports.createHold = httpSvc.createHold;
  exports.createHoldWithAltResource = httpSvc.createHoldWithAltResource;
  exports.createAppointment = httpSvc.createAppointment;
  exports.getAllCustomerReservations = httpSvc.getAllCustomerReservations;
  exports.loadCustomerUpcomingAppointments = httpSvc.loadCustomerUpcomingAppointments;
  exports.loadUnsavedAppointmentFromSession = httpSvc.loadUnsavedAppointmentFromSession;
  exports.loadPreviousAppointment = httpSvc.loadPreviousAppointment;
  exports.loadAppointment = httpSvc.loadAppointment;
  exports.storeUnsavedBookingToSessionAndLogIn = httpSvc.storeUnsavedBookingToSessionAndLogIn;
  exports.applyServicePromo = httpSvc.applyServicePromo;
  exports.cancelAppointment = httpSvc.cancelAppointment;
  exports.confirmAppointment = httpSvc.confirmAppointment;
  exports.saveCustomerDetails = httpSvc.saveCustomerDetails;
  exports.getOnlineBookingTimes = httpSvc.getOnlineBookingTimes;
  exports.getColorBarMembershipUsage = httpSvc.getColorBarMembershipUsage;
  exports.getColorBarUnlimitedMemberData = httpSvc.getColorBarUnlimitedMemberData;
  exports.createWaitlistEntry = httpSvc.createWaitlistEntry;
  exports.checkWaitlistForDuplicate = httpSvc.checkWaitlistForDuplicate;

  exports.initializeAppointmentData = initializeAppointmentData;
  exports.fromCalDate = fromCalDate;
  exports.trackPhoneClickEvent = trackPhoneClickEvent;
  exports.trackWaitlistClickEvent = trackWaitlistClickEvent;
  exports.editAppointment = null;

  exports.preSaveBookingInfo = httpSvc.preSaveBookingInfo;
  exports.loadUnconfirmedBooking = httpSvc.loadUnconfirmedBooking;

  function getAvailableDates(payload, callback) {
    httpSvc.getAvailableDates(payload, function(dates) {
      exports.dates.available = dates;
      callback();
    });
  }

  function trackPhoneClickEvent(eventName, location) {
    document.location.href = 'tel:' + location.phone;
    trackColorBarBookingEvent(eventName + ' - ' + location.name);
  }

  function trackWaitlistClickEvent(eventName, location) {
    trackColorBarBookingEvent(eventName + ' - ' + location.name);
  }

  function trackColorBarBookingEvent(event) {
    var eventName = 'Color Bar Booking';
    event = event.replace('Color Bar Booking: ', ''); // Backwards compatibility
    trackerSvc.trackEvent(eventName, {
      source: event
    });
  }

  function fromCalDate(calDate) {
    var dArr = calDate.toString().replace(/([0-9]{4})([0-9]{2})([0-9]{2})/, '$1-$2-$3').split('-');
    return new Date(parseInt(dArr[0]), parseInt(dArr[1]) - 1, parseInt(dArr[2]), 0, 0, 0);
  }

  function initializeAppointmentData() {
    exports.booking = {
      location: null,
      service: true,
      date: null,
      time: null,
      customer: null,
      comments: null,
      hold: null
    };

    exports.services = {
      all: [],
      selected: null,
      selectedAddon: null
    };

    exports.dates = {
      available: {},
      selected: {
        day: null
      },
      maxDaysInAdvance: 0,
      maxWaitlistDays: 0
    };

    exports.times = {
      selected: {
        time: null
      },
      available: {},
      allTimes: {}
    };

    exports.extraInfo = {
      notes: '',
      longHair: false
    };

    exports.promos = {
      all: [],
      displaySubtotal: null
    };

    exports.savedPromos = {
      all: []
    };

    exports.promoErrors = {
      all: [],
      isEmpty: false
    };

    exports.coupon = {
      code: null
    };
  }

  initializeAppointmentData();
  return exports;
}]).
factory('contactSvc', ['resource', 'loader', 'FileUploader', 'notifySvc', 'scrollToSvc', 'trackerSvc', function(resource, loader, FileUploader, notifySvc, scrollToSvc, trackerSvc) {
  var exports = {};
  var httpSvc = resource('/api/contact/', {}, {
    getCustomerBasicInfo: { method: 'GET', url: '/api/contact/getCustomerBasicInfo' },
    saveCustomerPhoneFromEmail: { method: 'POST', url: '/api/contact/saveCustomerPhoneFromEmail' },
    sendEmail: { method: 'POST', url: '/api/contact/sendEmail' },
    searchFaqs: { method: 'GET', url: '/api/search/searchFaq', isArray: false },
    getColorBarLocations: { method: 'GET', url: '/api/colorbar/listLocations', isArray: true }
  });

  var contact = {
    email: '',
    name: '',
    phone: '',
    preference: '',
    subject: '',
    subjectObj: {},
    message: '',
    first_name: '',
    last_name: '',
    captchaResponse: null
  };

  var authedUser = false;

  exports.sendEmail = httpSvc.sendEmail;
  exports.uploader = initUploader();
  exports.submit = submit;
  exports.searchFaqs = searchFaqs;
  exports.sendSalonEmail = sendSalonEmail;
  exports.getColorBarLocations = getColorBarLocations;

  exports.showForm = true;
  exports.showCaptcha = false;
  exports.contact = contact;
  exports.cbLocations = {};
  exports.faqSuggestions = [];
  exports.selectedCbLocation = null;
  exports.submitting = false;

  var appointments = {
    upcoming: {},
    last: {}
  };

  var uploadError = false;
  getCustomerBasicInfo();

  function getColorBarLocations() {
    if (Object.keys(exports.cbLocations).length) {
      //- in case we already loaded locations no need to do it again
      return;
    }

    httpSvc.getColorBarLocations({ filter: { active: true } }, function(locations) {
      (locations || []).forEach(function(location) {
        exports.cbLocations[location._id] = location;
      });

      if (appointments.upcoming.locationId) {
        exports.selectedCbLocation = exports.cbLocations[appointments.upcoming.locationId];
      } else if (appointments.last.locationId) {
        exports.selectedCbLocation = exports.cbLocations[appointments.last.locationId];
      }
    });
  }

  function initUploader() {
    // Create new instance of FileUploader plugin
    return new FileUploader({
      url: '/api/customer/uploadCustomerImage',
      filters: [{
        name: 'checkMaxSize',
        fn: function(item) {
          // Check if file is over maxSize
          var maxSize = 10000000;
          if (item.size > maxSize) {
            notifySvc.notify('error', item.name + ' is too large. Photos must be less than 7 MB in size.');
            return false;
          }
          return true;
        }
      }, {
        name: 'checkFileLimit',
        fn: function() {
          // Make sure the amount of files being uploaded is not over maxLimit
          var maxLimit = 3;
          if (exports.uploader.queue.length >= maxLimit) {
            notifySvc.notify('error', "We're sorry. We currently allow up to " + maxLimit + " photos per request.");
            return false;
          } else {
            return true;
          }
        }
      }, {
        name: 'imageFilter',
        fn: function(item) {
          var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
          return '|jpg|png|jpeg|bmp|'.indexOf(type) !== -1;
        }
      }]
    });
  }

  function submit(uploader, trackEvent, callback) {
    if (exports.submitting) {
      return;
    }
    exports.submitting = true;
    callback = callback || function() {};
    contact.photos = [];
    loader.start();
    // If nothing to upload then just send email
    if (!uploader || !uploader.queue.length) {
      return sendEmail(trackEvent, callback);
    }

    // Send email with attachments
    upload(uploader, trackEvent, callback);
  }

  function searchFaqs(subject) {
    var subj = subject || (exports.contact.subjectObj.subject + ' ' + exports.contact.message);
    var payload = {
      q: subj
    };

    httpSvc.searchFaqs(payload, function(searchResults) {
      exports.faqSuggestions = searchResults.hits || [];
    });
  }

  function upload(uploader, trackEvent, callback) {
    callback = callback || function() {};
    // upload all photos in uploader queue
    uploader.uploadAll();

    // uploader event handlers
    uploader.onErrorItem = function() {
      exports.showForm = true;
      notifySvc.notify('error', 'Sorry, something went wrong while uploading your photo.');
      uploadError = true;
      loader.finish();
      exports.submitting = false;
    };

    uploader.onCompleteItem = function(fileItem, response) {
      // when each uploads completes push into that contact object that will eventually be submitted
      var photo = {
        name: response.file_name,
        path: response.url,
        type: response.file_type
      };
      contact.photos.push(photo);
    };

    uploader.onCompleteAll = function() {
      if (!uploadError) {
        return sendEmail(trackEvent, callback);
      }
      return;
    };
  }

  function sendEmail(trackEvent, callback) {
    callback = callback || function() {};
    if (contact.subjectObj && contact.subjectObj.ticketType == 'colorbar') {
      contact.colorbar_location_name = exports.selectedCbLocation.name;
      contact.colorbar_location_code = exports.selectedCbLocation.code;
    }

    httpSvc.sendEmail(contact, function() {
      exports.showForm = false;
      exports.contact.open = false;
      // you need to have a '.thankyou-div' otherwise by default it will scroll to top of page
      setTimeout(function() {
        scrollToSvc.scrollToElement('.thankyou-div', 40);
      }, 300);

      loader.finish();
      exports.submitting = false;

      if (trackEvent) {
        trackerSvc.trackEvent(trackEvent);
      }

      if (authedUser) {
        saveCustomerPhoneFromEmail();
      }
      callback();
    }, function(err) {
      callback(err);
      if (err && err.data && err.data.code == 'CAPTCHA') {
        exports.showCaptcha = true;
        notifySvc.notify('info', err.data.message);
      } else if (err.data && err.data.validations) {
        var validations = err.data.validations;
        Object.keys(validations).forEach(function(validationError) {
          notifySvc.notify('error', validations[validationError].message);
        });
      } else {
        notifySvc.notify('error', 'Sorry, something went wrong.');
      }

      loader.finish();
      exports.submitting = false;
      if (err.data && err.data.code != 'CAPTCHA') {
        throw err;
      }
    });
  }

  function sendSalonEmail() {
    // Salon contact form has first_name and last_name field instead of name
    if (contact.name == '') {
      contact.name = contact.first_name + ' ' + contact.last_name;
    }
    contact.ticketType = 'salon';
    submit();
  }

  function getCustomerBasicInfo() {
    httpSvc.getCustomerBasicInfo(function(result) {
      var customer = result.customer;
      appointments.upcoming = result.upcomingAppointment || {};
      appointments.last = result.pastAppointment || {};
      // If the user is authenticated, then we must save the phone number (only) to her profile.
      if (customer.email !== '') {
        authedUser = true;
      }
      contact.email = customer.email;
      contact.first_name = customer.firstName;
      contact.last_name = customer.lastName;
      contact.name = customer.firstName;

      if (customer.lastName && customer.lastName !== '') {
        contact.name += ' ' + customer.lastName;
      }
      if (customer.phoneMain && customer.phoneMain !== '') {
        contact.phone = customer.phoneMain;
      }
    });
  }

  function saveCustomerPhoneFromEmail() {
    var noOp = function() {};
    var customer = {
      phone: contact.phone
    };
    httpSvc.saveCustomerPhoneFromEmail(customer, noOp);
  }


  return exports;
}])
.
factory('contentSvc', ['resource', function(resource) {
  var svc = resource('/api/contentReview', {}, {
    getProductReviews: { method: 'GET', url: '/api/contentReview/getProductReviews' },
    getApprovedReviewsInfo: { method: 'GET', url: '/api/contentReview/getProductReviewsSummary' },
    getReviewSummariesForProducts: { method: 'GET', url: '/api/contentReview/getReviewSummariesForProducts' },
    canUserReview: { method: 'GET', url: '/api/contentReview/canUserReview' },
    getRandomFiveStarReview: { method: 'GET', url: '/api/contentReview/getRandomFiveStarReview' },
    voteForReview: { method: 'POST', url: '/api/contentReview/voteForReview' }
  });

  svc.getProductReviewsSummary = function(product, callback) {
    var payload = { product_id: product.id };

    return svc.getApprovedReviewsInfo(payload, callback);
  };

  return svc;
}])
.
/* global redirectUrl */
factory('customerSvc', ['$rootScope', 'resource', 'notifySvc', 'dateFilter', '$window', function($rootScope, resource, notifySvc, dateFilter, $window) {
  var httpSvc = resource('/api/customer', {}, {
    newsletterSignUp: { method: 'POST', url: '/api/customer/newsletterSignUp' },
    smsOptInOut: { method: 'POST', url: '/api/customer/smsOptInOut' },
    saveRecommendations: { method: 'POST', url: '/api/customer/saveRecommendations' },
    createCustomer: { method: 'POST', url: '/api/customer/createCustomer' },
    createCustomerFromEmailCapture: { method: 'POST', url: '/api/customer/createCustomerFromEmailCapture' },
    disableEmailGate: { method: 'POST', url: '/api/customer/disableEmailGate' },
    getCustomerInfo: { method: 'GET', url: '/api/customer/getCustomerInfo' },
    gatherCustomerShoppingData: { method: 'GET', url: '/api/customer/gatherCustomerShoppingData' },
    facebook: { method: 'POST', url: '/api/customer/facebookLogin' },
    encodeFacebookUserId: { method: 'POST', url: '/api/customer/encodeFacebookUserId' },
    updateAcc: { method: 'POST', url: '/api/account/updateAccount' },
    uploadPhoto: { method: 'POST', url: '/api/account/uploadPhoto' },
    login: { method: 'POST', url: '/api/customer/login' },
    forgotPassword: { method: 'POST', url: '/api/customer/forgotPassword' },
    sendPasswordResetSMS: { method: 'POST', url: '/api/customer/sendPasswordResetSMS' },
    logOut: { method: 'POST', url: '/api/customer/logout' },
    getSignInData: { method: 'GET', url: '/api/customer/getSignInData' },
    verifyCipherStr: { method: 'GET', url: '/api/customer/verifyCipherStr' },
    resetPassword: { method: 'POST', url: '/api/customer/resetPassword' },
    resetAccount: { method: 'POST', url: '/api/customer/resetAccount' },
    updatePassword: { method: 'POST', url: '/api/customer/updatePassword' },
    requiresLogin: { method: 'POST', url: '/api/customer/requiresLogin' },
    getRecsChatStatus: { method: 'GET', url: '/api/customer/getRecsChatStatus' },
    getMarketingPreferencesByUserId: { method: 'GET', url: '/api/customer/getMarketingPreferencesByUserId' },
    setMarketingPreferences: { method: 'POST', url: '/api/customer/setMarketingPreferences' },
    setRecsChatStatus: { method: 'POST', url: '/api/customer/setRecsChatStatus' },
    createConciergeTicket: { method: 'POST', url: '/api/customer/createConciergeTicket' },
    getAllCustomInstructionsForCustomer: { method: 'GET', url: '/api/customer/getAllCustomInstructionsForCustomer', isArray: true },
    sendPasswordCreateEmail: { method: 'POST', url: '/api/customer/sendPasswordCreateEmail' },
  });

  var exports = {};

  exports.createCustomer = httpSvc.createCustomer;
  exports.createCustomerFromEmailCapture = httpSvc.createCustomerFromEmailCapture;
  exports.disableEmailGate = httpSvc.disableEmailGate;
  exports.facebook = httpSvc.facebook;
  exports.encodeFacebookUserId = httpSvc.encodeFacebookUserId;
  exports.uploadPhoto = httpSvc.uploadPhoto;
  exports.login = httpSvc.login;
  exports.create = httpSvc.create;
  exports.forgotPassword = httpSvc.forgotPassword;
  exports.sendPasswordResetSMS = httpSvc.sendPasswordResetSMS;
  exports.sendPasswordCreateEmail = httpSvc.sendPasswordCreateEmail;
  exports.logOut = httpSvc.logOut;
  exports.resetPassword = httpSvc.resetPassword;
  exports.resetAccount = httpSvc.resetAccount;
  exports.getSignInData = httpSvc.getSignInData;
  exports.verifyCipherStr = httpSvc.verifyCipherStr;
  exports.requiresLogin = httpSvc.requiresLogin;

  exports.getCustomerInfo = getCustomerInfo;
  exports.checkIfExistingUser = checkIfExistingUser;
  exports.newsletterSignUp = newsletterSignUp;
  exports.wifiSignUp = wifiSignUp;
  exports.saveRecommendations = saveRecommendations;
  exports.getRecsChatStatus = getRecsChatStatus;
  exports.setRecsChatStatus = setRecsChatStatus;
  exports.createConciergeTicket = createConciergeTicket;
  exports.updatePassword = updatePassword;
  exports.resetEditProfile = resetEditProfile;
  exports.cancelEditProfile = cancelEditProfile;
  exports.updateCustomerInfo = updateCustomerInfo;
  exports.checkUserLoginError = checkUserLoginError;
  exports.writeReview = writeReview;
  exports.checkSmsInputs = checkSmsInputs;
  exports.getMarketingPreferencesByUserId = getMarketingPreferencesByUserId;
  exports.gatherCustomerShoppingData = gatherCustomerShoppingData;
  exports.updateMarketingPrefsStatus = updateMarketingPrefsStatus;
  exports.getAllCustomInstructionsForCustomer = getAllCustomInstructionsForCustomer;
  exports.createAccountPayload = createAccountPayload;

  exports.existingUser = {
    email: ''
  };

  exports.customer = {};
  exports.passwordData = {};
  exports.editProfileInfo = {};
  exports.recentOrders = {};
  exports.phoneMask = '(999) 999-9999';

  exports.userAttemptedSubmit = false;
  exports.newsletterMessage = null;
  exports.marketingPreferences = {
    loaded: false
  };

  exports.isSubscribed = null;
  exports.customerEmail = '';
  exports.customerSource = '';
  exports.colorConcierge = {
    showForm: false,
    messageFormElement: 'input',
    message: ""
  };

  exports.smsOptions = {
    mobileNumber: '',
    optInSms: false
  };

  exports.groupedSubs = null;
  exports.inactiveSubs = [];
  exports.purchaseHistory = [];
  exports.customInstructions = [];
  exports.upcomingAppointments = [];

  checkIfExistingUser();
  getRecsChatStatus();

  $rootScope.$on('reload_customer_credits', function() {
    getCustomerInfo();
  });
  //- in case where customer updates payment profile that needs attention
  $rootScope.$on('payment_profile_modified', function() {
    gatherCustomerShoppingData();
  });

  function getCustomerInfo(callback) {
    callback = callback || angular.noop;
    httpSvc.getCustomerInfo({}, function(customer) {
      exports.customer = customer;
      exports.marketingPreferences = customer.marketingPreferences;

      if (customer.phone_mobile) {
        exports.smsOptions.mobileNumber = formatPhoneNumber(customer.phone_mobile);
      }
      exports.smsOptions.optInSms = exports.marketingPreferences.optInSms;

      $rootScope.$broadcast('customer_loaded');
      callback(customer);
    }, function() {
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function gatherCustomerShoppingData() {
    httpSvc.gatherCustomerShoppingData({}, function(res) {
      exports.inactiveSubs = res.groupedSubs.inactive || [];
      delete res.groupedSubs.inactive;

      if (!Object.keys(res.groupedSubs).length) {
        res.groupedSubs = null;
      }

      exports.groupedSubs = res.groupedSubs;
      exports.purchaseHistory = res.purchaseHistory.filter(function(purchase) {
        return purchase.product.product_type !== 'service_charge';
      });
      exports.recentOrders = res.recentOrders;
      exports.declinedPayments = res.declinedPayments;
      //- leave it null when nothing there so we can use this on the template for ng-if
      exports.customerPromos = Object.keys(res.customerPromos).length ? res.customerPromos : null;
      exports.upcomingAppointments = res.upcomingAppointments;

      $rootScope.$broadcast('shopping_data_loaded');
    });
  }

  function saveRecommendations(email, source, listId) {
    exports.userAttemptedSubmit = true;
    //- clear message
    exports.newsletterMessage = null;
    var params = {
      email: email,
      email_source: source,
      list_id: listId
    };

    httpSvc.saveRecommendations(params, function() {
      var MessengerExtensions = MessengerExtensions || null;
      exports.isSubscribed = true;
      if (MessengerExtensions) {
        setTimeout(function() {
          MessengerExtensions.requestCloseBrowser(function() {}, function() {});
        }, 2000);
      }
    }, function(err) {
      if (err.data && err.data.message) {
        return exports.newsletterMessage = err.data.message;
      }
      exports.newsletterMessage = 'We were not able to save your recommendations.';
    });
  }

  function newsletterSignUp(email, source, listId) {
    //- clear message
    exports.newsletterMessage = null;
    var params = {
      email: email,
      email_source: source,
      list_id: listId
    };

    httpSvc.newsletterSignUp(params, function() {
      exports.isSubscribed = true;
    }, function(err) {
      if (err.data && err.data.message) {
        return exports.newsletterMessage = err.data.message;
      }
      exports.newsletterMessage = 'We were not able to save your email.';
    });
  }

  function checkIfExistingUser() {
    httpSvc.getSignInData(function(data) {
      if (!data.email) {
        exports.isSubscribed = false;
        return;
      }
      exports.isSubscribed = true;
      exports.existingUser.email = data.email;
    });
  }

  function getRecsChatStatus() {
    httpSvc.getRecsChatStatus(function(results) {
      exports.recsChatStatus = results.status;
    }, function(err) {
      if (err) {
        exports.recsChatStatus = 'expanded';
      }
    });
  }

  function setRecsChatStatus() {
    exports.recsChatStatus = 'collapsed';
    var params = {
      status: "collapsed"
    };
    httpSvc.setRecsChatStatus(params, function() {});
  }

  function createConciergeTicket() {
    var params = {
      message: exports.colorConcierge.message
    };

    httpSvc.createConciergeTicket(params, function() {
      exports.colorConcierge.messageFormElement = 'success';
      setTimeout(function() {
        exports.colorConcierge.showForm = !exports.colorConcierge.showForm;
        exports.colorConcierge.messageFormElement = 'input';
      }, 5000);
    }, function() {
      exports.colorConcierge.messageFormElement = 'error';
      setTimeout(function() {
        exports.colorConcierge.showForm = !exports.colorConcierge.showForm;
        exports.colorConcierge.messageFormElement = 'input';
      }, 5000);
    });
  }

  function cancelEditProfile() {
    resetEditProfile();
  }

  function resetEditProfile() {
    exports.editProfileInfo = angular.copy(exports.customer);
  }

  function updateMarketingPrefsStatus(unsubChanged) {
    if (unsubChanged && exports.marketingPreferences.unsub) {
      Object.keys(exports.marketingPreferences.messages).forEach(function(key) {
        exports.marketingPreferences.messages[key] = false;
      });
    }

    if (exports.marketingPreferences.unsub) {
      Object.keys(exports.marketingPreferences.messages).some(function(key) {
        if (exports.marketingPreferences.messages[key]) {
          exports.marketingPreferences.unsub = false;
          return true;
        }
      });
    }

    var unsubMessages = [];
    exports.marketingPreferences.allMessageTypes.forEach(function(key) {
      if (!exports.marketingPreferences.messages[key] || exports.marketingPreferences.unsub) {
        unsubMessages.push(key);
      }
    });

    exports.marketingPreferences.unsubMessages = unsubMessages;

    var payload = {
      email: exports.customer.email,
      marketingPreferences: exports.marketingPreferences
    };

    httpSvc.setMarketingPreferences(payload, function() {
      notifySvc.notify('success', 'Your marketing preferences have been updated.');
    }, function() {
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function updateCustomerInfo() {
    exports.savingProfile = true;

    var birthday;
    if (exports.editProfileInfo.birthdayShort) {
      birthday = exports.editProfileInfo.birthdayShort.substring(0, 2) + '/' + exports.editProfileInfo.birthdayShort.substring(2, 4) + '/1896';
    }

    if (dateFilter(birthday, 'shortDate') !== dateFilter(exports.customer.birthdayShort, 'shortDate')) {
      exports.editProfileInfo.birthday = birthday;
    } else {
      delete exports.editProfileInfo.birthday;
    }

    if (exports.editProfileInfo.phone_main && exports.editProfileInfo.sameAsPrimary) {
      exports.editProfileInfo.phone_mobile = exports.editProfileInfo.phone_main;
    }

    exports.editProfileInfo.marketingPreferences = exports.marketingPreferences;

    exports.editProfileInfo.marketingPreferences.mobilePhone = exports.editProfileInfo.phone_mobile;

    httpSvc.updateAcc(exports.editProfileInfo, function(res) {
      exports.savingProfile = false;
      if (res.validation) {
        angular.forEach(res.validation, function(err) {
          var errMsg = err;
          if (err == 'invalid date') {
            errMsg = 'Birthday date is invalid. Please update and try again.';
          }
          notifySvc.notify('error', errMsg);
        });
        return;
      }
      getCustomerInfo(resetEditProfile);
      notifySvc.notify('success', 'Your account has been updated.');

      if (res.sendSMSOptIn) {
        notifySvc.notify('info', "You've opted-in to receive SMS messages. Check your phone to complete the process");
      }
    }, function(err) {
      exports.savingProfile = false;
      checkUserLoginError(err);
      var error = 'We were not able to update your info. Please try again or contact Color Crew';
      if (err.data && err.data.message) {
        error = err.data.message;
      }
      notifySvc.notify('error', error);
    });
  }

  function updatePassword(callback) {
    callback = callback || angular.noop;
    exports.passwordData.savingPassword = true;

    httpSvc.updatePassword(exports.passwordData, function() {
      exports.passwordData = {};
      notifySvc.notify('success', 'You have successfully updated your password.');
      callback();
    }, function() {
      exports.passwordData = {};
      notifySvc.notify('error', 'We were not able to update your password. Please try again or contact Color Crew');
    });
  }

  //- checks error is user not logged in error, if so will redirect to signin and return true
  function checkUserLoginError(errObj) {
    if (!(errObj && errObj.data && errObj.data.message)) {
      return false;
    }
    //If the error message has 'not logged in'
    var isNotLogged = ~errObj.data.message.indexOf('not logged in');
    //Redirect to login page
    var errorDetails = errObj.data.errorDetails || [];
    var doRedirect = errorDetails.some(function(detail) {
      return detail.doRedirect;
    });

    if (doRedirect && isNotLogged) {
      $window.location.reload();
      return true;
    }
    return false;
  }

  function getAllCustomInstructionsForCustomer() {
    exports.customInstructions = [];
    httpSvc.getAllCustomInstructionsForCustomer(function(instructions) {
      exports.customInstructions = instructions;
    }, function() {
      notifySvc.notify('error', 'Sorry, we couldn\'t find any instructions. Please contact Color Crew if you keep experiencing this issue.');
    });
  }

  function getMarketingPreferencesByUserId() {
    httpSvc.getMarketingPreferencesByUserId(function(res) {
      exports.marketingPreferences = res;
      if (res.mobile_number) {
        exports.smsOptions.mobileNumber = formatPhoneNumber(res.mobile_number);
      }
      exports.smsOptions.phoneMask = '(999) 999-9999';
      exports.marketingPreferences.loaded = true;
    });
  }

  function checkSmsInputs(noPhoneCallback) {
    noPhoneCallback = noPhoneCallback || angular.noop;
    if (!exports.smsOptions.mobileNumber || !exports.smsOptions.mobileNumber.length) {
      exports.smsOptions.optInSms = false;
      noPhoneCallback();
      notifySvc.notify('warn', 'Not able to update SMS notifications, please check your mobile phone number.');
      return;
    }
    exports.savingProfile = true;

    // check to update phone_mobile
    if (exports.customer.id && !exports.customer.phone_mobile) {
      httpSvc.updateAcc({ phone_mobile: exports.smsOptions.mobileNumber }, function() {
        callSMSOptInOut();
      });
    } else {
      callSMSOptInOut();
    }

    function callSMSOptInOut() {
      exports.smsOptions.email = exports.existingUser.email;
      httpSvc.smsOptInOut(exports.smsOptions, function() {
        exports.savingProfile = false;
        var message = ['You have ' + (!exports.smsOptions.optInSms ? 'unsubscribed' : 'subscribed') + ' to order updates & reminders via SMS'];
        if (exports.smsOptions.optInSms) {
          message.push('Check your phone to complete the process.');
        }
        notifySvc.notify('success', message.join(' '));
      }, function() {
        exports.savingProfile = false;
        notifySvc.notify('error', 'We were not able to update your SMS preferences');
      });
    }
  }

  function formatPhoneNumber(phone) {
    var newPhone = phone.replace('+1', '');
    return '(' + newPhone.slice(0, 3) + ')' + ' ' + newPhone.slice(3, 6) + '-' + newPhone.slice(6, 10);
  }

  function writeReview(url, rating) {
    var href = '/product/' + url + '/review';
    if (rating !== undefined) {
      href += '?stars=' + rating;
    }
    $window.location.href = href;
  }

  function wifiSignUp(user, baseGrantUrl, userContinueUrl) {
    if (!user.email) {
      return notifySvc.notify('error', 'Email field is empty');
    }
    user.email_source = 'colorBarWiFi';
    var payload = createAccountPayload(user);
    httpSvc.newsletterSignUp(payload, function() {
      $window.location.href = decodeURIComponent(baseGrantUrl) + '?continue_url=' + decodeURIComponent(userContinueUrl);
    }, function(err) {
      if (window.Raygun) {
        window.Raygun
          .withTags(['colorBarWiFi'])
          .send(new Error('Color Bar WiFi email error'), { config: err.config, data: err.data });
      }
      $window.location.href = decodeURIComponent(baseGrantUrl) + '?continue_url=' + decodeURIComponent(userContinueUrl);
    });
  }

  function createAccountPayload(user) {
    var fakeBirthdayYear = 1896;
    var birthday;
    if (user.birthday) {
      birthday = new Date(user.birthday + '/' + fakeBirthdayYear);
    }

    return {
      email: user.email,
      password: user.password,
      confirm: user.password,
      url: redirectUrl || false,
      email_source: user.email_source || 'website',
      optInEmail: user.optInEmail,
      birthday: birthday,
      captchaResponse: user.captchaResponse,
    };
  }

  return exports;
}]).
factory('dataHub', function(){
  var data = {};

  return {
    getData: function(key) {
      return data[key];
    },
    saveData: function(key, val) {
      data[key] = val;
    },
    resetData: function(key) {
      delete data[key];
    }
  };
}).
factory('dispositionSvc', ['resource', function(resource) {
  return resource('/api/disposition', {}, {
    getEmailUnsubscribeReasons: { method: 'GET', url: '/api/disposition/getEmailUnsubscribeReasons', isArray: true },
    setEmailUnsubscribeDisposition: { method: 'POST', url: '/api/disposition/setEmailUnsubscribeDisposition', isArray: false }
  });
}]).
factory('emailSvc', ['notifySvc', 'preferenceSvc', 'cdata', 'resource', 'mrNgUtils', '$cookies', function(notifySvc, preferenceSvc, cdata, resource, mrNgUtils, $cookies) {
  var exports = {};

  exports.setEmailSubPreferences = setEmailSubPreferences;
  exports.preferencesUpdatedModal = {
    show: false
  };
  exports.email = '';
  exports.allMessageTypes = [];

  if ($cookies.iterableEndUserId) {
    exports.email = decodeURIComponent($cookies.iterableEndUserId);
  } else if (cdata.user && cdata.user.email) {
    exports.email = cdata.user.email;
  }

  exports.iterable = {};

  preferenceSvc.getMarketingPreferences({email: exports.email}, function(res) {
    res = res || {};


    var unsubbedChannels = res.iterableChannel || [];
    var unsubbedMessages = res.iterableMessages || [];
    exports.allMessageTypes = res.allMessageTypes || [];

    if (unsubbedChannels.length) {
      exports.iterable.unsubscribe = true;
    }

    exports.allMessageTypes.forEach(function(key) {
      exports.iterable[key] = unsubbedMessages.indexOf(key) == -1;
    });
  });

  exports.onChange = function(unsub) {
    if (unsub && exports.iterable.unsubscribe) {
      Object.keys(exports.iterable).forEach(function(key) {
        if (key != 'unsubscribe') {
          exports.iterable[key] = false;
        }
      });
    }

    if (exports.iterable.unsubscribe) {
      Object.keys(exports.iterable).some(function(key) {
        if (exports.iterable[key] && key != 'unsubscribe') {
          exports.iterable.unsubscribe = false;
          return true;
        }
      });
    }
  };

  //- update customer email subscription preferences
  function setEmailSubPreferences() {
    var unsubMessages = [];
    exports.allMessageTypes.forEach(function(key) {
      if (!exports.iterable[key] || exports.iterable.unsubscribe) {
        unsubMessages.push(key);
      }
    });

    var payload = {
      email: exports.email,
      marketingPreferences: {
        unsub: exports.iterable.unsubscribe,
        unsubMessages: unsubMessages
      },
      hideSpinner: true
    };

    // Automatically pop modal. User should not have to wait for response back to see update confirmation modal.
    exports.preferencesUpdatedModal.show = true;

    preferenceSvc.setMarketingPreferences(payload,
      // For success callback status do nothing (angular.noop)
      angular.noop,
      // Error callback notify user of error
      function() {
        exports.preferencesUpdatedModal.show = false;
        notifySvc.notify('error', 'Sorry, something went wrong while updating your preferences.');
    });
  }

  return exports;
}])
.
factory('experimentSvc', ['resource', function(resource) {
  return resource('/experiment', {}, {
    getVariantForExperiment: { method: 'GET', url: '/api/experiment/getVariantForExperiment' },
  });
}])
.
factory('faqSvc', ['$rootScope', 'resource', function($rootScope, resource) {
  var httpSvc = resource('/rest/press', {}, {
    getCategorizedFaqs: { method: 'GET', url: '/api/faqs/getCategorizedFaqs', isArray: false },
  });

  var hashParams = window.location.hash.split('/');

  var exports = {
    allFaqs: {},
    selectedCategoryQuestions: {},
    selectedCategory: hashParams[1], //- category always comes first
    selectedQuestion: hashParams[2], //- second is question
    highlightSelectedQuestion: hashParams[2] && hashParams[2].length ? true : false
  };

  exports.selectCategory = selectCategory;
  exports.selectQuestion = selectQuestion;

  httpSvc.getCategorizedFaqs({}, function(res) {
    exports.allFaqs = res.faqMap;
    exports.selectedCategoryQuestions = exports.allFaqs[exports.selectedCategory] ? exports.allFaqs[exports.selectedCategory].questions : {};
    
    //- if nothing in params preselect the first category and question
    if (!exports.selectedCategory) {
      var sortedCategoryKeys = sortAlphabetically(Object.keys(exports.allFaqs));
      selectCategory(sortedCategoryKeys[0]);
      var sortedQuestionKeys = sortAlphabetically(Object.keys(exports.selectedCategoryQuestions));
      selectQuestion(sortedQuestionKeys[0]);
    }

    $rootScope.$broadcast('FAQsLoaded', exports.allFaqs);
  });

  function selectCategory(category) {
    exports.selectedQuestion = '';
    exports.selectedCategory = category;
    exports.selectedCategoryQuestions = exports.allFaqs[category].questions;
  }

  function selectQuestion(questionKey) {
    exports.highlightSelectedQuestion = false;
    exports.selectedQuestion = questionKey;
  }

  function sortAlphabetically(array) {
    array.sort(function(a, b){
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });

    return array;
  }

  return exports;
}]).
factory('gaEventSvc', [], function() {
  // custom events for google analytics
  var exports = {};
  exports.gaEvents = {
    'orders': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'manage orders'
    },
    'profile': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'my profile'
    },
    'shipping': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'shipping & billing'
    },
    'changeDelivery': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'change delivery date'
    },
    'shipNow': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'ship now'
    },
    'cancelOrders': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'cancel all future orders'
    },
    'changeColor': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'change my color'
    },
    'changeColorReorder': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'change my color and reorder'
    },
    'reorder': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'reorder now',
      'nonInteraction': true
    },
    'accountInformation': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'account information'
    },
    'fbConnect': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'connect with facebook'
    },
    'editAccountInfo': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit account information'
    },
    'hairProfile': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'hair profile'
    },
    'editHairProfile': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit hair profile'
    },
    'customInstructions': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'my customized instructions'
    },
    'message': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'message center'
    },
    'editEmail': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit email'
    },
    'unsubscribe': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'unsubscribe from all the emails above'
    },
    'editAddress': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit address'
    },
    'addAddress': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'add a new address'
    },
    'editPayment': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit payment'
    },
    'addPayment': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'add payment'
    }
  };

  return exports;
}).
/* global redirect */
factory('giftcardSvc', ['$rootScope', 'resource', 'notifySvc', 'newCartSvc', function($rootScope, resource, notifySvc, newCartSvc) {

  var httpSvc = resource('/api/customer', {}, {
    getAllGiftcards: { method: 'GET', url: '/api/giftcard/getAllGiftcards', isArray: true },
    addToCart: { method: 'POST', url: '/api/cart/addToCart', isArray: false },
    getProductsByType: { method: 'GET', url: '/api/product/getProductsByType', isArray: true },
    redeem: { method: 'POST', url: '/api/giftcard/redeem' },
    validateGiftcard: { method: 'POST', url: '/api/giftcard/validateGiftcard' }
  });

  var exports = {};

  exports.messages = {
    giftcardAdded: 'Succesfully added gift card to your profile.',
    somethingWrong: 'Something went wrong, please try again or contact Color Crew'
  };

  exports.giftCard = {
    senderEmail: '',
    senderName: '',
    giftcardProduct: {},
    sendNow: true
  };

  var future = new Date();
  var minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);
  future.setMonth(future.getMonth() + 3);

  exports.sendDateOptions = {
    minDate: new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate()),
    maxDate: new Date(future.getFullYear(), future.getMonth(), future.getDate())
  };

  exports.giftcards = [];

  exports.getAllGiftcards = getAllGiftcards;
  exports.addGiftcardToCart = addGiftcardToCart;
  exports.redeem = redeem;
  exports.showDatePicker = showDatePicker;
  exports.validateGiftcard = validateGiftcard;

  function getAllGiftcards() {
    httpSvc.getAllGiftcards(function(res) {
      // check cart for existing giftcard in session and if found prepopulate the form
      newCartSvc.getCartItems(function(items) {
        // sort them here instead of on the template so we can assign default value
        exports.giftcards = res.sort(function(a, b) {
          return a.price - b.price;
        });
        // select $50 gift card by default (after sort it is second element in the array)
        exports.giftCard.giftcardProduct = exports.giftcards[1];

        items.some(function(item) {
          if (item.giftCard) {
            exports.giftCard = item.giftCard;
            var sendAt = exports.giftCard.sendAt;

            if (sendAt) {
              exports.giftCard.sendAt = new Date(exports.giftCard.sendAt);
            }

            exports.giftcards.forEach(function(card) {
              if (card.id == exports.giftCard.giftcardProduct.id) {
                exports.giftCard.giftcardProduct = card;
              }
            });
            return true;
          }
        });
      });
    }, function() {
      notifySvc.notify('error', exports.messages.somethingWrong);
    });
  }

  function addGiftcardToCart() {
    if (exports.giftCard.sendNow) {
      exports.giftCard.sendAt = null;
    }

    var payload = {
      product_id: exports.giftCard.giftcardProduct.id, // Whatever the ID for the gift card is
      qty: 1,
      subscription: 0,
      giftCard: exports.giftCard
    };

    httpSvc.addToCart(payload, function() {
      redirect('/cart');
    }, function(err) {
      var error = exports.messages.somethingWrong;
      if (err.data && err.data.message) {
        error = err.data.message;
      }
      notifySvc.notify('error', error);
    });
  }

  function validateGiftcard(form) {
    httpSvc.validateGiftcard(exports.giftCard, function(res) {
      if (!res.invalid) {
        return exports.showForm = false;
      }

      Object.keys(res.invalid).forEach(function(key) {
        form[key].$setValidity('required', false);
      });
      notifySvc.notify('error', 'Please check your form for invalid fields');
    });
  }

  function redeem(giftCode) {
    httpSvc.redeem({ code: giftCode }, function() {
      $rootScope.$broadcast('reload_customer_credits');
      notifySvc.notify('success', exports.messages.giftcardAdded);
    }, function(err) {
      var error = exports.messages.somethingWrong;
      if (err.data && err.data.message) {
        error = err.data.message;
      }
      notifySvc.notify('error', error);
    });
  }

  function showDatePicker(elementId) {
    angular.element(elementId).datepicker('show');
  }

  return exports;
}]).
factory('greenhouseSvc', ['resource', function(resource) {
  return resource('/api/greenhouse', {}, {
    submitJobApplication: { method: 'POST', url: '/api/greenhouse/submitJobApplication', isArray: false }
  });
}])
.
factory('imageSvc', ['$window', 'loader', 'FileUploader', 'notifySvc', 'trackerSvc', function($window, loader, FileUploader, notifySvc, trackerSvc) {
  var exports = {};

  exports.uploadSupport = uploadSupport;
  exports.upload = upload;
  exports.eventName = 'Photo Submitted';
  exports.uploading = false;
  exports.uploader = new FileUploader({
    url: '/api/customer/uploadCustomerImage'
  });

  exports.uploader.filters.push({
    name: 'checkMaxSize',
    fn: function(item) {
      // Check if file is over maxSize
      var maxSize = 10000000;
      if (item.size > maxSize) {
        notifySvc.notify('error', item.name + ' is too large. Photos must be less than 7 MB in size.');
        return false;
      }
      return true;
    }
  });

  exports.uploader.filters.push({
    name: 'checkFileLimit',
    fn: function() {
      // Make sure the amount of files being uploaded is not over maxLimit
      var maxLimit = 3;
      if (exports.uploader.queue.length >= maxLimit) {
        notifySvc.notify('error', "We're sorry. We currently allow up to " + maxLimit + " photos per request.");
        return false;
      } else {
        return true;
      }
    }
  });

  exports.uploader.filters.push({
    name: 'imageFilter',
    fn: function(item) {
      var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
      var isImage = '|jpg|png|jpeg|bmp|'.indexOf(type) !== -1;
      if (!isImage) {
        notifySvc.notify('error', item.name + ' is not a recognized image type.');
      }
      return isImage;
    }
  });

  function uploadSupport() {
    return !!($window.FileReader && $window.CanvasRenderingContext2D);
  }

  function upload(cb) {
    cb = cb || angular.noop;

    if (exports.uploading) {
      return;
    }

    if (!exports.uploader || !exports.uploader.queue.length) {
      return cb();
    }

    exports.uploading = true;

    loader.start();
    trackerSvc.trackEvent(exports.eventName, {
      numImages: exports.uploader.queue.length
    });
    exports.uploader.uploadAll();

    exports.uploader.onErrorItem = function() {
      notifySvc.notify('error', 'Sorry, something went wrong while uploading your photo.');
      exports.uploading = false;
      cb();
    };

    exports.uploader.onCompleteAll = function() {
      exports.uploader.clearQueue();
      loader.finish();
      exports.uploading = false;
      cb();
    };
  }

  return exports;
}]).
factory('loader', ['$timeout', function($timeout) {
  var loaderBG = $('#ajaxLoaderBG');
  var loaderContent = $('#ajaxLoaderContent');
  var reqCount = 0;
  var timeoutId;

  function startLoader(immediately) {
    var delay = immediately ? 0 : 2000;
    timeoutId = $timeout(function() {
      loaderBG.fadeIn('fast');
      loaderContent.show();
    }, delay);
  }

  function stopLoader() {
    $timeout.cancel(timeoutId);
    loaderBG.fadeOut('fast');
    loaderContent.fadeOut('fast');
  }

  return {
    start: function(immediately) {
      if (!reqCount) {
        startLoader(immediately);
      }

      reqCount++;
    },

    finish: function() {
      reqCount--;

      if (!reqCount) {
        stopLoader();
      }
    }
  };
}]).
service('location', ['$location', '$rootScope', function($location, $rootScope) {
  $location.skipReload = function() {
    var un = $rootScope.$on('$stateChangeStart', function(event) {
      event.preventDefault();
      un();
    });
    return $location;
  };

  return $location;
}]).
factory('manageFlowSvc', ['$rootScope', 'notifySvc', 'resource', 'mrNgUtils', function($rootScope, notifySvc, resource, mrNgUtils) {
  var httpSvc = resource('/api/subscription', {}, {
    getCancelReasons: { method: 'GET', url: '/api/subscription/getCancelReasons' },
    getSubPauseDates: { method: 'GET', url: '/api/subscription/getSubPauseDates', isArray: true }
  });

  var exports = {};

  exports.sub = {};
  exports.defaultPauseMonths = 3;
  exports.cancelReasons = [];
  //- setting fallback date, once we get more accurat valid dates for subs we update this date
  //- so it take in to account weekends and holidays
  exports.defaultPauseDate = mrNgUtils.addMonthsToDate(new Date(), exports.defaultPauseMonths);

  exports.manageAutoDelivery = {
    selected: null,
    actions: [{
        text: 'Change Color',
        action: function() {
          $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/change-color');
          clearActions();
        }
      },
      {
        text: 'Change Date or Frequency',
        action: function() {
          $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/change');
          clearActions();
        }
      },
      {
        text: 'Ship It Now',
        action: function() {
          $rootScope.go('/account/next-delivery/' + exports.sub.id + '/ship-now');
          clearActions();
        }
      },
      {
        text: 'Pause Auto Delivery',
        action: function() {
          $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/pause-it');
          clearActions();
        }
      },
      {
        text: 'Stop Auto Delivery',
        action: function() {
          $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/stop');
          clearActions();
        }
      },
      {
        text: 'Change Shipping Address',
        action: function() {
          $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/change-address');
          clearActions();
        }
      },
      {
        text: 'Change Payment Method',
        action: function() {
          $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/change-payment');
          clearActions();
        }
      },
    ]
  };

  exports.pauseAutoDelivery = {
    selected: null,
    actions: []
  };

  exports.stopAutoDelivery = {
    selected: null,
    actions: []
  };

  exports.deliveryCancelation = {
    selected: null,
    actions: []
  };

  exports.stopActions = [{
      text: 'Choose Your Own Delivery Date',
      action: function() {
        $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/change');
        clearActions();
      }
    },
    {
      text: 'Permanently',
      helperText: 'Shipments will be stopped',
      action: function() {
        $rootScope.go('/account/auto-delivery/' + exports.sub.id + '/cancel-reasons');
        clearActions();
      }
    }
  ];

  exports.initFlow = initFlow;

  function initFlow(sub) {
    if (sub.id == exports.sub.id) {
      //- no need to reinitialize
      return;
    }
    exports.sub = sub;
    clearActions();
    getCancelReasons();
    generatePauseActions();
  }

  function clearActions() {
    exports.manageAutoDelivery.selected = null;
    exports.pauseAutoDelivery.selected = null;
    exports.deliveryCancelation.selected = null;
  }

  function getCancelReasons() {
    httpSvc.getCancelReasons({
      product_type: exports.sub.product_type,
      randomize: true
    }, function(res) {
      var hasNNN = exports.sub.code.indexOf('NNN') < -1;
      exports.cancelReasons = res.reasons.map(function(reason) {
        reason.mention_nnn = !hasNNN && reason.mention_nnn;
        return reason;
      });

      exports.deliveryCancelation.actions = (res.reasons || []).map(function(reason) {
        var cancelAction = {
          text: reason.reason,
          value: reason
        };

        if (~[2].indexOf(reason.id)) {
          cancelAction.action = function() {
            cancelActionCallback('/cancel/save', this.value);
          };
        } else if (~[1].indexOf(reason.id)) {
          cancelAction.action = function() {
            cancelActionCallback('/cancel/pause', this.value);
          };
        } else if (~[6, 7, 8, 9, 10, 11, 12, 14, 16, 17].indexOf(reason.id)) {
          cancelAction.action = function() {
            cancelActionCallback('/cancel/satisfaction', this.value);
          };
        } else {
          cancelAction.action = function() {
            cancelActionCallback('/cancel/general', this.value);
          };
        }

        return cancelAction;
      });
    });
  }

  function cancelActionCallback(cancelPath, reason) {
    exports.deliveryCancelation.selected.reason = reason;
    $rootScope.go('/account/auto-delivery/' + exports.sub.id + cancelPath);
  }

  function generatePauseActions() {
    if (!exports.sub.next) {
      return;
    }
    httpSvc.getSubPauseDates({ sub_id: exports.sub.id, frequency: 4 }, function(res) {
      var pauseDates = res;
      var newChoices = [];
      for (var i = 0; i < pauseDates.length; i++) {
        var choice = {};
        var currentMonth = i + 1;
        choice.text = currentMonth + ' Month' + (currentMonth > 1 ? 's' : '');
        choice.type = 'pause';
        choice.value = new Date(pauseDates[i]);

        if (currentMonth == exports.defaultPauseMonths) {
          exports.defaultPauseDate = pauseDates[i];
        }

        var m = ('0' + (choice.value.getMonth() + 1)).substr(-2);
        var d = ('0' + choice.value.getDate()).substr(-2);

        choice.helperText = 'Next ship date on ' + m + '/' + d;
        exports.pauseAutoDelivery.actions.push(choice);
        exports.stopAutoDelivery.actions.push(choice);
      }

      exports.stopAutoDelivery.actions = exports.pauseAutoDelivery.actions.concat(newChoices, exports.stopActions);
    });
  }

  return exports;
}]).
factory('Modal', function() {
  var modalFactory = {
    modals: {},
    veil: false,
    veilDisabled: false
  };

  modalFactory.newModal = function(name) {
    var modal = modalFactory.modals[name] = {
      show: false
    };

    modal.close = function() {
      var hideVeil = true;
      modal.show = false;
      angular.forEach(modalFactory.modals, function(modal) {
        if (modal.show == true) {
          hideVeil = false;
        }
      });
      if (hideVeil) {
        modalFactory.hideVeil();
      }
    };

    modal.open = function() {
      modal.show = true;
      modalFactory.showVeil();
    };

    return modal;
  };

  modalFactory.closeAll = function() {
    for (var modal in modalFactory.modals) {
      modalFactory.modals[modal].close();
    }
  };

  modalFactory.hideVeil = function() {
    modalFactory.veil = false;
    // $('body').removeClass('noscroll');
  };

  modalFactory.showVeil = function() {
    modalFactory.veil = true;
    // $('body').addClass('noscroll');
  };

  return modalFactory;
})
.
factory('modalSvc', ['mrNgUtils', function(mrNgUtils) {
  var exports = {};
  exports.modals = {};

  exports.createModal = createModal;
  exports.showModal = showModal;
  exports.hideModal = hideModal;

  function createModal(modalId, limitCookie, urlParam, urlParamValue) {
    if (!exports.modals[modalId]) {
      exports.modals[modalId] = {
        show: true
      };

      if (limitCookie) {
        exports.modals[modalId].cookie = limitCookie;
        if ($.cookie(limitCookie)) {
          exports.modals[modalId].show = false;
        }
        $.cookie(limitCookie, "viewed", { expires: 1 }); // cookie expires in 1 day
      }

      if (urlParam && urlParamValue) {
        exports.modals[modalId].urlParam = urlParam;
        exports.modals[modalId].urlParamValue = urlParamValue;
        checkUrlParams(urlParam, urlParamValue) ? '' : exports.modals[modalId].show = false;
      }
    }
  }

  function showModal(modalId) {
    if (!exports.modals[modalId]) {
      exports.modals[modalId] = {
        show: true
      };
    } else if (exports.modals[modalId].cookie) {
      if (!$.cookie()[exports.modals[modalId].cookie]) {
        exports.modals[modalId].show = true;
      }
    }
  }

  function hideModal(modalId) {
    if (!exports.modals[modalId]) {
      exports.modals[modalId] = {};
    }
    exports.modals[modalId].show = false;
  }

  // Helper functions

  function checkUrlParams(param, value) {
    var params = mrNgUtils.locationSearchParams();
    return params[param] && ~params[param].indexOf(value);
  }

  return exports;
}]).
factory('mrNgUtils', function() {
  var mrNgUtils = {};

  mrNgUtils.chunkArray = chunkArray;
  mrNgUtils.specialKey = specialKey;
  mrNgUtils.isJson = isJson;
  mrNgUtils.updateQueryStringParameter = updateQueryStringParameter;
  mrNgUtils.locationSearchParams = locationSearchParams;
  mrNgUtils.getShortDateString = getShortDateString;
  mrNgUtils.addMonthsToDate = addMonthsToDate;
  mrNgUtils.getHeight = getHeight;

  // splits data array in sub arrays by size attribute
  function chunkArray(arr, size) {
    var newArr = [];
    for (var i=0; i<arr.length; i+=size) {
      newArr.push(arr.slice(i, i+size));
    }
    return newArr;
  }

  // this function returns true if the event has a key code
  // for tab, shift, or an arrow key
  function specialKey($event) {
    var keyCode = $event.keyCode;
    if (keyCode == 9 || keyCode == 16 || keyCode == 19 || keyCode == 37 || keyCode == 38 || keyCode == 39 || keyCode == 40) {
      return true;
    }
  }

  function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  function locationSearchParams() {
    var search = window.location.search;
    if (!search) {
      return {};
    }
    var params = {};
    search.replace(/^\?/, '').split('&').forEach(function(paramStr) {
      var part = paramStr.split('=');
      params[part[0]] = part[1];
    });
    return params;
  }

  function getShortDateString(date) {
    date = new Date(date);
    var m = ('0' + (date.getMonth() + 1)).substr(-2);
    var d = ('0' + date.getDate()).substr(-2);

    return date.getFullYear() + '-' + m + '-' + d;
  }

  function addMonthsToDate(date, months) {
    var next = new Date(date);
    return new Date(next.setMonth(next.getMonth() + months));
  }

  function getHeight(selector) {
    var height = 0;
    $(selector).each(function(index, element) {
      height += element.clientHeight;
    });
    return height;
  }

  return mrNgUtils;
}).
factory('mrProductCatalogUtils', function() {
  var mrProductCatalogUtils = {};

  // Filter products active and visible
  mrProductCatalogUtils.filterActive = function(products) {
    return products.filter(function(val) {
      return (val.status === 1 && val.visible === 1);
    });
  };

  mrProductCatalogUtils.filterColorNumber = function(products) {
    return products.sort(function(a, b) {
      return a.color_number > b.color_number;
    });
  };

  return mrProductCatalogUtils;
})
.
factory('mrWindowHistory', function() {
  var exports = {};

  exports.back = back;
  exports.forward = forward;
  exports.go = go;

  function back() {
    window.history.back();
  }

  function forward() {
    window.history.forward();
  }

  function go(int) {
    window.history.go(int);
  }

  return exports;
})
.
// The old cartSvc that is located in mrServices should be depreciated
// as soon as mr cart is refactored and we got rid of old endpoints
factory('newCartSvc', ['resource', '$cookies', '$rootScope', 'cdata', 'trackerSvc', function(resource, $cookies, $rootScope, cdata, trackerSvc) {
  var cartHttpSvc = resource('/api/cart', {}, {
    getCartItems: { method: 'GET', url: '/api/cart/getCartItems', isArray: true },
    getShippingMethods: { method: 'GET', url: '/api/cart/getShippingMethods', isArray: false },
    getShipDate: { method: 'GET', url: '/api/cart/getShipDate', isArray: false },
    getDeliveryRange: { method: 'GET', url: '/api/cart/getDeliveryRange', isArray: false },
    getAddons: { method: 'GET', url: '/api/cart/getAddons', isArray: true },
    getTotals: { method: 'POST', url: '/api/cart/getTotals', isArray: false },
    getCartItemCount: { method: 'GET', url: '/api/cart/getCartItemCount', isArray: false },
    addProduct: { method: 'POST', url: '/api/cart/addProduct', isArray: false },
    addProducts: { method: 'POST', url: '/api/cart/addProducts', isArray: false },
    addToCart: { method: 'POST', url: '/api/cart/addToCart', isArray: false },
    addMultipleItemsToCart: { method: 'POST', url: '/api/cart/addMultipleItemsToCart', isArray: false },
    reorderAddToCart: { method: 'POST', url: '/api/cart/reorderAddToCart', isArray: false },
    updateItemQty: { method: 'POST', url: '/api/cart/updateItemQty', isArray: false },
    applyCoupon: { method: 'POST', url: '/api/cart/applyCoupon', isArray: false },
    applyCoupons: { method: 'POST', url: '/api/cart/applyCoupons', isArray: false },
    applyPromo: { method: 'POST', url: '/api/cart/applyPromo', isArray: false },
    removeItemFromCart: { method: 'POST', url: '/api/cart/removeItemFromCart', isArray: false },
    updateItemSubscription: { method: 'POST', url: '/api/cart/updateItemSubscription', isArray: false },
    setShippingMethod: { method: 'POST', url: '/api/cart/setShippingMethod', isArray: false },
    setUseGiftCards: { method: 'POST', url: '/api/cart/setUseGiftCards', isArray: false },
    setShippingAddress: { method: 'POST', url: '/api/cart/setShippingAddress', isArray: false },
    removeCoupon: { method: 'POST', url: '/api/cart/removeCoupon', isArray: false },
    moveToOtherCart: { method: 'POST', url: '/api/cart/moveToOtherCart', isArray: false },
    shipRefillWithCart: { method: 'POST', url: '/api/cart/shipRefillWithCart', isArray: false },
    getCartDataForView: { method: 'GET', url: '/api/cart/getCartDataForView', isArray: false }
  });

  var exports = {
    cartType: $cookies.cartType || 'active'
  };
  var noOp = function() {};

  exports.cart = {};
  exports.addonsAdded = {};
  exports.reloading = {
    shippingAddress: false,
    items: false,
    shippingMethods: false,
    shipDate: false,
    addons: false,
    addonsByContext: false,
    totals: false
  };
  exports.waiting = [];
  exports.highlightSubItems = false;
  exports.hasColorInCart = false;
  exports.firstColorInCart = undefined;
  exports.noMoreValidOffers = false;

  exports.getInitialCache = getInitialCache;
  exports.recacheCartData = recacheCartData;
  exports.getCartItems = getCartItems;
  exports.updateFirstColorInCart = updateFirstColorInCart;
  exports.getShippingMethods = getShippingMethods;
  exports.getShipDate = getShipDate;
  exports.getDeliveryRange = getDeliveryRange;
  exports.getAddons = getAddons;
  exports.trackCrossSell = trackCrossSell;
  exports.getTotals = getTotals;
  exports.setCartItemCountInCookie = setCartItemCountInCookie;
  exports.addProduct = addProduct;
  exports.addProducts = addProducts;
  exports.addToCart = addToCart;
  exports.addToCartUpdateAddons = addToCartUpdateAddons;
  exports.addMultipleItemsToCart = addMultipleItemsToCart;
  exports.reorderAddToCart = reorderAddToCart;
  exports.updateItemQty = updateItemQty;
  exports.applyCoupon = applyCoupon;
  exports.applyCoupons = applyCoupons;
  exports.applyPromo = applyPromo;
  exports.removeItemFromCart = removeItemFromCart;
  exports.updateItemSubscription = updateItemSubscription;
  exports.setShippingMethod = setShippingMethod;
  exports.setShippingAddress = setShippingAddress;
  exports.setUseGiftCards = setUseGiftCards;
  exports.removeCoupon = removeCoupon;
  exports.moveToOtherCart = moveToOtherCart;
  exports.shipRefillWithCart = shipRefillWithCart;

  getInitialCache();

  // Helper functions
  function recacheCartDataIfNeeded(key, args) {
    var cb;
    for (var i = 0; i < args.length; i++) {
      if (cb) {
        break;
      }

      if (typeof args[i] == 'function') {
        cb = args[i];
      }
    }

    if (!cb) {
      cb = angular.noOp;
    }

    if (exports.reloading[key]) {
      exports.waiting.push(function() {
        cb(exports.cart[key]);
      });
      return;
    }

    if (exports.cart.hasOwnProperty(key)) {
      return cb(exports.cart[key]);
    }

    recacheCartData(key, function() {
      cb(exports.cart[key]);
    });
  }

  function recacheCartData(specifics, cb) {
    var initialCartDataCache = null;

    if (arguments.length == 1) {
      cb = specifics;
      specifics = ['all'];
    }

    if (specifics.initialCartDataCache) {
      initialCartDataCache = specifics.initialCartDataCache;
    }

    if (!Array.isArray(specifics)) {
      specifics = [specifics];
    }

    if (specifics.length == 1 && specifics[0] == 'all') {
      specifics = Object.keys(exports.reloading);
    }

    specifics.forEach(function(key) {
      exports.reloading[key] = true;
    });
    var params = {
      keys: specifics
    };

    // If initialCartDataCache
    if (initialCartDataCache) {
      specifics.forEach(function(key) {
        exports.reloading[key] = false;
      });

      return cb(initialCartDataCache);
    }

    params.cartType = exports.cartType;

    cartHttpSvc.getCartDataForView(params, function(data) {
      // Updating values that changed, not overwriting the whole cached cart object
      Object.keys(data).forEach(function(key) {
        if (key.indexOf('$') === 0) {
          return;
        }
        exports.cart[key] = data[key];
      });

      // reset selectedShippingMethod
      exports.cart.shippingMethods.methods.forEach(function(method) {
        if (method.code == exports.cart.shippingMethods.selected.code) {
          exports.cart.shippingMethods.selected = method;
        }
      });

      cb(data);
      while (exports.waiting.length) {
        exports.waiting.pop()(data);
      }
      specifics.forEach(function(key) {
        exports.reloading[key] = false;
      });
    });
  }

  function trackCrossSell() {
    var addons = exports.cart.addons || [];

    var trackProps = {
      products: addons.map(function(product, index) {
        return {
          id: product.id,
          name: product.name,
          code: product.code,
          position: index + 1
        };
      })
    };

    trackerSvc.trackEvent('Cross-sell Items Viewed', trackProps);
  }

  function callHttpSvc(method, params, reloadPartial, successFunc, failFunc) {
    if (reloadPartial && reloadPartial.length == 1 && reloadPartial[0] == 'all') {
      reloadPartial = Object.keys(exports.reloading);
    }
    if (!successFunc) {
      successFunc = noOp;
    }
    if (!failFunc) {
      failFunc = noOp;
    }
    if (!Array.isArray(reloadPartial)) {
      reloadPartial = [];
    }

    params.cartType = params.cartType || exports.cartType;

    cartHttpSvc[method](params, function(response) {
      reloadPartial.forEach(function(key) {

        if (response.hasOwnProperty(key)) {
          exports.cart[key] = response[key];
        }

        if (key === 'items') {
          updateFirstColorInCart();
        }
      });

      successFunc(response);
    }, failFunc);
  }
  // end Helper functions

  function getInitialCache(specifics, cb) {
    switch (arguments.length) {
      case 1:
        cb = specifics;
        specifics = ['all'];
        break;
      case 0:
        cb = noOp;
        specifics = ['all'];
        break;
    }

    recacheCartData(specifics, function(results) {
      updateFirstColorInCart();
      exports.cart.isLoaded = true;
      $rootScope.$broadcast('cart_loaded');
      cb(results);
    });
  }

  function getCartItems() {
    recacheCartDataIfNeeded('items', arguments);
  }

  function updateFirstColorInCart() {

    exports.firstColorInCart = (exports.cart.items || []).reduce(function(found, item) {
      return !found && item && item.product_type === 'color_kit' ? item : found;
    }, undefined);

    exports.hasColorInCart = !!exports.firstColorInCart;
  }

  function getShippingMethods() {
    recacheCartDataIfNeeded('shippingMethods', arguments);
  }

  /**
   * Get shipDate for cart.
   *
   * @param {Function} cb a callback function
   */
  function getShipDate(cb) {
    cb = cb || noOp;
    cartHttpSvc.getShipDate(function(res) {
      exports.cart.shipDate = res.shipDate;
      cb();
    });
  }

  /**
   * Gets a delivery range based on the shippingMethod.
   *
   * @param {object} shippingMethod shipping method object
   * @param {Function} cb a callback function
   */
  function getDeliveryRange(shippingMethod, cb) {
    cb = cb || noOp;
    cartHttpSvc.getDeliveryRange({ shippingMethod: shippingMethod }, function(res) {
      exports.cart.deliveryRange = res.deliveryRange;
      cb();
    });
  }

  function getAddons() {
    recacheCartDataIfNeeded('addons', arguments);
  }

  function getTotals() {
    recacheCartDataIfNeeded('totals', arguments);
  }

  function setCartItemCountInCookie() {
    cartHttpSvc.getCartItemCount(function(res) {
      if (res.count) {
        $cookies.cic = res.count;
      }
    });
  }

  function addProduct(params, successFunc, failFunc) {
    callHttpSvc('addProduct', params, false, successFunc, failFunc);
  }

  function addProducts(params, successFunc, failFunc) {
    callHttpSvc('addProducts', params, false, successFunc, failFunc);
  }

  function addToCart(params, successFunc, failFunc) {
    callHttpSvc('addToCart', params, ['items', 'totals', 'addons', 'addonsByContext'], successFunc, failFunc);
  }

  function addToCartUpdateAddons(params, successFunc, failFunc) {
    exports.addingProduct = true;
    successFunc = successFunc || noOp;
    failFunc = failFunc || noOp;
    var noMoreValidOffers = true;

    exports.addonsAdded[params.product.id] = true;

    if (params.product.product_type == 'bundle') {
      params.product.products.forEach(function(p) {
        exports.addonsAdded[p.id] = true;
      });
    }

    callHttpSvc('addToCart', params, false, function(result) {
      exports.addingProduct = false;
      if (result.addons && exports.cart.addons) {
        result.addons.forEach(function(resultAddon) {
          if (resultAddon.validOffer) {
            noMoreValidOffers = false;
          }
          exports.cart.addons.forEach(function(cartAddon) {
            if (cartAddon.code == resultAddon.code) {
              Object.keys(resultAddon).forEach(function(key) {
                cartAddon[key] = resultAddon[key];
              });
              Object.keys(cartAddon).forEach(function(key) {
                if (cartAddon[key] && !resultAddon[key]) {
                  delete cartAddon[key];
                }
              });
            }
          });
        });
      }
      exports.noMoreValidOffers = noMoreValidOffers;
      successFunc(result);
    }, function(err) {
      exports.addingProduct = false;
      failFunc(err);
    });
  }

  function addMultipleItemsToCart(params, successFunc, failFunc) {
    callHttpSvc('addMultipleItemsToCart', params, ['items', 'totals', 'addons', 'addonsByContext'], successFunc, failFunc);
  }

  function reorderAddToCart(params, successFunc, failFunc) {
    callHttpSvc('reorderAddToCart', params, ['items', 'totals', 'addons'], successFunc, failFunc);
  }

  function updateItemQty(params, successFunc, failFunc) {
    callHttpSvc('updateItemQty', params, ['items', 'totals'], successFunc, failFunc);
  }

  function applyCoupon(params, successFunc, failFunc) {
    callHttpSvc('applyCoupon', params, ['all'], successFunc, failFunc);
  }

  function applyCoupons(params, successFunc, failFunc) {
    callHttpSvc('applyCoupons', params, ['all'], successFunc, failFunc);
  }

  function applyPromo(params, successFunc, failFunc) {
    callHttpSvc('applyPromo', params, ['all'], successFunc, failFunc);
  }

  function removeItemFromCart(params, successFunc, failFunc) {
    callHttpSvc('removeItemFromCart', params, ['items', 'totals', 'addons', 'addonsByContext'], successFunc, failFunc);
  }

  function updateItemSubscription(params, successFunc, failFunc) {
    callHttpSvc('updateItemSubscription', params, ['items', 'totals'], successFunc, failFunc);
  }

  function setShippingMethod(params, successFunc, failFunc) {
    callHttpSvc('setShippingMethod', params, ['totals'], successFunc, failFunc);
  }

  function setShippingAddress(params, successFunc, failFunc) {
    callHttpSvc('setShippingAddress', params, ['totals', 'shippingMethods'], successFunc, failFunc);
  }

  function removeCoupon(params, successFunc, failFunc) {
    callHttpSvc('removeCoupon', params, ['all'], successFunc, failFunc);
  }

  function moveToOtherCart(params, successFunc, failFunc) {
    callHttpSvc('moveToOtherCart', params, ['items', 'totals', 'addons', 'refillCart'], successFunc, failFunc);
  }

  function shipRefillWithCart(params, successFunc, failFunc) {
    callHttpSvc('shipRefillWithCart', params, false, successFunc, failFunc);
  }

  function setUseGiftCards(params, successFunc, failFunc) {
    callHttpSvc('setUseGiftCards', params, ['totals'], successFunc, failFunc);
  }

  return exports;
}]).
factory('notifySvc', ['resource', '$rootScope', '$timeout', function(resource, $rootScope, $timeout) {
  var exports = {};
  var httpSvc = resource('/api/notify/', {}, {
    emptyBackendNotificationsArray: { method: 'GET', url: '/api/notify/emptyBackendNotificationsArray' }
  });

  /**
   * Utility function for displaying notification messages in the UI.
   * @param type [string] - The message type. [error, warn, info, success] This string is used as a class for the notification so you can make custom notification styles.
   * @param message [string] - The text of the notification.
   * @param displayTime [number] - [Optional] length of time in milliseconds that you want the notification to display. Defaults to 5000 (5s). If you pass 0 the user will have to click the close box to dismiss it.
   **/
  // This varable is used to generate incremental notification ids
  var notification_id = 0;
  exports.notifications = [];
  exports.messages = {
    canNotCompleteTransaction: 'Sorry, we couldn\'t finish the transaction. Please contact Color Crew if you keep experiencing this issue'
  };

  exports.notify = notify;
  exports.removeNotification = removeNotification;
  exports.emptyBackendNotificationsArray = emptyBackendNotificationsArray;

  function notify(type, message, displayTime) {
    if (angular.isUndefined(displayTime)) {
      displayTime =  5000;
    }
    var noteId = notification_id++;

    for (var i = 0; exports.notifications.length > i; i++) {
      if (exports.notifications[i].message === message) {
        return;
      }
    }

    exports.notifications.push({
      id: noteId,
      class: type,
      message: message
    });

    $rootScope.$applyAsync();
    if (displayTime) {
      $timeout(removeNotification.bind(null, noteId), displayTime);
    }
    return noteId;
  }

  function removeNotification(noteId) {
    var noteIdx;
    var notes = exports.notifications;
    for (noteIdx = 0; noteIdx < notes.length; noteIdx++) {
      if (notes[noteIdx].id == noteId) {
        break;
      }
    }
    if (noteIdx < notes.length) {
      exports.notifications.splice(noteIdx, 1);
      $rootScope.$applyAsync();
    }
  }

  function emptyBackendNotificationsArray() {
    httpSvc.emptyBackendNotificationsArray({}, angular.noop);
  }

  return exports;
}])
.
factory('ordersSvc', ['resource', function(resource) {
  return resource('/portal', {}, {
    getSubs: { method: 'GET', url: '/api/subscription/getSubscriptionsByCustomerId' },
    getOrderAndSubInfoByProductType: { method: 'GET', url: '/api/account/getOrderAndSubInfoByProductType' },
    getOrderSummary: { method: 'GET', url: '/api/account/getOrderSummary' }
  });
}])
.
factory('Pagination', function() {

  var pagination = {};

  pagination.getNew = function(perPage) {

    perPage = perPage === undefined ? 5 : perPage;

    var paginator = {
      numPages: 1,
      perPage: perPage,
      page: 0
    };

    paginator.prev = function() {
      if (paginator.page > 0) {
        paginator.page -= 1;
      }
    };

    paginator.next = function() {
      if (paginator.page < paginator.numPages - 1) {
        paginator.page += 1;
      }
    };

    paginator.toPageId = function(id) {
      if (id >= 0 && id <= paginator.numPages - 1) {
        paginator.page = id;
      }
    };

    return paginator;
  };

  return pagination;
}).
factory('partySvc', ['cdata', 'mrNgUtils', function(cdata, mrNgUtils) {
  var exports = {};

  exports.confetti = confetti;
  exports.flashParty = flashParty;
  exports.birthdayParty = birthdayParty;

  // plays a confetti animation inside canvas "canvasId"
  function confetti(canvasId, callback) {
    var canvas = document.getElementById(canvasId);
    var context = canvas.getContext("2d");
    var width = canvas.width = canvas.parentElement.clientWidth;
    var height = canvas.height = canvas.parentElement.clientHeight;

    var particle = [];
    var particleCount = 300;
    var gravity = 10;
    var timeInitial = + new Date();
    var timePassed = 0;
    var timeTotal = 0;

    var colors = [
      '#53284F', '#e91e63', '#9c27b0', '#53284F', '#3f51b5',
      '#2196f3', '#03a9f4', '#53284F', '#009688', '#4CAF50',
      '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800',
      '#FF5722', '#53284F'
    ];

    for (var i = 0; i < particleCount; i++) {
      particle.push({ 
        x: width/2 * randomRange(0.6, 1.4),
        y: height/2 * randomRange(0.8, 1.2),
        boxW: randomRange(5, 20),
        boxH: randomRange(5, 20),
        size: randomRange(2, 8),
        velX: randomRange(-12, 12),
        velY: randomRange(-30, -5),
        friction: randomRange(0.4, 0.6),
        angle: convertToRadians(randomRange(0, 360)),
        color: colors[Math.floor(Math.random() * colors.length)],
        anglespin: randomRange(-0.2, 0.2),
        inframe: true,

        draw: function() {
          if (this.inframe) {
            context.save();
            context.translate(this.x, this.y);
            context.rotate(this.angle);
            context.fillStyle = this.color;
            context.beginPath();
            context.fillRect(this.boxW/2 * -1, this.boxH/2 * -1, this.boxW, this.boxH);
            context.fill();
            context.closePath();
            context.restore();

            this.angle += this.anglespin;
            var secondsPassed = timePassed / 1000;
            var gravityVector = gravity * secondsPassed;
            var frictionVectorY = this.friction * this.velY * secondsPassed;
            var changeInVelocity = gravityVector - frictionVectorY;
            
            this.velY += changeInVelocity;

            this.x += this.velX;
            this.y += this.velY;

            if (this.x + this.boxW < 0 || this.x - this.boxW > width || this.y - this.boxH > height) {
              this.inframe = false;
            }
          }
        }
      });
    }

    function drawScreen() {
      for (var i = 0; i < particle.length; i++) {
        particle[i].draw();
      }
    }

    function update() {
      context.clearRect(0, 0, width, height);
      var newTimeTotal = + new Date() - timeInitial;
      timePassed = newTimeTotal - timeTotal;
      timeTotal = newTimeTotal;
      drawScreen();

      if (timeTotal < 5000) {
        requestAnimationFrame(update);
      } else {
        context.clearRect(0, 0, width, height);
        if (callback) {
          callback();
        }
      }
    }

    update();
  }

  // fades in element "flashId", plays confetti on canvas "canvasId" then fades out "flashId"
  // if limitCookie is preset don't play the animation
  function flashParty(canvasId, flashId, limitCookie, ignoreCookie) {
    if (!$.cookie()[limitCookie] || ignoreCookie) {
      setTimeout(function() {
        $('#' + flashId).fadeIn(600, function() {
          confetti(canvasId, function() {
            $('#' + flashId).fadeOut();
          });
        });
      }, 500);

      if (limitCookie) {
        $.cookie(limitCookie, "partied", { expires: 7 }); // cookie expires in 7 days
      }
    }
  }

  // has a flashParty only if it's the users birthday, or a specific "urlParam" is present
  function birthdayParty(canvasId, flashId, urlParam) {
    var params = mrNgUtils.locationSearchParams();
    var month = new Date().getMonth();
    
    if (params[urlParam]) {
      flashParty(canvasId, flashId, 'bday', true);
    } else if (cdata.birthday && new Date(cdata.birthday).getMonth() == month) {
      flashParty(canvasId, flashId, 'bday');
    }
  }

  // Helper functions

  function randomRange(min, max) {
    return min + Math.random() * (max - min);
  }

  function convertToRadians(degree) {
    return degree*(Math.PI/180);
  }

  return exports;
}])
.
/* global MR, braintree, dataLayer */
factory('paymentProfileSvc', ['$rootScope', 'resource', 'loader', 'notifySvc', 'trackerSvc', 'addressSvc', 'phoneNumberFilter', 'Modal', function($rootScope, resource, loader, notifySvc, trackerSvc, addressSvc, phoneNumberFilter, Modal) {

  var httpSvc = resource('/api/paymentProfile', {}, {
    updateBillingInfo: { method: 'POST', url: '/api/customer/updateBillingInfo' },
    setDefaultShipAddress: { method: 'POST', url: '/api/customer/setDefaultShipAddress' },
    setDefaultPaymentMethod: { method: 'POST', url: '/api/customer/setDefaultPaymentMethod' },
    getPaymentProfiles: { method: 'GET', url: '/api/paymentProfile/getActivePaymentProfiles', isArray: true },
    deletePaymentProfile: { method: 'POST', url: '/api/customer/deletePaymentProfile' },
    getActiveSubscriptionsByPaymentProfileId: { method: 'GET', url: '/api/subscription/getActiveSubscriptionsByPaymentProfileId', isArray: true },
    updatePaymentProfileForAllUserSubscriptions: { method: 'POST', url: '/api/subscription/updatePaymentProfileForAllUserSubscriptions' },
    getClientToken: { method: 'GET', url: '/api/paymentProfile/getClientToken' },
    updatePaypalInfo: { method: 'POST', url: '/api/customer/updatePaypalInfo' }
  });

  var exports = {};

  /**
   * Payment profile
   */
  function PaymentProfile() {
    this.cc_cvc = '';
    this.cc_exp_month = '';
    this.cc_exp_year = '';
    this.cc_number = '';
    this.is_default = true;
    this.address = {
      first_name: '',
      last_name: '',
      street_1: '',
      street_2: '',
      city: '',
      post_code: '',
      region: '',
      phone: ''
    };
  }

  var ccTypes = {
    visa: {
      regex: /^4/,
      cvc: 3,
      cvcMask: '000',
      size: 16,
      formSize: 19,
      mask: '0000 0000 0000 0000'
    },
    mc: {
      regex: /^(5[1-5]|2[2-7])/,
      cvc: 3,
      cvcMask: '000',
      size: 16,
      formSize: 19,
      mask: '0000 0000 0000 0000'
    },
    amex: {
      regex: /^3[47]/,
      cvc: 4,
      cvcMask: '0000',
      size: 15,
      formSize: 18,
      mask: '0000 000000 00000'
    },
    discover: {
      regex: /^6(?:011|5)/,
      cvc: 3,
      cvcMask: '000',
      size: 16,
      formSize: 19,
      mask: '0000 0000 0000 0000'
    },
    default: {
      regex: /^[0-9]/,
      cvc: 3,
      cvcMask: '000',
      size: 16,
      formSize: 19,
      mask: '0000 0000 0000 0000'
    }
  };

  var paypalButtonRetries = 0;

  //- 
  /**
   * What is mod10Check? Look no further: https://en.wikipedia.org/wiki/Luhn_algorithm
   * @param {number} num
   */
  function mod10Check(num) {
    var parts = ('' + num).replace(/\D/g, '').split('').reverse();

    var sum = 0;
    for (var i = 0; i < parts.length; i++) {
      var part = +parts[i];
      if (i % 2) {
        part = (+part) * 2;
        if (part > 9) {
          part = 1 + (part % 10);
        }
      }
      sum += part;
    }

    return sum % 10 === 0;
  }

  exports.messages = {
    declined: 'Your card has been declined. Please verify your information and resubmit your order. Thank you!',
    default: 'We were unable to process your payment method. Please review your information or call us at ' + MR.config.contactPhone, //- <- global
    success: 'Thanks! Your billing information has been updated.',
    deleted: 'Your payment method was successfully removed.',
    generalError: 'Something went wrong and your changes could not be saved. Please review your information or call us at ' + MR.config.contactPhone, //- <- global
    subBillingUpdate: 'Thanks! Your billing information has been updated and your subscription will process as scheduled.',
    updatedDefaultPayment: 'Your default payment method was successfully updated.',
    allSubPayment: 'Payment profile for all your active auto-deliveries has been updated'
  };

  exports.associatedSubsModal = Modal.newModal('associatedSubsModal');
  exports.shipNowSubsModal = Modal.newModal('shipNowSubsModal');

  exports.profiles = [];
  exports.profileMap = {};
  exports.inEditMode = false;
  exports.initialized = false;
  exports.selectedProfile = {};
  exports.defaultProfile = null;
  exports.savingPayment = false;
  exports.confirmedPayment = false;
  exports.profileInEdit = { same_as_shipping: true };

  exports.ccTypes = ccTypes;
  exports.mod10Check = mod10Check;

  exports.sameAsShipping = sameAsShipping;
  exports.cancelEdit = cancelEdit;
  exports.editPayment = editPayment;
  exports.checkIfShipNowModal = checkIfShipNowModal;
  exports.deletePayment = deletePayment;
  exports.clearBillingForm = clearBillingForm;
  exports.getPaymentProfiles = getPaymentProfiles;
  exports.savePaymentProfile = savePaymentProfile;
  exports.checkSameShippingBilling = checkSameShippingBilling;
  exports.updateDefaultPaymentProfile = updateDefaultPaymentProfile;
  exports.updatePaymentProfileForAllUserSubscriptions = updatePaymentProfileForAllUserSubscriptions;
  exports.setSelectedPaymentProfile = setSelectedPaymentProfile;
  exports.deleteAndUpdateDefaultPayment = deleteAndUpdateDefaultPayment;
  exports.initPaypalButton = initPaypalButton;
  exports.initPaypalAuthFlow = initPaypalAuthFlow;

  getPaymentProfiles();

  /**
   * Get payment profiles
   */
  function getPaymentProfiles() {
    httpSvc.getPaymentProfiles({}, function(profiles) {
      exports.profiles = profiles;

      if (profiles.length) {
        exports.confirmedPayment = true;
      } else {
        exports.inEditMode = true;
      }

      for (var i = 0; i < exports.profiles.length; i++) {
        var profile = exports.profiles[i];
        exports.profileMap[profile.paymentProfileId] = profile;
        if (exports.selectedProfile && exports.selectedProfile.paymentProfileId == profile.paymentProfileId) {
          setSelectedPaymentProfile(profile.paymentProfileId);
        }

        if (profile.is_default) {
          exports.defaultProfile = profile;
        }
      }

      if (exports.profiles.length && !exports.selectedProfile || !exports.selectedProfile.paymentProfileId) {
        exports.selectedProfile = exports.defaultProfile || exports.profiles[0] || {};
      }

      exports.initialized = true;
      $rootScope.$broadcast('payment_profile_profiles_loaded', profiles);
    });
  }

  /**
   * Same as shipping
   * @param {object} profileAddress
   * @param {object} shippingAddress
   */
  function sameAsShipping(profileAddress, shippingAddress) {
    if (!profileAddress || !shippingAddress) {
      return false;
    }
    return !Object.keys(profileAddress).some(function(key) {
      var a = profileAddress[key] || null;
      var b = shippingAddress[key] || null;
      return a != b;
    });
  }

  /**
   * Edit payment
   * @param {number} profileId
   */
  function editPayment(profileId) {
    var profile = exports.profileMap[profileId] || new PaymentProfile();
    exports.profileInEdit = angular.copy(profile);

    exports.inEditMode = true;
    exports.confirmedPayment = false;
  }

  /**
   * Cancel edit
   * @param {object} form
   */
  function cancelEdit(form) {
    clearBillingForm(form);

    if (exports.selectedProfile && exports.selectedProfile.paymentProfileId) {
      exports.confirmedPayment = true;
    }

    exports.inEditMode = false;
  }

  /**
   * Clear billing form
   * @param {object} form
   */
  function clearBillingForm(form) {
    exports.profileInEdit = new PaymentProfile();
    exports.savingPayment = false;
    if (form) {
      form.$setPristine();
    }
  }

  /**
   * Set selected payment profile
   * @param {number} paymentProfileId
   */
  function setSelectedPaymentProfile(paymentProfileId) {
    exports.selectedProfile = exports.profileMap[paymentProfileId] || {};
    exports.confirmedPayment = true;
    $rootScope.$broadcast('payment_profile_selected', exports.selectedProfile);
  }

  /**
   * Update payment profile for all user subscriptions
   * @param {number} paymentProfileId
   */
  function updatePaymentProfileForAllUserSubscriptions(paymentProfileId) {
    var payload = {
      paymentProfileId: paymentProfileId
    };

    httpSvc.updatePaymentProfileForAllUserSubscriptions(payload, function() {
      $rootScope.$broadcast('update_payment_for_subs');
      notifySvc.notify('success', exports.messages.subBillingUpdate);
      updateDefaultPaymentProfile(paymentProfileId);
    }, function(err) {
      var message = exports.messages.generalError;
      if (err.data && err.data.message) {
        message = err.data.message;
      }

      notifySvc.notify('warn', message);
    });
  }

  /**
   * Update default payment profile
   * @param {number} paymentProfileId
   * @param {Function} callback
   */
  function updateDefaultPaymentProfile(paymentProfileId, callback) {
    callback = callback || angular.noop;
    var payload = {
      paymentProfileId: paymentProfileId
    };

    httpSvc.setDefaultPaymentMethod(payload, function() {
      getPaymentProfiles();
      notifySvc.notify('success', exports.messages.updatedDefaultPayment);
      callback();
    }, function() {
      notifySvc.notify('error', exports.messages.generalError);
    });
  }

  /**
   * Delete and update default payment
   * @param {object} currentProfile
   */
  function deleteAndUpdateDefaultPayment(currentProfile) {
    var profiles = exports.profiles;
    if (profiles.length > 1) {
      updateDefaultPaymentProfile((profiles[0].paymentProfileId == currentProfile.paymentProfileId ? profiles[profiles.length - 1].paymentProfileId : profiles[0].paymentProfileId), deletePayment(currentProfile.paymentProfileId));
    }
  }

  /**
   * Save payment profile
   * When called from the Booking flow, no address info is present. Instead, send userInfo containing first and last name. 
   * @param {object} form
   * @param {object} userInfo
   * @param {Function} callback
   */
  function savePaymentProfile(form, userInfo, callback) {
    callback = Array.prototype.pop.call(arguments);
    switch (arguments.length) {
      case 1:
        userInfo = null;
        break;
    }

    if (typeof callback != 'function') {
      callback = null;
    }

    userInfo = userInfo || {};

    if (exports.savingPayment) {
      return;
    }

    if (form.$invalid) {
      $rootScope.$broadcast('payment_profile_save_failed');
      form.$setDirty();
      Object.keys(form).forEach(function(key) {
        if (form[key] && form[key].$setDirty) {
          form[key].$setDirty();
        }
      });
      return;
    }

    exports.savingPayment = true;

    callback = callback || angular.noop;
    var address = exports.profileInEdit.address;
    if (!address) {
      address = {};
    }

    if (exports.profileInEdit.same_as_shipping && !addressSvc.confirmedShippingAddress) {
      exports.savingPayment = false;
      notifySvc.notify('error', addressSvc.messages.incomplete);
      //- without timeout form is not cleared. Angular issue.
      setTimeout(function() {
        form.$setPristine();
      }, 100);
      $rootScope.$broadcast('payment_profile_save_failed');
      return;
    }

    var payload = {
      paymentProfileId: exports.profileInEdit.paymentProfileId,
      updateDeclinedCC: exports.profileInEdit.isDeclined,
      is_default: exports.profileInEdit.is_default,
      updateAllSubs: exports.profileInEdit.updateAllSubs
    };

    // if same_as_shipping use shipping address as billing address
    if (exports.profileInEdit.same_as_shipping) {
      address = angular.copy(addressSvc.selectedAddress);
      address.id = null;
    }

    if (address) {
      address.is_default_shipping = false;
    }

    payload.address = angular.copy(address);

    if (exports.profileInEdit.cc_exp_month_year) {
      var expStr = exports.profileInEdit.cc_exp_month_year;
      exports.profileInEdit.cc_exp_month = expStr.substr(0, 2);
      exports.profileInEdit.cc_exp_year = '20' + expStr.substr(-2, 2);
    }

    var firstName = address.first_name || userInfo.firstName;
    var lastName = address.last_name || userInfo.lastName;
    var billingAddress = {
      firstName: firstName,
      lastName: lastName,
      streetAddress: address.street_1 || '',
      extendedAddress: address.street_2 || '',
      locality: address.city || '',
      region: address.region || '',
      postalCode: address.post_code || ''
    };

    var card = {
      cardholderName: [firstName, lastName].filter(Boolean).join(' '),
      expirationMonth: exports.profileInEdit.cc_exp_month,
      expirationYear: exports.profileInEdit.cc_exp_year,
      billingAddress: billingAddress
    };

    if (exports.profileInEdit.cc_number) {
      card.number = exports.profileInEdit.cc_number;
    }

    if (exports.profileInEdit.cc_cvc) {
      card.cvv = exports.profileInEdit.cc_cvc;
    }

    httpSvc.getClientToken(function(clientToken) {
      var dataCollector = braintree.data.setup({
        kount: { environment: MR.config.braintreeEnvironment },
      });

      var client = new braintree.api.Client(clientToken);
      client.tokenizeCard(card, function(err, nonce) {
        if (err) {
          $rootScope.$broadcast('payment_profile_save_failed');
          return;
        }

        payload.nonce = nonce;
        payload.deviceData = dataCollector.deviceData;

        payload.address.first_name = billingAddress.firstName;
        payload.address.last_name = billingAddress.lastName;

        httpSvc.updateBillingInfo(payload, function(profile) {
          if (exports.profileInEdit.paymentProfileId) {
            $rootScope.$broadcast('payment_profile_modified', profile);
          } else {
            $rootScope.$broadcast('payment_profile_created', profile);
          }

          // set selectedProfile before getting paymentProfiles to keep track of selected
          exports.selectedProfile = profile;
          getPaymentProfiles();

          exports.confirmedPayment = true;
          exports.inEditMode = false;
          exports.savingPayment = false;

          if (payload.updateDeclinedCC) {
            checkIfShipNowModal();
          }

          if (form) {
            clearBillingForm(form);
          }

          exports.profileInEdit = {};
          callback();
        }, function(err) {
          $rootScope.$broadcast('payment_profile_save_failed');
          var error = exports.messages.default;
          if (isDeclineError(err)) {
            error = exports.messages.declined;
          } else if (err.data.message) {
            error = err.data.message;
          }
          exports.savingPayment = false;
          exports.confirmedPayment = false;
          //- without timeout form is not cleared. Angular issue.
          setTimeout(function() {
            form.$setPristine();
          }, 100);
          loader.finish();
          notifySvc.notify('error', error);
        });
      });
    }, function(err) {
      exports.savingPayment = false;
      notifySvc.notify('error', exports.messages.generalError);
      $rootScope.$broadcast('payment_profile_save_failed', err);
    });
    return;
  }

  var paypalCheckout;

  /**
   * Init paypal auth flow
   */
  function initPaypalAuthFlow() {
    if (!paypalCheckout) {
      return;
    }

    paypalCheckout.paypal.initAuthFlow();
  }

  /**
   * Init paypal button
   * @param {Function} onReceivedFunc
   * @param {Function} successFunc
   * @param {Function} errFunc
   */
  function initPaypalButton(onReceivedFunc, successFunc, errFunc) {
    errFunc = errFunc || angular.noop;

    if (!window.braintree && paypalButtonRetries < 3) {
      return setTimeout(function() {
        ++paypalButtonRetries;
        initPaypalButton(onReceivedFunc, successFunc, errFunc);
      }, 1000);
    }

    httpSvc.getClientToken(function(res) {
      braintree.setup(res.clientToken, 'custom', {
        paypal: {
          singleUse: false,
          enableShippingAddress: true,
          headless: true
        },
        onReady: function(integration) {
          paypalCheckout = integration;
        },
        dataCollector: {
          kount: { environment: MR.config.braintreeEnvironment },
          paypal: true,
        },
        onPaymentMethodReceived: function(res) {
          onReceivedFunc();
          trackerSvc.trackEvent('Payment Selected', { type: 'PayPal' });
          var address = {};
          var email = res.details.email;
          httpSvc.updatePaypalInfo(res, function(updateData) {
            dataLayer.push({
              'event': 'AddPaymentInfo',
              'paymentType': 'paypal'
            });
            successFunc({
              paymentProfileId: updateData.id,
              address: address,
              email: email
            });
          }, function(err) {
            errFunc(err);
            $rootScope.$broadcast('payment_profile_save_failed', err);

            if (err.data) {
              switch (err.data.code) {
                case "USER_ALREADY_EXISTS":
                  if (err.data.errorDetails) {
                    email = (err.data.errorDetails[0] || {}).email;
                  }

                  $rootScope.$broadcast('show_sign_in_modal', {
                    email: email,
                    err: err.data.code
                  });
                  return;

                case "ONLY_US_ADDRESS":
                  notifySvc.notify('error', err.data.message);
                  return;
              }
            }

            notifySvc.notify('error', exports.messages.generalError);
          });
        },
        onUnsupported: function(err) {
          errFunc(err);
          notifySvc.notify('error', exports.messages.generalError);
          $rootScope.$broadcast('payment_profile_save_failed', err);
        }
      });
    }, function(err) {
      errFunc(err);
      notifySvc.notify('error', exports.messages.generalError);
      $rootScope.$broadcast('payment_profile_save_failed', err);
    });
  }

  /**
   * check if any dependent sub next date is today or in the past and ask if they
   * want to ship those subs now. This covers cases when attempted refill failed
   * and without ship now sub will have to wait til tomorrow.
   */
  function checkIfShipNowModal() {
    var shipNowSubs = [];
    if (exports.profileInEdit.subs && exports.profileInEdit.subs.length) {
      var endOfDay = new Date();
      endOfDay.setHours(23);
      endOfDay.setMinutes(59);
      endOfDay.setSeconds(59);
      exports.profileInEdit.subs.forEach(function(sub) {
        if (new Date(sub.next) < endOfDay) {
          shipNowSubs.push(sub);
        }
      });
    }

    if (shipNowSubs.length) {
      //- open modal
      exports.shipNowSubsModal.shipNowSubs = shipNowSubs;
      exports.shipNowSubsModal.open();
      trackerSvc.trackEvent('DeclinedShipNowModal: show', { subsShown: shipNowSubs.length });
    }
  }

  /**
   * Delete payment
   * @param {number} payment_id
   * @param {Function} callback
   */
  function deletePayment(payment_id, callback) {
    if (!callback) {
      callback = angular.noop;
    }
    var payload = {
      paymentProfileId: payment_id
    };

    httpSvc.deletePaymentProfile(payload, function() {
      notifySvc.notify('success', exports.messages.deleted);
      getPaymentProfiles();
    }, function(err) {
      var message = exports.messages.generalError;
      if (err.data && err.data.message) {
        message = err.data.message;
      }

      notifySvc.notify('warn', message);
    });
  }

  /**
   * If shipAddress and billAddress are the same set same_as_shipping to true
   */
  function checkSameShippingBilling() {
    //- if payment is in edit mode no need to compare addresses
    if (exports.inEditMode) {
      return;
    }

    var shipping = addressSvc.selectedAddress;
    // shipping.phone needs to be filtered in order to be compare to billing.phone
    shipping.phone = phoneNumberFilter(shipping.phone);
    var billing = exports.selectedProfile.address || {};
    var isSameFlag = isShippingSameBilling(shipping, billing);

    //Clear form
    if (!isSameFlag) {
      clearBillingForm();
    }

    exports.selectedProfile.same_as_shipping = angular.equals(billing, {}) ? true : isSameFlag;
  }

  // Helper functions
  /**
   * Is shipping same billing
   * @param {object} shipping
   * @param {object} billing
   */
  function isShippingSameBilling(shipping, billing) {
    // If shipping fields different from billing set flag false
    for (var i = 0; i < addressSvc.addressKeys.length; i++) {
      var key = addressSvc.addressKeys[i];
      if ((shipping[key] || '').toLowerCase() != (billing[key] || '').toLowerCase()) {
        return false;
      }
    }
    return true;
  }

  /**
   * Is decline error
   * @param {string} msg
   */
  function isDeclineError(msg) {
    msg = '' + msg;
    return msg.toLowerCase().indexOf('credit card declined') >= 0;
  }

  return exports;
}]).
factory('preOrderSvc', ['resource', function(resource) {
  return resource('/api/preOrder', {}, {
    getPreOrderId: { method: 'GET', url: '/api/preOrder/getPreOrderId' },
    cancelPreOrder: { method: 'POST', url: '/api/preOrder/cancelPreOrder' }
  });
}]).
factory('preferenceSvc', ['resource', function(resource) {
  return resource('/api/preferences', {}, {
    getMarketingPreferences: { method: 'GET', url: '/api/customer/getMarketingPreferences' },
    setMarketingPreferences: { method: 'POST', url: '/api/customer/setMarketingPreferences' },
    smsOptInOut: { method: 'POST', url: '/api/customer/smsOptInOut' }
  });
}]).
factory('pressAssetSvc', ['$rootScope', 'resource', function($rootScope, resource) {

  var httpSvc = resource('/rest/press', {}, {
    loadAllPressAssets: { method: 'GET', url: '/api/press/loadAllPressAssets' }
  });

  var exports = {};
  var initializing = false;
  exports.pressImages = [];
  exports.pressVideos = [];
  exports.pressFactSheets = [];
  exports.pressLogos = [];

  exports.loadPressAssets = loadPressAssets;

  function loadPressAssets() {
    if (initializing) {
      return;
    }

    initializing = true;
    httpSvc.loadAllPressAssets({}, function(res) {
      exports.pressImages = res.pressImages.filter(filterVisible);
      exports.pressVideos = res.pressVideos.filter(filterVisible);
      exports.pressFactSheets = res.pressFactSheets.filter(filterVisible);
      exports.pressLogos = res.pressLogos.filter(filterVisible);
      initializing = false;
    }, function() {
      initializing = false;
    });
  }

  function filterVisible(item) {
    return item.visible;
  }

  return exports;
}]).
factory('pressItemSvc', ['$rootScope', 'resource', function($rootScope, resource) {

  var httpSvc = resource('/rest/press', {}, {
    getPagePressItems: { method: 'GET', url: '/api/press/getPagePressItems', isArray: true },
    getPressItemCount: { method: 'GET', url: '/api/press/getPressItemCount' },
    loadFeaturedPress: { method: 'GET', url: '/api/press/loadFeaturedPress', isArray: true }
  });

  var exports = {};
  exports.maxPageCount = 0;
  exports.pageNr = 0;
  exports.pageSize = 0;
  exports.pressItems = [];
  exports.featuredPress = [];
  exports.initializePressPage = initializePressPage;
  exports.getNextPagePressItems = getNextPagePressItems;
  exports.getPreviousPagePressItems = getPreviousPagePressItems;
  exports.loadFeaturedPress = loadFeaturedPress;

  function initializePressPage() {
    getPressItemCount(function() {
      getNextPagePressItems(exports.pageNr);
    });
  }

  function getPressItemCount(callback) {
    httpSvc.getPressItemCount(function(res) {
      exports.maxPageCount = Math.ceil(res.count / exports.pageSize);
      callback();
    });
  }

  function loadFeaturedPress() {
    httpSvc.loadFeaturedPress(function(res) {
      exports.featuredPress = res;
    });
  }

  function getNextPagePressItems() {
    if (exports.pageNr < exports.maxPageCount) {
      exports.pageNr += 1;
    }

    var payload = {
      pageSize: exports.pageSize,
      pageNr: exports.pageNr
    };

    getPagePressItems(payload);
  }

  function getPreviousPagePressItems() {
    if (exports.pageNr > 1) {
      exports.pageNr -= 1;
    }

    var payload = {
      pageSize: exports.pageSize,
      pageNr: exports.pageNr,
    };

    getPagePressItems(payload);
  }

  function getPagePressItems(payload) {
    httpSvc.getPagePressItems(payload, function(res) {
      exports.pressItems = res;
    });
  }

  return exports;
}])
.
factory('pressReleaseSvc', ['$rootScope', 'resource', function($rootScope, resource) {

  var httpSvc = resource('/rest/press', {}, {
    getPagePressReleases: { method: 'GET', url: '/api/press/getPagePressReleases', isArray: true },
  });

  var exports = {};
  var lastSortOrder = 0;
  exports.pageSize = 0;
  exports.pressReleases = [];
  exports.noMoreRecords = true;

  exports.initializePressReleases = initializePressReleases;
  exports.getPressReleaseBatch = getPressReleaseBatch;

  function initializePressReleases() {
    getPressReleaseBatch();
  }

  function getPressReleaseBatch() {
    exports.noMoreRecords = true;

    if (exports.pageNr < exports.maxPageCount) {
      exports.pageNr += 1;
    }

    var payload = {
      pageSize: exports.pageSize,
      sortOrder: lastSortOrder
    };
    
    httpSvc.getPagePressReleases(payload, function(res) {
      if (!res.length) {
        return;
      }
      if (res.length < exports.pageSize) {
        exports.noMoreRecords = true;
      } else {
        exports.noMoreRecords = false;
      }

      lastSortOrder = res[res.length -1].sort_order;
      exports.pressReleases = exports.pressReleases.concat(res);
    });
  }

  return exports;
}])
.
factory('productCatalogSvc', ['resource', function(resource) {
  return resource('/api/product', {}, {
    getAllProducts: {method: 'GET', url: '/api/product/getAllProducts', isArray: true },
    getColorsSortedByLevel: { method: 'GET', url: '/api/product/getColorsSortedByLevel', isArray: true },
    getColorsByColorFamily: { method: 'GET', url: '/api/product/getColorsByColorFamily', isArray: true },
    getProductsByType: {method: 'GET', url: '/api/product/getProductsByType', isArray: true },
    getProductByCode: {method: 'GET', url: '/api/product/getProductByCode' },
    getProductById: {method: 'GET', url: '/api/product/getProductById' },
    getProductsById: {method: 'GET', url: '/api/product/getProductsById', isArray: true },
    getProductByUrlKey: {method: 'GET', url: '/api/product/getProductByUrlKey' },
    getProductPrices: {method: 'GET', url: '/api/product/getProductPrices' },
    getAverageReviewsByProductId: {method: 'GET', url: '/api/product/getAverageReviewsByProductId'},
    getProductSummaryByCode: {method: 'GET', url: '/api/product/getProductSummaryByCode'}
  });
}])
.
factory('productTypeSvc', ['resource', function(resource) {
  return resource('/api/productTypes', {}, {
    getById: { method: 'GET', url: '/api/productTypes/getById' }
  });
}]).
factory('promoSvc', ['resource', function(resource) {
  var promoHttpSvc = resource('api/cart', {}, {
    loadById: { method: 'POST', url: '/api/promo/loadById', isArray: false },
    applyTestPromo: { method: 'POST', url: '/api/cart/applyTestPromo', isArray: false }
  });

  var exports = {
    testPromo: {}
  };

  exports.loadById = loadById;
  exports.applyTestPromo = applyTestPromo;
  exports.extractDiscounts = extractDiscounts;

  function loadById(params, successFunc, failFunc) {
    return promoHttpSvc.loadById(params, successFunc, failFunc);
  }

  function applyTestPromo() {
    promoHttpSvc.applyTestPromo(function(res) {
      exports.testPromo = res;
    });
  }

  function extractDiscounts(promos, selectedShipping) {
    var discounts = [];
    promos.forEach(function(promo) {
      if (promo.asCredits) {
        return;
      }

      if (promo.offers && promo.offers.length > 1) {
        //list for promos that contain more than one offer
        displayPromoAsOfferList(promo, discounts, selectedShipping);
      } else {
        //creates a header row where the promo assumes the values of the offer
        displayPromoAsOffer(promo, discounts, selectedShipping);
      }
    });
    return discounts;
  }

  function displayPromoAsOfferList(promo, discounts, selectedShipping) {
    // Filter out the 2-3 day free shipping if selected shipping is 1-2 day for site wide shipping
    promo.offers = promo.offers.filter(function(offer) {
      if (selectedShipping && selectedShipping.price && offer.type === 'freeShipping') {
        return false;
      }
      return true;
    });

    if (!promo.id) { //- promos in confirmation page, order history do not have ids
      //- thats all we need to display in confirmation/invoice history page
      discounts.push({
        header: true,
        amt: promo.amount,
        label: promo.displayName,
        showOriginalPrice: true
      });
      return;
    }

    var discHeader = {
      header: true,
      promo_id: promo.id,
      label: promo.displayName,
      can_remove: promo.can_remove,
      showOriginalPrice: !!promo.showOriginalPrice,
      type: promo.type,
      displayPrice: false,
      amt: promo.amount
    };
    if (discHeader.header && discHeader.label && promo.type === 'bundle' && discHeader.amt === 0) {
      return;
    }

    var discOffers = [];
    var nullAmts = ['customerPromo', 'freeProduct', 'credit'];
    var someOfferHasDisplay = false;

    promo.offers.forEach(function(offer) {
      if (+offer.hideProduct) {
        return;
      }

      var displayAmount = +offer.amount;
      if (offer.hasOwnProperty('displayAmount')) {
        displayAmount = +offer.displayAmount;
      }

      var display = false;
      if (nullAmts.indexOf(offer.type) > -1) {
        displayAmount = null;
        display = true;
      }

      var amt = offer.showOriginalPrice ? Math.abs(displayAmount) * -1 : 0;

      if (amt) {
        display = true;
      }

      if (offer.type != 'freeShipping' && !offer.displayAmount) {
        display = false;
      }

      if (display) {
        someOfferHasDisplay = true;
      }

      discOffers.push({
        display: display,
        header: false,
        label: offer.display_name || promo.displayName,
        type: offer.type,
        offerType: offer.type,
        amt: amt,
        can_remove: false,
        showOriginalPrice: Boolean(offer.showOriginalPrice)
      });
    });

    if (!someOfferHasDisplay) {
      discHeader.displayPrice = true;
    }

    discounts.push(discHeader);
    if (discOffers.length) { //flatten the array, works faster than .concat()
      discounts.push.apply(discounts, discOffers);
    }
  }

  function displayPromoAsOffer(promo, discounts, selectedShipping) {
    var firstChildOffer = promo.offers[0];
    if (selectedShipping && selectedShipping.price && firstChildOffer.type === 'freeShipping') {
      return;
    }

    if (!promo.id) { //- promos in confirmation page, order history do not have ids
      //- thats all we need to display in confirmation/invoice history page
      discounts.push({
        header: true,
        amt: promo.amount,
        label: promo.displayName,
        showOriginalPrice: true
      });
      return;
    }

    var amount;
    if (promo.displayAmount) {
      amount = Math.abs(promo.displayAmount) * -1;
    } else if (firstChildOffer.displayAmount) {
      amount = Math.abs(firstChildOffer.displayAmount) * -1;
    } else {
      amount = Math.abs(promo.amount) * -1;
    }

    var discHeader = {
      header: true,
      displayPrice: amount < 0,
      promo_id: promo.id,
      amt: amount,
      label: firstChildOffer.display_name ? firstChildOffer.display_name : promo.displayName,
      can_remove: promo.can_remove,
      showOriginalPrice: firstChildOffer.showOriginalPrice,
      type: promo.type,
      offerType: firstChildOffer.type
    };

    if (discHeader.header && discHeader.label && promo.type === 'bundle' && discHeader.amt === 0) {
      return;
    }
    discounts.push(discHeader);
  }

  return exports;
}]).
factory('quizSvc', ['resource', 'FileUploader', function(resource, FileUploader) {
  var httpSvc = resource('/api/quiz', {}, {
    getHairToneOptions: { method: 'POST', url: '/api/quiz/getHairToneOptions' },
    persistCustomerAnswers: { method: 'POST', url: '/api/quiz/persistCustomerAnswers' },
    saveRecommendations: { method: 'POST', url: '/api/quiz/saveRecommendations' },
    createCustomerServiceTicket: { method: 'POST', url: '/api/quiz/createCustomerServiceTicket' },
    dequeueCustomerServiceTicket: { method: 'POST', url: '/api/quiz/dequeueCustomerServiceTicket' },
    trackQuizEvent: { method: 'POST', url: '/api/quiz/trackQuizEvent' },
    updateSubscriptionFrequency: { method: 'POST', url: '/api/quiz/updateSubscriptionFrequency' },
    emailAdvisorAnswers: { method: 'GET', url: '/api/quiz/emailAdvisorAnswers' },
    queueColorSatisfactionTicketCreation: { method: 'POST', url: '/api/quiz/queueColorSatisfactionTicketCreation' },
    getCustomerAnswers: { method: 'GET', url: '/api/quiz/getCustomerAnswers' },
    getQuizFlow: { method: 'GET', url: '/api/quiz/getQuizFlow' },
    isAnyAnswerRecordedForQuiz: { method: 'GET', url: '/api/quiz/isAnyAnswerRecordedForQuiz' },
    isQuizComplete: { method: 'POST', url: '/api/quiz/isQuizComplete' },
    getAllQuizNames: { method: 'GET', url: '/api/quiz/getAllQuizNames', isArray: true },
    getAllExperimentsForQuiz: { method: 'GET', url: '/api/quiz/getAllExperimentsForQuiz' },
    enrichQuizWithQuestions: { method: 'POST', url: '/api/quiz/enrichQuizWithQuestions' },
    saveNPS: { method: 'POST', url: '/api/quiz/saveNPS' },
    assignCustomerPromo: { method: 'POST', url: '/api/customer/assignCustomerPromo' }
  });

  var exports = {};
  Object.keys(httpSvc).forEach(function(key) {
    exports[key] = httpSvc[key];
  });

  exports.FileUploader = FileUploader;

  return exports;
}]).
/* global redirect */
factory('refillCartSvc', ['resource', 'notifySvc', '$rootScope', 'Modal', 'xsellSvc', 'subscriptionSvc', function(resource, notifySvc, $rootScope, Modal, xsellSvc, subscriptionSvc) {
  var httpSvc = resource('/api/cart', {}, {
    addToCart: { method: 'POST', url: '/api/refillCart/addToCart', isArray: false },
    setShippingMethod: { method: 'POST', url: '/api/refillCart/setShippingMethod' },
    getCartItems: { method: 'POST', url: '/api/refillCart/getCartItems', isArray: true },
    getAddons: { method: 'POST', url: '/api/refillCart/getAddons', isArray: true },
    removeItemFromCart: { method: 'POST', url: '/api/refillCart/removeItemFromCart', isArray: false },
    shipRefillWithCart: { method: 'POST', url: '/api/cart/shipRefillWithCart', isArray: false },
    shipAllSubsWithCart: { method: 'POST', url: '/api/cart/shipAllSubsWithCart', isArray: false },
    getRefillCartDataForView: { method: 'POST', url: '/api/refillCart/getRefillCartDataForView', isArray: false },
    getUpcomingRefillCartDataForView: { method: 'POST', url: '/api/refillCart/getUpcomingRefillCartDataForView', isArray: false },
    getProductByUrlKey: { method: 'GET', url: '/api/refillCart/getProductByUrlKey', isArray: false }
  });

  var exports = {};

  exports.addToCart = addToCart;
  exports.removeItemFromCart = removeItemFromCart;
  exports.getRefillCartDataForView = getRefillCartDataForView;
  exports.getUpcomingRefillCartDataForView = getUpcomingRefillCartDataForView;
  exports.shipNow = shipNow;
  exports.shipAllSubsNow = shipAllSubsNow;
  exports.getProductByUrlKey = getProductByUrlKey;
  exports.addToCartFromEmail = addToCartFromEmail;
  exports.loadMembershipXsellProducts = loadMembershipXsellProducts;

  exports.addProductToRefillCartModal = Modal.newModal('addProductToRefillCartModal');

  exports.refillCart = {};
  exports.loadingRefillCart = false;
  exports.subscriptionId = null;
  exports.addonProduct = {};
  exports.emailCtaSource = {
    name: null,
    idx: null
  };
  exports.addingToCart = false;
  exports.membershipRecommendations = [];
  exports.allMemberRecsInCart = false;
  exports.memberXsellProductsLoaded = false;

  function getProductByUrlKey(payload, onSuccess, onFail) {
    return httpSvc.getProductByUrlKey(payload, function(product) {
      exports.addonProduct = product;
      exports.addProductToRefillCartModal.show = true;

      if (onSuccess) {
        onSuccess(product);
      }
    }, onFail);
  }

  function getRefillCartDataForView(subscriptionId, callback) {
    callback = callback || function() {};
    subscriptionSvc.ensureLoadedSubscriptions(function() {
      if (!subscriptionSvc.subMap[subscriptionId]) {
        exports.loadingRefillCart = false;
        return;
      }

      exports.loadingRefillCart = true;
      exports.subscriptionId = subscriptionId;
      var payload = {
        subscriptionId: subscriptionId
      };
      httpSvc.getRefillCartDataForView(payload, function(res) {
        exports.refillCart = res;
        exports.loadingRefillCart = false;
        checkAddedRecommendations();
        callback();
      }, function() {
        exports.loadingRefillCart = false;
      });
    });
  }

  function getUpcomingRefillCartDataForView(cb) {
    cb = cb || function() {};
    exports.loadingRefillCart = true;
    httpSvc.getUpcomingRefillCartDataForView(function(res) {
      exports.refillCart = res;
      exports.loadingRefillCart = false;
      cb(exports.refillCart);
    }, function() {
      exports.loadingRefillCart = false;
      cb(null);
    });
  }

  function removeItemFromCart(index) {
    var payload = {
      subscriptionId: exports.subscriptionId,
      index: index
    };
    httpSvc.removeItemFromCart(payload, function(res) {
      exports.refillCart = res;
      checkAddedRecommendations();
      notifySvc.notify('success', 'Successfully removed product from your refill cart.');
    }, function() {
      notifySvc.notify('error', 'We were not able to remove this item to your delivery. Please try again or call Color Crew');
    });
  }

  function addToCart(addonItem, callback) {
    var payload = {
      subscriptionId: exports.subscriptionId,
      product_id: addonItem.prod.id,
      qty: 1,
      ctaSource: addonItem.ctaSource,
      membershipAddon: true
    };

    if (addonItem.validOffer) {
      payload.validOffer = addonItem.validOffer;
    }

    doAddToCart(payload, callback);
  }

  function addToCartFromEmail() {
    if (!exports.emailCtaSource.name) {
      exports.emailCtaSource.name = 'upcomingSubscriptionEmail';
    }

    var payload = {
      subscriptionId: exports.subscriptionId,
      product_id: exports.addonProduct.id,
      qty: 1,
      ctaSource: exports.emailCtaSource,
      membershipAddon: true
    };

    doAddToCart(payload, function() {
      //- after product has been added from email, move it to the top of the recommendation que
      var first = exports.addonProduct.id;
      exports.membershipRecommendations.sort(function(x, y) {
        return x.id == first ? -1 : y.id == first ? 1 : 0;
      });
    });
  }

  function doAddToCart(payload, callback) {
    if (typeof callback != 'function') {
      callback = function() {};
    }

    if (exports.addingToCart) {
      return;
    }

    exports.addingToCart = true;
    httpSvc.addToCart(payload, function(res) {
      exports.refillCart = res;
      checkAddedRecommendations();
      notifySvc.notify('success', 'Great call—we’ve just added this to your upcoming order.');
      $rootScope.$broadcast('prod_added_to_refill');
      exports.addingToCart = false;
      callback();
    }, function() {
      notifySvc.notify('error', 'We were not able to add this item to your delivery. Please try again or call Color Crew');
      exports.addingToCart = false;
    });
  }

  function shipNow(subId) {
    subId = subId || exports.subscriptionId;
    subscriptionSvc.ensureLoadedSubscriptions(function() {
      if (!subscriptionSvc.subMap[subId]) {
        notifySvc.notify('error', 'We were not able to ship this delivery now. Please try again or call Color Crew');
        return;
      }

      var payload = {
        subscriptionId: subId,
        nonPersistent: true
      };

      httpSvc.shipRefillWithCart(payload, function() {
        redirect('/checkout');
      }, function(err) {
        if (err.data && err.data.code == 'PENDING_ORDERS') {
          notifySvc.notify('warn', 'An order with these items is already being processed and will get to you in 3-10 business days.');
        } else {
          notifySvc.notify('error', 'We were not able to ship this delivery now. Please try again or call Color Crew');
        }
      });
    });
  }

  function shipAllSubsNow() {
    var payload = {
      nonPersistent: true
    };

    httpSvc.shipAllSubsWithCart(payload, function() {
      redirect('/checkout');
    }, function(err) {
      if (err.data && err.data.code == 'PENDING_ORDERS') {
        notifySvc.notify('warn', 'An order with these items is already being processed and will get to you in 3-10 business days.');
      } else {
        notifySvc.notify('error', 'We were not able to ship this delivery now. Please try again or call Color Crew');
      }
    });
  }

  function checkAddedRecommendations() {
    (exports.refillCart.addonsInCart || []).forEach(function(addon) {
      exports.membershipRecommendations.forEach(function(rec) {
        if (addon.id == rec.id) {
          rec.added = true;
        }
      });
    });

    exports.allMemberRecsInCart = !exports.membershipRecommendations.some(function(rec) {
      return !rec.added;
    });
  }

  function loadMembershipXsellProducts() {
    xsellSvc.getMembershipXsellProducts({}, function(res) {
      exports.membershipRecommendations = res;
      exports.memberXsellProductsLoaded = true;
      checkAddedRecommendations();
    });
  }

  return exports;
}]).
service('resource', ['$resource', 'loader', 'mrNgUtils', '$cookies', function($resource, loader, mrNgUtils, $cookies) {
  return function(url, params, actions) {
    params = params || {};

    angular.forEach(actions, function(v) {
      var isPOST = v.method === 'POST';

      try {
        window.dispatchEvent(new CustomEvent('ajaxEvent', { 'detail': url }));
      } catch (e) {
        // IE doesn't support dispatchEvent
      }

      v.headers = {};

      Object.defineProperty(v.headers, 'x-csrf-stp', {
        enumerable: true,
        get: function() {
          let value = $cookies.csrf_stp || '';
          return value;
        }
      });

      Object.defineProperty(v.headers, 'x-time-offset', {
        enumerable: true,
        get: function() {
          return new Date().getTimezoneOffset();
        }
      });

      v.transformRequest = function(data) {
        // Only show spinner for POST requests and if hideSpinner is falsy
        if (isPOST && (data && !data.hideSpinner)) {
          loader.start();
        }

        params._ts = Date.now();

        return data ? angular.toJson(data) : data;
      };

      v.transformResponse = function(data) {
        if (isPOST) {
          loader.finish();
        }

        return data ? (mrNgUtils.isJson(data) ? angular.fromJson(data) : data) : data;
      };
    });

    return $resource(url, params, actions);
  };
}]).
factory('reviewSvc', ['resource', function(resource) {
  return resource('/api/review', {}, {
    submitReview: { method: 'POST', url: 'api/review/submitReview' },
    getCustomerReviewForProduct: { method: 'GET', url: '/api/review/getCustomerReviewForProduct' },
    getApprovedReviewsByProdId: { method: 'GET', url: '/api/getApprovedReviewsByProdId', isArray: true },
    getSortByConstants: { method: 'GET', url: '/api/review/getSortByConstants' },
    getReviews: { method: 'GET', url: '/api/review/getReviews' },
    getReviewSummariesForCategories: { method: 'GET', url: '/api/review/getReviewSummariesForCategories' },
    getSortedPagedCategoryReviews: { method: 'GET', url: '/api/review/getSortedPagedCategoryReviews' }
  });
}]).
factory('scrollToSvc', [function() {
  var exports = {};
  exports.scrollToTop = scrollToTop;
  exports.scrollToElement = scrollToElement;

  function scrollToTop() {
    return $("body").animate({ scrollTop: $("body").offset().top }, "slow");
  }

  function scrollToElement(el, offset) {
    if (!el || !$(el).length) {
      return scrollToTop();
    }

    offset ? offset : 0;
    return $("body").animate({ scrollTop: $(el).offset().top - offset }, "slow");
  }
  return exports;
}]).
/**
 * @module searchSvc
 * @moduleType ngFactory
 */
factory('searchSvc', ['resource', function(resource) {
  return resource('/api/search', {}, {
    searchAll: {method: 'GET', url: '/api/search/searchAll', isArray: false},
    queryAll: {method: 'POST', url: '/api/search/queryAll', isArray: false},
    searchContent: {method: 'GET', url: '/api/search/searchContent', isArray: false},
    queryContent: {method: 'POST', url: '/api/search/queryContent', isArray: false},
    searchBlogPost: {method: 'GET', url: '/api/search/searchBlogPost', isArray: false},
    queryBlogPost: {method: 'POST', url: '/api/search/queryBlogPost', isArray: false},
    searchByFields: {method: 'GET', url: '/api/search/searchByFields', isArray: false}
  });
}])
.
factory('siteMessagesSvc', ['$rootScope', 'resource', function($rootScope, resource) {
  var httpSvc = resource('/api/siteMessages', {}, {
    getByTopics: { method: 'GET', url: '/api/siteMessages/getByTopics', isArray: true }
  });

  var exports = {};

  exports.getByTopics = getByTopics;

  /**
   * Gets site messages
   *
   * @param {string} topics
   * @param {Function} callback
   */
  function getByTopics(topics, callback) {
    callback = callback || function() {};
    httpSvc.getByTopics({ topics: topics }, function(messages) {
      callback(messages);
    }, function() {
      callback();
    });
  }

  return exports;
}]).
factory('subscriptionSvc', ['$rootScope', 'resource', 'notifySvc', 'advisorSvc', 'productCatalogSvc', 'manageFlowSvc', 'mrNgUtils', function($rootScope, resource, notifySvc, advisorSvc, productCatalogSvc, manageFlowSvc, mrNgUtils) {
  var httpSvc = resource('/api/subscription', {}, {
    getSubs: { method: 'GET', url: '/api/subscription/getSubscriptionsByCustomerId' },
    cancelSubscription: { method: 'POST', url: '/api/subscription/cancelSubscription' },
    updateSubscription: { method: 'POST', url: '/api/subscription/updateSubscription' },
    updateMultipleSubscriptions: { method: 'POST', url: '/api/subscription/updateMultipleSubscriptions' },
    getCancelReasons: { method: 'GET', url: '/api/subscription/getCancelReasons' },
    getSubscriptionsWithItemsByAddressId: { method: 'GET', url: '/api/subscription/getSubscriptionsWithItemsByAddressId', isArray: true },
    getClosedDates: { method: 'GET', url: '/api/subscription/getClosedDates', isArray: true },
    getSubPauseDates: { method: 'GET', url: '/api/subscription/getSubPauseDates', isArray: true },
    getSubDateOptions: { method: 'GET', url: '/api/subscription/getSubDateOptions' },
    updateSubscriptionColor: { method: 'POST', url: '/api/subscription/updateSubscriptionColor' },
    updateSubscriptionProductIgnoreType: { method: 'POST', url: '/api/subscription/updateSubscriptionProductIgnoreType' }
  });

  var exports = {};

  exports.subsLoaded = false;
  exports.subscriptions = [];
  exports.subMap = {};
  exports.subInEdit = {};
  exports.savingSub = false;
  exports.cancelSubPayload = {};
  exports.invalidDates = [];
  exports.subAddressIds = [];
  exports.updateAll = {
    showForm: false,
    next: null
  };
  exports.maxSkipDays = 16 * 7 + 3; //- 16 weeks

  //- global option for product qty dropdown
  exports.prodQtyOption = [];
  for (var qty = 1; qty <= 10; qty++) {
    exports.prodQtyOption.push(qty);
  }

  //- options to cofigure available date range for next shipment date
  var future = new Date();
  var minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);
  future.setMonth(future.getMonth() + 3);
  exports.nextDateOptions = {
    minDate: new Date(),
    maxDate: exports.maxSkipDays,
    beforeShowDay: function(date) {
      return [isDateValid(date), "", null];
    }
  };

  $rootScope.$on('reload_subs', function() {
    getSubscriptions();
  });

  exports.getClosedDates = httpSvc.getClosedDates;
  exports.getSubscriptionsWithItemsByAddressId = httpSvc.getSubscriptionsWithItemsByAddressId;
  exports.cancelSubscription = httpSvc.cancelSubscription;
  exports.updateSubscriptionProductIgnoreType = httpSvc.updateSubscriptionProductIgnoreType;

  exports.ensureLoadedSubscriptions = ensureLoadedSubscriptions;
  exports.editSub = editSub;
  exports.getSubscriptions = getSubscriptions;
  exports.updateSubscription = updateSubscription;
  exports.getCancelReasons = getCancelReasons;
  exports.cancelEditSub = cancelEditSub;
  exports.cancelSub = cancelSub;
  exports.savingsCalc = savingsCalc;
  exports.prepSubSkipDates = prepSubSkipDates;
  exports.updateSubscriptionColor = updateSubscriptionColor;
  exports.updateNextDateForAllSubscriptions = updateNextDateForAllSubscriptions;
  exports.pauseDeliveryUntilDate = pauseDeliveryUntilDate;

  getSubscriptions();

  function ensureLoadedSubscriptions(cb) {
    if (exports.subsLoaded) {
      return cb();
    }

    $rootScope.$on('all_subs_loaded', cb);
  }

  function getSubscriptions(cb) {
    cb = cb || angular.noop;
    var payload = {
      subStatus: 'active',
      sortOrder: 'asc'
    };

    httpSvc.getSubs(payload, function(res) {
      exports.subscriptions = res.subs || [];
      mapSubs();
      $rootScope.$broadcast('all_subs_loaded');
      exports.subsLoaded = true;
      cb();
    }, function() {
      exports.subsLoaded = false;
      //- no error shown here. Otherwise it will show up on /support page
      // when we check for user subs if user is not logged in
      cb();
    });
  }

  function getCancelReasons() {
    httpSvc.getCancelReasons({
      product_type: exports.subInEdit.product_type,
      randomize: true
    }, function(res) {
      var hasNNN = exports.subInEdit.code.indexOf('NNN') < -1;
      exports.cancelReasons = res.reasons.map(function(reason) {
        reason.mention_nnn = !hasNNN && reason.mention_nnn;
        return reason;
      });
    });
  }

  function mapSubs() {
    exports.subAddressIds = [];
    var subs = exports.subscriptions;
    if (!subs) {
      return;
    }

    for (var i = 0; i < subs.length; i++) {
      //- collect unique address ids from all subs
      if (!~exports.subAddressIds.indexOf(subs[i].shipping_address_id)) {
        exports.subAddressIds.push(subs[i].shipping_address_id);
      }

      exports.subMap[subs[i].id] = subs[i];
    }
  }

  function editSub(subId, nextDate, callback) {
    callback = callback || angular.noop;
    httpSvc.getSubDateOptions({ sub_id: subId }, function(res) {
      //- if we don't get invalid dates no need for panic
      exports.invalidDates = res.closeDates;
      //- maxSkipDays has a default val. Used for maximum furthest date in next date picker
      exports.maxSkipDays = res.maxSkipDays;

      exports.subInEdit = angular.copy(exports.subMap[subId] || {});
      //- need to track original next date
      exports.subInEdit.initialNext = exports.subInEdit.next;
      //- if nextDate param passed in use that
      if (nextDate) {
        nextDate = new Date(nextDate + ' 00:00:00');
        exports.subInEdit.next = nextDate;
      }

      if (exports.subInEdit.inactive) {
        exports.subInEdit.status = 'active';
      }

      getRecsForProductType(exports.subInEdit.product_type);
      savingsCalc(exports.subInEdit);
      callback();
    });
  }

  function getRecsForProductType(productType) {
    switch (productType) {
      case 'color_kit':
        advisorSvc.getCompareShadesData({}, function(results) {
          exports.subInEdit.compareShadesTool = results;

          if (!results.bestMatch) {
            exports.subInEdit.noColorAdvisor = true;
          }

          exports.subInEdit.compareShadesTool.colorsByLevel.forEach(function(level) {
            level.products.forEach(function(color) {
              if (exports.subInEdit.code == color.code) {
                exports.subInEdit.compareShadesTool.currentProduct = color;
              }
            });
          });
        });
        break;
      case 'gloss':
      case 'root_reboot':
      case 'root_touch_up':
      case 'root_perfection':
        productCatalogSvc.getProductsByType({
          productType: productType
        }, function(res) {
          exports.subInEdit.availableColors = res.sort(sortProducts);
          exports.subInEdit.availableColors.forEach(function(color, index) {
            if (color.code == exports.subInEdit.code) {
              exports.subInEdit.selectedIdx = index;
            }
          });
        });
        break;
    }
  }

  function updateSubscriptionColor(productId) {
    if (exports.savingSub) {
      return;
    }
    exports.savingSub = true;

    var payload = {
      subscriptionId: exports.subInEdit.id,
      productId: productId
    };

    httpSvc.updateSubscriptionColor(payload, function() {
      exports.savingSub = false;
      getSubscriptions();
      $rootScope.$broadcast('sub_updated', exports.subInEdit.id);
      notifySvc.notify('success', 'You have succesfully updated your auto-delivery.');
    }, function() {
      exports.savingSub = false;
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function sortProducts(a, b) {
    var cmpA = a.color_number;
    var cmpB = b.color_number;

    return cmpA - cmpB;
  }

  function cancelEditSub() {
    exports.subInEdit = {};
  }

  function updateSubscription(callback) {
    callback = callback || angular.noop;
    if (!exports.subInEdit.id) {
      notifySvc.notify('warn', notifySvc.messages.canNotCompleteTransaction);
      return;
    }
    var payload = {
      sub_id: exports.subInEdit.id,
      changes: angular.copy(exports.subInEdit) //- we are sending back the whole sub object, backend will figure out what to save
    };

    delete payload.changes.compareShadesTool;
    delete payload.changes.product_info;

    if (!payload.changes.next) {
      payload.changes.next = new Date(); //- default to today
    } else {
      //-make sure its a date obj
      payload.changes.next = new Date(payload.changes.next) == 'Invalid Date' ? new Date() : new Date(payload.changes.next);
    }

    //- check for weekends and 3pl blackout days
    if (!isDateValid(payload.changes.next)) {
      return notifySvc.notify('warn', 'Next ship date cannot be on weekends or select holidays. Please use the calendar for available dates.');
    }
    //- have to convert next date to string to avoid any funny business with servers and timezones
    payload.changes.next = mrNgUtils.getShortDateString(exports.subInEdit.next);
    exports.savingSub = true;

    httpSvc.updateSubscription(payload, function() {
      exports.savingSub = false;
      getSubscriptions();
      $rootScope.$broadcast('sub_updated', exports.subInEdit.id);
      $rootScope.$broadcast('reload_addresses');
      notifySvc.notify('success', 'You have succesfully updated your auto-delivery.');
      callback();
    }, function(err) {
      exports.savingSub = false;
      var errMsg = notifySvc.messages.canNotCompleteTransaction;
      if (err.data && err.data.message) {
        errMsg = err.data.message;
      }
      notifySvc.notify('error', errMsg);
    });
  }

  function pauseDeliveryUntilDate(date, callback) {
    exports.subInEdit.next = date;
    updateSubscription(callback);
  }

  function cancelSub(callback) {
    callback = callback || angular.noop;
    exports.cancelSubPayload.sub_id = exports.subInEdit.id;
    //- needed only for A/B test, if we choose new canelation flow remove if part
    if (!exports.cancelSubPayload.reason && manageFlowSvc.deliveryCancelation.selected) {
      exports.cancelSubPayload.reason = manageFlowSvc.deliveryCancelation.selected.value;
    }

    httpSvc.cancelSubscription(exports.cancelSubPayload, function() {
      exports.cancelSubPayload = {};
      notifySvc.notify('info', 'You have successfully canceled your Auto Delivery.');
      getSubscriptions();
      $rootScope.$broadcast('sub_canceled');
      $rootScope.$broadcast('reload_addresses');
      callback();
    }, function() {
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function prepSubSkipDates(subId) {
    //- always reset subInEdit in case there are some unsaved changes
    editSub(subId, null, function() {
      httpSvc.getSubPauseDates({ sub_id: subId }, function(dates) {
        exports.subInEdit.pauseDates = dates;
      });
    });
  }

  function savingsCalc(subInfo) {
    if (!subInfo || !subInfo.product_info) {
      return;
    }

    subInfo.annualSavings = Math.ceil((subInfo.product_info.price - subInfo.product_info.sub_price) * (52 / subInfo.frequency) * subInfo.qty);
  }

  //- date helpers
  function isSameDate(dateOne, dateTwo) {
    dateOne = new Date(dateOne);
    dateTwo = new Date(dateTwo);
    return !(dateOne.getFullYear() != dateTwo.getFullYear() || dateOne.getMonth() != dateTwo.getMonth() || dateOne.getDate() != dateTwo.getDate());
  }

  function isDateValid(date) {
    var weekend = [0, 6];
    if (!date || weekend.indexOf(new Date(date).getDay()) != -1) {
      return false;
    }

    return !exports.invalidDates.some(function(invalidDate) {
      return isSameDate(invalidDate, date);
    });
  }

  function updateNextDateForAllSubscriptions() {
    if (!exports.updateAll.next) {
      return notifySvc.notify('warn', 'Please select a date');
    }

    if (!isDateValid(exports.updateAll.next)) {
      return notifySvc.notify('warn', 'Next ship date cannot be on weekends or select holidays. Please use the calendar for available dates.');
    }

    exports.savingSub = true;
    var subIds = exports.subscriptions.map(function(sub) {
      return sub.id;
    });

    var payload = {
      subIds: subIds,
      changes: { next: mrNgUtils.getShortDateString(exports.updateAll.next) }
    };

    httpSvc.updateMultipleSubscriptions(payload, function() {
      $rootScope.$broadcast('sub_updated');
      exports.savingSub = false;
      getSubscriptions();
      exports.updateAll.showForm = false;
      exports.updateAll.next = null;
      notifySvc.notify('success', 'Successfully updated all your auto deliveries.');
    }, function() {
      exports.savingSub = false;
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  return exports;
}]).
/**
 * @module trackerSvc
 * @moduleType ngFactory
 */
factory('trackerSvc', ['cdata', function(cdata) {
  function trackEvent(eventName, properties) {
    if (!properties) {
      properties = {};
    }
    appendStdProps(properties);
    var context = {
      location: cdata.locationContext
    };

    if (!properties.user_id) {
      context.anonymousId = cdata.dig;
    }

    window.analytics.track(eventName, properties, context);
  }

  function trackMREvent(eventName, properties) {
    properties = properties || {};
    properties.eventName = eventName;
    trackEvent('MREvent', properties);
  }

  function appendStdProps(properties) {
    properties.dig = cdata.dig;
    properties.dug = cdata.dug;
    properties.isIOS = cdata.isIOS;
    properties.sessionId = cdata.sessionId;
    properties.agent_id = cdata.agent_id;
    properties.postal_code = cdata.postalCode;
    if (cdata.user && cdata.user.id) {
      properties.user_id = cdata.user.id;
      if (cdata.user.email) {
        properties.email = cdata.user.email;
      }
    }
  }

  return {
    trackEvent: trackEvent,
    trackMREvent: trackMREvent
  };
}]).
factory('waitlistSvc', ['resource', function(resource) {
  return resource('/api/waitlist', {}, {
    addToWaitlist: { method: 'POST', url: '/api/waitlist/addToWaitlist' }
  });
}]).
factory('xsellSvc', ['resource', function(resource) {
  return resource('/api/xsell', {}, {
    getXsellItemsForProduct: { method: 'GET', url: '/api/xsell/getXsellItemsForProduct', isArray: true },
    getSystemRecommendations: { method: 'GET', url: '/api/xsell/getSystemRecommendations', isArray: true },
    getRoutineRecommendations: { method: 'POST', url: '/api/xsell/getRoutineRecommendations', isArray: false },
    getGlossGiftRecommendations: { method: 'POST', url: '/api/xsell/getGlossGiftRecommendations', isArray: false },
    getMembershipXsellProducts: { method: 'GET', url: '/api/xsell/getMembershipXsellProducts', isArray: true }
  });
}])
;
/* global analytics, Raygun, env, isMobile, isIOS, redirect, ouibounce, Sentry, cdata*/
angular.module('mrWebsite', [
    'ngResource',
    'ngRoute',
    'ngAnimate',
    'ngTouch',
    'ngCookies',
    'ngSanitize',
    'mrShared.controllers',
    'mrShared.directives',
    'mrShared.filters',
    'mrShared.services',
    'mrWebsite.directives',
    'mrWebsite.filters',
    'mrWebsite.services',
    'angularFileUpload',
    'iso',
    'ui.date',
    'ui.mask',
    '720kb.socialshare',
    'rzModule'
  ])

  // Angular global error handler
  .factory('$exceptionHandler', [function() {
    return function(exception) {
      // Output to console
      console.error('Coming from Angular'); // eslint-disable-line no-console
      console.error(exception.stack); // eslint-disable-line no-console

      // Send angular errors to sentry
      if (Sentry) {
        Sentry.withScope(function(scope) {
          scope.setTag("framework", "angular");
          scope.setTag("initFile", "mrWebsite.js");

          if (cdata) {
            scope.setUser({
              'email': cdata.email ? cdata.email : null,
              'id': cdata.id ? cdata.id : cdata.dug
            });
          }

          Sentry.captureException(exception);
        });
      }
    };
  }])

  .config(['$sceDelegateProvider', '$compileProvider', function($sceDelegateProvider, $compileProvider) {
    performance.mark('angularConfigInit'); // custom perf metric
    if (env === 'production') {
      $compileProvider.debugInfoEnabled(false);
    }

    $sceDelegateProvider.resourceUrlWhitelist([
      'self',
      'https://www.youtube.com/**'
    ]);
  }])

  .controller('mrMainCtl', [
    '$scope',
    '$rootScope',
    '$location',
    '$route',
    '$window',
    '$timeout',
    '$compile',
    'customerSvc',
    'newCartSvc',
    'productCatalogSvc',
    'Modal',
    '$cookies',
    'notifySvc',
    'cdata',
    'contentData',
    'trackerSvc',
    'mrNgUtils',
    'mrWindowHistory',
    function(
      $scope,
      $rootScope,
      $location,
      $route,
      $window,
      $timeout,
      $compile,
      customerSvc,
      newCartSvc,
      productCatalogSvc,
      Modal,
      $cookies,
      notifySvc,
      cdata,
      contentData,
      trackerSvc,
      mrNgUtils,
      mrWindowHistory
    ) {
      performance.mark('angularInit'); // custom perf metric
      $scope.$location = $location;
      $scope.$window = $window;
      $scope.$cookies = $cookies; // this is also exposed as cookies without the $ but that has been deprecated
      $scope.$timeout = $timeout;
      $scope.mrNgUtils = mrNgUtils;
      $scope.Math = Math;
      $scope.mrWindowHistory = mrWindowHistory;
      $scope.params = mrNgUtils.locationSearchParams();
      $scope.redirect = redirect;
      $scope.mrtest = '';
      $scope.cart = { summary: {} };
      $scope.shippingAddress = false;
      $scope.env = env;
      $scope.notifySvc = notifySvc;
      $scope.cookies = $cookies; // $scope.cookies has been deprecated, use $scope.$cookies instead
      $scope.cdata = cdata;
      $scope.trackerSvc = trackerSvc;
      $scope.newCartSvc = newCartSvc;
      $scope.customerSvc = customerSvc;
      //- adding contact phone to rootScope so its available everywhere
      $rootScope.mrContactPhone = window.MR.config.contactPhone; //- used in mrContactPhone
      performance.mark('angularInit'); // custom perf metric

      var custIdentified = false;
      // Adjust recent product added cookie for xsell modal on cart
      $scope.cdata.recentAddedProduct = 0;
      if ($cookies.recentAddedProduct) {
        $scope.cdata.recentAddedProduct = +$cookies.recentAddedProduct;
        delete $cookies.recentAddedProduct;
      }

      if (window.notifications) {
        // Displays any messages found in the notifications array passed from the backend
        window.notifications.forEach(function(notification) {
          notifySvc.notify(notification.class, notification.message, notification.displayTime);
        });
      }

      $('header a').click(function(e) {
        if (e.target.attributes && e.target.attributes.href && e.target.attributes.href.value) {
          $scope.trackerSvc.trackEvent('Nav Clicked', {
            targetUrl: e.target.attributes.href.value,
            navElement: e.target.innerHTML
          });
        }
      });

      $('header a.video_consult_nav_link').click(() => {        
        $scope.trackerSvc.trackEvent('Nav Clicked', {
          path: '/schedule-video-chat',
          ctaSource: 'video_consult_nav_link',
        });
      });

      var RCDMenu = $('#top-menu');
      var RCDMenuNav = $('#top-menu nav');

      if (RCDMenu && RCDMenuNav && RCDMenu.offset()) {
        RCDMenu.height(RCDMenuNav.outerHeight());

        var RCDMenuItems = $('#top-menu nav ul li a');
        for (var x = 0; x < RCDMenuItems.length; x++) {
          if (window.location.href.indexOf(RCDMenuItems[x].href) != -1) {
            $(RCDMenuItems[x]).addClass('selected');
          } else {
            $(RCDMenuItems[x]).removeClass('selected');
          }
        }

        $scope.$on('windowScroll', function() {
          if ($scope.windowData.scrollTop > RCDMenu.offset().top) {
            RCDMenuNav.addClass('fixed');
          } else {
            RCDMenuNav.removeClass('fixed');
          }

          if ($scope.windowData.scrollTop > RCDMenu.offset().top + RCDMenu.height() && $scope.windowData.scrollDirection == 1) {
            RCDMenuNav.addClass('up');
          } else {
            RCDMenuNav.removeClass('up');
          }
        });
      }

      var customerSubscriptions = cdata && cdata.activeSubscriptions ? cdata.activeSubscriptions : [];
      let urm = [];
      let limitlessPlus = [];
      let subscriptions = [];

      customerSubscriptions.forEach(function(sub) {
        if (sub.productType === "renewable_cb_membership") {
          urm.push(sub);
        } else if (sub.productType === 'omni_memb') {
          limitlessPlus.push(sub);
        } else {
          subscriptions.push(sub);
        }
      });
      $scope.isUnlimitedRootsMembership = urm.length;
      $scope.isLimitlessPlus = limitlessPlus.length;
      $scope.nonMembershipSubscriptions = subscriptions.length;

      var customerCanceledSubscriptions = cdata && cdata.canceledSubTypes ? cdata.canceledSubTypes : {};
      var hasMoreThanCanceledMembership = Object.keys(customerCanceledSubscriptions).filter(function(subType) {
        return subType !== 'renewable_cb_membership' && subType !== 'omni_memb';
      }).length;

      $scope.hasMoreThanCanceledMembership = Boolean(hasMoreThanCanceledMembership);

      // All notificatgions sent from the backend have been displayed, so now we proceed to
      // remove them to avoid showing them on other pages.
      notifySvc.emptyBackendNotificationsArray();

      // eslint-disable-next-line no-undef
      var emailCapture = new EmailCapture(cdata);
      emailCapture.executeEmailCaptureCampaigns();

      if (!cdata.user || !cdata.user.authed) {
        $cookies.ajs_user_id = null;
      } else if (cdata.user && cdata.user.authed && cdata.user.id != $cookies.ajs_user_id) {
        $cookies.ajs_user_id = cdata.user.id;
      }

      if ($cookies.cic === undefined) {
        newCartSvc.setCartItemCountInCookie();
      }

      // top nav stuff
      $scope.topNav = {};
      $scope.signInControl = {
        open: false
      };
      $scope.signInData = {};
      $scope.signInView = null;

      $scope.$on('show_sign_in_modal', function(e, data) {
        $scope.signInControl.open = true;
        $scope.signInData = data;
        $scope.signInView = data.view;
      });

      document.addEventListener('click', function() {
        $scope.topNav.selected = 0;
        $scope.safeApply();
      });

      $scope.toggleHamburger = function() {
        $scope.mobileNavOpen = !$scope.mobileNavOpen;
        $scope.mobileNavOpen ? '' : $scope.topNav.selected = 0;
        trackerSvc.trackEvent('Hamburger toggled', { open: $scope.mobileNavOpen, breakpoint: $scope.windowData.breakpoint });
      };

      $scope.clickOpen = function(section, event) {
        event.stopPropagation();
        if ($scope.topNav.selected == section) {
          $scope.topNav.selected = 0;
        } else {
          $scope.topNav.selected = section;
          trackerSvc.trackEvent('Nav Opened', { category: event.target.innerText, breakpoint: $scope.windowData.breakpoint, hovered: false });
        }
      };

      // modal stuff
      $scope.Modal = Modal;
      $scope.mobileMenuOpen = false;
      // set when a modal is open (must be built into modal ctl)
      // read when you want to disable a cta or popup when a modal is open
      $scope.isModalOpen = false;
      // modals should use this setter when opening or closing
      $scope.setIsModalOpen = function(val) {
        $scope.isModalOpen = !!val;
      };

      $scope.modals = {
        confirmLogOutModal: Modal.newModal('confirmLogOutModal')
      };

      // mobile device
      $scope.isMobileDevice = isMobile;
      $scope.isIOS = isIOS;

      $scope.isEmptyObject = function isEmptyObject(obj) {
        return angular.equals({}, obj);
      };

      var urlParser = new RegExp('([^:]+)://([^/]+)(/[^?]+)?');

      $scope.$on('$locationChangeSuccess', function(event, url, fromUrl) {
        var props = {
          dig: cdata.dig,
          dug: cdata.dug,
          isIOSApp: cdata.isIOS,
          sessionId: cdata.sessionId,
          agent_id: cdata.agentId
        };

        var path = urlParser.exec(url)[3];
        var fromPath = urlParser.exec(fromUrl)[3];
        var referrer = path === fromPath || !fromUrl ? document.referrer : fromUrl;

        var search = '';

        if (url.indexOf('?') > -1) {
          var splitPath = url.split('?');
          url = splitPath[0];
          search = splitPath[1];
        }
        props.path = path || '/';
        props.url = url;
        props.search = search;

        if (referrer) {
          props.referrer = referrer;
        }

        var opts = {};
        if (!cdata.user || !cdata.user.id) {
          opts.anonymousId = cdata.dig;
        }

        if (!custIdentified && /^[0-9]+$/.test(cdata.userId) && !cdata.agentId) {
          var trackProps = angular.copy(cdata.user) || {};
          trackProps.dig = cdata.dig ? cdata.dig : null;
          trackProps.dug = cdata.dug ? cdata.dug : null;
          trackProps.agentId = cdata.agentId;
          trackProps.isIOSApp = cdata.isIOS;
          trackProps.sessionId = cdata.sessionId;
          if (cdata.user) {
            analytics.identify(cdata.user.id, trackProps);
            custIdentified = true;
          }
        }

        analytics.page(props, opts);

        if (cdata.trackExperiment) {
          var trackData = {
            experiment_id: cdata.trackExperiment.experiment_id,
            experiment_name: cdata.trackExperiment.experiment_name,
            variation_id: cdata.trackExperiment.variation_id,
            variation_name: cdata.trackExperiment.variation_name,
          };

          trackerSvc.trackEvent('Experiment Viewed', trackData);
          delete cdata.trackExperiment.recorded;
        }
        $('link').each(function() {
          if (this.rel === 'canonical') {
            if (this.href !== url) {
              this.href = url.split('?')[0];
            }
          }
        });
      });

      /** `$scope.notifications` is an array containing all the currently displaying notifications. **/
      $scope.notifications = [];

      //- Use goToPath with angular when you want to get outside of angular routing (reloads page)
      $scope.goToPath = function goToPath(path, newTab) {
        if (newTab) {
          window.open(path);
          return false;
        }
        location.href = path;
      };
      //- angular way to go using angular routing (does not reload page)
      $scope.go = function(path) {
        $location.path(path);
        $scope.scrollTop();
      };

      $rootScope.go = $scope.go;

      $scope.goBack = function() {
        window.history.back();
      };

      $scope.removeParamKey = function(key, caseSensitive) {
        var removeKey = key;
        if (!caseSensitive) {
          Object.keys($location.search()).some(function(paramKey) {
            if (paramKey.toLowerCase() == (key || '').toLowerCase()) {
              removeKey = paramKey;
              return true;
            }
          });
        }

        $location.search(removeKey, null);
      };

      $scope.setFocus = function(id) {
        window.setTimeout(function() {
          document.getElementById(id).focus();
        }, 10);
      };

      //sets a cookie on a key:value pair in (n) hours
      $scope.setCookie = function setCookie(key, value, hours) {
        var d = new Date();
        d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
        var expireString = "expires=" + d.toUTCString();
        //must access the jquery collection of document
        $(document)[0].cookie = key + "=" + value + "; " + expireString;
      };

      $scope.deleteCookie = function deleteCookie(key) {
        $scope.setCookie(key, '', -1);
      };

      //- checks error is user not logged in error, if so will redirect to signin and return true
      $scope.checkUserLoginError = customerSvc.checkUserLoginError;

      // makes logging available to cms jade templates.
      // very useful when creating components that us DynoCtl
      $scope.consoleLog = function(message) {
        console.log(message); // eslint-disable-line no-console
      };

      // used for A/B testing
      if ($scope.params.mrt) {
        $scope.mrtest = $scope.params.mrt;
      }

      $scope.scrollTo = function scrollTo(selector, animateDuration, delay) {
        if (!$(selector).length) {
          return;
        }
        var timeoutDelay = delay || 10;
        setTimeout(function() {
          //Default is to use scroll animation
          if (animateDuration === false) {
            $("body, html").scrollTop($(selector).offset().top);
          } else {
            // Convert string ms into a number else default to 'slow' animation
            animateDuration = ++animateDuration || 'slow';
            $("body, html").animate({ scrollTop: $(selector).offset().top }, animateDuration);
          }
        }, timeoutDelay);
      };

      if ($scope.params.scrollTo) {
        $scope.scrollTo('#' + $scope.params.scrollTo);
      }

      $scope.stopScroll = function() {
        $("body, html").stop(true, false);
      };

      //On mobile you cannot do both href and ng-click on an 'a' tag
      //Instead do:
      //a(ng-click="scrollTo('.sections','/account/auto-delivery')")
      $scope.linkScrollTo = function linkScrollTo(selector, url, flag, animateDuration) {
        //Change route
        $location.path(url);

        // Flag whether to scroll or not
        // Example: In my account we only want to scroll on mobile but not desktop
        if (flag) {
          //Scroll to selector passed in
          $scope.scrollTo(selector, animateDuration);
        }
      };

      $scope.scrollTop = function scrollTop() {
        $("body, html").animate({ scrollTop: $(".angular-div").offset().top }, "slow");
      };

      // scrolls the selected div right by the width of it's children
      $scope.scrollRight = function scrollRight(selector, animateDuration) {
        animateDuration = ++animateDuration || 'fast';
        $(selector).animate({ scrollLeft: $(selector).scrollLeft() + $(selector + ' > div').width() }, animateDuration);
      };

      // scrolls the selected div left by the width of it's children
      $scope.scrollLeft = function scrollLeft(selector, animateDuration) {
        animateDuration = ++animateDuration || 'fast';
        $(selector).animate({ scrollLeft: $(selector).scrollLeft() - $(selector + ' > div').width() }, animateDuration);
      };

      $scope.logOut = function logOut() {
        delete $cookies.amazon_Login_state_cache;
        delete $cookies.amazon_Login_accessToken;
        delete $cookies.amazon_Address_consentToken;

        localStorage.removeItem('ajs_group_properties');
        localStorage.removeItem('ajs_user_traits');
        $scope.modals.confirmLogOutModal.close();

        customerSvc.logOut(function() {
          trackerSvc.trackEvent('Logged Out');
          analytics.reset();
          location.href = '/';
        });
      };

      $rootScope.$on('log_out', function() {
        $scope.logOut();
      });

      $scope.addToBag = function(productId, qty, isSubscription, ctaSource) {
        var payload = {
          id: productId,
          qty: qty,
          ctaSource: ctaSource,
          subscription: isSubscription,
          cartType: 'active'
        };

        newCartSvc.addProduct(payload, function(res) {
          $cookies.recentAddedProduct = payload.id;

          // Adding AddToCart event for Facebook Pixel Tracking
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Shopping Cart',
              content_ids: [res.product_type_name + ' - ' + res.name],
              content_type: 'product',
              value: '' + res.price,
              currency: 'USD',
              order_type: payload.subscription ? 'subscription' : 'non-subscription'
            });
          }

          redirect('/cart', {
            product_code: res.code
          });
        });
      };

      $scope.getProductById = function(productId) {
        return productCatalogSvc.getProductById({ id: productId });
      };

      $scope.getProductByCode = function(productCode) {
        return productCatalogSvc.getProductByCode({ code: productCode });
      };

      $scope.getProductByUrlKey = function(urlKey) {
        return productCatalogSvc.getProductByUrlKey({ urlKey: urlKey });
      };

      /**
       Provides a way to call `$scope.$apply` in a 'safe' manner. That is... it will only
       call it if one isn't already in progress.
       **/
      $scope.safeApply = function safeApply(fn) {
        var phase = this.$root.$$phase;
        if (phase == '$apply' || phase == '$digest') {
          if (fn && (typeof(fn) === 'function')) {
            fn();
          }
        } else {
          this.$apply(fn);
        }
      };
      //- when using 'scroll' param in url, scroll to tag with 'scroll' value
      if ($scope.params.scroll) {
        setTimeout(function() {
          $scope.scrollTo('#' + $scope.params.scroll, 300);
        }, 5); // slight timeout needed to prevent Chrome to scroll to old location
      }

      // TODO: put windowWatcher code into a window watcher service that uses events
      var wndw = $(window);
      var doc = $(document);

      $rootScope.windowData = $scope.windowData = {
        noScroll: false, // used to disable scrolling when a modal is active
        // disable scrolling on mobile only
        noScrollOnMobile: false,
        breakpoint: null,
        width: null,
        oldHeightOnScroll: window.innerHeight,
        heightOnScroll: window.innerHeight,
        mobileNavHidden: false,
        scrollTop: 0,
        pageHeight: 0, // the height of the whole page
        scrollBottom: null,
        scrollDirection: 0, // defaults to 0, 1 if scrolling down, -1 if scrolling up
        scrollDepth: 0, // how deep the user has scrolled down the page
        hash: null,
        facebookBrowser: false,
        instagramBrowser: false,
        pinterestBrowser: false,
        isIphone: false,
        isIpod: false,
        isIpad: false,
        isIosDevice: false,
        fixedCTAOn: false
      };

      $rootScope.accessibilityViewed = 0;

      windowSizeWatcher();
      setInterval(windowScrollAndHeightWatcher, 200);
      wndw.resize(windowSizeWatcher);

      checkBrowsers();

      function windowSizeWatcher() {
        var width = wndw.width();
        var previousWidth = $scope.windowData.width;
        var previousBreakpoint = $scope.windowData.breakpoint;
        $scope.windowData.width = width;

        // NOTE: these values are based on bp-mobile-max, bp-tablet-max,
        // bp-desktop-md-max from variables.styl
        if (width <= 559) {
          $scope.windowData.breakpoint = 'mobile';
        } else if (width <= 759) {
          $scope.windowData.breakpoint = 'tablet';
        } else if (width <= 959) {
          $scope.windowData.breakpoint = 'desktop-md';
        } else {
          $scope.windowData.breakpoint = 'desktop';
          $scope.mobileNavOpen = false;
          $scope.windowData.noScroll = false;
        }

        setTimeout(function() {
          if (previousWidth != $scope.windowData.width) {
            $scope.$broadcast('widthChange', $scope.windowData);
            $scope.safeApply();
          }
          if (previousBreakpoint != $scope.windowData.breakpoint) {
            $scope.$broadcast('breakpointChange', $scope.windowData);
            $scope.safeApply();
          }
        }, 500);

        $scope.safeApply();
      }

      function checkBrowsers() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        if ((ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1)) {
          $scope.windowData.facebookBrowser = true;
        }
        if (ua.indexOf('Instagram') > -1) {
          $scope.windowData.instagramBrowser = true;
        }
        if (ua.indexOf('Pinterest') > -1) {
          $scope.windowData.pinterestBrowser = true;
        }
        if (ua.indexOf('iPhone')) {
          $scope.windowData.isIphone = true;
        }
        if (ua.indexOf('iPod')) {
          $scope.windowData.isIphone = true;
        }
        if (ua.indexOf('iPad')) {
          $scope.windowData.isIpod = true;
        }
        if ($scope.windowData.isIphone || $scope.windowData.isIpod || $scope.windowData.isIpad) {
          $scope.windowData.isIosDevice = true;
        }
      }

      $scope.$on('fixedCTAOn', function() {
        $scope.windowData.fixedCTAOn = true;
        $('body').addClass('has-fixed-cta');
      });

      $scope.$on('fixedCTAOff', function() {
        $scope.windowData.fixedCTAOn = true;
        $('body').removeClass('has-fixed-cta');
      });

      $scope.$on('noScroll', function(event, val) {
        $scope.windowData.noScroll = val;
      });

      ouibounce(false, {
        callback: function() {
          $scope.windowData.tryingToLeave = true;
        }
      });

      $scope.setHash = function setHash(hash) {
        window.location.hash = hash;
      };

      $scope.$watch(function() {
        return window.location.hash;
      }, function(value) {
        $scope.windowData.hash = value.replace('#', '');
        $scope.$broadcast('hashChanged', $scope.windowData);
      });

      function windowScrollAndHeightWatcher() {
        var windowScrollTop = wndw.scrollTop();

        if ($scope.windowData.scrollTop != windowScrollTop) {
          var oldScrollTop = $scope.windowData.scrollTop;
          var oldScrollDepth = $scope.windowData.scrollDepth;

          $scope.windowData.scrollTop = windowScrollTop;
          $scope.windowData.scrollBottom = windowScrollTop + wndw.height();
          $scope.windowData.scrollDirection = oldScrollTop > $scope.windowData.scrollTop ? -1 : 1;

          // browser hidden nav detection
          $scope.windowData.heightOnScroll = window.innerHeight;
          if ($scope.windowData.heightOnScroll != $scope.windowData.oldHeightOnScroll) {
            if ($scope.windowData.heightOnScroll - 25 > $scope.windowData.oldHeightOnScroll) {
              // innerHeight increased indicating mobile nav is hidden
              $scope.windowData.mobileNavHidden = true;
            } else if ($scope.windowData.heightOnScroll + 25 < $scope.windowData.oldHeightOnScroll) {
              // innerHeight decreased indicating mobile nav is visible
              $scope.windowData.mobileNavHidden = false;
            }

            $scope.windowData.oldHeightOnScroll = $scope.windowData.heightOnScroll;
          }

          var currentScrollDepth = $scope.windowData.scrollBottom / $('.angular-div').height() * 100;
          if (currentScrollDepth > $scope.windowData.scrollDepth) {
            $scope.windowData.scrollDepth = currentScrollDepth;
            // Scroll depth tracking
            if (contentData && contentData.depthTracking) {
              var trackingData = {
                url: window.location.href,
                breakpoint: $scope.windowData.breakpoint,
                uri: contentData.uri,
                variationId: contentData.variationId,
                targetPlatform: contentData.targetPlatform,
                variationKey: contentData.variationKey,
                variationName: contentData.variationName,
                experimentId: contentData.experimentId,
                experimentName: contentData.experimentName
              };

              if ($scope.windowData.scrollDepth > 25 && oldScrollDepth < 25) {
                trackingData.percent = 25;
                trackerSvc.trackEvent('Scroll Depth', trackingData);
              }
              if ($scope.windowData.scrollDepth > 50 && oldScrollDepth < 50) {
                trackingData.percent = 50;
                trackerSvc.trackEvent('Scroll Depth', trackingData);
              }
              if ($scope.windowData.scrollDepth > 75 && oldScrollDepth < 75) {
                trackingData.percent = 75;
                trackerSvc.trackEvent('Scroll Depth', trackingData);
              }
              if ($scope.windowData.scrollDepth > 100 && oldScrollDepth < 100) {
                trackingData.percent = 100;
                trackerSvc.trackEvent('Scroll Depth', trackingData);
              }
            }
          }

          $scope.$broadcast('windowScroll', $scope.windowData);
        }

        if (!$rootScope.accessibilityViewed) {
          $rootScope.accessibilityViewed = $('#ada_help_container').length;
          if ($rootScope.accessibilityViewed) {
            // should only trigger one time when the ada_help_container gets added to the page
            trackerSvc.trackEvent('Accessiblity Widget Viewed');
          }
        }

        var pageHeight = doc.height();
        if ($scope.windowData.pageHeight != pageHeight) {
          $scope.windowData.pageHeight = pageHeight;
          $scope.$broadcast('pageHeightChanged', $scope.windowData);
        }
      }

      function locationSearchParams() {
        var search = window.location.search;
        if (!search) {
          return {};
        }
        var params = {};
        search.replace(/^\?/, '').split('&').forEach(function(paramStr) {
          var part = paramStr.split('=');
          params[part[0]] = part[1];
        });
        return params;
      }

      $scope.locationSearchParams = locationSearchParams;

      var url = $location.absUrl().split('?')[0].split('/');

      if (window.Raygun && !window.referralCampaign && url.indexOf('refer') > -1) {
        Raygun
          .withTags(['ambassador'])
          .send(new Error('Campaign id is not present on the page.'), { email: window.email, cdata: cdata });
      }

      // Reopening the Ambassador sharing gate to see if we get parity with Extole
      // window.ambassadorOnloadFlag = cdata.totalAllTimeOrders > 0;
      $scope.referralCampaign = window.referralCampaign;
      $scope.referralCampaignName = window.referralCampaignName;
      $scope.referralCampaignGroup = window.referralCampaignGroup;
    }
  ]);

/* global mobileMin, tabletMin, mediumMin, desktopMin, desktopMax, currentBreakpoint:true, breakpoints, triggerImgResize, dataLayer, jQuery */
window.inventory = window.inventory || {};

window.isMobileDevice = isMobileDevice();
window.createUser = createUser;

var evt = document.createEvent("Event");
evt.initEvent("breakpointUpdate", true, true);

(function(window) {
  window.currentBreakpoint = null;
  var checkInt = 100;

  window.mobileMin = 320;
  window.tabletMin = 560;
  window.mediumMin = 760;
  window.desktopMin = 960;
  window.desktopMax = 1300;

  window.breakpoints = {};
  window.breakpoints[mobileMin] = 'mobile';
  window.breakpoints[tabletMin] = 'tablet';
  window.breakpoints[mediumMin] = 'medium';
  window.breakpoints[desktopMin] = 'desktop';
  window.breakpoints[desktopMax] = 'max';

  window.watchResize = function(callback) {
    var resizing;

    function done() {
      var currSize = window.innerWidth || document.body.offsetWidth;
      clearTimeout(resizing);
      resizing = null;

      // only run on a true resize
      callback(currSize);
    }

    window.addEventListener('resize', function() {
      if (resizing) {
        clearTimeout(resizing);
        resizing = null;
      }
      resizing = setTimeout(done, checkInt);
    });

    // init
    callback();
  };

  // do stuff after breakpoint
  window.watchResize(function(size) {
    if (size < tabletMin && currentBreakpoint != breakpoints[mobileMin]) {
      currentBreakpoint = breakpoints[mobileMin];
      return triggerImgResize();
    }

    if (size >= tabletMin && size < mediumMin && currentBreakpoint != breakpoints[tabletMin]) {
      currentBreakpoint = breakpoints[tabletMin];
      return triggerImgResize();
    }

    if (size >= mediumMin && size < desktopMin && currentBreakpoint != breakpoints[mediumMin]) {
      currentBreakpoint = breakpoints[mediumMin];
      return triggerImgResize();
    }

    if (size >= desktopMin && size < desktopMax && currentBreakpoint != breakpoints[desktopMin]) {
      currentBreakpoint = breakpoints[desktopMin];
      return triggerImgResize();
    }

    if (size >= desktopMax && currentBreakpoint != breakpoints[desktopMax]) {
      currentBreakpoint = breakpoints[desktopMax];
      return triggerImgResize();
    }

  });

  window.triggerImgResize = function() {
    document.dispatchEvent(evt);
  };

}(window));

//- var data = {
//-   api_key: value,
//-   email: value,
//-   list_id: value,
//-   source: value
//- };
function createUser(data) {
  if (!data.api_key && !data.email) {
    return false;
  }

  $.ajax({
    type: "POST",
    url: "/api/customer/createCustomer",
    data: data,
    async: false,
    success: function() {
      return true;
    },
    error: function() {
      return false;
    }
  });
}

function isMobileDevice() {
  var check = false;
  (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

// Pluralizes a string
// argument `plural` is optional
// $.pluralize(4, 'car') // 'cars'
// $.pluralize('4', 'goose', 'geese') // 'geese'
$.pluralize = function(num, single, plural) {
  return +num === 1 ? single :
    arguments.length > 2 ? plural :
    single + 's';
};

$.dollar = function(amount, forceNumber) {
  amount = isNaN(amount) ? 0 : +amount;
  if (amount === 0 && !forceNumber) {
    return 'Free';
  } else {
    return ((amount < 0) ? '-' : '') + '$' + Math.abs(amount).toFixed(2);
  }
};

$.isMobile = function() {
  return window.innerWidth <= 568;
};

$.isTablet = function() {
  return !$.isMobile() && window.innerWidth <= 768;
};

// Custom dropdown code.
var dropdownTyping = {
  search: '',
  timeout: null
};
$.fn.customDropdown = function() {
  var realDropdown = this;
  var data = [];
  var selected;
  var customId;

  if (!realDropdown.is('select')) {
    return;
  }

  realDropdown.children('option').each(function() {
    var self = $(this);
    var classAttr = self.attr('class');
    var item = {
      val: self.val(),
      text: self.text(),
      selected: false,
      classes: classAttr ? classAttr : null
    };

    if (!selected) {
      selected = item;
    }

    if (self.is(':selected')) {
      selected = item;
      item.selected = true;
    }
    if (item.val != "?") {
      data.push(item);
    }
  });

  customId = realDropdown.data('custom-id');
  if (customId) {
    $('[data-custom-rel="' + customId + '"]').remove();
    realDropdown.removeClass('hiddenButPresent');
  }

  var cssProps = [
    'vertical-align',
    'float',
    'display'
  ];

  var cont = $('<div/>')
    .addClass('customDropdown')
    .css(realDropdown.css(cssProps))
    .addClass(realDropdown.attr('class'));

  if (cont.css('min-width') === '0px') {
    cont.css('min-width', realDropdown.outerWidth());
  }

  if (realDropdown.is(':disabled')) {
    cont.addClass('disabled');
  }

  realDropdown.addClass('hiddenButPresent');

  customId = new Date().getTime().toString(36);
  realDropdown.data('custom-id', customId);
  // Since this isn't real we have to set it as an attribute and not use data... for reasons?
  cont.attr('data-custom-rel', customId);

  var select = $('<div/>')
    .addClass('select')
    .append(
      $('<div/>').html(selected.text).addClass(selected.classes),
      $('<div/>').addClass('arrow down')
    );

  var options = $('<ul/>').addClass('option');

  $.each(data, function() {
    var opt = $('<li/>')
      .data('val', this.val)
      .html(this.text);

    if (this.selected) {
      opt.addClass('selected');
    }

    if (this.classes) {
      opt.addClass(this.classes);
    }

    options.append(opt);
  });

  select.mousedown(function() {
    select.data("mousedown", true);
  });

  select.mouseup(function() {
    select.data("mousedown", false);
  });

  select.focus(function() {
    if (!select.data("mousedown")) {
      select.click();
    }
  });

  select.on('click', function(e) {
    e.stopPropagation();

    if (realDropdown.is(':disabled')) {
      return;
    }

    if (options.is('.expanded')) {
      contractOptions();
    } else {
      expandOptions();
    }
  });

  realDropdown.change(function() {
    var sel = $(this).children(':selected');

    select
      .children('div:first')
      .html(sel.text());

    options
      .children('li')
      .removeClass('selected');

    options
      .children('li')
      .each(function() {
        var li = $(this);

        if (li.data('val') == sel.val()) {
          li.addClass('selected');
          return false;
        }
      });
    contractOptions();
  });

  cont
    .append(select)
    .append(options);

  realDropdown.after(cont);

  $("#container :input, #container .customDropdown > .select").not('.hide').each(function(i) {
    $(this).attr('tabindex', i + 1);
    if ($(this).is('.select')) {
      $(':input[tabindex="' + (i + 1) + '"]').removeAttr('tabindex');
    }
  });

  function keyPress(e) {
    var current = options.children('li.selected');
    var selected;

    // Special control keys
    switch (e.which) {
      case 27: // Escape
        contractOptions();
        break;

      case 9: // Tab
      case 13: // Return
        triggerOptionSelect();
        contractOptions();
        break;

      case 38: // Up
        selected = current.prev();
        if (selected.length === 0) {
          selected = options.children('li').last();
        }
        break;

      case 40: // Down
        selected = current.next();
        if (selected.length === 0) {
          selected = options.children('li').first();
        }
        break;
    }


    // Detect typing
    if (!selected && e.which >= 48 && e.which <= 90) {
      clearTimeout(dropdownTyping.timeout);
      dropdownTyping.search += String.fromCharCode(e.which);
      dropdownTyping.timeout = setTimeout(clearTextSearch, 600);
      selected = searchOptions();
    }

    if (selected) {
      selectOption(selected);
    }
  }

  function selectOption(elem) {
    elem
      .addClass('selected')
      .siblings()
      .removeClass('selected');

    options.scrollTop(0).scrollTop(elem.position().top);
  }

  function clearTextSearch() {
    clearTimeout(dropdownTyping.timeout);
    dropdownTyping.search = '';
  }

  function searchOptions() {
    var search = new RegExp('^' + dropdownTyping.search, 'i');

    // We'd use filter here if it was supported in more browsers.
    var selected;
    options.children('li').each(function() {
      if (search.test($(this).text())) {
        selected = $(this);
        return false;
      }
    });
    return selected;
  }

  function stopScroll(e) {
    if (e.which == 40 || e.which == 38) {
      e.preventDefault();
      return false;
    }
  }

  function triggerOptionSelect() {
    var selected = options.children('li.selected');
    realDropdown
      .val(selected.data('val'))
      .change();
  }

  function contractOptions() {
    if (realDropdown.is(':disabled')) {
      return;
    }

    select.off('keydown', keyPress);
    $(window).off('keydown', stopScroll);

    var arrow = options.parents('.customDropdown').find('.arrow');
    $('body').off('click');

    arrow
      .removeClass('up')
      .addClass('down');

    select.removeClass('expanded');
    options.removeClass('expanded');
  }

  function expandOptions() {
    if (realDropdown.is(':disabled')) {
      return;
    }

    select.on('keydown', keyPress);
    $(window).on('keydown', stopScroll);

    var arrow = options.parents('.customDropdown').find('.arrow');
    arrow.addClass('up').removeClass('down');

    select.addClass('expanded');
    options.addClass('expanded');
    $('body').off('click').on('click', function() {
      contractOptions();
    });
    options.children().off('mousedown').on('mousedown', function(e) {
      e.stopPropagation();
      selectOption($(this));
      triggerOptionSelect();
    });
  }

  return cont;
};

// Used to create a callback func that will auto-deal with server errors first
// The following are the ways you can pass arguments:
// (callback)
// (errContainer, callback)
// (errContainer, callback, errCallback)
// (options) -> options.errContainer, options.elementMap, options.callback, options.errCallback
// options.elementMap keys are the input .desc()s, and values are .desc, .input, .handler
! function() {
  var slice = Array.prototype.slice;
  var toString = Object.prototype.toString;
  var noOp = function() {};

  $.dealWithIssues = function() {
    var args = slice.call(arguments);
    var errContainer, callback, errCallback, elementMap;
    var usingGeneric = false;

    if (args.length === 1) {
      if (toString.call(args[0]) === '[object Object]') {
        errContainer = args[0].errContainer;
        callback = args[0].callback;
        errCallback = args[0].errCallback;
        elementMap = args[0].elementMap;
      } else {
        callback = args[0];
      }
    } else {
      errContainer = args[0];
      callback = args[1];
      errCallback = args[2];
    }

    errContainer = errContainer || (usingGeneric = true && '#genericErrors');
    callback = callback || noOp;
    errCallback = errCallback || noOp;
    elementMap = elementMap || {};

    errContainer = $(errContainer);

    return function(res) {
      var keys;
      var list;
      var err = res.err;
      var errRedirect = res.errRedirect;
      var validation = res.validation;
      var count;

      if (!err && errRedirect) {
        return redirect(errRedirect);
      }

      if (!validation) {
        // checking if not successful, but without errors
        if (res.success === 0) {
          if (!err) {
            err = 'An error occurred';
          }
        } else {
          errContainer.addClass('hide');
          callback(res);
          return;
        }
      }

      errContainer = $(errContainer);
      list = $('<ul></ul>');

      if (err) {
        if (!validation) {
          list.append(
            $('<li></li>')
            .addClass('summary')
            .text(err)
          );
        }
      } else if (validation) {
        count = validation instanceof Array ? count.length :
          typeof Object.keys === 'function' ? Object.keys(validation).length :
          $.map(validation, function(value, key) {
            return key;
          }).length;

        list.append(
          $('<li></li>').text(
            $.pluralize(count, '1 error has', keys.length + ' errors have') +
            ' been found. Please correct the ' + $.pluralize(keys.length, 'field') +
            ' below.'
          )
        );
      }

      if (validation) {
        if (validation instanceof Array) {
          $.each(validation, function(key, value) {
            list.append(
              $('<li></li>').text(value)
            );
          });
        } else {
          keys = $.map(validation, function(value, key) {
            return {
              key: key,
              value: value
            };
          });

          $.each(keys, function(index, obj) {
            var input = $('#' + obj.key);
            var desc = input.desc();
            var mapped = elementMap[obj.key];

            if (mapped) {
              input = mapped.input || input;
              // allowing mapped inputs of '#someid' instead of $('#someid')
              input = typeof input === 'string' ? $(input) : input,
                desc = mapped.desc ? mapped.desc : input.desc();
            } else if (!desc) {
              desc = obj.key;
            }

            list.append(
              $('<li></li>').text(desc + ' ' + obj.value)
            );

            if (mapped && mapped.handler) {
              mapped.handler();
            } else if (input) {
              input.addClass('incorrect');
            }
          });
        }
      }

      list
        .find('li')
        .first()
        .addClass('first');

      if (usingGeneric) {
        showAlertModal('Oops!', list, [{
          text: 'OK',
          action: errRedirect
        }]);
      } else {
        errContainer.find('ul').empty().append(list.children('li'));
        list = undefined;
        errContainer.removeClass('hide');
        errContainer.fadeIn(520);
      }

      errCallback(res, validation);
    };
  };
}();

function showModal(modalElem) {
  var container = $('#container');
  var modalName = modalElem.attr('id');

  if (modalElem.length > 0) {
    if (modalName === 'photo-modal') {
      modalName = modalElem.find('.prod_name').html() + ' photo-modal';
    }

    dataLayer.push({
      'event': 'MRCustom',
      'category': 'modal',
      'action': 'show',
      'label': modalName + ', ' + window.location.pathname
    });

    $('#veil').removeClass('hide');
    $('body').addClass('no-scroll');
    $('.modal').not(modalElem).fadeOut('fast', function() {
      modalElem.fadeIn('fast');
      modalElem.find('input:first').focus();
    });

    if (modalElem.find('input[type="email"]') && modalElem.find('input[type="email"]').val()) {
      modalElem.find('input[type="password"]').focus();
    }

    container.bind('touchmove', function(e) {
      e.preventDefault();
    }).addClass('no-scroll').removeClass('nav-open');
  }
}

function showAlertModal(header, content, buttons) {
  var defaultButton = {
    text: 'OK',
    action: null,
    className: ''
  };

  if (!buttons || buttons.length === 0) {
    buttons = [defaultButton];
  }

  var alertModal = $('#pseudo_alert');
  alertModal.find('.header').html(header);
  alertModal.find('.text').html(content);

  var buttonArea = alertModal.find('.buttons');
  buttonArea.empty();

  $.each(buttons, function(index, button) {
    var text = button.text || defaultButton.text;
    var className = button.className || defaultButton.className;
    var action = button.action || defaultButton.action;

    var btn = $('<a/>');
    btn.text(text);
    btn.addClass('button');
    btn.addClass(className);
    btn.attr('href', '');
    btn.on('click', function(e) {
      e.preventDefault();
      if (!action) {
        hideModal();
      } else {
        if (typeof action === 'function') {
          hideModal();
          action();
        } else {
          redirect(action);
        }
      }
    });
    buttonArea.append(btn);
  });

  showModal(alertModal);
}

function hideModal() {
  $('.modal').fadeOut('fast', function() {
    $('#veil').addClass('hide');
    $('body').removeClass('no-scroll');
    $('#youtube_modal_iframe').removeAttr('src');
    $(document).unbind('keyup');
    $('#container').unbind('touchmove').removeClass('no-scroll');
  });
}

function redirect(location, carry) {
  if (arguments.length > 1) {
    var cookieStr = 'carriedFromRedirect=' + JSON.stringify(carry) + '; ';
    cookieStr += 'path=/;';
    document.cookie = cookieStr;
  }

  window.location = location.replace(/[:()<>]/g, '');
}

! function() {
  var msie = /MSIE ([0-9]{1,}[.0-9]{0,})/;

  window.getInternetExplorerVersion = function() {
    var resp = -1; // Return value assumes failure.

    if (navigator.appName === 'Microsoft Internet Explorer') {
      if (msie.exec(navigator.userAgent) != null) {
        resp = +(RegExp.$1);
      }
    }

    return resp;
  };
}();

// Add format method to Date objects
! function() {
  /*
   * Date Format 1.2.3
   * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
   * MIT license
   *
   * Includes enhancements by Scott Trenda <scott.trenda.net>
   * and Kris Kowal <cixar.com/~kris.kowal/>
   *
   * Accepts a date, a mask, or a date and a mask.
   * Returns a formatted version of the given date.
   * The date defaults to the current date/time.
   * The mask defaults to dateFormat.masks.default.
   */

  // if some future version of javascript has this method, don't do anything.
  if (Date.prototype.format) {
    return;
  }
  var dateFormat = function() {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function(val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };

    // Regexes and supporting functions are cached through closure
    return function(date, mask, utc) {
      var dF = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d: d,
          dd: pad(d),
          ddd: dF.i18n.dayNames[D],
          dddd: dF.i18n.dayNames[D + 7],
          m: m + 1,
          mm: pad(m + 1),
          mmm: dF.i18n.monthNames[m],
          mmmm: dF.i18n.monthNames[m + 12],
          yy: String(y).slice(2),
          yyyy: y,
          h: H % 12 || 12,
          hh: pad(H % 12 || 12),
          H: H,
          HH: pad(H),
          M: M,
          MM: pad(M),
          s: s,
          ss: pad(s),
          l: pad(L, 3),
          L: pad(L > 99 ? Math.round(L / 10) : L),
          t: H < 12 ? "a" : "p",
          tt: H < 12 ? "am" : "pm",
          T: H < 12 ? "A" : "P",
          TT: H < 12 ? "AM" : "PM",
          Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

      return mask.replace(token, function($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  // Some common format strings
  dateFormat.masks = {
    "default": "ddd mmm dd yyyy HH:MM:ss",
    shortDate: "m/d/yy",
    mediumDate: "mmm d, yyyy",
    longDate: "mmmm d, yyyy",
    fullDate: "dddd, mmmm d, yyyy",
    shortTime: "h:MM TT",
    mediumTime: "h:MM:ss TT",
    longTime: "h:MM:ss TT Z",
    isoDate: "yyyy-mm-dd",
    isoTime: "HH:MM:ss",
    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
  };

  // For convenience...
  Date.prototype.format = function(mask, utc) {
    return dateFormat(this, mask, utc);
  };
}();

$(function() {
  // Any custom dropdowns, make 'em custom here
  $('select[data-custom]').each(function() {
    $(this).customDropdown();
  });

  $('.dropdownWrapper').on('click', function(e) {
    $(this).toggleClass('active');
    e.stopPropagation();
  });

  $('.showYoutubeModal').on('click', function() {
    var modal = $('#youtube_modal');
    $('#youtube_modal_iframe').attr('src', 'https://www.youtube.com/embed/' + $(this).attr('rel') + '?autoplay=1&wmode=transparent');
    showModal(modal);
  });

  $('.showYoutubeFullscreen').first().on('click', function() {
    var self = $(this);
    var frame = self.attr('rev');
    var method = self.find('img').attr('rev');

    if (frame) {
      frame = $(frame);
    } else {
      frame = $('#youtube-fullscreen-iframe').appendTo('body'); // make sure it's absolute to body
    }

    frame
      .attr('src', 'https://www.youtube.com/embed/' + $(this).attr('rel') + '?autoplay=1&wmode=transparent')
      .removeClass('hide');

    if (method && window[method]) {
      window[method]();
    }
  });

  // Modal binds
  $('[showModal]').on('click', function(e) {
    e.preventDefault();

    var modalId = $(this).attr('showModal');
    showModal($(modalId));
  });

  $('.modal .close').on('click', function(e) {
    e.preventDefault();
    if ($(this).attr('href').length) {
      redirect($(this).attr('href'));
    } else {
      hideModal();
    }
  });

  $('.newTabCloseModal').click(function() {
    hideModal();
  });

  // Global binds
  $('input,select').change(function() {
    $(this).removeClass('incorrect');
    var name = $(this).attr('name');
    $('[name="' + name + '"]').removeClass('incorrect');
  });

  $('[enter]').keyup(function(e) {
    var self = $(this);
    var nope, method;

    if (e.which == 13) {
      nope = $.data(self, 'no[enter]');

      if (nope === true) {
        return;
      }

      // preventing another enter for 100ms
      $.data(self, 'no[enter]', true);
      setTimeout(function() {
        $.data(self, 'no[enter]', false);
      }, 100);

      method = self.attr('enter').split('|');

      if (method.length == 1) {
        window[method[0]](self);
      } else {
        $(method[0]).trigger(method[1]);
      }
    }
  });

  $('i.info').hover(function() {
    var self = $(this);
    var popover = self.siblings('.popover');
    var arrow = popover.children('.arrow');
    popover.css({
      top: -(popover.height())
    });
    arrow.css({
      left: self.position().left + self.width()
    });
    popover.fadeIn('fast');
  }, function() {
    $(this).siblings('.popover').fadeOut('fast');
  });

  $('.supportToggle, .close-support').on('click', function(e) {
    e.preventDefault();
    var container = $('#container');
    if (container.is(e.target)) {
      return;
    }

    if ($('.fixedBottom .support').is('.expanded')) {
      $('.fixedBottom .support').removeClass('expanded');
    } else {
      $('.fixedBottom .support').addClass('expanded');
    }
  });

  $('.backLink').on('click', function(e) {
    e.preventDefault();
    window.history.back();
  });

  $('.scrollToTop .back2top').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 500, 'swing');
  });

  (function($) {
    // $(':radio').checkboxVal();
    // returns the selected radio value, or null
    $.fn.radioVal = function() {
      var name = this.attr('name');
      if (name !== undefined) {
        var selected = $('[name="' + name + '"]:checked');
        return selected.length ? selected.val() : null;
      }
      return null;
    };

    // $('[name]').mixedVal();
    // returns the value of an input
    // boolean if checkedbox
    // selected value of a radio button (or null)
    $.fn.mixedVal = function() {
      return this.is(':radio') ? this.radioVal() :
        this.is(':checkbox') ? this.is(':checked') :
        this.val();
    };

    $.fn.desc = function() {
      var desc = this.attr('desc');
      var name;
      var label;

      if (desc) {
        return desc;
      }

      name = this.attr('name');

      // if no desc found, try to find a label
      if (name && (label = $('label[for="' + name + '"]'))) {
        return label.text();
      }

      return name;
    };

  }(jQuery));


});
/** global $, $.cookie */

/**
 * @typedef {object} EmailCaptureParams
 * @param {string} emailCaptureUrl endpoint for submitting email
 */

/**
 * @typedef {object} CampaignModalDef
 * @property {object} message html message to display
 * @property {object} campaignSubmitParams hash of extra params to submit with email
 * @property {(string|array)[]} successAction action to call on successful email submit.  first param is method, rest are args.
 */

/**
 * @typedef {object} CampaignBannerDef
 * @property {string} message html message to display
 * @property {string} actionTitle label for action button
 * @property {(string|array|object)[]} action action to call on button select. first param is method, rest are args.
 */

/**
 * @typedef {object} Campaign
 * @property {string} id unique identifier
 * @property {string[]} rules rules to pass before executing campaign
 * @property {string[]} [allowedOnPaths] Path Prefixes Where Capture IS Permitted
 * @property {string[]} [bannedOnPaths] Path Prefixes Where Capture Not Permitted
 * @property {CampaignModalDef} [modal] modal display rules
 * @property {CampaignBannerDef} [banner] banner display rules
 */

/**
 * Framework-independent drop-in replacement for Lytics email capture.
 *
 * UX and UI are identical to lytics.
 *
 * To use, run `new EmailCapture(cdata).executeEmailCaptureCampaigns();` on page init.
 *
 * @param {object} customerData 'cdata' mr hash
 * @param {EmailCaptureParams} [params] configuration params
 */
function EmailCapture(customerData, params) { // eslint-disable-line no-unused-vars

  const Mailcheck = {domainThreshold:2,secondLevelThreshold:2,topLevelThreshold:2,defaultDomains:["msn.com","bellsouth.net","telus.net","comcast.net","optusnet.com.au","earthlink.net","qq.com","sky.com","icloud.com","mac.com","sympatico.ca","googlemail.com","att.net","xtra.co.nz","web.de","cox.net","gmail.com","ymail.com","aim.com","rogers.com","verizon.net","rocketmail.com","google.com","optonline.net","sbcglobal.net","aol.com","me.com","btinternet.com","charter.net","shaw.ca"],defaultSecondLevelDomains:["yahoo","hotmail","mail","live","outlook","gmx"],defaultTopLevelDomains:["com","com.au","com.tw","ca","co.nz","co.uk","de","fr","it","ru","net","org","edu","gov","jp","nl","kr","se","eu","ie","co.il","us","at","be","dk","hk","es","gr","ch","no","cz","in","net","net.au","info","biz","mil","co.jp","sg","hu"],run:function(a){a.domains=a.domains||Mailcheck.defaultDomains,a.secondLevelDomains=a.secondLevelDomains||Mailcheck.defaultSecondLevelDomains,a.topLevelDomains=a.topLevelDomains||Mailcheck.defaultTopLevelDomains,a.distanceFunction=a.distanceFunction||Mailcheck.sift3Distance;var b=function(a){return a;},c=a.suggested||b,d=a.empty||b,e=Mailcheck.suggest(Mailcheck.encodeEmail(a.email),a.domains,a.secondLevelDomains,a.topLevelDomains,a.distanceFunction);return e?c(e):d();},suggest:function(a,b,c,d,e){a=a.toLowerCase();var f=this.splitEmail(a);if (c&&d&&-1!==c.indexOf(f.secondLevelDomain)&&-1!==d.indexOf(f.topLevelDomain)) return !1;var g=this.findClosestDomain(f.domain,b,e,this.domainThreshold);if (g) return g==f.domain?!1:{address:f.address,domain:g,full:f.address+"@"+g};var h=this.findClosestDomain(f.secondLevelDomain,c,e,this.secondLevelThreshold),i=this.findClosestDomain(f.topLevelDomain,d,e,this.topLevelThreshold);if (f.domain){var g=f.domain,j=!1;if (h&&h!=f.secondLevelDomain&&(g=g.replace(f.secondLevelDomain,h),j=!0),i&&i!=f.topLevelDomain&&(g=g.replace(f.topLevelDomain,i),j=!0),1==j) return {address:f.address,domain:g,full:f.address+"@"+g};} return !1;},findClosestDomain:function(a,b,c,d){d=d||this.topLevelThreshold;var e,f=99,g=null;if (!a||!b) return !1;c||(c=this.sift3Distance);for (var h=0;h<b.length;h++){if (a===b[h]) return a;e=c(a,b[h]),f>e&&(f=e,g=b[h]);} return d>=f&&null!==g?g:!1;},sift3Distance:function(a,b){if (null==a||0===a.length) return null==b||0===b.length?0:b.length;if (null==b||0===b.length) return a.length;for (var c=0,d=0,e=0,f=0,g=5;c+d<a.length&&c+e<b.length;){if (a.charAt(c+d)==b.charAt(c+e))f++;else {d=0,e=0;for (var h=0;g>h;h++){if (c+h<a.length&&a.charAt(c+h)==b.charAt(c)){d=h;break;} if (c+h<b.length&&a.charAt(c)==b.charAt(c+h)){e=h;break;}}}c++;} return (a.length+b.length)/2-f;},splitEmail:function(a){var b=a.trim().split("@");if (b.length<2) return !1;for (var c=0;c<b.length;c++) if (""===b[c]) return !1;var d=b.pop(),e=d.split("."),f="",g="";if (0==e.length) return !1;if (1==e.length)g=e[0];else {f=e[0];for (var c=1;c<e.length;c++)g+=e[c]+".";g=g.substring(0,g.length-1);} return {topLevelDomain:g,secondLevelDomain:f,domain:d,address:b.join("@")};},encodeEmail:function(a){var b=encodeURI(a);return b=b.replace("%20"," ").replace("%25","%").replace("%5E","^").replace("%60","`").replace("%7B","{").replace("%7C","|").replace("%7D","}");}};"undefined"!=typeof module&&module.exports&&(module.exports=Mailcheck),"function"==typeof define&&define.amd&&define("mailcheck",[],function(){return Mailcheck;}),"undefined"!=typeof window&&window.jQuery&&!function(a){a.fn.mailcheck=function(a){var b=this;if (a.suggested){var c=a.suggested;a.suggested=function(a){c(b,a);};} if (a.empty){var d=a.empty;a.empty=function(){d.call(null,b);};}a.email=this.val(),Mailcheck.run(a);};}(jQuery); // eslint-disable-line

  //
  // Definitions
  //

  /** Default Modal Message */
  var DEFAULT_MODAL_MSG = {
    "email-capture-modal-msg": '<div class="xs-f-small md-f-large max-at-tweak">Share your email &amp; we\'ll treat you to</div><div class="bold xs-f-xlarge max-at-tweak color-mr-purple">FREE SHIPPING</div> <div class="xs-f-small md-f-large max-at-tweak">on your first order.</div>',

    "email-capture-modal-msg-free-shipping-disclaimer": '<div class="color-smoke xs-f-xxsmall">*Free standard shipping on first purchase. Valid only for new customers.</div>',

    "success-state": '<p class="pf-widget-headline">Thank You</p>'
                      + '<div class="pf-widget-message">'
                        + '<span>Free shipping on your first purchase will be automatically applied at checkout.</span>'
                        + '<span>*Free standing shipping on first purchase.  Valid only for new customers.</span>'
                      + '</div>'
                      + '<button class="pf-widget-btn pf-widget-ok" type="button" id="email-capture-modal-success-ok-btn">CONTINUE SHOPPING</button>',

    "error-state": '<p class="pf-widget-headline"></p>'
                    + '<div class="pf-widget-message">'
                    +   '<span>As an existing customer, FREE SHIPPING is not available to you.</span>'
                    + '</div>'
  };

  var COLORBAR_MODAL_MSG = {
    "email-capture-modal-msg": '<div class="xs-f-small md-f-large max-at-tweak xs-ml-150pct xs-mr-150pct">Share your email and get <span style="white-space: nowrap;">Color Bar<span> updates, offers, and more</div>',
    "success-state": '<p class="pf-widget-headline">Thank You</p>'
                      + '<div class="pf-widget-message">'
                        + '<span>Free shipping on your first purchase will be automatically applied at checkout.</span>'
                        + '<span>*Free standing shipping on first purchase.  Valid only for new customers.</span>'
                      + '</div>'
                      + '<button class="pf-widget-btn pf-widget-ok" type="button" id="email-capture-modal-success-ok-btn">CONTINUE SHOPPING</button>'
  };


  /** Id to use for 'email source' on backend */
  var EMAIL_SOURCE = "popup_email_capture";

  /**
   * Campaign Rules - function that takes a context and returns boolean indicating if
   * the rule has passed for the given context ('cdata' object in this case.)
   */
  var CAMPAIGN_RULES = {
    isThirdParty: function(context) {
      return !!context.thirdParty;
    },

    isFirstTimeVisitor: function(context) {
      return context.visitorType == "Net New";
    },

    isReturnVisitor: function(context) {
      return context.visitorType == "Return Visitor";
    },

    hasCapturedEmail: function(context) {
      return context.email && (context.emailSource == "lytics" || context.emailSource == EMAIL_SOURCE);
    },

    hasEmail: function(context) {
      return !!context.email;
    },

    hasDismissedEmailModal: function() {
      return $.cookie("no_email_capture_modal");
    },

    hasPurchaseHistory: function(context) {
      return context.isCustomer;
    },

    hasCustomerId: function(context) {
      return !!context.cid;
    }
  };

  var MENS_ALLOWED_PATHS = [
    "/men",
    "/product/mens-"
  ];

  /**
   * Campaign Definitions.
   *
   * Iterated over in sequential order, and the first that's rules pass
   * is displayed the user.  Two campaigns will not display simultaneously.
   *
   * Serializable so as to be simple to control via CMS later if need be.
   *
   * @type {Campaign[]}
   *
   * */
  var CAMPAIGNS = [
    { // colorbar email capture modal
      id: "colorbar_email_capture_modal",
      modal: {
        message: COLORBAR_MODAL_MSG,
        campaignSubmitParams: {
          offerCode: "Color_FSOrder"
        },
        successAction: [],
      },
      rules: [
        "isFirstTimeVisitor",
        "!hasCapturedEmail",
        "!hasEmail",
        "!hasDismissedEmailModal",
        "!hasPurchaseHistory"
      ],
      allowedOnPaths: [
        "/colorbar"
      ]
    },

    { // mens email capture modal
      id: "menssignup_email_capture_modal",
      modal: {
        message: DEFAULT_MODAL_MSG,
        campaignSubmitParams: {
          offerCode: "Color_FSOrder",
          email_source: "menssignup_popup_email_capture"
        },
        successAction: [
          "presentCampaignBanner",
          '<span style="font-weight:600;">FREE SHIPPING</span> automatically applied at checkout',
          "FIND MY COLOR MATCH",
          ["openUrl", "http://www.madison-reed.com/color-advisor-men", "_blank"]],
      },
      rules: [
        "isFirstTimeVisitor",
        "!hasCapturedEmail",
        "!hasEmail",
        "!hasDismissedEmailModal",
        "!hasPurchaseHistory"
      ],
      allowedOnPaths: MENS_ALLOWED_PATHS
    },

    { // primer third-party-capture modal
      id: "primer_email_capture_modal",
      modal: {
        message: DEFAULT_MODAL_MSG,
        campaignSubmitParams: {
          offerCode: "Color_FSOrder"
        },
        successAction: [
          "presentCampaignBanner",
          '<span style="font-weight:600;">FREE SHIPPING</span> automatically applied at checkout',
          "FIND YOUR PERFECT SHADE",
          ["openUrl", "http://www.madison-reed.com/color-advisor", "_blank"]]
      },
      rules: [
        "isThirdParty"
      ],
      bannedOnPaths: [
        "/account",
        "/careers",
        "/cart",
        "/checkout",
        "/color-advisor",
        "/color-advisor-ulta",
        "/color-crew",
        "/compare-shades",
        "/confirmation",
        "/email",
        "/product",
        "/shop/hair-color",
        "/support",
        "/term",
        "/signIn",
        "/signin",
        "/colorbar",
        "/booking",
        "/refer",
        "/share",
        "/tv",
        "/coloristcooperative",
        "/coloristaffiliates",
        "/coloristcooperative-raf",
        "/coloristcooperative-terms-and-conditions",
        "/quiz-on-q"
      ]
    },

    // capture modal
    {
      id: "email_capture_modal",
      modal: {
        message: DEFAULT_MODAL_MSG,
        campaignSubmitParams: {
          offerCode: "Color_FSOrder"
        },
        successAction: [
          "presentCampaignBanner",
          '<span style="font-weight:600;">FREE SHIPPING</span> automatically applied at checkout',
          "FIND YOUR PERFECT SHADE",
          ["openUrl", "http://www.madison-reed.com/color-advisor", "_blank"]]
      },
      rules: [
        "isFirstTimeVisitor",
        "!hasCapturedEmail",
        "!hasEmail",
        "!hasDismissedEmailModal",
        "!hasPurchaseHistory"
      ],
      bannedOnPaths: [
        "/account",
        "/careers",
        "/cart",
        "/checkout",
        "/color-advisor",
        "/color-advisor-ulta",
        "/color-crew",
        "/compare-shades",
        "/confirmation",
        "/email",
        "/product",
        "/shop/hair-color",
        "/support",
        "/term",
        "/signIn",
        "/signin",
        "/colorbar",
        "/booking",
        "/refer",
        "/share",
        "/tv",
        "/men",
        "/product/men",
        "/coloristcooperative",
        "/coloristaffiliates",
        "/coloristcooperative-raf",
        "/coloristcooperative-terms-and-conditions",
        "/quiz-on-q"
      ]
    },

    // "first time visitor and return visitor banner -- no email"
    {
      id: "return_visitor_no_email",
      banner: { // audience: "Free shipping no thanks"
        message: 'Want <span style="font-weight:600;">FREE SHIPPING</span> on your first order?',
        actionTitle: "UNLOCK MY OFFER",
        action: [
          "presentCaptureModal",
          DEFAULT_MODAL_MSG,
          {
            offerCode: "Color_FSOrder"
          },
          [
            "presentCampaignBanner",
            '<span style="font-weight:600;">FREE SHIPPING</span> automatically applied at checkout',
            "FIND YOUR PERFECT SHADE",
            ["openUrl", "http://www.madison-reed.com/color-advisor", "_blank"]
          ]
        ]
      },
      rules: [
        "!hasCapturedEmail",
        "!hasEmail",
        "!hasPurchaseHistory"
      ],
      bannedOnPaths: [
        "/account",
        "/careers",
        "/cart",
        "/checkout",
        "/color-advisor",
        "/color-advisor-ulta",
        "/color-crew",
        "/compare-shades",
        "/confirmation",
        "/email",
        "/product",
        "/shop/hair-color",
        "/support",
        "/term",
        "/signIn",
        "/signin",
        "/colorbar",
        "/booking",
        "/refer",
        "/share",
        "/tv",
        "/men",
        "/product/mens-",
        "/coloristcooperative",
        "/coloristaffiliates",
        "/coloristcooperative-raf",
        "/coloristcooperative-terms-and-conditions",
        "/quiz-on-q"
      ]
    },
    // "return visitor banner - email"
    {
      id: "return_visitor_email",
      rules: [
        "isReturnVisitor",
        "hasCapturedEmail",
        "!hasPurchaseHistory"
      ],
      banner: {
        message: '<span>Don’t forget, you’ve earned&nbsp;</span><span style="font-weight:600;">FREE SHIPPING&nbsp;</span><span>on your first order.</span>',
        actionTitle: "FIND YOUR PERFECT SHADE",
        action: ["openUrl", "http://www.madison-reed.com/color-advisor", "_blank"]
      },
      bannedOnPaths: [
        "/account",
        "/careers",
        "/cart",
        "/checkout",
        "/color-advisor",
        "/color-advisor-ulta",
        "/color-crew",
        "/compare-shades",
        "/confirmation",
        "/email",
        "/product",
        "/shop/hair-color",
        "/support",
        "/term",
        "/signIn",
        "/signin",
        "/colorbar",
        "/booking",
        "/refer",
        "/share",
        "/tv",
        "/men",
        "/product/mens-",
        "/coloristcooperative",
        "/coloristaffiliates",
        "/coloristcooperative-raf",
        "/coloristcooperative-terms-and-conditions",
        "/quiz-on-q"
      ]
    },
    // "first time MEN's visitor and return visitor banner -- no email"
    {
      id: "return_mens_visitor_no_email",
      banner: { // audience: "Free shipping no thanks"
        message: 'Want <span style="font-weight:600;">FREE SHIPPING</span> on your first order?',
        actionTitle: "UNLOCK MY OFFER",
        action: [
          "presentCaptureModal",
          DEFAULT_MODAL_MSG,
          {
            offerCode: "Color_FSOrder"
          },
          [
            "presentCampaignBanner",
            '<span style="font-weight:600;">FREE SHIPPING</span> automatically applied at checkout',
            "FIND MY COLOR MATCH",
            ["openUrl", "http://www.madison-reed.com/color-advisor-men", "_blank"]
          ]
        ]
      },
      rules: [
        "!hasCapturedEmail",
        "!hasEmail",
        "!hasPurchaseHistory"
      ],
      allowedOnPaths: MENS_ALLOWED_PATHS
    },
    //- "return MENs visitor banner - email"
    {
      id: "return_mens_visitor_email_men",
      rules: [
        "isReturnVisitor",
        "hasCapturedEmail",
        "!hasPurchaseHistory"
      ],
      banner: {
        message: '<span>Don’t forget, you’ve earned&nbsp;</span><span style="font-weight:600;">FREE SHIPPING&nbsp;</span><span>on your first order.</span>',
        actionTitle: "FIND MY COLOR MATCH",
        action: ["openUrl", "http://www.madison-reed.com/color-advisor-men", "_blank"]
      },
      allowedOnPaths: MENS_ALLOWED_PATHS
    }
  ];

  /** Modal HTML */
  var MODAL_HTML=
  '<div class="pf-widget pf-form pf-widget-modal pf-position-middle-center pf-widget-variant-1 pf-theme-none mr-lytics-modal" id="email-capture-modal">' +
  '  <div class="pf-widget-container">' +
  '    <div class="pf-va-middle">' +
  '      <div class="pf-widget-content">' +
  '        <button class="pf-widget-close" type="button" id="email-capture-modal-close-btn" data-mr-ass="close-email-capture">×</button>' +
  '        <div class="pf-widget-text">' +
  '          <div class="pf-widget-body">' +
  '            <div class="pf-va-middle" id="email-capture-body">' +
  '              <div class="pf-widget-message xs-f-medium md-f-large max-at-tweak" id="email-capture-modal-msg"><span>Share your email and we\'ll treat you to</span><span>FREE SHIPPING</span><span>on your first order.</span><span>*Free standard shipping on first purchase.  Valid only for new customers.</span></div>' +
  '              <form id="email-capture-form">' +
  '                <label for="email-capture-input" class="tooltip">Enter Email</label>' +
  '                <input id="email-capture-input" name="email" type="email" placeholder="Enter Email" data-required="true" data-mr-ass="email-capture-input"/>' +
  '                  <button class="pf-widget-btn pf-widget-ok bold max-at-tweak" type="submit" value="YES, PLEASE" id="email-capture-modal-submit-btn" data-mr-ass="email-capture-submit">YES, PLEASE</button>' +
  '                  <p class="domain-error-msg bold mb-10">Did you mean ' +
  '                    <span class="domain-suggested underline" style="cursor: pointer"></span> ?' +
  '                  </p>' +
  '                  <button class="pf-widget-btn pf-widget-cancel bold max-at-tweak" type="button" value="NO THANKS" id="email-capture-modal-dismiss-btn" data-mr-ass="email-capture-no-thanks">NO THANKS</button>' +
  '                </form>' +
  '              <div id="email-capture-modal-msg-free-shipping-disclaimer">' +
  '              </div>' +
  '            </div>' +
  '          </div>' +
  '          <div id="success-state" class="success-state">' +
  '            <p class="pf-widget-headline">Thank You</p>' +
  '            <div class="pf-widget-message"><span>Free shipping on your first purchase will be automatically applied at checkout.</span><span>*Free standing shipping on first purchase.  Valid only for new customers.</span></div>' +
  '            <button class="pf-widget-btn pf-widget-ok" type="button" id="email-capture-modal-success-ok-btn">CONTINUE SHOPPING</button>' +
  '          </div>' +
  '          <div id="error-state" class="error-state">' +
  '            <p class="pf-widget-headline"></p>' +
  '            <div class="pf-widget-message"> <span>As an existing customer, FREE SHIPPING is not available to you.</span></div>' +
  '          </div>' +
  '        </div>' +
  '      </div>' +
  '    </div>' +
  '  </div>';

  /** Banner HTML */
  var BANNER_HTML=
    '<div id="email-capture-banner" class="pf-widget pf-message pf-widget-bar pf-position-top-absolute pf-has-push-down pf-widget-variant-1 pf-theme-none mr-lytics-top-bar">' +
    '  <button type="button" id="email-capture-banner-close-btn" class="pf-widget-close">×</button>' +
    '  <div class="pf-bar-content">' +
    '    <p id="email-capture-banner-msg" class="pf-widget-message">Want <span style="font-weight:600;">FREE SHIPPING</span> on your first order?</p>' +
    '    <span><button type="button" id="email-capture-banner-confirm-btn" value="UNLOCK MY OFFER" class="pf-widget-btn pf-widget-ok">UNLOCK MY OFFER</button></span>' +
    '  </div>'+
    '</div>';


  //
  // Instance Variables
  //

  /** Customer Data */
  var cdata = customerData;

  /** Campaigns Executed on this Page */
  var campaignsExecuted = {};

  /** Scope */
  var self = this;

  /** Config Params */
  params = params || {};

  var $= window.jQuery || window.$;
  if ($ && $.cookie) {
    $.cookie.raw = true;

    $("body").append(BANNER_HTML);
    $("body").append(MODAL_HTML);
    $('.domain-error-msg').hide();

    $('#email-capture-input').on('keyup', function() {
      $(this).mailcheck({
        suggested: function(element, suggestion) {
          if (suggestion) {
            $('.domain-error-msg').show().children('span').html(suggestion.full);
          }
        },
        empty: function() {
          $('.domain-error-msg').hide();
        }
      });
    });

    $('.domain-suggested').on("click", function() {
      $('#email-capture-input').val($(this).text());
      $('.domain-error-msg').hide();
    });
  }

  //
  // Implementation
  //

  /**
   * Check if url is banned from email capture campaigns.
   * @returns {boolean} true if capture is allowed on current page
   */
  function doesPageAllowCapture(campaign) {
    if (campaign.allowedOnPaths) {
      for (var i = 0; i < campaign.allowedOnPaths.length; i++) {
        var path = campaign.allowedOnPaths[i];
        if (window.location.pathname.indexOf(path) == 0) {
          return true;
        }
      }
      return false;
    } else if (campaign.bannedOnPaths) {
      for (var j = 0; j < campaign.bannedOnPaths.length; j++) {
        var banned = campaign.bannedOnPaths[j];

        if (window.location.pathname.indexOf(banned) == 0) {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  }

  /**
   * Compare campaign rules hash to cdata to determine
   * if the campaign should display.
   *
   * @param {Campaign} campaign
   */
  function testCampaignRules(campaign) {

    for (var i = 0; i < campaign.rules.length; i++) {
      var rule = campaign.rules[i];
      var inv = rule.indexOf("!") + 1;
      var fn = rule.substring(inv, rule.length);
      var ruleResult = CAMPAIGN_RULES[fn](cdata);
      ruleResult = inv ? !ruleResult : ruleResult;
      if (!ruleResult) {
        return false;
      }
    }

    return true;
  }

  /**
   * Dismiss the Email Capture Modal.
   * @param {function} [dismissAction] function to execute after dismissal
   */
  function dismissCaptureModal(dismissAction) {
    $("#email-capture-modal").removeClass("opened");
    $.cookie("no_email_capture_modal", "true", { expires: 365, path: "/" });

    if (dismissAction) {
      dismissAction();
    }
  }

  /**
   * Present the modal form success state, and execute success Action.
   * Exit out of modal if there isn't a successMessage
   */
  function presentModalFormSuccessState(successMessage, successAction) {
    successAction = successAction || [];
    if (!successMessage) {
      return dismissCaptureModal(actionToFunction(successAction));
    }

    $('#success-state').html(successMessage);

    $("#email-capture-modal-success-ok-btn").on("click", function() {
      dismissCaptureModal(actionToFunction(successAction));
    });

    $("#email-capture-modal").addClass("success");
  }

  /**
   * Present the modal form error state.
   * Exit out of modal if there isn't an errorMessage
   */
  function presentModalFormErrorState(errorMessage) {
    if (!errorMessage) {
      return dismissCaptureModal();
    }

    $("#error-state").html(errorMessage);
    $("#email-capture-modal").addClass("error");
  }

  /**
   * Open URL.
   *
   * @param {string} url url to open
   * @param {string} target window target
   */
  function openUrl(url, target) {
    window.open(url, target);
  }

  /**
   * Turn action definition to function.
   *
   * @param {array} action array where first property is method name, rest are args
   * @param {object} [scope] scope to apply to generated function
   * @returns {function} executable action
   */
  function actionToFunction(action, scope) {
    if (typeof action == "function") {
      return action;
    }

    if (!action || !action.length) {
      return null;
    }

    var methodName = action[0];

    if (!methodName) {
      return null;
    }

    var args = action.slice(1, action.length);
    scope = scope || self;

    var supportedActions = {
      "openUrl": openUrl,
      "presentCaptureModal": self.presentCaptureModal,
      "presentCampaignBanner": presentCampaignBanner
    };

    var actionMethod = supportedActions[methodName];
    if (!actionMethod) {
      return null;
    }

    return function() {
      actionMethod.apply(scope, args);
    };
  }

  /**
   * Dismiss campaign banner.
   *
   * @param {function} [dismissAction] function to execute after dismissal
   */
  function dismissCampaignBanner(dismissAction) {
    $("body").removeClass("pf-push-down mr-lytics-top-bar-added opened");
    $("#email-capture-banner").removeClass("opened");

    if (dismissAction) {
      dismissAction();
    }
  }

  /**
   * Present campaign banner.
   *
   * @param {string} message banner display message
   * @param {string} actionTitle title for banner action button
   * @param {array} [confirmAction] action to execute after action button selected
   * @param {array} [dismissAction] action to execute after banner dismissed
   */
  function presentCampaignBanner(message, actionTitle, confirmAction, dismissAction) {
    $("#email-capture-banner-msg").html(message);

    $("#email-capture-banner-close-btn").on("click", function() {
      dismissCampaignBanner(actionToFunction(dismissAction));
    });

    $("#email-capture-banner-confirm-btn").text(actionTitle);
    $("#email-capture-banner-confirm-btn").on("click", function() {
      dismissCampaignBanner(actionToFunction(confirmAction));
    });

    $("#email-capture-banner").addClass("opened");
    $("body").addClass("pf-push-down mr-lytics-top-bar-added opened");
  }

  /**
   * Display the popup for the given campaign.
   *
   * @param {*} campaign
   */
  function executeCampaign(campaign) {
    var banner = campaign.banner;
    campaignsExecuted[campaign.id] = campaign;

    if (banner) {
      return presentCampaignBanner(banner.message, banner.actionTitle, banner.action);
    }

    var modal = campaign.modal;
    if (modal) {
      self.presentCaptureModal(modal.message, modal.campaignSubmitParams, modal.successAction, true);
    }
  }

  //
  // Public Methods
  //

  /**
   * Execute any valid campaign actions.
   */
  this.executeEmailCaptureCampaigns = function() {
    for (var i = 0; i < CAMPAIGNS.length; i++) {
      var campaign = CAMPAIGNS[i];
      if (campaignsExecuted[campaign.id]) {
        continue;
      }

      if (doesPageAllowCapture(campaign) === false) {
        continue;
      }

      if (testCampaignRules(campaign)) {
        setTimeout(function() {
          executeCampaign(campaign);
        }, 50);
        return;
      }
    }
  };

  /**
   * Generates the A/B experiment settings
   */
  function getExperimentSettings() {
    let showDelay = 0;
    let experimentEnabled = false;
    let experimentVersion = null;

    if (window.experiments && window.experiments['Email Capture Modal Popup Delay']) {
      experimentEnabled = true;
      experimentVersion = window.experiments['Email Capture Modal Popup Delay'];

      if (experimentVersion === 'A') {
        showDelay = 0;
      } else if (experimentVersion === 'B') {
        showDelay = 20000;
      }
    }

    return {
      showDelay,
      experimentEnabled,
      experimentVersion
    };
  }

  /**
   * Present the Email Capture Modal.
   *
   * @param {object} message display message for the modal
   * @param {object} campaignSubmitParams hash of additional params to submit with email
   * @param {array} [successAction] action on form submit success
   * @param {boolean} trackModalEvent decides if the event will be tracked by Segment or not
   */
  this.presentCaptureModal = function(message, campaignSubmitParams, successAction, trackModalEvent = false) {
    const expSettings = getExperimentSettings();
    const modalDelay = trackModalEvent ? expSettings.showDelay : 0;
    const trackSegmentEvent = trackModalEvent && expSettings.experimentEnabled && expSettings.experimentVersion;

    setTimeout(() => {
      // add content to #email-capture-modal-msg
      $("#email-capture-modal-msg").html(message["email-capture-modal-msg"]);

      // add content to #email-capture-modal-msg-free-shipping-disclaimer
      if (message['email-capture-modal-msg-free-shipping-disclaimer']) {
        $('#email-capture-modal-msg-free-shipping-disclaimer').html(message['email-capture-modal-msg-free-shipping-disclaimer']);
      } else {
        $('#email-capture-modal-msg-free-shipping-disclaimer').css("display", "none");
      }

      $("#email-capture-modal-close-btn, #email-capture-modal-dismiss-btn").on("click", function() {
        dismissCaptureModal();
      });

      if (trackSegmentEvent) {
        trackEvent('emailCaptureModalView', expSettings.experimentVersion);
      }

      $("#email-capture-form").submit(function(event) {
        event.preventDefault();

        // hide form body
        $("#email-capture-body").css("display", "none");

        var emailAddress = $(this).find(":input").val();
        campaignSubmitParams = campaignSubmitParams || {};
        campaignSubmitParams.email = emailAddress;
        campaignSubmitParams.email_source = campaignSubmitParams.email_source || EMAIL_SOURCE;
        campaignSubmitParams.skipPassword = true;
        var emailSubmitUrl = params.emailSubmitUrl || "/api/customer/createCustomerFromEmailCapture";

        $.ajax({
          type: "POST",
          url: emailSubmitUrl,
          xhrFields: {
            withCredentials: true
          },
          data: campaignSubmitParams
        }).done(function(result) {
          if (!result || !result.offerApplied) {
            presentModalFormErrorState(message['error-state']);
            return;
          }

          if ((result.numOrders && result.numOrders > 0) || (result.statusCode && result.statusCode != 200)) {
            presentModalFormErrorState(message['error-state']);
          } else {
            presentModalFormSuccessState(message['success-state'], successAction);

            if (trackSegmentEvent) {
              trackEvent('emailCaptureModalSubmit', expSettings.experimentVersion);
            }
          }
        }).fail(function(result) {
          if (result.responseJSON && result.responseJSON.errors && result.responseJSON.errors.email) {
            $("#email-capture-body").css("display", "block");
            $("#email-capture-modal-msg").append("<p class='bold xs-f-xsmall md-f-small max-at-tweak mt-15'>Please enter a valid email address</p>");
            return;
          }
          presentModalFormErrorState(message['error-state']);
        });
      });

      $("#email-capture-modal").addClass("opened");
    }, modalDelay);
  };

  /**
   * Tracks the A/B tested version on Segment
   * @param {string} eventName
   * @param {string} version
   */
  function trackEvent (eventName, version) {
    let properties = {};
    properties.dig = window.cdata.dig;
    properties.dug = window.cdata.dug;
    properties.isIOS = window.cdata.isIOS;
    properties.sessionId = window.cdata.sessionId;
    properties.agent_id = window.cdata.agent_id;
    properties.postal_code = window.cdata.postalCode;
    properties.version = version;

    if (window.cdata.user && window.cdata.user.id) {
      properties.user_id = window.cdata.user.id;
      if (window.cdata.user.email) {
        properties.email = window.cdata.user.email;
      }
    }

    const context = {
      location: window.cdata.locationContext
    };

    if (!properties.user_id) {
      context.anonymousId = this.cdata.dig;
    }

    if (window.analytics && window.analytics.track) {
      window.analytics.track(eventName, properties, context);
    }
  }
}

window.EmailCapture = EmailCapture;

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t():"function"==typeof define&&define.amd?define(t):t()}(0,function(){"use strict";function e(e){var t=!0,n=!1,o=null,d={text:!0,search:!0,url:!0,tel:!0,email:!0,password:!0,number:!0,date:!0,month:!0,week:!0,time:!0,datetime:!0,"datetime-local":!0};function i(e){return!!(e&&e!==document&&"HTML"!==e.nodeName&&"BODY"!==e.nodeName&&"classList"in e&&"contains"in e.classList)}function s(e){e.classList.contains("focus-visible")||(e.classList.add("focus-visible"),e.setAttribute("data-focus-visible-added",""))}function u(e){t=!1}function a(){document.addEventListener("mousemove",c),document.addEventListener("mousedown",c),document.addEventListener("mouseup",c),document.addEventListener("pointermove",c),document.addEventListener("pointerdown",c),document.addEventListener("pointerup",c),document.addEventListener("touchmove",c),document.addEventListener("touchstart",c),document.addEventListener("touchend",c)}function c(e){e.target.nodeName&&"html"===e.target.nodeName.toLowerCase()||(t=!1,document.removeEventListener("mousemove",c),document.removeEventListener("mousedown",c),document.removeEventListener("mouseup",c),document.removeEventListener("pointermove",c),document.removeEventListener("pointerdown",c),document.removeEventListener("pointerup",c),document.removeEventListener("touchmove",c),document.removeEventListener("touchstart",c),document.removeEventListener("touchend",c))}document.addEventListener("keydown",function(n){n.metaKey||n.altKey||n.ctrlKey||(i(e.activeElement)&&s(e.activeElement),t=!0)},!0),document.addEventListener("mousedown",u,!0),document.addEventListener("pointerdown",u,!0),document.addEventListener("touchstart",u,!0),document.addEventListener("visibilitychange",function(e){"hidden"==document.visibilityState&&(n&&(t=!0),a())},!0),a(),e.addEventListener("focus",function(e){var n,o,u;i(e.target)&&(t||(n=e.target,o=n.type,"INPUT"==(u=n.tagName)&&d[o]&&!n.readOnly||"TEXTAREA"==u&&!n.readOnly||n.isContentEditable))&&s(e.target)},!0),e.addEventListener("blur",function(e){var t;i(e.target)&&(e.target.classList.contains("focus-visible")||e.target.hasAttribute("data-focus-visible-added"))&&(n=!0,window.clearTimeout(o),o=window.setTimeout(function(){n=!1,window.clearTimeout(o)},100),(t=e.target).hasAttribute("data-focus-visible-added")&&(t.classList.remove("focus-visible"),t.removeAttribute("data-focus-visible-added")))},!0),e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&e.host?e.host.setAttribute("data-js-focus-visible",""):e.nodeType===Node.DOCUMENT_NODE&&document.documentElement.classList.add("js-focus-visible")}if("undefined"!=typeof window&&"undefined"!=typeof document){var t;window.applyFocusVisiblePolyfill=e;try{t=new CustomEvent("focus-visible-polyfill-ready")}catch(e){(t=document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready",!1,!1,{})}window.dispatchEvent(t)}"undefined"!=typeof document&&e(document)});
//# sourceMappingURL=focus-visible.min.js.map

// 1. String.prototype.trim polyfill
if (!"".trim) String.prototype.trim = function(){ return this.replace(/^[\s﻿]+|[\s﻿]+$/g, ''); };
(function(window){"use strict"; // prevent global namespace pollution
if(!window.DOMException) (DOMException = function(reason){this.message = reason}).prototype = new Error;
var wsRE = /[\11\12\14\15\40]/, wsIndex = 0, checkIfValidClassListEntry = function(O, V) {
  if (V === "") throw new DOMException(
    "Failed to execute '" + O + "' on 'DOMTokenList': The token provided must not be empty." );
  if((wsIndex=V.search(wsRE))!==-1) throw new DOMException("Failed to execute '"+O+"' on 'DOMTokenList': " +
    "The token provided ('"+V[wsIndex]+"') contains HTML space characters, which are not valid in tokens.");
}
// 2. Implement the barebones DOMTokenList livelyness polyfill
if (typeof DOMTokenList !== "function") (function(window){
    var document = window.document, Object = window.Object, hasOwnProp = Object.prototype.hasOwnProperty;
    var defineProperty = Object.defineProperty, allowTokenListConstruction = 0, skipPropChange = 0;
    function DOMTokenList(){
        if (!allowTokenListConstruction) throw TypeError("Illegal constructor"); // internally let it through
    }
    DOMTokenList.prototype.toString = DOMTokenList.prototype.toLocaleString = function(){return this.value};
    DOMTokenList.prototype.add = function(){
        a: for(var v=0, argLen=arguments.length,val="",ele=this[" uCL"],proto=ele[" uCLp"]; v!==argLen; ++v) {
            val = arguments[v] + "", checkIfValidClassListEntry("add", val);
            for (var i=0, Len=proto.length, resStr=val; i !== Len; ++i)
                if (this[i] === val) continue a; else resStr += " " + this[i];
            this[Len] = val, proto.length += 1, proto.value = resStr;
        }
        skipPropChange = 1, ele.className = proto.value, skipPropChange = 0;
    };
    DOMTokenList.prototype.remove = function(){
        for (var v=0, argLen=arguments.length,val="",ele=this[" uCL"],proto=ele[" uCLp"]; v !== argLen; ++v) {
            val = arguments[v] + "", checkIfValidClassListEntry("remove", val);
            for (var i=0, Len=proto.length, resStr="", is=0; i !== Len; ++i)
                if(is){ this[i-1]=this[i] }else{ if(this[i] !== val){ resStr+=this[i]+" "; }else{ is=1; } }
            if (!is) continue;
            delete this[Len], proto.length -= 1, proto.value = resStr;
        }
        skipPropChange = 1, ele.className = proto.value, skipPropChange = 0;
    };
    window.DOMTokenList = DOMTokenList;
    function whenPropChanges(){
        var evt = window.event, prop = evt.propertyName;
        if ( !skipPropChange && (prop==="className" || (prop==="classList" && !defineProperty)) ) {
            var target = evt.srcElement, protoObjProto = target[" uCLp"], strval = "" + target[prop];
            var tokens=strval.trim().split(wsRE), resTokenList=target[prop==="classList"?" uCL":"classList"];
            var oldLen = protoObjProto.length;
            a: for(var cI = 0, cLen = protoObjProto.length = tokens.length, sub = 0; cI !== cLen; ++cI){
                for(var innerI=0; innerI!==cI; ++innerI) if(tokens[innerI]===tokens[cI]) {sub++; continue a;}
                resTokenList[cI-sub] = tokens[cI];
            }
            for (var i=cLen-sub; i < oldLen; ++i) delete resTokenList[i]; //remove trailing indexs
            if(prop !== "classList") return;
            skipPropChange = 1, target.classList = resTokenList, target.className = strval;
            skipPropChange = 0, resTokenList.length = tokens.length - sub;
        }
    }
    function polyfillClassList(ele){
        if (!ele || !("innerHTML" in ele)) throw TypeError("Illegal invocation");
        ele.detachEvent( "onpropertychange", whenPropChanges ); // prevent duplicate handler infinite loop
        allowTokenListConstruction = 1;
        try{ function protoObj(){} protoObj.prototype = new DOMTokenList(); }
        finally { allowTokenListConstruction = 0 }
        var protoObjProto = protoObj.prototype, resTokenList = new protoObj();
        a: for(var toks=ele.className.trim().split(wsRE), cI=0, cLen=toks.length, sub=0; cI !== cLen; ++cI){
            for (var innerI=0; innerI !== cI; ++innerI) if (toks[innerI] === toks[cI]) { sub++; continue a; }
            this[cI-sub] = toks[cI];
        }
        protoObjProto.length = cLen-sub, protoObjProto.value = ele.className, protoObjProto[" uCL"] = ele;
        if (defineProperty) { defineProperty(ele, "classList", { // IE8 & IE9 allow defineProperty on the DOM
            enumerable:   1, get: function(){return resTokenList},
            configurable: 0, set: function(newVal){
                skipPropChange = 1, ele.className = protoObjProto.value = (newVal += ""), skipPropChange = 0;
                var toks = newVal.trim().split(wsRE), oldLen = protoObjProto.length;
                a: for(var cI = 0, cLen = protoObjProto.length = toks.length, sub = 0; cI !== cLen; ++cI){
                    for(var innerI=0; innerI!==cI; ++innerI) if(toks[innerI]===toks[cI]) {sub++; continue a;}
                    resTokenList[cI-sub] = toks[cI];
                }
                for (var i=cLen-sub; i < oldLen; ++i) delete resTokenList[i]; //remove trailing indexs
            }
        }); defineProperty(ele, " uCLp", { // for accessing the hidden prototype
            enumerable: 0, configurable: 0, writeable: 0, value: protoObj.prototype
        }); defineProperty(protoObjProto, " uCL", {
            enumerable: 0, configurable: 0, writeable: 0, value: ele
        }); } else { ele.classList=resTokenList, ele[" uCL"]=resTokenList, ele[" uCLp"]=protoObj.prototype; }
        ele.attachEvent( "onpropertychange", whenPropChanges );
    }
    try { // Much faster & cleaner version for IE8 & IE9:
        // Should work in IE8 because Element.prototype instanceof Node is true according to the specs
        window.Object.defineProperty(window.Element.prototype, "classList", {
            enumerable: 1,   get: function(val){
                                 if (!hasOwnProp.call(this, "classList")) polyfillClassList(this);
                                 return this.classList;
                             },
            configurable: 0, set: function(val){this.className = val}
        });
    } catch(e) { // Less performant fallback for older browsers (IE 6-8):
        window[" uCL"] = polyfillClassList;
        // the below code ensures polyfillClassList is applied to all current and future elements in the doc.
        document.documentElement.firstChild.appendChild(document.createElement('style')).styleSheet.cssText=(
            '_*{x-uCLp:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}' + //  IE6
            '[class]{x-uCLp/**/:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}' //IE7-8
        );
    }
})(window);
// 3. Patch in unsupported methods in DOMTokenList
(function(DOMTokenListProto, testClass){
    if (!DOMTokenListProto.item) DOMTokenListProto.item = function(i){
        function NullCheck(n) {return n===void 0 ? null : n} return NullCheck(this[i]);
    };
    if (!DOMTokenListProto.toggle || testClass.toggle("a",0)!==false) DOMTokenListProto.toggle=function(val){
        if (arguments.length > 1) return (this[arguments[1] ? "add" : "remove"](val), !!arguments[1]);
        var oldValue = this.value;
        return (this.remove(oldValue), oldValue === this.value && (this.add(val), true) /*|| false*/);
    };
    if (!DOMTokenListProto.replace || typeof testClass.replace("a", "b") !== "boolean")
        DOMTokenListProto.replace = function(oldToken, newToken){
            checkIfValidClassListEntry("replace", oldToken), checkIfValidClassListEntry("replace", newToken);
            var oldValue = this.value;
            return (this.remove(oldToken), this.value !== oldValue && (this.add(newToken), true));
        };
    if (!DOMTokenListProto.contains) DOMTokenListProto.contains = function(value){
        for (var i=0,Len=this.length; i !== Len; ++i) if (this[i] === value) return true;
        return false;
    };
    if (!DOMTokenListProto.forEach) DOMTokenListProto.forEach = function(f){
        if (arguments.length === 1) for (var i = 0, Len = this.length; i !== Len; ++i) f( this[i], i, this);
        else for (var i=0,Len=this.length,tArg=arguments[1]; i !== Len; ++i) f.call(tArg, this[i], i, this);
    };
    if (!DOMTokenListProto.entries) DOMTokenListProto.entries = function(){
        var nextIndex = 0, that = this;
        return {next: function() {
            return nextIndex<that.length ? {value: [nextIndex, that[nextIndex]], done: false} : {done: true};
        }};
    };
    if (!DOMTokenListProto.values) DOMTokenListProto.values = function(){
        var nextIndex = 0, that = this;
        return {next: function() {
            return nextIndex<that.length ? {value: that[nextIndex], done: false} : {done: true};
        }};
    };
    if (!DOMTokenListProto.keys) DOMTokenListProto.keys = function(){
        var nextIndex = 0, that = this;
        return {next: function() {
            return nextIndex<that.length ? {value: nextIndex, done: false} : {done: true};
        }};
    };
})(window.DOMTokenList.prototype, window.document.createElement("div").classList);
})(window);